(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.cA.aD === region.dn.aD)
	{
		return 'on line ' + region.cA.aD;
	}
	return 'on lines ' + region.cA.aD + ' through ' + region.dn.aD;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hr,
		impl.jQ,
		impl.jm,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		eh: func(record.eh),
		jj: record.jj,
		iK: record.iK
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.eh;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.jj;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.iK) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hr,
		impl.jQ,
		impl.jm,
		function(sendToApp, initialModel) {
			var view = impl.jV;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hr,
		impl.jQ,
		impl.jm,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.cr && impl.cr(sendToApp)
			var view = impl.jV;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fW);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.jB) && (_VirtualDom_doc.title = title = doc.jB);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.iq;
	var onUrlRequest = impl.ir;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		cr: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.eH === next.eH
							&& curr.dZ === next.dZ
							&& curr.eC.a === next.eC.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		hr: function(flags)
		{
			return A3(impl.hr, flags, _Browser_getUrl(), key);
		},
		jV: impl.jV,
		jQ: impl.jQ,
		jm: impl.jm
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hm: 'hidden', f9: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hm: 'mozHidden', f9: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hm: 'msHidden', f9: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hm: 'webkitHidden', f9: 'webkitvisibilitychange' }
		: { hm: 'hidden', f9: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		eT: _Browser_getScene(),
		fr: {
			fx: _Browser_window.pageXOffset,
			fy: _Browser_window.pageYOffset,
			fv: _Browser_doc.documentElement.clientWidth,
			dV: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fv: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		dV: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			eT: {
				fv: node.scrollWidth,
				dV: node.scrollHeight
			},
			fr: {
				fx: node.scrollLeft,
				fy: node.scrollTop,
				fv: node.clientWidth,
				dV: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			eT: _Browser_getScene(),
			fr: {
				fx: x,
				fy: y,
				fv: _Browser_doc.documentElement.clientWidth,
				dV: _Browser_doc.documentElement.clientHeight
			},
			gK: {
				fx: x + rect.left,
				fy: y + rect.top,
				fv: rect.width,
				dV: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.z.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.z.b, xhr)); });
		$elm$core$Maybe$isJust(request.fo) && _Http_track(router, xhr, request.fo.a);

		try {
			xhr.open(request.ei, request.jR, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.jR));
		}

		_Http_configureRequest(xhr, request);

		request.fW.a && xhr.setRequestHeader('Content-Type', request.fW.a);
		xhr.send(request.fW.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.A; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.fl.a || 0;
	xhr.responseType = request.z.d;
	xhr.withCredentials = request.fK;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		jR: xhr.responseURL,
		e9: xhr.status,
		ji: xhr.statusText,
		A: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			i3: event.loaded,
			e6: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			iO: event.loaded,
			e6: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.en) { flags += 'm'; }
	if (options.cZ) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.k) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.m),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.m);
		} else {
			var treeLen = builder.k * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.n) : builder.n;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.k);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.m) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.m);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{n: nodeList, k: (len / $elm$core$Array$branchFactor) | 0, m: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {dO: fragment, dZ: host, ey: path, eC: port_, eH: protocol, iM: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Components$Modal$Model$ClosedModal = {$: 2};
var $author$project$Initialisation$Messages$FetchedTimesheetData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Initialisation$Messages$FetchedUser = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Initialising = function (a) {
	return {$: 2, a: a};
};
var $author$project$Messages$IntialiseMsg = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Components$HelpDesk$Model$Closed = 1;
var $author$project$Components$HelpDesk$Model$NotSubmitted = 0;
var $author$project$Components$HelpDesk$Model$emptyHelpDesk = {dd: '', dl: '', b2: '', cB: '', cC: 0, cF: false, cJ: 1};
var $author$project$Components$Header$Data$defaultHeader = F2(
	function (csrfToken, cspNonce) {
		return {c5: cspNonce, gr: csrfToken, dW: $author$project$Components$HelpDesk$Model$emptyHelpDesk, dX: false, eo: false};
	});
var $author$project$TimesheetPage$Data$ContextualModel = F5(
	function (model, timeZone, currentTime, announcementMsgReceivedAt, frontendVersion) {
		return {fM: announcementMsgReceivedAt, gw: currentTime, hd: frontendVersion, a6: model, jy: timeZone};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {c$: col, gp: contextStack, eE: problem, eP: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.eP, s.c$, x, s.bs));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.b),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{c$: col, bs: s0.bs, f: s0.f, c: offset, eP: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.eP, s.c$, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.b),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.b);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{c$: 1, bs: s.bs, f: s.f, c: s.c + 1, eP: s.eP + 1, b: s.b}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{c$: s.c$ + 1, bs: s.bs, f: s.f, c: newOffset, eP: s.eP, b: s.b}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.eP, s.c$, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{c$: newCol, bs: s.bs, f: s.f, c: newOffset, eP: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {c$: col, eE: problem, eP: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.eP, p.c$, p.eE);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{c$: 1, bs: _List_Nil, f: 1, c: 0, eP: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $elm_community$json_extra$Json$Decode$Extra$datetime = A2(
	$elm$json$Json$Decode$andThen,
	function (dateString) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
		if (!_v0.$) {
			var v = _v0.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$IntegrationStatuses$BannerMinimized = 0;
var $author$project$Components$MergeFees$Model$Closed = {$: 1};
var $author$project$Components$Modal$Model$Closed = {$: 5};
var $author$project$Components$SearchInput$Model$Closed = {$: 0};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$TimesheetPage$Data$Model = function (user) {
	return function (activityFeed) {
		return function (feeSearchConfiguration) {
			return function (fees) {
				return function (recentMatters) {
					return function (recentRestrictedMatters) {
						return function (billingOptions) {
							return function (modal) {
								return function (feeCardFeeTypeInput) {
									return function (feeCardCurrentSearchInput) {
										return function (feeCardCurrentSelectInput) {
											return function (mergeFees) {
												return function (dashboard) {
													return function (feeTypes) {
														return function (integrationStatuses) {
															return function (flashMessages) {
																return function (expandedFeeConversations) {
																	return function (actionStepRates) {
																		return function (integrationStatusState) {
																			return function (currentRataDie) {
																				return function (utbmsCodes) {
																					return function (mobileDeviceTab) {
																						return function (csrfToken) {
																							return function (cspNonce) {
																								return {bn: actionStepRates, fI: activityFeed, fU: billingOptions, c5: cspNonce, gr: csrfToken, aU: currentRataDie, gx: dashboard, gO: expandedFeeConversations, gX: feeCardCurrentSearchInput, gY: feeCardCurrentSelectInput, gZ: feeCardFeeTypeInput, g$: feeSearchConfiguration, bG: feeTypes, aY: fees, P: flashMessages, ht: integrationStatusState, hu: integrationStatuses, a4: mergeFees, h6: mobileDeviceTab, h7: modal, iP: recentMatters, eI: recentRestrictedMatters, jS: user, cL: utbmsCodes};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$MobileDeviceTab$NoSelection = 0;
var $author$project$Activities$Data$Activity = F9(
	function (id, event, startsAt, contact, isActionsMenuOpen, isActionsKebabMenuOpen, binnedAt, feedDecisionReason, isBinnedActionsMenuOpen) {
		return {fV: binnedAt, c2: contact, i: event, g3: feedDecisionReason, aC: id, hw: isActionsKebabMenuOpen, hx: isActionsMenuOpen, hz: isBinnedActionsMenuOpen, jg: startsAt};
	});
var $author$project$Activities$Model$Event$Appointment = function (a) {
	return {$: 0, a: a};
};
var $author$project$Activities$Model$Event$AppointmentActivity = F5(
	function (subject, duration, attendees, emailName, emailAddress) {
		return {ai: attendees, X: duration, dl: emailAddress, dm: emailName, cB: subject};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Activities$Model$Event$decodeAppointmentActivity = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'emailAddress',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'emailName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'attendees',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'duration',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subject',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Activities$Model$Event$AppointmentActivity))))));
var $author$project$Activities$Model$Event$decodeAppointment = A2($elm$json$Json$Decode$map, $author$project$Activities$Model$Event$Appointment, $author$project$Activities$Model$Event$decodeAppointmentActivity);
var $author$project$Activities$Model$Event$BrowserResearch = function (a) {
	return {$: 5, a: a};
};
var $author$project$Activities$Model$Event$BrowserResearchActivity = F5(
	function (url, duration, bookmarkTitle, bookmarkUrl, pageTitle) {
		return {aR: bookmarkTitle, fX: bookmarkUrl, X: duration, iD: pageTitle, jR: url};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Activities$Model$Event$decodeBrowserResearchActivity = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'pageTitle',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'bookmarkUrl',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bookmarkTitle',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'duration',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Activities$Model$Event$BrowserResearchActivity))))));
var $author$project$Activities$Model$Event$decodeBrowserResearch = A2($elm$json$Json$Decode$map, $author$project$Activities$Model$Event$BrowserResearch, $author$project$Activities$Model$Event$decodeBrowserResearchActivity);
var $author$project$Activities$Model$Event$Phonecall = function (a) {
	return {$: 4, a: a};
};
var $author$project$Activities$Model$Event$PhonecallActivity = F3(
	function (number, duration, direction) {
		return {df: direction, X: duration, a9: number};
	});
var $author$project$Activities$Model$Event$Incoming = 0;
var $author$project$Activities$Model$Event$NoDirection = 2;
var $author$project$Activities$Model$Event$Outgoing = 1;
var $author$project$Activities$Model$Event$decodeActivityDirection = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (dir) {
				switch (dir) {
					case 'incoming':
						return $elm$json$Json$Decode$succeed(0);
					case 'outgoing':
						return $elm$json$Json$Decode$succeed(1);
					case '':
						return $elm$json$Json$Decode$succeed(2);
					default:
						var somethingElse = dir;
						return $elm$json$Json$Decode$fail('Activity direction ' + (somethingElse + ' not supported.'));
				}
			},
			$elm$json$Json$Decode$string),
			$elm$json$Json$Decode$null(2)
		]));
var $author$project$Activities$Model$Event$decodePhoneActivity = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'direction',
	$author$project$Activities$Model$Event$decodeActivityDirection,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'duration',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'number',
			$elm$json$Json$Decode$string,
			'',
			$elm$json$Json$Decode$succeed($author$project$Activities$Model$Event$PhonecallActivity))));
var $author$project$Activities$Model$Event$decodeCall = A2($elm$json$Json$Decode$map, $author$project$Activities$Model$Event$Phonecall, $author$project$Activities$Model$Event$decodePhoneActivity);
var $author$project$Activities$Model$Event$Document = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Activities$Model$Event$Drafted = 1;
var $author$project$Activities$Model$Event$DocumentActivity = F8(
	function (name, extension, externalDocumentId, eventType, matterCode, matterDescription, duration, source) {
		return {X: duration, dr: eventType, dv: extension, dw: externalDocumentId, hZ: matterCode, h_: matterDescription, b2: name, jb: source};
	});
var $author$project$Activities$Model$Event$DMS = 1;
var $author$project$Activities$Model$Event$Word = 0;
var $author$project$Activities$Model$Event$decodeSource = A2(
	$elm$json$Json$Decode$andThen,
	function (source) {
		switch (source) {
			case 'dms':
				return $elm$json$Json$Decode$succeed(1);
			case 'word':
				return $elm$json$Json$Decode$succeed(0);
			case '':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = source;
				return $elm$json$Json$Decode$fail('Source ' + (somethingElse + ' not supported.'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Activities$Model$Event$decodeDocumentActivity = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'source',
	$author$project$Activities$Model$Event$decodeSource,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'duration',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'matterDescription',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'matterCode',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventType',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'externalDocumentId',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'extension',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Activities$Model$Event$DocumentActivity)))))))));
var $author$project$Activities$Model$Event$decodeDrafted = A2(
	$elm$json$Json$Decode$map,
	$author$project$Activities$Model$Event$Document(1),
	$author$project$Activities$Model$Event$decodeDocumentActivity);
var $author$project$Activities$Model$Event$Drafting = 0;
var $author$project$Activities$Model$Event$decodeDrafting = A2(
	$elm$json$Json$Decode$map,
	$author$project$Activities$Model$Event$Document(0),
	$author$project$Activities$Model$Event$decodeDocumentActivity);
var $author$project$Activities$Model$Event$Email = function (a) {
	return {$: 3, a: a};
};
var $author$project$Activities$Model$Event$EmailActivity = F8(
	function (subject, body, emailName, emailAddress, direction, conversationId, filingStatus, duration) {
		return {fW: body, gq: conversationId, df: direction, X: duration, dl: emailAddress, dm: emailName, dH: filingStatus, cB: subject};
	});
var $author$project$Activities$Model$FilingStatus$FilingStatus = F9(
	function (id, filingType, filedStatus, externalId, library, folder, workspace, matter, note) {
		return {gR: externalId, dG: filedStatus, g7: filingType, hb: folder, aC: id, hV: library, hY: matter, ij: note, jZ: workspace};
	});
var $author$project$Activities$Model$FilingStatus$Cancelled = {$: 7};
var $author$project$Activities$Model$FilingStatus$Filing = {$: 3};
var $author$project$Activities$Model$FilingStatus$RenameFailed = {$: 5};
var $author$project$Activities$Model$FilingStatus$Renaming = {$: 4};
var $author$project$Activities$Model$FilingStatus$SelectionRequired = {$: 6};
var $author$project$Activities$Model$FilingStatus$Failed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Activities$Model$FilingStatus$decodeFailReason = A2($elm$json$Json$Decode$field, 'failReason', $elm$json$Json$Decode$string);
var $author$project$Activities$Model$FilingStatus$decodeFailed = A2($elm$json$Json$Decode$map, $author$project$Activities$Model$FilingStatus$Failed, $author$project$Activities$Model$FilingStatus$decodeFailReason);
var $author$project$Activities$Model$FilingStatus$decodeFileStatus = A2($elm$json$Json$Decode$field, 'fileStatus', $elm$json$Json$Decode$string);
var $author$project$Activities$Model$FilingStatus$Filed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Activities$Model$FilingStatus$decodeUpdatedAt = A2($elm$json$Json$Decode$field, 'updatedAt', $elm_community$json_extra$Json$Decode$Extra$datetime);
var $author$project$Activities$Model$FilingStatus$decodeFiled = A2($elm$json$Json$Decode$map, $author$project$Activities$Model$FilingStatus$Filed, $author$project$Activities$Model$FilingStatus$decodeUpdatedAt);
var $author$project$Activities$Model$FilingStatus$Scheduled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Activities$Model$FilingStatus$decodeScheduledAt = A2($elm$json$Json$Decode$field, 'scheduledAt', $elm_community$json_extra$Json$Decode$Extra$datetime);
var $author$project$Activities$Model$FilingStatus$decodeScheduled = A2($elm$json$Json$Decode$map, $author$project$Activities$Model$FilingStatus$Scheduled, $author$project$Activities$Model$FilingStatus$decodeScheduledAt);
var $author$project$Activities$Model$FilingStatus$is = F2(
	function (expected, val) {
		return _Utils_eq(expected, val);
	});
var $elm_community$json_extra$Json$Decode$Extra$when = F3(
	function (checkDecoder, check, passDecoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (checkVal) {
				return check(checkVal) ? passDecoder : $elm$json$Json$Decode$fail('Check failed with input');
			},
			checkDecoder);
	});
var $author$project$Activities$Model$FilingStatus$decodeFiledStatus = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$FilingStatus$decodeFileStatus,
			$author$project$Activities$Model$FilingStatus$is('Scheduled'),
			$author$project$Activities$Model$FilingStatus$decodeScheduled),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$FilingStatus$decodeFileStatus,
			$author$project$Activities$Model$FilingStatus$is('Filing'),
			$elm$json$Json$Decode$succeed($author$project$Activities$Model$FilingStatus$Filing)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$FilingStatus$decodeFileStatus,
			$author$project$Activities$Model$FilingStatus$is('Renaming'),
			$elm$json$Json$Decode$succeed($author$project$Activities$Model$FilingStatus$Renaming)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$FilingStatus$decodeFileStatus,
			$author$project$Activities$Model$FilingStatus$is('Rename Failed'),
			$elm$json$Json$Decode$succeed($author$project$Activities$Model$FilingStatus$RenameFailed)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$FilingStatus$decodeFileStatus,
			$author$project$Activities$Model$FilingStatus$is('Failed'),
			$author$project$Activities$Model$FilingStatus$decodeFailed),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$FilingStatus$decodeFileStatus,
			$author$project$Activities$Model$FilingStatus$is('Filed'),
			$author$project$Activities$Model$FilingStatus$decodeFiled),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$FilingStatus$decodeFileStatus,
			$author$project$Activities$Model$FilingStatus$is('Cancelled'),
			$elm$json$Json$Decode$succeed($author$project$Activities$Model$FilingStatus$Cancelled)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$FilingStatus$decodeFileStatus,
			$author$project$Activities$Model$FilingStatus$is('Selection Required'),
			$elm$json$Json$Decode$succeed($author$project$Activities$Model$FilingStatus$SelectionRequired))
		]));
var $author$project$Activities$Model$FilingStatus$Email = 0;
var $author$project$Activities$Model$FilingStatus$Note = 1;
var $author$project$Activities$Model$FilingStatus$decodeFilingType = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (filingType) {
				switch (filingType) {
					case 'email':
						return $elm$json$Json$Decode$succeed(0);
					case 'note':
						return $elm$json$Json$Decode$succeed(1);
					default:
						var somethingElse = filingType;
						return $elm$json$Json$Decode$fail('Filing type ' + (somethingElse + ' not supported.'));
				}
			},
			$elm$json$Json$Decode$string)
		]));
var $author$project$MatterTypes$Matter = function (id) {
	return function (externalIdentifier) {
		return function (code) {
			return function (description) {
				return function (billingBehaviour) {
					return function (clientName) {
						return function (matterStatus) {
							return function (utbmsEnabled) {
								return function (utbmsTaskCategoryCode) {
									return function (scaleGroupId) {
										return function (restricted) {
											return function (tags) {
												return {fS: billingBehaviour, gd: clientName, br: code, dd: description, gS: externalIdentifier, aC: id, h0: matterStatus, iU: restricted, eS: scaleGroupId, fi: tags, jT: utbmsEnabled, jU: utbmsTaskCategoryCode};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Fee$BillingBehaviour$Billable = 0;
var $author$project$Model$Fee$BillingBehaviour$BillableNoCharge = 1;
var $author$project$Model$Fee$BillingBehaviour$BillableNoChargeHidden = 2;
var $author$project$Model$Fee$BillingBehaviour$NotBillable = 3;
var $author$project$Model$Fee$BillingBehaviour$fromString = function (billingBehaviour) {
	switch (billingBehaviour) {
		case 'billable':
			return 0;
		case 'billable_no_charge':
			return 1;
		case 'billable_no_charge_hidden':
			return 2;
		case 'not_billable':
			return 3;
		default:
			return 0;
	}
};
var $author$project$Model$Fee$BillingBehaviour$decodeBillingBehaviour = A2(
	$elm$json$Json$Decode$andThen,
	function (behaviour) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Model$Fee$BillingBehaviour$fromString(behaviour));
	},
	$elm$json$Json$Decode$string);
var $author$project$MatterTypes$MatterArchived = {$: 1};
var $author$project$MatterTypes$MatterOk = {$: 0};
var $author$project$MatterTypes$MatterOnHold = function (a) {
	return {$: 2, a: a};
};
var $author$project$MatterTypes$makeStatus = F3(
	function (archived, onHold, onHoldReason) {
		return archived ? $author$project$MatterTypes$MatterArchived : (onHold ? $author$project$MatterTypes$MatterOnHold(onHoldReason) : $author$project$MatterTypes$MatterOk);
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$MatterTypes$decodeMatterStatus = A4(
	$elm$json$Json$Decode$map3,
	$author$project$MatterTypes$makeStatus,
	A2($elm$json$Json$Decode$field, 'archived', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'onHold', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'onHoldReason', $elm$json$Json$Decode$string));
var $author$project$Model$Tag$Tag = F2(
	function (id, name) {
		return {aC: id, b2: name};
	});
var $author$project$Model$Tag$decodeTag = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$Tag$Tag)));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Model$Tag$decodeTags = $elm$json$Json$Decode$list($author$project$Model$Tag$decodeTag);
var $author$project$MatterTypes$decodeMatter = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tags',
	$author$project$Model$Tag$decodeTags,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'restricted',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'scaleGroupId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'utbmsTaskCategoryCode',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'utbmsEnabled',
					$elm$json$Json$Decode$bool,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$MatterTypes$decodeMatterStatus,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'clientName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'billingBehaviour',
								$author$project$Model$Fee$BillingBehaviour$decodeBillingBehaviour,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'description',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'code',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'externalIdentifier',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$succeed($author$project$MatterTypes$Matter)))))))))))));
var $author$project$Components$FileNotes$Types$FileNote$FileNote = F5(
	function (id, title, content, feeId, matterId) {
		return {go: content, g_: feeId, aC: id, ef: matterId, jB: title};
	});
var $author$project$Components$FileNotes$Types$FileNote$fileNoteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'matterId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'feeId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'content',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FileNote$FileNote))))));
var $author$project$Activities$Model$FilingStatus$decodeFilingStatus = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'note',
	$elm$json$Json$Decode$nullable($author$project$Components$FileNotes$Types$FileNote$fileNoteDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'matter',
		$elm$json$Json$Decode$nullable($author$project$MatterTypes$decodeMatter),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'workspace',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'folder',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'library',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'externalId',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'filedStatus',
							$author$project$Activities$Model$FilingStatus$decodeFiledStatus,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'filingType',
								$author$project$Activities$Model$FilingStatus$decodeFilingType,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									$elm$json$Json$Decode$succeed($author$project$Activities$Model$FilingStatus$FilingStatus))))))))));
var $author$project$Activities$Model$Event$decodeEmailActivity = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'duration',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filingStatus',
		$elm$json$Json$Decode$nullable($author$project$Activities$Model$FilingStatus$decodeFilingStatus),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'conversationId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'direction',
				$author$project$Activities$Model$Event$decodeActivityDirection,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'emailAddress',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'emailName',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'body',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'subject',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Activities$Model$Event$EmailActivity)))))))));
var $author$project$Activities$Model$Event$decodeEmail = A2($elm$json$Json$Decode$map, $author$project$Activities$Model$Event$Email, $author$project$Activities$Model$Event$decodeEmailActivity);
var $author$project$Activities$Model$Event$decodeKind = A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string);
var $author$project$Activities$Model$Event$ConferenceCall = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Activities$Model$Event$MSTeams = 0;
var $author$project$Activities$Model$Event$ConferenceCallActivity = F2(
	function (attendees, duration) {
		return {ai: attendees, X: duration};
	});
var $author$project$Activities$Model$Event$decodeConferenceCallActivity = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'duration',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'attendees',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Activities$Model$Event$ConferenceCallActivity)));
var $author$project$Activities$Model$Event$decodeMSTeams = A2(
	$elm$json$Json$Decode$map,
	$author$project$Activities$Model$Event$ConferenceCall(0),
	$author$project$Activities$Model$Event$decodeConferenceCallActivity);
var $author$project$Activities$Model$Event$Reading = 2;
var $author$project$Activities$Model$Event$decodeReading = A2(
	$elm$json$Json$Decode$map,
	$author$project$Activities$Model$Event$Document(2),
	$author$project$Activities$Model$Event$decodeDocumentActivity);
var $author$project$Activities$Model$Event$is = F2(
	function (expected, val) {
		return _Utils_eq(expected, val);
	});
var $author$project$Activities$Model$Event$decodeActivityEvent = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$Event$decodeKind,
			$author$project$Activities$Model$Event$is('email'),
			$author$project$Activities$Model$Event$decodeEmail),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$Event$decodeKind,
			$author$project$Activities$Model$Event$is('phonecall'),
			$author$project$Activities$Model$Event$decodeCall),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$Event$decodeKind,
			$author$project$Activities$Model$Event$is('ms-teams-call'),
			$author$project$Activities$Model$Event$decodeMSTeams),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$Event$decodeKind,
			$author$project$Activities$Model$Event$is('appointment'),
			$author$project$Activities$Model$Event$decodeAppointment),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$Event$decodeKind,
			$author$project$Activities$Model$Event$is('drafting'),
			$author$project$Activities$Model$Event$decodeDrafting),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$Event$decodeKind,
			$author$project$Activities$Model$Event$is('drafted'),
			$author$project$Activities$Model$Event$decodeDrafted),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$Event$decodeKind,
			$author$project$Activities$Model$Event$is('reading'),
			$author$project$Activities$Model$Event$decodeReading),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Activities$Model$Event$decodeKind,
			$author$project$Activities$Model$Event$is('browser-research'),
			$author$project$Activities$Model$Event$decodeBrowserResearch)
		]));
var $author$project$Contacts$Data$Contact = F5(
	function (id, name, source, contactVia, companyName) {
		return {gh: companyName, gn: contactVia, aC: id, b2: name, jb: source};
	});
var $author$project$Contacts$Data$ActionStep = 0;
var $author$project$Contacts$Data$Affinity = 1;
var $author$project$Contacts$Data$Clio = 5;
var $author$project$Contacts$Data$FilePro = 4;
var $author$project$Contacts$Data$Nebulaw = 2;
var $author$project$Contacts$Data$Outlook = 3;
var $author$project$Contacts$Data$decodeContactSource = A2(
	$elm$json$Json$Decode$andThen,
	function (source) {
		switch (source) {
			case 'actionstep':
				return $elm$json$Json$Decode$succeed(0);
			case 'affinity':
				return $elm$json$Json$Decode$succeed(1);
			case 'exchange':
				return $elm$json$Json$Decode$succeed(3);
			case 'filepro':
				return $elm$json$Json$Decode$succeed(4);
			case 'nebulaw':
				return $elm$json$Json$Decode$succeed(2);
			case 'clio':
				return $elm$json$Json$Decode$succeed(5);
			case 'toca':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var unexpected = source;
				return $elm$json$Json$Decode$fail('Unexpected contact source ' + unexpected);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Contacts$Data$decodeContact = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'companyName',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contactVia',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'source',
			$author$project$Contacts$Data$decodeContactSource,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Contacts$Data$Contact))))));
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Activities$Data$activityDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'feedDecisionReason',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'binnedAt',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				false,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					false,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contact',
						$elm$json$Json$Decode$nullable($author$project$Contacts$Data$decodeContact),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'startsAt',
							$elm_community$json_extra$Json$Decode$Extra$datetime,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'event',
								$author$project$Activities$Model$Event$decodeActivityEvent,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Activities$Data$Activity))))))))));
var $author$project$BudgetBar$Data$Model = F3(
	function (filterStatus, dashboardUI, nowTime) {
		return {gy: dashboardUI, ha: filterStatus, io: nowTime};
	});
var $author$project$BudgetBar$Data$Off = {$: 1};
var $author$project$BudgetBar$Data$ProgressBar = 0;
var $author$project$BudgetBar$Data$TimelineBar = 1;
var $author$project$BudgetBar$Data$dashboardModelDecoder = function (preferTimeline) {
	return $elm$json$Json$Decode$succeed(
		preferTimeline ? A3($author$project$BudgetBar$Data$Model, $author$project$BudgetBar$Data$Off, 1, $elm$core$Maybe$Nothing) : A3($author$project$BudgetBar$Data$Model, $author$project$BudgetBar$Data$Off, 0, $elm$core$Maybe$Nothing));
};
var $author$project$BudgetBar$Data$dashboardWithPreferenceDecoder = function (preferTimeline) {
	return $author$project$BudgetBar$Data$dashboardModelDecoder(preferTimeline);
};
var $author$project$Model$FeeCounts$FeeCounts = F5(
	function (expiring, incomplete, failed, pending, onHold) {
		return {du: expiring, dx: failed, d$: incomplete, ip: onHold, ez: pending};
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Model$FeeCounts$decodeSetInt = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $elm$core$Set$fromList, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int));
var $author$project$Model$FeeCounts$decodeFeeCounts = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'on_hold',
	$author$project$Model$FeeCounts$decodeSetInt,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pending',
		$author$project$Model$FeeCounts$decodeSetInt,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'failed',
			$author$project$Model$FeeCounts$decodeSetInt,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'incomplete',
				$author$project$Model$FeeCounts$decodeSetInt,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'expiring',
					$author$project$Model$FeeCounts$decodeSetInt,
					$elm$json$Json$Decode$succeed($author$project$Model$FeeCounts$FeeCounts))))));
var $author$project$Model$Timesheet$GroupByFilter$Closed = function (a) {
	return {$: 1, a: a};
};
var $author$project$FeeFilter$Off = {$: 1};
var $author$project$SearchState$SearchClosed = 1;
var $Gizra$elm_debouncer$Debouncer$Internal$Config = $elm$core$Basics$identity;
var $Gizra$elm_debouncer$Debouncer$Internal$lastInput = F2(
	function (i, o) {
		return $elm$core$Maybe$Just(i);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$manual = {V: $Gizra$elm_debouncer$Debouncer$Internal$lastInput, F: $elm$core$Maybe$Nothing, G: $elm$core$Maybe$Nothing, K: $elm$core$Maybe$Nothing};
var $Gizra$elm_debouncer$Debouncer$Basic$manual = $Gizra$elm_debouncer$Debouncer$Internal$manual;
var $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor = F2(
	function (time, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{K: time});
	});
var $Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor = $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor;
var $Gizra$elm_debouncer$Debouncer$Basic$debounce = function (interval) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor,
		$elm$core$Maybe$Just(interval),
		$Gizra$elm_debouncer$Debouncer$Basic$manual);
};
var $Gizra$elm_debouncer$Debouncer$Internal$Debouncer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$Settled = {$: 0};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative = $elm$core$Maybe$andThen(
	function (num) {
		return (num < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(num);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig = function (_v0) {
	var config = _v0;
	return {
		V: config.V,
		F: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.F),
		G: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.G),
		K: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.K)
	};
};
var $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer = function (config) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Internal$Debouncer,
		$Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig(config),
		$Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer = $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer;
var $author$project$Model$FeeSearchConfiguration$defaultFeeSearchConfiguration = F2(
	function (groupByFilter, feeCounts) {
		return {
			c8: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
				$Gizra$elm_debouncer$Debouncer$Basic$debounce(500)),
			dB: false,
			dI: feeCounts,
			g9: $author$project$FeeFilter$Off,
			dN: $elm$core$Maybe$Nothing,
			dT: $author$project$Model$Timesheet$GroupByFilter$Closed(groupByFilter),
			ea: 0,
			ep: false,
			i1: 1,
			i2: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Model$FeeSearchConfiguration$decodeFeeSearchConfigurationWithFilter = function (groupByFilter) {
	return A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Model$FeeSearchConfiguration$defaultFeeSearchConfiguration(groupByFilter),
			$elm$json$Json$Decode$succeed),
		A2($elm$json$Json$Decode$field, 'feeCounts', $author$project$Model$FeeCounts$decodeFeeCounts));
};
var $author$project$Model$Timesheet$GroupByFilter$Day = 1;
var $author$project$Model$Timesheet$GroupByFilter$DayAndMatter = 0;
var $author$project$Model$Timesheet$GroupByFilter$decodeGroupByFilter = A2(
	$elm$json$Json$Decode$andThen,
	function (byDayAndMatter) {
		return $elm$json$Json$Decode$succeed(
			byDayAndMatter ? 0 : 1);
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['user', 'groupFeesByDayAndMatter']),
		$elm$json$Json$Decode$bool));
var $author$project$Model$FeeSearchConfiguration$decodeFeeSearchConfiguration = A2($elm$json$Json$Decode$andThen, $author$project$Model$FeeSearchConfiguration$decodeFeeSearchConfigurationWithFilter, $author$project$Model$Timesheet$GroupByFilter$decodeGroupByFilter);
var $author$project$Model$FeeType$FeeType = function (id) {
	return function (code) {
		return function (description) {
			return function (feeDescriptionPrefix) {
				return function (otherDescription) {
					return function (kind) {
						return function (direction) {
							return function (billingBehaviour) {
								return function (billingDescriptionBehaviour) {
									return function (scaleGroupId) {
										return {fS: billingBehaviour, fT: billingDescriptionBehaviour, br: code, dd: description, df: direction, dC: feeDescriptionPrefix, aC: id, hQ: kind, iA: otherDescription, eS: scaleGroupId};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Activities$Model$ActivityType$AppointmentType = 0;
var $author$project$Activities$Model$ActivityType$BrowserResearching = 8;
var $author$project$Activities$Model$ActivityType$ConsolidatedEmails = 7;
var $author$project$Activities$Model$ActivityType$Drafted = 4;
var $author$project$Activities$Model$ActivityType$Drafting = 3;
var $author$project$Activities$Model$ActivityType$MSTeamsCall = 1;
var $author$project$Activities$Model$ActivityType$MergedFees = 9;
var $author$project$Activities$Model$ActivityType$Phone = 2;
var $author$project$Activities$Model$ActivityType$Reading = 5;
var $author$project$Activities$Model$ActivityType$SingletonEmail = 6;
var $author$project$Activities$Model$ActivityType$decodeActivityType = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		switch (status) {
			case 'consolidated-emails':
				return $elm$json$Json$Decode$succeed(7);
			case 'email':
				return $elm$json$Json$Decode$succeed(6);
			case 'appointment':
				return $elm$json$Json$Decode$succeed(0);
			case 'phonecall':
				return $elm$json$Json$Decode$succeed(2);
			case 'ms-teams-call':
				return $elm$json$Json$Decode$succeed(1);
			case 'drafting':
				return $elm$json$Json$Decode$succeed(3);
			case 'drafted':
				return $elm$json$Json$Decode$succeed(4);
			case 'reading':
				return $elm$json$Json$Decode$succeed(5);
			case 'browser-research':
				return $elm$json$Json$Decode$succeed(8);
			case 'merged-fees':
				return $elm$json$Json$Decode$succeed(9);
			default:
				var somethingElse = status;
				return $elm$json$Json$Decode$fail('Activity kind ' + (somethingElse + ' not supported.'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FeeType$EnforcePrefix = 0;
var $author$project$Model$FeeType$InitialiseWithPrefix = 1;
var $author$project$Model$FeeType$Omit = 2;
var $author$project$Model$FeeType$decodeBillingDescriptionBehavior = A2(
	$elm$json$Json$Decode$andThen,
	function (behaviour) {
		switch (behaviour) {
			case 'inserted_by_pms':
				return $elm$json$Json$Decode$succeed(0);
			case 'enforced_by_mitimes':
				return $elm$json$Json$Decode$succeed(0);
			case 'prefix_allow_edits':
				return $elm$json$Json$Decode$succeed(1);
			case 'omit':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Billing behaviour not supported');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FeeType$decodeFeeType = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'scaleGroupId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billingDescriptionBehaviour',
		$author$project$Model$FeeType$decodeBillingDescriptionBehavior,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'billingBehaviour',
			$author$project$Model$Fee$BillingBehaviour$decodeBillingBehaviour,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'direction',
				$author$project$Activities$Model$Event$decodeActivityDirection,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'kind',
					$elm$json$Json$Decode$nullable($author$project$Activities$Model$ActivityType$decodeActivityType),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'otherDescription',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'feeDescriptionPrefix',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'code',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$int,
										$elm$json$Json$Decode$succeed($author$project$Model$FeeType$FeeType)))))))))));
var $author$project$Model$Fees$AllClosed = {$: 1};
var $author$project$PagedLoadingStatus$PagedFees = 0;
var $Gizra$elm_debouncer$Debouncer$Messages$debounce = $Gizra$elm_debouncer$Debouncer$Basic$debounce;
var $author$project$Model$Fee$FeeTypeView$DisplayFeeType = {$: 0};
var $author$project$Model$Fee$Fee = function (id) {
	return function (feeType) {
		return function (insertedAt) {
			return function (description) {
				return function (units) {
					return function (billingBehaviour) {
						return function (reasonCreated) {
							return function (occurredAt) {
								return function (activity) {
									return function (matter) {
										return function (fileNotes) {
											return function (hasGuessedMatter) {
												return function (hasPendingMatter) {
													return function (onHold) {
														return function (descriptionScrollTop) {
															return function (postStatus) {
																return function (unpostableReasons) {
																	return function (failureReason) {
																		return function (failedAt) {
																			return function (feeTypeView) {
																				return function (aiInput) {
																					return function (matterInput) {
																						return function (durationInputDebouncer) {
																							return function (consolidatedFees) {
																								return function (tempDateString) {
																									return function (tempTimeString) {
																										return function (subjectEditor) {
																											return function (splitDurationInSeconds) {
																												return function (isActionsMenuOpen) {
																													return function (openFilingMenuFeeId) {
																														return function (isConsolidatedFeesOpen) {
																															return function (timer) {
																																return function (recordInMinutes) {
																																	return function (descriptionKey) {
																																		return function (actionStepRate) {
																																			return function (actionStepRateValue) {
																																				return function (cachedRateValue) {
																																					return function (scaleItem) {
																																						return function (actionStepRateValues) {
																																							return function (scaleItems) {
																																								return function (activityCode) {
																																									return function (taskCode) {
																																										return function (timekeeperCode) {
																																											return function (temporaryId) {
																																												return function (tags) {
																																													return {fD: actionStepRate, aO: actionStepRateValue, cO: actionStepRateValues, fG: activity, bp: activityCode, aQ: aiInput, fS: billingBehaviour, f_: cachedRateValue, gm: consolidatedFees, dd: description, gC: descriptionKey, gD: descriptionScrollTop, dj: durationInputDebouncer, dy: failedAt, dz: failureReason, g0: feeType, g1: feeTypeView, g6: fileNotes, aB: hasGuessedMatter, a_: hasPendingMatter, aC: id, d4: insertedAt, hx: isActionsMenuOpen, hA: isConsolidatedFeesOpen, hY: matter, eg: matterInput, b7: occurredAt, ip: onHold, cb: openFilingMenuFeeId, eD: postStatus, cg: reasonCreated, iQ: recordInMinutes, bd: scaleItem, be: scaleItems, jc: splitDurationInSeconds, ad: subjectEditor, fi: tags, cE: taskCode, js: tempDateString, jt: tempTimeString, ju: temporaryId, cG: timekeeperCode, jA: timer, jP: units, cK: unpostableReasons};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$ActionStep$RateValue$RateValue = F6(
	function (externalId, overrideSource, overrideRate, displayName, actionStepRateLabelId, isFixedAmount) {
		return {fE: actionStepRateLabelId, dg: displayName, gR: externalId, hE: isFixedAmount, iB: overrideRate, ev: overrideSource};
	});
var $author$project$Model$ActionStep$RateValue$CodedUserClient = 6;
var $author$project$Model$ActionStep$RateValue$Contact = 1;
var $author$project$Model$ActionStep$RateValue$Matter = 0;
var $author$project$Model$ActionStep$RateValue$Organisation = 3;
var $author$project$Model$ActionStep$RateValue$User = 2;
var $author$project$Model$ActionStep$RateValue$UserClient = 5;
var $author$project$Model$ActionStep$RateValue$UserMatter = 4;
var $author$project$Model$ActionStep$RateValue$decodeRateValueSource = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'organisation':
				return $elm$json$Json$Decode$succeed(3);
			case 'user':
				return $elm$json$Json$Decode$succeed(2);
			case 'contact':
				return $elm$json$Json$Decode$succeed(1);
			case 'matter':
				return $elm$json$Json$Decode$succeed(0);
			case 'user_matter':
				return $elm$json$Json$Decode$succeed(4);
			case 'user_client':
				return $elm$json$Json$Decode$succeed(5);
			case 'coded_user_client':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('Failed to decode rate value source');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$ActionStep$RateValue$decodeActionStepRateValue = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isFixedAmount',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actionStepRateLabelId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'displayName',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'overrideRate',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'overrideSource',
					$author$project$Model$ActionStep$RateValue$decodeRateValueSource,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'externalId',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$ActionStep$RateValue$RateValue)))))));
var $author$project$Model$Fee$ConsolidatedFees = $elm$core$Basics$identity;
var $author$project$Model$Fee$baseFeeConstructor = F9(
	function (id, feeType, insertedAt, description, units, billingBehaviour, reasonCreated, occurredAt, activity) {
		return {fG: activity, fS: billingBehaviour, dd: description, g0: feeType, aC: id, d4: insertedAt, b7: occurredAt, cg: reasonCreated, jP: units};
	});
var $author$project$Model$Fee$ChargingPreference = 3;
var $author$project$Model$Fee$ClonedEntry = 6;
var $author$project$Model$Fee$Consolidated = 5;
var $author$project$Model$Fee$LinkedMatter = 2;
var $author$project$Model$Fee$Manual = 1;
var $author$project$Model$Fee$MatterInSubject = 4;
var $author$project$Model$Fee$SplitEntry = 7;
var $author$project$Model$Fee$Unknown = 0;
var $author$project$Model$Fee$decodeReasonCreated = A2(
	$elm$json$Json$Decode$andThen,
	function (reason) {
		switch (reason) {
			case 'Manual':
				return $elm$json$Json$Decode$succeed(1);
			case 'ClonedEntry':
				return $elm$json$Json$Decode$succeed(6);
			case 'SplitEntry':
				return $elm$json$Json$Decode$succeed(7);
			case 'LinkedMatter':
				return $elm$json$Json$Decode$succeed(2);
			case 'ChargingPreference':
				return $elm$json$Json$Decode$succeed(3);
			case 'MatterInSubject':
				return $elm$json$Json$Decode$succeed(4);
			case 'Consolidated':
				return $elm$json$Json$Decode$succeed(5);
			case 'Unknown':
				return $elm$json$Json$Decode$succeed(0);
			default:
				var unexpectedReason = reason;
				return $elm$json$Json$Decode$fail('Unexpected reason created field value: ' + unexpectedReason);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Model$Fee$decodeConsolidatedFee = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'activity',
	$elm$json$Json$Decode$nullable($author$project$Activities$Data$activityDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'occurredAt',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reasonCreated',
			$author$project$Model$Fee$decodeReasonCreated,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'billingBehaviour',
				$author$project$Model$Fee$BillingBehaviour$decodeBillingBehaviour,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'units',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'insertedAt',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'feeType',
								$author$project$Model$FeeType$decodeFeeType,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Model$Fee$baseFeeConstructor))))))))));
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Model$Fee$decodeConsolidatedFees = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Model$Fee$decodeConsolidatedFee;
			})));
var $author$project$Components$MatterInput$Model$Model = F9(
	function (matterEditMode, recentMatters, recentRestrictedMatters, suggestedMatters, searchResultsMatters, searchDebouncer, searchTerms, contact, autocompleteIndex) {
		return {av: autocompleteIndex, c2: contact, bY: matterEditMode, iP: recentMatters, eI: recentRestrictedMatters, i0: searchDebouncer, eW: searchResultsMatters, eX: searchTerms, fe: suggestedMatters};
	});
var $author$project$EditMode$Show = 1;
var $Gizra$elm_debouncer$Debouncer$Messages$toDebouncer = $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer;
var $author$project$Model$Fee$decodeMatterInput = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'contact',
		$elm$json$Json$Decode$nullable($author$project$Contacts$Data$decodeContact),
		$elm$core$Maybe$Nothing,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			'',
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$Gizra$elm_debouncer$Debouncer$Messages$toDebouncer(
					$Gizra$elm_debouncer$Debouncer$Messages$debounce(1000)),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						$krisajenkins$remotedata$RemoteData$NotAsked,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							$krisajenkins$remotedata$RemoteData$NotAsked,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								_List_Nil,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									1,
									$elm$json$Json$Decode$succeed($author$project$Components$MatterInput$Model$Model))))))))));
var $author$project$Model$Fee$PostStatus$Failed = 6;
var $author$project$Model$Fee$PostStatus$InTransit = 3;
var $author$project$Model$Fee$PostStatus$Posted = 4;
var $author$project$Model$Fee$PostStatus$PostedModified = 5;
var $author$project$Model$Fee$PostStatus$Processing = 2;
var $author$project$Model$Fee$PostStatus$Quarantined = 7;
var $author$project$Model$Fee$PostStatus$Queued = 1;
var $author$project$Model$Fee$PostStatus$Unqueued = 0;
var $author$project$Model$Fee$PostStatus$fromString = function (postStatus) {
	switch (postStatus) {
		case 'unqueued':
			return 0;
		case 'queued':
			return 1;
		case 'processing':
			return 2;
		case 'in_transit':
			return 3;
		case 'posted':
			return 4;
		case 'posted_modified':
			return 5;
		case 'failed':
			return 6;
		case 'quarantined':
			return 7;
		default:
			return 6;
	}
};
var $author$project$Model$Fee$PostStatus$decodePostStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Model$Fee$PostStatus$fromString(status));
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$ActionStep$Rate$Rate = F6(
	function (id, externalId, name, unitPrice, isDeleted, rateValues) {
		return {gR: externalId, aC: id, d6: isDeleted, b2: name, iN: rateValues, jO: unitPrice};
	});
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Model$ActionStep$Rate$decodeRateLabelAndValue = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'custom_rate_values',
	$elm$json$Json$Decode$list($author$project$Model$ActionStep$RateValue$decodeActionStepRateValue),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_deleted',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'unit_price',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'external_id',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
						$elm$json$Json$Decode$succeed($author$project$Model$ActionStep$Rate$Rate)))))));
var $author$project$Model$ScaleItem$ScaleItem = F3(
	function (id, externalId, description) {
		return {dd: description, gR: externalId, aC: id};
	});
var $author$project$Model$ScaleItem$decodeScaleItem = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'externalId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Model$ScaleItem$ScaleItem))));
var $author$project$Model$UtbmsCode$TaskCode = F5(
	function (id, externalId, description, categoryCode, parentUtbmsCodeId) {
		return {f8: categoryCode, dd: description, gR: externalId, aC: id, ex: parentUtbmsCodeId};
	});
var $author$project$Model$UtbmsCode$decodeTaskCode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'parentUtbmsCodeId',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'categoryCode',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'externalId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Model$UtbmsCode$TaskCode))))));
var $author$project$Model$Fee$Timer = F4(
	function (startedAt, stoppedAt, totalMilliseconds, currentTime) {
		return {gw: currentTime, jf: startedAt, jk: stoppedAt, jJ: totalMilliseconds};
	});
var $author$project$Model$Fee$decodeTimer = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'currentTime',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'totalMilliseconds',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'stoppedAt',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'startedAt',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				$elm$json$Json$Decode$succeed($author$project$Model$Fee$Timer)))));
var $author$project$Model$Fee$ActionStepRateUnavailable = {$: 6};
var $author$project$Model$Fee$ArchivedMatter = {$: 2};
var $author$project$Model$Fee$Dispatched = {$: 14};
var $author$project$Model$Fee$FutureDated = {$: 13};
var $author$project$Model$Fee$HeldFee = {$: 11};
var $author$project$Model$Fee$HeldMatter = {$: 10};
var $author$project$Model$Fee$MissingDescription = {$: 0};
var $author$project$Model$Fee$MissingTag = {$: 15};
var $author$project$Model$Fee$PendingMatter = {$: 9};
var $author$project$Model$Fee$RateValueInvalid = {$: 7};
var $author$project$Model$Fee$RunningTimer = {$: 12};
var $author$project$Model$Fee$ScaleItemMissing = {$: 4};
var $author$project$Model$Fee$Unpostable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Fee$UnverifiedMatter = {$: 1};
var $author$project$Model$Fee$UtbmsCodeMissing = {$: 8};
var $author$project$Model$Fee$decodeUnpostableReason = A2(
	$elm$json$Json$Decode$andThen,
	function (input) {
		switch (input) {
			case 'dispatched':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$Dispatched);
			case 'missingDescription':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$MissingDescription);
			case 'pendingMatter':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$PendingMatter);
			case 'unverifiedMatter':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$UnverifiedMatter);
			case 'archivedMatter':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$ArchivedMatter);
			case 'heldMatter':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$HeldMatter);
			case 'heldFee':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$HeldFee);
			case 'invalidDate':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$FutureDated);
			case 'runningTimer':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$RunningTimer);
			case 'scaleItemMissing':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$ScaleItemMissing);
			case 'rateLabelUnavailable':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$ActionStepRateUnavailable);
			case 'rateValueInvalid':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$RateValueInvalid);
			case 'utbmsCodesMissing':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$UtbmsCodeMissing);
			case 'missingTag':
				return $elm$json$Json$Decode$succeed($author$project$Model$Fee$MissingTag);
			default:
				return $elm$json$Json$Decode$succeed(
					$author$project$Model$Fee$Unpostable(input));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$UtbmsCode$UtbmsCode = F3(
	function (id, externalId, description) {
		return {dd: description, gR: externalId, aC: id};
	});
var $author$project$Model$UtbmsCode$decodeUtbmsCode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'externalId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Model$UtbmsCode$UtbmsCode))));
var $author$project$Components$AiInput$Model$Closed = 1;
var $author$project$Components$AiInput$Model$Idle = {$: 1};
var $author$project$Components$AiInput$Model$defaultAiInputModel = {eQ: $author$project$Components$AiInput$Model$Idle, ff: 1, fg: $elm$core$Maybe$Nothing};
var $author$project$Model$Fee$defaultMatterInput = {
	av: $elm$core$Maybe$Nothing,
	c2: $elm$core$Maybe$Nothing,
	bY: 1,
	iP: _List_Nil,
	eI: $krisajenkins$remotedata$RemoteData$NotAsked,
	i0: $Gizra$elm_debouncer$Debouncer$Messages$toDebouncer(
		$Gizra$elm_debouncer$Debouncer$Messages$debounce(1000)),
	eW: $krisajenkins$remotedata$RemoteData$NotAsked,
	eX: '',
	fe: $krisajenkins$remotedata$RemoteData$NotAsked
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Model$Fee$nullableDefaultWith = function (_default) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (maybeDescription) {
			return $elm$json$Json$Decode$succeed(
				A2($elm$core$Maybe$withDefault, _default, maybeDescription));
		},
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, path, valDecoder, fallback),
			decoder);
	});
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {jD: toAmPm, jE: toMonthAbbreviation, jF: toMonthName, ap: toOrdinalSuffix, jG: toWeekdayAbbreviation, jH: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.cA, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.jD(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		gA: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		h9: month,
		j$: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gA;
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).h9;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).j$;
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$core$String$toLower = _String_toLower;
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ap(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.jE(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.jF(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ap(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ap(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ap(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ap(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.jG(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.jH(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ap(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$MonthFixed = {$: 2};
var $ryan_haskell$date_format$DateFormat$monthFixed = $ryan_haskell$date_format$DateFormat$MonthFixed;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$CoreX$DateFormat$toDateString = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text('-'),
			$ryan_haskell$date_format$DateFormat$monthFixed,
			$ryan_haskell$date_format$DateFormat$text('-'),
			$ryan_haskell$date_format$DateFormat$dayOfMonthFixed
		]));
var $author$project$Model$Fee$decodeFee = function () {
	var tempDate = function (d) {
		return $author$project$CoreX$DateFormat$toDateString(d);
	};
	var descriptionKey = function (f) {
		return $elm$core$String$fromInt(f.aC);
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fee) {
			return $elm$json$Json$Decode$succeed(
				_Utils_update(
					fee,
					{
						gC: descriptionKey(fee)
					}));
		},
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tags',
			$elm$json$Json$Decode$list($author$project$Model$Tag$decodeTag),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'timekeeperCode',
					$elm$json$Json$Decode$maybe($author$project$Model$UtbmsCode$decodeUtbmsCode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'taskCode',
						$elm$json$Json$Decode$maybe($author$project$Model$UtbmsCode$decodeTaskCode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'activityCode',
							$elm$json$Json$Decode$maybe($author$project$Model$UtbmsCode$decodeUtbmsCode),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								$krisajenkins$remotedata$RemoteData$Success(_List_Nil),
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									$krisajenkins$remotedata$RemoteData$Success(_List_Nil),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'scaleItem',
										$elm$json$Json$Decode$nullable($author$project$Model$ScaleItem$decodeScaleItem),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'cachedRateValue',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'actionStepRateValue',
												$elm$json$Json$Decode$nullable($author$project$Model$ActionStep$RateValue$decodeActionStepRateValue),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'actionStepRate',
													$elm$json$Json$Decode$nullable($author$project$Model$ActionStep$Rate$decodeRateLabelAndValue),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'description',
														$author$project$Model$Fee$nullableDefaultWith(''),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'recordInMinutes',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'timer',
																$elm$json$Json$Decode$nullable($author$project$Model$Fee$decodeTimer),
																A2(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																	false,
																	A2(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																		$elm$core$Maybe$Nothing,
																		A2(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																			false,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'splitDurationInSeconds',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																				A2(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																					$elm$core$Maybe$Nothing,
																					A2(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																						$elm$core$Maybe$Nothing,
																						A2(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																							$elm$core$Maybe$Nothing,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'consolidatedFees',
																								$author$project$Model$Fee$decodeConsolidatedFees,
																								A2(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																									$Gizra$elm_debouncer$Debouncer$Messages$toDebouncer(
																										$Gizra$elm_debouncer$Debouncer$Messages$debounce(300)),
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																										_List_fromArray(
																											['activity']),
																										$author$project$Model$Fee$decodeMatterInput,
																										$author$project$Model$Fee$defaultMatterInput,
																										A2(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																											$author$project$Components$AiInput$Model$defaultAiInputModel,
																											A2(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																												$author$project$Model$Fee$FeeTypeView$DisplayFeeType,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'failedAt',
																													$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'failureReason',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'unpostableReasons',
																															$elm$json$Json$Decode$list($author$project$Model$Fee$decodeUnpostableReason),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'postStatus',
																																$author$project$Model$Fee$PostStatus$decodePostStatus,
																																A2(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																																	0,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'onHold',
																																		$elm$json$Json$Decode$bool,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'hasPendingMatter',
																																			$elm$json$Json$Decode$bool,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'hasGuessedMatter',
																																				$elm$json$Json$Decode$bool,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'fileNotes',
																																					$elm$json$Json$Decode$list($author$project$Components$FileNotes$Types$FileNote$fileNoteDecoder),
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'matter',
																																						$elm$json$Json$Decode$nullable($author$project$MatterTypes$decodeMatter),
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'activity',
																																							$elm$json$Json$Decode$nullable($author$project$Activities$Data$activityDecoder),
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'occurredAt',
																																								$elm_community$json_extra$Json$Decode$Extra$datetime,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'reasonCreated',
																																									$author$project$Model$Fee$decodeReasonCreated,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'billingBehaviour',
																																										$author$project$Model$Fee$BillingBehaviour$decodeBillingBehaviour,
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'units',
																																											$elm$json$Json$Decode$float,
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'description',
																																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'insertedAt',
																																													$elm$json$Json$Decode$string,
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'feeType',
																																														$author$project$Model$FeeType$decodeFeeType,
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'id',
																																															$elm$json$Json$Decode$int,
																																															$elm$json$Json$Decode$succeed($author$project$Model$Fee$Fee)))))))))))))))))))))))))))))))))))))))))))))));
}();
var $rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_sorter_experiment$Sort$Dict$empty = function (sorter) {
	return $rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter);
};
var $author$project$PagedLoadingStatusLogic$activitiesPerPage = 10;
var $author$project$PagedLoadingStatusLogic$feesPerPage = 20;
var $author$project$PagedLoadingStatus$MoreAvailable = 1;
var $author$project$PagedLoadingStatus$OnLastPage = 2;
var $author$project$PagedLoadingStatusLogic$pageLoading = function (hasMoreToLoad) {
	return hasMoreToLoad ? 1 : 2;
};
var $author$project$PagedLoadingStatusLogic$hasMore = F2(
	function (pageFor, entries) {
		return $author$project$PagedLoadingStatusLogic$pageLoading(
			function () {
				if (pageFor === 1) {
					return _Utils_cmp(
						$elm$core$List$length(entries),
						$author$project$PagedLoadingStatusLogic$activitiesPerPage) > -1;
				} else {
					return _Utils_cmp(
						$elm$core$List$length(entries),
						$author$project$PagedLoadingStatusLogic$feesPerPage) > -1;
				}
			}());
	});
var $author$project$CoreX$DateCompare$compare_ = F2(
	function (a, b) {
		return A2(
			$elm$core$Basics$compare,
			$elm$time$Time$posixToMillis(a),
			$elm$time$Time$posixToMillis(b));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Model$Fees$oldestEntry = function (fees) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$sortWith,
			F2(
				function (e1, e2) {
					return A2($author$project$CoreX$DateCompare$compare_, e1.b7, e2.b7);
				}),
			fees));
};
var $rtfeldman$elm_sorter_experiment$Sort$Sorter = $elm$core$Basics$identity;
var $rtfeldman$elm_sorter_experiment$Sort$compareNumbers = F2(
	function (first, second) {
		return A2($elm$core$Basics$compare, first + 0, second);
	});
var $rtfeldman$elm_sorter_experiment$Sort$increasing = $rtfeldman$elm_sorter_experiment$Sort$compareNumbers;
var $rtfeldman$elm_sorter_experiment$Sort$flip = F3(
	function (fn, a, b) {
		return A2(fn, b, a);
	});
var $rtfeldman$elm_sorter_experiment$Sort$reverse = function (_v0) {
	var sort = _v0;
	return $rtfeldman$elm_sorter_experiment$Sort$flip(sort);
};
var $author$project$CoreX$Sorter$reverseInt = $rtfeldman$elm_sorter_experiment$Sort$reverse($rtfeldman$elm_sorter_experiment$Sort$increasing);
var $author$project$Model$Fees$decodeFees = A2(
	$elm$json$Json$Decode$andThen,
	function (fees) {
		return $elm$json$Json$Decode$succeed(
			{
				cV: $author$project$Model$Fees$oldestEntry(fees),
				gj: $elm$core$Set$empty,
				c4: $author$project$Model$Fees$AllClosed,
				dc: {
					c8: $Gizra$elm_debouncer$Debouncer$Messages$toDebouncer(
						$Gizra$elm_debouncer$Debouncer$Messages$debounce(500)),
					dD: _List_Nil
				},
				$7: $rtfeldman$elm_sorter_experiment$Sort$Dict$empty($author$project$CoreX$Sorter$reverseInt),
				dE: A2($author$project$PagedLoadingStatusLogic$hasMore, 0, fees),
				d1: fees,
				e1: $elm$core$Maybe$Nothing
			});
	},
	$elm$json$Json$Decode$list($author$project$Model$Fee$decodeFee));
var $author$project$Model$IntegrationStatuses$IntegrationStatuses = F4(
	function (exchange, phone, pms, browserExtension) {
		return {cX: browserExtension, bC: exchange, iG: phone, ce: pms};
	});
var $author$project$Model$IntegrationStatuses$IntegrationStatus = F4(
	function (state, text, extraInformation, link) {
		return {gV: extraInformation, hW: link, jh: state, fk: text};
	});
var $author$project$Model$IntegrationStatuses$IntegrationDisabled = 2;
var $author$project$Model$IntegrationStatuses$IntegrationError = 0;
var $author$project$Model$IntegrationStatuses$IntegrationOk = 3;
var $author$project$Model$IntegrationStatuses$IntegrationPending = 1;
var $author$project$Model$IntegrationStatuses$decodeIntegrationState = A2(
	$elm$json$Json$Decode$andThen,
	function (input) {
		switch (input) {
			case 'error':
				return $elm$json$Json$Decode$succeed(0);
			case 'pending':
				return $elm$json$Json$Decode$succeed(1);
			case 'disabled':
				return $elm$json$Json$Decode$succeed(2);
			case 'ok':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$succeed(3);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$IntegrationStatuses$IntegrationStatusLink = F2(
	function (to, text) {
		return {fk: text, jC: to};
	});
var $author$project$Model$IntegrationStatuses$decodeStatusLink = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'text',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'to',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$IntegrationStatuses$IntegrationStatusLink)));
var $author$project$Model$IntegrationStatuses$decodeIntegrationStatus = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'link',
	$elm$json$Json$Decode$nullable($author$project$Model$IntegrationStatuses$decodeStatusLink),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'extra_information',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'text',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'state',
				$author$project$Model$IntegrationStatuses$decodeIntegrationState,
				$elm$json$Json$Decode$succeed($author$project$Model$IntegrationStatuses$IntegrationStatus)))));
var $author$project$Model$IntegrationStatuses$decodeIntegrationStatuses = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'browser_extension',
	$author$project$Model$IntegrationStatuses$decodeIntegrationStatus,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pms',
		$author$project$Model$IntegrationStatuses$decodeIntegrationStatus,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			$author$project$Model$IntegrationStatuses$decodeIntegrationStatus,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'exchange',
				$author$project$Model$IntegrationStatuses$decodeIntegrationStatus,
				$elm$json$Json$Decode$succeed($author$project$Model$IntegrationStatuses$IntegrationStatuses)))));
var $author$project$MatterTypes$decodeMatters = $elm$json$Json$Decode$list($author$project$MatterTypes$decodeMatter);
var $author$project$User$Data$User = function (id) {
	return function (token) {
		return function (email) {
			return function (name) {
				return function (organisationId) {
					return function (organisationName) {
						return function (connectorIds) {
							return function (isFeeEarner) {
								return function (isAdmin) {
									return function (isSuperAdmin) {
										return function (impersonation) {
											return function (pms) {
												return function (dms) {
													return function (defaultFeeTypeId) {
														return function (weeklyBudgets) {
															return function (showDailyBudgetSummary) {
																return function (showNonChargeableOnBudgetBar) {
																	return function (countNonChargeablesInBudget) {
																		return function (showTimePointer) {
																			return function (minutesPerUnit) {
																				return function (splitIncrement) {
																					return function (splitExtraTo) {
																						return function (feeExpiryDays) {
																							return function (fileNoteCustomisation) {
																								return function (tours) {
																									return function (hasActivityFeedOnLeft) {
																										return function (trackActivities) {
																											return function (collapseActivityFeed) {
																												return function (insertedAt) {
																													return function (signInCount) {
																														return function (currentSignInAt) {
																															return function (showPostedEntries) {
																																return function (showReadingDocumentActivities) {
																																	return function (canEditFiledEmailSubject) {
																																		return function (canFileEmail) {
																																			return function (canHoldFee) {
																																				return function (canRecordInMinutes) {
																																					return function (canSetFileProRates) {
																																						return function (canUseAiSummary) {
																																							return function (canEditPostedFees) {
																																								return function (canViewRateValues) {
																																									return function (tags) {
																																										return {f$: canEditFiledEmailSubject, f0: canEditPostedFees, f1: canFileEmail, f2: canHoldFee, f3: canRecordInMinutes, aS: canSetFileProRates, f6: canUseAiSummary, f7: canViewRateValues, gg: collapseActivityFeed, gi: connectorIds, aT: countNonChargeablesInBudget, gu: currentSignInAt, da: defaultFeeTypeId, E: dms, gL: email, aX: feeExpiryDays, bH: fileNoteCustomisation, am: hasActivityFeedOnLeft, aC: id, a$: impersonation, d4: insertedAt, hy: isAdmin, hD: isFeeEarner, d7: isSuperAdmin, ej: minutesPerUnit, b2: name, ix: organisationId, iy: organisationName, ce: pms, i5: showDailyBudgetSummary, i6: showNonChargeableOnBudgetBar, i7: showPostedEntries, i8: showReadingDocumentActivities, e5: showTimePointer, i9: signInCount, jd: splitExtraTo, je: splitIncrement, fi: tags, jI: token, cI: tours, jL: trackActivities, jY: weeklyBudgets};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$Data$DMS = F7(
	function (preferredLibrary, libraries, docSystem, fileNoteTemplates, documentUrlPrefix, folderUrlPrefix, workspaceUrlPrefix) {
		return {by: docSystem, di: documentUrlPrefix, dF: fileNoteTemplates, dM: folderUrlPrefix, hU: libraries, iI: preferredLibrary, fw: workspaceUrlPrefix};
	});
var $author$project$User$Data$IManage = 1;
var $author$project$User$Data$NetDocs = 0;
var $author$project$User$Data$None = 2;
var $author$project$User$Data$decodeDocSystem = A2(
	$elm$json$Json$Decode$andThen,
	function (dms) {
		switch (dms) {
			case 'NetDocs':
				return $elm$json$Json$Decode$succeed(0);
			case 'IManage':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$succeed(2);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$User$Data$FileNoteTemplate = F3(
	function (id, title, _default) {
		return {c9: _default, aC: id, jB: title};
	});
var $author$project$User$Data$decodeFileNoteTemplate = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'default',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$json$Json$Decode$succeed($author$project$User$Data$FileNoteTemplate))));
var $author$project$User$Data$decodeDms = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'workspaceUrlPrefix',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'folderUrlPrefix',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'documentUrlPrefix',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fileNoteTemplates',
				$elm$json$Json$Decode$list($author$project$User$Data$decodeFileNoteTemplate),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'docSystem',
					$author$project$User$Data$decodeDocSystem,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'libraries',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'preferredLibrary',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$User$Data$DMS))))))));
var $author$project$Components$SplitFee$SplitLogic$New = 1;
var $author$project$Components$SplitFee$SplitLogic$Original = 0;
var $author$project$User$Data$decodeExtraTo = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'original':
				return $elm$json$Json$Decode$succeed(0);
			case 'new':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknown splitExtraTo: ' + value);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$User$Data$FileNoteCustomisation = F3(
	function (label, appendUnits, prompt) {
		return {fN: appendUnits, ec: label, iL: prompt};
	});
var $author$project$User$Data$decodeFileNoteCustomisation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'prompt',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'appendUnits',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$User$Data$FileNoteCustomisation))));
var $author$project$User$Data$Impersonation = F2(
	function (impersonationType, name) {
		return {hp: impersonationType, b2: name};
	});
var $author$project$User$Data$Delegate = 1;
var $author$project$User$Data$SuperAdmin = 0;
var $author$project$User$Data$decodeImpersonationType = A2(
	$elm$json$Json$Decode$andThen,
	function (key) {
		switch (key) {
			case 'SuperAdmin':
				return $elm$json$Json$Decode$succeed(0);
			case 'Delegate':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var unexpectedValue = key;
				return $elm$json$Json$Decode$fail('Unexpected impersonation value: ' + unexpectedValue);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$User$Data$decodeImpersonation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'impersonationType',
		$author$project$User$Data$decodeImpersonationType,
		$elm$json$Json$Decode$succeed($author$project$User$Data$Impersonation)));
var $author$project$User$Data$ActionStep = 1;
var $author$project$User$Data$Aderant = 5;
var $author$project$User$Data$Affinity = 0;
var $author$project$User$Data$Clio = 6;
var $author$project$User$Data$FilePro = 2;
var $author$project$User$Data$FileProWithScale = 3;
var $author$project$User$Data$Nebulaw = 4;
var $author$project$User$Data$Toca = 7;
var $author$project$User$Data$decodePms = A2(
	$elm$json$Json$Decode$andThen,
	function (pms) {
		switch (pms) {
			case 'FileProWithScale':
				return $elm$json$Json$Decode$succeed(3);
			case 'FilePro':
				return $elm$json$Json$Decode$succeed(2);
			case 'ActionStep':
				return $elm$json$Json$Decode$succeed(1);
			case 'Affinity':
				return $elm$json$Json$Decode$succeed(0);
			case 'Nebulaw':
				return $elm$json$Json$Decode$succeed(4);
			case 'AderantClassic':
				return $elm$json$Json$Decode$succeed(5);
			case 'Clio':
				return $elm$json$Json$Decode$succeed(6);
			case 'Toca':
				return $elm$json$Json$Decode$succeed(7);
			default:
				var unexpectedPms = pms;
				return $elm$json$Json$Decode$fail('Unexpected pms value: ' + unexpectedPms);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$User$Data$Tours = F4(
	function (hasCompletedManualFeeTour, hasCompletedActivityReviewTour, hasAcknowledgedFeeGrouping, hasAcknowledgedMerging) {
		return {hg: hasAcknowledgedFeeGrouping, hh: hasAcknowledgedMerging, hi: hasCompletedActivityReviewTour, hj: hasCompletedManualFeeTour};
	});
var $author$project$User$Data$decodeTours = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hasAcknowledgedMerging',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hasAcknowledgedFeeGrouping',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hasCompletedActivityReviewTour',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'hasCompletedManualFeeTour',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$User$Data$Tours)))));
var $author$project$User$Data$WeeklyBudgets = F7(
	function (mondayBudget, tuesdayBudget, wednesdayBudget, thursdayBudget, fridayBudget, saturdayBudget, sundayBudget) {
		return {hc: fridayBudget, h8: mondayBudget, i$: saturdayBudget, jn: sundayBudget, jx: thursdayBudget, jM: tuesdayBudget, jW: wednesdayBudget};
	});
var $author$project$User$Data$decodeWeeklyBudgets = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sundayBudget',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'saturdayBudget',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fridayBudget',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'thursdayBudget',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'wednesdayBudget',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tuesdayBudget',
						$elm$json$Json$Decode$float,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'mondayBudget',
							$elm$json$Json$Decode$float,
							$elm$json$Json$Decode$succeed($author$project$User$Data$WeeklyBudgets))))))));
var $author$project$User$Data$decodeUser = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tags',
	$author$project$Model$Tag$decodeTags,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'canViewRateValues',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'canEditPostedFees',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'canUseAiSummary',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'canSetFileProRates',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'canRecordInMinutes',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'canHoldFee',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'canFileEmail',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'canEditFiledEmailSubject',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'showReadingDocumentActivities',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'showPostedEntries',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'currentSignInAt',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'signInCount',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'insertedAt',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'collapseActivityFeed',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'trackActivities',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'hasActivityFeedOnLeft',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'tours',
																		$author$project$User$Data$decodeTours,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'fileNoteCustomisation',
																			$elm$json$Json$Decode$nullable($author$project$User$Data$decodeFileNoteCustomisation),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'feeExpiryDays',
																				$elm$json$Json$Decode$int,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'splitExtraTo',
																					$author$project$User$Data$decodeExtraTo,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'splitIncrement',
																						$elm$json$Json$Decode$int,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'minutesPerUnit',
																							$elm$json$Json$Decode$int,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'showTimePointer',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'countNonChargeablesInBudget',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'showNonChargeableOnBudgetBar',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'showDailyBudgetSummary',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'weeklyBudgets',
																												$author$project$User$Data$decodeWeeklyBudgets,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'defaultFeeTypeId',
																													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'dms',
																														$author$project$User$Data$decodeDms,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'pms',
																															$author$project$User$Data$decodePms,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'impersonation',
																																$elm$json$Json$Decode$nullable($author$project$User$Data$decodeImpersonation),
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'isSuperAdmin',
																																	$elm$json$Json$Decode$bool,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'isAdmin',
																																		$elm$json$Json$Decode$bool,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'isFeeEarner',
																																			$elm$json$Json$Decode$bool,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'connectorIds',
																																				$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'organisationName',
																																					$elm$json$Json$Decode$string,
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'organisationId',
																																						$elm$json$Json$Decode$int,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'name',
																																							$elm$json$Json$Decode$string,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'email',
																																								$elm$json$Json$Decode$string,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'token',
																																									$elm$json$Json$Decode$string,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'id',
																																										$elm$json$Json$Decode$int,
																																										$elm$json$Json$Decode$succeed($author$project$User$Data$User)))))))))))))))))))))))))))))))))))))))))));
var $author$project$Model$UtbmsCodes$UtbmsCodes = F4(
	function (activityCodes, timekeeperCodes, taskCodes, parentTaskCodes) {
		return {fH: activityCodes, iE: parentTaskCodes, jr: taskCodes, jz: timekeeperCodes};
	});
var $author$project$Model$UtbmsCodes$decodeUtbmsCodes = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'parentTaskCodes',
	$elm$json$Json$Decode$list($author$project$Model$UtbmsCode$decodeUtbmsCode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'taskCodes',
		$elm$json$Json$Decode$list($author$project$Model$UtbmsCode$decodeTaskCode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'timekeeperCodes',
			$elm$json$Json$Decode$list($author$project$Model$UtbmsCode$decodeUtbmsCode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'activityCodes',
				$elm$json$Json$Decode$list($author$project$Model$UtbmsCode$decodeUtbmsCode),
				$elm$json$Json$Decode$succeed($author$project$Model$UtbmsCodes$UtbmsCodes)))));
var $author$project$Activities$Data$ActiveActivities = 0;
var $author$project$PagedLoadingStatus$PagedActivities = 1;
var $author$project$Activities$Data$activityFeedFilterToInt = function (feedFilter) {
	switch (feedFilter) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $turboMaCk$any_set$Set$Any$AnySet = $elm$core$Basics$identity;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $turboMaCk$any_dict$Dict$Any$AnyDict = $elm$core$Basics$identity;
var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
	return {d: $elm$core$Dict$empty, y: toKey};
};
var $turboMaCk$any_set$Set$Any$empty = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $turboMaCk$any_dict$Dict$Any$empty);
var $author$project$TimesheetPage$Data$initialActivityFeed = function (activities) {
	return $elm$json$Json$Decode$succeed(
		{
			fF: activities,
			cP: A2($author$project$PagedLoadingStatusLogic$hasMore, 1, activities),
			aP: 0,
			ds: _List_Nil,
			bG: _List_Nil,
			g2: $elm$core$Maybe$Nothing,
			g4: $turboMaCk$any_set$Set$Any$empty($author$project$Activities$Data$activityFeedFilterToInt),
			g5: 0,
			g8: false,
			am: false,
			it: $elm$core$Maybe$Nothing,
			i0: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
				$Gizra$elm_debouncer$Debouncer$Basic$debounce(500)),
			i1: 1,
			eX: $elm$core$Maybe$Nothing,
			cp: $elm$core$Set$empty,
			i8: true
		});
};
var $o_train$elm_search_input$Select$CustomFilter = $elm$core$Basics$identity;
var $author$project$EditMode$Edit = 0;
var $o_train$elm_search_input$Select$EmitMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$FeeEntry$Messages$MatterInputMessage = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$MatterInput$Messages$OpenMatterEdit = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$MatterInput$Messages$SingletonFee = 2;
var $o_train$elm_search_input$Select$flip = F3(
	function (fn, a, b) {
		return A2(fn, b, a);
	});
var $o_train$elm_search_input$Select$setSearch = F2(
	function (search, model) {
		return _Utils_update(
			model,
			{eV: search});
	});
var $o_train$elm_search_input$Select$setDebouncer = F2(
	function (debouncer, model) {
		var search = model.eV;
		return A3(
			$o_train$elm_search_input$Select$flip,
			$o_train$elm_search_input$Select$setSearch,
			model,
			_Utils_update(
				search,
				{c8: debouncer}));
	});
var $o_train$elm_search_input$Select$addDebounceInterval = F2(
	function (debounceInterval, model) {
		return A2(
			$o_train$elm_search_input$Select$setDebouncer,
			$Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
				$Gizra$elm_debouncer$Debouncer$Basic$debounce(debounceInterval)),
			model);
	});
var $o_train$elm_search_input$Select$setFilters = F2(
	function (filters, search) {
		return _Utils_update(
			search,
			{aA: filters});
	});
var $o_train$elm_search_input$Select$addFilter = F2(
	function (filter, model) {
		return A3(
			$o_train$elm_search_input$Select$flip,
			$o_train$elm_search_input$Select$setSearch,
			model,
			A3(
				$o_train$elm_search_input$Select$flip,
				$o_train$elm_search_input$Select$setFilters,
				model.eV,
				A2($elm$core$List$cons, filter, model.eV.aA)));
	});
var $o_train$elm_search_input$Select$addSearchQuery = F2(
	function (query, model) {
		var search = model.eV;
		return A3(
			$o_train$elm_search_input$Select$flip,
			$o_train$elm_search_input$Select$setSearch,
			model,
			_Utils_update(
				search,
				{iM: query}));
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $o_train$elm_search_input$Select$BasicQuery = {$: 0};
var $o_train$elm_search_input$Select$Closed = 1;
var $o_train$elm_search_input$Select$init = F2(
	function (label, toItem) {
		return {
			av: $elm$core$Maybe$Nothing,
			ec: label,
			bZ: $elm$core$Maybe$Nothing,
			aE: 0,
			a5: 1,
			eV: {
				c8: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
					$Gizra$elm_debouncer$Debouncer$Basic$debounce(0)),
				aA: _List_Nil,
				Q: _List_Nil,
				iM: $o_train$elm_search_input$Select$BasicQuery,
				iV: $krisajenkins$remotedata$RemoteData$NotAsked,
				N: $elm$core$Maybe$Nothing
			},
			e0: $elm$core$Maybe$Nothing,
			cs: true,
			cH: toItem
		};
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $o_train$elm_search_input$Select$HttpQuery = function (a) {
	return {$: 1, a: a};
};
var $author$project$Requests$Param = F2(
	function (name, value) {
		return {b2: name, af: value};
	});
var $author$project$EditMode$RestrictedEdit = 2;
var $author$project$MatterTypes$ExternalMatter = F5(
	function (id, externalIdentifier, code, description, billingBehaviour) {
		return {fS: billingBehaviour, br: code, dd: description, gS: externalIdentifier, aC: id};
	});
var $author$project$MatterTypes$decodeExternalMatter = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'billingBehaviour',
	$author$project$Model$Fee$BillingBehaviour$decodeBillingBehaviour,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'externalIdentifier',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$MatterTypes$ExternalMatter))))));
var $author$project$MatterTypes$decodeExternalMatters = $elm$json$Json$Decode$list($author$project$MatterTypes$decodeExternalMatter);
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $author$project$EditMode$toString = function (mode) {
	return (mode === 2) ? 'restricted' : 'unrestricted';
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Requests$toParamString = function (_v0) {
	var name = _v0.b2;
	var value = _v0.af;
	return A2(
		$elm$core$Maybe$map,
		function (v) {
			return A2(
				$elm$core$String$join,
				'=',
				_List_fromArray(
					[name, v]));
		},
		value);
};
var $author$project$Requests$toQueryString = function (params) {
	return A2(
		$elm$core$String$join,
		'&',
		A2($elm$core$List$filterMap, $author$project$Requests$toParamString, params));
};
var $author$project$Requests$toUrl = F2(
	function (baseUrl, params) {
		return A2(
			$elm$core$String$join,
			'?',
			A2(
				$elm$core$List$filter,
				function (str) {
					return !$elm$core$String$isEmpty(str);
				},
				_List_fromArray(
					[
						baseUrl,
						$author$project$Requests$toQueryString(params)
					])));
	});
var $author$project$FeeEntry$Selectors$ExternalMatters$searchQuery = $o_train$elm_search_input$Select$HttpQuery(
	function (terms) {
		return {
			fW: $elm$http$Http$emptyBody,
			gB: $author$project$MatterTypes$decodeExternalMatters,
			A: _List_Nil,
			ei: 'GET',
			jR: A2(
				$author$project$Requests$toUrl,
				'api/matters/search',
				_List_fromArray(
					[
						A2(
						$author$project$Requests$Param,
						'term',
						$elm$core$Maybe$Just(
							$elm$url$Url$percentEncode(
								A2($elm$core$Maybe$withDefault, '', terms)))),
						A2(
						$author$project$Requests$Param,
						'mode',
						$elm$core$Maybe$Just(
							$author$project$EditMode$toString(2)))
					]))
		};
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$FeeEntry$Selectors$ExternalMatters$toItem = function (externalMatter) {
	return {aC: externalMatter.aC, aa: externalMatter, hK: true, ec: externalMatter.gS + (' ' + externalMatter.dd)};
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Icons$Locked$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 15 20'),
					$elm$svg$Svg$Attributes$fill('currentColor')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M1.80775 19.5C1.31058 19.5 0.885 19.323 0.531 18.969C0.177 18.615 0 18.1894 0 17.6923V8.30775C0 7.81058 0.177 7.385 0.531 7.031C0.885 6.677 1.31058 6.5 1.80775 6.5H3V4.5C3 3.25133 3.43783 2.18917 4.3135 1.3135C5.18917 0.437833 6.25133 0 7.5 0C8.74867 0 9.81083 0.437833 10.6865 1.3135C11.5622 2.18917 12 3.25133 12 4.5V6.5H13.1923C13.6894 6.5 14.115 6.677 14.469 7.031C14.823 7.385 15 7.81058 15 8.30775V17.6923C15 18.1894 14.823 18.615 14.469 18.969C14.115 19.323 13.6894 19.5 13.1923 19.5H1.80775ZM7.5 14.75C7.98583 14.75 8.399 14.5798 8.7395 14.2395C9.07983 13.899 9.25 13.4858 9.25 13C9.25 12.5142 9.07983 12.101 8.7395 11.7605C8.399 11.4202 7.98583 11.25 7.5 11.25C7.01417 11.25 6.601 11.4202 6.2605 11.7605C5.92017 12.101 5.75 12.5142 5.75 13C5.75 13.4858 5.92017 13.899 6.2605 14.2395C6.601 14.5798 7.01417 14.75 7.5 14.75ZM4.5 6.5H10.5V4.5C10.5 3.66667 10.2083 2.95833 9.625 2.375C9.04167 1.79167 8.33333 1.5 7.5 1.5C6.66667 1.5 5.95833 1.79167 5.375 2.375C4.79167 2.95833 4.5 3.66667 4.5 4.5V6.5Z')
					]),
				_List_Nil)
			]));
};
var $author$project$FeeEntry$Selectors$ExternalMatters$selectorModel = A2(
	$o_train$elm_search_input$Select$addFilter,
	$author$project$Icons$Locked$viewWithAttributes(
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('elm-icon'),
				$elm$html$Html$Attributes$title('Matters'),
				$elm$html$Html$Events$onClick(
				$o_train$elm_search_input$Select$EmitMsg(
					$author$project$FeeEntry$Messages$MatterInputMessage(
						A2($author$project$Components$MatterInput$Messages$OpenMatterEdit, 0, 2))))
			])),
	A2(
		$o_train$elm_search_input$Select$addSearchQuery,
		$author$project$FeeEntry$Selectors$ExternalMatters$searchQuery,
		A2(
			$o_train$elm_search_input$Select$addDebounceInterval,
			300,
			A2($o_train$elm_search_input$Select$init, 'External Matters', $author$project$FeeEntry$Selectors$ExternalMatters$toItem))));
var $author$project$TimesheetPage$Data$decodeTimesheetModel = F2(
	function (csrfToken, cspNonce) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (mod) {
				var feed = mod.fI;
				var updatedActivityFeed = _Utils_update(
					feed,
					{bG: mod.bG, am: mod.jS.am, i8: mod.jS.i8});
				return $elm$json$Json$Decode$succeed(
					_Utils_update(
						mod,
						{fI: updatedActivityFeed}));
			},
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				cspNonce,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					csrfToken,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						0,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'utbmsCodes',
							$elm$json$Json$Decode$maybe($author$project$Model$UtbmsCodes$decodeUtbmsCodes),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								1,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									0,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
										$krisajenkins$remotedata$RemoteData$Loading,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											_List_Nil,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
												_List_Nil,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'integrationStatuses',
													$author$project$Model$IntegrationStatuses$decodeIntegrationStatuses,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'feeTypes',
														$elm$json$Json$Decode$list($author$project$Model$FeeType$decodeFeeType),
														A2(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
															A2(
																$elm$json$Json$Decode$andThen,
																$author$project$BudgetBar$Data$dashboardWithPreferenceDecoder,
																A2(
																	$elm$json$Json$Decode$at,
																	_List_fromArray(
																		['user', 'preferTimeline']),
																	$elm$json$Json$Decode$bool)),
															A2(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																$author$project$Components$MergeFees$Model$Closed,
																A2(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																	$author$project$FeeEntry$Selectors$ExternalMatters$selectorModel,
																	A2(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																		$author$project$Components$SearchInput$Model$Closed,
																		A2(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																			$elm$core$Maybe$Nothing,
																			A2(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																				$author$project$Components$Modal$Model$Closed,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'billingOptions',
																					$elm$json$Json$Decode$list($author$project$Model$Fee$BillingBehaviour$decodeBillingBehaviour),
																					A2(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																						$krisajenkins$remotedata$RemoteData$NotAsked,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'recentMatters',
																							$author$project$MatterTypes$decodeMatters,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'fees',
																								$author$project$Model$Fees$decodeFees,
																								A2(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																									$author$project$Model$FeeSearchConfiguration$decodeFeeSearchConfiguration,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'activities',
																										A2(
																											$elm$json$Json$Decode$andThen,
																											$author$project$TimesheetPage$Data$initialActivityFeed,
																											$elm$json$Json$Decode$list($author$project$Activities$Data$activityDecoder)),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'user',
																											$author$project$User$Data$decodeUser,
																											$elm$json$Json$Decode$succeed($author$project$TimesheetPage$Data$Model))))))))))))))))))))))))));
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$TimesheetPage$Data$decodeTimesheetData = F2(
	function (csrfToken, cspNonce) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'frontendVersion',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'announcementMsgReceivedAt',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'currentTime',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						$elm$time$Time$utc,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'timesheet',
							A2($author$project$TimesheetPage$Data$decodeTimesheetModel, csrfToken, cspNonce),
							$elm$json$Json$Decode$succeed($author$project$TimesheetPage$Data$ContextualModel))))));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $jzxhuang$http_extras$Http$Detailed$BadBody = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $jzxhuang$http_extras$Http$Detailed$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $jzxhuang$http_extras$Http$Detailed$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $jzxhuang$http_extras$Http$Detailed$NetworkError = {$: 2};
var $jzxhuang$http_extras$Http$Detailed$Timeout = {$: 1};
var $jzxhuang$http_extras$Http$Detailed$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$jzxhuang$http_extras$Http$Detailed$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($jzxhuang$http_extras$Http$Detailed$Timeout);
			case 2:
				return $elm$core$Result$Err($jzxhuang$http_extras$Http$Detailed$NetworkError);
			case 3:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Err(
					A2($jzxhuang$http_extras$Http$Detailed$BadStatus, metadata, body));
			default:
				var metadata = response.a;
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					A2($jzxhuang$http_extras$Http$Detailed$BadBody, metadata, body),
					toResult(
						_Utils_Tuple2(metadata, body)));
		}
	});
var $jzxhuang$http_extras$Http$Detailed$responseToJson = F2(
	function (decoder, responseString) {
		return A2(
			$jzxhuang$http_extras$Http$Detailed$resolve,
			function (_v0) {
				var metadata = _v0.a;
				var body = _v0.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$json$Json$Decode$errorToString,
					A2(
						$elm$json$Json$Decode$decodeString,
						A2(
							$elm$json$Json$Decode$map,
							function (res) {
								return _Utils_Tuple2(metadata, res);
							},
							decoder),
						body));
			},
			responseString);
	});
var $jzxhuang$http_extras$Http$Detailed$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$jzxhuang$http_extras$Http$Detailed$responseToJson(decoder));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {eL: reqs, fd: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.fo;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.eL));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.fd)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					fK: r.fK,
					fW: r.fW,
					z: A2(_Http_mapExpect, func, r.z),
					A: r.A,
					ei: r.ei,
					fl: r.fl,
					fo: r.fo,
					jR: r.jR
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{fK: false, fW: r.fW, z: r.z, A: r.A, ei: r.ei, fl: r.fl, fo: r.fo, jR: r.jR}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{fW: $elm$http$Http$emptyBody, z: r.z, A: _List_Nil, ei: 'GET', fl: $elm$core$Maybe$Nothing, fo: $elm$core$Maybe$Nothing, jR: r.jR});
};
var $author$project$Initialisation$Requests$fetchTimesheetData = F3(
	function (csrfToken, cspNonce, cmdMsg) {
		return $elm$http$Http$get(
			{
				z: A2(
					$jzxhuang$http_extras$Http$Detailed$expectJson,
					cmdMsg,
					A2($author$project$TimesheetPage$Data$decodeTimesheetData, csrfToken, cspNonce)),
				jR: '/api/timesheet'
			});
	});
var $author$project$User$Requests$fetchUser = function (cmdMsg) {
	return $elm$http$Http$get(
		{
			z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, cmdMsg, $author$project$User$Data$decodeUser),
			jR: '/api/user'
		});
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$init = function (flags) {
	var cmd = flags.bU ? A3($author$project$Initialisation$Requests$fetchTimesheetData, flags.gr, flags.c5, $author$project$Initialisation$Messages$FetchedTimesheetData) : $author$project$User$Requests$fetchUser($author$project$Initialisation$Messages$FetchedUser);
	return _Utils_Tuple2(
		{
			bq: flags.bq,
			c5: flags.c5,
			gr: flags.gr,
			hl: A2($author$project$Components$Header$Data$defaultHeader, flags.gr, flags.c5),
			bM: flags.bM,
			h7: $author$project$Components$Modal$Model$ClosedModal,
			b5: flags.b5,
			im: $krisajenkins$remotedata$RemoteData$NotAsked,
			iC: $author$project$Page$Initialising(flags.bU),
			ci: flags.ci,
			jS: $krisajenkins$remotedata$RemoteData$NotAsked
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Messages$IntialiseMsg, cmd));
};
var $author$project$Messages$FileNoteMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Messages$NotificationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Messages$PageMsg = function (a) {
	return {$: 6, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Components$FileNotes$Messages$ConfirmChangedTitle = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$FileNotes$Messages$FileNoteError = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$FileNotes$Types$FilingStatus$decodeTitleChanged = function (value) {
	return A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'titleChanged', $elm$json$Json$Decode$bool),
		value);
};
var $author$project$Ports$Channels$FileNotes$decodeConfirmTitleChanged = function (payload) {
	var _v0 = $author$project$Components$FileNotes$Types$FilingStatus$decodeTitleChanged(payload);
	if (!_v0.$) {
		return $author$project$Components$FileNotes$Messages$ConfirmChangedTitle(true);
	} else {
		return $author$project$Components$FileNotes$Messages$FileNoteError('Failed to decode Changed Title');
	}
};
var $author$project$Components$FileNotes$Types$FileNote$ForMatter = {$: 1};
var $author$project$Components$FileNotes$Messages$Open = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$FileNotes$Types$FilingStatus$FilingStatus = function (id) {
	return function (filingType) {
		return function (filedStatus) {
			return function (externalId) {
				return function (library) {
					return function (folder) {
						return function (folderName) {
							return function (matter) {
								return function (note) {
									return function (hasChangedContent) {
										return {gR: externalId, dG: filedStatus, g7: filingType, hb: folder, dL: folderName, dU: hasChangedContent, aC: id, hV: library, hY: matter, ij: note};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$FileNotes$Types$FilingStatus$Cancelled = {$: 7};
var $author$project$Components$FileNotes$Types$FilingStatus$Filing = {$: 3};
var $author$project$Components$FileNotes$Types$FilingStatus$NotScheduled = {$: 8};
var $author$project$Components$FileNotes$Types$FilingStatus$RenameFailed = {$: 5};
var $author$project$Components$FileNotes$Types$FilingStatus$Renaming = {$: 4};
var $author$project$Components$FileNotes$Types$FilingStatus$SelectionRequired = {$: 6};
var $author$project$Components$FileNotes$Types$FilingStatus$Failed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$FileNotes$Types$FilingStatus$decodeFailReason = A2($elm$json$Json$Decode$field, 'failReason', $elm$json$Json$Decode$string);
var $author$project$Components$FileNotes$Types$FilingStatus$decodeFailed = A2($elm$json$Json$Decode$map, $author$project$Components$FileNotes$Types$FilingStatus$Failed, $author$project$Components$FileNotes$Types$FilingStatus$decodeFailReason);
var $author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus = A2($elm$json$Json$Decode$field, 'fileStatus', $elm$json$Json$Decode$string);
var $author$project$Components$FileNotes$Types$FilingStatus$Filed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$FileNotes$Types$FilingStatus$decodeUpdatedAt = A2($elm$json$Json$Decode$field, 'updatedAt', $elm_community$json_extra$Json$Decode$Extra$datetime);
var $author$project$Components$FileNotes$Types$FilingStatus$decodeFiled = A2($elm$json$Json$Decode$map, $author$project$Components$FileNotes$Types$FilingStatus$Filed, $author$project$Components$FileNotes$Types$FilingStatus$decodeUpdatedAt);
var $author$project$Components$FileNotes$Types$FilingStatus$Scheduled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$FileNotes$Types$FilingStatus$decodeScheduledAt = A2($elm$json$Json$Decode$field, 'scheduledAt', $elm_community$json_extra$Json$Decode$Extra$datetime);
var $author$project$Components$FileNotes$Types$FilingStatus$decodeScheduled = A2($elm$json$Json$Decode$map, $author$project$Components$FileNotes$Types$FilingStatus$Scheduled, $author$project$Components$FileNotes$Types$FilingStatus$decodeScheduledAt);
var $author$project$Components$FileNotes$Types$FilingStatus$is = F2(
	function (expected, val) {
		return _Utils_eq(expected, val);
	});
var $author$project$Components$FileNotes$Types$FilingStatus$decodeFiledStatus = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus,
			$author$project$Components$FileNotes$Types$FilingStatus$is('Scheduled'),
			$author$project$Components$FileNotes$Types$FilingStatus$decodeScheduled),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus,
			$author$project$Components$FileNotes$Types$FilingStatus$is('Filing'),
			$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FilingStatus$Filing)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus,
			$author$project$Components$FileNotes$Types$FilingStatus$is('Renaming'),
			$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FilingStatus$Renaming)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus,
			$author$project$Components$FileNotes$Types$FilingStatus$is('Rename Failed'),
			$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FilingStatus$RenameFailed)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus,
			$author$project$Components$FileNotes$Types$FilingStatus$is('Failed'),
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFailed),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus,
			$author$project$Components$FileNotes$Types$FilingStatus$is('Filed'),
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFiled),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus,
			$author$project$Components$FileNotes$Types$FilingStatus$is('Cancelled'),
			$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FilingStatus$Cancelled)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$author$project$Components$FileNotes$Types$FilingStatus$decodeFileStatus,
			$author$project$Components$FileNotes$Types$FilingStatus$is('Selection Required'),
			$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FilingStatus$SelectionRequired)),
			$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FilingStatus$NotScheduled)
		]));
var $author$project$Components$FileNotes$Types$FilingStatus$Email = 0;
var $author$project$Components$FileNotes$Types$FilingStatus$Note = 1;
var $author$project$Components$FileNotes$Types$FilingStatus$decodeFilingType = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (filingType) {
				switch (filingType) {
					case 'email':
						return $elm$json$Json$Decode$succeed(0);
					case 'note':
						return $elm$json$Json$Decode$succeed(1);
					default:
						var somethingElse = filingType;
						return $elm$json$Json$Decode$fail('Filing type ' + (somethingElse + ' not supported.'));
				}
			},
			$elm$json$Json$Decode$string)
		]));
var $author$project$Components$FileNotes$Types$FilingStatus$decodeFilingStatus = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'note',
		$elm$json$Json$Decode$nullable($author$project$Components$FileNotes$Types$FileNote$fileNoteDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'matter',
			$elm$json$Json$Decode$nullable($author$project$MatterTypes$decodeMatter),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'folderName',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'folder',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'library',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'externalId',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'filedStatus',
								$author$project$Components$FileNotes$Types$FilingStatus$decodeFiledStatus,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'filingType',
									$author$project$Components$FileNotes$Types$FilingStatus$decodeFilingType,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FilingStatus$FilingStatus)))))))))));
var $author$project$Components$FileNotes$Types$FilingStatus$decodeFilingStatusValue = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Components$FileNotes$Types$FilingStatus$decodeFilingStatus, value);
};
var $author$project$Ports$Channels$FileNotes$decodeReceivedFileNote = function (payload) {
	var _v0 = $author$project$Components$FileNotes$Types$FilingStatus$decodeFilingStatusValue(payload);
	if (!_v0.$) {
		var filingStatus = _v0.a;
		return A2($author$project$Components$FileNotes$Messages$Open, filingStatus, $author$project$Components$FileNotes$Types$FileNote$ForMatter);
	} else {
		return $author$project$Components$FileNotes$Messages$FileNoteError('Failed to open File Note');
	}
};
var $author$project$Components$FileNotes$Messages$ReceiveContent = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$FileNotes$Types$FileNote$SavedFileNote = function (content) {
	return {go: content};
};
var $author$project$Components$FileNotes$Types$FileNote$decodeSavedFileNote = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'content',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Components$FileNotes$Types$FileNote$SavedFileNote));
var $author$project$Ports$FileNotes$decodeSavedFileNote = function (payload) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Components$FileNotes$Types$FileNote$decodeSavedFileNote, payload);
	if (!_v0.$) {
		var fileNote = _v0.a;
		return $author$project$Components$FileNotes$Messages$ReceiveContent(fileNote);
	} else {
		var err = _v0.a;
		return $author$project$Components$FileNotes$Messages$FileNoteError(
			$elm$json$Json$Decode$errorToString(err));
	}
};
var $author$project$Components$FileNotes$Messages$ReceiveFilingStatus = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ports$Channels$FileNotes$decodeUpdatedFilingStatus = function (payload) {
	var _v0 = $author$project$Components$FileNotes$Types$FilingStatus$decodeFilingStatusValue(payload);
	if (!_v0.$) {
		var filingStatus = _v0.a;
		return $author$project$Components$FileNotes$Messages$ReceiveFilingStatus(filingStatus);
	} else {
		return $author$project$Components$FileNotes$Messages$FileNoteError('Failed to decode Filing Status');
	}
};
var $author$project$Ports$FileNotes$onRichTextContentChange = _Platform_incomingPort('onRichTextContentChange', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$FileNotes$receiveConfirmTitleChanged = _Platform_incomingPort('receiveConfirmTitleChanged', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$FileNotes$receiveFileNote = _Platform_incomingPort('receiveFileNote', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$FileNotes$receiveFileStatusUpdate = _Platform_incomingPort('receiveFileStatusUpdate', $elm$json$Json$Decode$value);
var $author$project$Components$FileNotes$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Ports$Channels$FileNotes$receiveFileNote($author$project$Ports$Channels$FileNotes$decodeReceivedFileNote),
			$author$project$Ports$Channels$FileNotes$receiveFileStatusUpdate($author$project$Ports$Channels$FileNotes$decodeUpdatedFilingStatus),
			$author$project$Ports$Channels$FileNotes$receiveConfirmTitleChanged($author$project$Ports$Channels$FileNotes$decodeConfirmTitleChanged),
			$author$project$Ports$FileNotes$onRichTextContentChange($author$project$Ports$FileNotes$decodeSavedFileNote)
		]));
var $author$project$Components$Notifications$Messages$Error = {$: 5};
var $author$project$Components$Notifications$Messages$ReceiveNotification = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Notifications$Data$ReceivedNotification = F2(
	function (notification, action) {
		return {fC: action, il: notification};
	});
var $author$project$Components$Notifications$Data$Create = 0;
var $author$project$Components$Notifications$Data$Delete = 2;
var $author$project$Components$Notifications$Data$NoOp = 3;
var $author$project$Components$Notifications$Data$Update = 1;
var $author$project$Components$Notifications$Data$decodeAction = A2(
	$elm$json$Json$Decode$andThen,
	function (action) {
		return $elm$json$Json$Decode$succeed(
			function () {
				switch (action) {
					case 'create':
						return 0;
					case 'update':
						return 1;
					case 'delete':
						return 2;
					default:
						return 3;
				}
			}());
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$Notifications$Data$Notification = function (id) {
	return function (title) {
		return function (type_) {
			return function (backgroundColor) {
				return function (textColor) {
					return function (content) {
						return function (closeable) {
							return function (linkText) {
								return function (link) {
									return function (imageLink) {
										return function (slides) {
											return function (currentSlideIdx) {
												return {fP: backgroundColor, gf: closeable, go: content, gv: currentSlideIdx, aC: id, d_: imageLink, hW: link, hX: linkText, ja: slides, jv: textColor, jB: title, jN: type_};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Notifications$Data$Banner = 0;
var $author$project$Components$Notifications$Data$Modal = 1;
var $author$project$Components$Notifications$Data$Slider = 2;
var $author$project$Components$Notifications$Data$decodeNotificationType = function (type_) {
	return $elm$json$Json$Decode$succeed(
		function () {
			switch (type_) {
				case 'banner':
					return 0;
				case 'modal':
					return 1;
				case 'slider':
					return 2;
				default:
					return 0;
			}
		}());
};
var $author$project$Components$Notifications$Data$Slide = F3(
	function (imageLink, title, content) {
		return {go: content, d_: imageLink, jB: title};
	});
var $author$project$Components$Notifications$Data$decodeSlide = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'content',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'imageLink',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$Notifications$Data$Slide))));
var $author$project$Components$Notifications$Data$decodeNotification = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'slides',
		$elm$json$Json$Decode$list($author$project$Components$Notifications$Data$decodeSlide),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'imageLink',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'link',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'linkText',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'closeable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'content',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'textColor',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'backgroundColor',
									$elm$json$Json$Decode$string,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A2(
											$elm$json$Json$Decode$andThen,
											$author$project$Components$Notifications$Data$decodeNotificationType,
											A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string)),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$succeed($author$project$Components$Notifications$Data$Notification)))))))))))));
var $author$project$Components$Notifications$Data$decodeReceivedNotification = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'action',
	$author$project$Components$Notifications$Data$decodeAction,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'notification',
		$author$project$Components$Notifications$Data$decodeNotification,
		$elm$json$Json$Decode$succeed($author$project$Components$Notifications$Data$ReceivedNotification)));
var $author$project$Components$Notifications$Data$notificationReceivedDecodeJson = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Components$Notifications$Data$decodeReceivedNotification, value);
};
var $author$project$Ports$Channels$Notifications$decodeReceivedNotification = function (payload) {
	var _v0 = $author$project$Components$Notifications$Data$notificationReceivedDecodeJson(payload);
	if (!_v0.$) {
		var receivedNotification = _v0.a;
		return $author$project$Components$Notifications$Messages$ReceiveNotification(receivedNotification);
	} else {
		return $author$project$Components$Notifications$Messages$Error;
	}
};
var $author$project$Ports$Channels$Notifications$receiveNotification = _Platform_incomingPort('receiveNotification', $elm$json$Json$Decode$value);
var $author$project$Components$Notifications$Subscriptions$subscriptions = $author$project$Ports$Channels$Notifications$receiveNotification($author$project$Ports$Channels$Notifications$decodeReceivedNotification);
var $author$project$TimesheetPage$Messages$CheckAnnouncementInterruption = function (a) {
	return {$: 101, a: a};
};
var $author$project$TimesheetPage$Messages$CompleteTour = function (a) {
	return {$: 104, a: a};
};
var $author$project$TimesheetPage$Messages$FileNote = function (a) {
	return {$: 21, a: a};
};
var $author$project$TimesheetPage$Messages$ReceiveCurrentRataDie = function (a) {
	return {$: 86, a: a};
};
var $author$project$TimesheetPage$Messages$ReceiveTime = function (a) {
	return {$: 85, a: a};
};
var $author$project$TimesheetPage$Messages$UpdateFutureDatedFees = function (a) {
	return {$: 50, a: a};
};
var $Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent = F7(
	function (altKey, ctrlKey, key, keyCode, metaKey, repeat, shiftKey) {
		return {fL: altKey, gs: ctrlKey, d9: key, hP: keyCode, h2: metaKey, iT: repeat, i4: shiftKey};
	});
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKey = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return $elm$core$String$isEmpty(key) ? $elm$json$Json$Decode$fail('empty key') : $elm$json$Json$Decode$succeed(key);
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		return (!code) ? $elm$json$Json$Decode$fail('code was zero') : $elm$json$Json$Decode$succeed(code);
	},
	$elm$json$Json$Decode$int);
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'keyCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'which', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'charCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			$elm$json$Json$Decode$succeed(0)
		]));
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$A = {$: 0};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add = {$: 85};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt = {$: 32};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous = function (a) {
	return {$: 89, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$B = {$: 1};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace = {$: 38};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$C = {$: 2};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock = {$: 34};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch = {$: 59};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command = {$: 58};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl = function (a) {
	return {$: 31, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$D = {$: 3};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal = {$: 87};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete = {$: 39};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide = {$: 88};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down = {$: 29};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$E = {$: 4};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight = {$: 52};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$End = {$: 42};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter = {$: 37};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape = {$: 36};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F = {$: 5};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1 = {$: 62};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10 = {$: 71};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11 = {$: 72};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12 = {$: 73};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2 = {$: 63};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3 = {$: 64};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4 = {$: 65};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5 = {$: 66};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6 = {$: 67};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7 = {$: 68};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8 = {$: 69};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9 = {$: 70};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five = {$: 49};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four = {$: 48};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$G = {$: 6};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$H = {$: 7};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home = {$: 43};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$I = {$: 8};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert = {$: 54};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$J = {$: 9};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$K = {$: 10};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$L = {$: 11};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left = {$: 26};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$M = {$: 12};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply = {$: 84};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$N = {$: 13};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine = {$: 53};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock = {$: 60};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight = {$: 82};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive = {$: 79};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour = {$: 78};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine = {$: 83};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne = {$: 75};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven = {$: 81};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix = {$: 80};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree = {$: 77};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo = {$: 76};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero = {$: 74};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$O = {$: 14};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$One = {$: 45};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$P = {$: 15};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown = {$: 41};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp = {$: 40};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak = {$: 56};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen = {$: 55};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q = {$: 16};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$R = {$: 17};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right = {$: 27};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$S = {$: 18};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock = {$: 61};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven = {$: 51};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift = function (a) {
	return {$: 30, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six = {$: 50};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar = {$: 35};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract = {$: 86};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$T = {$: 19};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab = {$: 33};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three = {$: 47};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two = {$: 46};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$U = {$: 20};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown = function (a) {
	return {$: 90, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up = {$: 28};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$V = {$: 21};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$W = {$: 22};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows = {$: 57};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$X = {$: 23};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y = {$: 24};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z = {$: 25};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero = {$: 44};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode = function (keyCode) {
	switch (keyCode) {
		case 8:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace;
		case 9:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab;
		case 13:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter;
		case 16:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift($elm$core$Maybe$Nothing);
		case 17:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl($elm$core$Maybe$Nothing);
		case 18:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt;
		case 19:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak;
		case 20:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock;
		case 27:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape;
		case 32:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar;
		case 33:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp;
		case 34:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown;
		case 35:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$End;
		case 36:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home;
		case 37:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left;
		case 38:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up;
		case 39:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right;
		case 40:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down;
		case 44:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen;
		case 45:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert;
		case 46:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete;
		case 48:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero;
		case 49:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$One;
		case 50:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two;
		case 51:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three;
		case 52:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four;
		case 53:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five;
		case 54:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six;
		case 55:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven;
		case 56:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight;
		case 57:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine;
		case 65:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$A;
		case 66:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$B;
		case 67:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$C;
		case 68:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$D;
		case 69:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$E;
		case 70:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F;
		case 71:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$G;
		case 72:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$H;
		case 73:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$I;
		case 74:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$J;
		case 75:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$K;
		case 76:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$L;
		case 77:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$M;
		case 78:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$N;
		case 79:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$O;
		case 80:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$P;
		case 81:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q;
		case 82:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$R;
		case 83:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$S;
		case 84:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$T;
		case 85:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$U;
		case 86:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$V;
		case 87:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$W;
		case 88:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$X;
		case 89:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y;
		case 90:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z;
		case 91:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous(
				_List_fromArray(
					[$SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows, $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command, $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch]));
		case 96:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero;
		case 97:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne;
		case 98:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo;
		case 99:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree;
		case 100:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour;
		case 101:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive;
		case 102:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix;
		case 103:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven;
		case 104:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight;
		case 105:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine;
		case 106:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply;
		case 107:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add;
		case 109:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract;
		case 110:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal;
		case 111:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide;
		case 112:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1;
		case 113:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2;
		case 114:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3;
		case 115:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4;
		case 116:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5;
		case 117:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6;
		case 118:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7;
		case 119:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8;
		case 120:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9;
		case 121:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10;
		case 122:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11;
		case 123:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12;
		case 144:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock;
		case 145:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock;
		default:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown(keyCode);
	}
};
var $elm$json$Json$Decode$map7 = _Json_map7;
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent = A8(
	$elm$json$Json$Decode$map7,
	$Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	$Gizra$elm_keyboard_event$Keyboard$Event$decodeKey,
	A2($elm$json$Json$Decode$map, $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode, $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode),
	A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $Gizra$elm_keyboard_event$Keyboard$Event$considerKeyboardEvent = function (func) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (event) {
			var _v0 = func(event);
			if (!_v0.$) {
				var msg = _v0.a;
				return $elm$json$Json$Decode$succeed(msg);
			} else {
				return $elm$json$Json$Decode$fail('Ignoring keyboard event');
			}
		},
		$Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent);
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {eG: processes, fh: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.eG;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.fh);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Tours$ActivityReviewTour = 1;
var $author$project$Tours$ManualFeeTour = 0;
var $author$project$Tours$freshDeskEventTourName = function (str) {
	switch (str) {
		case 'hasCompletedManualFeeTour':
			return $elm$core$Maybe$Just(0);
		case 'hasCompletedActivityReviewTour':
			return $elm$core$Maybe$Just(1);
		case 'hasAcknowledgedFeeGrouping':
			return $elm$core$Maybe$Just(1);
		case 'hasAcknowledgedMerging':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$TimesheetPage$Subscriptions$fromSeconds = function (seconds) {
	return seconds * 1000;
};
var $author$project$TimesheetPage$Messages$EscapePressed = {$: 106};
var $author$project$TimesheetPage$Messages$NewEntry = {$: 51};
var $author$project$Components$FileNotes$Types$FileNote$newFileNote = function (feeId) {
	return {go: '', g_: feeId, aC: $elm$core$Maybe$Nothing, ef: $elm$core$Maybe$Nothing, jB: ''};
};
var $author$project$Components$FileNotes$Types$FilingStatus$newFileNote = function (feeId) {
	return {
		gR: $elm$core$Maybe$Nothing,
		dG: $author$project$Components$FileNotes$Types$FilingStatus$NotScheduled,
		g7: 1,
		hb: $elm$core$Maybe$Nothing,
		dL: $elm$core$Maybe$Nothing,
		dU: false,
		aC: $elm$core$Maybe$Nothing,
		hV: $elm$core$Maybe$Nothing,
		hY: $elm$core$Maybe$Nothing,
		ij: $elm$core$Maybe$Just(
			$author$project$Components$FileNotes$Types$FileNote$newFileNote(feeId))
	};
};
var $author$project$HotKeys$msgForKeyboardEvent = function (keyboardEvent) {
	var _v0 = _Utils_Tuple2(keyboardEvent.fL, keyboardEvent.hP);
	_v0$3:
	while (true) {
		switch (_v0.b.$) {
			case 13:
				if (_v0.a) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just($author$project$TimesheetPage$Messages$NewEntry);
				} else {
					break _v0$3;
				}
			case 5:
				if (_v0.a) {
					var _v2 = _v0.b;
					return $elm$core$Maybe$Just(
						$author$project$TimesheetPage$Messages$FileNote(
							A2(
								$author$project$Components$FileNotes$Messages$Open,
								$author$project$Components$FileNotes$Types$FilingStatus$newFileNote($elm$core$Maybe$Nothing),
								$author$project$Components$FileNotes$Types$FileNote$ForMatter)));
				} else {
					break _v0$3;
				}
			case 36:
				var _v3 = _v0.b;
				return $elm$core$Maybe$Just($author$project$TimesheetPage$Messages$EscapePressed);
			default:
				break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Ports$OnCompleteTour$onCompleteTour = _Platform_incomingPort('onCompleteTour', $elm$json$Json$Decode$string);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {eB: pids, fd: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {i: event, d9: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.eB,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.d9;
		var event = _v0.i;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.fd);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Ports$Channels$Timesheet$activitiesDeletedToast = _Platform_incomingPort('activitiesDeletedToast', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$activity = _Platform_incomingPort('activity', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$activityRefresh = _Platform_incomingPort('activityRefresh', $elm$json$Json$Decode$value);
var $author$project$TimesheetPage$Messages$ActivityFeedComponent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Activities$Messages$ReceiveActivity = function (a) {
	return {$: 3, a: a};
};
var $author$project$TimesheetPage$Messages$SocketDecodeError = function (a) {
	return {$: 100, a: a};
};
var $author$project$Activities$Data$decodeActivity = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Activities$Data$activityDecoder, value);
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedActivity = function (payload) {
	var _v0 = $author$project$Activities$Data$decodeActivity(payload);
	if (!_v0.$) {
		var activity_ = _v0.a;
		return $author$project$TimesheetPage$Messages$ActivityFeedComponent(
			$author$project$Activities$Messages$ReceiveActivity(activity_));
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveAiError = function (a) {
	return {$: 87, a: a};
};
var $author$project$Model$Fee$AiError = F2(
	function (feeId, message) {
		return {g_: feeId, eh: message};
	});
var $author$project$Model$Fee$decodeAiError = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'feeId',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$Fee$AiError)));
var $author$project$Model$Fee$feeAiErrorDecoder = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Model$Fee$decodeAiError, value);
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedAiError = function (payload) {
	var _v0 = $author$project$Model$Fee$feeAiErrorDecoder(payload);
	if (!_v0.$) {
		var msg = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveAiError(msg);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Ports$Channels$Announcement$decodeReceivedAnnouncement = function (_v0) {
	var time = $elm$time$Time$millisToPosix(0);
	return $author$project$TimesheetPage$Messages$CheckAnnouncementInterruption(time);
};
var $author$project$Model$IntegrationStatuses$BrowserExtension = 3;
var $author$project$TimesheetPage$Messages$ReceiveIntegrationStatus = F2(
	function (a, b) {
		return {$: 90, a: a, b: b};
	});
var $author$project$Model$IntegrationStatuses$decodeIncomingIntegrationStatus = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Model$IntegrationStatuses$decodeIntegrationStatus, value);
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedBrowserExtensionIntegrationStatus = function (payload) {
	var _v0 = $author$project$Model$IntegrationStatuses$decodeIncomingIntegrationStatus(payload);
	if (!_v0.$) {
		var status = _v0.a;
		return A2($author$project$TimesheetPage$Messages$ReceiveIntegrationStatus, 3, status);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveDeletedFeeIds = function (a) {
	return {$: 80, a: a};
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedDeletedFees = function (payload) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2(
			$elm$json$Json$Decode$field,
			'fee_ids',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		payload);
	if (!_v0.$) {
		var feeIds = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveDeletedFeeIds(feeIds);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Model$FlashMessage$Fee = 1;
var $author$project$TimesheetPage$Messages$SetFlashMessage = F4(
	function (a, b, c, d) {
		return {$: 97, a: a, b: b, c: c, d: d};
	});
var $author$project$Model$FlashMessage$Undo = 0;
var $author$project$Ports$Channels$Timesheet$decodeReceivedDeletedFeesFlashMessage = function (payload) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2(
			$elm$json$Json$Decode$field,
			'fee_ids',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		payload);
	if (!_v0.$) {
		var feeIds = _v0.a;
		return A4($author$project$TimesheetPage$Messages$SetFlashMessage, 'Fee removed', 0, 1, feeIds);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Model$IntegrationStatuses$Exchange = 1;
var $author$project$Ports$Channels$Timesheet$decodeReceivedExchangeIntegrationStatus = function (payload) {
	var _v0 = $author$project$Model$IntegrationStatuses$decodeIncomingIntegrationStatus(payload);
	if (!_v0.$) {
		var status = _v0.a;
		return A2($author$project$TimesheetPage$Messages$ReceiveIntegrationStatus, 1, status);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFee = function (a) {
	return {$: 76, a: a};
};
var $author$project$Model$Fee$feeDecodeJson = function (value) {
	return A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'fee', $author$project$Model$Fee$decodeFee),
		value);
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedFee = function (payload) {
	var _v0 = $author$project$Model$Fee$feeDecodeJson(payload);
	if (!_v0.$) {
		var fee_ = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFee(fee_);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFeeCreatedAndSelect = function (a) {
	return {$: 78, a: a};
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedFeeCreatedAndSelect = function (payload) {
	var _v0 = $author$project$Model$Fee$feeDecodeJson(payload);
	if (!_v0.$) {
		var fee_ = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFeeCreatedAndSelect(fee_);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFeeAiCompleted = function (a) {
	return {$: 84, a: a};
};
var $author$project$Model$Fee$FeeId = F2(
	function (feeId, occurredAt) {
		return {g_: feeId, b7: occurredAt};
	});
var $author$project$Model$Fee$decodeFeeId = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'occurredAt',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'feeId',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$Fee$FeeId)));
var $author$project$Model$Fee$feeIdDecoder = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Model$Fee$decodeFeeId, value);
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedFeeId = function (payload) {
	var _v0 = $author$project$Model$Fee$feeIdDecoder(payload);
	if (!_v0.$) {
		var feeId = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFeeAiCompleted(feeId);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFeesCreated = function (a) {
	return {$: 77, a: a};
};
var $author$project$Model$Fee$decodeFeeList = A2(
	$elm$json$Json$Decode$field,
	'fees',
	$elm$json$Json$Decode$list($author$project$Model$Fee$decodeFee));
var $author$project$Ports$Channels$Timesheet$decodeReceivedFeeList = function (payload) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Model$Fee$decodeFeeList, payload);
	if (!_v0.$) {
		var fees_ = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFeesCreated(fees_);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFeeStatusUpdate = function (a) {
	return {$: 81, a: a};
};
var $author$project$Model$Fee$FeeStatus = F6(
	function (feeId, occurredAt, postStatus, failureReason, failedAt, unpostableReasons) {
		return {dy: failedAt, dz: failureReason, g_: feeId, b7: occurredAt, eD: postStatus, cK: unpostableReasons};
	});
var $author$project$Model$Fee$decodeFeeStatus = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unpostableReasons',
	$elm$json$Json$Decode$list($author$project$Model$Fee$decodeUnpostableReason),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'failedAt',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'failureReason',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'postStatus',
				$author$project$Model$Fee$PostStatus$decodePostStatus,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'occurredAt',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'feeId',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Model$Fee$FeeStatus)))))));
var $author$project$Model$Fee$feeStatusDecoder = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Model$Fee$decodeFeeStatus, value);
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedFeeStatus = function (payload) {
	var _v0 = $author$project$Model$Fee$feeStatusDecoder(payload);
	if (!_v0.$) {
		var feeStatus = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFeeStatusUpdate(feeStatus);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFeeSummaryUpdate = function (a) {
	return {$: 83, a: a};
};
var $author$project$Model$Fee$FeeDescription = F3(
	function (feeId, occurredAt, description) {
		return {dd: description, g_: feeId, b7: occurredAt};
	});
var $author$project$Model$Fee$decodeFeeDescription = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'occurredAt',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'feeId',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Model$Fee$FeeDescription))));
var $author$project$Model$Fee$feeDescriptionDecoder = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Model$Fee$decodeFeeDescription, value);
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedFeeSummary = function (payload) {
	var _v0 = $author$project$Model$Fee$feeDescriptionDecoder(payload);
	if (!_v0.$) {
		var feeDesc = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFeeSummaryUpdate(feeDesc);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFeeWithTimerUpdate = function (a) {
	return {$: 79, a: a};
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedFeeWithTimer = function (payload) {
	var _v0 = $author$project$Model$Fee$feeDecodeJson(payload);
	if (!_v0.$) {
		var fee_ = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFeeWithTimerUpdate(fee_);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFilingStatusUpdate = function (a) {
	return {$: 82, a: a};
};
var $author$project$Model$Fee$FilingStatusUpdate = F4(
	function (feeId, occurredAt, consolidatedFeeId, filingStatus) {
		return {gl: consolidatedFeeId, g_: feeId, dH: filingStatus, b7: occurredAt};
	});
var $author$project$Model$Fee$decodeFilingStatusUpdate = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'filingStatus',
	$author$project$Activities$Model$FilingStatus$decodeFilingStatus,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'consolidatedFeeId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'occurredAt',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'feeId',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Model$Fee$FilingStatusUpdate)))));
var $author$project$Model$Fee$feeFilingStatusDecoder = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Model$Fee$decodeFilingStatusUpdate, value);
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedFilingStatus = function (payload) {
	var _v0 = $author$project$Model$Fee$feeFilingStatusDecoder(payload);
	if (!_v0.$) {
		var filingStatus = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFilingStatusUpdate(filingStatus);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$ReceiveFlashMessage = function (a) {
	return {$: 88, a: a};
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedFlashMessage = function (payload) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
		payload);
	if (!_v0.$) {
		var message = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFlashMessage(message);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$TimesheetPage$Messages$FrontendVersion = function (a) {
	return {$: 102, a: a};
};
var $author$project$Ports$Channels$Announcement$decodeReceivedFrontendVersion = function (payload) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$string),
		payload);
	if (!_v0.$) {
		var version = _v0.a;
		return $author$project$TimesheetPage$Messages$FrontendVersion(version);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Model$FlashMessage$Activity = 0;
var $author$project$Model$FlashMessage$FlashMessage = F5(
	function (message, id, actionType, entityType, entityIds) {
		return {bo: actionType, bA: entityIds, bB: entityType, aC: id, eh: message};
	});
var $author$project$Model$FlashMessage$Matter = 2;
var $author$project$Model$FlashMessage$NoType = 3;
var $author$project$Model$FlashMessage$None = 2;
var $author$project$Model$FlashMessage$Redo = 1;
var $author$project$Model$FlashMessage$decodeMatterPostedFlashMessage = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'entityIds',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'entityType',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$succeed(2),
					$elm$json$Json$Decode$succeed(0),
					$elm$json$Json$Decode$succeed(1),
					$elm$json$Json$Decode$succeed(3)
				])),
		3,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'actionType',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$succeed(0),
						$elm$json$Json$Decode$succeed(1),
						$elm$json$Json$Decode$succeed(2)
					])),
			2,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'message',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$FlashMessage$FlashMessage))))));
var $author$project$Model$FlashMessage$matterPostedFlashMessageDecodeJson = function (value) {
	return A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'flashMessage', $author$project$Model$FlashMessage$decodeMatterPostedFlashMessage),
		value);
};
var $author$project$Ports$Channels$Organisation$decodeReceivedMatterPostedFlashMessage = function (payload) {
	var _v0 = $author$project$Model$FlashMessage$matterPostedFlashMessageDecodeJson(payload);
	if (!_v0.$) {
		var flashMessage = _v0.a;
		return $author$project$TimesheetPage$Messages$ReceiveFlashMessage(flashMessage.eh);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Model$IntegrationStatuses$PMS = 0;
var $author$project$Ports$Channels$Timesheet$decodeReceivedPMSIntegrationStatus = function (payload) {
	var _v0 = $author$project$Model$IntegrationStatuses$decodeIncomingIntegrationStatus(payload);
	if (!_v0.$) {
		var status = _v0.a;
		return A2($author$project$TimesheetPage$Messages$ReceiveIntegrationStatus, 0, status);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Model$IntegrationStatuses$Phone = 2;
var $author$project$Ports$Channels$Timesheet$decodeReceivedPhoneIntegrationStatus = function (payload) {
	var _v0 = $author$project$Model$IntegrationStatuses$decodeIncomingIntegrationStatus(payload);
	if (!_v0.$) {
		var status = _v0.a;
		return A2($author$project$TimesheetPage$Messages$ReceiveIntegrationStatus, 2, status);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedRemoveActivitiesFlashMessage = function (payload) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2(
			$elm$json$Json$Decode$field,
			'activity_ids',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		payload);
	if (!_v0.$) {
		var activityIds = _v0.a;
		return A4($author$project$TimesheetPage$Messages$SetFlashMessage, 'Activity removed', 0, 0, activityIds);
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Activities$Messages$ReceiveRemovedActivityIds = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ports$Channels$Timesheet$decodeReceivedRemovedActivityIds = function (payload) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2(
			$elm$json$Json$Decode$field,
			'activity_ids',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		payload);
	if (!_v0.$) {
		var activityIds = _v0.a;
		return $author$project$TimesheetPage$Messages$ActivityFeedComponent(
			$author$project$Activities$Messages$ReceiveRemovedActivityIds(activityIds));
	} else {
		var e = _v0.a;
		return $author$project$TimesheetPage$Messages$SocketDecodeError(e);
	}
};
var $author$project$Ports$Channels$Timesheet$deletedFees = _Platform_incomingPort('deletedFees', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$fee = _Platform_incomingPort('fee', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$feeAiCompleted = _Platform_incomingPort('feeAiCompleted', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$feeCreatedAndSelect = _Platform_incomingPort('feeCreatedAndSelect', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$feeFileStatusUpdate = _Platform_incomingPort('feeFileStatusUpdate', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$feeStatusUpdate = _Platform_incomingPort('feeStatusUpdate', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$feeSummaryUpdate = _Platform_incomingPort('feeSummaryUpdate', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$feeWithRunningTimer = _Platform_incomingPort('feeWithRunningTimer', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$fees = _Platform_incomingPort('fees', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$feesDeletedToast = _Platform_incomingPort('feesDeletedToast', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Announcement$frontendVersion = _Platform_incomingPort('frontendVersion', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Organisation$matterPosted = _Platform_incomingPort('matterPosted', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$receiveAiErrorMessage = _Platform_incomingPort('receiveAiErrorMessage', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Announcement$receiveAnnouncement = _Platform_incomingPort('receiveAnnouncement', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$receiveFlashMessage = _Platform_incomingPort('receiveFlashMessage', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$removeActivities = _Platform_incomingPort('removeActivities', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$updateBrowserExtensionIntegrationStatus = _Platform_incomingPort('updateBrowserExtensionIntegrationStatus', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$updateExchangeIntegrationStatus = _Platform_incomingPort('updateExchangeIntegrationStatus', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$updatePMSIntegrationStatus = _Platform_incomingPort('updatePMSIntegrationStatus', $elm$json$Json$Decode$value);
var $author$project$Ports$Channels$Timesheet$updatePhoneIntegrationStatus = _Platform_incomingPort('updatePhoneIntegrationStatus', $elm$json$Json$Decode$value);
var $author$project$Sockets$subscriptions = _List_fromArray(
	[
		$author$project$Ports$Channels$Timesheet$activitiesDeletedToast($author$project$Ports$Channels$Timesheet$decodeReceivedRemoveActivitiesFlashMessage),
		$author$project$Ports$Channels$Timesheet$feesDeletedToast($author$project$Ports$Channels$Timesheet$decodeReceivedDeletedFeesFlashMessage),
		$author$project$Ports$Channels$Announcement$frontendVersion($author$project$Ports$Channels$Announcement$decodeReceivedFrontendVersion),
		$author$project$Ports$Channels$Announcement$receiveAnnouncement($author$project$Ports$Channels$Announcement$decodeReceivedAnnouncement),
		$author$project$Ports$Channels$Timesheet$receiveAiErrorMessage($author$project$Ports$Channels$Timesheet$decodeReceivedAiError),
		$author$project$Ports$Channels$Timesheet$receiveFlashMessage($author$project$Ports$Channels$Timesheet$decodeReceivedFlashMessage),
		$author$project$Ports$Channels$Organisation$matterPosted($author$project$Ports$Channels$Organisation$decodeReceivedMatterPostedFlashMessage),
		$author$project$Ports$Channels$Timesheet$feeStatusUpdate($author$project$Ports$Channels$Timesheet$decodeReceivedFeeStatus),
		$author$project$Ports$Channels$Timesheet$feeSummaryUpdate($author$project$Ports$Channels$Timesheet$decodeReceivedFeeSummary),
		$author$project$Ports$Channels$Timesheet$feeAiCompleted($author$project$Ports$Channels$Timesheet$decodeReceivedFeeId),
		$author$project$Ports$Channels$Timesheet$fee($author$project$Ports$Channels$Timesheet$decodeReceivedFee),
		$author$project$Ports$Channels$Timesheet$fees($author$project$Ports$Channels$Timesheet$decodeReceivedFeeList),
		$author$project$Ports$Channels$Timesheet$feeCreatedAndSelect($author$project$Ports$Channels$Timesheet$decodeReceivedFeeCreatedAndSelect),
		$author$project$Ports$Channels$Timesheet$feeWithRunningTimer($author$project$Ports$Channels$Timesheet$decodeReceivedFeeWithTimer),
		$author$project$Ports$Channels$Timesheet$feeFileStatusUpdate($author$project$Ports$Channels$Timesheet$decodeReceivedFilingStatus),
		$author$project$Ports$Channels$Timesheet$deletedFees($author$project$Ports$Channels$Timesheet$decodeReceivedDeletedFees),
		$author$project$Ports$Channels$Timesheet$activity($author$project$Ports$Channels$Timesheet$decodeReceivedActivity),
		$author$project$Ports$Channels$Timesheet$activityRefresh($author$project$Ports$Channels$Timesheet$decodeReceivedActivity),
		$author$project$Ports$Channels$Timesheet$removeActivities($author$project$Ports$Channels$Timesheet$decodeReceivedRemovedActivityIds),
		$author$project$Ports$Channels$Timesheet$updateExchangeIntegrationStatus($author$project$Ports$Channels$Timesheet$decodeReceivedExchangeIntegrationStatus),
		$author$project$Ports$Channels$Timesheet$updatePMSIntegrationStatus($author$project$Ports$Channels$Timesheet$decodeReceivedPMSIntegrationStatus),
		$author$project$Ports$Channels$Timesheet$updatePhoneIntegrationStatus($author$project$Ports$Channels$Timesheet$decodeReceivedPhoneIntegrationStatus),
		$author$project$Ports$Channels$Timesheet$updateBrowserExtensionIntegrationStatus($author$project$Ports$Channels$Timesheet$decodeReceivedBrowserExtensionIntegrationStatus)
	]);
var $author$project$TimesheetPage$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(
	_Utils_ap(
		_List_fromArray(
			[
				A2(
				$elm$time$Time$every,
				$author$project$TimesheetPage$Subscriptions$fromSeconds(1),
				$author$project$TimesheetPage$Messages$ReceiveTime),
				A2(
				$elm$time$Time$every,
				$author$project$TimesheetPage$Subscriptions$fromSeconds(60),
				$author$project$TimesheetPage$Messages$UpdateFutureDatedFees),
				A2(
				$elm$time$Time$every,
				$author$project$TimesheetPage$Subscriptions$fromSeconds(300),
				$author$project$TimesheetPage$Messages$ReceiveCurrentRataDie),
				A2(
				$elm$time$Time$every,
				$author$project$TimesheetPage$Subscriptions$fromSeconds(20),
				$author$project$TimesheetPage$Messages$CheckAnnouncementInterruption),
				$elm$browser$Browser$Events$onKeyDown(
				$Gizra$elm_keyboard_event$Keyboard$Event$considerKeyboardEvent($author$project$HotKeys$msgForKeyboardEvent)),
				$author$project$Ports$OnCompleteTour$onCompleteTour(
				A2($elm$core$Basics$composeL, $author$project$TimesheetPage$Messages$CompleteTour, $author$project$Tours$freshDeskEventTourName)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$TimesheetPage$Messages$FileNote,
				$author$project$Ports$FileNotes$onRichTextContentChange($author$project$Ports$FileNotes$decodeSavedFileNote)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$TimesheetPage$Messages$FileNote,
				$author$project$Ports$Channels$FileNotes$receiveFileStatusUpdate($author$project$Ports$Channels$FileNotes$decodeUpdatedFilingStatus)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$TimesheetPage$Messages$FileNote,
				$author$project$Ports$Channels$FileNotes$receiveConfirmTitleChanged($author$project$Ports$Channels$FileNotes$decodeConfirmTitleChanged))
			]),
		$author$project$Sockets$subscriptions));
var $author$project$Main$subscriptions = function (model) {
	var _v0 = model.iC;
	switch (_v0.$) {
		case 0:
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Sub$map, $author$project$Messages$NotificationMsg, $author$project$Components$Notifications$Subscriptions$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Messages$PageMsg, $author$project$TimesheetPage$Subscriptions$subscriptions)
					]));
		case 1:
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Sub$map, $author$project$Messages$NotificationMsg, $author$project$Components$Notifications$Subscriptions$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Messages$FileNoteMsg, $author$project$Components$FileNotes$Subscriptions$subscriptions)
					]));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Messages$Close = 0;
var $author$project$Components$Modal$Model$FileNotesModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Messages$HeaderMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Messages$HelpResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Messages$LoadPage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$LogOut = function (a) {
	return {$: 3, a: a};
};
var $author$project$Messages$ModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Messages$NewsResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Modal$Model$NotificationsModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Messages$RecentMattersFetched = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$SessionError = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Timesheet = function (a) {
	return {$: 0, a: a};
};
var $author$project$Update$applyPage = F2(
	function (page, model) {
		return _Utils_update(
			model,
			{iC: page});
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $Fresheyeball$elm_return$Return$command = F2(
	function (cmd, _v0) {
		var model = _v0.a;
		var cmd_ = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Update$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time * 1000));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.e9));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Components$MatterInput$Requests$fetchRecentMatters = function (toMsg) {
	return $elm$http$Http$get(
		{
			z: A2(
				$elm$http$Http$expectJson,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
				$author$project$MatterTypes$decodeMatters),
			jR: A2(
				$author$project$Requests$toUrl,
				'/api/matters/suggested',
				_List_fromArray(
					[
						A2(
						$author$project$Requests$Param,
						'mode',
						$elm$core$Maybe$Just(
							$author$project$EditMode$toString(0)))
					]))
		});
};
var $author$project$ErrorLogic$MultipleMessages = function (a) {
	return {$: 1, a: a};
};
var $author$project$ErrorLogic$SingleMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$ErrorLogic$errorDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$ErrorLogic$SingleMessage,
			A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$ErrorLogic$SingleMessage,
			A2(
				$elm$json$Json$Decode$field,
				'error',
				A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$ErrorLogic$SingleMessage,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$ErrorLogic$MultipleMessages,
			A2(
				$elm$json$Json$Decode$field,
				'errors',
				A2(
					$elm$json$Json$Decode$field,
					'details',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))
		]));
var $author$project$ErrorLogic$errorMessages = A2(
	$elm$json$Json$Decode$map,
	function (err) {
		if (!err.$) {
			var msg = err.a;
			return msg;
		} else {
			var msgs = err.a;
			return A2($elm$core$String$join, ',', msgs);
		}
	},
	$author$project$ErrorLogic$errorDecoder);
var $author$project$ErrorLogic$decodeErrorBody = function (s) {
	var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$ErrorLogic$errorMessages, s);
	if (!_v0.$) {
		var msg = _v0.a;
		return msg;
	} else {
		return s;
	}
};
var $author$project$ErrorLogic$getMessage = function (error) {
	switch (error.$) {
		case 0:
			var string = error.a;
			return 'Looks like ' + (string + ' cannot be found.');
		case 1:
			return 'Looks like the server timed out, please try again soon.';
		case 2:
			return 'Problem with request due to Network connection.';
		case 3:
			var metadata = error.a;
			var body = error.b;
			var errorText = $author$project$ErrorLogic$decodeErrorBody(body);
			return 'That didn\'t work: ' + (errorText + (' (' + ($elm$core$String$fromInt(metadata.e9) + ')')));
		default:
			var metadata = error.a;
			var body = error.b;
			var string = error.c;
			return 'We\'re sorry but the data sent was bad: ' + string;
	}
};
var $o_train$elm_search_input$Select$setSelected = F2(
	function (item, model) {
		return _Utils_update(
			model,
			{
				e0: $elm$core$Maybe$Just(item)
			});
	});
var $o_train$elm_search_input$Select$addSelectedItem = $o_train$elm_search_input$Select$setSelected;
var $author$project$Components$SelectInput$Folders$toItem = function (lib) {
	return {aC: lib.aC, aa: lib, hK: true, ec: lib.b2};
};
var $author$project$Components$SelectInput$Folders$addDefault = F2(
	function (preferredLib, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (s) {
					return A2($o_train$elm_search_input$Select$addSelectedItem, s, model);
				},
				A2($elm$core$Maybe$map, $author$project$Components$SelectInput$Folders$toItem, preferredLib)));
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Components$MatterInput$Model$resetContactMatterInput = F2(
	function (contact, recentMatters) {
		return {
			av: $elm$core$Maybe$Nothing,
			c2: contact,
			bY: 1,
			iP: recentMatters,
			eI: $krisajenkins$remotedata$RemoteData$NotAsked,
			i0: $Gizra$elm_debouncer$Debouncer$Messages$toDebouncer(
				$Gizra$elm_debouncer$Debouncer$Messages$debounce(500)),
			eW: $krisajenkins$remotedata$RemoteData$NotAsked,
			eX: '',
			fe: $krisajenkins$remotedata$RemoteData$NotAsked
		};
	});
var $author$project$CoreX$Appendable$andMaybeAppend = F2(
	function (maybe, base) {
		if (maybe.$ === 1) {
			return base;
		} else {
			var addition = maybe.a;
			return _Utils_ap(base, addition);
		}
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$CoreX$Appendable$andAppendMaybe = A2(
	$elm$core$Basics$composeL,
	$author$project$CoreX$Appendable$andMaybeAppend,
	$elm$core$Maybe$map($elm$core$List$singleton));
var $author$project$CoreX$Appendable$andAppendMaybeRun = F2(
	function (maybe, fn) {
		return A3(
			$elm$core$Basics$composeL,
			$author$project$CoreX$Appendable$andAppendMaybe,
			$elm$core$Maybe$map(fn),
			maybe);
	});
var $author$project$Components$SelectInput$Folders$LibraryFolder = F3(
	function (id, name, database) {
		return {gz: database, aC: id, b2: name};
	});
var $author$project$Components$SelectInput$Folders$decodeLibraryFolder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'database',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Components$SelectInput$Folders$LibraryFolder))));
var $author$project$Components$SelectInput$Folders$decodeLibraryFolders = A2(
	$elm$json$Json$Decode$field,
	'folders',
	$elm$json$Json$Decode$list($author$project$Components$SelectInput$Folders$decodeLibraryFolder));
var $author$project$Components$SelectInput$Folders$makeSearchQuery = F2(
	function (library, matter) {
		var params = A3(
			$author$project$CoreX$Appendable$andAppendMaybeRun,
			library,
			function (lib) {
				return A2(
					$author$project$Requests$Param,
					'library',
					$elm$core$Maybe$Just(
						$elm$url$Url$percentEncode(lib.aa)));
			},
			_List_fromArray(
				[
					A2(
					$author$project$Requests$Param,
					'matter_id',
					$elm$core$Maybe$Just(
						$elm$url$Url$percentEncode(
							$elm$core$String$fromInt(matter.aC))))
				]));
		return $o_train$elm_search_input$Select$HttpQuery(
			function (terms) {
				return {
					fW: $elm$http$Http$emptyBody,
					gB: $author$project$Components$SelectInput$Folders$decodeLibraryFolders,
					A: _List_Nil,
					ei: 'GET',
					jR: A2($author$project$Requests$toUrl, '/api/documents/folders', params)
				};
			});
	});
var $author$project$Components$SelectInput$Folders$searchQuery = F2(
	function (lib, maybeMatter) {
		return A2(
			$elm$core$Maybe$withDefault,
			$o_train$elm_search_input$Select$BasicQuery,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$SelectInput$Folders$makeSearchQuery(lib),
				maybeMatter));
	});
var $author$project$Components$SelectInput$Folders$selectorModel = F3(
	function (lib, dms, matter) {
		var label = function () {
			if (!dms) {
				return 'Folder - if required';
			} else {
				return 'Folder';
			}
		}();
		return A2(
			$o_train$elm_search_input$Select$addSearchQuery,
			A2($author$project$Components$SelectInput$Folders$searchQuery, lib, matter),
			A2($o_train$elm_search_input$Select$init, label, $author$project$Components$SelectInput$Folders$toItem));
	});
var $author$project$Components$SelectInput$Libraries$toItem = function (lib) {
	return {aC: lib, aa: lib, hK: true, ec: lib};
};
var $author$project$Components$SelectInput$Libraries$addDefault = F2(
	function (preferredLib, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (s) {
					return A2($o_train$elm_search_input$Select$addSelectedItem, s, model);
				},
				A2($elm$core$Maybe$map, $author$project$Components$SelectInput$Libraries$toItem, preferredLib)));
	});
var $o_train$elm_search_input$Select$addItems = F2(
	function (items, model) {
		var search = model.eV;
		return A3(
			$o_train$elm_search_input$Select$flip,
			$o_train$elm_search_input$Select$setSearch,
			model,
			_Utils_update(
				search,
				{Q: items}));
	});
var $author$project$Components$SelectInput$Libraries$selectorModel = F2(
	function (selected, libraries) {
		return A2(
			$author$project$Components$SelectInput$Libraries$addDefault,
			selected,
			A2(
				$o_train$elm_search_input$Select$addItems,
				A2($elm$core$List$map, $author$project$Components$SelectInput$Libraries$toItem, libraries),
				A2($o_train$elm_search_input$Select$init, 'Library', $author$project$Components$SelectInput$Libraries$toItem)));
	});
var $author$project$Components$SelectInput$Templates$toItem = function (template) {
	return {
		aC: A2(
			$elm$core$Maybe$withDefault,
			'Nothing',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, template.aC)),
		aa: template,
		hK: true,
		ec: template.jB
	};
};
var $author$project$Components$SelectInput$Templates$addDefault = F2(
	function (defaultTemplate, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (s) {
					return A2($o_train$elm_search_input$Select$addSelectedItem, s, model);
				},
				A2($elm$core$Maybe$map, $author$project$Components$SelectInput$Templates$toItem, defaultTemplate)));
	});
var $author$project$Components$SelectInput$Templates$selectorModel = F2(
	function (selectedTemplate, fileNoteTemplates) {
		return A2(
			$author$project$Components$SelectInput$Templates$addDefault,
			selectedTemplate,
			A2(
				$o_train$elm_search_input$Select$addItems,
				A2($elm$core$List$map, $author$project$Components$SelectInput$Templates$toItem, fileNoteTemplates),
				A2($o_train$elm_search_input$Select$init, 'Template', $author$project$Components$SelectInput$Templates$toItem)));
	});
var $author$project$Components$FileNotes$Model$init = F7(
	function (parentMsg, closeMsg, csrfToken, user, recentMatters, resource, filingStatus) {
		var selectedLib = function () {
			var _v0 = filingStatus.hV;
			if (_v0.$ === 1) {
				return user.E.iI;
			} else {
				var lib = _v0.a;
				return $elm$core$Maybe$Just(lib);
			}
		}();
		var selectedLibItem = A2($elm$core$Maybe$map, $author$project$Components$SelectInput$Libraries$toItem, selectedLib);
		var selectedFolder = A2(
			$elm$core$Maybe$map,
			function (f) {
				return {
					gz: $elm$core$Maybe$Just(f),
					aC: f,
					b2: ''
				};
			},
			filingStatus.hb);
		var matterInput = A2($author$project$Components$MatterInput$Model$resetContactMatterInput, $elm$core$Maybe$Nothing, recentMatters);
		var blankTemplate = {c9: false, aC: $elm$core$Maybe$Nothing, jB: 'Blank Template'};
		var selectedTemplate = $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				blankTemplate,
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.c9;
						},
						$elm$core$Basics$eq(true)),
					user.E.dF)));
		var templates = A2(
			$elm$core$List$append,
			user.E.dF,
			_List_fromArray(
				[blankTemplate]));
		return {
			ge: closeMsg,
			gr: csrfToken,
			E: user.E,
			bH: user.bH,
			bI: resource,
			dH: filingStatus,
			eg: matterInput,
			ew: parentMsg,
			ce: user.ce,
			cn: A2(
				$author$project$Components$SelectInput$Folders$addDefault,
				selectedFolder,
				A3($author$project$Components$SelectInput$Folders$selectorModel, selectedLibItem, user.E.by, filingStatus.hY)),
			co: A2($author$project$Components$SelectInput$Libraries$selectorModel, selectedLib, user.E.hU),
			e$: A2($author$project$Components$SelectInput$Templates$selectorModel, selectedTemplate, templates),
			cq: filingStatus.hY,
			fj: $elm$core$Maybe$Nothing,
			jP: 0
		};
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Messages$LoggedOut = function (a) {
	return {$: 12, a: a};
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Requests$appendJSONHeaders = function (headers) {
	return _Utils_ap(
		headers,
		_List_fromArray(
			[
				A2($elm$http$Http$header, 'Accept', 'application/json')
			]));
};
var $author$project$Requests$delete = function (req) {
	return $elm$http$Http$request(
		{
			fW: req.fW,
			z: req.z,
			A: $author$project$Requests$appendJSONHeaders(req.A),
			ei: 'DELETE',
			fl: $elm$core$Maybe$Nothing,
			fo: $elm$core$Maybe$Nothing,
			jR: req.jR
		});
};
var $jzxhuang$http_extras$Http$Detailed$responseToString = function (responseString) {
	return A2(
		$jzxhuang$http_extras$Http$Detailed$resolve,
		function (_v0) {
			var metadata = _v0.a;
			var body = _v0.b;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(metadata, body));
		},
		responseString);
};
var $jzxhuang$http_extras$Http$Detailed$expectString = function (toMsg) {
	return A2($elm$http$Http$expectStringResponse, toMsg, $jzxhuang$http_extras$Http$Detailed$responseToString);
};
var $author$project$LoggedOutPage$Requests$logOut = function (csrfToken) {
	return $author$project$Requests$delete(
		{
			fW: $elm$http$Http$emptyBody,
			z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$Messages$LoggedOut),
			A: _List_fromArray(
				[
					A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
				]),
			jR: '/api/sessions'
		});
};
var $author$project$LoggedOutPage$Data$decodeLoggedOut = A2(
	$elm$json$Json$Decode$andThen,
	function (path) {
		return A2($elm$core$String$contains, '/super_admin/users', path) ? $elm$json$Json$Decode$succeed(path) : (A2($elm$core$String$contains, '/user_delegations', path) ? $elm$json$Json$Decode$succeed(path) : $elm$json$Json$Decode$succeed('/sessions/new'));
	},
	$elm$json$Json$Decode$string);
var $author$project$LoggedOutPage$Data$logOutDecoder = $elm$json$Json$Decode$decodeString($author$project$LoggedOutPage$Data$decodeLoggedOut);
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $Fresheyeball$elm_return$Return$mapCmd = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			A2($elm$core$Platform$Cmd$map, f, cmd));
	});
var $author$project$Update$newsResponseDecoder = A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string);
var $author$project$Ports$OpenNewTab$openNewTab = _Platform_outgoingPort('openNewTab', $elm$json$Json$Encode$string);
var $author$project$TimesheetPage$Messages$SetFlashMessageHttp = function (a) {
	return {$: 96, a: a};
};
var $author$project$Utils$send = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Activities$Update$setFlashResponseCmd = function (response) {
	return $author$project$Utils$send(
		$author$project$TimesheetPage$Messages$SetFlashMessageHttp(
			$elm$core$Result$Err(response)));
};
var $author$project$Update$setRecentMatters = F2(
	function (matters, model) {
		var _v0 = model.h7;
		if (_v0.$ === 1) {
			var fileNoteModel = _v0.a;
			var matterInput = fileNoteModel.eg;
			return _Utils_update(
				model,
				{
					h7: $author$project$Components$Modal$Model$FileNotesModal(
						_Utils_update(
							fileNoteModel,
							{
								eg: _Utils_update(
									matterInput,
									{iP: matters})
							}))
				});
		} else {
			return model;
		}
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $Fresheyeball$elm_return$Return$singleton = function (a) {
	return _Utils_Tuple2(a, $elm$core$Platform$Cmd$none);
};
var $author$project$Components$FileNotes$Messages$FocusFailure = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$FileNotes$Messages$MatterInputMessage = function (a) {
	return {$: 7, a: a};
};
var $o_train$elm_search_input$Select$RunSearch = {$: 3};
var $author$project$Components$FileNotes$Messages$SelectFolderMessage = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$FileNotes$Messages$SelectLibraryMessage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$FileNotes$Messages$SelectTemplateMessage = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$FileNotes$Messages$SetTitle = function (a) {
	return {$: 2, a: a};
};
var $Fresheyeball$elm_return$Return$andThen = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = f(model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		return _Utils_Tuple2(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$FileNotes$cleanUp = _Platform_outgoingPort(
	'cleanUp',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $Fresheyeball$elm_return$Return$effect_ = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						f(model)
					])));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Components$FileNotes$Types$FileNote$encodeFileNote = F3(
	function (isEditable, matterId, fileNote) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(fileNote.jB)),
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string(fileNote.go)),
					_Utils_Tuple2(
					'isEditable',
					$elm$json$Json$Encode$bool(isEditable)),
					_Utils_Tuple2(
					'matter_id',
					$elm$json$Json$Encode$int(matterId))
				]));
	});
var $author$project$Components$FileNotes$Messages$SaveFileNoteResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$FileNotes$Types$FilingStatus$encodeFilingStatus = F3(
	function (lib, folder, folderName) {
		var encoder = function (v) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, v));
		};
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'library',
					encoder(lib)),
					_Utils_Tuple2(
					'folder',
					encoder(folder)),
					_Utils_Tuple2(
					'folder_name',
					encoder(folderName))
				]));
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Requests$post = function (req) {
	return $elm$http$Http$request(
		{
			fW: req.fW,
			z: req.z,
			A: $author$project$Requests$appendJSONHeaders(req.A),
			ei: 'POST',
			fl: $elm$core$Maybe$Nothing,
			fo: $elm$core$Maybe$Nothing,
			jR: req.jR
		});
};
var $author$project$Components$FileNotes$Requests$fileNote = F4(
	function (feeId, matterId, note, model) {
		var body = function () {
			var lib = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.aa;
				},
				model.co.e0);
			var folderName = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aa;
					},
					function ($) {
						return $.b2;
					}),
				model.cn.e0);
			var folder = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aa;
					},
					function ($) {
						return $.aC;
					}),
				model.cn.e0);
			return $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'file_note',
							A3($author$project$Components$FileNotes$Types$FileNote$encodeFileNote, true, matterId, note)),
							_Utils_Tuple2(
							'filing_status',
							A3($author$project$Components$FileNotes$Types$FilingStatus$encodeFilingStatus, lib, folder, folderName)),
							_Utils_Tuple2(
							'units',
							$elm$json$Json$Encode$int(model.jP))
						])));
		}();
		return $author$project$Requests$post(
			{
				fW: body,
				z: A2(
					$jzxhuang$http_extras$Http$Detailed$expectJson,
					A2($elm$core$Basics$composeL, model.ew, $author$project$Components$FileNotes$Messages$SaveFileNoteResponse),
					$author$project$Components$FileNotes$Types$FilingStatus$decodeFilingStatus),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', model.gr)
					]),
				jR: '/api/fees/' + ($elm$core$String$fromInt(feeId) + '/file_notes')
			});
	});
var $author$project$Components$FileNotes$Requests$fileNoteToMatter = F3(
	function (matterId, note, model) {
		var body = function () {
			var lib = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.aa;
				},
				model.co.e0);
			var folderName = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aa;
					},
					function ($) {
						return $.b2;
					}),
				model.cn.e0);
			var folder = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aa;
					},
					function ($) {
						return $.aC;
					}),
				model.cn.e0);
			return $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'file_note',
							A3($author$project$Components$FileNotes$Types$FileNote$encodeFileNote, true, matterId, note)),
							_Utils_Tuple2(
							'filing_status',
							A3($author$project$Components$FileNotes$Types$FilingStatus$encodeFilingStatus, lib, folder, folderName))
						])));
		}();
		return $author$project$Requests$post(
			{
				fW: body,
				z: A2(
					$jzxhuang$http_extras$Http$Detailed$expectJson,
					A2($elm$core$Basics$composeL, model.ew, $author$project$Components$FileNotes$Messages$SaveFileNoteResponse),
					$author$project$Components$FileNotes$Types$FilingStatus$decodeFilingStatus),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', model.gr)
					]),
				jR: '/api/matters/' + ($elm$core$String$fromInt(matterId) + '/file_notes')
			});
	});
var $author$project$CoreX$Basics$flip = F3(
	function (fn, a, b) {
		return A2(fn, b, a);
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Ports$FileNotes$focus = _Platform_outgoingPort(
	'focus',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Components$FileNotes$Messages$ContentTemplateResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$FileNotes$Types$FilingStatus$decodeContent = A2(
	$elm$json$Json$Decode$field,
	'content',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Components$FileNotes$Requests$getTemplateContent = function (model) {
	var encodedTemplate = A2(
		$elm$core$Maybe$withDefault,
		$elm$json$Json$Encode$null,
		A2(
			$elm$core$Maybe$map,
			$elm$json$Json$Encode$int,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aa;
					},
					function ($) {
						return $.aC;
					}),
				model.e$.e0)));
	var encodedFileNote = function () {
		var matterId = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.aC;
				},
				model.cq));
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Components$FileNotes$Types$FileNote$encodeFileNote, true, matterId),
				model.dH.ij));
	}();
	var body = $elm$http$Http$jsonBody(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('file_note', encodedFileNote),
					_Utils_Tuple2('template_id', encodedTemplate)
				])));
	return $author$project$Requests$post(
		{
			fW: body,
			z: A2(
				$jzxhuang$http_extras$Http$Detailed$expectJson,
				A2($elm$core$Basics$composeL, model.ew, $author$project$Components$FileNotes$Messages$ContentTemplateResponse),
				$author$project$Components$FileNotes$Types$FilingStatus$decodeContent),
			A: _List_fromArray(
				[
					A2($elm$http$Http$header, 'X-CSRF-TOKEN', model.gr)
				]),
			jR: '/api/file_notes/content'
		});
};
var $author$project$Components$FileNotes$Types$FilingStatus$isEditable = function (filingStatus) {
	var _v0 = filingStatus.dG;
	switch (_v0.$) {
		case 0:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		default:
			return true;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $Fresheyeball$elm_return$Return$map = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			f(model),
			cmd);
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Ports$FileNotes$openFileNote = _Platform_outgoingPort('openFileNote', $elm$core$Basics$identity);
var $Fresheyeball$elm_return$Return$return = F2(
	function (a, b) {
		return $elm$core$Basics$identity(
			_Utils_Tuple2(a, b));
	});
var $author$project$Components$FileNotes$Update$runFolderSearch = function (model) {
	var _v0 = model.cq;
	if (!_v0.$) {
		var selectFolder = model.cn;
		var cleared = _Utils_update(
			selectFolder,
			{e0: $elm$core$Maybe$Nothing});
		var clearedResults = _Utils_update(
			model,
			{cn: cleared});
		return _Utils_Tuple2(
			clearedResults,
			$author$project$Utils$send(
				$author$project$Components$FileNotes$Messages$SelectFolderMessage($o_train$elm_search_input$Select$RunSearch)));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Components$FileNotes$FilingStatusLogic$setContent = F2(
	function (str, fileNote) {
		return _Utils_update(
			fileNote,
			{go: str});
	});
var $author$project$Components$FileNotes$FilingStatusLogic$setFailed = F2(
	function (errMsg, filingStatus) {
		return _Utils_update(
			filingStatus,
			{
				dG: $author$project$Components$FileNotes$Types$FilingStatus$Failed(errMsg)
			});
	});
var $author$project$Components$FileNotes$FilingStatusLogic$setFileNote = F2(
	function (note, filingStatus) {
		return _Utils_update(
			filingStatus,
			{
				ij: $elm$core$Maybe$Just(note)
			});
	});
var $author$project$Components$FileNotes$FilingStatusLogic$setFileNoteField = F2(
	function (fn, filingStatus) {
		return A2(
			$elm$core$Maybe$withDefault,
			filingStatus,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$CoreX$Basics$flip, $author$project$Components$FileNotes$FilingStatusLogic$setFileNote, filingStatus),
				A2($elm$core$Maybe$map, fn, filingStatus.ij)));
	});
var $author$project$Components$FileNotes$FilingStatusLogic$setFilingStatus = F2(
	function (filingStatus, model) {
		return _Utils_update(
			model,
			{dH: filingStatus});
	});
var $author$project$Components$FileNotes$FilingStatusLogic$setTitle = F2(
	function (str, fileNote) {
		return _Utils_update(
			fileNote,
			{jB: str});
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Ports$EventTracking$EmailGroupEvent = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$MatterInput$MatterSelection$MatterSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$MatterInput$MatterSelection$NoChange = {$: 0};
var $author$project$Components$MatterInput$MatterSelection$PendingMatterSelected = {$: 3};
var $author$project$Components$MatterInput$Messages$QueueSearchMatters = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$MatterInput$Messages$RunSearchMatters = {$: 11};
var $author$project$Components$AutocompleteLogic$changeStep = F2(
	function (dir, index) {
		var _v0 = _Utils_Tuple2(dir, index);
		if (!_v0.a) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$core$Maybe$Just(0);
			} else {
				var _v3 = _v0.a;
				var i = _v0.b.a;
				return $elm$core$Maybe$Just(i + 1);
			}
		} else {
			if (_v0.b.$ === 1) {
				var _v4 = _v0.a;
				var _v5 = _v0.b;
				return $elm$core$Maybe$Nothing;
			} else {
				var _v6 = _v0.a;
				var i = _v0.b.a;
				return $elm$core$Maybe$Just(i - 1);
			}
		}
	});
var $author$project$Components$MatterInput$Messages$SearchedMattersFetched = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$MatterInput$Requests$fetchMatchingMatters = F2(
	function (editMode, term) {
		return $elm$http$Http$get(
			{
				z: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Components$MatterInput$Messages$SearchedMattersFetched),
					$author$project$MatterTypes$decodeMatters),
				jR: A2(
					$author$project$Requests$toUrl,
					'/api/matters/search',
					_List_fromArray(
						[
							A2(
							$author$project$Requests$Param,
							'term',
							$elm$core$Maybe$Just(
								$elm$url$Url$percentEncode(term))),
							A2(
							$author$project$Requests$Param,
							'mode',
							$elm$core$Maybe$Just(
								$author$project$EditMode$toString(editMode)))
						]))
			});
	});
var $author$project$Components$MatterInput$Model$Recent = 0;
var $author$project$Components$MatterInput$Model$RecentRestricted = 3;
var $author$project$Components$MatterInput$Model$Search = 2;
var $author$project$Components$MatterInput$Model$Suggested = 1;
var $author$project$Components$MatterInput$Model$deriveDisplayMode = function (model) {
	if ($elm$core$String$length(model.eX) > 0) {
		return 2;
	} else {
		var _default = (model.bY === 2) ? 3 : 0;
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(1),
				model.c2));
	}
};
var $krisajenkins$remotedata$RemoteData$succeed = $krisajenkins$remotedata$RemoteData$Success;
var $author$project$Components$MatterInput$Update$getCurrentMattersList = function (model) {
	var _v0 = $author$project$Components$MatterInput$Model$deriveDisplayMode(model);
	switch (_v0) {
		case 2:
			return model.eW;
		case 1:
			return model.fe;
		case 3:
			return model.eI;
		default:
			return $krisajenkins$remotedata$RemoteData$succeed(model.iP);
	}
};
var $author$project$Components$MatterInput$Messages$FocusMatterSearch = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$MatterInput$MatterSelection$OpenRestricted = {$: 2};
var $author$project$Components$MatterInput$Messages$SuggestedMattersFetched = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$MatterInput$Requests$fetchSuggestedMatters = F2(
	function (editMode, contact) {
		var contact_id = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.aC;
				},
				contact));
		return $elm$http$Http$get(
			{
				z: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Components$MatterInput$Messages$SuggestedMattersFetched),
					$author$project$MatterTypes$decodeMatters),
				jR: A2(
					$author$project$Requests$toUrl,
					'/api/matters/suggested',
					_List_fromArray(
						[
							A2($author$project$Requests$Param, 'contact_id', contact_id),
							A2(
							$author$project$Requests$Param,
							'mode',
							$elm$core$Maybe$Just(
								$author$project$EditMode$toString(editMode)))
						]))
			});
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$MatterLogic$openMatter = F4(
	function (recentMatters, model, mode, domId) {
		if (mode === 2) {
			return _Utils_Tuple3(model, $author$project$Components$MatterInput$MatterSelection$OpenRestricted, $elm$core$Platform$Cmd$none);
		} else {
			var cmd = $elm_community$maybe_extra$Maybe$Extra$isJust(model.c2) ? A2($author$project$Components$MatterInput$Requests$fetchSuggestedMatters, mode, model.c2) : $elm$core$Platform$Cmd$none;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{bY: mode, iP: recentMatters}),
				$author$project$Components$MatterInput$MatterSelection$NoChange,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A2(
							$elm$core$Task$attempt,
							$author$project$Components$MatterInput$Messages$FocusMatterSearch,
							$elm$browser$Browser$Dom$focus(domId + '-search'))
						])));
		}
	});
var $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput = function (a) {
	return {$: 0, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Basic$provideInput = $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput;
var $author$project$Ports$Scroll$End = 3;
var $author$project$Ports$Scroll$encodeVerticalAlignment = function (verticalAlignment) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (verticalAlignment) {
				case 0:
					return 'start';
				case 1:
					return 'center';
				case 2:
					return 'nearest';
				default:
					return 'end';
			}
		}());
};
var $author$project$Ports$Scroll$encodeIntoViewParameters = function (_v0) {
	var id = _v0.aC;
	var verticalAlignment = _v0.bk;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(id)),
				_Utils_Tuple2(
				'verticalAlignment',
				$author$project$Ports$Scroll$encodeVerticalAlignment(verticalAlignment))
			]));
};
var $author$project$Ports$Scroll$intoView = _Platform_outgoingPort('intoView', $elm$core$Basics$identity);
var $author$project$Ports$Scroll$scrollIntoViewWithAlignment = F2(
	function (verticalAlignment, id) {
		return $author$project$Ports$Scroll$intoView(
			$author$project$Ports$Scroll$encodeIntoViewParameters(
				{aC: id, bk: verticalAlignment}));
	});
var $author$project$Components$AutocompleteLogic$scrollMatterAutocompleteIndexIntoView = function (autocompleteIndex) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$fromInt,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$append('-'),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$append('matter-search-index-'),
						$author$project$Ports$Scroll$scrollIntoViewWithAlignment(3)))),
			autocompleteIndex));
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Components$MatterInput$Update$getAutoCompleteIndexMatter = F2(
	function (index, matters) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return A2($elm_community$list_extra$List$Extra$getAt, a, matters);
			},
			index);
	});
var $author$project$Ports$EventTracking$Event = F2(
	function (eventName, eventProperties) {
		return {dp: eventName, dq: eventProperties};
	});
var $author$project$Ports$EventTracking$trackEventWithProperties = _Platform_outgoingPort(
	'trackEventWithProperties',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'eventName',
					$elm$json$Json$Encode$string($.dp)),
					_Utils_Tuple2(
					'eventProperties',
					$elm$core$Basics$identity($.dq))
				]));
	});
var $author$project$Ports$EventTracking$trackEvent = function (eventName) {
	return $author$project$Ports$EventTracking$trackEventWithProperties(
		A2($author$project$Ports$EventTracking$Event, eventName, $elm$json$Json$Encode$null));
};
var $author$project$Components$MatterInput$Update$setMatterFromAutocomplete = F2(
	function (model, matters) {
		var pendingMatterOrNoChange = function (i) {
			return _Utils_eq(
				i,
				$elm$core$List$length(matters)) ? $author$project$Components$MatterInput$MatterSelection$PendingMatterSelected : $author$project$Components$MatterInput$MatterSelection$NoChange;
		};
		var matter = A2($author$project$Components$MatterInput$Update$getAutoCompleteIndexMatter, model.av, matters);
		var defaultUpperMsg = pendingMatterOrNoChange(
			A2($elm$core$Maybe$withDefault, 0, model.av));
		return function (cmd) {
			return _Utils_Tuple3(
				model,
				cmd,
				_Utils_eq(cmd, $author$project$Components$MatterInput$MatterSelection$NoChange) ? $elm$core$Platform$Cmd$none : $author$project$Ports$EventTracking$trackEvent('Autocomplete Matter Select'));
		}(
			A2(
				$elm$core$Maybe$withDefault,
				defaultUpperMsg,
				A2($elm$core$Maybe$map, $author$project$Components$MatterInput$MatterSelection$MatterSelected, matter)));
	});
var $author$project$Tours$amplitudeEventTourName = function (userTour) {
	switch (userTour) {
		case 0:
			return 'ManualFeeTour';
		case 1:
			return 'ActivityReviewTour';
		case 2:
			return 'FeeGroupingAcknowledgement';
		default:
			return 'MergingAcknowledgement';
	}
};
var $author$project$FeeFilter$feeFilterString = function (feeFilter) {
	switch (feeFilter) {
		case 0:
			return 'incomplete';
		case 1:
			return 'expiring';
		case 2:
			return 'failed';
		case 3:
			return 'pending';
		default:
			return 'on-hold';
	}
};
var $author$project$Model$Timesheet$GroupByFilter$filterText = function (filter) {
	if (!filter) {
		return 'Day and Matter';
	} else {
		return 'Day';
	}
};
var $author$project$Model$Timesheet$GroupByFilter$getCurrentGrouping = function (filterMode) {
	if (!filterMode.$) {
		var res = filterMode.a;
		return res;
	} else {
		var res = filterMode.a;
		return res;
	}
};
var $author$project$Model$Timesheet$GroupByFilter$filterModeText = function (filterMode) {
	return A3($elm$core$Basics$composeR, $author$project$Model$Timesheet$GroupByFilter$getCurrentGrouping, $author$project$Model$Timesheet$GroupByFilter$filterText, filterMode);
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Ports$EventTracking$track = F2(
	function (title, obj) {
		return $author$project$Ports$EventTracking$trackEventWithProperties(
			A2(
				$author$project$Ports$EventTracking$Event,
				title,
				$elm$json$Json$Encode$object(obj)));
	});
var $author$project$Ports$EventTracking$trackEventFor = function (trackEvent_) {
	switch (trackEvent_.$) {
		case 0:
			var description = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set Fee Type',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description))
					]));
		case 1:
			var description = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set ActionStep Rate',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description))
					]));
		case 2:
			var description = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set ActionStep Matter Rate',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description))
					]));
		case 3:
			var description = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set Scale Item',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description))
					]));
		case 4:
			var units = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set Units Button',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'units',
						$elm$json$Json$Encode$float(units))
					]));
		case 5:
			var units = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set Units - Manual Input',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'units',
						$elm$json$Json$Encode$float(units))
					]));
		case 6:
			var behaviour = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set Is Chargeable',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'isChargeable',
						$elm$json$Json$Encode$string(behaviour))
					]));
		case 7:
			var isRecordingInMinutes = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set Is Recording In Minutes',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'isRecordingInMinutes',
						$elm$json$Json$Encode$bool(isRecordingInMinutes))
					]));
		case 8:
			var tour = trackEvent_.a;
			if (!tour.$) {
				var tour_ = tour.a;
				return A2(
					$author$project$Ports$EventTracking$track,
					'Completed Tour',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'tour',
							$elm$json$Json$Encode$string(
								$author$project$Tours$amplitudeEventTourName(tour_)))
						]));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		case 9:
			var description = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set ActivityCode',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description))
					]));
		case 10:
			var description = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set TaskCode',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description))
					]));
		case 11:
			var description = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set TimekeeperCode',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(description))
					]));
		case 12:
			var filterMode = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Set Group By',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'groupBy',
						A3($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Model$Timesheet$GroupByFilter$filterModeText, filterMode))
					]));
		case 13:
			var filterState = trackEvent_.a;
			if (!filterState.$) {
				var filter = filterState.a;
				return A2(
					$author$project$Ports$EventTracking$track,
					'Set Filter',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'filter',
							A3($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$FeeFilter$feeFilterString, filter))
						]));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		case 14:
			var showPosted = trackEvent_.a;
			return showPosted ? A2(
				$author$project$Ports$EventTracking$track,
				'Set Filter',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'filter',
						$elm$json$Json$Encode$string('posted'))
					])) : $elm$core$Platform$Cmd$none;
		case 15:
			var action = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Email Group Event',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'action',
						$elm$json$Json$Encode$string(action))
					]));
		case 16:
			var _v3 = trackEvent_.a;
			var action = _v3.a;
			var activityType = _v3.b;
			var feeCount = _v3.c;
			return A2(
				$author$project$Ports$EventTracking$track,
				'Merge Fee Event',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'action',
						$elm$json$Json$Encode$string(action)),
						_Utils_Tuple2(
						'activityType',
						$elm$json$Json$Encode$string(activityType)),
						_Utils_Tuple2(
						'feeCount',
						$elm$json$Json$Encode$int(feeCount))
					]));
		default:
			var task = trackEvent_.a;
			return A2(
				$author$project$Ports$EventTracking$track,
				'AI Task',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'task',
						$elm$json$Json$Encode$string(task))
					]));
	}
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$Check = function (a) {
	return {$: 4, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt = function (a) {
	return {$: 3, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal = function (a) {
	return {$: 2, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$Unsettled = function (a) {
	return {$: 1, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$cancel = function (_v0) {
	var config = _v0.a;
	var state = _v0.b;
	return A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, config, $Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $Gizra$elm_debouncer$Debouncer$Internal$update = F2(
	function (msg, debouncer) {
		var wrappedConfig = debouncer.a;
		var config = wrappedConfig;
		var state = debouncer.b;
		switch (msg.$) {
			case 0:
				var input = msg.a;
				var time = msg.b;
				var newState = function () {
					if (!state.$) {
						return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							{
								an: $elm$core$Maybe$Nothing,
								a1: time,
								C: A2(config.V, input, $elm$core$Maybe$Nothing),
								bi: time
							});
					} else {
						var unsettled = state.a;
						return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							_Utils_update(
								unsettled,
								{
									a1: time,
									C: A2(config.V, input, unsettled.C)
								}));
					}
				}();
				var newDebouncer = A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState);
				var checks = function () {
					if (!state.$) {
						return $elm_community$list_extra$List$Extra$unique(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[config.F, config.G, config.K])));
					} else {
						return A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[config.K]));
					}
				}();
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
					A2(
						$elm$core$List$partition,
						function (interval) {
							return interval <= 0;
						},
						checks));
				var checkNow = _v1.a;
				var checkLater = _v1.b;
				var _v2 = checkNow ? A2(
					$Gizra$elm_debouncer$Debouncer$Internal$update,
					$Gizra$elm_debouncer$Debouncer$Internal$Check(time),
					newDebouncer) : _Utils_Tuple3(newDebouncer, _List_Nil, $elm$core$Maybe$Nothing);
				var checkedDebouncer = _v2.a;
				var checkedIntervals = _v2.b;
				var emit = _v2.c;
				return _Utils_Tuple3(
					checkedDebouncer,
					_Utils_ap(checkedIntervals, checkLater),
					emit);
			case 1:
				return _Utils_Tuple3(
					$Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer),
					_List_Nil,
					$elm$core$Maybe$Nothing);
			case 2:
				var emit = function () {
					if (!state.$) {
						return $elm$core$Maybe$Nothing;
					} else {
						var unsettled = state.a;
						return unsettled.C;
					}
				}();
				return _Utils_Tuple3(
					$Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer),
					_List_Nil,
					emit);
			case 3:
				var time = msg.a;
				if (!state.$) {
					return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
				} else {
					var unsettled = state.a;
					var _v7 = unsettled.C;
					if (!_v7.$) {
						var newState = $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							_Utils_update(
								unsettled,
								{
									an: $elm$core$Maybe$Just(time),
									C: $elm$core$Maybe$Nothing
								}));
						var intervals = function () {
							var _v8 = config.F;
							if (!_v8.$) {
								var emit = _v8.a;
								return _List_fromArray(
									[emit]);
							} else {
								return _List_Nil;
							}
						}();
						return _Utils_Tuple3(
							A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState),
							intervals,
							unsettled.C);
					} else {
						return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
					}
				}
			default:
				var time = msg.a;
				if (!state.$) {
					return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
				} else {
					var unsettled = state.a;
					var shouldSettle = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (interval) {
								return _Utils_cmp(unsettled.a1 + interval, time) < 1;
							},
							config.K));
					var becauseEmitWhileUnsettled = function () {
						var _v13 = config.G;
						if (!_v13.$) {
							var interval = _v13.a;
							var _v14 = unsettled.an;
							if (!_v14.$) {
								var lastEmittedAt = _v14.a;
								return _Utils_cmp(lastEmittedAt + interval, time) < 1;
							} else {
								return _Utils_cmp(unsettled.bi + interval, time) < 1;
							}
						} else {
							return false;
						}
					}();
					var becauseEmitWhenUnsettled = function () {
						var _v11 = config.F;
						if (!_v11.$) {
							var interval = _v11.a;
							var _v12 = unsettled.an;
							if (!_v12.$) {
								return false;
							} else {
								return _Utils_cmp(unsettled.bi + interval, time) < 1;
							}
						} else {
							return false;
						}
					}();
					var shouldEmit = (!_Utils_eq(unsettled.C, $elm$core$Maybe$Nothing)) && (shouldSettle || (becauseEmitWhenUnsettled || becauseEmitWhileUnsettled));
					var emit = shouldEmit ? unsettled.C : $elm$core$Maybe$Nothing;
					var intervals = function () {
						if (shouldEmit && (!shouldSettle)) {
							var _v10 = config.G;
							if (!_v10.$) {
								var interval = _v10.a;
								return _List_fromArray(
									[interval]);
							} else {
								return _List_Nil;
							}
						} else {
							return _List_Nil;
						}
					}();
					var newState = shouldSettle ? $Gizra$elm_debouncer$Debouncer$Internal$Settled : (shouldEmit ? $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
						_Utils_update(
							unsettled,
							{
								an: $elm$core$Maybe$Just(time),
								C: $elm$core$Maybe$Nothing
							})) : state);
					return _Utils_Tuple3(
						A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState),
						intervals,
						emit);
				}
		}
	});
var $Gizra$elm_debouncer$Debouncer$Basic$update = F2(
	function (msg, debouncer) {
		switch (msg.$) {
			case 0:
				var input = msg.a;
				return _Utils_Tuple3(
					debouncer,
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$Gizra$elm_debouncer$Debouncer$Basic$MsgInternal,
								$Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt(input)),
							$elm$time$Time$posixToMillis),
						$elm$time$Time$now),
					$elm$core$Maybe$Nothing);
			case 1:
				return _Utils_Tuple3(
					debouncer,
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt),
							$elm$time$Time$posixToMillis),
						$elm$time$Time$now),
					$elm$core$Maybe$Nothing);
			default:
				var subMsg = msg.a;
				var _v1 = A2($Gizra$elm_debouncer$Debouncer$Internal$update, subMsg, debouncer);
				var updatedDebouncer = _v1.a;
				var intervals = _v1.b;
				var output = _v1.c;
				var cmds = $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (interval) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$Check),
									$elm$time$Time$posixToMillis),
								A2(
									$elm$core$Task$andThen,
									$elm$core$Basics$always($elm$time$Time$now),
									$elm$core$Process$sleep(interval)));
						},
						intervals));
				return _Utils_Tuple3(updatedDebouncer, cmds, output);
		}
	});
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Components$MatterInput$Update$update = F4(
	function (msg, model, recentMatters, domId) {
		switch (msg.$) {
			case 5:
				var mode = msg.a;
				return A4($author$project$MatterLogic$openMatter, recentMatters, model, mode, domId);
			case 8:
				return _Utils_Tuple3(
					A2($author$project$Components$MatterInput$Model$resetContactMatterInput, model.c2, model.iP),
					$author$project$Components$MatterInput$MatterSelection$NoChange,
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple3(model, $author$project$Components$MatterInput$MatterSelection$NoChange, $elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple3(model, $author$project$Components$MatterInput$MatterSelection$NoChange, $elm$core$Platform$Cmd$none);
			case 0:
				var matter = msg.a;
				var context = msg.b;
				var trackCmd = function () {
					if (!context) {
						return $author$project$Ports$EventTracking$trackEventFor(
							$author$project$Ports$EventTracking$EmailGroupEvent('Verify Email Group'));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bY: 1}),
					$author$project$Components$MatterInput$MatterSelection$MatterSelected(matter),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$EventTracking$trackEvent('Verified SuggestedMatter'),
								trackCmd
							])));
			case 4:
				var dir = msg.a;
				var autocompleteIndex = A2($author$project$Components$AutocompleteLogic$changeStep, dir, model.av);
				var scrollToCmd = $author$project$Components$AutocompleteLogic$scrollMatterAutocompleteIndexIntoView(autocompleteIndex);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{av: autocompleteIndex}),
					$author$project$Components$MatterInput$MatterSelection$NoChange,
					scrollToCmd);
			case 1:
				var matter = msg.a;
				var verificationType = $elm$core$String$isEmpty(model.eX) ? 'Verified ListedMatter' : 'Verified SearchedMatter';
				return _Utils_Tuple3(
					A2($author$project$Components$MatterInput$Model$resetContactMatterInput, model.c2, model.iP),
					$author$project$Components$MatterInput$MatterSelection$MatterSelected(matter),
					$author$project$Ports$EventTracking$trackEvent(verificationType));
			case 2:
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(model, $author$project$Components$MatterInput$MatterSelection$NoChange, $elm$core$Platform$Cmd$none),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						$author$project$Components$MatterInput$Update$setMatterFromAutocomplete(model),
						$author$project$Components$MatterInput$Update$getCurrentMattersList(model)));
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bY: 1}),
					$author$project$Components$MatterInput$MatterSelection$PendingMatterSelected,
					$elm$core$Platform$Cmd$none);
			case 9:
				var matterData = msg.a;
				var currentMatters = (model.bY === 2) ? A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.eI) : model.iP;
				var suggestedMatters = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					model.iP,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (matters) {
							return A2(
								$elm$core$List$take,
								10,
								A2(
									$elm_community$list_extra$List$Extra$uniqueBy,
									function ($) {
										return $.aC;
									},
									A2($elm$core$List$append, matters, currentMatters)));
						},
						matterData));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fe: $krisajenkins$remotedata$RemoteData$succeed(suggestedMatters)
						}),
					$author$project$Components$MatterInput$MatterSelection$NoChange,
					$elm$core$Platform$Cmd$none);
			case 10:
				var matters = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eW: matters}),
					$author$project$Components$MatterInput$MatterSelection$NoChange,
					$elm$core$Platform$Cmd$none);
			case 11:
				var runSearch = A2($author$project$Components$MatterInput$Requests$fetchMatchingMatters, model.bY, model.eX);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eW: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Components$MatterInput$MatterSelection$NoChange,
					runSearch);
			case 12:
				var terms = msg.a;
				var runnable = $elm$core$String$length(terms) > 1;
				var cmd = runnable ? A2(
					$elm$core$Task$perform,
					$elm$core$Basics$identity,
					$elm$core$Task$succeed(
						$author$project$Components$MatterInput$Messages$QueueSearchMatters(
							$Gizra$elm_debouncer$Debouncer$Basic$provideInput($author$project$Components$MatterInput$Messages$RunSearchMatters)))) : $elm$core$Platform$Cmd$none;
				var autocompleteIndex = ($elm$core$String$length(terms) > 0) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{av: autocompleteIndex, eW: $krisajenkins$remotedata$RemoteData$NotAsked, eX: terms}),
					$author$project$Components$MatterInput$MatterSelection$NoChange,
					cmd);
			default:
				var subMsg = msg.a;
				var _v2 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, model.i0);
				var debouncedModel = _v2.a;
				var subCmd = _v2.b;
				var emittedMsg = _v2.c;
				var updatedModel = _Utils_update(
					model,
					{i0: debouncedModel});
				var mappedCmd = A2($elm$core$Platform$Cmd$map, $author$project$Components$MatterInput$Messages$QueueSearchMatters, subCmd);
				if (!emittedMsg.$) {
					var emitted = emittedMsg.a;
					var _v4 = A4($author$project$Components$MatterInput$Update$update, emitted, updatedModel, model.iP, domId);
					var m = _v4.a;
					var c = _v4.c;
					return _Utils_Tuple3(
						m,
						$author$project$Components$MatterInput$MatterSelection$NoChange,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[c, mappedCmd])));
				} else {
					return _Utils_Tuple3(updatedModel, $author$project$Components$MatterInput$MatterSelection$NoChange, mappedCmd);
				}
		}
	});
var $o_train$elm_search_input$Select$NoChange = {$: 2};
var $o_train$elm_search_input$Select$Opened = 0;
var $o_train$elm_search_input$Select$ParentMsg = function (a) {
	return {$: 1, a: a};
};
var $o_train$elm_search_input$Select$QueueSearch = function (a) {
	return {$: 5, a: a};
};
var $o_train$elm_search_input$Select$SelectedItem = function (a) {
	return {$: 0, a: a};
};
var $o_train$elm_search_input$Select$setSearchResults = F2(
	function (results, search) {
		return _Utils_update(
			search,
			{iV: results});
	});
var $o_train$elm_search_input$Select$setSearchTerms = F2(
	function (terms, search) {
		return _Utils_update(
			search,
			{N: terms});
	});
var $o_train$elm_search_input$Select$clear = function (model) {
	return A3(
		$o_train$elm_search_input$Select$flip,
		$o_train$elm_search_input$Select$setSearch,
		model,
		A2(
			$o_train$elm_search_input$Select$setSearchResults,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($o_train$elm_search_input$Select$setSearchTerms, $elm$core$Maybe$Nothing, model.eV)));
};
var $o_train$elm_search_input$Select$NoOp = {$: 6};
var $o_train$elm_search_input$Select$domInputId = function (label) {
	return 'elm-select-search-' + label;
};
var $o_train$elm_search_input$Select$focusSearch = function (label) {
	return A2(
		$elm$core$Task$attempt,
		$elm$core$Basics$always($o_train$elm_search_input$Select$NoOp),
		$elm$browser$Browser$Dom$focus(
			$o_train$elm_search_input$Select$domInputId(label)));
};
var $o_train$elm_search_input$Select$isSelected = F2(
	function (selected, item) {
		return _Utils_eq(
			$elm$core$Maybe$Just(item.aC),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.aC;
				},
				selected));
	});
var $o_train$elm_search_input$Select$AutocompleteLogic$changeStep = F2(
	function (dir, index) {
		var _v0 = _Utils_Tuple2(dir, index);
		if (!_v0.a) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$core$Maybe$Just(0);
			} else {
				var _v3 = _v0.a;
				var i = _v0.b.a;
				return $elm$core$Maybe$Just(i + 1);
			}
		} else {
			if (_v0.b.$ === 1) {
				var _v4 = _v0.a;
				var _v5 = _v0.b;
				return $elm$core$Maybe$Nothing;
			} else {
				var _v6 = _v0.a;
				var i = _v0.b.a;
				return $elm$core$Maybe$Just(i - 1);
			}
		}
	});
var $o_train$elm_search_input$Select$setAutocompleteIndex = F2(
	function (autocompleteIndex, model) {
		return _Utils_update(
			model,
			{av: autocompleteIndex});
	});
var $o_train$elm_search_input$Select$navigateAutocompleteIndex = F2(
	function (dir, model) {
		return A3(
			$o_train$elm_search_input$Select$flip,
			$o_train$elm_search_input$Select$setAutocompleteIndex,
			model,
			A2($o_train$elm_search_input$Select$AutocompleteLogic$changeStep, dir, model.av));
	});
var $o_train$elm_search_input$Select$returnCmd = F2(
	function (cmd, _return) {
		var m = _return.a;
		var p = _return.b;
		var c = _return.c;
		return _Utils_Tuple3(
			m,
			p,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[c, cmd])));
	});
var $o_train$elm_search_input$Select$returnParentMsg = F2(
	function (parentMsg, _return) {
		var m = _return.a;
		var c = _return.c;
		return _Utils_Tuple3(m, parentMsg, c);
	});
var $o_train$elm_search_input$Select$returnSingleton = function (model) {
	return _Utils_Tuple3(model, $o_train$elm_search_input$Select$NoChange, $elm$core$Platform$Cmd$none);
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $o_train$elm_search_input$Select$basicSearch = F2(
	function (selected, model) {
		var anyMatch = F2(
			function (description, term) {
				return A2(
					$elm$core$List$any,
					$elm$core$String$startsWith(
						$elm$core$String$toLower(term)),
					A2(
						$elm$core$String$split,
						' ',
						$elm$core$String$toLower(description)));
			});
		var matchesSearch = F2(
			function (filterString, item) {
				if (A2($o_train$elm_search_input$Select$isSelected, selected, item)) {
					return false;
				} else {
					var stringForFiltering = _List_fromArray(
						[item.ec]);
					return A2(
						$elm$core$List$all,
						anyMatch(
							A2($elm$core$String$join, ' ', stringForFiltering)),
						A2($elm$core$String$split, ' ', filterString));
				}
			});
		var items = function () {
			var _v0 = model.N;
			if (!_v0.$) {
				var filterString = _v0.a;
				return A2(
					$elm$core$List$filter,
					matchesSearch(filterString),
					model.Q);
			} else {
				return model.Q;
			}
		}();
		return _Utils_update(
			model,
			{
				iV: $krisajenkins$remotedata$RemoteData$Success(items)
			});
	});
var $o_train$elm_search_input$Select$SearchResults = function (a) {
	return {$: 5, a: a};
};
var $o_train$elm_search_input$Select$Set = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $o_train$elm_search_input$Select$makeRequest = F2(
	function (toItemFn, req) {
		return $elm$http$Http$request(
			{
				fW: req.fW,
				z: A2(
					$elm$http$Http$expectJson,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $o_train$elm_search_input$Select$Set, $o_train$elm_search_input$Select$SearchResults),
							$krisajenkins$remotedata$RemoteData$fromResult),
						$elm$core$Result$map(
							$elm$core$List$map(toItemFn))),
					req.gB),
				A: req.A,
				ei: req.ei,
				fl: $elm$core$Maybe$Nothing,
				fo: $elm$core$Maybe$Nothing,
				jR: req.jR
			});
	});
var $o_train$elm_search_input$Select$searchItems = function (model) {
	var _v0 = function () {
		var _v1 = model.eV.iM;
		switch (_v1.$) {
			case 0:
				return _Utils_Tuple2(
					A2($o_train$elm_search_input$Select$basicSearch, model.e0, model.eV),
					$elm$core$Platform$Cmd$none);
			case 1:
				var req = _v1.a;
				var updatedModel = A2($o_train$elm_search_input$Select$setSearchResults, $krisajenkins$remotedata$RemoteData$Loading, model.eV);
				return _Utils_Tuple2(
					updatedModel,
					A2(
						$o_train$elm_search_input$Select$makeRequest,
						model.cH,
						req(model.eV.N)));
			default:
				var customSearch = _v1.a;
				return customSearch(model.eV);
		}
	}();
	var search = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(
		_Utils_update(
			model,
			{eV: search}),
		$o_train$elm_search_input$Select$NoChange,
		cmd);
};
var $o_train$elm_search_input$Select$sendMsg = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $o_train$elm_search_input$Select$setAutocomplete = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		model,
		A2(
			$elm$core$Maybe$map,
			A2($o_train$elm_search_input$Select$flip, $o_train$elm_search_input$Select$setSelected, model),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$o_train$elm_search_input$Select$flip,
					$elm_community$list_extra$List$Extra$getAt,
					A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.eV.iV)),
				model.av)));
};
var $o_train$elm_search_input$Select$setMode = F2(
	function (mode, model) {
		return _Utils_update(
			model,
			{a5: mode});
	});
var $o_train$elm_search_input$Select$setClosed = function (model) {
	return A2(
		$o_train$elm_search_input$Select$setMode,
		1,
		$o_train$elm_search_input$Select$clear(model));
};
var $o_train$elm_search_input$Select$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return $o_train$elm_search_input$Select$returnSingleton(
					$o_train$elm_search_input$Select$setClosed(
						$o_train$elm_search_input$Select$setAutocomplete(model)));
			case 1:
				return $o_train$elm_search_input$Select$returnSingleton(
					$o_train$elm_search_input$Select$clear(model));
			case 2:
				switch (msg.a.$) {
					case 0:
						if (msg.a.a === 1) {
							var _v1 = msg.a.a;
							return $o_train$elm_search_input$Select$returnSingleton(
								$o_train$elm_search_input$Select$setClosed(model));
						} else {
							var _v2 = msg.a.a;
							return A2(
								$o_train$elm_search_input$Select$returnCmd,
								$o_train$elm_search_input$Select$focusSearch(model.ec),
								$o_train$elm_search_input$Select$returnSingleton(
									A2($o_train$elm_search_input$Select$setMode, 0, model)));
						}
					case 1:
						var item = msg.a.a;
						return A2(
							$o_train$elm_search_input$Select$returnParentMsg,
							$o_train$elm_search_input$Select$SelectedItem(item),
							$o_train$elm_search_input$Select$returnSingleton(
								$o_train$elm_search_input$Select$setClosed(
									A2($o_train$elm_search_input$Select$setSelected, item, model))));
					case 2:
						var item = msg.a.a;
						return $o_train$elm_search_input$Select$returnSingleton(
							_Utils_update(
								model,
								{e0: $elm$core$Maybe$Nothing}));
					case 3:
						var dir = msg.a.a;
						return $o_train$elm_search_input$Select$returnSingleton(
							A2($o_train$elm_search_input$Select$navigateAutocompleteIndex, dir, model));
					case 4:
						var terms = msg.a.a;
						var sanitisedTerms = $elm$core$String$trim(terms);
						var runnable = _Utils_cmp(
							$elm$core$String$length(sanitisedTerms),
							model.aE) > -1;
						var cmd = runnable ? $o_train$elm_search_input$Select$sendMsg(
							$o_train$elm_search_input$Select$QueueSearch(
								$Gizra$elm_debouncer$Debouncer$Basic$provideInput($o_train$elm_search_input$Select$RunSearch))) : $elm$core$Platform$Cmd$none;
						var autocompleteIndex = ($elm$core$String$length(sanitisedTerms) > 0) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing;
						return A2(
							$o_train$elm_search_input$Select$returnCmd,
							cmd,
							$o_train$elm_search_input$Select$returnSingleton(
								A2(
									$o_train$elm_search_input$Select$setAutocompleteIndex,
									autocompleteIndex,
									A3(
										$o_train$elm_search_input$Select$flip,
										$o_train$elm_search_input$Select$setSearch,
										model,
										A2(
											$o_train$elm_search_input$Select$setSearchResults,
											$krisajenkins$remotedata$RemoteData$NotAsked,
											A2(
												$o_train$elm_search_input$Select$setSearchTerms,
												$elm$core$Maybe$Just(terms),
												model.eV))))));
					case 5:
						var results = msg.a.a;
						return $o_train$elm_search_input$Select$returnSingleton(
							A3(
								$o_train$elm_search_input$Select$flip,
								$o_train$elm_search_input$Select$setSearch,
								model,
								A3(
									$o_train$elm_search_input$Select$flip,
									$o_train$elm_search_input$Select$setSearchResults,
									model.eV,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										$elm$core$List$filter(
											A2(
												$elm$core$Basics$composeL,
												$elm$core$Basics$not,
												$o_train$elm_search_input$Select$isSelected(model.e0))),
										results))));
					default:
						var filter = msg.a.a;
						return $o_train$elm_search_input$Select$returnSingleton(model);
				}
			case 4:
				var parentMsg = msg.a;
				return _Utils_Tuple3(
					model,
					$o_train$elm_search_input$Select$ParentMsg(parentMsg),
					$elm$core$Platform$Cmd$none);
			case 5:
				var subMsg = msg.a;
				var _v3 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, model.eV.c8);
				var debouncedModel = _v3.a;
				var subCmd = _v3.b;
				var emittedMsg = _v3.c;
				var updatedModel = A2($o_train$elm_search_input$Select$setDebouncer, debouncedModel, model);
				var mappedCmd = A2($elm$core$Platform$Cmd$map, $o_train$elm_search_input$Select$QueueSearch, subCmd);
				if (!emittedMsg.$) {
					var emitted = emittedMsg.a;
					var _v5 = A2($o_train$elm_search_input$Select$update, emitted, updatedModel);
					var m = _v5.a;
					var parentMsg = _v5.b;
					var c = _v5.c;
					return _Utils_Tuple3(
						m,
						parentMsg,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[c, mappedCmd])));
				} else {
					return _Utils_Tuple3(updatedModel, $o_train$elm_search_input$Select$NoChange, mappedCmd);
				}
			case 3:
				return $o_train$elm_search_input$Select$searchItems(model);
			default:
				return $o_train$elm_search_input$Select$returnSingleton(model);
		}
	});
var $author$project$Ports$FileNotes$updateContent = _Platform_outgoingPort('updateContent', $elm$core$Basics$identity);
var $author$project$Components$FileNotes$Update$updateFolderQuery = function (model) {
	var query = function () {
		var _v0 = model.E.by;
		if (_v0 === 1) {
			return A2($author$project$Components$SelectInput$Folders$searchQuery, model.co.e0, model.cq);
		} else {
			return A2($author$project$Components$SelectInput$Folders$searchQuery, $elm$core$Maybe$Nothing, model.cq);
		}
	}();
	return _Utils_update(
		model,
		{
			cn: A2($o_train$elm_search_input$Select$addSearchQuery, query, model.cn)
		});
};
var $elm$core$String$trimLeft = _String_trimLeft;
var $author$project$CoreX$String$removePrefix = F2(
	function (substring, str) {
		var trimmed = $elm$core$String$trimLeft(str);
		return A2($elm$core$String$startsWith, substring, trimmed) ? $elm$core$String$trimLeft(
			A2(
				$elm$core$String$dropLeft,
				$elm$core$String$length(substring),
				trimmed)) : trimmed;
	});
var $author$project$CoreX$String$replacePrefix = F3(
	function (substring, replacement, str) {
		var strNoPrefix = A2($author$project$CoreX$String$removePrefix, substring, str);
		return _Utils_ap(replacement, strNoPrefix);
	});
var $author$project$Components$FileNotes$Update$updateNoteContent = F3(
	function (newTemplateContent, oldTemplateContent, fileNote) {
		if (_Utils_eq(newTemplateContent, oldTemplateContent)) {
			return fileNote;
		} else {
			if ($elm_community$maybe_extra$Maybe$Extra$isNothing(oldTemplateContent)) {
				return A2(
					$elm$core$Maybe$withDefault,
					fileNote,
					A2(
						$elm$core$Maybe$map,
						function (c) {
							return _Utils_update(
								fileNote,
								{
									go: _Utils_ap(c, fileNote.go)
								});
						},
						newTemplateContent));
			} else {
				var oldContentTemp = A2($elm$core$Maybe$withDefault, '', oldTemplateContent);
				var newContentTemp = A2($elm$core$Maybe$withDefault, '', newTemplateContent);
				var newContent = A2($elm$core$String$startsWith, oldContentTemp, fileNote.go) ? A3($author$project$CoreX$String$replacePrefix, oldContentTemp, newContentTemp, fileNote.go) : newContentTemp;
				return _Utils_update(
					fileNote,
					{go: newContent});
			}
		}
	});
var $author$project$Components$FileNotes$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var filingStatus = msg.a;
				var fileNoteResource = msg.b;
				var _v1 = filingStatus.ij;
				if (_v1.$ === 1) {
					return $Fresheyeball$elm_return$Return$singleton(model);
				} else {
					var note = _v1.a;
					var m = _Utils_update(
						model,
						{
							bI: fileNoteResource,
							dH: A2($author$project$Components$FileNotes$FilingStatusLogic$setFileNote, note, model.dH)
						});
					var _v2 = function () {
						if (!fileNoteResource.$) {
							var description = fileNoteResource.b;
							var maybeMatter = fileNoteResource.c;
							var mod = $author$project$Components$FileNotes$Update$updateFolderQuery(
								_Utils_update(
									m,
									{cq: maybeMatter}));
							return A2(
								$Fresheyeball$elm_return$Return$command,
								$author$project$Utils$send(
									$author$project$Components$FileNotes$Messages$SetTitle(description)),
								$author$project$Components$FileNotes$Update$runFolderSearch(mod));
						} else {
							return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
						}
					}();
					var updatedModel = _v2.a;
					var cmd = _v2.b;
					return A2(
						$Fresheyeball$elm_return$Return$mapCmd,
						model.ew,
						A2(
							$Fresheyeball$elm_return$Return$command,
							cmd,
							A2(
								$Fresheyeball$elm_return$Return$command,
								A2(
									$elm$core$Task$attempt,
									$author$project$Components$FileNotes$Messages$FocusFailure,
									$elm$browser$Browser$Dom$focus('file-note-title')),
								A2(
									$Fresheyeball$elm_return$Return$command,
									$author$project$Ports$FileNotes$openFileNote(
										A3(
											$author$project$Components$FileNotes$Types$FileNote$encodeFileNote,
											$author$project$Components$FileNotes$Types$FilingStatus$isEditable(filingStatus),
											0,
											note)),
									$Fresheyeball$elm_return$Return$singleton(updatedModel)))));
				}
			case 1:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$FileNotes$cleanUp(0),
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Utils$send(model.ge),
						$Fresheyeball$elm_return$Return$singleton(model)));
			case 2:
				var str = msg.a;
				var oldTitle = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.jB;
					},
					model.dH.ij);
				var noteId = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.aC;
					},
					model.dH.ij);
				var isNewStringEmpty = $elm$core$String$isEmpty(
					$elm$core$String$trim(str));
				var hasChangedContent = model.dH.dU;
				var shouldUpdateContent = (!_Utils_eq(
					$elm$core$Maybe$Just(str),
					oldTitle)) && ($elm_community$maybe_extra$Maybe$Extra$isNothing(noteId) && ((!isNewStringEmpty) && (!hasChangedContent)));
				var cmd = shouldUpdateContent ? $author$project$Components$FileNotes$Requests$getTemplateContent : $elm$core$Basics$always($elm$core$Platform$Cmd$none);
				return A2(
					$Fresheyeball$elm_return$Return$effect_,
					cmd,
					$Fresheyeball$elm_return$Return$singleton(
						A3(
							$author$project$CoreX$Basics$flip,
							$author$project$Components$FileNotes$FilingStatusLogic$setFilingStatus,
							model,
							A2(
								$author$project$Components$FileNotes$FilingStatusLogic$setFileNoteField,
								$author$project$Components$FileNotes$FilingStatusLogic$setTitle(str),
								model.dH))));
			case 4:
				var subMsg = msg.a;
				var _v4 = A2($o_train$elm_search_input$Select$update, subMsg, model.co);
				var selectInputModel = _v4.a;
				var selectCmd = _v4.c;
				return A2(
					$Fresheyeball$elm_return$Return$mapCmd,
					model.ew,
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$FileNotes$Messages$SelectLibraryMessage, selectCmd),
						A2(
							$Fresheyeball$elm_return$Return$map,
							$author$project$Components$FileNotes$Update$updateFolderQuery,
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{co: selectInputModel})))));
			case 6:
				var subMsg = msg.a;
				var _v5 = A2($o_train$elm_search_input$Select$update, subMsg, model.e$);
				var selectInputModel = _v5.a;
				var selected = _v5.b;
				var selectCmd = _v5.c;
				var hasChanged = function () {
					if (!selected.$) {
						var item = selected.a;
						return !_Utils_eq(
							$elm$core$Maybe$Just(item),
							model.e$.e0);
					} else {
						return false;
					}
				}();
				var cmd = hasChanged ? $author$project$Components$FileNotes$Requests$getTemplateContent : $elm$core$Basics$always($elm$core$Platform$Cmd$none);
				return A2(
					$Fresheyeball$elm_return$Return$effect_,
					cmd,
					A2(
						$Fresheyeball$elm_return$Return$mapCmd,
						model.ew,
						A2(
							$Fresheyeball$elm_return$Return$mapCmd,
							$author$project$Components$FileNotes$Messages$SelectTemplateMessage,
							A2(
								$Fresheyeball$elm_return$Return$command,
								selectCmd,
								$Fresheyeball$elm_return$Return$singleton(
									_Utils_update(
										model,
										{e$: selectInputModel}))))));
			case 5:
				var subMsg = msg.a;
				var runSearchCmd = function () {
					if (((subMsg.$ === 2) && (!subMsg.a.$)) && (!subMsg.a.a)) {
						var _v11 = subMsg.a.a;
						return $author$project$Utils$send($o_train$elm_search_input$Select$RunSearch);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v7 = A2($o_train$elm_search_input$Select$update, subMsg, model.cn);
				var selectInputModel = _v7.a;
				var selectedMsg = _v7.b;
				var selectCmd = _v7.c;
				var updatedModel = function () {
					var _v9 = _Utils_Tuple2(selectInputModel.eV.iV, selectInputModel.eV.iM);
					if (_v9.a.$ === 3) {
						var results = _v9.a.a;
						var addSelected = function (mod) {
							return A2(
								$elm$core$Maybe$withDefault,
								mod,
								A2(
									$elm$core$Maybe$map,
									function (h) {
										return A2($o_train$elm_search_input$Select$addSelectedItem, h, mod);
									},
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.aa;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.b2;
												},
												A2(
													$elm$core$Basics$composeR,
													$elm$core$String$toLower,
													$elm$core$String$contains('note')))),
										results)));
						};
						return addSelected(
							A2(
								$o_train$elm_search_input$Select$addSearchQuery,
								$o_train$elm_search_input$Select$BasicQuery,
								A2($o_train$elm_search_input$Select$addItems, results, selectInputModel)));
					} else {
						return selectInputModel;
					}
				}();
				var focusCmd = function () {
					if (!selectedMsg.$) {
						return $author$project$Ports$FileNotes$focus(0);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$mapCmd,
					model.ew,
					A2(
						$Fresheyeball$elm_return$Return$command,
						focusCmd,
						A2(
							$Fresheyeball$elm_return$Return$mapCmd,
							$author$project$Components$FileNotes$Messages$SelectFolderMessage,
							A2(
								$Fresheyeball$elm_return$Return$command,
								runSearchCmd,
								A2(
									$Fresheyeball$elm_return$Return$command,
									selectCmd,
									$Fresheyeball$elm_return$Return$singleton(
										_Utils_update(
											model,
											{cn: updatedModel})))))));
			case 7:
				var subMsg = msg.a;
				var _v12 = A4($author$project$Components$MatterInput$Update$update, subMsg, model.eg, model.eg.iP, 'file-note-matter-selection');
				var newMatterInput = _v12.a;
				var matterSelection = _v12.b;
				var subCmd = _v12.c;
				var _v13 = function () {
					switch (matterSelection.$) {
						case 1:
							var m = matterSelection.a;
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(m),
								$author$project$Components$FileNotes$Update$runFolderSearch);
						case 3:
							return _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								function (mod) {
									return _Utils_Tuple2(mod, $elm$core$Platform$Cmd$none);
								});
						default:
							return _Utils_Tuple2(
								model.cq,
								function (mod) {
									return _Utils_Tuple2(mod, $elm$core$Platform$Cmd$none);
								});
					}
				}();
				var selectedMatter = _v13.a;
				var cmdFn = _v13.b;
				return A2(
					$Fresheyeball$elm_return$Return$mapCmd,
					model.ew,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						cmdFn,
						A2(
							$Fresheyeball$elm_return$Return$mapCmd,
							$author$project$Components$FileNotes$Messages$MatterInputMessage,
							A2(
								$Fresheyeball$elm_return$Return$command,
								subCmd,
								A2(
									$Fresheyeball$elm_return$Return$map,
									$author$project$Components$FileNotes$Update$updateFolderQuery,
									$Fresheyeball$elm_return$Return$singleton(
										_Utils_update(
											model,
											{eg: newMatterInput, cq: selectedMatter})))))));
			case 10:
				if (!msg.a.$) {
					var _v15 = msg.a.a;
					var templateContent = _v15.b;
					var updatedFilingStatus = A2(
						$elm$core$Maybe$withDefault,
						model.dH,
						A2(
							$elm$core$Maybe$map,
							A2($author$project$CoreX$Basics$flip, $author$project$Components$FileNotes$FilingStatusLogic$setFileNote, model.dH),
							A2(
								$elm$core$Maybe$map,
								A2($author$project$Components$FileNotes$Update$updateNoteContent, templateContent, model.fj),
								model.dH.ij)));
					var cmd = _Utils_eq(model.dH, updatedFilingStatus) ? $elm$core$Platform$Cmd$none : A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								A2(
									$author$project$Components$FileNotes$Types$FileNote$encodeFileNote,
									$author$project$Components$FileNotes$Types$FilingStatus$isEditable(updatedFilingStatus),
									0),
								$author$project$Ports$FileNotes$updateContent),
							updatedFilingStatus.ij));
					return A2(
						$Fresheyeball$elm_return$Return$mapCmd,
						model.ew,
						A2(
							$Fresheyeball$elm_return$Return$command,
							cmd,
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{dH: updatedFilingStatus, fj: templateContent}))));
				} else {
					var response = msg.a.a;
					var errorMsg = function () {
						if (response.$ === 4) {
							var str = response.c;
							return str;
						} else {
							return 'An error occurred';
						}
					}();
					return $Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								dH: A2($author$project$Components$FileNotes$FilingStatusLogic$setFailed, errorMsg, model.dH)
							}));
				}
			case 3:
				var savedFileNote = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					A3(
						$author$project$CoreX$Basics$flip,
						$author$project$Components$FileNotes$FilingStatusLogic$setFilingStatus,
						model,
						A2(
							$author$project$Components$FileNotes$FilingStatusLogic$setFileNoteField,
							$author$project$Components$FileNotes$FilingStatusLogic$setContent(savedFileNote.go),
							model.dH)));
			case 8:
				var _v17 = function () {
					var _v18 = _Utils_Tuple2(model.dH.ij, model.bI);
					if (!_v18.a.$) {
						if (_v18.b.$ === 1) {
							var note = _v18.a.a;
							var _v19 = _v18.b;
							return A2(
								$Fresheyeball$elm_return$Return$return,
								model,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										function (m) {
											return A3($author$project$Components$FileNotes$Requests$fileNoteToMatter, m.aC, note, model);
										},
										model.cq)));
						} else {
							var note = _v18.a.a;
							var _v20 = _v18.b;
							var id = _v20.a;
							return A2(
								$Fresheyeball$elm_return$Return$return,
								model,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										function (m) {
											return A4($author$project$Components$FileNotes$Requests$fileNote, id, m.aC, note, model);
										},
										model.cq)));
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									dH: A2($author$project$Components$FileNotes$FilingStatusLogic$setFailed, 'File Note is incomplete.', model.dH)
								}),
							$elm$core$Platform$Cmd$none);
					}
				}();
				var updatedModel = _v17.a;
				var cmd = _v17.b;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					cmd,
					$Fresheyeball$elm_return$Return$singleton(updatedModel));
			case 9:
				if (!msg.a.$) {
					var _v21 = msg.a.a;
					var filingStatus = _v21.b;
					return A2(
						$Fresheyeball$elm_return$Return$mapCmd,
						model.ew,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{dH: filingStatus})));
				} else {
					var response = msg.a.a;
					var errorMsg = function () {
						if (response.$ === 4) {
							var str = response.c;
							return str;
						} else {
							return 'An error occurred';
						}
					}();
					return $Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								dH: A2($author$project$Components$FileNotes$FilingStatusLogic$setFailed, errorMsg, model.dH)
							}));
				}
			case 12:
				var errorMsg = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							dH: A2($author$project$Components$FileNotes$FilingStatusLogic$setFailed, errorMsg, model.dH)
						}));
			case 11:
				return $Fresheyeball$elm_return$Return$singleton(model);
			case 13:
				var newFilingStatus = msg.a;
				var updateModel = function (isEqual) {
					return isEqual ? _Utils_update(
						model,
						{dH: newFilingStatus}) : model;
				};
				var newModel = A2(
					$elm$core$Maybe$withDefault,
					model,
					A2(
						$elm$core$Maybe$map,
						updateModel,
						A3($elm$core$Maybe$map2, $elm$core$Basics$eq, model.dH.aC, newFilingStatus.aC)));
				return $Fresheyeball$elm_return$Return$singleton(newModel);
			case 14:
				var changed = msg.a;
				var filingStatus = model.dH;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							dH: _Utils_update(
								filingStatus,
								{dU: changed})
						}));
			case 15:
				var n = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							jP: A2($elm$core$Basics$max, 0, n)
						}));
			default:
				return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$Components$HelpDesk$Model$Failure = 3;
var $author$project$Components$Header$Messages$FocusFailure = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$HelpDesk$Messages$SetSubmissionState = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$HelpDesk$Model$Success = 2;
var $author$project$Components$HelpDesk$Requests$ticketAttrs = function (helpDesk) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(helpDesk.b2)),
			_Utils_Tuple2(
			'email',
			$elm$json$Json$Encode$string(helpDesk.dl)),
			_Utils_Tuple2(
			'subject',
			$elm$json$Json$Encode$string(helpDesk.cB)),
			_Utils_Tuple2(
			'description',
			$elm$json$Json$Encode$string(helpDesk.dd))
		]);
};
var $author$project$Components$HelpDesk$Requests$newTicketObject = function (helpDesk) {
	return $elm$json$Json$Encode$object(
		$author$project$Components$HelpDesk$Requests$ticketAttrs(helpDesk));
};
var $author$project$Components$Header$Messages$CreateSupportTicketResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HelpDesk$Requests$postTicket = F2(
	function (csrfToken, ticketObject) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('ticket', ticketObject)
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$Components$Header$Messages$CreateSupportTicketResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: '/api/support/tickets'
			});
	});
var $author$project$Components$HelpDesk$Requests$createTicketRequest = F2(
	function (csrfToken, helpDesk) {
		return A2(
			$author$project$Components$HelpDesk$Requests$postTicket,
			csrfToken,
			$author$project$Components$HelpDesk$Requests$newTicketObject(helpDesk));
	});
var $author$project$Components$Header$Messages$QueueAllPostableFeesForMatterResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Header$Update$queueAllPostableFeesForMatter = function (csrfToken) {
	return $author$project$Requests$post(
		{
			fW: $elm$http$Http$emptyBody,
			z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$Components$Header$Messages$QueueAllPostableFeesForMatterResponse),
			A: _List_fromArray(
				[
					A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
				]),
			jR: 'api/fees/batch_post_all_postable_fees'
		});
};
var $author$project$Components$Header$Update$setHelpDesk = F2(
	function (model, helpdesk) {
		return _Utils_update(
			model,
			{dW: helpdesk});
	});
var $author$project$Components$HelpDesk$Model$PendingResponse = 1;
var $author$project$Components$HelpDesk$Model$Open = 0;
var $author$project$Components$HelpDesk$Model$initialiseWithUser = function (user) {
	return {dd: '', dl: user.gL, b2: user.b2, cB: '', cC: 0, cF: false, cJ: 0};
};
var $author$project$Components$HelpDesk$Update$validateTicket = function (model) {
	return (model.b2 !== '') && ((model.dl !== '') && (model.cB !== ''));
};
var $author$project$Components$HelpDesk$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var user = msg.a;
				return $author$project$Components$HelpDesk$Model$initialiseWithUser(user);
			case 1:
				return $author$project$Components$HelpDesk$Model$emptyHelpDesk;
			case 2:
				var name = msg.a;
				return _Utils_update(
					model,
					{
						b2: name,
						cF: $author$project$Components$HelpDesk$Update$validateTicket(
							_Utils_update(
								model,
								{b2: name}))
					});
			case 3:
				var email = msg.a;
				return _Utils_update(
					model,
					{
						dl: email,
						cF: $author$project$Components$HelpDesk$Update$validateTicket(
							_Utils_update(
								model,
								{dl: email}))
					});
			case 4:
				var subject = msg.a;
				return _Utils_update(
					model,
					{
						cB: subject,
						cF: $author$project$Components$HelpDesk$Update$validateTicket(
							_Utils_update(
								model,
								{cB: subject}))
					});
			case 5:
				var desc = msg.a;
				return _Utils_update(
					model,
					{dd: desc});
			case 6:
				var submissionState = msg.a;
				return _Utils_update(
					model,
					{cC: submissionState});
			default:
				return _Utils_update(
					model,
					{cC: 1});
		}
	});
var $author$project$Components$Header$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{eo: false}));
			case 3:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2(
						$elm$core$Task$attempt,
						$author$project$Components$Header$Messages$FocusFailure,
						$elm$browser$Browser$Dom$focus('top-hamburger-menu')),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{eo: true})));
			case 4:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2(
						$elm$core$Task$attempt,
						$author$project$Components$Header$Messages$FocusFailure,
						$elm$browser$Browser$Dom$focus('top-help-menu')),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{dX: true})));
			case 5:
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{dX: false}));
			case 1:
				var subMsg = msg.a;
				var updatedHelpDesk = A2($author$project$Components$HelpDesk$Update$update, subMsg, model.dW);
				return A2(
					$Fresheyeball$elm_return$Return$map,
					$author$project$Components$Header$Update$setHelpDesk(model),
					function () {
						if (subMsg.$ === 7) {
							return $Fresheyeball$elm_return$Return$command(
								A2($author$project$Components$HelpDesk$Requests$createTicketRequest, model.gr, model.dW));
						} else {
							return $elm$core$Basics$identity;
						}
					}()(
						$Fresheyeball$elm_return$Return$singleton(updatedHelpDesk)));
			case 2:
				var res = msg.a;
				var updatedHelpDesk = function () {
					if (!res.$) {
						return A2(
							$author$project$Components$HelpDesk$Update$update,
							$author$project$Components$HelpDesk$Messages$SetSubmissionState(2),
							model.dW);
					} else {
						return A2(
							$author$project$Components$HelpDesk$Update$update,
							$author$project$Components$HelpDesk$Messages$SetSubmissionState(3),
							model.dW);
					}
				}();
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{dW: updatedHelpDesk}));
			case 6:
				return A2(
					$Fresheyeball$elm_return$Return$return,
					_Utils_update(
						model,
						{eo: false}),
					$author$project$Components$Header$Update$queueAllPostableFeesForMatter(model.gr));
			case 7:
				return $Fresheyeball$elm_return$Return$singleton(model);
			default:
				return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$Components$Notifications$Messages$AcknowledgeNotificationResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Notifications$Data$decodeAcknowledgedResponse = A2($elm$json$Json$Decode$field, 'notificationId', $elm$json$Json$Decode$int);
var $author$project$Components$Notifications$Requests$acknowledgeNotification = F2(
	function (csrfToken, id) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$Components$Notifications$Messages$AcknowledgeNotificationResponse, $author$project$Components$Notifications$Data$decodeAcknowledgedResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: '/api/notifications/' + ($elm$core$String$fromInt(id) + '/acknowledgements')
			});
	});
var $author$project$Components$Notifications$Update$updateNotificationsInData = F2(
	function (notifications, data) {
		return _Utils_update(
			data,
			{$9: notifications});
	});
var $author$project$Components$Notifications$Update$removeNotification = F2(
	function (id, data) {
		var updatedNotifications = A2(
			$elm$core$List$filter,
			function (n) {
				return !_Utils_eq(n.aC, id);
			},
			data.$9);
		return A2($author$project$Components$Notifications$Update$updateNotificationsInData, updatedNotifications, data);
	});
var $author$project$Components$Notifications$Update$updateAcknowledgedIdsInData = F2(
	function (ids, data) {
		return _Utils_update(
			data,
			{fB: ids});
	});
var $author$project$Components$Notifications$Update$addNotification = F2(
	function (newNotification, data) {
		var updatedNotifications = A2($elm$core$List$cons, newNotification, data.$9);
		return A2($author$project$Components$Notifications$Update$updateNotificationsInData, updatedNotifications, data);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Components$Notifications$Update$updateNotificationUnlessAcknowledged = F2(
	function (data, notification) {
		return A2(
			$elm$core$Maybe$withDefault,
			data,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Components$Notifications$Update$addNotification(notification),
						$author$project$Components$Notifications$Update$removeNotification(notification.aC)),
					$elm$core$Basics$always(data)),
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.aC;
						},
						$elm$core$Basics$eq(notification.aC)),
					data.$9)));
	});
var $author$project$Components$Notifications$Update$updateNotificationData = F2(
	function (receivedNotification, notificationsData) {
		var acknowledgedIds = notificationsData.fB;
		var notification = receivedNotification.il;
		var hasAcknowledged = A2($elm$core$Set$member, notification.aC, acknowledgedIds);
		var _v0 = receivedNotification.fC;
		switch (_v0) {
			case 0:
				return hasAcknowledged ? notificationsData : A2($author$project$Components$Notifications$Update$addNotification, notification, notificationsData);
			case 2:
				return A2($author$project$Components$Notifications$Update$removeNotification, notification.aC, notificationsData);
			case 1:
				return hasAcknowledged ? notificationsData : A2($author$project$Components$Notifications$Update$updateNotificationUnlessAcknowledged, notificationsData, notification);
			default:
				return notificationsData;
		}
	});
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Components$Notifications$Update$updateNotifcationInDataByAction = F3(
	function (f, notification, data) {
		var currentSlideIdx = notification.gv;
		return A3(
			$author$project$CoreX$Basics$flip,
			$author$project$Components$Notifications$Update$updateNotificationsInData,
			data,
			A3(
				$elm_community$list_extra$List$Extra$updateIf,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aC;
					},
					$elm$core$Basics$eq(notification.aC)),
				$elm$core$Basics$always(
					_Utils_update(
						notification,
						{
							gv: f(currentSlideIdx)
						})),
				data.$9));
	});
var $author$project$Components$Notifications$Update$updateNotificationDataByAction = F3(
	function (action, notification, data) {
		if (action === 1) {
			return A3(
				$author$project$Components$Notifications$Update$updateNotifcationInDataByAction,
				A2($author$project$CoreX$Basics$flip, $elm$core$Basics$sub, 1),
				notification,
				data);
		} else {
			return A3(
				$author$project$Components$Notifications$Update$updateNotifcationInDataByAction,
				$elm$core$Basics$add(1),
				notification,
				data);
		}
	});
var $author$project$Components$Notifications$Update$update = F2(
	function (msg, model) {
		_v0$6:
		while (true) {
			switch (msg.$) {
				case 0:
					var receivedNotification = msg.a;
					var updatedNotificationData = A2(
						$krisajenkins$remotedata$RemoteData$map,
						$author$project$Components$Notifications$Update$updateNotificationData(receivedNotification),
						model.im);
					return $Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{im: updatedNotificationData}));
				case 2:
					var id = msg.a;
					return A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$Components$Notifications$Requests$acknowledgeNotification, model.gr, id),
						$Fresheyeball$elm_return$Return$singleton(model));
				case 3:
					if (!msg.a.$) {
						var _v1 = msg.a.a;
						var id = _v1.b;
						var removeNotificationAndUpdateAckIds = function (notificationsData) {
							return A2(
								$author$project$Components$Notifications$Update$updateAcknowledgedIdsInData,
								A2($elm$core$Set$insert, id, notificationsData.fB),
								A2($author$project$Components$Notifications$Update$removeNotification, id, notificationsData));
						};
						var updatedNotificationData = A2($krisajenkins$remotedata$RemoteData$map, removeNotificationAndUpdateAckIds, model.im);
						return $Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{im: updatedNotificationData}));
					} else {
						break _v0$6;
					}
				case 1:
					if (!msg.a.$) {
						var notificationsData = msg.a.a;
						return $Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									im: $krisajenkins$remotedata$RemoteData$succeed(notificationsData)
								}));
					} else {
						var response = msg.a.a;
						return $Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									im: $krisajenkins$remotedata$RemoteData$Failure(response)
								}));
					}
				case 4:
					var action = msg.a;
					var notification = msg.b;
					var updatedNotificationData = A2(
						$krisajenkins$remotedata$RemoteData$map,
						A2($author$project$Components$Notifications$Update$updateNotificationDataByAction, action, notification),
						model.im);
					return $Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{im: updatedNotificationData}));
				default:
					break _v0$6;
			}
		}
		return $Fresheyeball$elm_return$Return$singleton(model);
	});
var $author$project$TimesheetPage$Messages$AdjustTimeZone = function (a) {
	return {$: 99, a: a};
};
var $author$project$Page$Header = {$: 1};
var $author$project$CoreX$Appendable$andAppendIf = F3(
	function (pred, addition, base) {
		return pred ? _Utils_ap(base, addition) : base;
	});
var $author$project$Components$Notifications$Messages$FetchedNotificationResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Notifications$Data$NotificationData = F2(
	function (acknowledgedIds, notifications) {
		return {fB: acknowledgedIds, $9: notifications};
	});
var $author$project$Components$Notifications$Data$decodeAcknowledgeIds = A2(
	$elm$json$Json$Decode$andThen,
	function (list) {
		return $elm$json$Json$Decode$succeed(
			$elm$core$Set$fromList(list));
	},
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int));
var $author$project$Components$Notifications$Data$decodeNotifications = $elm$json$Json$Decode$list($author$project$Components$Notifications$Data$decodeNotification);
var $author$project$Components$Notifications$Data$decodeNotificationData = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'notifications',
	$author$project$Components$Notifications$Data$decodeNotifications,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'acknowledgedIds',
		$author$project$Components$Notifications$Data$decodeAcknowledgeIds,
		$elm$json$Json$Decode$succeed($author$project$Components$Notifications$Data$NotificationData)));
var $author$project$Components$Notifications$Requests$fetchNotifications = $elm$http$Http$get(
	{
		z: A2($elm$http$Http$expectJson, $author$project$Components$Notifications$Messages$FetchedNotificationResponse, $author$project$Components$Notifications$Data$decodeNotificationData),
		jR: '/api/notifications'
	});
var $author$project$Initialisation$Update$fetchActiveNotifications = A2($elm$core$Platform$Cmd$map, $author$project$Messages$NotificationMsg, $author$project$Components$Notifications$Requests$fetchNotifications);
var $author$project$TimesheetPage$Messages$FetchedRates = function (a) {
	return {$: 47, a: a};
};
var $author$project$Model$ActionStep$Rate$decodeRateLabelAndValues = $elm$json$Json$Decode$list($author$project$Model$ActionStep$Rate$decodeRateLabelAndValue);
var $author$project$Timesheet$Requests$fetchRates = $elm$http$Http$get(
	{
		z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$TimesheetPage$Messages$FetchedRates, $author$project$Model$ActionStep$Rate$decodeRateLabelAndValues),
		jR: 'api/rates'
	});
var $elm$time$Time$here = _Time_here(0);
var $author$project$Ports$Helpdesk$splitNames = function (names) {
	var _v0 = A2($elm$core$String$split, ' ', names);
	if (!_v0.b) {
		return _Utils_Tuple2('Unknown', '');
	} else {
		if (!_v0.b.b) {
			var name = _v0.a;
			return _Utils_Tuple2(name, '');
		} else {
			var name = _v0.a;
			var rest = _v0.b;
			return _Utils_Tuple2(
				name,
				A2($elm$core$String$join, ' ', rest));
		}
	}
};
var $author$project$Ports$Helpdesk$encode = function (user) {
	var _v0 = $author$project$Ports$Helpdesk$splitNames(user.b2);
	var firstName = _v0.a;
	var surname = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(user.aC)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(user.gL)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(user.b2)),
				_Utils_Tuple2(
				'organisationId',
				$elm$json$Json$Encode$int(user.ix)),
				_Utils_Tuple2(
				'organisationName',
				$elm$json$Json$Encode$string(user.iy)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(firstName)),
				_Utils_Tuple2(
				'surname',
				$elm$json$Json$Encode$string(surname))
			]));
};
var $author$project$Ports$Helpdesk$initHelpdesk = _Platform_outgoingPort('initHelpdesk', $elm$core$Basics$identity);
var $author$project$Ports$Helpdesk$initialise = function (user) {
	return $author$project$Ports$Helpdesk$initHelpdesk(
		$author$project$Ports$Helpdesk$encode(user));
};
var $author$project$Ports$Analytics$encode = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(user.aC)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(user.gL)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(user.b2)),
				_Utils_Tuple2(
				'signInCount',
				$elm$json$Json$Encode$int(user.i9)),
				_Utils_Tuple2(
				'organisationId',
				$elm$json$Json$Encode$int(user.ix)),
				_Utils_Tuple2(
				'organisationName',
				$elm$json$Json$Encode$string(user.iy)),
				_Utils_Tuple2(
				'insertedAt',
				$elm$json$Json$Encode$string(user.d4)),
				_Utils_Tuple2(
				'currentSignInAt',
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map($elm$json$Json$Encode$string),
					$elm$core$Maybe$withDefault($elm$json$Json$Encode$null))(user.gu))
			]));
};
var $author$project$Ports$Analytics$setUpAnalytics = _Platform_outgoingPort('setUpAnalytics', $elm$core$Basics$identity);
var $author$project$Ports$Analytics$setUp = function (user) {
	return $author$project$Ports$Analytics$setUpAnalytics(
		$author$project$Ports$Analytics$encode(user));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$User$Data$pmsToString = function (pms) {
	switch (pms) {
		case 3:
			return 'FileProWithScale';
		case 2:
			return 'FilePro';
		case 1:
			return 'ActionStep';
		case 0:
			return 'Affinity';
		case 5:
			return 'Aderant';
		case 4:
			return 'Nebulaw';
		case 6:
			return 'Clio';
		default:
			return 'Toca';
	}
};
var $author$project$Ports$Websockets$encode = function (user) {
	var connectorIds = A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, user.gi);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(user.aC)),
				_Utils_Tuple2(
				'token',
				$elm$json$Json$Encode$string(user.jI)),
				_Utils_Tuple2(
				'organisationId',
				$elm$json$Json$Encode$int(user.ix)),
				_Utils_Tuple2('connectorIds', connectorIds),
				_Utils_Tuple2(
				'pms',
				$elm$json$Json$Encode$string(
					$author$project$User$Data$pmsToString(user.ce)))
			]));
};
var $author$project$Ports$Websockets$setUpWebsockets = _Platform_outgoingPort('setUpWebsockets', $elm$core$Basics$identity);
var $author$project$Ports$Websockets$setUp = function (user) {
	return $author$project$Ports$Websockets$setUpWebsockets(
		$author$project$Ports$Websockets$encode(user));
};
var $author$project$Ports$TourTriggers$startManualFeeTourPort = _Platform_outgoingPort(
	'startManualFeeTourPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$TourTriggers$startManualFeeTour = function (_v0) {
	var hasCompletedManualFeeTour = _v0.hj;
	return (!hasCompletedManualFeeTour) ? $author$project$Ports$TourTriggers$startManualFeeTourPort(0) : $elm$core$Platform$Cmd$none;
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Ports$PageTitle$setPageTitle = _Platform_outgoingPort('setPageTitle', $elm$json$Json$Encode$string);
var $author$project$Ports$PageTitle$updateTitle = function (count) {
	return (count > 0) ? $author$project$Ports$PageTitle$setPageTitle(
		'Time Entries ' + ('(' + ($elm$core$String$fromInt(count) + ') - mitimes'))) : $author$project$Ports$PageTitle$setPageTitle('mitimes');
};
var $author$project$Ports$PageTitle$updatePageTitle = function (model) {
	return $author$project$Ports$PageTitle$updateTitle(
		$elm$core$Set$size(model.g$.dI.d$));
};
var $author$project$Initialisation$Update$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			if (!msg.a.$) {
				var _v1 = msg.a.a;
				var contextualModel = _v1.b;
				var user = contextualModel.a6.jS;
				var hasCompletedTours = user.cI.hj && user.cI.hi;
				var cmds = $elm$core$Platform$Cmd$batch(
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						hasCompletedTours,
						_List_fromArray(
							[$author$project$Initialisation$Update$fetchActiveNotifications]),
						_List_fromArray(
							[
								$author$project$Ports$Analytics$setUp(user),
								$author$project$Ports$Helpdesk$initialise(user),
								$author$project$Ports$Websockets$setUp(user),
								$author$project$Ports$PageTitle$updatePageTitle(contextualModel.a6),
								$author$project$Ports$TourTriggers$startManualFeeTour(user.cI),
								A2(
								$elm$core$Task$perform,
								A2($elm$core$Basics$composeL, $author$project$Messages$PageMsg, $author$project$TimesheetPage$Messages$AdjustTimeZone),
								$elm$time$Time$here),
								A2($elm$core$Platform$Cmd$map, $author$project$Messages$PageMsg, $author$project$Timesheet$Requests$fetchRates)
							])));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hl: A2($author$project$Components$Header$Data$defaultHeader, model.gr, model.c5),
							iC: $author$project$Page$Timesheet(contextualModel),
							jS: $krisajenkins$remotedata$RemoteData$Success(user)
						}),
					cmds);
			} else {
				var error = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iC: A2(
								$author$project$Page$SessionError,
								'Please refresh this page',
								$author$project$ErrorLogic$getMessage(error))
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			if (!msg.a.$) {
				var _v2 = msg.a.a;
				var user = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hl: A2($author$project$Components$Header$Data$defaultHeader, model.gr, model.c5),
							iC: $author$project$Page$Header,
							jS: $krisajenkins$remotedata$RemoteData$Success(user)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Analytics$setUp(user),
								$author$project$Ports$Helpdesk$initialise(user),
								$author$project$Ports$Websockets$setUp(user),
								$author$project$Initialisation$Update$fetchActiveNotifications
							])));
			} else {
				var error = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iC: A2(
								$author$project$Page$SessionError,
								'Please refresh this page',
								$author$project$ErrorLogic$getMessage(error))
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$TimesheetPage$Update$getCurrentRataDieCommand = A2($elm$core$Task$perform, $author$project$TimesheetPage$Messages$ReceiveCurrentRataDie, $elm$time$Time$now);
var $author$project$Ports$EventTracking$CompletedTourEvent = function (a) {
	return {$: 8, a: a};
};
var $author$project$TimesheetPage$Messages$Consolidate = function (a) {
	return {$: 43, a: a};
};
var $author$project$Activities$Messages$DeleteActivities = function (a) {
	return {$: 19, a: a};
};
var $author$project$TimesheetPage$Messages$DeleteFees = function (a) {
	return {$: 15, a: a};
};
var $author$project$TimesheetPage$Messages$FeeFormEdit = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Tours$FeeGroupingAcknowledgement = 2;
var $author$project$Components$Modal$Model$FileNotes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$EventTracking$FilterEvent = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ports$EventTracking$FilterPostedEvent = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ports$EventTracking$GroupByEvent = function (a) {
	return {$: 12, a: a};
};
var $author$project$PagedLoadingStatus$IsLoading = 0;
var $author$project$Components$UiInfoAlerts$Data$Merging = 1;
var $author$project$Tours$MergingAcknowledgement = 3;
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $author$project$TimesheetPage$Messages$ModalAction = function (a) {
	return {$: 92, a: a};
};
var $author$project$Model$Fee$Merge$NotRequired = 1;
var $author$project$Components$MergeFees$Model$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$TimesheetPage$Messages$QueueDeleteFees = function (a) {
	return {$: 64, a: a};
};
var $author$project$TimesheetPage$Messages$QueueSearchFees = function (a) {
	return {$: 63, a: a};
};
var $author$project$SearchState$SearchOpen = 0;
var $author$project$Activities$Messages$SetActivityFeedMode = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$ContactModal$Messages$SetConflictingContact = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$SplitFee$Messages$SplitChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$TimesheetPage$Messages$SplitFee = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Modal$Model$SplitFeeModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$FeeEntry$Messages$StartPostedEdit = {$: 37};
var $author$project$Components$Modal$Model$UiInfoAlertModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$TimesheetPage$Messages$ActivateTrackActivitiesResponse = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Activities$Requests$activateTrackActivities = F2(
	function (csrfToken, activityTourCompleted) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$ActivateTrackActivitiesResponse(activityTourCompleted)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/user_settings/track_activities'
			});
	});
var $author$project$User$UserLogic$activateTrackActivities = function (user) {
	return _Utils_update(
		user,
		{jL: true});
};
var $author$project$TimesheetPage$Data$activateTrackActivities = function (model) {
	return _Utils_update(
		model,
		{
			jS: $author$project$User$UserLogic$activateTrackActivities(model.jS)
		});
};
var $author$project$TimesheetPage$Update$activityFeedCommand = function (subMsg) {
	return $author$project$Utils$send(
		$author$project$TimesheetPage$Messages$ActivityFeedComponent(subMsg));
};
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mgold$elm_nonempty_list$List$Nonempty$fromList = function (ys) {
	if (ys.b) {
		var x = ys.a;
		var xs = ys.b;
		return $elm$core$Maybe$Just(
			A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_sorter_experiment$Sort$toOrder = F3(
	function (_v0, first, second) {
		var sort = _v0;
		return A2(sort, first, second);
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (!dict.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var sorter = dict.a;
				var key = dict.c;
				var value = dict.d;
				var left = dict.e;
				var right = dict.f;
				var _v1 = A3($rtfeldman$elm_sorter_experiment$Sort$toOrder, sorter, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 2:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					default:
						return $elm$core$Maybe$Just(value);
				}
			}
		}
	});
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $author$project$CoreX$RataDie$fromPosix = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix));
	});
var $author$project$Timesheet$FeeLogic$getRataDie = F2(
	function (zone, fee) {
		return A2($author$project$CoreX$RataDie$fromPosix, zone, fee.b7);
	});
var $rtfeldman$elm_sorter_experiment$Internal$Dict$Black = 0;
var $rtfeldman$elm_sorter_experiment$Internal$Dict$Node = F6(
	function (a, b, c, d, e, f) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $rtfeldman$elm_sorter_experiment$Internal$Dict$Red = 1;
var $rtfeldman$elm_sorter_experiment$Sort$Dict$balance = F6(
	function (sorter, color, key, value, left, right) {
		if ((right.$ === 1) && (right.b === 1)) {
			var _v1 = right.b;
			var rK = right.c;
			var rV = right.d;
			var rLeft = right.e;
			var rRight = right.f;
			if ((left.$ === 1) && (left.b === 1)) {
				var _v3 = left.b;
				var lK = left.c;
				var lV = left.d;
				var lLeft = left.e;
				var lRight = left.f;
				return A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					1,
					key,
					value,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, lK, lV, lLeft, lRight),
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, rK, rV, rLeft, rRight));
			} else {
				return A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					color,
					rK,
					rV,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 1) && (left.b === 1)) && (left.e.$ === 1)) && (left.e.b === 1)) {
				var _v5 = left.b;
				var lK = left.c;
				var lV = left.d;
				var _v6 = left.e;
				var _v7 = _v6.b;
				var llK = _v6.c;
				var llV = _v6.d;
				var llLeft = _v6.e;
				var llRight = _v6.f;
				var lRight = left.f;
				return A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					1,
					lK,
					lV,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, llK, llV, llLeft, llRight),
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, key, value, lRight, right));
			} else {
				return A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, color, key, value, left, right);
			}
		}
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (!dict.$) {
			var sorter = dict.a;
			return A6(
				$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
				sorter,
				1,
				key,
				value,
				$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter),
				$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter));
		} else {
			var sorter = dict.a;
			var nColor = dict.b;
			var nKey = dict.c;
			var nValue = dict.d;
			var nLeft = dict.e;
			var nRight = dict.f;
			var _v1 = A3($rtfeldman$elm_sorter_experiment$Sort$toOrder, sorter, key, nKey);
			switch (_v1) {
				case 0:
					return A6(
						$rtfeldman$elm_sorter_experiment$Sort$Dict$balance,
						sorter,
						nColor,
						nKey,
						nValue,
						A3($rtfeldman$elm_sorter_experiment$Sort$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 2:
					return A6(
						$rtfeldman$elm_sorter_experiment$Sort$Dict$balance,
						sorter,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($rtfeldman$elm_sorter_experiment$Sort$Dict$insertHelp, key, value, nRight));
				default:
					return A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, nColor, nKey, value, nLeft, nRight);
			}
		}
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($rtfeldman$elm_sorter_experiment$Sort$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 1) && (_v0.b === 1)) {
			var sorter = _v0.a;
			var _v1 = _v0.b;
			var k = _v0.c;
			var v = _v0.d;
			var l = _v0.e;
			var r = _v0.f;
			return A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $author$project$Timesheet$FeeLogic$getConsolidatedFees = function (fee) {
	var _v0 = fee.gm;
	var fees = _v0;
	return fees;
};
var $author$project$Timesheet$FeeLogic$isConsolidation = function (fee) {
	return !$elm$core$List$isEmpty(
		$author$project$Timesheet$FeeLogic$getConsolidatedFees(fee));
};
var $mgold$elm_nonempty_list$List$Nonempty$singleton = function (x) {
	return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, _List_Nil);
};
var $mgold$elm_nonempty_list$List$Nonempty$toList = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return A2($elm$core$List$cons, x, xs);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$CoreX$DateFormat$toUtcIsoString = function (time) {
	return $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(time);
};
var $rtfeldman$elm_sorter_experiment$Sort$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === 1) && (dict.e.$ === 1)) {
			var left = dict.e;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $rtfeldman$elm_sorter_experiment$Sort$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === 1) && (dict.e.$ === 1)) && (dict.f.$ === 1)) {
		if ((dict.f.e.$ === 1) && (dict.f.e.b === 1)) {
			var sorter = dict.a;
			var clr = dict.b;
			var k = dict.c;
			var v = dict.d;
			var _v1 = dict.e;
			var lClr = _v1.b;
			var lK = _v1.c;
			var lV = _v1.d;
			var lLeft = _v1.e;
			var lRight = _v1.f;
			var _v2 = dict.f;
			var rClr = _v2.b;
			var rK = _v2.c;
			var rV = _v2.d;
			var rLeft = _v2.e;
			var _v3 = rLeft.b;
			var rlK = rLeft.c;
			var rlV = rLeft.d;
			var rlL = rLeft.e;
			var rlR = rLeft.f;
			var rRight = _v2.f;
			return A6(
				$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
				sorter,
				1,
				rlK,
				rlV,
				A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					0,
					k,
					v,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, lK, lV, lLeft, lRight),
					rlL),
				A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, rK, rV, rlR, rRight));
		} else {
			var sorter = dict.a;
			var clr = dict.b;
			var k = dict.c;
			var v = dict.d;
			var _v4 = dict.e;
			var lClr = _v4.b;
			var lK = _v4.c;
			var lV = _v4.d;
			var lLeft = _v4.e;
			var lRight = _v4.f;
			var _v5 = dict.f;
			var rClr = _v5.b;
			var rK = _v5.c;
			var rV = _v5.d;
			var rLeft = _v5.e;
			var rRight = _v5.f;
			if (!clr) {
				return A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					0,
					k,
					v,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, lK, lV, lLeft, lRight),
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, rK, rV, rLeft, rRight));
			} else {
				return A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					0,
					k,
					v,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, lK, lV, lLeft, lRight),
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $rtfeldman$elm_sorter_experiment$Sort$Dict$moveRedRight = function (dict) {
	if (((dict.$ === 1) && (dict.e.$ === 1)) && (dict.f.$ === 1)) {
		if ((dict.e.e.$ === 1) && (dict.e.e.b === 1)) {
			var sorter = dict.a;
			var clr = dict.b;
			var k = dict.c;
			var v = dict.d;
			var _v1 = dict.e;
			var lClr = _v1.b;
			var lK = _v1.c;
			var lV = _v1.d;
			var _v2 = _v1.e;
			var _v3 = _v2.b;
			var llK = _v2.c;
			var llV = _v2.d;
			var llLeft = _v2.e;
			var llRight = _v2.f;
			var lRight = _v1.f;
			var _v4 = dict.f;
			var rClr = _v4.b;
			var rK = _v4.c;
			var rV = _v4.d;
			var rLeft = _v4.e;
			var rRight = _v4.f;
			return A6(
				$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
				sorter,
				1,
				lK,
				lV,
				A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, llK, llV, llLeft, llRight),
				A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					0,
					k,
					v,
					lRight,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, rK, rV, rLeft, rRight)));
		} else {
			var sorter = dict.a;
			var clr = dict.b;
			var k = dict.c;
			var v = dict.d;
			var _v5 = dict.e;
			var lClr = _v5.b;
			var lK = _v5.c;
			var lV = _v5.d;
			var lLeft = _v5.e;
			var lRight = _v5.f;
			var _v6 = dict.f;
			var rClr = _v6.b;
			var rK = _v6.c;
			var rV = _v6.d;
			var rLeft = _v6.e;
			var rRight = _v6.f;
			if (!clr) {
				return A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					0,
					k,
					v,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, lK, lV, lLeft, lRight),
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, rK, rV, rLeft, rRight));
			} else {
				return A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					0,
					k,
					v,
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, lK, lV, lLeft, lRight),
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === 1) && (left.b === 1)) {
			var sorter = left.a;
			var _v1 = left.b;
			var lK = left.c;
			var lV = left.d;
			var lLeft = left.e;
			var lRight = left.f;
			return A6(
				$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
				sorter,
				color,
				lK,
				lV,
				lLeft,
				A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === 1) && (!right.b)) {
					if (right.e.$ === 1) {
						if (!right.e.b) {
							var _v3 = right.b;
							var _v4 = right.e;
							var _v5 = _v4.b;
							return $rtfeldman$elm_sorter_experiment$Sort$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.b;
						return $rtfeldman$elm_sorter_experiment$Sort$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$removeMin = function (dict) {
	if (dict.$ === 1) {
		if (dict.e.$ === 1) {
			var sorter = dict.a;
			var color = dict.b;
			var key = dict.c;
			var value = dict.d;
			var left = dict.e;
			var lColor = left.b;
			var lLeft = left.e;
			var right = dict.f;
			if (!lColor) {
				if ((lLeft.$ === 1) && (lLeft.b === 1)) {
					var _v3 = lLeft.b;
					return A6(
						$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
						sorter,
						color,
						key,
						value,
						$rtfeldman$elm_sorter_experiment$Sort$Dict$removeMin(left),
						right);
				} else {
					var _v4 = $rtfeldman$elm_sorter_experiment$Sort$Dict$moveRedLeft(dict);
					if (_v4.$ === 1) {
						var movedColor = _v4.b;
						var movedKey = _v4.c;
						var movedValue = _v4.d;
						var movedLeft = _v4.e;
						var movedRight = _v4.f;
						return A6(
							$rtfeldman$elm_sorter_experiment$Sort$Dict$balance,
							sorter,
							movedColor,
							movedKey,
							movedValue,
							$rtfeldman$elm_sorter_experiment$Sort$Dict$removeMin(movedLeft),
							movedRight);
					} else {
						var leaf = _v4;
						return leaf;
					}
				}
			} else {
				return A6(
					$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
					sorter,
					color,
					key,
					value,
					$rtfeldman$elm_sorter_experiment$Sort$Dict$removeMin(left),
					right);
			}
		} else {
			var leaf = dict.e;
			return leaf;
		}
	} else {
		var leaf = dict;
		return leaf;
	}
};
var $rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (!dict.$) {
			var leaf = dict;
			return leaf;
		} else {
			var sorter = dict.a;
			var color = dict.b;
			var key = dict.c;
			var value = dict.d;
			var left = dict.e;
			var right = dict.f;
			var _v3 = A3($rtfeldman$elm_sorter_experiment$Sort$toOrder, sorter, targetKey, key);
			if (!_v3) {
				if ((left.$ === 1) && (!left.b)) {
					var _v5 = left.b;
					var lLeft = left.e;
					if ((lLeft.$ === 1) && (lLeft.b === 1)) {
						var _v7 = lLeft.b;
						return A6(
							$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
							sorter,
							color,
							key,
							value,
							A2($rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v8 = $rtfeldman$elm_sorter_experiment$Sort$Dict$moveRedLeft(dict);
						if (_v8.$ === 1) {
							var movedColor = _v8.b;
							var movedKey = _v8.c;
							var movedValue = _v8.d;
							var movedLeft = _v8.e;
							var movedRight = _v8.f;
							return A6(
								$rtfeldman$elm_sorter_experiment$Sort$Dict$balance,
								sorter,
								movedColor,
								movedKey,
								movedValue,
								A2($rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelp, targetKey, movedLeft),
								movedRight);
						} else {
							var leaf = _v8;
							return leaf;
						}
					}
				} else {
					return A6(
						$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
						sorter,
						color,
						key,
						value,
						A2($rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelpEQGT,
					targetKey,
					A7($rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === 1) {
			var sorter = dict.a;
			var color = dict.b;
			var key = dict.c;
			var value = dict.d;
			var left = dict.e;
			var right = dict.f;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $rtfeldman$elm_sorter_experiment$Sort$Dict$getMin(right);
				if (_v1.$ === 1) {
					var minKey = _v1.c;
					var minValue = _v1.d;
					return A6(
						$rtfeldman$elm_sorter_experiment$Sort$Dict$balance,
						sorter,
						color,
						minKey,
						minValue,
						left,
						$rtfeldman$elm_sorter_experiment$Sort$Dict$removeMin(right));
				} else {
					var leaf = _v1;
					return leaf;
				}
			} else {
				return A6(
					$rtfeldman$elm_sorter_experiment$Sort$Dict$balance,
					sorter,
					color,
					key,
					value,
					left,
					A2($rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelp, targetKey, right));
			}
		} else {
			var leaf = dict;
			return leaf;
		}
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$remove = F2(
	function (targetKey, dict) {
		var _v0 = A2($rtfeldman$elm_sorter_experiment$Sort$Dict$removeHelp, targetKey, dict);
		if ((_v0.$ === 1) && (_v0.b === 1)) {
			var sorter = _v0.a;
			var _v1 = _v0.b;
			var k = _v0.c;
			var v = _v0.d;
			var l = _v0.e;
			var r = _v0.f;
			return A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$update = F3(
	function (key, alter, dict) {
		var _v0 = alter(
			A2($rtfeldman$elm_sorter_experiment$Sort$Dict$get, key, dict));
		if (_v0.$ === 1) {
			return A2($rtfeldman$elm_sorter_experiment$Sort$Dict$remove, key, dict);
		} else {
			var value = _v0.a;
			return A3($rtfeldman$elm_sorter_experiment$Sort$Dict$insert, key, value, dict);
		}
	});
var $author$project$Timesheet$FeeLogic$addEntryInSort = F3(
	function (zone, newEntry, entries) {
		var fee = _Utils_update(
			newEntry,
			{
				hA: $author$project$Timesheet$FeeLogic$isConsolidation(newEntry)
			});
		var rataDie = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, fee);
		var sortEntries = F2(
			function (newFee, feeList) {
				return function (_v1) {
					var before = _v1.a;
					var after = _v1.b;
					return _Utils_ap(
						before,
						_Utils_ap(
							_List_fromArray(
								[newFee]),
							after));
				}(
					A2(
						$elm$core$List$partition,
						function (f) {
							return _Utils_cmp(
								$author$project$CoreX$DateFormat$toUtcIsoString(f.b7),
								$author$project$CoreX$DateFormat$toUtcIsoString(fee.b7)) < 0;
						},
						feeList));
			});
		var _v0 = A2($rtfeldman$elm_sorter_experiment$Sort$Dict$get, rataDie, entries);
		if (_v0.$ === 1) {
			return A3(
				$rtfeldman$elm_sorter_experiment$Sort$Dict$insert,
				rataDie,
				$mgold$elm_nonempty_list$List$Nonempty$singleton(fee),
				entries);
		} else {
			return A3(
				$rtfeldman$elm_sorter_experiment$Sort$Dict$update,
				rataDie,
				$elm$core$Maybe$andThen(
					A2(
						$elm$core$Basics$composeR,
						$mgold$elm_nonempty_list$List$Nonempty$toList,
						A2(
							$elm$core$Basics$composeR,
							sortEntries(fee),
							$mgold$elm_nonempty_list$List$Nonempty$fromList))),
				entries);
		}
	});
var $author$project$Timesheet$FeeLogic$addFeeInSort = F3(
	function (zone, fee, fees) {
		return _Utils_update(
			fees,
			{
				$7: A3($author$project$Timesheet$FeeLogic$addEntryInSort, zone, fee, fees.$7)
			});
	});
var $author$project$CoreX$Predicate$hasId = F2(
	function (searchedId, _v0) {
		var id = _v0.aC;
		return _Utils_eq(id, searchedId);
	});
var $author$project$CoreX$List$findById = F2(
	function (id, list) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			$author$project$CoreX$Predicate$hasId(id),
			list);
	});
var $rtfeldman$elm_sorter_experiment$Internal$Dict$foldr = F3(
	function (f, acc, dict) {
		foldr:
		while (true) {
			if (!dict.$) {
				return acc;
			} else {
				var key = dict.c;
				var value = dict.d;
				var left = dict.e;
				var right = dict.f;
				var $temp$f = f,
					$temp$acc = A3(
					f,
					key,
					value,
					A3($rtfeldman$elm_sorter_experiment$Internal$Dict$foldr, f, acc, right)),
					$temp$dict = left;
				f = $temp$f;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldr;
			}
		}
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$foldr = F3(
	function (f, acc, dict) {
		return A3($rtfeldman$elm_sorter_experiment$Internal$Dict$foldr, f, acc, dict);
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$values = function (dict) {
	return A3(
		$rtfeldman$elm_sorter_experiment$Sort$Dict$foldr,
		F3(
			function (_v0, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Timesheet$FeeLogic$findEntryById = F2(
	function (feeId, entries) {
		return A2(
			$author$project$CoreX$List$findById,
			feeId,
			A3(
				$elm$core$List$foldr,
				A2($elm$core$Basics$composeR, $mgold$elm_nonempty_list$List$Nonempty$toList, $elm$core$Basics$append),
				_List_Nil,
				$rtfeldman$elm_sorter_experiment$Sort$Dict$values(entries)));
	});
var $author$project$Timesheet$FeeLogic$findFeeById = F2(
	function (feeId, fees) {
		return A2($author$project$Timesheet$FeeLogic$findEntryById, feeId, fees.$7);
	});
var $author$project$Timesheet$FeeLogic$insertIfMissing = F3(
	function (zone, fee, fees) {
		var _v0 = A2($author$project$Timesheet$FeeLogic$findFeeById, fee.aC, fees);
		if (!_v0.$) {
			return fees;
		} else {
			return A3($author$project$Timesheet$FeeLogic$addFeeInSort, zone, fee, fees);
		}
	});
var $author$project$Timesheet$FeeLogic$selectFee = F2(
	function (fee, fees) {
		return _Utils_update(
			fees,
			{
				e1: $elm$core$Maybe$Just(fee.aC)
			});
	});
var $author$project$Timesheet$FeeLogic$addFee = F3(
	function (zone, fee, fees) {
		var feesWithSelection = A2($author$project$Timesheet$FeeLogic$selectFee, fee, fees);
		return A3($author$project$Timesheet$FeeLogic$insertIfMissing, zone, fee, feesWithSelection);
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$FlashMessage$flashMessageId = function (existingErrors) {
	return 1 + A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$maximum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.aC;
				},
				existingErrors)));
};
var $author$project$Model$FlashMessage$make = F2(
	function (str, existing) {
		return {
			bo: 2,
			bA: _List_Nil,
			bB: 3,
			aC: $author$project$Model$FlashMessage$flashMessageId(existing),
			eh: str
		};
	});
var $author$project$TimesheetPage$Messages$ClearFlashMessage = function (a) {
	return {$: 98, a: a};
};
var $author$project$FlashMessageLogic$delayedFlashMessageClear = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(
			$author$project$TimesheetPage$Messages$ClearFlashMessage(msg)),
		$elm$core$Process$sleep(15000));
};
var $author$project$FlashMessageLogic$prependToModelWithDelay = F2(
	function (model, flashMessage) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					P: A2($elm$core$List$cons, flashMessage, model.P)
				}),
			$author$project$FlashMessageLogic$delayedFlashMessageClear(flashMessage));
	});
var $author$project$FlashMessageLogic$addFromString = F2(
	function (model, message) {
		return A2(
			$author$project$FlashMessageLogic$prependToModelWithDelay,
			model,
			A2($author$project$Model$FlashMessage$make, message, model.P));
	});
var $author$project$FlashMessageLogic$addFromResponse = F2(
	function (model, response) {
		var flashStr = function () {
			var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$string, response);
			if (!_v0.$) {
				var message = _v0.a;
				return message;
			} else {
				var error = _v0.a;
				return $elm$json$Json$Decode$errorToString(error);
			}
		}();
		return A2($author$project$FlashMessageLogic$addFromString, model, flashStr);
	});
var $author$project$Model$Fee$Merge$Unchecked = 1;
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$FeeTypeLogic$getSearchableField = function (feeType) {
	return A2($elm_community$maybe_extra$Maybe$Extra$or, feeType.iA, feeType.br);
};
var $author$project$FeeTypeLogic$feeTypeDescription = function (feeType) {
	var displayableCode = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (code) {
				return ' (' + (code + ')');
			},
			$author$project$FeeTypeLogic$getSearchableField(feeType)));
	return _Utils_ap(feeType.dd, displayableCode);
};
var $author$project$Components$SelectInput$FeeTypes$toItem = function (feeType) {
	return {
		aC: $elm$core$String$fromInt(feeType.aC),
		aa: feeType,
		hK: true,
		ec: $author$project$FeeTypeLogic$feeTypeDescription(feeType)
	};
};
var $author$project$Components$SelectInput$FeeTypes$addDefault = F2(
	function (feeType, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (s) {
					return A2($o_train$elm_search_input$Select$addSelectedItem, s, model);
				},
				A2($elm$core$Maybe$map, $author$project$Components$SelectInput$FeeTypes$toItem, feeType)));
	});
var $author$project$FeeTypeLogic$isMergeFeesType = function (activityType) {
	if (!activityType.$) {
		var at = activityType.a;
		return at === 9;
	} else {
		return false;
	}
};
var $author$project$FeeTypeLogic$canMergeFees = function (feeTypes) {
	return A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.hQ;
			},
			$author$project$FeeTypeLogic$isMergeFeesType),
		feeTypes);
};
var $author$project$Components$MergeFees$Model$close = $author$project$Components$MergeFees$Model$Closed;
var $author$project$FeeTypeLogic$isConsolidatedEmail = function (ft) {
	var _v0 = ft.hQ;
	if ((!_v0.$) && (_v0.a === 7)) {
		var _v1 = _v0.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$FeeTypeLogic$getConsolidatedEmails = function (feeTypes) {
	return $elm$core$List$head(
		A2($elm$core$List$filter, $author$project$FeeTypeLogic$isConsolidatedEmail, feeTypes));
};
var $author$project$FeeTypeLogic$getMergeFeesType = function (feeTypes) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.hQ;
				},
				$author$project$FeeTypeLogic$isMergeFeesType),
			feeTypes));
};
var $author$project$FeeTypeLogic$getDefaultMergeFeeType = F2(
	function (allFeeTypes, selectedFeeTypes) {
		var emailConversationFeeType = F2(
			function (fts, _default) {
				var isEmailConvo = A2(
					$elm$core$List$all,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.hQ;
						},
						$elm$core$Basics$eq(
							$elm$core$Maybe$Just(6))),
					fts);
				var _v2 = _Utils_Tuple2(
					isEmailConvo,
					$author$project$FeeTypeLogic$getConsolidatedEmails(allFeeTypes));
				if (_v2.a && (!_v2.b.$)) {
					var ft = _v2.b.a;
					return $elm$core$Maybe$Just(ft);
				} else {
					return _default;
				}
			});
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.aC;
			},
			selectedFeeTypes);
		if (_v0.b && (!_v0.b.b)) {
			var feeType = _v0.a;
			return A2(
				emailConversationFeeType,
				_List_fromArray(
					[feeType]),
				$elm$core$Maybe$Just(feeType));
		} else {
			var feeTypes = _v0;
			var defaultMerge = function (_v1) {
				return $author$project$FeeTypeLogic$getMergeFeesType(allFeeTypes);
			};
			return A2(
				emailConversationFeeType,
				feeTypes,
				defaultMerge(0));
		}
	});
var $author$project$Activities$ActivityLogic$getActivityKindAndDirection = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 0:
			return _Utils_Tuple2(0, 2);
		case 1:
			return _Utils_Tuple2(1, 2);
		case 4:
			var phone = _v0.a;
			return _Utils_Tuple2(2, phone.df);
		case 3:
			var email = _v0.a;
			return _Utils_Tuple2(6, email.df);
		case 5:
			return _Utils_Tuple2(8, 2);
		default:
			if (_v0.a === 2) {
				var _v1 = _v0.a;
				return _Utils_Tuple2(5, 2);
			} else {
				return _Utils_Tuple2(3, 2);
			}
	}
};
var $author$project$FeeTypeLogic$getFeeTypeFromKind = F3(
	function (feeTypes, kind, direction) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (ft) {
				return _Utils_eq(
					ft.hQ,
					$elm$core$Maybe$Just(kind)) && _Utils_eq(ft.df, direction);
			},
			feeTypes);
	});
var $author$project$Activities$ActivityLogic$getFeeTypes = F2(
	function (feeTypes, activities) {
		return $elm_community$list_extra$List$Extra$unique(
			A3(
				$elm$core$List$foldl,
				F2(
					function (ft, acc) {
						return A2(
							$elm$core$Maybe$withDefault,
							acc,
							A2(
								$elm$core$Maybe$map,
								A2($author$project$CoreX$Basics$flip, $elm$core$List$cons, acc),
								ft));
					}),
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var kind = _v0.a;
						var direction = _v0.b;
						return A3($author$project$FeeTypeLogic$getFeeTypeFromKind, feeTypes, kind, direction);
					},
					A2($elm$core$List$map, $author$project$Activities$ActivityLogic$getActivityKindAndDirection, activities))));
	});
var $author$project$Timesheet$FeeLogic$listMatchingIds = F2(
	function (feeIds, fees) {
		var addMatching = F2(
			function (entries, acc) {
				return _Utils_ap(
					acc,
					A2(
						$elm$core$List$filter,
						function (f) {
							return A2($elm$core$List$member, f.aC, feeIds);
						},
						$mgold$elm_nonempty_list$List$Nonempty$toList(entries)));
			});
		return A3(
			$elm$core$List$foldr,
			addMatching,
			_List_Nil,
			$rtfeldman$elm_sorter_experiment$Sort$Dict$values(fees.$7));
	});
var $author$project$Timesheet$ConsolidateUpdateLogic$getMergeFeeType = function (model) {
	var feeTypesOfFees = A2(
		$elm$core$List$map,
		function ($) {
			return $.g0;
		},
		A2(
			$author$project$Timesheet$FeeLogic$listMatchingIds,
			$elm$core$Set$toList(model.aY.gj),
			model.aY));
	var feeTypesOfActivities = A2(
		$author$project$Activities$ActivityLogic$getFeeTypes,
		model.bG,
		A2(
			$elm$core$List$filter,
			function (act) {
				return A2($elm$core$Set$member, act.aC, model.fI.cp);
			},
			model.fI.fF));
	return A2(
		$author$project$FeeTypeLogic$getDefaultMergeFeeType,
		model.bG,
		_Utils_ap(feeTypesOfFees, feeTypesOfActivities));
};
var $author$project$Components$SelectInput$FeeTypes$selectorModel = F2(
	function (selected, feeTypes) {
		return A2(
			$author$project$Components$SelectInput$FeeTypes$addDefault,
			selected,
			A2(
				$o_train$elm_search_input$Select$addItems,
				A2($elm$core$List$map, $author$project$Components$SelectInput$FeeTypes$toItem, feeTypes),
				A2($o_train$elm_search_input$Select$init, 'Fee Type', $author$project$Components$SelectInput$FeeTypes$toItem)));
	});
var $author$project$Components$MergeFees$Model$init = F5(
	function (canMergeFees, selected, feeTypes, feeIds, activityIds) {
		return $author$project$Components$MergeFees$Model$Open(
			{
				cQ: activityIds,
				cY: canMergeFees,
				dD: feeIds,
				eZ: A2($author$project$Components$SelectInput$FeeTypes$selectorModel, selected, feeTypes),
				fq: false
			});
	});
var $author$project$Timesheet$ConsolidateUpdateLogic$setMergeFees = function (model) {
	var numOfIds = $elm$core$Set$size(model.aY.gj) + $elm$core$Set$size(model.fI.cp);
	var _v0 = _Utils_Tuple2(model.a4, numOfIds > 1);
	if (_v0.b) {
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			var defaultFeeType = $author$project$Timesheet$ConsolidateUpdateLogic$getMergeFeeType(model);
			return _Utils_update(
				model,
				{
					a4: A5(
						$author$project$Components$MergeFees$Model$init,
						$author$project$FeeTypeLogic$canMergeFees(model.bG),
						defaultFeeType,
						model.bG,
						model.aY.gj,
						model.fI.cp)
				});
		} else {
			var mergeFees = _v0.a.a;
			if (mergeFees.fq) {
				return model;
			} else {
				var defaultFeeType = $author$project$Timesheet$ConsolidateUpdateLogic$getMergeFeeType(model);
				var updatedMergeFees = _Utils_update(
					mergeFees,
					{
						cQ: model.fI.cp,
						dD: model.aY.gj,
						eZ: A2($author$project$Components$SelectInput$FeeTypes$addDefault, defaultFeeType, mergeFees.eZ)
					});
				return _Utils_update(
					model,
					{
						a4: $author$project$Components$MergeFees$Model$Open(updatedMergeFees)
					});
			}
		}
	} else {
		return _Utils_update(
			model,
			{a4: $author$project$Components$MergeFees$Model$close});
	}
};
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$diff, dict1, dict2);
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$union, dict1, dict2);
	});
var $author$project$ActivityFeedLogic$updateSelectedActivityIds = F3(
	function (ids, state, activityFeed) {
		var selectedActivityIds = activityFeed.cp;
		var updatedSelectedActivityIds = function () {
			if (!state) {
				return $elm$core$Set$union;
			} else {
				return $elm$core$Set$diff;
			}
		}();
		return _Utils_update(
			activityFeed,
			{
				cp: A2(updatedSelectedActivityIds, selectedActivityIds, ids)
			});
	});
var $author$project$Timesheet$ConsolidateUpdateLogic$updateActivitiesForMerge = F3(
	function (activityIds, consolidateState, model) {
		return $author$project$Timesheet$ConsolidateUpdateLogic$setMergeFees(
			_Utils_update(
				model,
				{
					fI: A3($author$project$ActivityFeedLogic$updateSelectedActivityIds, activityIds, consolidateState, model.fI)
				}));
	});
var $author$project$Timesheet$ConsolidateUpdateLogic$deselectActivitiesForMerge = F2(
	function (activityIds, model) {
		return A3($author$project$Timesheet$ConsolidateUpdateLogic$updateActivitiesForMerge, activityIds, 1, model);
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $author$project$Timesheet$ConsolidateUpdateLogic$deselectSingleActivityForMerge = F2(
	function (activityId, model) {
		return A2(
			$author$project$Timesheet$ConsolidateUpdateLogic$deselectActivitiesForMerge,
			$elm$core$Set$singleton(activityId),
			model);
	});
var $author$project$TimesheetPage$Update$expandConversation = F2(
	function (groupByKey, model) {
		var expandedFeeConversations = model.gO;
		return _Utils_update(
			model,
			{
				gO: A2($elm$core$List$cons, groupByKey, expandedFeeConversations)
			});
	});
var $author$project$TimesheetPage$Messages$FocusFailure = function (a) {
	return {$: 95, a: a};
};
var $author$project$TimesheetPage$Update$focusOn = function (id) {
	return A2(
		$elm$core$Task$attempt,
		$author$project$TimesheetPage$Messages$FocusFailure,
		$elm$browser$Browser$Dom$focus(id));
};
var $author$project$TimesheetPage$Update$focusOnFeeEntryDescription = $author$project$TimesheetPage$Update$focusOn('fee-entry-description');
var $author$project$Timesheet$FeeLogic$getActivityId = function (_v0) {
	var activity = _v0.fG;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.aC;
		},
		activity);
};
var $author$project$Activities$ActivityLogic$groupByKeyForRataDie = F2(
	function (rataDie, activity) {
		var identifier = function () {
			var _v0 = activity.i;
			switch (_v0.$) {
				case 3:
					var act = _v0.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$core$String$fromInt(activity.aC),
						act.gq);
				case 2:
					if (_v0.a === 2) {
						var _v1 = _v0.a;
						var act = _v0.b;
						return act.dw + '-reading';
					} else {
						var act = _v0.b;
						return act.dw + '-drafting';
					}
				case 5:
					var act = _v0.a;
					return act.aR;
				default:
					return $elm$core$String$fromInt(activity.aC);
			}
		}();
		return identifier + ('-' + $elm$core$String$fromInt(rataDie));
	});
var $author$project$Model$Fee$PostStatus$isEditable = function (postStatus) {
	return A2(
		$elm$core$List$member,
		postStatus,
		_List_fromArray(
			[0, 6]));
};
var $author$project$Timesheet$FeeLogic$isEditable = function (fee) {
	return $author$project$Model$Fee$PostStatus$isEditable(fee.eD);
};
var $author$project$Timesheet$FeeLogic$groupByKey = F2(
	function (zone, fee) {
		var rataDie = A2($author$project$CoreX$RataDie$fromPosix, zone, fee.b7);
		var postKey = $author$project$Timesheet$FeeLogic$isEditable(fee) ? '-postable-' : '-not-postable-';
		var matterKey = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.gS;
				},
				fee.hY));
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$String$fromInt(fee.aC) + ('-' + $elm$core$String$fromInt(rataDie)),
			A2(
				$elm$core$Maybe$andThen,
				function (key) {
					return $elm$core$Maybe$Just(
						_Utils_ap(
							key,
							_Utils_ap(postKey, matterKey)));
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Activities$ActivityLogic$groupByKeyForRataDie(rataDie),
					fee.fG)));
	});
var $author$project$Model$Fee$decodeOptionalMessage = function (str) {
	return A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'flashMessage', $elm$json$Json$Decode$string),
		str);
};
var $author$project$TimesheetPage$Update$handleFlashWhenPresent = F2(
	function (response, model) {
		var _v0 = $author$project$Model$Fee$decodeOptionalMessage(response);
		if (!_v0.$) {
			var message = _v0.a;
			return A2($author$project$FlashMessageLogic$addFromString, model, message);
		} else {
			return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$Model$Fee$optionalFeeDecoder = function (value) {
	return A2(
		$elm$json$Json$Decode$decodeString,
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'fee', $author$project$Model$Fee$decodeFee)),
		value);
};
var $author$project$TimesheetPage$Update$resetMobileDeviceTab = function (model) {
	return _Utils_update(
		model,
		{h6: 0});
};
var $author$project$TimesheetPage$Messages$ScrollToId = function (a) {
	return {$: 103, a: a};
};
var $author$project$TimesheetPage$Update$delayedCmd = F2(
	function (msg, delay) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(delay));
	});
var $author$project$TimesheetPage$Update$scrollSelectedFeeIdIntoView = function (model) {
	var fees = model.aY;
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
		A2(
			$elm$core$Maybe$map,
			function (feeId) {
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$TimesheetPage$Update$delayedCmd,
						$author$project$TimesheetPage$Messages$ScrollToId(
							'fee-' + $elm$core$String$fromInt(feeId)),
						1));
			},
			fees.e1));
};
var $author$project$TimesheetPage$Update$addFeeFromCreateFeeResponse = F4(
	function (zone, response, model, removeActivity) {
		var _v0 = $author$project$Model$Fee$optionalFeeDecoder(response);
		if (!_v0.$) {
			if (_v0.a.$ === 1) {
				var _v1 = _v0.a;
				return A2($author$project$TimesheetPage$Update$handleFlashWhenPresent, response, model);
			} else {
				var fee = _v0.a.a;
				var updatedModel = A2(
					$elm$core$Maybe$withDefault,
					model,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$CoreX$Basics$flip, $author$project$Timesheet$ConsolidateUpdateLogic$deselectSingleActivityForMerge, model),
						$author$project$Timesheet$FeeLogic$getActivityId(fee)));
				var setFees = function (m) {
					return _Utils_update(
						m,
						{
							aY: A3($author$project$Timesheet$FeeLogic$addFee, zone, fee, model.aY)
						});
				};
				var groupByKey = A2($author$project$Timesheet$FeeLogic$groupByKey, zone, fee);
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$TimesheetPage$Update$scrollSelectedFeeIdIntoView,
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$TimesheetPage$Update$focusOnFeeEntryDescription,
						A2(
							$Fresheyeball$elm_return$Return$map,
							$author$project$TimesheetPage$Update$resetMobileDeviceTab,
							A2(
								$Fresheyeball$elm_return$Return$map,
								$author$project$TimesheetPage$Update$expandConversation(groupByKey),
								A2(
									$Fresheyeball$elm_return$Return$map,
									setFees,
									A2($author$project$TimesheetPage$Update$handleFlashWhenPresent, response, updatedModel))))));
			}
		} else {
			var error = _v0.a;
			return A2(
				$author$project$FlashMessageLogic$addFromResponse,
				model,
				$elm$json$Json$Decode$errorToString(error));
		}
	});
var $author$project$FlashMessageLogic$addFromError = F2(
	function (model, httpError) {
		return A2(
			$author$project$FlashMessageLogic$addFromString,
			model,
			$author$project$ErrorLogic$getMessage(httpError));
	});
var $author$project$Model$FlashMessage$makeForAction = F5(
	function (str, actionType, entityType, entityIds, existing) {
		return {
			bo: actionType,
			bA: entityIds,
			bB: entityType,
			aC: $author$project$Model$FlashMessage$flashMessageId(existing),
			eh: str
		};
	});
var $author$project$FlashMessageLogic$addFromStringWithAction = F5(
	function (model, message, actionType, entityType, entityIds) {
		return A2(
			$author$project$FlashMessageLogic$prependToModelWithDelay,
			model,
			A5($author$project$Model$FlashMessage$makeForAction, message, actionType, entityType, entityIds, model.P));
	});
var $author$project$FlashMessageLogic$loadingMessage = 'Loading, please wait...';
var $author$project$FlashMessageLogic$addLoadingMessage = function (model) {
	var isDisplayed = F2(
		function (message, model_) {
			var _v0 = $elm$core$List$head(model_.P);
			if (!_v0.$) {
				var msg = _v0.a;
				return _Utils_eq(msg.eh, message);
			} else {
				return false;
			}
		});
	return A2(isDisplayed, $author$project$FlashMessageLogic$loadingMessage, model) ? $Fresheyeball$elm_return$Return$singleton(model) : A2($author$project$FlashMessageLogic$addFromString, model, $author$project$FlashMessageLogic$loadingMessage);
};
var $author$project$Timesheet$FeeLogic$updateFeeIdWith = F3(
	function (updater, rec, fees) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			$author$project$CoreX$Predicate$hasId(rec.g_),
			updater,
			fees);
	});
var $author$project$Timesheet$FeeLogic$appendToFeeSummary = F3(
	function (zone, feeDesc, fees) {
		var updateDesc = F2(
			function (oldDesc, newDesc) {
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						' ',
						A2(
							$author$project$CoreX$Appendable$andAppendMaybe,
							newDesc,
							A2($author$project$CoreX$Appendable$andAppendMaybe, oldDesc, _List_Nil))));
			});
		var updateFeeSummary = F2(
			function (fee, item) {
				var aiInput = item.aQ;
				var desc = A2(updateDesc, aiInput.fg, fee.dd);
				var updatedAiInput = _Utils_update(
					aiInput,
					{fg: desc});
				return _Utils_update(
					item,
					{aQ: updatedAiInput});
			});
		var rataDie = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, feeDesc);
		var entries = A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$update,
			rataDie,
			$elm$core$Maybe$andThen(
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$toList,
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$Timesheet$FeeLogic$updateFeeIdWith,
							updateFeeSummary(feeDesc),
							feeDesc),
						$mgold$elm_nonempty_list$List$Nonempty$fromList))),
			fees.$7);
		return _Utils_update(
			fees,
			{$7: entries});
	});
var $mgold$elm_nonempty_list$List$Nonempty$cons = F2(
	function (y, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			y,
			A2($elm$core$List$cons, x, xs));
	});
var $mgold$elm_nonempty_list$List$Nonempty$foldl = F3(
	function (f, b, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A3(
			$elm$core$List$foldl,
			f,
			b,
			A2($elm$core$List$cons, x, xs));
	});
var $author$project$GroupBy$groupBy = F3(
	function (sorter, keyfn, list) {
		return A3(
			$mgold$elm_nonempty_list$List$Nonempty$foldl,
			F2(
				function (x, acc) {
					return A3(
						$rtfeldman$elm_sorter_experiment$Sort$Dict$update,
						keyfn(x),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$mgold$elm_nonempty_list$List$Nonempty$cons(x)),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(
									A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, _List_Nil)),
								$elm$core$Maybe$Just)),
						acc);
				}),
			$rtfeldman$elm_sorter_experiment$Sort$Dict$empty(sorter),
			list);
	});
var $author$project$GroupBy$groupFeesByRataDie = F3(
	function (zone, getDate, list) {
		return A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_sorter_experiment$Sort$Dict$empty($author$project$CoreX$Sorter$reverseInt),
			A2(
				$elm$core$Maybe$map,
				A2(
					$author$project$GroupBy$groupBy,
					$author$project$CoreX$Sorter$reverseInt,
					A2(
						$elm$core$Basics$composeR,
						getDate,
						$author$project$CoreX$RataDie$fromPosix(zone))),
				$mgold$elm_nonempty_list$List$Nonempty$fromList(list)));
	});
var $mgold$elm_nonempty_list$List$Nonempty$append = F2(
	function (_v0, _v1) {
		var x = _v0.a;
		var xs = _v0.b;
		var y = _v1.a;
		var ys = _v1.b;
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			x,
			_Utils_ap(
				xs,
				A2($elm$core$List$cons, y, ys)));
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$foldl = F3(
	function (f, acc, dict) {
		foldl:
		while (true) {
			if (!dict.$) {
				return acc;
			} else {
				var key = dict.c;
				var value = dict.d;
				var left = dict.e;
				var right = dict.f;
				var $temp$f = f,
					$temp$acc = A3(
					f,
					key,
					value,
					A3($rtfeldman$elm_sorter_experiment$Sort$Dict$foldl, f, acc, left)),
					$temp$dict = right;
				f = $temp$f;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$toList = function (dict) {
	return A3(
		$rtfeldman$elm_sorter_experiment$Sort$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $rtfeldman$elm_sorter_experiment$Sort$Dict$merge = F7(
	function (sorter, leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						var _v3 = A3($rtfeldman$elm_sorter_experiment$Sort$toOrder, sorter, lKey, rKey);
						switch (_v3) {
							case 0:
								var $temp$rKey = rKey,
									$temp$rValue = rValue,
									$temp$_v0 = _Utils_Tuple2(
									rest,
									A3(leftStep, lKey, lValue, result));
								rKey = $temp$rKey;
								rValue = $temp$rValue;
								_v0 = $temp$_v0;
								continue stepState;
							case 2:
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							default:
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
						}
					}
				}
			});
		var _v4 = A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$rtfeldman$elm_sorter_experiment$Sort$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v4.a;
		var intermediateResult = _v4.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v5, result) {
					var k = _v5.a;
					var v = _v5.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $author$project$Timesheet$FeeLogic$mergeFeesDict = F2(
	function (dictOne, dictTwo) {
		var whenNoMatch = F3(
			function (key, val, result) {
				return A3($rtfeldman$elm_sorter_experiment$Sort$Dict$insert, key, val, result);
			});
		var whenMatch = F4(
			function (key, dictOneEntries, dictTwoEntries, result) {
				var updatedFees = A2(
					$elm$core$Maybe$withDefault,
					dictOneEntries,
					$mgold$elm_nonempty_list$List$Nonempty$fromList(
						A2(
							$elm_community$list_extra$List$Extra$uniqueBy,
							function ($) {
								return $.aC;
							},
							$mgold$elm_nonempty_list$List$Nonempty$toList(
								A2($mgold$elm_nonempty_list$List$Nonempty$append, dictTwoEntries, dictOneEntries)))));
				return A3($rtfeldman$elm_sorter_experiment$Sort$Dict$insert, key, updatedFees, result);
			});
		return A7(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$merge,
			$author$project$CoreX$Sorter$reverseInt,
			whenNoMatch,
			whenMatch,
			whenNoMatch,
			dictOne,
			dictTwo,
			$rtfeldman$elm_sorter_experiment$Sort$Dict$empty($author$project$CoreX$Sorter$reverseInt));
	});
var $author$project$Timesheet$FeeLogic$updateLoading = F2(
	function (newFees, replacedFees) {
		return _Utils_update(
			replacedFees,
			{
				cV: $author$project$Model$Fees$oldestEntry(newFees),
				dE: A2($author$project$PagedLoadingStatusLogic$hasMore, 0, newFees)
			});
	});
var $author$project$Timesheet$FeeLogic$appendUniqFeeEntries = F3(
	function (zone, existingFees, newFees) {
		var groupedNewFees = A3(
			$author$project$GroupBy$groupFeesByRataDie,
			zone,
			function ($) {
				return $.b7;
			},
			newFees);
		var entries = A2($author$project$Timesheet$FeeLogic$mergeFeesDict, existingFees.$7, groupedNewFees);
		return A2(
			$author$project$Timesheet$FeeLogic$updateLoading,
			newFees,
			_Utils_update(
				existingFees,
				{$7: entries}));
	});
var $author$project$TimesheetPage$Update$applyMaybeCommand = F2(
	function (applyCmd, _return) {
		return A2(
			$elm$core$Maybe$withDefault,
			_return,
			A2(
				$elm$core$Maybe$map,
				function (cmd) {
					return A2($Fresheyeball$elm_return$Return$command, cmd, _return);
				},
				applyCmd));
	});
var $author$project$TimesheetPage$Messages$BlockFeeByEmailResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Timesheet$Requests$blockFeeByEmail = F2(
	function (csrfToken, feeId) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$BlockFeeByEmailResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(feeId) + '/block_email_address')
			});
	});
var $author$project$Timesheet$FeeLogic$isFutureDated = function (fee) {
	return A2($elm$core$List$member, $author$project$Model$Fee$FutureDated, fee.cK);
};
var $author$project$CoreX$DateCompare$isLaterThan = F2(
	function (timeOne, timeTwo) {
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(timeTwo),
			$elm$time$Time$posixToMillis(timeOne)) > 0;
	});
var $author$project$Timesheet$FeeLogic$checkFeeHasOccurred = F2(
	function (now, fee) {
		var isFutureOfNow = A2($author$project$CoreX$DateCompare$isLaterThan, now, fee.b7);
		var _v0 = _Utils_Tuple2(
			$author$project$Timesheet$FeeLogic$isFutureDated(fee),
			isFutureOfNow);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (_v0.b) {
					return _Utils_update(
						fee,
						{
							cK: A2($elm$core$List$cons, $author$project$Model$Fee$FutureDated, fee.cK)
						});
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b) {
					return _Utils_update(
						fee,
						{
							cK: A2(
								$elm$core$List$filter,
								function (r) {
									return !_Utils_eq(r, $author$project$Model$Fee$FutureDated);
								},
								fee.cK)
						});
				} else {
					break _v0$2;
				}
			}
		}
		return fee;
	});
var $rtfeldman$elm_sorter_experiment$Sort$Dict$map = F2(
	function (f, dict) {
		if (!dict.$) {
			var sorter = dict.a;
			return $rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter);
		} else {
			var sorter = dict.a;
			var color = dict.b;
			var key = dict.c;
			var value = dict.d;
			var left = dict.e;
			var right = dict.f;
			return A6(
				$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
				sorter,
				color,
				key,
				A2(f, key, value),
				A2($rtfeldman$elm_sorter_experiment$Sort$Dict$map, f, left),
				A2($rtfeldman$elm_sorter_experiment$Sort$Dict$map, f, right));
		}
	});
var $author$project$Timesheet$FeeLogic$mapEntries = F2(
	function (updater, entries) {
		return A2(
			$elm$core$Maybe$withDefault,
			entries,
			$mgold$elm_nonempty_list$List$Nonempty$fromList(
				A2(
					$elm$core$List$map,
					updater,
					$mgold$elm_nonempty_list$List$Nonempty$toList(entries))));
	});
var $rtfeldman$elm_sorter_experiment$Internal$Dict$accumulateNodeList = F7(
	function (sorter, isReversed, revList, a, _v0, b, list) {
		accumulateNodeList:
		while (true) {
			var k1 = _v0.a;
			var v1 = _v0.b;
			if (!list.b) {
				return isReversed ? _Utils_Tuple2(
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, k1, v1, b, a),
					revList) : _Utils_Tuple2(
					A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, k1, v1, a, b),
					revList);
			} else {
				if (!list.b.b) {
					var _v2 = list.a;
					var _v3 = _v2.a;
					var k2 = _v3.a;
					var v2 = _v3.b;
					var c = _v2.b;
					return isReversed ? _Utils_Tuple2(
						A6(
							$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
							sorter,
							0,
							k1,
							v1,
							A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, k2, v2, c, b),
							a),
						revList) : _Utils_Tuple2(
						A6(
							$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
							sorter,
							0,
							k2,
							v2,
							A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, k1, v1, a, b),
							c),
						revList);
				} else {
					if (!list.b.b.b) {
						var _v4 = list.a;
						var p2 = _v4.a;
						var c = _v4.b;
						var _v5 = list.b;
						var _v6 = _v5.a;
						var _v7 = _v6.a;
						var k3 = _v7.a;
						var v3 = _v7.b;
						var d = _v6.b;
						return isReversed ? _Utils_Tuple2(
							A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, k3, v3, d, c),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									p2,
									A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, k1, v1, b, a)),
								revList)) : _Utils_Tuple2(
							A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, k3, v3, c, d),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									p2,
									A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 0, k1, v1, a, b)),
								revList));
					} else {
						var _v8 = list.a;
						var _v9 = _v8.a;
						var k2 = _v9.a;
						var v2 = _v9.b;
						var c = _v8.b;
						var _v10 = list.b;
						var _v11 = _v10.a;
						var p3 = _v11.a;
						var d = _v11.b;
						var _v12 = _v10.b;
						var _v13 = _v12.a;
						var p4 = _v13.a;
						var e = _v13.b;
						var rest = _v12.b;
						if (isReversed) {
							var $temp$sorter = sorter,
								$temp$isReversed = isReversed,
								$temp$revList = A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									p3,
									A6(
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
										sorter,
										0,
										k1,
										v1,
										A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, k2, v2, c, b),
										a)),
								revList),
								$temp$a = d,
								$temp$_v0 = p4,
								$temp$b = e,
								$temp$list = rest;
							sorter = $temp$sorter;
							isReversed = $temp$isReversed;
							revList = $temp$revList;
							a = $temp$a;
							_v0 = $temp$_v0;
							b = $temp$b;
							list = $temp$list;
							continue accumulateNodeList;
						} else {
							var $temp$sorter = sorter,
								$temp$isReversed = isReversed,
								$temp$revList = A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									p3,
									A6(
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
										sorter,
										0,
										k2,
										v2,
										A6($rtfeldman$elm_sorter_experiment$Internal$Dict$Node, sorter, 1, k1, v1, a, b),
										c)),
								revList),
								$temp$a = d,
								$temp$_v0 = p4,
								$temp$b = e,
								$temp$list = rest;
							sorter = $temp$sorter;
							isReversed = $temp$isReversed;
							revList = $temp$revList;
							a = $temp$a;
							_v0 = $temp$_v0;
							b = $temp$b;
							list = $temp$list;
							continue accumulateNodeList;
						}
					}
				}
			}
		}
	});
var $rtfeldman$elm_sorter_experiment$Internal$Dict$fromNodeList = F3(
	function (sorter, isReversed, nodeList) {
		fromNodeList:
		while (true) {
			if (!nodeList.b.b) {
				var node = nodeList.a;
				return node;
			} else {
				var a = nodeList.a;
				var _v1 = nodeList.b;
				var _v2 = _v1.a;
				var p1 = _v2.a;
				var b = _v2.b;
				var list = _v1.b;
				var $temp$sorter = sorter,
					$temp$isReversed = !isReversed,
					$temp$nodeList = A7($rtfeldman$elm_sorter_experiment$Internal$Dict$accumulateNodeList, sorter, isReversed, _List_Nil, a, p1, b, list);
				sorter = $temp$sorter;
				isReversed = $temp$isReversed;
				nodeList = $temp$nodeList;
				continue fromNodeList;
			}
		}
	});
var $rtfeldman$elm_sorter_experiment$Internal$Dict$sortedListToNodeList = F5(
	function (sorter, isAsc, revList, _v0, list) {
		sortedListToNodeList:
		while (true) {
			var k1 = _v0.a;
			var v1 = _v0.b;
			if (!list.b) {
				return _Utils_Tuple2(
					A6(
						$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
						sorter,
						0,
						k1,
						v1,
						$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter),
						$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter)),
					revList);
			} else {
				if (!list.b.b) {
					var _v2 = list.a;
					var k2 = _v2.a;
					var v2 = _v2.b;
					return isAsc ? _Utils_Tuple2(
						A6(
							$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
							sorter,
							0,
							k2,
							v2,
							A6(
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
								sorter,
								1,
								k1,
								v1,
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter),
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter)),
							$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter)),
						revList) : _Utils_Tuple2(
						A6(
							$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
							sorter,
							0,
							k1,
							v1,
							A6(
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
								sorter,
								1,
								k2,
								v2,
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter),
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter)),
							$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter)),
						revList);
				} else {
					if (!list.b.b.b) {
						var p2 = list.a;
						var _v3 = list.b;
						var _v4 = _v3.a;
						var k3 = _v4.a;
						var v3 = _v4.b;
						return _Utils_Tuple2(
							A6(
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
								sorter,
								0,
								k3,
								v3,
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter),
								$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									p2,
									A6(
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
										sorter,
										0,
										k1,
										v1,
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter),
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter))),
								revList));
					} else {
						var _v5 = list.a;
						var k2 = _v5.a;
						var v2 = _v5.b;
						var _v6 = list.b;
						var p3 = _v6.a;
						var _v7 = _v6.b;
						var p4 = _v7.a;
						var rest = _v7.b;
						if (isAsc) {
							var $temp$sorter = sorter,
								$temp$isAsc = isAsc,
								$temp$revList = A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									p3,
									A6(
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
										sorter,
										0,
										k2,
										v2,
										A6(
											$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
											sorter,
											1,
											k1,
											v1,
											$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter),
											$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter)),
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter))),
								revList),
								$temp$_v0 = p4,
								$temp$list = rest;
							sorter = $temp$sorter;
							isAsc = $temp$isAsc;
							revList = $temp$revList;
							_v0 = $temp$_v0;
							list = $temp$list;
							continue sortedListToNodeList;
						} else {
							var $temp$sorter = sorter,
								$temp$isAsc = isAsc,
								$temp$revList = A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									p3,
									A6(
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
										sorter,
										0,
										k1,
										v1,
										A6(
											$rtfeldman$elm_sorter_experiment$Internal$Dict$Node,
											sorter,
											1,
											k2,
											v2,
											$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter),
											$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter)),
										$rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter))),
								revList),
								$temp$_v0 = p4,
								$temp$list = rest;
							sorter = $temp$sorter;
							isAsc = $temp$isAsc;
							revList = $temp$revList;
							_v0 = $temp$_v0;
							list = $temp$list;
							continue sortedListToNodeList;
						}
					}
				}
			}
		}
	});
var $rtfeldman$elm_sorter_experiment$Internal$Dict$fromSortedList = F3(
	function (sorter, isAsc, list) {
		if (!list.b) {
			return $rtfeldman$elm_sorter_experiment$Internal$Dict$Leaf(sorter);
		} else {
			var pair = list.a;
			var rest = list.b;
			return A3(
				$rtfeldman$elm_sorter_experiment$Internal$Dict$fromNodeList,
				sorter,
				isAsc,
				A5($rtfeldman$elm_sorter_experiment$Internal$Dict$sortedListToNodeList, sorter, isAsc, _List_Nil, pair, rest));
		}
	});
var $rtfeldman$elm_sorter_experiment$Internal$Dict$getSorter = function (dict) {
	if (!dict.$) {
		var sorter = dict.a;
		return sorter;
	} else {
		var sorter = dict.a;
		return sorter;
	}
};
var $rtfeldman$elm_sorter_experiment$Sort$Dict$partition = F2(
	function (predicate, dict) {
		var sorter = $rtfeldman$elm_sorter_experiment$Internal$Dict$getSorter(dict);
		var helper = F3(
			function (key, value, _v1) {
				var trues = _v1.a;
				var falses = _v1.b;
				return A2(predicate, key, value) ? _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, value),
						trues),
					falses) : _Utils_Tuple2(
					trues,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, value),
						falses));
			});
		var _v0 = A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$foldr,
			helper,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			dict);
		var finalTrues = _v0.a;
		var finalFalses = _v0.b;
		return _Utils_Tuple2(
			A3($rtfeldman$elm_sorter_experiment$Internal$Dict$fromSortedList, sorter, true, finalTrues),
			A3($rtfeldman$elm_sorter_experiment$Internal$Dict$fromSortedList, sorter, true, finalFalses));
	});
var $author$project$Timesheet$FeeLogic$checkFeesHaveOccurred = F3(
	function (zone, now, fees) {
		var todayRataDie = A2($author$project$CoreX$RataDie$fromPosix, zone, now);
		var _v0 = A2(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$partition,
			F2(
				function (k, _v1) {
					return _Utils_cmp(k, todayRataDie) < 1;
				}),
			fees.$7);
		var dictForUpdate = _v0.a;
		var rest = _v0.b;
		var updatedDays = A2(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$map,
			F2(
				function (rataDie, entries) {
					return A2(
						$author$project$Timesheet$FeeLogic$mapEntries,
						$author$project$Timesheet$FeeLogic$checkFeeHasOccurred(now),
						entries);
				}),
			dictForUpdate);
		return _Utils_update(
			fees,
			{
				$7: A2($author$project$Timesheet$FeeLogic$mergeFeesDict, updatedDays, rest)
			});
	});
var $author$project$TimesheetPage$Update$checkFeesHaveOccurred = F3(
	function (zone, now, model) {
		return _Utils_update(
			model,
			{
				aY: A3($author$project$Timesheet$FeeLogic$checkFeesHaveOccurred, zone, now, model.aY)
			});
	});
var $author$project$FlashMessageLogic$clear = F2(
	function (model, flashMessage) {
		var filteredMessages = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(flashMessage),
			model.P);
		return _Utils_update(
			model,
			{P: filteredMessages});
	});
var $author$project$FlashMessageLogic$clearFlashMessageWithValue = F2(
	function (model, message) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				$author$project$FlashMessageLogic$clear(model),
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (fm) {
						return _Utils_eq(fm.eh, $author$project$FlashMessageLogic$loadingMessage);
					},
					model.P)));
	});
var $author$project$FlashMessageLogic$clearLoadingMessage = function (model) {
	return A2($author$project$FlashMessageLogic$clearFlashMessageWithValue, model, $author$project$FlashMessageLogic$loadingMessage);
};
var $author$project$TimesheetPage$Update$setFeeSearchNewEntryLoading = F2(
	function (loading, model) {
		var feeSearchConfig = model.g$;
		var updatedFeeSearch = _Utils_update(
			feeSearchConfig,
			{ep: loading});
		return _Utils_update(
			model,
			{g$: updatedFeeSearch});
	});
var $author$project$TimesheetPage$Update$clearNewEntryLoading = function (model) {
	return $author$project$FlashMessageLogic$clearLoadingMessage(
		A2($author$project$TimesheetPage$Update$setFeeSearchNewEntryLoading, false, model));
};
var $author$project$TimesheetPage$Messages$CreateActivityFeeResponse = function (a) {
	return {$: 66, a: a};
};
var $author$project$Timesheet$Requests$cloneFee = F2(
	function (csrfToken, fee) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$CreateActivityFeeResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/clone')
			});
	});
var $author$project$Timesheet$FeeLogic$getSelectedFee = function (fees) {
	return A2(
		$elm$core$Maybe$andThen,
		function (selectedId) {
			return A2($author$project$Timesheet$FeeLogic$findFeeById, selectedId, fees);
		},
		fees.e1);
};
var $elm_community$list_extra$List$Extra$setIf = F3(
	function (predicate, replacement, list) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			predicate,
			$elm$core$Basics$always(replacement),
			list);
	});
var $author$project$Timesheet$FeeLogic$updateEntries = F4(
	function (updater, zone, fee, entries) {
		var rataDie = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, fee);
		return A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$update,
			rataDie,
			$elm$core$Maybe$andThen(
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$toList,
					A2($elm$core$Basics$composeR, updater, $mgold$elm_nonempty_list$List$Nonempty$fromList))),
			entries);
	});
var $author$project$Timesheet$FeeLogic$replaceFee = F3(
	function (zone, fee, fees) {
		return _Utils_update(
			fees,
			{
				$7: A4(
					$author$project$Timesheet$FeeLogic$updateEntries,
					A2(
						$elm_community$list_extra$List$Extra$setIf,
						$author$project$CoreX$Predicate$hasId(fee.aC),
						fee),
					zone,
					fee,
					fees.$7)
			});
	});
var $author$project$Timesheet$FeeLogic$contactFromFee = function (fee) {
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.c2;
		},
		fee.fG);
};
var $author$project$Timesheet$FeeLogic$resetMatterInput = function (fee) {
	return {
		av: $elm$core$Maybe$Nothing,
		c2: $author$project$Timesheet$FeeLogic$contactFromFee(fee),
		bY: 1,
		iP: _List_Nil,
		eI: $krisajenkins$remotedata$RemoteData$NotAsked,
		i0: $Gizra$elm_debouncer$Debouncer$Messages$toDebouncer(
			$Gizra$elm_debouncer$Debouncer$Messages$debounce(500)),
		eW: $krisajenkins$remotedata$RemoteData$NotAsked,
		eX: '',
		fe: $krisajenkins$remotedata$RemoteData$NotAsked
	};
};
var $author$project$Timesheet$FeeLogic$unselectFee = F2(
	function (zone, fees) {
		var updatedFees = function () {
			var _v0 = $author$project$Timesheet$FeeLogic$getSelectedFee(fees);
			if (!_v0.$) {
				var fee = _v0.a;
				return A3(
					$author$project$Timesheet$FeeLogic$replaceFee,
					zone,
					_Utils_update(
						fee,
						{
							hA: false,
							eg: $author$project$Timesheet$FeeLogic$resetMatterInput(fee)
						}),
					fees);
			} else {
				return fees;
			}
		}();
		return _Utils_update(
			updatedFees,
			{e1: $elm$core$Maybe$Nothing});
	});
var $author$project$TimesheetPage$Update$closeFee = F2(
	function (zone, model) {
		return _Utils_update(
			model,
			{
				gX: $author$project$Components$SearchInput$Model$Closed,
				aY: A2($author$project$Timesheet$FeeLogic$unselectFee, zone, model.aY)
			});
	});
var $author$project$TimesheetPage$Messages$IgnoreResponse = function (a) {
	return {$: 107, a: a};
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Requests$patch = function (req) {
	return $elm$http$Http$request(
		{
			fW: req.fW,
			z: req.z,
			A: $author$project$Requests$appendJSONHeaders(req.A),
			ei: 'PATCH',
			fl: $elm$core$Maybe$Nothing,
			fo: $elm$core$Maybe$Nothing,
			jR: req.jR
		});
};
var $author$project$Activities$Requests$collapseActivityFeed = F2(
	function (csrfToken, collapse) {
		return $author$project$Requests$patch(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'collapse_activity_feed',
								$elm$json$Json$Encode$bool(collapse))
							]))),
				z: $elm$http$Http$expectWhatever($author$project$TimesheetPage$Messages$IgnoreResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/user_settings'
			});
	});
var $elm_community$list_extra$List$Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3($elm$core$List$foldl, $elm$core$List$cons, list2, list1);
	});
var $elm_community$list_extra$List$Extra$removeHelp = F4(
	function (list, x, xs, previousElements) {
		removeHelp:
		while (true) {
			if (!xs.b) {
				return list;
			} else {
				var y = xs.a;
				var ys = xs.b;
				if (_Utils_eq(x, y)) {
					return A2($elm_community$list_extra$List$Extra$reverseAppend, previousElements, ys);
				} else {
					var $temp$list = list,
						$temp$x = x,
						$temp$xs = ys,
						$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
					list = $temp$list;
					x = $temp$x;
					xs = $temp$xs;
					previousElements = $temp$previousElements;
					continue removeHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		return A4($elm_community$list_extra$List$Extra$removeHelp, xs, x, xs, _List_Nil);
	});
var $author$project$TimesheetPage$Update$collapseConversation = F2(
	function (groupByKey, model) {
		var expandedFeeConversations = model.gO;
		return _Utils_update(
			model,
			{
				gO: A2($elm_community$list_extra$List$Extra$remove, groupByKey, expandedFeeConversations)
			});
	});
var $author$project$TimesheetPage$Messages$CompleteTourResponse = function (a) {
	return {$: 105, a: a};
};
var $author$project$Tours$mitimesDatabaseKey = function (userTour) {
	switch (userTour) {
		case 0:
			return 'has_completed_manual_fee_tour';
		case 1:
			return 'has_completed_activity_review_tour';
		case 2:
			return 'has_acknowledged_fee_grouping';
		default:
			return 'has_acknowledged_merging';
	}
};
var $author$project$User$Requests$completeTour = F2(
	function (csrfToken, tourTypeM) {
		if (!tourTypeM.$) {
			var tourType = tourTypeM.a;
			return $author$project$Requests$patch(
				{
					fW: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Tours$mitimesDatabaseKey(tourType),
									$elm$json$Json$Encode$bool(true))
								]))),
					z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$CompleteTourResponse),
					A: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
						]),
					jR: 'api/tour_statuses'
				});
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$User$UserLogic$completeTour = F2(
	function (tour, tours) {
		switch (tour) {
			case 0:
				return _Utils_update(
					tours,
					{hj: true});
			case 1:
				return _Utils_update(
					tours,
					{hi: true});
			case 2:
				return _Utils_update(
					tours,
					{hg: true});
			default:
				return _Utils_update(
					tours,
					{hh: true});
		}
	});
var $author$project$User$UserLogic$updateUserTours = F2(
	function (user, tours) {
		return _Utils_update(
			user,
			{cI: tours});
	});
var $author$project$User$UserLogic$completeUserTour = F2(
	function (tour, user) {
		return A2(
			$elm$core$Maybe$withDefault,
			user,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$CoreX$Basics$flip, $author$project$User$UserLogic$completeTour, user.cI),
					$author$project$User$UserLogic$updateUserTours(user)),
				tour));
	});
var $author$project$Ports$EventTracking$MergeEvent = function (a) {
	return {$: 16, a: a};
};
var $author$project$TimesheetPage$Messages$ConsolidateFeeResponse = function (a) {
	return {$: 68, a: a};
};
var $author$project$Timesheet$Requests$consolidate = F4(
	function (feeType, csrfToken, feeIds, activityIds) {
		var encodedFeeTypeId = A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2(
				$elm$core$Maybe$map,
				function (ft) {
					return $elm$json$Json$Encode$int(ft.aC);
				},
				feeType));
		var encodedFeeIds = A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, feeIds);
		var encodedActivityIds = A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, activityIds);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('fee_ids', encodedFeeIds),
						_Utils_Tuple2('activity_ids', encodedActivityIds),
						_Utils_Tuple2('fee_type_id', encodedFeeTypeId)
					])));
		return $author$project$Requests$post(
			{
				fW: body,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$ConsolidateFeeResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/consolidate'
			});
	});
var $author$project$Activities$ActivityLogic$getActivityType = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 0:
			return 0;
		case 4:
			return 2;
		case 2:
			switch (_v0.a) {
				case 0:
					var _v1 = _v0.a;
					return 3;
				case 1:
					var _v2 = _v0.a;
					return 4;
				default:
					var _v3 = _v0.a;
					return 5;
			}
		case 3:
			return 6;
		case 1:
			var _v4 = _v0.a;
			return 1;
		default:
			return 8;
	}
};
var $author$project$Activities$Model$ActivityType$stringFromActivityType = function (activityType) {
	switch (activityType) {
		case 7:
			return 'ConsolidatedEmails';
		case 6:
			return 'Email';
		case 0:
			return 'Appointment';
		case 2:
			return 'Phonecall';
		case 1:
			return 'MSTeamsCall';
		case 3:
			return 'Drafting';
		case 4:
			return 'Drafted';
		case 5:
			return 'Reading';
		case 8:
			return 'Web Research';
		default:
			return 'Merged Fees';
	}
};
var $author$project$Activities$ActivityLogic$kindToString = function (activity) {
	return $author$project$Activities$Model$ActivityType$stringFromActivityType(
		$author$project$Activities$ActivityLogic$getActivityType(activity));
};
var $author$project$Ports$EventTracking$getMergeEvent = F2(
	function (fees, confirmationRequired) {
		var feeCount = $elm$core$List$length(fees);
		var activityTypes = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fG;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Activities$ActivityLogic$kindToString),
						$elm$core$Maybe$withDefault('No Activity'))),
				fees));
		var activityType = function () {
			if (activityTypes.b && (!activityTypes.b.b)) {
				var soloType = activityTypes.a;
				return soloType;
			} else {
				return 'Multiple';
			}
		}();
		if (!confirmationRequired) {
			return _Utils_Tuple3('Checkbox Merge', activityType, feeCount);
		} else {
			return _Utils_Tuple3('Inline Merge', activityType, feeCount);
		}
	});
var $author$project$TimesheetPage$Update$consolidateFees = F2(
	function (confirmationRequired, model) {
		var _v0 = function () {
			var fT = function () {
				var _v1 = model.a4;
				if (!_v1.$) {
					var mergeFees = _v1.a;
					return A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aa;
						},
						mergeFees.eZ.e0);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			return _Utils_Tuple3(
				fT,
				$elm$core$Set$toList(model.aY.gj),
				model.fI.cp);
		}();
		var feeType = _v0.a;
		var feeIds = _v0.b;
		var activityIds = _v0.c;
		var fees = A2($author$project$Timesheet$FeeLogic$listMatchingIds, feeIds, model.aY);
		var trackEvent = A2($author$project$Ports$EventTracking$getMergeEvent, fees, confirmationRequired);
		var trackCmd = $author$project$Ports$EventTracking$trackEventFor(
			$author$project$Ports$EventTracking$MergeEvent(trackEvent));
		return A2(
			$Fresheyeball$elm_return$Return$command,
			trackCmd,
			A2(
				$Fresheyeball$elm_return$Return$command,
				A4(
					$author$project$Timesheet$Requests$consolidate,
					feeType,
					model.gr,
					feeIds,
					$elm$core$Set$toList(activityIds)),
				$Fresheyeball$elm_return$Return$singleton(model)));
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Timesheet$FeeLogic$getLatestFee = function (fees) {
	return A2(
		$elm_community$list_extra$List$Extra$getAt,
		1,
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.b7;
				},
				$elm$time$Time$posixToMillis),
			fees));
};
var $author$project$Timesheet$FeeLogic$emptyFees = $rtfeldman$elm_sorter_experiment$Sort$Dict$empty($author$project$CoreX$Sorter$reverseInt);
var $elm_community$list_extra$List$Extra$notMember = function (x) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$not,
		$elm$core$List$member(x));
};
var $author$project$Timesheet$FeeLogic$removeEntries = F2(
	function (feeIds, dict) {
		var filterEntries = F2(
			function (_v1, entries) {
				return $mgold$elm_nonempty_list$List$Nonempty$fromList(
					A2(
						$elm$core$List$filter,
						function (f) {
							return A2($elm_community$list_extra$List$Extra$notMember, f.aC, feeIds);
						},
						$mgold$elm_nonempty_list$List$Nonempty$toList(entries)));
			});
		return A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$foldr,
			F3(
				function (k, v, acc) {
					if (v.$ === 1) {
						return acc;
					} else {
						var e = v.a;
						return A3($rtfeldman$elm_sorter_experiment$Sort$Dict$insert, k, e, acc);
					}
				}),
			$author$project$Timesheet$FeeLogic$emptyFees,
			A2($rtfeldman$elm_sorter_experiment$Sort$Dict$map, filterEntries, dict));
	});
var $author$project$Timesheet$FeeLogic$removeFees = F2(
	function (feeIds, fees) {
		var entries = A2($author$project$Timesheet$FeeLogic$removeEntries, feeIds, fees.$7);
		var deselectIf = F2(
			function (selectedFeeId, bool) {
				return bool ? $elm$core$Maybe$Nothing : selectedFeeId;
			});
		var deletingSelectedFee = A2(
			$elm$core$Maybe$andThen,
			deselectIf(fees.e1),
			A2(
				$elm$core$Maybe$map,
				function (id) {
					return A2($elm$core$List$member, id, feeIds);
				},
				fees.e1));
		var deletedFees = fees.dc;
		var addToDeletedFeesField = _Utils_update(
			deletedFees,
			{
				dD: _Utils_ap(feeIds, deletedFees.dD)
			});
		return _Utils_update(
			fees,
			{dc: addToDeletedFeesField, $7: entries, e1: deletingSelectedFee});
	});
var $author$project$ActivityFeedLogic$setActivities = F2(
	function (newActivities, activityFeed) {
		return _Utils_update(
			activityFeed,
			{fF: newActivities});
	});
var $author$project$ActivityFeedLogic$asActivitiesIn = F2(
	function (b, a) {
		return A2($author$project$ActivityFeedLogic$setActivities, a, b);
	});
var $author$project$ActivityFeedLogic$removeFromActivities = F2(
	function (model, activities) {
		return A2(
			$author$project$ActivityFeedLogic$asActivitiesIn,
			model,
			A3($elm$core$List$foldl, $elm_community$list_extra$List$Extra$remove, model.fF, activities));
	});
var $author$project$ActivityFeedLogic$removeFromActivityIds = F2(
	function (model, activityIds) {
		return A2(
			$author$project$ActivityFeedLogic$removeFromActivities,
			model,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aC;
					},
					A2($author$project$CoreX$Basics$flip, $elm$core$Set$member, activityIds)),
				model.fF));
	});
var $author$project$TimesheetPage$Update$resetSelectedForMerge = function (model) {
	var fees = model.aY;
	var updatedFees = _Utils_update(
		fees,
		{gj: $elm$core$Set$empty});
	var activityFeed = model.fI;
	var updatedActivityFeed = _Utils_update(
		activityFeed,
		{cp: $elm$core$Set$empty});
	return _Utils_update(
		model,
		{fI: updatedActivityFeed, aY: updatedFees, a4: $author$project$Components$MergeFees$Model$close});
};
var $author$project$TimesheetPage$Update$consolidateFeesResponse = F3(
	function (zone, response, model) {
		var selectedFeeIds = $elm$core$Set$toList(model.aY.gj);
		var selectedActivityIds = model.fI.cp;
		var updatedModel = _Utils_update(
			model,
			{
				fI: A2($author$project$ActivityFeedLogic$removeFromActivityIds, model.fI, selectedActivityIds),
				aY: A2($author$project$Timesheet$FeeLogic$removeFees, selectedFeeIds, model.aY)
			});
		var fees = A2($author$project$Timesheet$FeeLogic$listMatchingIds, selectedFeeIds, updatedModel.aY);
		var modelWithTemporaryPlaceholder = A2(
			$elm$core$Maybe$withDefault,
			updatedModel,
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return _Utils_update(
						updatedModel,
						{
							aY: A3($author$project$Timesheet$FeeLogic$addFeeInSort, zone, f, updatedModel.aY)
						});
				},
				A2(
					$elm$core$Maybe$map,
					function (f) {
						return _Utils_update(
							f,
							{
								ju: $elm$core$Maybe$Just(
									$elm$core$String$fromInt(f.aC))
							});
					},
					$author$project$Timesheet$FeeLogic$getLatestFee(fees))));
		return A3(
			$author$project$CoreX$Basics$flip,
			A2($author$project$TimesheetPage$Update$addFeeFromCreateFeeResponse, zone, response),
			false,
			$author$project$TimesheetPage$Update$resetSelectedForMerge(modelWithTemporaryPlaceholder));
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.eE;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$TimesheetPage$Update$convertDateIsoToDate = function (dateString) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(dateString);
	if (!_v0.$) {
		var date = _v0.a;
		return $elm$core$Maybe$Just(date);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$ContactModal$ContactModalLogic$hasConflictingContact = function (contactModal) {
	var _v0 = contactModal.c1;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$ContactModal$Requests$activitylessContactAttrs = function (modal) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'given_name',
			$elm$json$Json$Encode$string(modal.hf)),
			_Utils_Tuple2(
			'surname',
			$elm$json$Json$Encode$string(modal.jo)),
			_Utils_Tuple2(
			'email_address',
			$elm$json$Json$Encode$string(modal.dl)),
			_Utils_Tuple2(
			'phone_number',
			$elm$json$Json$Encode$string(modal.iH)),
			_Utils_Tuple2(
			'company_name',
			$elm$json$Json$Encode$string(modal.gh)),
			_Utils_Tuple2(
			'notes',
			$elm$json$Json$Encode$string(modal.ik)),
			_Utils_Tuple2(
			'job_title',
			$elm$json$Json$Encode$string(modal.hO)),
			_Utils_Tuple2(
			'force_create',
			$elm$json$Json$Encode$bool(
				$author$project$Components$ContactModal$ContactModalLogic$hasConflictingContact(modal)))
		]);
};
var $author$project$Components$ContactModal$Requests$newContactObject = F2(
	function (activity, modal) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				$author$project$Components$ContactModal$Requests$activitylessContactAttrs(modal),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'activity_id',
						$elm$json$Json$Encode$int(activity.aC))
					])));
	});
var $author$project$TimesheetPage$Messages$CreateContactAndUpgradeResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ContactModal$Requests$postContact = F2(
	function (csrfToken, contactObject) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('contact', contactObject)
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$CreateContactAndUpgradeResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/exchange_contacts'
			});
	});
var $author$project$Components$ContactModal$Requests$createContactAndUpgradeActivityRequest = F3(
	function (csrfToken, activity, model) {
		return A2(
			$author$project$Components$ContactModal$Requests$postContact,
			csrfToken,
			A2($author$project$Components$ContactModal$Requests$newContactObject, activity, model));
	});
var $author$project$FeeEntry$Requests$defaultDescription = function (feeType) {
	var _v0 = feeType.fT;
	if (_v0 === 2) {
		return '';
	} else {
		return feeType.dC;
	}
};
var $author$project$Model$Fee$BillingBehaviour$toString = function (billingBehaviour) {
	switch (billingBehaviour) {
		case 0:
			return 'billable';
		case 1:
			return 'billable_no_charge';
		case 2:
			return 'billable_no_charge_hidden';
		default:
			return 'not_billable';
	}
};
var $author$project$FeeEntry$Requests$newFeeObject = function (feeType) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('matter_id', $elm$json$Json$Encode$null),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(
					$author$project$FeeEntry$Requests$defaultDescription(feeType) + ' ')),
				_Utils_Tuple2(
				'units',
				$elm$json$Json$Encode$float(1.0)),
				_Utils_Tuple2(
				'billing_behaviour',
				$elm$json$Json$Encode$string(
					$author$project$Model$Fee$BillingBehaviour$toString(0))),
				_Utils_Tuple2(
				'fee_type_id',
				$elm$json$Json$Encode$int(feeType.aC))
			]));
};
var $author$project$TimesheetPage$Messages$NewManualEntryResponse = function (a) {
	return {$: 65, a: a};
};
var $author$project$FeeEntry$Requests$postNewFee = F2(
	function (csrfToken, feeObject) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('fee', feeObject)
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$NewManualEntryResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees'
			});
	});
var $author$project$FeeEntry$Requests$createFee = F2(
	function (csrfToken, feeType) {
		return A2(
			$author$project$FeeEntry$Requests$postNewFee,
			csrfToken,
			$author$project$FeeEntry$Requests$newFeeObject(feeType));
	});
var $author$project$FeeEntry$Requests$newFeeObjectWithTimer = function (feeType) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('matter_id', $elm$json$Json$Encode$null),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(
					$author$project$FeeEntry$Requests$defaultDescription(feeType) + ' ')),
				_Utils_Tuple2(
				'units',
				$elm$json$Json$Encode$float(0)),
				_Utils_Tuple2(
				'billing_behaviour',
				$elm$json$Json$Encode$string(
					$author$project$Model$Fee$BillingBehaviour$toString(0))),
				_Utils_Tuple2(
				'fee_type_id',
				$elm$json$Json$Encode$int(feeType.aC)),
				_Utils_Tuple2(
				'start_timer',
				$elm$json$Json$Encode$bool(true))
			]));
};
var $author$project$FeeEntry$Requests$createFeeWithTimer = F2(
	function (csrfToken, feeType) {
		return A2(
			$author$project$FeeEntry$Requests$postNewFee,
			csrfToken,
			$author$project$FeeEntry$Requests$newFeeObjectWithTimer(feeType));
	});
var $author$project$TimesheetPage$Messages$RunDeleteFees = {$: 12};
var $author$project$TimesheetPage$Update$debouncedDeleteFees_ = F2(
	function (model, feeIds) {
		var fees = A2($author$project$Timesheet$FeeLogic$removeFees, feeIds, model.aY);
		var updatedModel = _Utils_update(
			model,
			{aY: fees});
		var cmd = A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			$elm$core$Task$succeed(
				$author$project$TimesheetPage$Messages$QueueDeleteFees(
					$Gizra$elm_debouncer$Debouncer$Basic$provideInput($author$project$TimesheetPage$Messages$RunDeleteFees))));
		return _Utils_Tuple2(updatedModel, cmd);
	});
var $author$project$TimesheetPage$Update$debouncedDeleteFees = function (model) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$TimesheetPage$Update$debouncedDeleteFees_(model),
		$elm$core$List$map(
			function ($) {
				return $.g_;
			}));
};
var $author$project$Components$ContactModal$Model$ConflictingContactName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ContactModal$Model$NoConflict = {$: 1};
var $author$project$Components$ContactModal$Model$conflictingContactDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (input) {
		if (input.$ === 1) {
			return $elm$json$Json$Decode$succeed($author$project$Components$ContactModal$Model$NoConflict);
		} else {
			var contactName = input.a;
			return $elm$json$Json$Decode$succeed(
				$author$project$Components$ContactModal$Model$ConflictingContactName(contactName));
		}
	},
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Components$ContactModal$Model$decodeConflictingContact = function (value) {
	return A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'existingContactName', $author$project$Components$ContactModal$Model$conflictingContactDecoder),
		value);
};
var $author$project$TimesheetPage$Messages$DeconsolidateFeeResponse = function (a) {
	return {$: 69, a: a};
};
var $author$project$Timesheet$Requests$deconsolidate = F2(
	function (deconsolidatedFeeId, csrfToken) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$DeconsolidateFeeResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(deconsolidatedFeeId) + '/deconsolidate')
			});
	});
var $author$project$Timesheet$Requests$deconsolidateAll = F2(
	function (feeId, csrfToken) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$SetFlashMessageHttp),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(feeId) + '/deconsolidate_all')
			});
	});
var $author$project$TimesheetPage$Messages$DeleteFeesResponse = function (a) {
	return {$: 74, a: a};
};
var $author$project$Timesheet$Requests$encodeFeeIdsBody = function (feeIds) {
	var encodedFeeIds = A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, feeIds);
	return $elm$http$Http$jsonBody(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('fee_ids', encodedFeeIds)
				])));
};
var $author$project$Timesheet$Requests$deleteFees = F2(
	function (csrfToken, feeIds) {
		return $author$project$Requests$delete(
			{
				fW: $author$project$Timesheet$Requests$encodeFeeIdsBody(feeIds),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$DeleteFeesResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/batch_delete'
			});
	});
var $author$project$FeeEntry$FeeEntryLogic$descriptionForContact = F2(
	function (feeTypeDescription, contactName) {
		return $elm$core$String$trim(
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					$elm$core$String$trim,
					_List_fromArray(
						[feeTypeDescription, contactName]))));
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Timesheet$ConsolidateUpdateLogic$setConsolidatedFeeId = function (consolidateState) {
	if (!consolidateState) {
		return $elm$core$Set$insert;
	} else {
		return $elm$core$Set$remove;
	}
};
var $author$project$Timesheet$ConsolidateUpdateLogic$updateConsolidatedFeeIds = F2(
	function (fees, feeIds) {
		return _Utils_update(
			fees,
			{gj: feeIds});
	});
var $author$project$Timesheet$ConsolidateUpdateLogic$updateFeesForMerge = F3(
	function (feeIds, consolidateState, model) {
		var updatedFees = A2(
			$author$project$Timesheet$ConsolidateUpdateLogic$updateConsolidatedFeeIds,
			model.aY,
			A3(
				$elm$core$List$foldl,
				$author$project$Timesheet$ConsolidateUpdateLogic$setConsolidatedFeeId(consolidateState),
				model.aY.gj,
				feeIds));
		return $author$project$Timesheet$ConsolidateUpdateLogic$setMergeFees(
			_Utils_update(
				model,
				{aY: updatedFees}));
	});
var $author$project$Timesheet$ConsolidateUpdateLogic$deselectFeesForMerge = F2(
	function (feeIds, model) {
		return A3($author$project$Timesheet$ConsolidateUpdateLogic$updateFeesForMerge, feeIds, 1, model);
	});
var $author$project$Timesheet$ConsolidateUpdateLogic$deselectSingleFeeForMerge = F2(
	function (feeId, model) {
		return A2(
			$author$project$Timesheet$ConsolidateUpdateLogic$deselectFeesForMerge,
			$elm$core$List$singleton(feeId),
			model);
	});
var $author$project$TimesheetPage$Messages$DowngradeToActivitiesResponse = function (a) {
	return {$: 18, a: a};
};
var $author$project$Timesheet$Requests$downgradeToActivities = F2(
	function (csrfToken, contactId) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$DowngradeToActivitiesResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/contacts/' + ($elm$core$String$fromInt(contactId) + '/downgrade_to_sometimes')
			});
	});
var $author$project$Components$UiInfoAlerts$Data$feeMergingAlert = {bm: false, go: 'Please be aware that you are trying to merge fees that have been assigned different matters. You may continue or cancel this action if this was an error.', bs: 1, jB: 'Selected fees have different matters'};
var $author$project$TimesheetPage$Messages$FetchedFeeCounts = function (a) {
	return {$: 53, a: a};
};
var $author$project$Timesheet$Requests$feeFilterParam = function (feeFilterState) {
	if (feeFilterState.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var feeFilter = feeFilterState.a;
		return $elm$core$Maybe$Just(
			$author$project$FeeFilter$feeFilterString(feeFilter));
	}
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {gA: d, h9: m, j$: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		cc: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		j$: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.j$, 0, date.cc);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.gA;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.h9;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.cc;
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		fs: 1 + (((rd - week1Day1) / 7) | 0),
		ft: wy,
		jX: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.fs;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ft;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.a7(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.b1(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.a7(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.bt(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.ah(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.ah(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.ah(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.cM(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ah(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.ah(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.c, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	bt: $justinmimbs$date$Date$withOrdinalSuffix,
	b1: $justinmimbs$date$Date$monthToName,
	a7: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	cM: $justinmimbs$date$Date$weekdayToName,
	ah: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Timesheet$Requests$forDateParam = function (showDate) {
	return A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, showDate);
};
var $author$project$Timesheet$Requests$fetchFeeCounts = function (feeSearchConfiguration) {
	return $elm$http$Http$get(
		{
			z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$TimesheetPage$Messages$FetchedFeeCounts, $author$project$Model$FeeCounts$decodeFeeCounts),
			jR: A2(
				$author$project$Requests$toUrl,
				'api/fee_counts',
				_List_fromArray(
					[
						A2($author$project$Requests$Param, 'query', feeSearchConfiguration.i2),
						A2(
						$author$project$Requests$Param,
						'for_date',
						$author$project$Timesheet$Requests$forDateParam(feeSearchConfiguration.dN)),
						A2(
						$author$project$Requests$Param,
						'fee_filter',
						$author$project$Timesheet$Requests$feeFilterParam(feeSearchConfiguration.g9))
					]))
		});
};
var $author$project$TimesheetPage$Update$fetchFeeCountsCmd = function (_v0) {
	var feeSearchConfiguration = _v0.g$;
	return $author$project$Timesheet$Requests$fetchFeeCounts(feeSearchConfiguration);
};
var $author$project$TimesheetPage$Messages$FetchedFees = function (a) {
	return {$: 48, a: a};
};
var $author$project$Model$Fee$decodeFees = $elm$json$Json$Decode$list($author$project$Model$Fee$decodeFee);
var $author$project$Timesheet$Requests$beforeTimeParam = function (fee) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$CoreX$DateFormat$toUtcIsoString,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.b7;
			},
			fee));
};
var $author$project$Timesheet$Requests$excludeIdsParam = function (ids) {
	return A2(
		$elm$core$List$map,
		function (id) {
			return A2(
				$author$project$Requests$Param,
				'exclude_ids[]',
				$elm$core$Maybe$Just(id));
		},
		A2($elm$core$List$map, $elm$core$String$fromInt, ids));
};
var $author$project$Timesheet$Requests$fetchFeesUrlFor = F3(
	function (fee, excludedFeeIds, feeSearchConfiguration) {
		var time_params = A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A2(
					$author$project$Requests$Param,
					'before_time',
					$author$project$Timesheet$Requests$beforeTimeParam(fee))
				]),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return _List_fromArray(
						[
							A2(
							$author$project$Requests$Param,
							'for_date',
							$author$project$Timesheet$Requests$forDateParam(feeSearchConfiguration.dN))
						]);
				},
				feeSearchConfiguration.dN));
		return A2(
			$author$project$Requests$toUrl,
			'api/fees',
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Requests$Param, 'query', feeSearchConfiguration.i2),
						A2(
						$author$project$Requests$Param,
						'fee_filter',
						$author$project$Timesheet$Requests$feeFilterParam(feeSearchConfiguration.g9))
					]),
				_Utils_ap(
					$author$project$Timesheet$Requests$excludeIdsParam(excludedFeeIds),
					time_params)));
	});
var $author$project$Timesheet$Requests$fetchFees = function (feeSearchConfiguration) {
	return $elm$http$Http$get(
		{
			z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$TimesheetPage$Messages$FetchedFees, $author$project$Model$Fee$decodeFees),
			jR: A3($author$project$Timesheet$Requests$fetchFeesUrlFor, $elm$core$Maybe$Nothing, _List_Nil, feeSearchConfiguration)
		});
};
var $author$project$TimesheetPage$Update$fetchFeesCmd = function (_v0) {
	var feeSearchConfiguration = _v0.g$;
	return $author$project$Timesheet$Requests$fetchFees(feeSearchConfiguration);
};
var $author$project$TimesheetPage$Messages$FetchedMoreFees = function (a) {
	return {$: 49, a: a};
};
var $author$project$Timesheet$Requests$fetchFeesFor = F2(
	function (date, feeSearchConfiguration) {
		return $elm$http$Http$get(
			{
				z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$TimesheetPage$Messages$FetchedMoreFees, $author$project$Model$Fee$decodeFees),
				jR: A3(
					$author$project$Timesheet$Requests$fetchFeesUrlFor,
					$elm$core$Maybe$Nothing,
					_List_Nil,
					_Utils_update(
						feeSearchConfiguration,
						{
							dN: $elm$core$Maybe$Just(date)
						}))
			});
	});
var $author$project$CoreX$DateCompare$equal = F2(
	function (a, b) {
		return _Utils_eq(
			$elm$time$Time$posixToMillis(a),
			$elm$time$Time$posixToMillis(b));
	});
var $author$project$Timesheet$FeeLogic$getFeesBy = F2(
	function (fetcher, fees) {
		return A2(
			$elm$core$List$filter,
			fetcher,
			A3(
				$elm$core$List$foldr,
				A2($elm$core$Basics$composeR, $mgold$elm_nonempty_list$List$Nonempty$toList, $elm$core$Basics$append),
				_List_Nil,
				$rtfeldman$elm_sorter_experiment$Sort$Dict$values(fees.$7)));
	});
var $author$project$TimesheetPage$Update$feeIdsWithSameOccurrenceTime = F2(
	function (fee, fees) {
		var equalOccurredAt = F2(
			function (maybeFee, f2) {
				if (maybeFee.$ === 1) {
					return false;
				} else {
					var f1 = maybeFee.a;
					return A2($author$project$CoreX$DateCompare$equal, f1.b7, f2.b7);
				}
			});
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.aC;
			},
			A2(
				$author$project$Timesheet$FeeLogic$getFeesBy,
				equalOccurredAt(fee),
				fees));
	});
var $author$project$Timesheet$Requests$fetchFeesBefore = F3(
	function (fee, excludedFeeIds, feeSearchConfiguration) {
		return $elm$http$Http$get(
			{
				z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$TimesheetPage$Messages$FetchedMoreFees, $author$project$Model$Fee$decodeFees),
				jR: A3($author$project$Timesheet$Requests$fetchFeesUrlFor, fee, excludedFeeIds, feeSearchConfiguration)
			});
	});
var $author$project$TimesheetPage$Update$fetchMoreFeesCmd = function (_v0) {
	var fees = _v0.aY;
	var feeSearchConfiguration = _v0.g$;
	var excludedFeeIds = A2($author$project$TimesheetPage$Update$feeIdsWithSameOccurrenceTime, fees.cV, fees);
	return A3($author$project$Timesheet$Requests$fetchFeesBefore, fees.cV, excludedFeeIds, feeSearchConfiguration);
};
var $author$project$TimesheetPage$Messages$UpdateFeeResponse = F2(
	function (a, b) {
		return {$: 71, a: a, b: b};
	});
var $author$project$Timesheet$Requests$fileEmail = F3(
	function (csrfToken, fee, library) {
		var body = function () {
			if (!library.$) {
				var lib = library.a;
				return $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'library',
								$elm$json$Json$Encode$string(lib))
							])));
			} else {
				return $elm$http$Http$emptyBody;
			}
		}();
		return $author$project$Requests$post(
			{
				fW: body,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/file_email')
			});
	});
var $author$project$Timesheet$FeeLogic$filterEntriesBy = F2(
	function (filter, entries) {
		return A2(
			$elm$core$Maybe$withDefault,
			entries,
			$mgold$elm_nonempty_list$List$Nonempty$fromList(
				A2(
					$elm$core$List$filter,
					filter,
					$mgold$elm_nonempty_list$List$Nonempty$toList(entries))));
	});
var $author$project$Timesheet$FeeLogic$filterFees = F2(
	function (filter, fees) {
		return A2(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$map,
			F2(
				function (_v0, e) {
					return A2($author$project$Timesheet$FeeLogic$filterEntriesBy, filter, e);
				}),
			fees);
	});
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $author$project$FeeTypeLogic$getById = F2(
	function (id, feeTypes) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (f) {
				return _Utils_eq(f.aC, id);
			},
			feeTypes);
	});
var $author$project$Activities$ActivityLogic$getDuration = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 3:
			var ea = _v0.a;
			return ea.X;
		case 4:
			var ph = _v0.a;
			return $elm$core$Maybe$Just(ph.X);
		case 0:
			var appt = _v0.a;
			return $elm$core$Maybe$Just(appt.X);
		case 1:
			var _v1 = _v0.a;
			var call = _v0.b;
			return $elm$core$Maybe$Just(call.X);
		case 2:
			var doc = _v0.b;
			return $elm$core$Maybe$Just(doc.X);
		default:
			var event = _v0.a;
			return event.X;
	}
};
var $author$project$Components$DurationInput$DurationInputLogic$totalMinutesToDuration = function (totalMins) {
	var hours = (totalMins / 60) | 0;
	var mins = (hours > 23) ? 59 : (totalMins % 60);
	return {_: hours, aF: mins};
};
var $author$project$Components$DurationInput$DurationInputLogic$getHoursAndMinutes = F2(
	function (units, minutesPerUnit) {
		var minutesPer = minutesPerUnit;
		var totalMins = $elm$core$Basics$ceiling(units * minutesPer);
		return $author$project$Components$DurationInput$DurationInputLogic$totalMinutesToDuration(totalMins);
	});
var $author$project$ErrorLogic$getHttpError = function (error) {
	switch (error.$) {
		case 0:
			var string = error.a;
			return $elm$http$Http$BadUrl('Looks like ' + (string + ' cannot be found.'));
		case 1:
			return $elm$http$Http$Timeout;
		case 2:
			return $elm$http$Http$NetworkError;
		case 3:
			var metadata = error.a;
			return $elm$http$Http$BadStatus(metadata.e9);
		default:
			var body = error.b;
			return $elm$http$Http$BadBody(body);
	}
};
var $author$project$Direction$Previous = 1;
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $rtfeldman$elm_sorter_experiment$Sort$alphabetical = $elm$core$Basics$compare;
var $mgold$elm_nonempty_list$List$Nonempty$head = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return x;
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$GroupBy$compareConversationDates = F3(
	function (getDate, fstLst, sndLst) {
		var snd = $mgold$elm_nonempty_list$List$Nonempty$head(sndLst.b);
		var fst = $mgold$elm_nonempty_list$List$Nonempty$head(fstLst.b);
		return A2(
			$author$project$CoreX$DateCompare$compare_,
			getDate(snd),
			getDate(fst));
	});
var $mgold$elm_nonempty_list$List$Nonempty$insertWith = F3(
	function (cmp, hd, aList) {
		if (aList.b) {
			var x = aList.a;
			var xs = aList.b;
			return (!A2(cmp, x, hd)) ? A2(
				$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
				x,
				A2(
					$elm$core$List$sortWith,
					cmp,
					A2($elm$core$List$cons, hd, xs))) : A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, hd, aList);
		} else {
			return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, hd, _List_Nil);
		}
	});
var $mgold$elm_nonempty_list$List$Nonempty$sortWith = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A3(
			$mgold$elm_nonempty_list$List$Nonempty$insertWith,
			f,
			x,
			A2($elm$core$List$sortWith, f, xs));
	});
var $author$project$GroupBy$conversation = F3(
	function (getDate, getConversationGroupKey, items) {
		var sortConversations = $elm$core$List$sortWith(
			$author$project$GroupBy$compareConversationDates(getDate));
		var itemDateCompare = F2(
			function (a, b) {
				return A2(
					$author$project$CoreX$DateCompare$compare_,
					getDate(b),
					getDate(a));
			});
		return sortConversations(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$toList(
				A2(
					$rtfeldman$elm_sorter_experiment$Sort$Dict$map,
					F2(
						function (_v0, e) {
							return A2($mgold$elm_nonempty_list$List$Nonempty$sortWith, itemDateCompare, e);
						}),
					A3(
						$author$project$GroupBy$groupBy,
						$rtfeldman$elm_sorter_experiment$Sort$reverse($rtfeldman$elm_sorter_experiment$Sort$alphabetical),
						getConversationGroupKey,
						items))));
	});
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $author$project$Timesheet$FeeLogic$getNextFee = F4(
	function (zone, fee, fees, direction) {
		var reverseWhenPrevious = F2(
			function (dir, fs) {
				return (dir === 1) ? $elm$core$List$reverse(fs) : fs;
			});
		var orderedFees = A2(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$map,
			F2(
				function (rataDie, entries) {
					return $elm$core$List$concat(
						A2(
							$elm$core$List$map,
							function (_v0) {
								var nonEmptyFees = _v0.b;
								return $mgold$elm_nonempty_list$List$Nonempty$toList(nonEmptyFees);
							},
							A3(
								$author$project$GroupBy$conversation,
								function ($) {
									return $.b7;
								},
								$author$project$Timesheet$FeeLogic$groupByKey(zone),
								entries)));
				}),
			fees.$7);
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				reverseWhenPrevious(direction),
				A2(
					$elm$core$Basics$composeR,
					$elm_community$list_extra$List$Extra$dropWhile(
						function (f) {
							return !_Utils_eq(f.aC, fee.aC);
						}),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$drop(1),
						$elm$core$List$head))),
			A2(
				$rtfeldman$elm_sorter_experiment$Sort$Dict$get,
				A2($author$project$CoreX$RataDie$fromPosix, zone, fee.b7),
				orderedFees));
	});
var $author$project$FeeEntry$Messages$ScaleItemsLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$FeeEntry$Requests$getScaleItems = function (fee) {
	var params = _List_fromArray(
		[
			A2(
			$author$project$Requests$Param,
			'fee_id',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(fee.aC)))
		]);
	return _Utils_eq(fee.hY, $elm$core$Maybe$Nothing) ? A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(
			A4($author$project$TimesheetPage$Messages$SetFlashMessage, 'Please select a matter', 2, 3, _List_Nil))) : $elm$http$Http$get(
		{
			z: A2(
				$jzxhuang$http_extras$Http$Detailed$expectJson,
				A2(
					$elm$core$Basics$composeL,
					$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
					$author$project$FeeEntry$Messages$ScaleItemsLoaded),
				$elm$json$Json$Decode$list($author$project$Model$ScaleItem$decodeScaleItem)),
			jR: A2($author$project$Requests$toUrl, 'api/scale_items', params)
		});
};
var $author$project$Activities$Requests$restoreActivities = F2(
	function (csrfToken, ids) {
		return $author$project$Requests$patch(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'activity_ids',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, ids))
							]))),
				z: $elm$http$Http$expectWhatever($author$project$TimesheetPage$Messages$IgnoreResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: '/api/activities/batch_restore'
			});
	});
var $author$project$Timesheet$Requests$restoreFees = F2(
	function (csrfToken, feeIds) {
		return $author$project$Requests$patch(
			{
				fW: $author$project$Timesheet$Requests$encodeFeeIdsBody(feeIds),
				z: $elm$http$Http$expectWhatever($author$project$TimesheetPage$Messages$IgnoreResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/batch_restore'
			});
	});
var $author$project$TimesheetPage$Update$handleUndo = F3(
	function (model, entityType, entityIds) {
		switch (entityType) {
			case 0:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent('Activities Restored'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$Activities$Requests$restoreActivities, model.gr, entityIds),
						$Fresheyeball$elm_return$Return$singleton(model)));
			case 1:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent('Fees Restored'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$Timesheet$Requests$restoreFees, model.gr, entityIds),
						$Fresheyeball$elm_return$Return$singleton(model)));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Fee$feeDecoder = function (value) {
	return A2(
		$elm$json$Json$Decode$decodeString,
		A2($elm$json$Json$Decode$field, 'fee', $author$project$Model$Fee$decodeFee),
		value);
};
var $author$project$Timesheet$FeeLogic$isSelectedFee = F2(
	function (fee, fees) {
		return _Utils_eq(
			fees.e1,
			$elm$core$Maybe$Just(fee.aC));
	});
var $author$project$Ports$InputControl$setValueOf = _Platform_outgoingPort(
	'setValueOf',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$TimesheetPage$Update$refreshDescriptionIfSelected = F2(
	function (fee, m) {
		var descriptionValue = A2($elm$core$Maybe$withDefault, '', fee.dd);
		return A2($author$project$Timesheet$FeeLogic$isSelectedFee, fee, m.aY) ? $author$project$Ports$InputControl$setValueOf(
			_Utils_Tuple2('fee-entry-description', descriptionValue)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Timesheet$FeeLogic$updateFee = F2(
	function (newFee, oldFee) {
		return _Utils_update(
			oldFee,
			{fD: newFee.fD, aO: newFee.aO, fG: newFee.fG, bp: newFee.bp, fS: newFee.fS, gm: newFee.gm, dd: newFee.dd, gC: newFee.gC, dy: newFee.dy, dz: newFee.dz, g0: newFee.g0, aB: newFee.aB, aC: newFee.aC, d4: newFee.d4, hY: newFee.hY, b7: newFee.b7, ip: newFee.ip, eD: newFee.eD, bd: newFee.bd, jc: newFee.jc, ad: $elm$core$Maybe$Nothing, fi: newFee.fi, cE: newFee.cE, js: $elm$core$Maybe$Nothing, jt: $elm$core$Maybe$Nothing, cG: newFee.cG, jA: newFee.jA, jP: newFee.jP, cK: newFee.cK});
	});
var $author$project$Timesheet$FeeLogic$updateFeeWith = F3(
	function (updater, newFee, fees) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			$author$project$CoreX$Predicate$hasId(newFee.aC),
			updater(newFee),
			fees);
	});
var $author$project$Timesheet$FeeLogic$replaceFeeData = F4(
	function (zone, oldFee, newFee, entries) {
		var rataDie = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, newFee);
		var dateHasChanged = !_Utils_eq(
			A2($author$project$Timesheet$FeeLogic$getRataDie, zone, newFee),
			A2($author$project$Timesheet$FeeLogic$getRataDie, zone, oldFee));
		return dateHasChanged ? A3(
			$author$project$Timesheet$FeeLogic$addEntryInSort,
			zone,
			newFee,
			A2(
				$author$project$Timesheet$FeeLogic$removeEntries,
				_List_fromArray(
					[oldFee.aC]),
				entries)) : A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$update,
			rataDie,
			$elm$core$Maybe$andThen(
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$toList,
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Timesheet$FeeLogic$updateFeeWith, $author$project$Timesheet$FeeLogic$updateFee, newFee),
						$mgold$elm_nonempty_list$List$Nonempty$fromList))),
			entries);
	});
var $author$project$Timesheet$FeeLogic$replaceOrInsert = F3(
	function (zone, fee, fees) {
		var _v0 = A2($author$project$Timesheet$FeeLogic$findFeeById, fee.aC, fees);
		if (!_v0.$) {
			var oldFee = _v0.a;
			return _Utils_update(
				fees,
				{
					$7: A4($author$project$Timesheet$FeeLogic$replaceFeeData, zone, oldFee, fee, fees.$7)
				});
		} else {
			return A3($author$project$Timesheet$FeeLogic$addFeeInSort, zone, fee, fees);
		}
	});
var $author$project$Ports$Scroll$Center = 1;
var $author$project$Ports$Scroll$scrollIntoView = function (id) {
	return $author$project$Ports$Scroll$intoView(
		$author$project$Ports$Scroll$encodeIntoViewParameters(
			{aC: id, bk: 1}));
};
var $author$project$TimesheetPage$Update$scrollTo = function (id) {
	return $author$project$Ports$Scroll$scrollIntoView(id);
};
var $author$project$Activities$ActivityLogic$getDocumentFileName = function (doc) {
	return $elm$core$String$isEmpty(doc.dv) ? doc.b2 : (doc.b2 + ('.' + doc.dv));
};
var $author$project$Activities$ActivityLogic$getTitle = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 3:
			var email = _v0.a;
			return email.cB;
		case 4:
			var phone = _v0.a;
			return phone.a9;
		case 1:
			var _v1 = _v0.a;
			var call = _v0.b;
			return call.ai;
		case 0:
			var appt = _v0.a;
			return appt.cB;
		case 2:
			var doc = _v0.b;
			return $author$project$Activities$ActivityLogic$getDocumentFileName(doc);
		default:
			var research = _v0.a;
			return A2($elm$core$Maybe$withDefault, research.aR, research.iD);
	}
};
var $author$project$Timesheet$FeeSearchConfigurationLogic$getActivityTerms = function (activity) {
	var _v0 = activity.i;
	if (_v0.$ === 1) {
		return '';
	} else {
		return $author$project$Activities$ActivityLogic$getTitle(activity);
	}
};
var $author$project$Contacts$ContactLogic$getSearchTerms = function (contact) {
	return _Utils_ap(contact.b2, contact.gh);
};
var $author$project$MatterLogic$matterTitle = function (matter) {
	return A2($elm$core$Maybe$withDefault, '', matter.br) + (' ' + (matter.dd + (' (' + (matter.gd + ')'))));
};
var $author$project$Timesheet$FeeSearchConfigurationLogic$getFeeSearchTerms = function (fee) {
	var matterTerms = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$MatterLogic$matterTitle, fee.hY));
	var feeDesc = A2($elm$core$Maybe$withDefault, '', fee.dd);
	var contactTerms = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Contacts$ContactLogic$getSearchTerms,
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return a.c2;
				},
				fee.fG)));
	var activityTerms = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Timesheet$FeeSearchConfigurationLogic$getActivityTerms, fee.fG));
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[feeDesc, matterTerms, activityTerms, contactTerms]));
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {d0: index, bX: match, a9: number, jl: submatches};
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$String$words = _String_words;
var $author$project$Timesheet$FeeSearchConfigurationLogic$isInTerms = F2(
	function (terms, feeSearchTerms) {
		var regexString = A2(
			$elm$core$String$join,
			'|',
			$elm$core$String$words(
				$elm$core$String$trim(terms)));
		var pattern = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{cZ: true, en: false},
				'(' + (regexString + ')')));
		var matches = A2($elm$regex$Regex$find, pattern, feeSearchTerms);
		return !$elm$core$List$isEmpty(matches);
	});
var $author$project$Timesheet$FeeSearchConfigurationLogic$feeInSearchConfiguration = F2(
	function (feeSearchConfiguration, fee) {
		var _v0 = _Utils_Tuple2(feeSearchConfiguration.i1, feeSearchConfiguration.i2);
		if ((!_v0.a) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var terms = _v0.b.a;
			var feeTerms = $author$project$Timesheet$FeeSearchConfigurationLogic$getFeeSearchTerms(fee);
			return A2($author$project$Timesheet$FeeSearchConfigurationLogic$isInTerms, terms, feeTerms);
		} else {
			return true;
		}
	});
var $author$project$Timesheet$FeeSearchConfigurationLogic$isSameDate = F3(
	function (zone, fee, date) {
		var feeRataDie = A2($author$project$CoreX$RataDie$fromPosix, zone, fee.b7);
		var dateRataDie = $justinmimbs$date$Date$toRataDie(date);
		return _Utils_eq(feeRataDie, dateRataDie);
	});
var $author$project$Timesheet$FeeCountsLogic$addToFailed = F2(
	function (id, feeCounts) {
		return _Utils_update(
			feeCounts,
			{
				dx: A2($elm$core$Set$insert, id, feeCounts.dx)
			});
	});
var $author$project$Timesheet$FeeCountsLogic$addToExpiring = F2(
	function (id, feeCounts) {
		return _Utils_update(
			feeCounts,
			{
				du: A2($elm$core$Set$insert, id, feeCounts.du)
			});
	});
var $author$project$Timesheet$FeeCountsLogic$addToIncomplete = F2(
	function (id, feeCounts) {
		return _Utils_update(
			feeCounts,
			{
				d$: A2($elm$core$Set$insert, id, feeCounts.d$)
			});
	});
var $author$project$Timesheet$FeeCountsLogic$addToOnHold = F2(
	function (id, feeCounts) {
		return _Utils_update(
			feeCounts,
			{
				ip: A2($elm$core$Set$insert, id, feeCounts.ip)
			});
	});
var $author$project$Timesheet$FeeCountsLogic$addToPending = F2(
	function (id, feeCounts) {
		return _Utils_update(
			feeCounts,
			{
				ez: A2($elm$core$Set$insert, id, feeCounts.ez)
			});
	});
var $author$project$Timesheet$FeeCountsLogic$addToFeeFilterState = F3(
	function (filterState, id, feeCounts) {
		switch (filterState.$) {
			case 0:
				if (!filterState.a) {
					var _v1 = filterState.a;
					return A2(
						$author$project$Timesheet$FeeCountsLogic$addToIncomplete,
						id,
						A2($author$project$Timesheet$FeeCountsLogic$addToExpiring, id, feeCounts));
				} else {
					var _v2 = filterState.a;
					return A2($author$project$Timesheet$FeeCountsLogic$addToIncomplete, id, feeCounts);
				}
			case 1:
				return A2($author$project$Timesheet$FeeCountsLogic$addToOnHold, id, feeCounts);
			case 2:
				return A2($author$project$Timesheet$FeeCountsLogic$addToPending, id, feeCounts);
			default:
				return feeCounts;
		}
	});
var $author$project$Timesheet$FeeCountsLogic$addToFilterCount = F3(
	function (filter, id, feeCounts) {
		switch (filter.$) {
			case 0:
				return feeCounts;
			case 1:
				var feeFilterState = filter.a;
				return A2(
					$author$project$Timesheet$FeeCountsLogic$addToFailed,
					id,
					A3($author$project$Timesheet$FeeCountsLogic$addToFeeFilterState, feeFilterState, id, feeCounts));
			default:
				var feeFilterState = filter.a;
				return A3($author$project$Timesheet$FeeCountsLogic$addToFeeFilterState, feeFilterState, id, feeCounts);
		}
	});
var $author$project$Timesheet$FeeCountsLogic$PostFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Timesheet$FeeCountsLogic$Posted = {$: 0};
var $author$project$Timesheet$FeeCountsLogic$Unposted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Timesheet$FeeCountsLogic$Expiring = 0;
var $author$project$Timesheet$FeeCountsLogic$Held = {$: 1};
var $author$project$Timesheet$FeeCountsLogic$Incompleted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Timesheet$FeeCountsLogic$NoFilter = {$: 3};
var $author$project$Timesheet$FeeCountsLogic$NotExpiring = 1;
var $author$project$Timesheet$FeeCountsLogic$Pending = {$: 2};
var $author$project$Timesheet$FeeLogic$isExpiring = F4(
	function (zone, currentRataDie, days, fee) {
		var feeRataDie = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, fee);
		var rataDieDiff = currentRataDie - feeRataDie;
		return _Utils_cmp(rataDieDiff, days) > -1;
	});
var $author$project$Timesheet$FeeCountsLogic$isUnverifiedMatter = function (reason) {
	return _Utils_eq(reason, $author$project$Model$Fee$UnverifiedMatter);
};
var $author$project$Timesheet$FeeCountsLogic$isExpiring = F4(
	function (zone, currentRataDie, days, fee) {
		return A2($elm$core$List$any, $author$project$Timesheet$FeeCountsLogic$isUnverifiedMatter, fee.cK) && A4($author$project$Timesheet$FeeLogic$isExpiring, zone, currentRataDie, days, fee);
	});
var $author$project$Timesheet$FeeCountsLogic$isHeld = function (reason) {
	return _Utils_eq(reason, $author$project$Model$Fee$HeldFee) || _Utils_eq(reason, $author$project$Model$Fee$HeldMatter);
};
var $author$project$Timesheet$FeeCountsLogic$isIncompleteReason = function (unpostableReason) {
	switch (unpostableReason.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 6:
			return true;
		case 5:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return false;
		case 10:
			return false;
		case 11:
			return false;
		case 12:
			return false;
		case 13:
			return false;
		case 14:
			return false;
		default:
			return true;
	}
};
var $author$project$Timesheet$FeeCountsLogic$isIncomplete = function (fee) {
	return !$elm$core$List$isEmpty(
		A2($elm$core$List$filter, $author$project$Timesheet$FeeCountsLogic$isIncompleteReason, fee.cK));
};
var $author$project$Timesheet$FeeCountsLogic$isPending = function (reason) {
	return _Utils_eq(reason, $author$project$Model$Fee$PendingMatter);
};
var $author$project$Timesheet$FeeCountsLogic$getFeeFilterState = F4(
	function (zone, currentRataDie, days, fee) {
		return A2($elm$core$List$any, $author$project$Timesheet$FeeCountsLogic$isHeld, fee.cK) ? $author$project$Timesheet$FeeCountsLogic$Held : (A2($elm$core$List$any, $author$project$Timesheet$FeeCountsLogic$isPending, fee.cK) ? $author$project$Timesheet$FeeCountsLogic$Pending : (A4($author$project$Timesheet$FeeCountsLogic$isExpiring, zone, currentRataDie, days, fee) ? $author$project$Timesheet$FeeCountsLogic$Incompleted(0) : ($author$project$Timesheet$FeeCountsLogic$isIncomplete(fee) ? $author$project$Timesheet$FeeCountsLogic$Incompleted(1) : $author$project$Timesheet$FeeCountsLogic$NoFilter)));
	});
var $author$project$Timesheet$FeeCountsLogic$isPosted = function (reason) {
	return _Utils_eq(reason, $author$project$Model$Fee$Dispatched);
};
var $author$project$Timesheet$FeeCountsLogic$getFilterState = F4(
	function (zone, currentRataDie, days, fee) {
		if (A2($elm$core$List$any, $author$project$Timesheet$FeeCountsLogic$isPosted, fee.cK)) {
			return $author$project$Timesheet$FeeCountsLogic$Posted;
		} else {
			var feeFilterState = A4($author$project$Timesheet$FeeCountsLogic$getFeeFilterState, zone, currentRataDie, days, fee);
			return (fee.eD === 6) ? $author$project$Timesheet$FeeCountsLogic$PostFailed(feeFilterState) : $author$project$Timesheet$FeeCountsLogic$Unposted(feeFilterState);
		}
	});
var $author$project$Timesheet$FeeCountsLogic$addFeeToCount = F5(
	function (zone, currentRataDie, days, fee, feeCounts) {
		var filter = A4($author$project$Timesheet$FeeCountsLogic$getFilterState, zone, currentRataDie, days, fee);
		return A3($author$project$Timesheet$FeeCountsLogic$addToFilterCount, filter, fee.aC, feeCounts);
	});
var $author$project$Timesheet$FeeCountsLogic$removeFromFilterCounts = F2(
	function (id, feeCounts) {
		return _Utils_update(
			feeCounts,
			{
				du: A2($elm$core$Set$remove, id, feeCounts.du),
				dx: A2($elm$core$Set$remove, id, feeCounts.dx),
				d$: A2($elm$core$Set$remove, id, feeCounts.d$),
				ip: A2($elm$core$Set$remove, id, feeCounts.ip),
				ez: A2($elm$core$Set$remove, id, feeCounts.ez)
			});
	});
var $author$project$Timesheet$FeeCountsLogic$updateCounts = F5(
	function (zone, currentRataDie, days, feeCounts, fee) {
		return A5(
			$author$project$Timesheet$FeeCountsLogic$addFeeToCount,
			zone,
			currentRataDie,
			days,
			fee,
			A2($author$project$Timesheet$FeeCountsLogic$removeFromFilterCounts, fee.aC, feeCounts));
	});
var $author$project$Timesheet$FeeSearchConfigurationLogic$updateReceivedFee = F5(
	function (zone, rataDie, days, feeSearchConfig, fee) {
		var inSearch = A2($author$project$Timesheet$FeeSearchConfigurationLogic$feeInSearchConfiguration, feeSearchConfig, fee);
		var inDateFilter = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Timesheet$FeeSearchConfigurationLogic$isSameDate, zone, fee),
				feeSearchConfig.dN));
		return (inSearch && inDateFilter) ? _Utils_update(
			feeSearchConfig,
			{
				dI: A5($author$project$Timesheet$FeeCountsLogic$updateCounts, zone, rataDie, days, feeSearchConfig.dI, fee)
			}) : feeSearchConfig;
	});
var $author$project$TimesheetPage$Update$handleUpdateFeeResponse = F4(
	function (zone, model, response, cmd) {
		var _v0 = $author$project$Model$Fee$feeDecoder(response);
		if (!_v0.$) {
			var fee = _v0.a;
			var updatedFeeSearchConfiguration = A5($author$project$Timesheet$FeeSearchConfigurationLogic$updateReceivedFee, zone, model.aU, model.jS.aX, model.g$, fee);
			var fees = A3($author$project$Timesheet$FeeLogic$replaceOrInsert, zone, fee, model.aY);
			return A2(
				$Fresheyeball$elm_return$Return$andThen,
				$author$project$TimesheetPage$Update$handleFlashWhenPresent(response),
				A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$TimesheetPage$Update$scrollTo('fee-form'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						cmd,
						A2(
							$Fresheyeball$elm_return$Return$effect_,
							$author$project$TimesheetPage$Update$refreshDescriptionIfSelected(fee),
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{g$: updatedFeeSearchConfiguration, aY: fees}))))));
		} else {
			return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$Components$MatterInput$Messages$CloseMatterEdit = {$: 8};
var $author$project$Timesheet$FeeLogic$matterDomId = function (feeId) {
	return 'fee-row-' + ($elm$core$String$fromInt(feeId) + '-matter');
};
var $author$project$TimesheetPage$Update$handleUpdateFeeResponseErr = F4(
	function (zone, model, previousFee, response) {
		var _v0 = A4(
			$author$project$Components$MatterInput$Update$update,
			$author$project$Components$MatterInput$Messages$CloseMatterEdit,
			previousFee.eg,
			model.iP,
			$author$project$Timesheet$FeeLogic$matterDomId(previousFee.aC));
		var newMatterInput = _v0.a;
		var subCmd = _v0.c;
		var updatedFee = _Utils_update(
			previousFee,
			{eg: newMatterInput});
		var fees = A3($author$project$Timesheet$FeeLogic$replaceOrInsert, zone, updatedFee, model.aY);
		var updatedFeeSearchConfiguration = A5($author$project$Timesheet$FeeSearchConfigurationLogic$updateReceivedFee, zone, model.aU, model.jS.aX, model.g$, updatedFee);
		return A2(
			$Fresheyeball$elm_return$Return$andThen,
			function (m) {
				return A2($author$project$FlashMessageLogic$addFromError, m, response);
			},
			A2(
				$Fresheyeball$elm_return$Return$mapCmd,
				A2(
					$elm$core$Basics$composeL,
					$author$project$TimesheetPage$Messages$FeeFormEdit(previousFee.aC),
					$author$project$FeeEntry$Messages$MatterInputMessage),
				A2(
					$Fresheyeball$elm_return$Return$command,
					subCmd,
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{g$: updatedFeeSearchConfiguration, aY: fees})))));
	});
var $author$project$Timesheet$FeeLogic$isJust = function (maybe) {
	return !_Utils_eq(maybe, $elm$core$Maybe$Nothing);
};
var $author$project$Timesheet$FeeLogic$hasSelected = function (fees) {
	return $author$project$Timesheet$FeeLogic$isJust(fees.e1);
};
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Timesheet$FeeLogic$haveSameMatter = F2(
	function (feeIds, fees) {
		var matterIds = $elm_community$maybe_extra$Maybe$Extra$values(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hY;
					},
					$elm$core$Maybe$map(
						function ($) {
							return $.aC;
						})),
				A2($author$project$Timesheet$FeeLogic$listMatchingIds, feeIds, fees)));
		if (!matterIds.b) {
			return true;
		} else {
			var first = matterIds.a;
			var rest = matterIds.b;
			return A2(
				$elm$core$List$all,
				$elm$core$Basics$eq(first),
				rest);
		}
	});
var $author$project$Timesheet$Requests$holdFee = F3(
	function (csrfToken, toHoldStatus, fee) {
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'on_hold',
						$elm$json$Json$Encode$bool(toHoldStatus))
					])));
		return $author$project$Requests$post(
			{
				fW: body,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/hold_fee')
			});
	});
var $author$project$Components$SplitFee$Model$Duration = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$SplitFee$Model$Units = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$SplitFee$SplitLogic$initialNewHundredths = F3(
	function (increment, total, extraTo) {
		var half = (total / 2) | 0;
		var roundedHalf = ((half / increment) | 0) * increment;
		if (!extraTo) {
			return roundedHalf;
		} else {
			return total - roundedHalf;
		}
	});
var $author$project$Components$SplitFee$SplitLogic$oddPart = F3(
	function (increment, total, extraTo) {
		if (!extraTo) {
			return 0;
		} else {
			return A2($elm$core$Basics$modBy, increment, total);
		}
	});
var $author$project$Components$SplitFee$SplitLogic$initialSteps = F3(
	function (increment, total, extraTo) {
		return ((A3($author$project$Components$SplitFee$SplitLogic$initialNewHundredths, increment, total, extraTo) - A3($author$project$Components$SplitFee$SplitLogic$oddPart, increment, total, extraTo)) / increment) | 0;
	});
var $author$project$Components$SplitFee$Model$init = F5(
	function (csrfToken, _v0, fee, durationInSeconds, recentMatters) {
		var pms = _v0.ce;
		var minutesPerUnit = _v0.ej;
		var splitIncrement = _v0.je;
		var splitExtraTo = _v0.jd;
		var totalHundredths = $elm$core$Basics$round(fee.jP * 100);
		var feeMeasure = fee.iQ ? A2(
			$elm$core$Basics$composeL,
			$author$project$Components$SplitFee$Model$Duration,
			A2($author$project$CoreX$Basics$flip, $author$project$Components$DurationInput$DurationInputLogic$getHoursAndMinutes, minutesPerUnit)) : $author$project$Components$SplitFee$Model$Units;
		var origFeeInput = {
			bz: durationInSeconds,
			eg: A2($author$project$Components$MatterInput$Model$resetContactMatterInput, $elm$core$Maybe$Nothing, recentMatters),
			b_: feeMeasure(fee.jP),
			cq: fee.hY
		};
		return {
			gr: csrfToken,
			bD: splitExtraTo,
			dA: fee,
			a0: splitIncrement,
			ej: minutesPerUnit,
			b4: A3($author$project$Components$SplitFee$SplitLogic$initialSteps, splitIncrement, totalHundredths, splitExtraTo),
			cd: origFeeInput,
			ce: pms,
			cz: _Utils_update(
				origFeeInput,
				{
					bz: $elm$core$Maybe$Just(0),
					b_: feeMeasure(0),
					cq: $elm$core$Maybe$Nothing
				}),
			bh: totalHundredths
		};
	});
var $author$project$Timesheet$FeeLogic$initGroupFees = F2(
	function (zone, fees) {
		var groupedFees = A3(
			$author$project$GroupBy$groupFeesByRataDie,
			zone,
			function ($) {
				return $.b7;
			},
			fees.d1);
		return _Utils_update(
			fees,
			{$7: groupedFees, d1: _List_Nil});
	});
var $author$project$FeeTimerLogic$running = function (timer) {
	return _Utils_eq(timer.jk, $elm$core$Maybe$Nothing);
};
var $author$project$FeeTimerLogic$isTimerRunning = function (fee) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$FeeTimerLogic$running, fee.jA));
};
var $author$project$FeeTimerLogic$getRunningTimer = function (fees) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		$author$project$FeeTimerLogic$isTimerRunning,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				$mgold$elm_nonempty_list$List$Nonempty$toList,
				$rtfeldman$elm_sorter_experiment$Sort$Dict$values(fees))));
};
var $author$project$TimesheetPage$Update$injectCurrentTimeToRunningTimer = F3(
	function (zone, now, model) {
		var updateFeesTimer = F2(
			function (m, f) {
				return _Utils_update(
					m,
					{
						aY: A3($author$project$Timesheet$FeeLogic$replaceOrInsert, zone, f, m.aY)
					});
			});
		var injectTime = F2(
			function (time, timer) {
				return _Utils_update(
					timer,
					{gw: time});
			});
		var updateFeeEntryTimer = F2(
			function (time, f) {
				return _Utils_update(
					f,
					{
						jA: A2(
							$elm$core$Maybe$map,
							injectTime(time),
							f.jA)
					});
			});
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				updateFeesTimer(model),
				A2(
					$elm$core$Maybe$map,
					updateFeeEntryTimer(now),
					$author$project$FeeTimerLogic$getRunningTimer(model.aY.$7))));
	});
var $author$project$Timesheet$FeeLogic$isDayLoaded = F3(
	function (zone, fees, fee) {
		var day = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, fee);
		var _v0 = A2($rtfeldman$elm_sorter_experiment$Sort$Dict$get, day, fees.$7);
		if (_v0.$ === 1) {
			return false;
		} else {
			return true;
		}
	});
var $author$project$Activities$ActivityLogic$isEmail = function (activity) {
	var _v0 = activity.i;
	if (_v0.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Timesheet$FeeLogic$isNotPosted = function (fee) {
	return fee.eD !== 4;
};
var $Fresheyeball$elm_return$Return$mapBoth = F3(
	function (f, f_, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			f_(model),
			A2($elm$core$Platform$Cmd$map, f, cmd));
	});
var $author$project$Timesheet$FeeLogic$maybeSelectFee = F2(
	function (fee, fees) {
		return _Utils_update(
			fees,
			{
				e1: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.aC;
					},
					fee)
			});
	});
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Model$ActionStep$RateValue$rateSourceToString = function (source) {
	switch (source) {
		case 3:
			return 'organisation';
		case 2:
			return 'user';
		case 1:
			return 'contact';
		case 0:
			return 'matter';
		case 4:
			return 'user_matter';
		case 5:
			return 'user_client';
		default:
			return 'coded_user_client';
	}
};
var $author$project$Timesheet$Requests$updateFee = F3(
	function (csrfToken, fee, msgMapper) {
		var encodeNullableIn = F3(
			function (rec, getter, decoder) {
				return A2(
					$elm_community$json_extra$Json$Encode$Extra$maybe,
					decoder,
					A2($elm$core$Maybe$map, getter, rec));
			});
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'fee',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'matter_id',
									A3(
										encodeNullableIn,
										fee.hY,
										function ($) {
											return $.aC;
										},
										$elm$json$Json$Encode$int)),
									_Utils_Tuple2(
									'has_guessed_matter',
									$elm$json$Json$Encode$bool(fee.aB)),
									_Utils_Tuple2(
									'has_pending_matter',
									$elm$json$Json$Encode$bool(fee.a_)),
									_Utils_Tuple2(
									'description',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, fee.dd)),
									_Utils_Tuple2(
									'units',
									$elm$json$Json$Encode$float(fee.jP)),
									_Utils_Tuple2(
									'billing_behaviour',
									$elm$json$Json$Encode$string(
										$author$project$Model$Fee$BillingBehaviour$toString(fee.fS))),
									_Utils_Tuple2(
									'record_in_minutes',
									$elm$json$Json$Encode$bool(fee.iQ)),
									_Utils_Tuple2(
									'fee_type_id',
									$elm$json$Json$Encode$int(fee.g0.aC)),
									_Utils_Tuple2(
									'scale_item_id',
									A3(
										encodeNullableIn,
										fee.bd,
										function ($) {
											return $.aC;
										},
										$elm$json$Json$Encode$int)),
									_Utils_Tuple2(
									'rate_label_id',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										$elm$json$Json$Encode$int,
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.aC;
											},
											fee.fD))),
									_Utils_Tuple2(
									'action_step_override_source',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										$elm$json$Json$Encode$string,
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.ev;
												},
												$author$project$Model$ActionStep$RateValue$rateSourceToString),
											fee.aO))),
									_Utils_Tuple2(
									'action_step_override_rate',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										$elm$json$Json$Encode$float,
										A2(
											$elm$core$Maybe$andThen,
											$elm$core$String$toFloat,
											A2(
												$elm$core$Maybe$withDefault,
												$elm$core$Maybe$Nothing,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.iB;
													},
													fee.aO))))),
									_Utils_Tuple2(
									'rate_value_display_name',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										$elm$json$Json$Encode$string,
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.dg;
											},
											fee.aO))),
									_Utils_Tuple2(
									'activity_code_id',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										$elm$json$Json$Encode$int,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.aC;
											},
											fee.bp))),
									_Utils_Tuple2(
									'task_code_id',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										$elm$json$Json$Encode$int,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.aC;
											},
											fee.cE))),
									_Utils_Tuple2(
									'timekeeper_code_id',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										$elm$json$Json$Encode$int,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.aC;
											},
											fee.cG))),
									_Utils_Tuple2(
									'occurred_at',
									$elm$json$Json$Encode$string(
										$author$project$CoreX$DateFormat$toUtcIsoString(fee.b7)))
								])))
					])));
		return $author$project$Requests$patch(
			{
				fW: body,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(msgMapper),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + $elm$core$String$fromInt(fee.aC)
			});
	});
var $author$project$Timesheet$FeeLogic$saveFeeCmd = F3(
	function (csrfToken, fee, newFee) {
		return A3(
			$author$project$Timesheet$Requests$updateFee,
			csrfToken,
			newFee,
			$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee));
	});
var $author$project$Components$SearchInput$SearchInputSelectors$ScaleItemSelector = 3;
var $author$project$TimesheetPage$Messages$UpdateFeeResponseAndLoadNextSelector = F3(
	function (a, b, c) {
		return {$: 72, a: a, b: b, c: c};
	});
var $author$project$TimesheetPage$Messages$UpdateRecentMatters = function (a) {
	return {$: 9, a: a};
};
var $author$project$Timesheet$Requests$setMatter = F4(
	function (csrfToken, feeId, matter, msgMapper) {
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'fee',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'matter_id',
									$elm$json$Json$Encode$int(matter.aC))
								])))
					])));
		return $author$project$Requests$post(
			{
				fW: body,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(msgMapper),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(feeId) + '/set_matter')
			});
	});
var $author$project$MatterLogic$setFeeMatterCmd = F4(
	function (csrfToken, pms, fee, matter) {
		var returnCmd = function (f) {
			if (pms === 3) {
				return A2($author$project$TimesheetPage$Messages$UpdateFeeResponseAndLoadNextSelector, 3, f);
			} else {
				return $author$project$TimesheetPage$Messages$UpdateFeeResponse(f);
			}
		};
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Timesheet$Requests$setMatter,
					csrfToken,
					fee.aC,
					matter,
					returnCmd(fee)),
					$author$project$Utils$send(
					$author$project$TimesheetPage$Messages$UpdateRecentMatters(matter))
				]));
	});
var $author$project$MatterLogic$applyMatterSelectionToFee = F6(
	function (csrfToken, pms, recentMatters, matterSelection, unchangedFee, updatedFee) {
		switch (matterSelection.$) {
			case 0:
				return $Fresheyeball$elm_return$Return$singleton(updatedFee);
			case 2:
				return $Fresheyeball$elm_return$Return$singleton(updatedFee);
			case 1:
				var matter = matterSelection.a;
				var fee = _Utils_update(
					updatedFee,
					{
						aB: false,
						a_: false,
						hY: $elm$core$Maybe$Just(matter)
					});
				return A2(
					$Fresheyeball$elm_return$Return$return,
					fee,
					A4($author$project$MatterLogic$setFeeMatterCmd, csrfToken, pms, fee, matter));
			default:
				var fee = _Utils_update(
					updatedFee,
					{aB: false, a_: true, hY: $elm$core$Maybe$Nothing});
				return A2(
					$Fresheyeball$elm_return$Return$return,
					fee,
					A3($author$project$Timesheet$FeeLogic$saveFeeCmd, csrfToken, unchangedFee, fee));
		}
	});
var $author$project$Components$UiInfoAlerts$Data$GroupedFees = 0;
var $author$project$Components$UiInfoAlerts$Data$feeGroupingAlert = {bm: false, go: 'Fees within a group can only be assigned to one matter. Any fees assigned to a second matter will be ejected from the group.', bs: 0, jB: 'One assigned matter per group'};
var $author$project$TimesheetPage$Update$openMatterAndSelectFee = F5(
	function (zone, model, mode, context, fee) {
		var uiAlertModal = function () {
			var _v2 = _Utils_Tuple2(context, model.jS.cI.hg);
			if ((_v2.a === 1) && (!_v2.b)) {
				var _v3 = _v2.a;
				return $author$project$Components$Modal$Model$UiInfoAlertModal($author$project$Components$UiInfoAlerts$Data$feeGroupingAlert);
			} else {
				return model.h7;
			}
		}();
		var _v0 = A4(
			$author$project$MatterLogic$openMatter,
			model.iP,
			fee.eg,
			mode,
			$author$project$Timesheet$FeeLogic$matterDomId(fee.aC));
		var newMatterInput = _v0.a;
		var matterSelection = _v0.b;
		var subCmd = _v0.c;
		var _v1 = A6(
			$author$project$MatterLogic$applyMatterSelectionToFee,
			model.gr,
			model.jS.ce,
			model.iP,
			matterSelection,
			fee,
			_Utils_update(
				fee,
				{eg: newMatterInput}));
		var updatedFee = _v1.a;
		var saveCmd = _v1.b;
		var updatedFees = A3($author$project$Timesheet$FeeLogic$replaceFee, zone, updatedFee, model.aY);
		return A2(
			$Fresheyeball$elm_return$Return$command,
			A2(
				$elm$core$Platform$Cmd$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
					$author$project$FeeEntry$Messages$MatterInputMessage),
				subCmd),
			A2(
				$Fresheyeball$elm_return$Return$return,
				_Utils_update(
					model,
					{
						gX: $author$project$Components$SearchInput$Model$Closed,
						aY: _Utils_update(
							updatedFees,
							{
								e1: $elm$core$Maybe$Just(fee.aC)
							}),
						h7: uiAlertModal
					}),
				saveCmd));
	});
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$TimesheetPage$Messages$QueueAllPostableFeesForMatterResponse = function (a) {
	return {$: 29, a: a};
};
var $author$project$Timesheet$Requests$queueAllPostableFeesForMatter = F2(
	function (csrfToken, matterId) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$QueueAllPostableFeesForMatterResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/matters/' + ($elm$core$String$fromInt(matterId) + '/batch_post_postable_fees')
			});
	});
var $author$project$Timesheet$Requests$queueFee = F2(
	function (csrfToken, fee) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/queue_entry')
			});
	});
var $author$project$TimesheetPage$Messages$SearchFees = {$: 59};
var $author$project$TimesheetPage$Update$queueSearchFeesCmd = $author$project$Utils$send(
	$author$project$TimesheetPage$Messages$QueueSearchFees(
		$Gizra$elm_debouncer$Debouncer$Basic$provideInput($author$project$TimesheetPage$Messages$SearchFees)));
var $author$project$TimesheetPage$Update$receiveFee = F3(
	function (zone, model, fee) {
		var updatedFeeSearchConfiguration = A5($author$project$Timesheet$FeeSearchConfigurationLogic$updateReceivedFee, zone, model.aU, model.jS.aX, model.g$, fee);
		return _Utils_update(
			model,
			{
				g$: updatedFeeSearchConfiguration,
				aY: A3($author$project$Timesheet$FeeLogic$replaceOrInsert, zone, fee, model.aY)
			});
	});
var $author$project$Timesheet$FeeSearchConfigurationLogic$removeDeletedFee = F2(
	function (feeSearchConfig, feeId) {
		return _Utils_update(
			feeSearchConfig,
			{
				dI: A2($author$project$Timesheet$FeeCountsLogic$removeFromFilterCounts, feeId, feeSearchConfig.dI)
			});
	});
var $author$project$TimesheetPage$Update$receivedDeletedFees = F3(
	function (zone, model, ids) {
		var updatedFeeSearchConfiguration = A3(
			$elm$core$List$foldl,
			F2(
				function (f, config) {
					return A2($author$project$Timesheet$FeeSearchConfigurationLogic$removeDeletedFee, config, f);
				}),
			model.g$,
			ids);
		var updatedEntries = A2($author$project$Timesheet$FeeLogic$removeFees, ids, model.aY);
		var fees = model.aY;
		var modelDeletedFees = fees.dc;
		var deletedFeeIds = A2(
			$elm$core$List$filter,
			function (id) {
				return !A2($elm$core$List$member, id, ids);
			},
			model.aY.dc.dD);
		var updatedDeletedFees = _Utils_update(
			modelDeletedFees,
			{dD: deletedFeeIds});
		var updatedFees = _Utils_update(
			updatedEntries,
			{dc: updatedDeletedFees});
		var updatedModel = _Utils_update(
			model,
			{g$: updatedFeeSearchConfiguration, aY: updatedFees});
		return updatedModel;
	});
var $author$project$TimesheetPage$Messages$SetConsolidating = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$FeeEntry$Update$removeConsolidatedFeeIdCmd = function (feeId) {
	return $author$project$Utils$send(
		A2($author$project$TimesheetPage$Messages$SetConsolidating, 1, feeId));
};
var $author$project$Timesheet$FeeSearchConfigurationLogic$removeDeletedFees = F2(
	function (feeSearchConfig, feeIds) {
		var updateFilterCounts = A2($elm$core$List$foldr, $author$project$Timesheet$FeeCountsLogic$removeFromFilterCounts, feeSearchConfig.dI);
		return _Utils_update(
			feeSearchConfig,
			{
				dI: updateFilterCounts(feeIds)
			});
	});
var $author$project$Timesheet$FeeLogic$updateFeeActionsMenuOpen = F2(
	function (newFee, oldFee) {
		return _Utils_update(
			oldFee,
			{hx: newFee.hx});
	});
var $author$project$Timesheet$FeeLogic$replaceFeeActionsMenuOpen = F3(
	function (zone, newFee, fees) {
		var rataDie = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, newFee);
		return A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$update,
			rataDie,
			$elm$core$Maybe$andThen(
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$toList,
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Timesheet$FeeLogic$updateFeeWith, $author$project$Timesheet$FeeLogic$updateFeeActionsMenuOpen, newFee),
						$mgold$elm_nonempty_list$List$Nonempty$fromList))),
			fees);
	});
var $author$project$Timesheet$FeeLogic$resetAiCompleted = F3(
	function (zone, feeId, fees) {
		var rataDie = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, feeId);
		var feeUpdate = function (item) {
			var aiInput = item.aQ;
			var updatedAiInput = _Utils_update(
				aiInput,
				{eQ: $author$project$Components$AiInput$Model$Idle});
			return _Utils_update(
				item,
				{aQ: updatedAiInput});
		};
		var entries = A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$update,
			rataDie,
			$elm$core$Maybe$andThen(
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$toList,
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Timesheet$FeeLogic$updateFeeIdWith, feeUpdate, feeId),
						$mgold$elm_nonempty_list$List$Nonempty$fromList))),
			fees.$7);
		return _Utils_update(
			fees,
			{$7: entries});
	});
var $author$project$TimesheetPage$Update$incrementFeeSearchKeyVersion = function (model) {
	var feeSearchConfig = model.g$;
	var updatedFeeSearchConfig = _Utils_update(
		feeSearchConfig,
		{ea: feeSearchConfig.ea + 1});
	return _Utils_update(
		model,
		{g$: updatedFeeSearchConfig});
};
var $author$project$TimesheetPage$Update$setFeeSearchForDate = F2(
	function (forDate, model) {
		var feeSearchConfig = model.g$;
		var updatedFeeSearchConfig = _Utils_update(
			feeSearchConfig,
			{dN: forDate});
		return _Utils_update(
			model,
			{g$: updatedFeeSearchConfig});
	});
var $author$project$TimesheetPage$Update$setFeeSearchMode = F2(
	function (newMode, model) {
		var feeSearchConfig = model.g$;
		var updatedFeeSearchConfig = _Utils_update(
			feeSearchConfig,
			{i1: newMode});
		return _Utils_update(
			model,
			{g$: updatedFeeSearchConfig});
	});
var $author$project$TimesheetPage$Update$setFeeSearchTerm = F2(
	function (newTerm, model) {
		var feeSearchConfig = model.g$;
		var updatedFeeSearchConfig = _Utils_update(
			feeSearchConfig,
			{i2: newTerm});
		return _Utils_update(
			model,
			{g$: updatedFeeSearchConfig});
	});
var $author$project$TimesheetPage$Update$resetFeeSearch = F2(
	function (model, feeSearchMode) {
		var fetchFeesWhenClosedEffect = function (m) {
			if (!feeSearchMode) {
				return $elm$core$Platform$Cmd$none;
			} else {
				return $author$project$TimesheetPage$Update$fetchFeesCmd(m);
			}
		};
		var fetchFeeCountsWhenClosedEffect = function (m) {
			if (!feeSearchMode) {
				return $elm$core$Platform$Cmd$none;
			} else {
				return $author$project$TimesheetPage$Update$fetchFeeCountsCmd(m);
			}
		};
		return A2(
			$Fresheyeball$elm_return$Return$effect_,
			fetchFeeCountsWhenClosedEffect,
			A2(
				$Fresheyeball$elm_return$Return$effect_,
				fetchFeesWhenClosedEffect,
				$Fresheyeball$elm_return$Return$singleton(
					$author$project$TimesheetPage$Update$incrementFeeSearchKeyVersion(
						A2(
							$author$project$TimesheetPage$Update$setFeeSearchForDate,
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$TimesheetPage$Update$setFeeSearchTerm,
								$elm$core$Maybe$Nothing,
								A2($author$project$TimesheetPage$Update$setFeeSearchMode, feeSearchMode, model)))))));
	});
var $author$project$TimesheetPage$Update$selectFee = F2(
	function (feeToSelect, model) {
		return _Utils_update(
			model,
			{
				aY: A2($author$project$Timesheet$FeeLogic$selectFee, feeToSelect, model.aY)
			});
	});
var $author$project$Components$Modal$Model$ContactModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$TimesheetPage$Update$setContactModal = F3(
	function (model, activity, cm) {
		return _Utils_update(
			model,
			{
				h7: A2($author$project$Components$Modal$Model$ContactModal, activity, cm)
			});
	});
var $author$project$TimesheetPage$Update$setFeeFilterState = F2(
	function (filterState, model) {
		var feeSearchConfig = model.g$;
		var updatedFeeSearchConfig = _Utils_update(
			feeSearchConfig,
			{g9: filterState});
		return _Utils_update(
			model,
			{g$: updatedFeeSearchConfig});
	});
var $author$project$TimesheetPage$Update$setFeeSearchConfig = F2(
	function (feeSearchConfig, model) {
		return _Utils_update(
			model,
			{g$: feeSearchConfig});
	});
var $author$project$TimesheetPage$Update$setFeeSearchCounts = F3(
	function (feeCounts, loading, model) {
		var feeSearchConfig = model.g$;
		var updatedFeeSearchConfig = _Utils_update(
			feeSearchConfig,
			{dB: loading, dI: feeCounts});
		return _Utils_update(
			model,
			{g$: updatedFeeSearchConfig});
	});
var $author$project$TimesheetPage$Update$setFeeSearchDebouncer = F2(
	function (model, debouncer) {
		var feeSearchConfig = model.g$;
		var updatedFeeSearchConfig = _Utils_update(
			feeSearchConfig,
			{c8: debouncer});
		return _Utils_update(
			model,
			{g$: updatedFeeSearchConfig});
	});
var $author$project$Timesheet$FeeSearchConfigurationLogic$setFeeSearchGroupByFilterMode = F2(
	function (groupByMode, feeSearchConfig) {
		return _Utils_update(
			feeSearchConfig,
			{dT: groupByMode});
	});
var $author$project$Activities$ActivityLogic$setEventFilingStatus = F2(
	function (event, updatedStatus) {
		if (event.$ === 3) {
			var emailActivity = event.a;
			return $author$project$Activities$Model$Event$Email(
				_Utils_update(
					emailActivity,
					{
						dH: $elm$core$Maybe$Just(updatedStatus)
					}));
		} else {
			return event;
		}
	});
var $author$project$Timesheet$FeeLogic$setFilingStatus = F2(
	function (fee, status) {
		return A2(
			$elm$core$Maybe$withDefault,
			fee,
			A2(
				$elm$core$Maybe$map,
				function (newActivity) {
					return _Utils_update(
						fee,
						{
							fG: $elm$core$Maybe$Just(newActivity)
						});
				},
				A2(
					$elm$core$Maybe$map,
					function (activity) {
						return _Utils_update(
							activity,
							{
								i: A2($author$project$Activities$ActivityLogic$setEventFilingStatus, activity.i, status)
							});
					},
					fee.fG)));
	});
var $author$project$Components$ContactModal$Messages$SetError = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$ContactModal$ContactModalLogic$setCompanyName = F2(
	function (companyName, contactModal) {
		return _Utils_update(
			contactModal,
			{gh: companyName});
	});
var $author$project$Components$ContactModal$ContactModalLogic$setConflictingContact = F2(
	function (conflictingContact, contactModal) {
		return _Utils_update(
			contactModal,
			{c1: conflictingContact, bV: false});
	});
var $author$project$Components$ContactModal$Model$Email = 0;
var $author$project$Components$ContactModal$ContactModalLogic$resetConflictingContactFieldOnChange = F2(
	function (originallyFrom, contactModal) {
		return (!_Utils_eq(contactModal.iz, originallyFrom)) ? A2($author$project$Components$ContactModal$ContactModalLogic$setConflictingContact, $author$project$Components$ContactModal$Model$NoConflict, contactModal) : contactModal;
	});
var $author$project$Components$ContactModal$ContactModalLogic$setEmailAddress = F2(
	function (email, contactModal) {
		return A2(
			$author$project$Components$ContactModal$ContactModalLogic$resetConflictingContactFieldOnChange,
			0,
			_Utils_update(
				contactModal,
				{dl: email}));
	});
var $author$project$Components$ContactModal$ContactModalLogic$setError = F2(
	function (error, contactModal) {
		return _Utils_update(
			contactModal,
			{gM: error, bV: false});
	});
var $author$project$Components$ContactModal$ContactModalLogic$setGivenNames = F2(
	function (name, contactModal) {
		return _Utils_update(
			contactModal,
			{hf: name});
	});
var $author$project$Components$ContactModal$ContactModalLogic$setJobTitle = F2(
	function (jobTitle, contactModal) {
		return _Utils_update(
			contactModal,
			{hO: jobTitle});
	});
var $author$project$Components$ContactModal$ContactModalLogic$setLoading = function (contactModal) {
	return _Utils_update(
		contactModal,
		{bV: true});
};
var $author$project$Components$ContactModal$ContactModalLogic$setNotes = F2(
	function (notes, contactModal) {
		return _Utils_update(
			contactModal,
			{ik: notes});
	});
var $author$project$Components$ContactModal$Model$Phone = 1;
var $author$project$Components$ContactModal$ContactModalLogic$setPhoneNumber = F2(
	function (phoneNumber, contactModal) {
		return A2(
			$author$project$Components$ContactModal$ContactModalLogic$resetConflictingContactFieldOnChange,
			1,
			_Utils_update(
				contactModal,
				{iH: phoneNumber}));
	});
var $author$project$Components$ContactModal$ContactModalLogic$setSurname = F2(
	function (name, contactModal) {
		return _Utils_update(
			contactModal,
			{jo: name});
	});
var $author$project$Components$ContactModal$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var givenNames = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setGivenNames, givenNames, model);
			case 1:
				var name = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setSurname, name, model);
			case 2:
				var email = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setEmailAddress, email, model);
			case 3:
				var phoneNumber = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setPhoneNumber, phoneNumber, model);
			case 4:
				var companyName = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setCompanyName, companyName, model);
			case 5:
				var notes = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setNotes, notes, model);
			case 6:
				var jobTitle = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setJobTitle, jobTitle, model);
			case 8:
				var error = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setError, error, model);
			case 9:
				var conflictingContact = msg.a;
				return A2($author$project$Components$ContactModal$ContactModalLogic$setConflictingContact, conflictingContact, model);
			default:
				return $author$project$Components$ContactModal$ContactModalLogic$setLoading(model);
		}
	});
var $author$project$TimesheetPage$Update$setHeaderErrorOnContactModalCreate = F2(
	function (response, model) {
		var _v0 = model.h7;
		if (!_v0.$) {
			var activity = _v0.a;
			var contactModalModel = _v0.b;
			var error = $author$project$ErrorLogic$getMessage(response);
			return A2(
				$Fresheyeball$elm_return$Return$map,
				function (contactModal) {
					return _Utils_update(
						model,
						{
							h7: A2($author$project$Components$Modal$Model$ContactModal, activity, contactModal)
						});
				},
				$Fresheyeball$elm_return$Return$singleton(
					A2(
						$author$project$Components$ContactModal$Update$update,
						$author$project$Components$ContactModal$Messages$SetError(error),
						contactModalModel)));
		} else {
			return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$TimesheetPage$Messages$SetShowPostedEntriesResponse = function (a) {
	return {$: 56, a: a};
};
var $author$project$Timesheet$Requests$setShowPostedEntries = F2(
	function (csrfToken, showPosted) {
		return $author$project$Requests$patch(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'show_posted_entries',
								$elm$json$Json$Encode$bool(showPosted))
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$SetShowPostedEntriesResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/user_settings'
			});
	});
var $author$project$Timesheet$Requests$setTag = F3(
	function (csrfToken, fee, tagId) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'tag_id',
								$elm$json$Json$Encode$int(tagId))
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/set_tag')
			});
	});
var $author$project$Ports$TourTriggers$startActivityReviewTourPort = _Platform_outgoingPort(
	'startActivityReviewTourPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$TourTriggers$startActivityReviewTour = function (hasCompletedActivityReviewTour) {
	return (!hasCompletedActivityReviewTour) ? $author$project$Ports$TourTriggers$startActivityReviewTourPort(0) : $elm$core$Platform$Cmd$none;
};
var $author$project$Timesheet$Requests$startTimer = F2(
	function (csrfToken, fee) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/start_timer')
			});
	});
var $author$project$Timesheet$Requests$stopTimer = F2(
	function (csrfToken, fee) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/stop_timer')
			});
	});
var $author$project$FeeTimerLogic$stopFeeTimerCmd = F2(
	function (csrfToken, fee) {
		return A2($author$project$Timesheet$Requests$stopTimer, csrfToken, fee);
	});
var $author$project$Timesheet$FeeLogic$toFeeId = function (fee) {
	return {g_: fee.aC, b7: fee.b7};
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Activities$Data$DateFilter = 6;
var $author$project$TimesheetPage$Messages$DeselectActivitiesForMergeFees = function (a) {
	return {$: 42, a: a};
};
var $author$project$Ports$BrowserExtension$EndAggregates = $elm$core$Basics$identity;
var $author$project$Activities$Messages$QueueSearchActivities = function (a) {
	return {$: 14, a: a};
};
var $author$project$Activities$Requests$acceptActivities = F4(
	function (csrfToken, activities, feeType, once) {
		var encodeFeeTypeId = A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aC;
					},
					$elm$json$Json$Encode$int),
				feeType));
		var activityIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.aC;
			},
			activities);
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'activity_ids',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, activityIds)),
								_Utils_Tuple2('fee_type_id', encodeFeeTypeId)
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$CreateActivityFeeResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: '/api/activities/batch_accept'
			});
	});
var $author$project$Activities$Requests$activityUrl = function (activity) {
	return 'api/activities/' + $elm$core$String$fromInt(activity.aC);
};
var $author$project$Activities$Requests$acceptActivityOnceUrl = function (activity) {
	return $author$project$Activities$Requests$activityUrl(activity) + '/accept_activity_once';
};
var $author$project$Activities$Requests$acceptActivityUrl = function (activity) {
	return $author$project$Activities$Requests$activityUrl(activity) + '/accept_activity';
};
var $author$project$Activities$Requests$acceptActivity = F3(
	function (csrfToken, activity, once) {
		var url = once ? $author$project$Activities$Requests$acceptActivityOnceUrl(activity) : $author$project$Activities$Requests$acceptActivityUrl(activity);
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$CreateActivityFeeResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: url
			});
	});
var $author$project$Activities$Update$acceptActivityEventCmd = F2(
	function (once, activity) {
		return $author$project$Ports$EventTracking$trackEvent(
			function () {
				var _v0 = _Utils_Tuple2(once, activity.fV);
				if (_v0.a) {
					if (_v0.b.$ === 1) {
						var _v1 = _v0.b;
						return 'ChargeOnceFromActivities Fee';
					} else {
						return 'ChargeOnceFromBin Fee';
					}
				} else {
					return 'ChargeAndUpgrade Fee';
				}
			}());
	});
var $author$project$Activities$ActivityLogic$groupByKey = F2(
	function (zone, activity) {
		var rataDie = A2($author$project$CoreX$RataDie$fromPosix, zone, activity.jg);
		return A2($author$project$Activities$ActivityLogic$groupByKeyForRataDie, rataDie, activity);
	});
var $author$project$ActivityFeedLogic$activitiesWithGroupKey = F3(
	function (zone, activities, groupByKey) {
		return A2(
			$elm$core$List$filter,
			function (activity) {
				return _Utils_eq(
					A2($author$project$Activities$ActivityLogic$groupByKey, zone, activity),
					groupByKey);
			},
			activities);
	});
var $author$project$Activities$ActivityLogic$isBinned = function (activity) {
	return !_Utils_eq(activity.fV, $elm$core$Maybe$Nothing);
};
var $author$project$Activities$ActivityLogic$matchesFeedMode = F2(
	function (feedMode, activity) {
		var _v0 = _Utils_Tuple2(
			feedMode,
			$author$project$Activities$ActivityLogic$isBinned(activity));
		if (!_v0.a) {
			if (!_v0.b) {
				var _v1 = _v0.a;
				return true;
			} else {
				var _v2 = _v0.a;
				return false;
			}
		} else {
			if (_v0.b) {
				var _v3 = _v0.a;
				return true;
			} else {
				var _v4 = _v0.a;
				return false;
			}
		}
	});
var $author$project$Activities$Data$AppointmentFilter = 3;
var $author$project$Activities$Data$BrowserResearchFilter = 5;
var $author$project$Activities$Data$DocumentFilter = 4;
var $author$project$Activities$Data$EmailFilter = 0;
var $author$project$Activities$Data$MSTeamsCallFilter = 2;
var $author$project$Activities$Data$PhonecallFilter = 1;
var $author$project$Activities$Data$activityToFilter = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 0:
			return 3;
		case 1:
			return 2;
		case 2:
			if (_v0.a === 2) {
				var _v1 = _v0.a;
				return 4;
			} else {
				return 4;
			}
		case 3:
			return 0;
		case 4:
			return 1;
		default:
			return 5;
	}
};
var $turboMaCk$any_dict$Dict$Any$isEmpty = function (_v0) {
	var dict = _v0.d;
	return $elm$core$Dict$isEmpty(dict);
};
var $turboMaCk$any_set$Set$Any$isEmpty = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$isEmpty(dict);
};
var $author$project$Activities$ActivityLogic$isReadingDocument = function (activity) {
	var _v0 = activity.i;
	if ((_v0.$ === 2) && (_v0.a === 2)) {
		var _v1 = _v0.a;
		return true;
	} else {
		return false;
	}
};
var $turboMaCk$any_dict$Dict$Any$member = F2(
	function (k, _v0) {
		var dict = _v0.d;
		var toKey = _v0.y;
		return A2(
			$elm$core$Dict$member,
			toKey(k),
			dict);
	});
var $turboMaCk$any_set$Set$Any$member = F2(
	function (a, _v0) {
		var dict = _v0;
		return A2($turboMaCk$any_dict$Dict$Any$member, a, dict);
	});
var $author$project$Activities$ActivityLogic$matchesFilter = F3(
	function (showReadingDocumentActivities, filters, activity) {
		var addReading = showReadingDocumentActivities ? true : (!$author$project$Activities$ActivityLogic$isReadingDocument(activity));
		var activityFilter = $author$project$Activities$Data$activityToFilter(activity);
		return $turboMaCk$any_set$Set$Any$isEmpty(filters) ? addReading : (A2($turboMaCk$any_set$Set$Any$member, activityFilter, filters) && addReading);
	});
var $author$project$Activities$ActivityLogic$activityMatchesFilters = F4(
	function (showReadingDocumentActivities, feedMode, filters, activity) {
		return A2($author$project$Activities$ActivityLogic$matchesFeedMode, feedMode, activity) && A3($author$project$Activities$ActivityLogic$matchesFilter, showReadingDocumentActivities, filters, activity);
	});
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $author$project$Activities$ActivityLogic$addActivityToOpenFeed = F2(
	function (activity, _v0) {
		var feedMode = _v0.g5;
		var activities = _v0.fF;
		var feedFilters = _v0.g4;
		var showReadingDocumentActivities = _v0.i8;
		return A4($author$project$Activities$ActivityLogic$activityMatchesFilters, showReadingDocumentActivities, feedMode, feedFilters, activity) ? A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.aC;
			},
			A2($elm$core$List$cons, activity, activities)) : A2(
			$elm_community$list_extra$List$Extra$filterNot,
			function (a) {
				return _Utils_eq(a.aC, activity.aC);
			},
			activities);
	});
var $author$project$Activities$ActivityLogic$addActivitiesToOpenFeed = F2(
	function (activityList, feed) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (activity) {
					return A2($author$project$Activities$ActivityLogic$addActivityToOpenFeed, activity, feed);
				},
				activityList));
	});
var $author$project$ActivityFeedLogic$asExpandedActivityGroupsIn = F2(
	function (activityFeed, newContractedGroups) {
		return _Utils_update(
			activityFeed,
			{ds: newContractedGroups});
	});
var $author$project$Activities$Messages$BlockActivityResponse = function (a) {
	return {$: 22, a: a};
};
var $author$project$Activities$Requests$blockActivityUrl = function (activity) {
	return $author$project$Activities$Requests$activityUrl(activity) + '/block';
};
var $author$project$Activities$Requests$blockActivity = F2(
	function (csrfToken, activity) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$Activities$Messages$BlockActivityResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: $author$project$Activities$Requests$blockActivityUrl(activity)
			});
	});
var $author$project$TimesheetPage$Messages$CreateActivitiesFeesResponse = function (a) {
	return {$: 67, a: a};
};
var $author$project$Activities$Requests$chargeActivities = F2(
	function (csrfToken, activityIds) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'activity_ids',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, activityIds))
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$CreateActivitiesFeesResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: '/api/activities/accept_activities'
			});
	});
var $author$project$Activities$Messages$DeleteActivitiesResponse = function (a) {
	return {$: 20, a: a};
};
var $author$project$Activities$Requests$deleteActivities = F2(
	function (csrfToken, activityIds) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'activity_ids',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, activityIds))
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$Activities$Messages$DeleteActivitiesResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: '/api/activities/batch_accept'
			});
	});
var $author$project$Activities$Messages$DeleteActivityResponse = function (a) {
	return {$: 18, a: a};
};
var $author$project$Activities$Requests$deleteActivity = F2(
	function (csrfToken, activity) {
		return $author$project$Requests$delete(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$Activities$Messages$DeleteActivityResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: $author$project$Activities$Requests$activityUrl(activity)
			});
	});
var $author$project$Activities$Update$focusOn = function (id) {
	return A2(
		$elm$core$Task$attempt,
		$author$project$TimesheetPage$Messages$FocusFailure,
		$elm$browser$Browser$Dom$focus(id));
};
var $justinmimbs$time_extra$Time$Extra$Parts = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return {gA: day, hn: hour, b0: millisecond, h4: minute, h9: month, cl: second, j$: year};
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.j$;
		var month = _v0.h9;
		var day = _v0.gA;
		var hour = _v0.hn;
		var minute = _v0.h4;
		var second = _v0.cl;
		var millisecond = _v0.b0;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$CoreX$DateConstruct$fromParts = F8(
	function (zone, year, month, day, hour, minute, second, ms) {
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			A7($justinmimbs$time_extra$Time$Extra$Parts, year, month, day, hour, minute, second, ms));
	});
var $author$project$CoreX$DateConstruct$fromDate = F2(
	function (zone, date) {
		return A8(
			$author$project$CoreX$DateConstruct$fromParts,
			zone,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			$justinmimbs$date$Date$day(date),
			0,
			0,
			0,
			0);
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$CoreX$DateConstruct$fromDateString = F2(
	function (zone, dateString) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$CoreX$DateConstruct$fromDate(zone),
			$elm$core$Result$toMaybe(
				$justinmimbs$date$Date$fromIsoString(dateString)));
	});
var $turboMaCk$any_dict$Dict$Any$insert = F3(
	function (k, v, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				d: A3(
					$elm$core$Dict$insert,
					inner.y(k),
					_Utils_Tuple2(k, v),
					inner.d)
			});
	});
var $turboMaCk$any_set$Set$Any$insert = F2(
	function (a, _v0) {
		var dict = _v0;
		return A3($turboMaCk$any_dict$Dict$Any$insert, a, 0, dict);
	});
var $author$project$Activities$Messages$SearchActivities = {$: 12};
var $author$project$Activities$Update$queueSearchCmd = $author$project$Utils$send(
	$author$project$Activities$Messages$QueueSearchActivities(
		$Gizra$elm_debouncer$Debouncer$Basic$provideInput($author$project$Activities$Messages$SearchActivities)));
var $turboMaCk$any_dict$Dict$Any$remove = F2(
	function (k, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				d: A2(
					$elm$core$Dict$remove,
					inner.y(k),
					inner.d)
			});
	});
var $turboMaCk$any_set$Set$Any$remove = F2(
	function (a, _v0) {
		var dict = _v0;
		return A2($turboMaCk$any_dict$Dict$Any$remove, a, dict);
	});
var $turboMaCk$any_dict$Dict$Any$removeAll = function (_v0) {
	var inner = _v0;
	return {d: $elm$core$Dict$empty, y: inner.y};
};
var $turboMaCk$any_set$Set$Any$removeAll = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$removeAll(dict);
};
var $author$project$Activities$Update$returnNone = function (_v0) {
	var feed = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(feed, cmd, $elm$core$Maybe$Nothing);
};
var $author$project$Activities$Update$returnTimesheetCmd = F2(
	function (timesheetMsg, _v0) {
		var feed = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple3(feed, cmd, timesheetMsg);
	});
var $author$project$Ports$BrowserExtension$browserExtensionMessage = _Platform_outgoingPort('browserExtensionMessage', $elm$core$Basics$identity);
var $author$project$Ports$BrowserExtension$encodeActivityIds = function (ids) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'activity_ids',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, ids))
			]));
};
var $author$project$Ports$BrowserExtension$encodeMessage = function (message) {
	var ids = message;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('END_AGGREGATE')),
				_Utils_Tuple2(
				'payload',
				$author$project$Ports$BrowserExtension$encodeActivityIds(ids))
			]));
};
var $author$project$Ports$BrowserExtension$sendExtensionMessage = function (msg) {
	return $author$project$Ports$BrowserExtension$browserExtensionMessage(
		$author$project$Ports$BrowserExtension$encodeMessage(msg));
};
var $author$project$ActivityFeedLogic$setActivitiesLoading = F2(
	function (newStatus, activityFeed) {
		return _Utils_update(
			activityFeed,
			{cP: newStatus});
	});
var $author$project$ActivityFeedLogic$setActivityFeedBeforeTime = F2(
	function (beforeTime, activityFeed) {
		return _Utils_update(
			activityFeed,
			{g2: beforeTime});
	});
var $author$project$ActivityFeedLogic$setActivityFeedFilters = F2(
	function (feedFilters, activityFeed) {
		return _Utils_update(
			activityFeed,
			{g4: feedFilters});
	});
var $author$project$ActivityFeedLogic$setActivityFeedMode = F2(
	function (newFeedMode, activityFeed) {
		return _Utils_update(
			activityFeed,
			{g5: newFeedMode});
	});
var $author$project$ActivityFeedLogic$setActivityFilterMenuOpen = F2(
	function (newFilterMenuOpen, activityFeed) {
		return _Utils_update(
			activityFeed,
			{g8: newFilterMenuOpen});
	});
var $author$project$ActivityFeedLogic$setActivitySearchDebouncer = F2(
	function (activityFeed, newDebouncer) {
		return _Utils_update(
			activityFeed,
			{i0: newDebouncer});
	});
var $author$project$ActivityFeedLogic$setActivitySearchMode = F2(
	function (newSearchMode, activityFeed) {
		return _Utils_update(
			activityFeed,
			{i1: newSearchMode});
	});
var $author$project$ActivityFeedLogic$setActivitySearchTerms = F2(
	function (newSearchTerms, activityFeed) {
		return _Utils_update(
			activityFeed,
			{eX: newSearchTerms});
	});
var $author$project$Activities$Update$setFlashCmd = F4(
	function (response, actionType, entityType, entityIds) {
		return $author$project$Utils$send(
			A4($author$project$TimesheetPage$Messages$SetFlashMessage, response, actionType, entityType, entityIds));
	});
var $author$project$Activities$Requests$activityFetchTracker = function (requestId) {
	return 'activity-feed-fetch-' + $elm$core$String$fromInt(requestId);
};
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $author$project$Activities$Requests$cancelActivitiesFetch = function (requestId) {
	return $elm$http$Http$cancel(
		$author$project$Activities$Requests$activityFetchTracker(requestId));
};
var $author$project$Activities$Messages$FetchedActivities = function (a) {
	return {$: 1, a: a};
};
var $author$project$Activities$Data$decodeActivities = $elm$json$Json$Decode$list($author$project$Activities$Data$activityDecoder);
var $author$project$CoreX$Appendable$andAppend = F2(
	function (addition, base) {
		return _Utils_ap(base, addition);
	});
var $author$project$Activities$Requests$beforeTimeParam = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($author$project$CoreX$DateFormat$toUtcIsoString),
	$author$project$Requests$Param('before_time'));
var $author$project$Activities$Requests$excludeIdsParam = function (ids) {
	return A2(
		$elm$core$List$map,
		function (id) {
			return A2(
				$author$project$Requests$Param,
				'exclude_ids[]',
				$elm$core$Maybe$Just(id));
		},
		A2($elm$core$List$map, $elm$core$String$fromInt, ids));
};
var $author$project$Activities$Data$activityFeedFilterParam = function (feedFilter) {
	switch (feedFilter) {
		case 3:
			return 'appointment';
		case 1:
			return 'phonecall';
		case 2:
			return 'ms-teams-call';
		case 4:
			return 'document';
		case 0:
			return 'email';
		case 5:
			return 'browser-research';
		default:
			return '';
	}
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $turboMaCk$any_dict$Dict$Any$toList = function (_v0) {
	var dict = _v0.d;
	return $elm$core$Dict$values(dict);
};
var $turboMaCk$any_dict$Dict$Any$keys = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$map($elm$core$Tuple$first),
	$turboMaCk$any_dict$Dict$Any$toList);
var $turboMaCk$any_set$Set$Any$toList = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$keys(dict);
};
var $author$project$Activities$Requests$filtersParam = function (feedFilters) {
	return A2(
		$elm$core$List$map,
		function (filter) {
			return A2(
				$author$project$Requests$Param,
				'filters[]',
				$elm$core$Maybe$Just(filter));
		},
		A2(
			$elm$core$List$map,
			$author$project$Activities$Data$activityFeedFilterParam,
			$turboMaCk$any_set$Set$Any$toList(
				A2($turboMaCk$any_set$Set$Any$remove, 6, feedFilters))));
};
var $author$project$Activities$Requests$searchQueryParam = $author$project$Requests$Param('search_query');
var $author$project$Activities$Requests$stateParam = function (feedDisplay) {
	var asString = function () {
		if (!feedDisplay) {
			return $elm$core$Maybe$Just('active');
		} else {
			return $elm$core$Maybe$Just('inactive');
		}
	}();
	return A2($author$project$Requests$Param, 'state', asString);
};
var $author$project$Activities$Requests$fetchActivitiesUrlFor = F5(
	function (feedFilters, feedDisplay, searchQuery, timestamp, excludedActivityIds) {
		return A2(
			$author$project$Requests$toUrl,
			'api/activities/',
			A2(
				$author$project$CoreX$Appendable$andAppend,
				$author$project$Activities$Requests$filtersParam(feedFilters),
				A2(
					$author$project$CoreX$Appendable$andAppend,
					$author$project$Activities$Requests$excludeIdsParam(excludedActivityIds),
					_List_fromArray(
						[
							$author$project$Activities$Requests$stateParam(feedDisplay),
							$author$project$Activities$Requests$beforeTimeParam(timestamp),
							$author$project$Activities$Requests$searchQueryParam(searchQuery)
						]))));
	});
var $author$project$Activities$Requests$fetchActivities = F2(
	function (requestId, _v0) {
		var feedFilters = _v0.g4;
		var feedMode = _v0.g5;
		var searchTerms = _v0.eX;
		var feedBeforeTime = _v0.g2;
		return $elm$http$Http$request(
			{
				fW: $elm$http$Http$emptyBody,
				z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$Activities$Messages$FetchedActivities, $author$project$Activities$Data$decodeActivities),
				A: _List_Nil,
				ei: 'GET',
				fl: $elm$core$Maybe$Nothing,
				fo: $elm$core$Maybe$Just(
					$author$project$Activities$Requests$activityFetchTracker(requestId)),
				jR: A5($author$project$Activities$Requests$fetchActivitiesUrlFor, feedFilters, feedMode, searchTerms, feedBeforeTime, _List_Nil)
			});
	});
var $author$project$ActivityFeedLogic$nextActivityRequestId = function (activityFeed) {
	return _Utils_update(
		activityFeed,
		{aP: activityFeed.aP + 1});
};
var $author$project$Activities$Update$startActivitiesFetch = function (model) {
	var fetching = $author$project$ActivityFeedLogic$nextActivityRequestId(
		A2($author$project$ActivityFeedLogic$setActivitiesLoading, 0, model));
	var cancelInFlight = $author$project$Activities$Requests$cancelActivitiesFetch(model.aP);
	return _Utils_Tuple2(
		fetching,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cancelInFlight,
					A2($author$project$Activities$Requests$fetchActivities, fetching.aP, fetching)
				])));
};
var $author$project$Activities$Update$activityIdsWithSameStartTime = F2(
	function (activity, activities) {
		var equalstartsAt = F2(
			function (maybeActivity, a2) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$CoreX$DateCompare$equal(a2.jg),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.jg;
							},
							maybeActivity)));
			});
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.aC;
			},
			A2(
				$elm$core$List$filter,
				equalstartsAt(activity),
				activities));
	});
var $author$project$Activities$Messages$FetchedMoreActivities = function (a) {
	return {$: 2, a: a};
};
var $author$project$Activities$Requests$fetchActivitiesBefore = F4(
	function (requestId, _v0, timestamp, excludedActivityIds) {
		var feedFilters = _v0.g4;
		var feedMode = _v0.g5;
		var searchTerms = _v0.eX;
		return $elm$http$Http$request(
			{
				fW: $elm$http$Http$emptyBody,
				z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$Activities$Messages$FetchedMoreActivities, $author$project$Activities$Data$decodeActivities),
				A: _List_Nil,
				ei: 'GET',
				fl: $elm$core$Maybe$Nothing,
				fo: $elm$core$Maybe$Just(
					$author$project$Activities$Requests$activityFetchTracker(requestId)),
				jR: A5($author$project$Activities$Requests$fetchActivitiesUrlFor, feedFilters, feedMode, searchTerms, timestamp, excludedActivityIds)
			});
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Activities$Update$startMoreActivitiesFetch = function (model) {
	var lastActivity = $elm_community$list_extra$List$Extra$last(model.fF);
	var oldestTimestamp = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.jg;
		},
		lastActivity);
	var fetching = $author$project$ActivityFeedLogic$nextActivityRequestId(
		A2($author$project$ActivityFeedLogic$setActivitiesLoading, 0, model));
	var excludedActivityId = A2($author$project$Activities$Update$activityIdsWithSameStartTime, lastActivity, model.fF);
	var cancelInFlight = $author$project$Activities$Requests$cancelActivitiesFetch(model.aP);
	return _Utils_Tuple2(
		fetching,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cancelInFlight,
					A4($author$project$Activities$Requests$fetchActivitiesBefore, fetching.aP, fetching, oldestTimestamp, excludedActivityId)
				])));
};
var $turboMaCk$any_set$Set$Any$toggle = F2(
	function (a, set) {
		return A2($turboMaCk$any_set$Set$Any$member, a, set) ? A2($turboMaCk$any_set$Set$Any$remove, a, set) : A2($turboMaCk$any_set$Set$Any$insert, a, set);
	});
var $author$project$ActivityFeedLogic$replaceActivity = F2(
	function (updatedActivity, activities) {
		return A3(
			$elm_community$list_extra$List$Extra$setIf,
			$author$project$CoreX$Predicate$hasId(updatedActivity.aC),
			updatedActivity,
			activities);
	});
var $author$project$ActivityFeedLogic$updateActivityIn = F2(
	function (model, updatedActivity) {
		return A2(
			$author$project$ActivityFeedLogic$asActivitiesIn,
			model,
			A2($author$project$ActivityFeedLogic$replaceActivity, updatedActivity, model.fF));
	});
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.j$ - 1)) + ($justinmimbs$date$Date$monthToNumber(date.h9) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.gA,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $author$project$CoreX$DateConstruct$withDayOffset = F2(
	function (zone, offset) {
		return A3($justinmimbs$time_extra$Time$Extra$add, 11, offset, zone);
	});
var $author$project$Activities$Update$update = F4(
	function (zone, csrfToken, msg, model) {
		switch (msg.$) {
			case 3:
				var activity = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$ActivityFeedLogic$asActivitiesIn,
							model,
							A2($author$project$Activities$ActivityLogic$addActivityToOpenFeed, activity, model))));
			case 4:
				var activities = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$ActivityFeedLogic$asActivitiesIn,
							model,
							A2($author$project$Activities$ActivityLogic$addActivitiesToOpenFeed, activities, model))));
			case 5:
				var activity = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2($author$project$ActivityFeedLogic$updateActivityIn, model, activity)));
			case 6:
				var activityIds = msg.a;
				var shouldKeepActivity = function (activity) {
					return !A2($elm$core$List$member, activity.aC, activityIds);
				};
				var _v1 = A2($elm$core$List$partition, shouldKeepActivity, model.fF);
				var activitiesKept = _v1.a;
				var activityRemoved = _v1.b;
				var removedActivityIds = $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.aC;
						},
						activityRemoved));
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					$elm$core$Maybe$Just(
						$author$project$Utils$send(
							$author$project$TimesheetPage$Messages$DeselectActivitiesForMergeFees(removedActivityIds))),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{fF: activitiesKept})));
			case 1:
				if (!msg.a.$) {
					var _v2 = msg.a.a;
					var activities = _v2.b;
					return $author$project$Activities$Update$returnNone(
						$Fresheyeball$elm_return$Return$singleton(
							A2(
								$author$project$ActivityFeedLogic$setActivitiesLoading,
								A2($author$project$PagedLoadingStatusLogic$hasMore, 1, activities),
								A2($author$project$ActivityFeedLogic$setActivities, activities, model))));
				} else {
					var response = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Activities$Update$setFlashResponseCmd(response)));
				}
			case 2:
				if (!msg.a.$) {
					var _v3 = msg.a.a;
					var activities = _v3.b;
					return $author$project$Activities$Update$returnNone(
						$Fresheyeball$elm_return$Return$singleton(
							A2(
								$author$project$ActivityFeedLogic$setActivitiesLoading,
								A2($author$project$PagedLoadingStatusLogic$hasMore, 1, activities),
								A2(
									$author$project$ActivityFeedLogic$setActivities,
									_Utils_ap(model.fF, activities),
									model))));
				} else {
					var response = msg.a.a;
					return A2(
						$author$project$Activities$Update$returnTimesheetCmd,
						$elm$core$Maybe$Just(
							$author$project$Activities$Update$setFlashResponseCmd(response)),
						$Fresheyeball$elm_return$Return$singleton(
							A2($author$project$ActivityFeedLogic$setActivitiesLoading, 2, model)));
				}
			case 7:
				var searchMode = msg.a;
				return $author$project$Activities$Update$returnNone(
					$author$project$Activities$Update$startActivitiesFetch(
						A2(
							$author$project$ActivityFeedLogic$setActivitySearchTerms,
							$elm$core$Maybe$Nothing,
							A2($author$project$ActivityFeedLogic$setActivitySearchMode, searchMode, model))));
			case 8:
				var isOpen = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2($author$project$ActivityFeedLogic$setActivityFilterMenuOpen, isOpen, model)));
			case 9:
				var display = msg.a;
				return $author$project$Activities$Update$returnNone(
					$author$project$Activities$Update$startActivitiesFetch(
						A2(
							$author$project$ActivityFeedLogic$setActivities,
							_List_Nil,
							A2(
								$author$project$ActivityFeedLogic$setActivityFeedMode,
								display,
								A2($author$project$ActivityFeedLogic$setActivityFilterMenuOpen, false, model)))));
			case 10:
				var feedFilter = msg.a;
				var feedFilters = msg.b;
				var feedMode = msg.c;
				var updatedFeedFilters = A2($turboMaCk$any_set$Set$Any$toggle, feedFilter, feedFilters);
				return $author$project$Activities$Update$returnNone(
					$author$project$Activities$Update$startActivitiesFetch(
						A2(
							$author$project$ActivityFeedLogic$setActivities,
							_List_Nil,
							A2(
								$author$project$ActivityFeedLogic$setActivityFeedMode,
								feedMode,
								A2($author$project$ActivityFeedLogic$setActivityFeedFilters, updatedFeedFilters, model)))));
			case 11:
				var emptyFilters = $turboMaCk$any_set$Set$Any$removeAll(model.g4);
				return $author$project$Activities$Update$returnNone(
					$author$project$Activities$Update$startActivitiesFetch(
						A2(
							$author$project$ActivityFeedLogic$setActivities,
							_List_Nil,
							A2(
								$author$project$ActivityFeedLogic$setActivityFilterMenuOpen,
								false,
								A2(
									$author$project$ActivityFeedLogic$setActivityFeedBeforeTime,
									$elm$core$Maybe$Nothing,
									A2($author$project$ActivityFeedLogic$setActivityFeedFilters, emptyFilters, model))))));
			case 0:
				var dateString = msg.a;
				var updateDateFilter = $elm$core$String$isEmpty(dateString) ? $turboMaCk$any_set$Set$Any$remove(6) : $turboMaCk$any_set$Set$Any$insert(6);
				var beforeTime = A2(
					$elm$core$Maybe$map,
					A2($author$project$CoreX$DateConstruct$withDayOffset, zone, 1),
					A2($author$project$CoreX$DateConstruct$fromDateString, zone, dateString));
				return $author$project$Activities$Update$returnNone(
					$author$project$Activities$Update$startActivitiesFetch(
						A2(
							$author$project$ActivityFeedLogic$setActivities,
							_List_Nil,
							A2(
								$author$project$ActivityFeedLogic$setActivityFeedBeforeTime,
								beforeTime,
								A2(
									$author$project$ActivityFeedLogic$setActivityFeedFilters,
									updateDateFilter(model.g4),
									model)))));
			case 12:
				return $author$project$Activities$Update$returnNone(
					$author$project$Activities$Update$startActivitiesFetch(model));
			case 13:
				var text = msg.a;
				var updatedModel = A2(
					$author$project$ActivityFeedLogic$setActivitySearchTerms,
					$elm$core$Maybe$Just(text),
					model);
				var runnable = $elm$core$String$length(text) > 1;
				var cmd = runnable ? $author$project$Activities$Update$queueSearchCmd : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(updatedModel, cmd, $elm$core$Maybe$Nothing);
			case 14:
				var subMsg = msg.a;
				var _v4 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, model.i0);
				var debouncedModel = _v4.a;
				var subCmd = _v4.b;
				var emittedMsg = _v4.c;
				var updatedModel = A2($author$project$ActivityFeedLogic$setActivitySearchDebouncer, model, debouncedModel);
				var mappedCmd = A2($elm$core$Platform$Cmd$map, $author$project$Activities$Messages$QueueSearchActivities, subCmd);
				if (!emittedMsg.$) {
					var emitted = emittedMsg.a;
					var _v6 = A4($author$project$Activities$Update$update, zone, csrfToken, emitted, updatedModel);
					var m = _v6.a;
					var c = _v6.b;
					var topMsg = _v6.c;
					return _Utils_Tuple3(
						m,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[c, mappedCmd])),
						topMsg);
				} else {
					return _Utils_Tuple3(updatedModel, mappedCmd, $elm$core$Maybe$Nothing);
				}
			case 15:
				var activity = msg.a;
				var once = msg.b;
				var trackEventCmd = A2($author$project$Activities$Update$acceptActivityEventCmd, once, activity);
				var cmd = A3($author$project$Activities$Requests$acceptActivity, csrfToken, activity, once);
				var topCmds = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[cmd, trackEventCmd]));
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					$elm$core$Maybe$Just(topCmds),
					A2($Fresheyeball$elm_return$Return$return, model, $elm$core$Platform$Cmd$none));
			case 16:
				var activityIds = msg.a;
				var ids = $elm$core$Set$toList(activityIds);
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					$elm$core$Maybe$Just(
						A2($author$project$Activities$Requests$chargeActivities, csrfToken, ids)),
					A2($Fresheyeball$elm_return$Return$return, model, $elm$core$Platform$Cmd$none));
			case 19:
				var activityIds = msg.a;
				var newModel = A2($author$project$ActivityFeedLogic$removeFromActivityIds, model, activityIds);
				var ids = $elm$core$Set$toList(activityIds);
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					$elm$core$Maybe$Just(
						$author$project$Utils$send(
							$author$project$TimesheetPage$Messages$DeselectActivitiesForMergeFees(activityIds))),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$Activities$Requests$deleteActivities, csrfToken, ids),
						$Fresheyeball$elm_return$Return$singleton(newModel)));
			case 20:
				if (!msg.a.$) {
					var _v7 = msg.a.a;
					return $author$project$Activities$Update$returnNone(
						$Fresheyeball$elm_return$Return$singleton(model));
				} else {
					var response = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Activities$Update$setFlashResponseCmd(response)));
				}
			case 17:
				var activity = msg.a;
				var topCmd = $elm$core$Maybe$Just(
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Utils$send(
								$author$project$TimesheetPage$Messages$DeselectActivitiesForMergeFees(
									$elm$core$Set$singleton(activity.aC))),
								$author$project$Ports$EventTracking$trackEvent('Deleted Activity')
							])));
				var newModel = A2(
					$author$project$ActivityFeedLogic$asActivitiesIn,
					model,
					A2($elm_community$list_extra$List$Extra$remove, activity, model.fF));
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					topCmd,
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$Activities$Requests$deleteActivity, csrfToken, activity),
						$Fresheyeball$elm_return$Return$singleton(newModel)));
			case 18:
				if (!msg.a.$) {
					var _v8 = msg.a.a;
					return $author$project$Activities$Update$returnNone(
						$Fresheyeball$elm_return$Return$singleton(model));
				} else {
					var response = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Activities$Update$setFlashResponseCmd(response)));
				}
			case 21:
				var activity = msg.a;
				var topCmd = $elm$core$Maybe$Just(
					$author$project$Ports$EventTracking$trackEvent('DeleteAndDowngrade Activity'));
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					topCmd,
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$Activities$Requests$blockActivity, csrfToken, activity),
						$Fresheyeball$elm_return$Return$singleton(model)));
			case 22:
				if (!msg.a.$) {
					var _v9 = msg.a.a;
					var response = _v9.b;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							A4($author$project$Activities$Update$setFlashCmd, response, 2, 3, _List_Nil)));
				} else {
					var response = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Activities$Update$setFlashResponseCmd(response)));
				}
			case 23:
				var activity = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$ActivityFeedLogic$updateActivityIn,
							model,
							_Utils_update(
								activity,
								{hw: false}))));
			case 25:
				var groupByKey = msg.a;
				var focusOnKebabCmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (key) {
							return $author$project$Activities$Update$focusOn('activity-kebab' + key);
						},
						groupByKey));
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					$elm$core$Maybe$Just(focusOnKebabCmd),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{it: groupByKey})));
			case 24:
				var activity = msg.a;
				var focusOnKebabCmd = $author$project$Activities$Update$focusOn(
					'activity-kebab' + $elm$core$String$fromInt(activity.aC));
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					$elm$core$Maybe$Just(focusOnKebabCmd),
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$ActivityFeedLogic$updateActivityIn,
							model,
							_Utils_update(
								activity,
								{hw: true}))));
			case 27:
				var activity = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$ActivityFeedLogic$updateActivityIn,
							model,
							_Utils_update(
								activity,
								{hz: !activity.hz}))));
			case 26:
				var activity = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$ActivityFeedLogic$updateActivityIn,
							model,
							_Utils_update(
								activity,
								{hx: !activity.hx}))));
			case 28:
				var groupByKey = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$ActivityFeedLogic$asExpandedActivityGroupsIn,
							model,
							A2($elm$core$List$cons, groupByKey, model.ds))));
			case 29:
				var groupByKey = msg.a;
				return $author$project$Activities$Update$returnNone(
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$ActivityFeedLogic$asExpandedActivityGroupsIn,
							model,
							A2($elm_community$list_extra$List$Extra$remove, groupByKey, model.ds))));
			case 30:
				var groupByKey = msg.a;
				var conversationActivities = A3($author$project$ActivityFeedLogic$activitiesWithGroupKey, zone, model.fF, groupByKey);
				var newModel = A2($author$project$ActivityFeedLogic$removeFromActivities, model, conversationActivities);
				var activityIds = $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.aC;
						},
						conversationActivities));
				var cmd = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A4($author$project$Activities$Requests$acceptActivities, csrfToken, conversationActivities, $elm$core$Maybe$Nothing, true),
							$author$project$Utils$send(
							$author$project$TimesheetPage$Messages$DeselectActivitiesForMergeFees(activityIds))
						]));
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(cmd));
			case 32:
				var groupByKey = msg.a;
				var outstandingEvents = A2(
					$elm$core$List$map,
					function ($) {
						return $.aC;
					},
					A2(
						$elm$core$List$filter,
						function (a) {
							return !$elm_community$maybe_extra$Maybe$Extra$isJust(
								$author$project$Activities$ActivityLogic$getDuration(a));
						},
						A3($author$project$ActivityFeedLogic$activitiesWithGroupKey, zone, model.fF, groupByKey)));
				return $author$project$Activities$Update$returnNone(
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Ports$BrowserExtension$sendExtensionMessage(outstandingEvents),
						$Fresheyeball$elm_return$Return$singleton(model)));
			case 31:
				var groupByKey = msg.a;
				var conversationActivities = A3($author$project$ActivityFeedLogic$activitiesWithGroupKey, zone, model.fF, groupByKey);
				var ids = A2(
					$elm$core$List$map,
					function (a) {
						return a.aC;
					},
					conversationActivities);
				var cmd = A2($author$project$Activities$Requests$deleteActivities, csrfToken, ids);
				var activityIds = $elm$core$Set$fromList(ids);
				return A2(
					$author$project$Activities$Update$returnTimesheetCmd,
					$elm$core$Maybe$Just(
						$author$project$Utils$send(
							$author$project$TimesheetPage$Messages$DeselectActivitiesForMergeFees(activityIds))),
					A2(
						$Fresheyeball$elm_return$Return$command,
						cmd,
						$Fresheyeball$elm_return$Return$singleton(
							A2($author$project$ActivityFeedLogic$removeFromActivities, model, conversationActivities))));
			case 33:
				return $author$project$Activities$Update$returnNone(
					$author$project$Activities$Update$startMoreActivitiesFetch(model));
			default:
				var extMsg = msg.a;
				return $author$project$Activities$Update$returnNone(
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Ports$BrowserExtension$sendExtensionMessage(extMsg),
						$Fresheyeball$elm_return$Return$singleton(model)));
		}
	});
var $author$project$TimesheetPage$Messages$MergeFeesAction = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$MergeFees$Messages$SelectFeeType = $elm$core$Basics$identity;
var $author$project$Components$MergeFees$Update$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($o_train$elm_search_input$Select$update, subMsg, model.eZ);
		var selectInputModel = _v1.a;
		var parentMsg = _v1.b;
		var selectCmd = _v1.c;
		var _v2 = function () {
			if (!parentMsg.$) {
				var item = parentMsg.a;
				var activityType = A2(
					$elm$core$Maybe$withDefault,
					'No Activity',
					A2($elm$core$Maybe$map, $author$project$Activities$Model$ActivityType$stringFromActivityType, item.aa.hQ));
				return _Utils_Tuple2(
					true,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$MergeEvent(
							_Utils_Tuple3(
								'Selected Fee Type',
								activityType,
								$elm$core$Set$size(model.dD)))));
			} else {
				return _Utils_Tuple2(model.fq, $elm$core$Platform$Cmd$none);
			}
		}();
		var selected = _v2.a;
		var eventTrackCmd = _v2.b;
		return A2(
			$Fresheyeball$elm_return$Return$command,
			eventTrackCmd,
			A2(
				$Fresheyeball$elm_return$Return$mapCmd,
				$author$project$TimesheetPage$Messages$MergeFeesAction,
				A2(
					$Fresheyeball$elm_return$Return$command,
					A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, selectCmd),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{eZ: selectInputModel, fq: selected})))));
	});
var $author$project$Components$SplitFee$Messages$MatterInputMessage = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$SplitFee$Model$applyFeeInput = F4(
	function (source, f, g, _v0) {
		var originalFeeInput = _v0.cd;
		var splitFeeInput = _v0.cz;
		if (!source) {
			return f(originalFeeInput);
		} else {
			return g(splitFeeInput);
		}
	});
var $author$project$Components$SplitFee$Update$domId = function (source) {
	return A3(
		$author$project$Components$SplitFee$Model$applyFeeInput,
		source,
		$elm$core$Basics$always('origin-fee-matter-input'),
		$elm$core$Basics$always('split-fee-matter-input'));
};
var $author$project$Components$SplitFee$Model$applyEither = F2(
	function (source, f) {
		return A3($author$project$Components$SplitFee$Model$applyFeeInput, source, f, f);
	});
var $author$project$Components$SplitFee$Update$matterInput = A2(
	$author$project$CoreX$Basics$flip,
	$author$project$Components$SplitFee$Model$applyEither,
	function ($) {
		return $.eg;
	});
var $author$project$Components$SplitFee$Model$applyFeeMeaure = F3(
	function (m, f, g) {
		if (!m.$) {
			var units = m.a;
			return f(units);
		} else {
			var durationInput = m.a;
			return g(durationInput);
		}
	});
var $author$project$Components$DurationInput$DurationInputLogic$updateUnits = F2(
	function (durationInput, minutesPerUnit) {
		var hoursInMinutes = durationInput._ * 60;
		var totalMinutes = hoursInMinutes + durationInput.aF;
		return totalMinutes / minutesPerUnit;
	});
var $author$project$Timesheet$Requests$splitFee = function (_v0) {
	var csrfToken = _v0.gr;
	var fee = _v0.dA;
	var originalFeeInput = _v0.cd;
	var splitFeeInput = _v0.cz;
	var minutesPerUnit = _v0.ej;
	var toUnits = function (_v1) {
		var measure = _v1.b_;
		return A3(
			$author$project$Components$SplitFee$Model$applyFeeMeaure,
			measure,
			$elm$core$Basics$identity,
			function (d) {
				return A2($author$project$Components$DurationInput$DurationInputLogic$updateUnits, d, minutesPerUnit);
			});
	};
	var encodeNullableIn = F3(
		function (rec, getter, decoder) {
			return A2(
				$elm_community$json_extra$Json$Encode$Extra$maybe,
				decoder,
				A2($elm$core$Maybe$map, getter, rec));
		});
	var body = $elm$http$Http$jsonBody(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'original_fee',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'matter_id',
								A3(
									encodeNullableIn,
									originalFeeInput.cq,
									function ($) {
										return $.aC;
									},
									$elm$json$Json$Encode$int)),
								_Utils_Tuple2(
								'units',
								$elm$json$Json$Encode$float(
									toUnits(originalFeeInput))),
								_Utils_Tuple2(
								'duration_in_seconds',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, originalFeeInput.bz))
							]))),
					_Utils_Tuple2(
					'split_fee',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'matter_id',
								A3(
									encodeNullableIn,
									splitFeeInput.cq,
									function ($) {
										return $.aC;
									},
									$elm$json$Json$Encode$int)),
								_Utils_Tuple2(
								'units',
								$elm$json$Json$Encode$float(
									toUnits(splitFeeInput))),
								_Utils_Tuple2(
								'split_duration_in_seconds',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, splitFeeInput.bz)),
								_Utils_Tuple2(
								'record_in_minutes',
								$elm$json$Json$Encode$bool(fee.iQ))
							])))
				])));
	return $author$project$Requests$post(
		{
			fW: body,
			z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$CreateActivityFeeResponse),
			A: _List_fromArray(
				[
					A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
				]),
			jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/split')
		});
};
var $author$project$Components$SplitFee$Messages$Origin = 0;
var $author$project$Components$SplitFee$Messages$Split = 1;
var $author$project$Components$SplitFee$SplitLogic$maxSteps = F2(
	function (increment, total) {
		return A2($elm$core$Basics$max, 0, ((total / increment) | 0) - 1);
	});
var $author$project$Components$SplitFee$SplitLogic$newHundredths = F4(
	function (increment, total, extraTo, steps) {
		return (!A2($author$project$Components$SplitFee$SplitLogic$maxSteps, increment, total)) ? 0 : ((steps * increment) + A3($author$project$Components$SplitFee$SplitLogic$oddPart, increment, total, extraTo));
	});
var $author$project$Components$SplitFee$Model$newHundredths = function (_v0) {
	var increment = _v0.a0;
	var totalHundredths = _v0.bh;
	var extraTo = _v0.bD;
	var newSteps = _v0.b4;
	return A4($author$project$Components$SplitFee$SplitLogic$newHundredths, increment, totalHundredths, extraTo, newSteps);
};
var $author$project$Components$SplitFee$SplitLogic$splitDuration = F3(
	function (total, newAmount, duration) {
		if (!total) {
			return _Utils_Tuple2(duration, 0);
		} else {
			var newSeconds = ((((2 * duration) * newAmount) + total) / (2 * total)) | 0;
			return _Utils_Tuple2(duration - newSeconds, newSeconds);
		}
	});
var $author$project$Components$SplitFee$Update$updateFeeInput = F3(
	function (source, updateFn, model) {
		return A4(
			$author$project$Components$SplitFee$Model$applyFeeInput,
			source,
			function (input) {
				return _Utils_update(
					model,
					{
						cd: updateFn(input)
					});
			},
			function (input) {
				return _Utils_update(
					model,
					{
						cz: updateFn(input)
					});
			},
			model);
	});
var $author$project$Components$SplitFee$Update$updateFeeInputDuration = F2(
	function (source, duration) {
		return A2(
			$author$project$Components$SplitFee$Update$updateFeeInput,
			source,
			function (input) {
				return _Utils_update(
					input,
					{bz: duration});
			});
	});
var $author$project$Components$SplitFee$Update$updateDuration = function (model) {
	var fee = model.dA;
	var totalHundredths = model.bh;
	var durationInSeconds = A2(
		$elm_community$maybe_extra$Maybe$Extra$orElse,
		fee.jc,
		A2($elm$core$Maybe$andThen, $author$project$Activities$ActivityLogic$getDuration, fee.fG));
	var splitDurations = A2(
		$elm$core$Maybe$map,
		A2(
			$author$project$Components$SplitFee$SplitLogic$splitDuration,
			totalHundredths,
			$author$project$Components$SplitFee$Model$newHundredths(model)),
		durationInSeconds);
	return A3(
		$author$project$Components$SplitFee$Update$updateFeeInputDuration,
		1,
		A2($elm$core$Maybe$map, $elm$core$Tuple$second, splitDurations),
		A3(
			$author$project$Components$SplitFee$Update$updateFeeInputDuration,
			0,
			A2($elm$core$Maybe$map, $elm$core$Tuple$first, splitDurations),
			model));
};
var $author$project$Components$SplitFee$Update$updateFeeInputMeasure = F2(
	function (source, measure) {
		return A2(
			$author$project$Components$SplitFee$Update$updateFeeInput,
			source,
			function (input) {
				return _Utils_update(
					input,
					{b_: measure});
			});
	});
var $author$project$Components$SplitFee$Update$updateMeasure = function (model) {
	var fee = model.dA;
	var totalHundredths = model.bh;
	var minutesPerUnit = model.ej;
	var toUnits = function (hundredths) {
		return hundredths / 100;
	};
	var newHundredths_ = $author$project$Components$SplitFee$Model$newHundredths(model);
	var origUnits = toUnits(totalHundredths - newHundredths_);
	var splitUnits = toUnits(newHundredths_);
	return fee.iQ ? A3(
		$author$project$Components$SplitFee$Update$updateFeeInputMeasure,
		1,
		$author$project$Components$SplitFee$Model$Duration(
			A2($author$project$Components$DurationInput$DurationInputLogic$getHoursAndMinutes, splitUnits, minutesPerUnit)),
		A3(
			$author$project$Components$SplitFee$Update$updateFeeInputMeasure,
			0,
			$author$project$Components$SplitFee$Model$Duration(
				A2($author$project$Components$DurationInput$DurationInputLogic$getHoursAndMinutes, origUnits, minutesPerUnit)),
			model)) : A3(
		$author$project$Components$SplitFee$Update$updateFeeInputMeasure,
		1,
		$author$project$Components$SplitFee$Model$Units(splitUnits),
		A3(
			$author$project$Components$SplitFee$Update$updateFeeInputMeasure,
			0,
			$author$project$Components$SplitFee$Model$Units(origUnits),
			model));
};
var $author$project$Components$SplitFee$Model$maxSteps = function (_v0) {
	var increment = _v0.a0;
	var totalHundredths = _v0.bh;
	return A2($author$project$Components$SplitFee$SplitLogic$maxSteps, increment, totalHundredths);
};
var $author$project$Components$SplitFee$Update$updateSteps = F2(
	function (newValue, model) {
		var max = $author$project$Components$SplitFee$Model$maxSteps(model);
		var steps = A3(
			$elm$core$Basics$clamp,
			A2($elm$core$Basics$min, 1, max),
			max,
			A2(
				$elm$core$Maybe$withDefault,
				model.b4,
				$elm$core$String$toInt(newValue)));
		return _Utils_update(
			model,
			{b4: steps});
	});
var $author$project$Components$SplitFee$Update$updateMeasureAndDuration = F2(
	function (newValue, model) {
		return $author$project$Components$SplitFee$Update$updateDuration(
			$author$project$Components$SplitFee$Update$updateMeasure(
				A2($author$project$Components$SplitFee$Update$updateSteps, newValue, model)));
	});
var $author$project$Components$SplitFee$Update$updateSelectedMatter = F3(
	function (source, mInput, matterSelection) {
		var updateFn = function (input) {
			var selectedMatter = function () {
				switch (matterSelection.$) {
					case 1:
						var m = matterSelection.a;
						return $elm$core$Maybe$Just(m);
					case 3:
						return $elm$core$Maybe$Nothing;
					default:
						return input.cq;
				}
			}();
			return _Utils_update(
				input,
				{eg: mInput, cq: selectedMatter});
		};
		return A2($author$project$Components$SplitFee$Update$updateFeeInput, source, updateFn);
	});
var $author$project$Components$SplitFee$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Utils$send(
						$author$project$TimesheetPage$Messages$ModalAction($author$project$Components$Modal$Model$Closed)),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 4:
				var source = msg.a;
				var subMsg = msg.b;
				var mInput = A2($author$project$Components$SplitFee$Update$matterInput, source, model);
				var domId_ = A2($author$project$Components$SplitFee$Update$domId, source, model);
				var _v1 = A4($author$project$Components$MatterInput$Update$update, subMsg, mInput, mInput.iP, domId_);
				var newMatterInput = _v1.a;
				var matterSelection = _v1.b;
				var subCmd = _v1.c;
				return A2(
					$Fresheyeball$elm_return$Return$mapCmd,
					A2(
						$elm$core$Basics$composeL,
						$author$project$TimesheetPage$Messages$SplitFee,
						$author$project$Components$SplitFee$Messages$MatterInputMessage(source)),
					A2(
						$Fresheyeball$elm_return$Return$command,
						subCmd,
						$Fresheyeball$elm_return$Return$singleton(
							A4($author$project$Components$SplitFee$Update$updateSelectedMatter, source, newMatterInput, matterSelection, model))));
			case 2:
				var newValue = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					A2($author$project$Components$SplitFee$Update$updateMeasureAndDuration, newValue, model));
			case 3:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Utils$send(
						$author$project$TimesheetPage$Messages$ModalAction($author$project$Components$Modal$Model$Closed)),
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Timesheet$Requests$splitFee(model),
						$Fresheyeball$elm_return$Return$singleton(model)));
			default:
				return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$Components$UiInfoAlerts$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_update(
					model,
					{bm: !model.bm});
			case 1:
				return model;
			default:
				return model;
		}
	});
var $author$project$FeeEntry$Messages$AiInputMessage = function (a) {
	return {$: 47, a: a};
};
var $author$project$Ports$EventTracking$ChargingBehaviourChange = function (a) {
	return {$: 6, a: a};
};
var $author$project$FeeEntry$Messages$ContactSelectorLoaded = function (a) {
	return {$: 31, a: a};
};
var $author$project$Model$Fee$FeeTypeView$ContactSelectorLoading = {$: 1};
var $author$project$Model$Fee$FeeTypeView$ContactSelectorOpen = function (a) {
	return {$: 0, a: a};
};
var $author$project$FeeEntry$Messages$DebounceDuration = function (a) {
	return {$: 46, a: a};
};
var $author$project$Ports$EventTracking$IsRecordingInMinutes = function (a) {
	return {$: 7, a: a};
};
var $o_train$elm_search_input$Select$Mode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$SearchInput$Model$Open = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$FeeEntry$Messages$PersistMinutes = {$: 41};
var $author$project$Model$Fee$FeeTypeView$SelectContact = function (a) {
	return {$: 2, a: a};
};
var $author$project$FeeEntry$Messages$SelectInput = function (a) {
	return {$: 48, a: a};
};
var $author$project$Ports$EventTracking$UnitsButtonEvent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ports$EventTracking$UnitsInputEvent = function (a) {
	return {$: 5, a: a};
};
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			gA: A2($elm$time$Time$toDay, zone, posix),
			hn: A2($elm$time$Time$toHour, zone, posix),
			b0: A2($elm$time$Time$toMillis, zone, posix),
			h4: A2($elm$time$Time$toMinute, zone, posix),
			h9: A2($elm$time$Time$toMonth, zone, posix),
			cl: A2($elm$time$Time$toSecond, zone, posix),
			j$: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $author$project$FeeEntry$Update$addDateToDateTime = F3(
	function (zone, dateTime, date) {
		var datePartResult = function (dateAsPartsList) {
			if ((((((dateAsPartsList.b && (!dateAsPartsList.a.$)) && dateAsPartsList.b.b) && (!dateAsPartsList.b.a.$)) && dateAsPartsList.b.b.b) && (!dateAsPartsList.b.b.a.$)) && (!dateAsPartsList.b.b.b.b)) {
				var year = dateAsPartsList.a.a;
				var _v3 = dateAsPartsList.b;
				var monthAsInt = _v3.a.a;
				var _v4 = _v3.b;
				var day = _v4.a.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						year,
						$justinmimbs$date$Date$numberToMonth(monthAsInt),
						day));
			} else {
				return $elm$core$Result$Err('Did not receive valid date string as input');
			}
		}(
			A2(
				$elm$core$List$map,
				$elm$core$String$toInt,
				A2($elm$core$String$split, '-', date)));
		if (!datePartResult.$) {
			var _v1 = datePartResult.a;
			var year = _v1.a;
			var month = _v1.b;
			var day = _v1.c;
			return A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				zone,
				function (dt) {
					return _Utils_update(
						dt,
						{gA: day, h9: month, j$: year});
				}(
					A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, dateTime)));
		} else {
			return dateTime;
		}
	});
var $author$project$FeeEntry$Update$addTimeToDateTime = F3(
	function (zone, dateTime, timeString) {
		var timePartResult = function (timeAsPartsList) {
			if ((((timeAsPartsList.b && (!timeAsPartsList.a.$)) && timeAsPartsList.b.b) && (!timeAsPartsList.b.a.$)) && (!timeAsPartsList.b.b.b)) {
				var hour = timeAsPartsList.a.a;
				var _v3 = timeAsPartsList.b;
				var minutes = _v3.a.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(hour, minutes));
			} else {
				return $elm$core$Result$Err('Did not receive valid date string as input');
			}
		}(
			A2(
				$elm$core$List$map,
				$elm$core$String$toInt,
				A2($elm$core$String$split, ':', timeString)));
		if (!timePartResult.$) {
			var _v1 = timePartResult.a;
			var hour = _v1.a;
			var minutes = _v1.b;
			return A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				zone,
				function (dt) {
					return _Utils_update(
						dt,
						{hn: hour, h4: minutes});
				}(
					A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, dateTime)));
		} else {
			return dateTime;
		}
	});
var $author$project$FeeTypeLogic$isRequiredPrefix = function (feeType) {
	var _v0 = feeType.fT;
	switch (_v0) {
		case 2:
			return false;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$FeeTypeLogic$getRequiredPrefix = function (feeType) {
	return $author$project$FeeTypeLogic$isRequiredPrefix(feeType) ? (feeType.dC + ' ') : '';
};
var $author$project$FeeEntry$FeeEntryLogic$applyDescriptionChange = F3(
	function (oldDesc, feeType, newDesc) {
		var requiredPref = $author$project$FeeTypeLogic$getRequiredPrefix(feeType);
		return A2($elm$core$String$startsWith, requiredPref, newDesc) ? $elm$core$Maybe$Just(newDesc) : ((_Utils_cmp(
			$elm$core$String$length(newDesc),
			$elm$core$String$length(requiredPref)) < 0) ? $elm$core$Maybe$Just(requiredPref) : oldDesc);
	});
var $author$project$Components$AutocompleteLogic$isRecordMatching = F2(
	function (searchTermsText, record) {
		var searchTerms = A2(
			$elm$core$String$split,
			' ',
			$elm$core$String$toLower(searchTermsText));
		var recordTerms = A2(
			$elm$core$String$split,
			' ',
			$elm$core$String$toLower(
				A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[record.br, record.dd]))));
		var anyRecordTermStartsWith = function (searchWord) {
			return A2(
				$elm$core$List$any,
				$elm$core$String$startsWith(searchWord),
				recordTerms);
		};
		return A2($elm$core$List$all, anyRecordTermStartsWith, searchTerms);
	});
var $author$project$Components$AutocompleteLogic$applySearchTerms = F2(
	function (searchTermsText, autocompleteDetails) {
		var userHasSearched = $elm$core$String$length(searchTermsText) > 0;
		var matchingRecords = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$List$filter(
				$author$project$Components$AutocompleteLogic$isRecordMatching(searchTermsText)),
			autocompleteDetails.ch);
		var autocompleteIndex = userHasSearched ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing;
		return _Utils_update(
			autocompleteDetails,
			{
				av: autocompleteIndex,
				aZ: matchingRecords,
				eX: $elm$core$Maybe$Just(searchTermsText)
			});
	});
var $author$project$Timesheet$FeeLogic$canEditPosted = F2(
	function (pms, fee) {
		return (fee.eD === 4) && (pms === 1);
	});
var $author$project$FeeEntry$Update$changeAutocompleteStep = F2(
	function (dir, model) {
		var currentSearchInput = model.gt;
		var updatedAutocomplete = function () {
			if (currentSearchInput.$ === 1) {
				var selector = currentSearchInput.a;
				var autocompleteDetails = currentSearchInput.b;
				return A2(
					$author$project$Components$SearchInput$Model$Open,
					selector,
					_Utils_update(
						autocompleteDetails,
						{
							av: A2($author$project$Components$AutocompleteLogic$changeStep, dir, autocompleteDetails.av)
						}));
			} else {
				var other = currentSearchInput;
				return other;
			}
		}();
		return _Utils_update(
			model,
			{gt: updatedAutocomplete});
	});
var $author$project$FeeEntry$FeeEntryLogic$setSearchInput = F2(
	function (searchInput, model) {
		return _Utils_update(
			model,
			{gt: searchInput});
	});
var $author$project$FeeEntry$FeeEntryLogic$closeSearchInput = function (model) {
	return A2($author$project$FeeEntry$FeeEntryLogic$setSearchInput, $author$project$Components$SearchInput$Model$Closed, model);
};
var $author$project$Contacts$ContactLogic$domId = function (contact) {
	return A2(
		$elm$core$String$append,
		'contact-',
		$elm$core$String$fromInt(contact.aC));
};
var $author$project$Components$SearchInput$SearchInputLogic$domResourcePrefix = function (selector) {
	switch (selector) {
		case 0:
			return 'fee-type';
		case 4:
			return 'file-email';
		case 3:
			return 'scale-item';
		case 1:
			return 'rate-label';
		case 2:
			return 'rate-value';
		case 5:
			return 'utbms-activity-code';
		case 6:
			return 'utbms-task-code';
		default:
			return 'utbms-timekeeper-code';
	}
};
var $author$project$Timesheet$Requests$editPostedFee = F2(
	function (csrfToken, fee) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$emptyBody,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/edit_posted')
			});
	});
var $author$project$FeeEntry$Messages$HandleFocus = function (a) {
	return {$: 34, a: a};
};
var $author$project$FeeEntry$Update$focus = F2(
	function (feeId, id) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				$author$project$TimesheetPage$Messages$FeeFormEdit(feeId),
				$author$project$FeeEntry$Messages$HandleFocus),
			$elm$browser$Browser$Dom$focus(id));
	});
var $author$project$FeeEntry$Messages$ExternalRateValuesLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$FeeEntry$Requests$getActionStepRateValues = function (fee) {
	var params = _List_fromArray(
		[
			A2(
			$author$project$Requests$Param,
			'matter_id',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.gS;
				},
				fee.hY)),
			A2(
			$author$project$Requests$Param,
			'rate_id',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.gR;
				},
				fee.fD))
		]);
	return $elm$http$Http$get(
		{
			z: A2(
				$jzxhuang$http_extras$Http$Detailed$expectJson,
				A2(
					$elm$core$Basics$composeL,
					$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
					$author$project$FeeEntry$Messages$ExternalRateValuesLoaded),
				$elm$json$Json$Decode$list($author$project$Model$ActionStep$RateValue$decodeActionStepRateValue)),
			jR: A2($author$project$Requests$toUrl, 'api/rate_values', params)
		});
};
var $author$project$FeeEntry$Requests$decodeContacts = A2(
	$elm$json$Json$Decode$field,
	'contacts',
	$elm$json$Json$Decode$list($author$project$Contacts$Data$decodeContact));
var $author$project$FeeEntry$Requests$getActivityContacts = function (activityId) {
	var params = $elm$core$List$singleton(
		A2(
			$author$project$Requests$Param,
			'activity_id',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(activityId))));
	return $elm$http$Http$get(
		{
			z: A2($elm$http$Http$expectJson, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$FeeEntry$Requests$decodeContacts),
			jR: A2($author$project$Requests$toUrl, 'api/activity_contacts', params)
		});
};
var $author$project$FeeEntry$Messages$SetCurrentTimeForFee = function (a) {
	return {$: 26, a: a};
};
var $author$project$FeeEntry$Update$getCurrentRataDieCommand = function (feeId) {
	return A2(
		$elm$core$Task$perform,
		function (time) {
			return A2(
				$author$project$TimesheetPage$Messages$FeeFormEdit,
				feeId,
				$author$project$FeeEntry$Messages$SetCurrentTimeForFee(time));
		},
		$elm$time$Time$now);
};
var $author$project$Components$AutocompleteLogic$getRecordToAutocomplete = function (_v0) {
	var filteredRecords = _v0.aZ;
	var autocompleteIndex = _v0.av;
	if (autocompleteIndex.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var index = autocompleteIndex.a;
		return A2(
			$elm_community$list_extra$List$Extra$getAt,
			index,
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, filteredRecords));
	}
};
var $author$project$Components$AutocompleteLogic$getIdToAutocomplete = A2(
	$elm$core$Basics$composeR,
	$author$project$Components$AutocompleteLogic$getRecordToAutocomplete,
	$elm$core$Maybe$map(
		function ($) {
			return $.aC;
		}));
var $author$project$FeeEntry$Messages$LibrariesLoaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$FeeEntry$Requests$getMatterLibraries = function (fee) {
	var params = _List_fromArray(
		[
			A2(
			$author$project$Requests$Param,
			'matter_id',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aC;
					},
					$elm$core$String$fromInt),
				fee.hY))
		]);
	return _Utils_eq(fee.hY, $elm$core$Maybe$Nothing) ? A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(
			A4($author$project$TimesheetPage$Messages$SetFlashMessage, 'Please select a matter', 2, 3, _List_Nil))) : $elm$http$Http$get(
		{
			z: A2(
				$jzxhuang$http_extras$Http$Detailed$expectJson,
				A2(
					$elm$core$Basics$composeL,
					$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
					$author$project$FeeEntry$Messages$LibrariesLoaded),
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			jR: A2($author$project$Requests$toUrl, 'api/documents/libraries', params)
		});
};
var $author$project$CoreX$Predicate$hasExternalId = F2(
	function (searchedId, _v0) {
		var externalId = _v0.gR;
		return _Utils_eq(externalId, searchedId);
	});
var $author$project$Components$AutocompleteLogic$emptyAutocompleteDetails = {
	av: $elm$core$Maybe$Nothing,
	aZ: $krisajenkins$remotedata$RemoteData$Success(_List_Nil),
	ch: $krisajenkins$remotedata$RemoteData$Success(_List_Nil),
	eX: $elm$core$Maybe$Nothing
};
var $author$project$Components$AutocompleteLogic$resetRecords = F2(
	function (webDataRecords, autocompleteDetails) {
		var toSearchInputRecords = function (_v0) {
			var id = _v0.aC;
			var code = _v0.br;
			var description = _v0.dd;
			var isDeleted = _v0.d6;
			return {br: code, dd: description, aC: id, d6: isDeleted};
		};
		var records = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$List$map(toSearchInputRecords),
			webDataRecords);
		return _Utils_update(
			autocompleteDetails,
			{aZ: records, ch: records});
	});
var $author$project$Components$AutocompleteLogic$makeAutocompleteDetails = function (webDataRecords) {
	return A2($author$project$Components$AutocompleteLogic$resetRecords, webDataRecords, $author$project$Components$AutocompleteLogic$emptyAutocompleteDetails);
};
var $author$project$FeeTypeLogic$makeSearchInputRecord = function (feeType) {
	var code = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$FeeTypeLogic$getSearchableField(feeType));
	return {
		br: code,
		dd: feeType.dd,
		aC: $elm$core$String$fromInt(feeType.aC),
		d6: false
	};
};
var $author$project$Components$SearchInput$SearchInputLogic$mapAutocompleteDetails = F2(
	function (f, searchInput) {
		if (searchInput.$ === 1) {
			var searchInputSelector = searchInput.a;
			var autocompleteDetails = searchInput.b;
			return A2(
				$author$project$Components$SearchInput$Model$Open,
				searchInputSelector,
				f(autocompleteDetails));
		} else {
			return searchInput;
		}
	});
var $author$project$Ports$InputControl$moveCaretToEnd = _Platform_outgoingPort('moveCaretToEnd', $elm$json$Json$Encode$string);
var $elm$core$Basics$truncate = _Basics_truncate;
var $author$project$FeeEntry$FeeEntryLogic$parseUnits = function (unitsStr) {
	var cutoffBelow2DigitsBelowDecimal = function (x) {
		return function (num) {
			return num / 100.0;
		}((100.0 * x) | 0);
	};
	return cutoffBelow2DigitsBelowDecimal(
		A2(
			$elm$core$Maybe$withDefault,
			0.0,
			$elm$core$String$toFloat(unitsStr)));
};
var $author$project$FeeEntry$Update$resetSearchInputRecords = F2(
	function (baseWebData, model) {
		var currentSearchInput = model.gt;
		var resetAutocompleteDetails = $author$project$Components$AutocompleteLogic$makeAutocompleteDetails(baseWebData);
		var updatedSearchInput = A2(
			$author$project$Components$SearchInput$SearchInputLogic$mapAutocompleteDetails,
			$elm$core$Basics$always(resetAutocompleteDetails),
			currentSearchInput);
		return A2($author$project$FeeEntry$FeeEntryLogic$setSearchInput, updatedSearchInput, model);
	});
var $author$project$Model$ActionStep$RateValue$rateSourceToLabel = function (source) {
	switch (source) {
		case 3:
			return 'Organisation rate';
		case 2:
			return 'User rate';
		case 1:
			return 'Client rate';
		case 0:
			return 'Matter rate';
		case 4:
			return 'Matter Team Member rate';
		case 5:
			return 'General Client rate';
		default:
			return 'Matter Client rate';
	}
};
var $author$project$Model$ActionStep$RateValue$sourceToLabel = F2(
	function (source, displayName) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$ActionStep$RateValue$rateSourceToLabel(source),
			displayName);
	});
var $author$project$Model$ActionStep$RateValue$toSearchInputRecord = F3(
	function (canViewRateValue, feeRateValue, rateValue) {
		var rv = canViewRateValue ? A2(
			$elm$core$Maybe$map,
			function (fr) {
				return ' (' + (fr + ')');
			},
			A2($elm_community$maybe_extra$Maybe$Extra$orElse, feeRateValue, rateValue.iB)) : $elm$core$Maybe$Nothing;
		var description = A2(
			$author$project$CoreX$Appendable$andMaybeAppend,
			rv,
			A2($author$project$Model$ActionStep$RateValue$sourceToLabel, rateValue.ev, rateValue.dg));
		return {br: '', dd: description, aC: rateValue.gR, d6: false};
	});
var $author$project$FeeEntry$Update$resetSearchInputRecordsForRateValueInput = F2(
	function (rateValues, model) {
		var sirs = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$List$map(
				A2($author$project$Model$ActionStep$RateValue$toSearchInputRecord, model.jS.f7, $elm$core$Maybe$Nothing)),
			rateValues);
		var fee = model.dA;
		var updatedFee = _Utils_update(
			fee,
			{cO: rateValues});
		return A2(
			$author$project$FeeEntry$Update$resetSearchInputRecords,
			sirs,
			_Utils_update(
				model,
				{dA: updatedFee}));
	});
var $author$project$Model$ScaleItem$toSearchInputRecord = function (scaleItem) {
	return {
		br: scaleItem.gR,
		dd: scaleItem.dd,
		aC: $elm$core$String$fromInt(scaleItem.aC),
		d6: false
	};
};
var $author$project$FeeEntry$Update$resetSearchInputRecordsForScaleItemsInput = F2(
	function (scaleItems, model) {
		var sirs = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$List$map($author$project$Model$ScaleItem$toSearchInputRecord),
			scaleItems);
		var fee = model.dA;
		var updatedFee = _Utils_update(
			fee,
			{be: scaleItems});
		return A2(
			$author$project$FeeEntry$Update$resetSearchInputRecords,
			sirs,
			_Utils_update(
				model,
				{dA: updatedFee}));
	});
var $author$project$Timesheet$Requests$setSubject = F3(
	function (csrfToken, fee, subject) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(subject))
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/set_subject')
			});
	});
var $author$project$TimesheetPage$Messages$SetSubjectResponse = function (a) {
	return {$: 75, a: a};
};
var $author$project$Timesheet$Requests$setSubjectFor = F3(
	function (csrfToken, feeId, subject) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(subject))
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString($author$project$TimesheetPage$Messages$SetSubjectResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(feeId) + '/set_subject')
			});
	});
var $author$project$FeeEntry$Logic$UpdateLogic$updateFee = F2(
	function (model, newFee) {
		return $Fresheyeball$elm_return$Return$singleton(
			_Utils_update(
				model,
				{gt: $author$project$Components$SearchInput$Model$Closed, dA: newFee}));
	});
var $author$project$FeeEntry$Update$retryRename = F4(
	function (model, fee, subjectFeeId, subject) {
		var closedFee = _Utils_update(
			fee,
			{cb: $elm$core$Maybe$Nothing, ad: $elm$core$Maybe$Nothing});
		return _Utils_eq(subjectFeeId, fee.aC) ? A2(
			$Fresheyeball$elm_return$Return$command,
			A3($author$project$Timesheet$Requests$setSubject, model.gr, fee, subject),
			A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, model, closedFee)) : A2(
			$Fresheyeball$elm_return$Return$command,
			A3($author$project$Timesheet$Requests$setSubjectFor, model.gr, subjectFeeId, subject),
			A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, model, closedFee));
	});
var $author$project$Timesheet$FeeLogic$activitySubject = function (fee) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Activities$ActivityLogic$getTitle, fee.fG));
};
var $author$project$Timesheet$FeeLogic$findConsolidatedFeeById = F2(
	function (consolidatedFeeId, fee) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aC;
				},
				$elm$core$Basics$eq(consolidatedFeeId)),
			$author$project$Timesheet$FeeLogic$getConsolidatedFees(fee));
	});
var $author$project$Activities$ActivityLogic$getFilingStatus = function (event) {
	if (event.$ === 3) {
		var emailActivity = event.a;
		return emailActivity.dH;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Timesheet$FeeLogic$getFilingStatus = function (fee) {
	return A2(
		$elm$core$Maybe$andThen,
		function (a) {
			return $author$project$Activities$ActivityLogic$getFilingStatus(a.i);
		},
		fee.fG);
};
var $author$project$Timesheet$FeeLogic$renameFailed = function (fee) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (filingStatus) {
				return _Utils_eq(filingStatus.dG, $author$project$Activities$Model$FilingStatus$RenameFailed);
			},
			$author$project$Timesheet$FeeLogic$getFilingStatus(fee)));
};
var $author$project$Activities$ActivityLogic$setEventSubject = F2(
	function (event, subject) {
		if (event.$ === 3) {
			var emailActivity = event.a;
			return $author$project$Activities$Model$Event$Email(
				_Utils_update(
					emailActivity,
					{cB: subject}));
		} else {
			return event;
		}
	});
var $author$project$Timesheet$FeeLogic$setActivitySubject = F2(
	function (fee, subject) {
		return A2(
			$elm$core$Maybe$withDefault,
			fee,
			A2(
				$elm$core$Maybe$map,
				function (newActivity) {
					return _Utils_update(
						fee,
						{
							fG: $elm$core$Maybe$Just(newActivity)
						});
				},
				A2(
					$elm$core$Maybe$map,
					function (activity) {
						return _Utils_update(
							activity,
							{
								i: A2($author$project$Activities$ActivityLogic$setEventSubject, activity.i, subject)
							});
					},
					fee.fG)));
	});
var $author$project$Timesheet$FeeLogic$setConsolidatedSubject = F3(
	function (consolidatedFeeId, subject, fee) {
		var updatedConsolidatedFees = A3(
			$elm_community$list_extra$List$Extra$updateIf,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aC;
				},
				$elm$core$Basics$eq(consolidatedFeeId)),
			function (consolidatedFee) {
				return A2($author$project$Timesheet$FeeLogic$setActivitySubject, consolidatedFee, subject);
			},
			$author$project$Timesheet$FeeLogic$getConsolidatedFees(fee));
		return _Utils_update(
			fee,
			{gm: updatedConsolidatedFees});
	});
var $author$project$FeeEntry$Update$saveSubject = F3(
	function (model, fee, editor) {
		var closedFee = _Utils_update(
			fee,
			{ad: $elm$core$Maybe$Nothing});
		if (_Utils_eq(editor.g_, fee.aC)) {
			return (_Utils_eq(
				editor.af,
				$author$project$Timesheet$FeeLogic$activitySubject(fee)) && (!$author$project$Timesheet$FeeLogic$renameFailed(fee))) ? A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, model, closedFee) : A2(
				$Fresheyeball$elm_return$Return$command,
				A3($author$project$Timesheet$Requests$setSubject, model.gr, fee, editor.af),
				A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, model, closedFee));
		} else {
			var _v0 = A2($author$project$Timesheet$FeeLogic$findConsolidatedFeeById, editor.g_, fee);
			if (!_v0.$) {
				var consolidatedFee = _v0.a;
				return (_Utils_eq(
					editor.af,
					$author$project$Timesheet$FeeLogic$activitySubject(consolidatedFee)) && (!$author$project$Timesheet$FeeLogic$renameFailed(consolidatedFee))) ? A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, model, closedFee) : A2(
					$Fresheyeball$elm_return$Return$command,
					A3($author$project$Timesheet$Requests$setSubjectFor, model.gr, editor.g_, editor.af),
					A2(
						$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
						model,
						A3($author$project$Timesheet$FeeLogic$setConsolidatedSubject, editor.g_, editor.af, closedFee)));
			} else {
				return A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, model, closedFee);
			}
		}
	});
var $author$project$Components$AutocompleteLogic$scrollAutocompleteIndexIntoView = function (searchInput) {
	if (!searchInput.$) {
		return $elm$core$Platform$Cmd$none;
	} else {
		var searchInputSelector = searchInput.a;
		var autocompleteDetails = searchInput.b;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$append('-search-index-'),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$append(
								$author$project$Components$SearchInput$SearchInputLogic$domResourcePrefix(searchInputSelector)),
							$author$project$Ports$Scroll$scrollIntoViewWithAlignment(3)))),
				autocompleteDetails.av));
	}
};
var $author$project$FeeEntry$Update$scrollTo = function (id) {
	return $author$project$Ports$Scroll$scrollIntoView(id);
};
var $author$project$Ports$InputControl$selectActiveContent = _Platform_outgoingPort(
	'selectActiveContent',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$EventTracking$ActionStepRateEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave = F2(
	function (model, newFee) {
		var fee = model.dA;
		return A2(
			$Fresheyeball$elm_return$Return$command,
			A3($author$project$Timesheet$FeeLogic$saveFeeCmd, model.gr, fee, newFee),
			A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, model, newFee));
	});
var $author$project$FeeEntry$Update$setActionStepRate = F3(
	function (model, fee, rate) {
		var updatedModel = $author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model);
		var updatedFee = _Utils_update(
			fee,
			{fD: rate});
		var hasRateSelectedChanged = F2(
			function (selected, toSelect) {
				return !_Utils_eq(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gR;
						},
						selected),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gR;
						},
						toSelect));
			});
		var rateHasChanged = A2(hasRateSelectedChanged, fee.fD, rate);
		var updatedFeeReturn = rateHasChanged ? A2(
			$author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave,
			updatedModel,
			_Utils_update(
				updatedFee,
				{cO: $krisajenkins$remotedata$RemoteData$Loading})) : A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, updatedModel, updatedFee);
		return A2(
			$Fresheyeball$elm_return$Return$command,
			$author$project$Ports$EventTracking$trackEventFor(
				$author$project$Ports$EventTracking$ActionStepRateEvent('selected')),
			updatedFeeReturn);
	});
var $author$project$Ports$EventTracking$ActivityCodeEvent = function (a) {
	return {$: 9, a: a};
};
var $author$project$FeeEntry$Update$setActivityCode = F3(
	function (model, fee, updatedActivityCode) {
		var updatedModel = $author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model);
		var updatedFee = _Utils_update(
			fee,
			{bp: updatedActivityCode});
		var codeHasChanged = !_Utils_eq(fee.bp, updatedActivityCode);
		var updatedFeeReturn = codeHasChanged ? A2($author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave, updatedModel, updatedFee) : A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, updatedModel, updatedFee);
		return A2(
			$Fresheyeball$elm_return$Return$command,
			$author$project$Ports$EventTracking$trackEventFor(
				$author$project$Ports$EventTracking$ActivityCodeEvent('selected')),
			updatedFeeReturn);
	});
var $author$project$TimesheetPage$Messages$AssociateFeeContactResponse = F2(
	function (a, b) {
		return {$: 70, a: a, b: b};
	});
var $author$project$FeeEntry$Requests$setActivityContact = F4(
	function (csrfToken, fee, activityId, contactId) {
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'activity_id',
						$elm$json$Json$Encode$int(activityId)),
						_Utils_Tuple2(
						'contact_id',
						$elm$json$Json$Encode$int(contactId))
					])));
		return $author$project$Requests$patch(
			{
				fW: body,
				z: A2(
					$jzxhuang$http_extras$Http$Detailed$expectJson,
					$author$project$TimesheetPage$Messages$AssociateFeeContactResponse(fee),
					$author$project$Contacts$Data$decodeContact),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/activity_contacts'
			});
	});
var $author$project$Timesheet$Requests$setExternalMatter = F4(
	function (csrfToken, feeId, externalMatter, msgMapper) {
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'external_matter_id',
						$elm$json$Json$Encode$string(externalMatter.gS))
					])));
		return $author$project$Requests$post(
			{
				fW: body,
				z: $jzxhuang$http_extras$Http$Detailed$expectString(msgMapper),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(feeId) + '/matters/restricted')
			});
	});
var $author$project$Ports$EventTracking$FeeTypeEvent = function (a) {
	return {$: 0, a: a};
};
var $author$project$FeeTypeLogic$initialiseWithPrefix = function (feeType) {
	var _v0 = feeType.fT;
	if (_v0 === 2) {
		return false;
	} else {
		return true;
	}
};
var $author$project$FeeTypeLogic$getInitialPrefix = function (feeType) {
	return $author$project$FeeTypeLogic$initialiseWithPrefix(feeType) ? (feeType.dC + ' ') : '';
};
var $author$project$FeeEntry$FeeEntryLogic$nothingWhenEmpty = function (desc) {
	return $elm$core$String$isEmpty(desc) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(desc);
};
var $author$project$FeeEntry$FeeEntryLogic$applyFeeTypeChange = F2(
	function (fee, newFeeType) {
		var oldFeeType = fee.g0;
		var newPrefix = $author$project$FeeTypeLogic$getInitialPrefix(newFeeType);
		return $author$project$FeeEntry$FeeEntryLogic$nothingWhenEmpty(
			A2(
				$elm$core$Maybe$withDefault,
				newPrefix,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$CoreX$String$replacePrefix, oldFeeType.dC, newPrefix),
					fee.dd)));
	});
var $author$project$FeeEntry$Update$setFeeType = F3(
	function (model, fee, maybeFeeType) {
		return A2(
			$elm$core$Maybe$withDefault,
			$Fresheyeball$elm_return$Return$singleton(model),
			A2(
				$elm$core$Maybe$map,
				function (feeType) {
					var updatedModel = $author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model);
					var updatedFee = _Utils_update(
						fee,
						{
							dd: A2($author$project$FeeEntry$FeeEntryLogic$applyFeeTypeChange, fee, feeType),
							g0: feeType,
							g1: $author$project$Model$Fee$FeeTypeView$DisplayFeeType
						});
					var updatedFeeReturn = _Utils_eq(fee.g0.aC, feeType.aC) ? A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, updatedModel, updatedFee) : A2($author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave, updatedModel, updatedFee);
					return A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$FeeEntry$Update$focus, fee.aC, 'fee-entry-description'),
						A2(
							$Fresheyeball$elm_return$Return$command,
							$author$project$Ports$InputControl$setValueOf(
								_Utils_Tuple2(
									'fee-entry-description',
									A2($elm$core$Maybe$withDefault, '', updatedFee.dd))),
							A2(
								$Fresheyeball$elm_return$Return$command,
								$author$project$Ports$EventTracking$trackEventFor(
									$author$project$Ports$EventTracking$FeeTypeEvent(feeType.dd)),
								updatedFeeReturn)));
				},
				maybeFeeType));
	});
var $author$project$FeeEntry$Update$setLibrary = F3(
	function (model, fee, maybeLib) {
		return A2(
			$elm$core$Maybe$withDefault,
			$Fresheyeball$elm_return$Return$singleton(model),
			A2(
				$elm$core$Maybe$map,
				function (lib) {
					return A2(
						$Fresheyeball$elm_return$Return$command,
						A3(
							$author$project$Timesheet$Requests$fileEmail,
							model.gr,
							fee,
							$elm$core$Maybe$Just(lib.br)),
						$Fresheyeball$elm_return$Return$singleton(
							$author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model)));
				},
				maybeLib));
	});
var $author$project$Model$Fee$PostStatus$toString = function (postStatus) {
	switch (postStatus) {
		case 0:
			return 'unqueued';
		case 1:
			return 'queued';
		case 2:
			return 'processing';
		case 3:
			return 'in_transit';
		case 4:
			return 'posted';
		case 5:
			return 'posted_modified';
		case 6:
			return 'failed';
		default:
			return 'quarantined';
	}
};
var $author$project$Timesheet$Requests$setPostStatus = F3(
	function (csrfToken, postStatus, fee) {
		return $author$project$Requests$post(
			{
				fW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'post_status',
								$elm$json$Json$Encode$string(
									$author$project$Model$Fee$PostStatus$toString(postStatus)))
							]))),
				z: $jzxhuang$http_extras$Http$Detailed$expectString(
					$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee)),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(fee.aC) + '/post_status')
			});
	});
var $author$project$Ports$EventTracking$ScaleItemEvent = function (a) {
	return {$: 3, a: a};
};
var $author$project$FeeEntry$Update$setScaleItem = F3(
	function (model, fee, scaleItem) {
		var updatedModel = $author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model);
		var updatedFee = _Utils_update(
			fee,
			{bd: scaleItem});
		var hasScaleItemSelectedChanged = F2(
			function (selected, toSelect) {
				return !_Utils_eq(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gR;
						},
						selected),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gR;
						},
						toSelect));
			});
		var scaleItemHasChanged = A2(hasScaleItemSelectedChanged, fee.bd, scaleItem);
		var updatedFeeReturn = scaleItemHasChanged ? A2($author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave, updatedModel, updatedFee) : A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, updatedModel, updatedFee);
		return A2(
			$Fresheyeball$elm_return$Return$command,
			$author$project$Ports$EventTracking$trackEventFor(
				$author$project$Ports$EventTracking$ScaleItemEvent('selected')),
			updatedFeeReturn);
	});
var $author$project$Ports$EventTracking$TaskCodeEvent = function (a) {
	return {$: 10, a: a};
};
var $author$project$FeeEntry$Update$setTaskCode = F3(
	function (model, fee, updatedCode) {
		var updatedModel = $author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model);
		var updatedFee = _Utils_update(
			fee,
			{cE: updatedCode});
		var codeHasChanged = !_Utils_eq(fee.cE, updatedCode);
		var updatedFeeReturn = codeHasChanged ? A2($author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave, updatedModel, updatedFee) : A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, updatedModel, updatedFee);
		return A2(
			$Fresheyeball$elm_return$Return$command,
			$author$project$Ports$EventTracking$trackEventFor(
				$author$project$Ports$EventTracking$TaskCodeEvent('selected')),
			updatedFeeReturn);
	});
var $author$project$Ports$EventTracking$TimekeeperCodeEvent = function (a) {
	return {$: 11, a: a};
};
var $author$project$FeeEntry$Update$setTimekeeperCode = F3(
	function (model, fee, updatedCode) {
		var updatedModel = $author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model);
		var updatedFee = _Utils_update(
			fee,
			{cG: updatedCode});
		var codeHasChanged = !_Utils_eq(fee.cG, updatedCode);
		var updatedFeeReturn = codeHasChanged ? A2($author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave, updatedModel, updatedFee) : A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, updatedModel, updatedFee);
		return A2(
			$Fresheyeball$elm_return$Return$command,
			$author$project$Ports$EventTracking$trackEventFor(
				$author$project$Ports$EventTracking$TimekeeperCodeEvent('selected')),
			updatedFeeReturn);
	});
var $author$project$Model$UtbmsCode$taskCodeToSearchInputRecord = function (taskCode) {
	return {
		br: taskCode.gR,
		dd: taskCode.dd,
		aC: $elm$core$String$fromInt(taskCode.aC),
		d6: false
	};
};
var $author$project$Model$UtbmsCode$taskCodefromSearchInputRecord = function (record) {
	return A2(
		$elm$core$Maybe$map,
		function (decodedId) {
			return {f8: '', dd: record.dd, gR: record.br, aC: decodedId, ex: $elm$core$Maybe$Nothing};
		},
		$elm$core$String$toInt(record.aC));
};
var $author$project$Model$IManage$Library$toSearchInputRecord = F2(
	function (index, library) {
		var indexAsString = $elm$core$String$fromInt(index);
		return {br: library, dd: '', aC: indexAsString, d6: false};
	});
var $author$project$Model$IManage$Library$toManySearchInputRecords = function (libraries) {
	return A2($elm$core$List$indexedMap, $author$project$Model$IManage$Library$toSearchInputRecord, libraries);
};
var $author$project$Model$ActionStep$Rate$toSearchInputRecord = function (rate) {
	return {br: '', dd: rate.b2, aC: rate.gR, d6: rate.d6};
};
var $author$project$Ports$EventTracking$AiTaskEvent = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$AiInput$Model$Running = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$AiInput$Messages$IgnoreResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AiInput$Requests$runAiSummary = F4(
	function (csrfToken, type_, feeId, length) {
		var summarySize = function () {
			if (!length) {
				return 'long';
			} else {
				return 'short';
			}
		}();
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'summary',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'summary_size',
									$elm$json$Json$Encode$string(summarySize)),
									_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string(type_))
								])))
					])));
		return $author$project$Requests$post(
			{
				fW: body,
				z: $elm$http$Http$expectWhatever($author$project$Components$AiInput$Messages$IgnoreResponse),
				A: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-TOKEN', csrfToken)
					]),
				jR: 'api/fees/' + ($elm$core$String$fromInt(feeId) + '/summarise')
			});
	});
var $author$project$Components$AiInput$Update$update = F2(
	function (msg, _v0) {
		var model = _v0.a6;
		var csrfToken = _v0.gr;
		var feeId = _v0.g_;
		switch (msg.$) {
			case 0:
				var aiRunner = msg.a;
				var _v2 = function () {
					if (!aiRunner.$) {
						var length = aiRunner.a;
						return _Utils_Tuple2(
							A4($author$project$Components$AiInput$Requests$runAiSummary, csrfToken, 'email', feeId, length),
							'Email Summary');
					} else {
						var length = aiRunner.a;
						return _Utils_Tuple2(
							A4($author$project$Components$AiInput$Requests$runAiSummary, csrfToken, 'description', feeId, length),
							'Description Summary');
					}
				}();
				var cmdOne = _v2.a;
				var eventTracking = _v2.b;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$AiTaskEvent(eventTracking)),
					A2(
						$Fresheyeball$elm_return$Return$command,
						cmdOne,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									eQ: $author$project$Components$AiInput$Model$Running(aiRunner),
									ff: 1,
									fg: $elm$core$Maybe$Nothing
								}))));
			case 2:
				return $Fresheyeball$elm_return$Return$singleton($author$project$Components$AiInput$Model$defaultAiInputModel);
			case 1:
				var state = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{ff: state}));
			default:
				return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$Components$DurationInput$DurationInputLogic$constrainAbove = F2(
	function (constraintAbove, actual) {
		return A2($elm$core$Basics$max, constraintAbove, actual);
	});
var $author$project$Components$DurationInput$DurationInputLogic$constrainBelow = F2(
	function (constraintBelow, actual) {
		return A2($elm$core$Basics$min, constraintBelow, actual);
	});
var $author$project$Components$DurationInput$DurationInputLogic$constrainBetween = F3(
	function (constraintAbove, constraintBelow, actual) {
		return A2(
			$author$project$Components$DurationInput$DurationInputLogic$constrainAbove,
			constraintAbove,
			A2($author$project$Components$DurationInput$DurationInputLogic$constrainBelow, constraintBelow, actual));
	});
var $author$project$Components$DurationInput$DurationInputLogic$updateDurationHours = F2(
	function (durationInput, hours) {
		return _Utils_update(
			durationInput,
			{
				_: A3($author$project$Components$DurationInput$DurationInputLogic$constrainBetween, 0, 23, hours)
			});
	});
var $author$project$Components$DurationInput$DurationInputLogic$constrainDuration = function (durationInput) {
	return {
		_: A3($author$project$Components$DurationInput$DurationInputLogic$constrainBetween, 0, 23, durationInput._),
		aF: A3($author$project$Components$DurationInput$DurationInputLogic$constrainBetween, 0, 59, durationInput.aF)
	};
};
var $author$project$Components$DurationInput$DurationInputLogic$updateDurationTotalMinutes = F2(
	function (durationInput, minutes) {
		var totalMins = F2(
			function (hrs, mins) {
				return (hrs * 60) + mins;
			});
		return $author$project$Components$DurationInput$DurationInputLogic$constrainDuration(
			$author$project$Components$DurationInput$DurationInputLogic$totalMinutesToDuration(
				A2(
					totalMins,
					durationInput._,
					A3($author$project$Components$DurationInput$DurationInputLogic$constrainBetween, -1, 60, minutes))));
	});
var $author$project$FeeEntry$FeeEntryLogic$updateFeeUnits = function (model) {
	var fee = model.dA;
	var durationInput = model.gI;
	var minutesPerUnit = model.ej;
	var updatedFee = _Utils_update(
		fee,
		{
			jP: A2($author$project$Components$DurationInput$DurationInputLogic$updateUnits, durationInput, minutesPerUnit)
		});
	return _Utils_update(
		model,
		{dA: updatedFee});
};
var $author$project$FeeEntry$Update$updateOccurredAtWith = F2(
	function (fee, time) {
		return _Utils_update(
			fee,
			{b7: time});
	});
var $author$project$Ports$EventTracking$ActionStepRateValueEvent = function (a) {
	return {$: 2, a: a};
};
var $author$project$FeeEntry$Logic$UpdateLogic$setActionStepRateValue = F3(
	function (model, fee, rateValue) {
		var updatedModel = $author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model);
		var updatedFee = _Utils_update(
			fee,
			{aO: rateValue});
		var hasRateValueSelectedChanged = F2(
			function (selected, toSelect) {
				return !_Utils_eq(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gR;
						},
						selected),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gR;
						},
						toSelect));
			});
		var sourceHasChanged = A2(hasRateValueSelectedChanged, fee.aO, rateValue);
		var updatedFeeReturn = sourceHasChanged ? A2($author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave, updatedModel, updatedFee) : A2($author$project$FeeEntry$Logic$UpdateLogic$updateFee, updatedModel, updatedFee);
		return A2(
			$Fresheyeball$elm_return$Return$command,
			$author$project$Ports$EventTracking$trackEventFor(
				$author$project$Ports$EventTracking$ActionStepRateValueEvent('selected')),
			updatedFeeReturn);
	});
var $author$project$FeeEntry$Logic$UpdateLogic$updateRateValue = F3(
	function (fee, searchInputRecordId, model) {
		return A3(
			$author$project$FeeEntry$Logic$UpdateLogic$setActionStepRateValue,
			model,
			fee,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				fee.aO,
				A2(
					$elm_community$list_extra$List$Extra$find,
					$author$project$CoreX$Predicate$hasExternalId(searchInputRecordId),
					A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, fee.cO))));
	});
var $author$project$FeeEntry$Logic$UpdateLogic$updateRateValueAutocomplete = F3(
	function (fee, autocompleteDetails, model) {
		return A3(
			$author$project$FeeEntry$Logic$UpdateLogic$setActionStepRateValue,
			model,
			fee,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				fee.aO,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						function (id) {
							return A2(
								$elm_community$list_extra$List$Extra$find,
								$author$project$CoreX$Predicate$hasExternalId(id),
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, fee.cO));
						},
						$author$project$Components$AutocompleteLogic$getIdToAutocomplete(autocompleteDetails)))));
	});
var $author$project$FeeEntry$Update$updateSubjectEditor = F2(
	function (fee, subject) {
		return _Utils_update(
			fee,
			{
				ad: A2(
					$elm$core$Maybe$map,
					function (editor) {
						return _Utils_update(
							editor,
							{af: subject});
					},
					fee.ad)
			});
	});
var $author$project$FeeEntry$Update$updateTempDate = F2(
	function (fee, date) {
		return _Utils_update(
			fee,
			{
				js: $elm$core$Maybe$Just(date)
			});
	});
var $author$project$FeeEntry$Update$updateTempTime = F2(
	function (fee, time) {
		return _Utils_update(
			fee,
			{
				jt: $elm$core$Maybe$Just(time)
			});
	});
var $author$project$Model$UtbmsCode$utbmsCodeToSearchInputRecord = function (utbmsCode) {
	return {
		br: utbmsCode.gR,
		dd: utbmsCode.dd,
		aC: $elm$core$String$fromInt(utbmsCode.aC),
		d6: false
	};
};
var $author$project$Model$UtbmsCode$utbmsCodefromSearchInputRecord = function (record) {
	return A2(
		$elm$core$Maybe$map,
		function (decodedId) {
			return {dd: record.dd, gR: record.br, aC: decodedId};
		},
		$elm$core$String$toInt(record.aC));
};
var $author$project$FeeEntry$Update$processFeeFormEdit = F4(
	function (zone, feeFormMsg, recentMatters, model) {
		var user = model.jS;
		var fee = model.dA;
		var durationInput = model.gI;
		var feeTypes = model.bG;
		var actionStepRates = model.bn;
		var utbmsCodes = model.cL;
		switch (feeFormMsg.$) {
			case 44:
				return $Fresheyeball$elm_return$Return$singleton(model);
			case 48:
				var subMsg = feeFormMsg.a;
				var _v2 = A2($o_train$elm_search_input$Select$update, subMsg, model.e_);
				var selectInputModel = _v2.a;
				var parentMsg = _v2.b;
				var selectCmd = _v2.c;
				var subCmd = function () {
					switch (parentMsg.$) {
						case 1:
							var m = parentMsg.a;
							return A2(
								$elm$core$Platform$Cmd$map,
								$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
								$author$project$Utils$send(m));
						case 0:
							var item = parentMsg.a;
							return A4(
								$author$project$Timesheet$Requests$setExternalMatter,
								model.gr,
								fee.aC,
								item.aa,
								$author$project$TimesheetPage$Messages$UpdateFeeResponse(fee));
						default:
							return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$command,
					subCmd,
					A2(
						$Fresheyeball$elm_return$Return$mapCmd,
						$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
						A2(
							$Fresheyeball$elm_return$Return$command,
							A2($elm$core$Platform$Cmd$map, $author$project$FeeEntry$Messages$SelectInput, selectCmd),
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{e_: selectInputModel})))));
			case 8:
				return $Fresheyeball$elm_return$Return$singleton(
					$author$project$FeeEntry$FeeEntryLogic$closeSearchInput(model));
			case 7:
				var searchInputSelector = feeFormMsg.a;
				var domId = $author$project$Components$SearchInput$SearchInputLogic$domResourcePrefix(searchInputSelector) + '-search-input';
				var _v4 = function () {
					switch (searchInputSelector) {
						case 0:
							var searchInputFeeTypes = A2($elm$core$List$map, $author$project$FeeTypeLogic$makeSearchInputRecord, feeTypes);
							return _Utils_Tuple2(
								$author$project$Components$AutocompleteLogic$makeAutocompleteDetails(
									$krisajenkins$remotedata$RemoteData$Success(searchInputFeeTypes)),
								$elm$core$Platform$Cmd$none);
						case 4:
							return _Utils_Tuple2(
								$author$project$Components$AutocompleteLogic$makeAutocompleteDetails($krisajenkins$remotedata$RemoteData$Loading),
								$author$project$FeeEntry$Requests$getMatterLibraries(fee));
						case 3:
							return _Utils_Tuple2(
								$author$project$Components$AutocompleteLogic$makeAutocompleteDetails($krisajenkins$remotedata$RemoteData$Loading),
								$author$project$FeeEntry$Requests$getScaleItems(fee));
						case 1:
							return _Utils_Tuple2(
								$author$project$Components$AutocompleteLogic$makeAutocompleteDetails(
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										$elm$core$List$map($author$project$Model$ActionStep$Rate$toSearchInputRecord),
										actionStepRates)),
								$elm$core$Platform$Cmd$none);
						case 2:
							return _Utils_Tuple2(
								$author$project$Components$AutocompleteLogic$makeAutocompleteDetails($krisajenkins$remotedata$RemoteData$Loading),
								$author$project$FeeEntry$Requests$getActionStepRateValues(fee));
						case 5:
							var searchableCodes = A2(
								$elm$core$List$map,
								$author$project$Model$UtbmsCode$utbmsCodeToSearchInputRecord,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (codes) {
											return codes.fH;
										},
										utbmsCodes)));
							return _Utils_Tuple2(
								$author$project$Components$AutocompleteLogic$makeAutocompleteDetails(
									$krisajenkins$remotedata$RemoteData$Success(searchableCodes)),
								$elm$core$Platform$Cmd$none);
						case 6:
							var isMatch = function (taskCode) {
								return A2(
									$elm$core$Maybe$withDefault,
									true,
									A2(
										$elm$core$Maybe$map,
										function (code) {
											return _Utils_eq(taskCode.f8, code);
										},
										A2(
											$elm$core$Maybe$andThen,
											function (m) {
												return m.jU;
											},
											fee.hY)));
							};
							var searchableCodes = A2(
								$elm$core$List$map,
								$author$project$Model$UtbmsCode$taskCodeToSearchInputRecord,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										$elm$core$List$filter(isMatch),
										A2(
											$elm$core$Maybe$map,
											function (codes) {
												return codes.jr;
											},
											utbmsCodes))));
							return _Utils_Tuple2(
								$author$project$Components$AutocompleteLogic$makeAutocompleteDetails(
									$krisajenkins$remotedata$RemoteData$Success(searchableCodes)),
								$elm$core$Platform$Cmd$none);
						default:
							var searchableCodes = A2(
								$elm$core$List$map,
								$author$project$Model$UtbmsCode$utbmsCodeToSearchInputRecord,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (codes) {
											return codes.jz;
										},
										utbmsCodes)));
							return _Utils_Tuple2(
								$author$project$Components$AutocompleteLogic$makeAutocompleteDetails(
									$krisajenkins$remotedata$RemoteData$Success(searchableCodes)),
								$elm$core$Platform$Cmd$none);
					}
				}();
				var autocompleteDetails = _v4.a;
				var loaderCmd = _v4.b;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2($author$project$FeeEntry$Update$focus, fee.aC, domId),
					A2(
						$Fresheyeball$elm_return$Return$command,
						loaderCmd,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									gt: A2($author$project$Components$SearchInput$Model$Open, searchInputSelector, autocompleteDetails)
								}))));
			case 4:
				var dir = feeFormMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$effect_,
					function (m) {
						return $author$project$Components$AutocompleteLogic$scrollAutocompleteIndexIntoView(m.gt);
					},
					$Fresheyeball$elm_return$Return$singleton(
						A2($author$project$FeeEntry$Update$changeAutocompleteStep, dir, model)));
			case 0:
				var searchInputRecordId = feeFormMsg.a;
				var getFromAutocomplete = function (autocompleteDetails) {
					return A2(
						$author$project$CoreX$List$findById,
						searchInputRecordId,
						A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, autocompleteDetails.aZ));
				};
				var _v6 = model.gt;
				if (!_v6.$) {
					return $Fresheyeball$elm_return$Return$singleton(model);
				} else {
					switch (_v6.a) {
						case 0:
							var _v7 = _v6.a;
							var autocompleteDetails = _v6.b;
							return A3(
								$author$project$FeeEntry$Update$setFeeType,
								model,
								fee,
								A2(
									$author$project$CoreX$List$findById,
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(searchInputRecordId)),
									feeTypes));
						case 4:
							var _v8 = _v6.a;
							var autocompleteDetails = _v6.b;
							return A3(
								$author$project$FeeEntry$Update$setLibrary,
								model,
								fee,
								getFromAutocomplete(autocompleteDetails));
						case 3:
							var _v9 = _v6.a;
							var autocompleteDetails = _v6.b;
							return A3(
								$author$project$FeeEntry$Update$setScaleItem,
								model,
								fee,
								A2(
									$elm_community$maybe_extra$Maybe$Extra$orElse,
									fee.bd,
									A2(
										$author$project$CoreX$List$findById,
										A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toInt(searchInputRecordId)),
										A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, fee.be))));
						case 1:
							var _v10 = _v6.a;
							var autocompleteDetails = _v6.b;
							return A3(
								$author$project$FeeEntry$Update$setActionStepRate,
								model,
								fee,
								A2(
									$elm_community$maybe_extra$Maybe$Extra$orElse,
									fee.fD,
									A2(
										$elm_community$list_extra$List$Extra$find,
										$author$project$CoreX$Predicate$hasExternalId(searchInputRecordId),
										A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, actionStepRates))));
						case 2:
							var _v11 = _v6.a;
							var autocompleteDetails = _v6.b;
							return A3($author$project$FeeEntry$Logic$UpdateLogic$updateRateValue, fee, searchInputRecordId, model);
						case 5:
							var _v12 = _v6.a;
							var autocompleteDetails = _v6.b;
							return A3(
								$author$project$FeeEntry$Update$setActivityCode,
								model,
								fee,
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Model$UtbmsCode$utbmsCodefromSearchInputRecord,
									getFromAutocomplete(autocompleteDetails)));
						case 6:
							var _v13 = _v6.a;
							var autocompleteDetails = _v6.b;
							return A3(
								$author$project$FeeEntry$Update$setTaskCode,
								model,
								fee,
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Model$UtbmsCode$taskCodefromSearchInputRecord,
									getFromAutocomplete(autocompleteDetails)));
						default:
							var _v14 = _v6.a;
							var autocompleteDetails = _v6.b;
							return A3(
								$author$project$FeeEntry$Update$setTimekeeperCode,
								model,
								fee,
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Model$UtbmsCode$utbmsCodefromSearchInputRecord,
									getFromAutocomplete(autocompleteDetails)));
					}
				}
			case 5:
				var _v15 = model.gt;
				if (!_v15.$) {
					return $Fresheyeball$elm_return$Return$singleton(model);
				} else {
					switch (_v15.a) {
						case 0:
							var _v16 = _v15.a;
							var autocompleteDetails = _v15.b;
							var autocompletedFeeType = function () {
								var _v17 = $author$project$Components$AutocompleteLogic$getIdToAutocomplete(autocompleteDetails);
								if (!_v17.$) {
									var searchInputRecordId = _v17.a;
									return A2(
										$author$project$CoreX$List$findById,
										A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toInt(searchInputRecordId)),
										feeTypes);
								} else {
									return $elm$core$Maybe$Just(fee.g0);
								}
							}();
							return A3($author$project$FeeEntry$Update$setFeeType, model, fee, autocompletedFeeType);
						case 4:
							var _v18 = _v15.a;
							var autocompleteDetails = _v15.b;
							return A3(
								$author$project$FeeEntry$Update$setLibrary,
								model,
								fee,
								$author$project$Components$AutocompleteLogic$getRecordToAutocomplete(autocompleteDetails));
						case 3:
							var _v19 = _v15.a;
							var autocompleteDetails = _v15.b;
							var scaleItems = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, fee.be);
							var idToAutocomplete = A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$toInt,
									$elm$core$Maybe$withDefault(0)),
								$author$project$Components$AutocompleteLogic$getIdToAutocomplete(autocompleteDetails));
							return A3(
								$author$project$FeeEntry$Update$setScaleItem,
								model,
								fee,
								A2(
									$elm_community$maybe_extra$Maybe$Extra$orElse,
									fee.bd,
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Maybe$Nothing,
										A2(
											$elm$core$Maybe$map,
											function (id) {
												return A2($author$project$CoreX$List$findById, id, scaleItems);
											},
											idToAutocomplete))));
						case 1:
							var _v20 = _v15.a;
							var autocompleteDetails = _v15.b;
							var rates = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, actionStepRates);
							var idToAutocomplete = A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$toInt,
									$elm$core$Maybe$withDefault(0)),
								$author$project$Components$AutocompleteLogic$getIdToAutocomplete(autocompleteDetails));
							return A3(
								$author$project$FeeEntry$Update$setActionStepRate,
								model,
								fee,
								A2(
									$elm_community$maybe_extra$Maybe$Extra$orElse,
									fee.fD,
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Maybe$Nothing,
										A2(
											$elm$core$Maybe$map,
											function (id) {
												return A2(
													$elm_community$list_extra$List$Extra$find,
													$author$project$CoreX$Predicate$hasExternalId(id),
													rates);
											},
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, idToAutocomplete)))));
						case 2:
							var _v21 = _v15.a;
							var autocompleteDetails = _v15.b;
							return A3($author$project$FeeEntry$Logic$UpdateLogic$updateRateValueAutocomplete, fee, autocompleteDetails, model);
						case 5:
							var _v22 = _v15.a;
							var autocompleteDetails = _v15.b;
							return A3(
								$author$project$FeeEntry$Update$setActivityCode,
								model,
								fee,
								A2(
									$elm_community$maybe_extra$Maybe$Extra$orElse,
									fee.bp,
									A2(
										$elm$core$Maybe$andThen,
										$author$project$Model$UtbmsCode$utbmsCodefromSearchInputRecord,
										$author$project$Components$AutocompleteLogic$getRecordToAutocomplete(autocompleteDetails))));
						case 6:
							var _v23 = _v15.a;
							var autocompleteDetails = _v15.b;
							return A3(
								$author$project$FeeEntry$Update$setTaskCode,
								model,
								fee,
								A2(
									$elm_community$maybe_extra$Maybe$Extra$orElse,
									fee.cE,
									A2(
										$elm$core$Maybe$andThen,
										$author$project$Model$UtbmsCode$taskCodefromSearchInputRecord,
										$author$project$Components$AutocompleteLogic$getRecordToAutocomplete(autocompleteDetails))));
						default:
							var _v24 = _v15.a;
							var autocompleteDetails = _v15.b;
							return A3(
								$author$project$FeeEntry$Update$setTimekeeperCode,
								model,
								fee,
								A2(
									$elm_community$maybe_extra$Maybe$Extra$orElse,
									fee.cG,
									A2(
										$elm$core$Maybe$andThen,
										$author$project$Model$UtbmsCode$utbmsCodefromSearchInputRecord,
										$author$project$Components$AutocompleteLogic$getRecordToAutocomplete(autocompleteDetails))));
					}
				}
			case 6:
				var filterString = feeFormMsg.a;
				var updatedSearchInput = A2(
					$author$project$Components$SearchInput$SearchInputLogic$mapAutocompleteDetails,
					$author$project$Components$AutocompleteLogic$applySearchTerms(filterString),
					model.gt);
				return $Fresheyeball$elm_return$Return$singleton(
					A2($author$project$FeeEntry$FeeEntryLogic$setSearchInput, updatedSearchInput, model));
			case 12:
				var top = feeFormMsg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							dA: _Utils_update(
								fee,
								{gD: top})
						}));
			case 10:
				var description = feeFormMsg.a;
				var maybeNewDescription = A3($author$project$FeeEntry$FeeEntryLogic$applyDescriptionChange, fee.dd, fee.g0, description);
				var aiInput = fee.aQ;
				var updatedAiInput = _Utils_update(
					aiInput,
					{fg: $elm$core$Maybe$Nothing});
				var updatedFee = _Utils_update(
					fee,
					{aQ: updatedAiInput, dd: maybeNewDescription});
				return A2(
					$Fresheyeball$elm_return$Return$effect_,
					function (m) {
						return A3($author$project$Timesheet$FeeLogic$saveFeeCmd, model.gr, fee, m.dA);
					},
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{dA: updatedFee})));
			case 9:
				var description = feeFormMsg.a;
				var maybeNewDescription = A3($author$project$FeeEntry$FeeEntryLogic$applyDescriptionChange, fee.dd, fee.g0, description);
				var checkedDescription = A2($elm$core$Maybe$withDefault, '', maybeNewDescription);
				var cmd = (!_Utils_eq(checkedDescription, description)) ? $author$project$Ports$InputControl$setValueOf(
					_Utils_Tuple2('fee-entry-description', checkedDescription)) : $elm$core$Platform$Cmd$none;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					cmd,
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								dA: _Utils_update(
									fee,
									{dd: maybeNewDescription})
							})));
			case 11:
				return _Utils_Tuple2(
					model,
					$author$project$Ports$InputControl$moveCaretToEnd('fee-entry-description'));
			case 14:
				var unitsStr = feeFormMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$UnitsButtonEvent(
							$author$project$FeeEntry$FeeEntryLogic$parseUnits(unitsStr))),
					A2(
						$Fresheyeball$elm_return$Return$effect_,
						function (m) {
							return A3($author$project$Timesheet$FeeLogic$saveFeeCmd, model.gr, fee, m.dA);
						},
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									dA: _Utils_update(
										fee,
										{
											jP: $author$project$FeeEntry$FeeEntryLogic$parseUnits(unitsStr)
										})
								}))));
			case 36:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A3($author$project$Timesheet$FeeLogic$saveFeeCmd, model.gr, fee, fee),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 37:
				return (model.jS.f0 && A2($author$project$Timesheet$FeeLogic$canEditPosted, model.ce, fee)) ? A2(
					$Fresheyeball$elm_return$Return$command,
					A2($author$project$Timesheet$Requests$editPostedFee, model.gr, fee),
					A2(
						$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
						model,
						_Utils_update(
							fee,
							{hx: false, eD: 5}))) : $Fresheyeball$elm_return$Return$singleton(model);
			case 38:
				var unitsStr = feeFormMsg.a;
				var updatedFee = _Utils_update(
					fee,
					{
						jP: $author$project$FeeEntry$FeeEntryLogic$parseUnits(unitsStr)
					});
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$UnitsInputEvent(
							$author$project$FeeEntry$FeeEntryLogic$parseUnits(unitsStr))),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A3($author$project$Timesheet$FeeLogic$saveFeeCmd, model.gr, fee, updatedFee),
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{dA: updatedFee}))));
			case 39:
				var stringMinutes = feeFormMsg.a;
				var updatedMinutesInput = A2(
					$elm$core$Maybe$withDefault,
					durationInput,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$DurationInput$DurationInputLogic$updateDurationTotalMinutes(durationInput),
						$elm$core$String$toInt(stringMinutes)));
				return $Fresheyeball$elm_return$Return$singleton(
					$author$project$FeeEntry$FeeEntryLogic$updateFeeUnits(
						_Utils_update(
							model,
							{gI: updatedMinutesInput})));
			case 40:
				var stringHours = feeFormMsg.a;
				var updatedHoursInput = A2(
					$elm$core$Maybe$withDefault,
					durationInput,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$DurationInput$DurationInputLogic$updateDurationHours(durationInput),
						$elm$core$String$toInt(stringHours)));
				return $Fresheyeball$elm_return$Return$singleton(
					$author$project$FeeEntry$FeeEntryLogic$updateFeeUnits(
						_Utils_update(
							model,
							{gI: updatedHoursInput})));
			case 45:
				var direction = feeFormMsg.a;
				var updatedMinutes = function () {
					if (!direction) {
						return durationInput.aF + 1;
					} else {
						return durationInput.aF - 1;
					}
				}();
				var updatedDuration = A2($author$project$Components$DurationInput$DurationInputLogic$updateDurationTotalMinutes, durationInput, updatedMinutes);
				var debounceMsg = $author$project$FeeEntry$Messages$DebounceDuration(
					$Gizra$elm_debouncer$Debouncer$Basic$provideInput($author$project$FeeEntry$Messages$PersistMinutes));
				var cmd = A2(
					$elm$core$Task$perform,
					$elm$core$Basics$identity,
					$elm$core$Task$succeed(
						A2($author$project$TimesheetPage$Messages$FeeFormEdit, fee.aC, debounceMsg)));
				return A2(
					$Fresheyeball$elm_return$Return$command,
					cmd,
					$Fresheyeball$elm_return$Return$singleton(
						$author$project$FeeEntry$FeeEntryLogic$updateFeeUnits(
							_Utils_update(
								model,
								{gI: updatedDuration}))));
			case 46:
				var subMsg = feeFormMsg.a;
				var updatedFee = model.dA;
				var _v26 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, model.dA.dj);
				var debouncedModel = _v26.a;
				var subCmd = _v26.b;
				var emittedMsg = _v26.c;
				var updatedDebouncer = _Utils_update(
					updatedFee,
					{dj: debouncedModel});
				var updatedModel = _Utils_update(
					model,
					{dA: updatedDebouncer});
				var mappedCmd = A2(
					$elm$core$Platform$Cmd$map,
					$author$project$TimesheetPage$Messages$FeeFormEdit(model.dA.aC),
					A2($elm$core$Platform$Cmd$map, $author$project$FeeEntry$Messages$DebounceDuration, subCmd));
				if (!emittedMsg.$) {
					var emitted = emittedMsg.a;
					var _v28 = A4(
						$author$project$FeeEntry$Update$update,
						zone,
						recentMatters,
						A2($author$project$TimesheetPage$Messages$FeeFormEdit, model.dA.aC, emitted),
						updatedModel);
					var mdl = _v28.a;
					var cmd = _v28.b;
					return _Utils_Tuple2(
						mdl,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, mappedCmd])));
				} else {
					return _Utils_Tuple2(updatedModel, mappedCmd);
				}
			case 41:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A3($author$project$Timesheet$FeeLogic$saveFeeCmd, model.gr, fee, fee),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 27:
				var behaviour = feeFormMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$ChargingBehaviourChange(
							$author$project$Model$Fee$BillingBehaviour$toString(behaviour))),
					A2(
						$author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave,
						model,
						_Utils_update(
							fee,
							{fS: behaviour})));
			case 29:
				var isRecordingInMinutes = feeFormMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$IsRecordingInMinutes(isRecordingInMinutes)),
					A2(
						$author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave,
						model,
						_Utils_update(
							fee,
							{iQ: isRecordingInMinutes})));
			case 28:
				var postStatus = feeFormMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent(
						'Mark Quarantined as ' + $author$project$Model$Fee$PostStatus$toString(postStatus)),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A3($author$project$Timesheet$Requests$setPostStatus, model.gr, postStatus, fee),
						A2(
							$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
							model,
							_Utils_update(
								fee,
								{eD: postStatus}))));
			case 15:
				var feeId = feeFormMsg.a;
				var subject = feeFormMsg.b;
				return A2(
					$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
					model,
					_Utils_update(
						fee,
						{
							cb: $elm$core$Maybe$Nothing,
							ad: $elm$core$Maybe$Just(
								{g_: feeId, af: subject})
						}));
			case 16:
				var subject = feeFormMsg.a;
				return A2(
					$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
					model,
					A2($author$project$FeeEntry$Update$updateSubjectEditor, model.dA, subject));
			case 17:
				var _v29 = fee.ad;
				if (!_v29.$) {
					var editor = _v29.a;
					return A3($author$project$FeeEntry$Update$saveSubject, model, fee, editor);
				} else {
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 18:
				var subjectFeeId = feeFormMsg.a;
				var subject = feeFormMsg.b;
				return A4($author$project$FeeEntry$Update$retryRename, model, fee, subjectFeeId, subject);
			case 19:
				return A2(
					$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
					model,
					_Utils_update(
						fee,
						{ad: $elm$core$Maybe$Nothing}));
			case 20:
				var subjectFeeId = feeFormMsg.a;
				return A2(
					$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
					model,
					_Utils_update(
						fee,
						{cb: subjectFeeId}));
			case 22:
				var dateString = feeFormMsg.a;
				return A2(
					$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
					model,
					A2($author$project$FeeEntry$Update$updateTempDate, model.dA, dateString));
			case 21:
				var dateString = feeFormMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$FeeEntry$Update$scrollTo('fee-form'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Ports$EventTracking$trackEvent('Set Date'),
						A2(
							$author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave,
							model,
							A2(
								$author$project$FeeEntry$Update$updateOccurredAtWith,
								model.dA,
								A3($author$project$FeeEntry$Update$addDateToDateTime, zone, fee.b7, dateString)))));
			case 23:
				var timestring = feeFormMsg.a;
				return A2(
					$author$project$FeeEntry$Logic$UpdateLogic$updateFee,
					model,
					A2($author$project$FeeEntry$Update$updateTempTime, model.dA, timestring));
			case 24:
				var timeString = feeFormMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$FeeEntry$Update$scrollTo('fee-form'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Ports$EventTracking$trackEvent('Set Time'),
						A2(
							$author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave,
							model,
							A2(
								$author$project$FeeEntry$Update$updateOccurredAtWith,
								model.dA,
								A3($author$project$FeeEntry$Update$addTimeToDateTime, zone, fee.b7, timeString)))));
			case 25:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$FeeEntry$Update$getCurrentRataDieCommand(fee.aC),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 26:
				var posix = feeFormMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$FeeEntry$Update$scrollTo('fee-form'),
					A2(
						$author$project$FeeEntry$Logic$UpdateLogic$updateFeeAndSave,
						model,
						A2($author$project$FeeEntry$Update$updateOccurredAtWith, model.dA, posix)));
			case 30:
				var cmd = function () {
					var _v30 = fee.fG;
					if (!_v30.$) {
						var a = _v30.a;
						return $author$project$FeeEntry$Requests$getActivityContacts(a.aC);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$mapCmd,
					A2(
						$elm$core$Basics$composeL,
						$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
						$author$project$FeeEntry$Messages$ContactSelectorLoaded),
					A2(
						$Fresheyeball$elm_return$Return$command,
						cmd,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									dA: _Utils_update(
										fee,
										{
											g1: $author$project$Model$Fee$FeeTypeView$SelectContact($author$project$Model$Fee$FeeTypeView$ContactSelectorLoading)
										})
								}))));
			case 31:
				var contactsWebData = feeFormMsg.a;
				var feeTypeView = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$author$project$Model$Fee$FeeTypeView$DisplayFeeType,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						A2($elm$core$Basics$composeR, $author$project$Model$Fee$FeeTypeView$ContactSelectorOpen, $author$project$Model$Fee$FeeTypeView$SelectContact),
						contactsWebData));
				var focusSelector = function () {
					if ((feeTypeView.$ === 2) && (!feeTypeView.a.$)) {
						var contacts = feeTypeView.a.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'contact-selector',
							A2(
								$elm$core$Maybe$map,
								$author$project$Contacts$ContactLogic$domId,
								$elm$core$List$head(contacts)));
					} else {
						return 'contact-selector';
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2($author$project$FeeEntry$Update$focus, fee.aC, focusSelector),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								dA: _Utils_update(
									fee,
									{g1: feeTypeView})
							})));
			case 32:
				var contactId = feeFormMsg.a;
				var cmd = function () {
					var _v32 = fee.fG;
					if (!_v32.$) {
						var a = _v32.a;
						return A4($author$project$FeeEntry$Requests$setActivityContact, model.gr, fee, a.aC, contactId);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent('Set Contact'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						cmd,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									dA: _Utils_update(
										fee,
										{g1: $author$project$Model$Fee$FeeTypeView$DisplayFeeType})
								}))));
			case 33:
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							dA: _Utils_update(
								fee,
								{g1: $author$project$Model$Fee$FeeTypeView$DisplayFeeType})
						}));
			case 34:
				return $Fresheyeball$elm_return$Return$singleton(model);
			case 35:
				var subMsg = feeFormMsg.a;
				var _v33 = A4(
					$author$project$Components$MatterInput$Update$update,
					subMsg,
					model.eg,
					recentMatters,
					$author$project$Timesheet$FeeLogic$matterDomId(fee.aC));
				var newMatterInput = _v33.a;
				var matterSelection = _v33.b;
				var subCmd = _v33.c;
				var _v34 = A6($author$project$MatterLogic$applyMatterSelectionToFee, model.gr, user.ce, recentMatters, matterSelection, fee, fee);
				var updatedFee = _v34.a;
				var updateMatterCmd = _v34.b;
				var openMatterCmd = _Utils_eq(matterSelection, $author$project$Components$MatterInput$MatterSelection$OpenRestricted) ? $author$project$Utils$send(
					$author$project$FeeEntry$Messages$SelectInput(
						$o_train$elm_search_input$Select$Set(
							$o_train$elm_search_input$Select$Mode(0)))) : $elm$core$Platform$Cmd$none;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$FeeEntry$Update$scrollTo('fee-form'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$TimesheetPage$Messages$FeeFormEdit(updatedFee.aC),
							openMatterCmd),
						A2(
							$Fresheyeball$elm_return$Return$command,
							updateMatterCmd,
							A2(
								$Fresheyeball$elm_return$Return$mapCmd,
								A2(
									$elm$core$Basics$composeL,
									$author$project$TimesheetPage$Messages$FeeFormEdit(updatedFee.aC),
									$author$project$FeeEntry$Messages$MatterInputMessage),
								A2(
									$Fresheyeball$elm_return$Return$command,
									subCmd,
									$Fresheyeball$elm_return$Return$singleton(
										_Utils_update(
											model,
											{dA: updatedFee, eg: newMatterInput})))))));
			case 1:
				if (!feeFormMsg.a.$) {
					var _v35 = feeFormMsg.a.a;
					var rateValues = _v35.b;
					var preloadedRateValues = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.iN;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (r) {
										return _Utils_eq(
											r.gR,
											A2(
												$elm$core$Maybe$withDefault,
												'Never Match Anything',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.gR;
													},
													fee.fD)));
									},
									A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, actionStepRates)))));
					var allRateValues = _Utils_ap(rateValues, preloadedRateValues);
					return _Utils_Tuple2(
						A2(
							$author$project$FeeEntry$Update$resetSearchInputRecordsForRateValueInput,
							$krisajenkins$remotedata$RemoteData$Success(allRateValues),
							model),
						A2($author$project$FeeEntry$Update$focus, fee.aC, 'action-step-matter-rate-search-input'));
				} else {
					var err = feeFormMsg.a.a;
					var failure = $krisajenkins$remotedata$RemoteData$Failure(
						$author$project$ErrorLogic$getHttpError(err));
					var updatedFee = _Utils_update(
						fee,
						{cO: failure});
					return $Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$FeeEntry$Update$resetSearchInputRecordsForRateValueInput,
							failure,
							_Utils_update(
								model,
								{dA: updatedFee})));
				}
			case 2:
				if (!feeFormMsg.a.$) {
					var _v36 = feeFormMsg.a.a;
					var scaleItemsWebData = _v36.b;
					return _Utils_Tuple2(
						A2(
							$author$project$FeeEntry$Update$resetSearchInputRecordsForScaleItemsInput,
							$krisajenkins$remotedata$RemoteData$Success(scaleItemsWebData),
							model),
						A2($author$project$FeeEntry$Update$focus, fee.aC, 'scale-item-search-input'));
				} else {
					var err = feeFormMsg.a.a;
					var failure = $krisajenkins$remotedata$RemoteData$Failure(
						$author$project$ErrorLogic$getHttpError(err));
					var updatedFee = _Utils_update(
						fee,
						{be: failure});
					return $Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$FeeEntry$Update$resetSearchInputRecordsForScaleItemsInput,
							failure,
							_Utils_update(
								model,
								{dA: updatedFee})));
				}
			case 3:
				if (!feeFormMsg.a.$) {
					var _v37 = feeFormMsg.a.a;
					var libraryNames = _v37.b;
					return _Utils_Tuple2(
						A2(
							$author$project$FeeEntry$Update$resetSearchInputRecords,
							$krisajenkins$remotedata$RemoteData$Success(
								$author$project$Model$IManage$Library$toManySearchInputRecords(libraryNames)),
							model),
						A2($author$project$FeeEntry$Update$focus, fee.aC, 'file-email-search-input'));
				} else {
					var err = feeFormMsg.a.a;
					return $Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$FeeEntry$Update$resetSearchInputRecords,
							$krisajenkins$remotedata$RemoteData$Failure(
								$author$project$ErrorLogic$getHttpError(err)),
							model));
				}
			case 13:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent('Started Timer'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$FeeEntry$Update$removeConsolidatedFeeIdCmd(fee.aC),
						A2(
							$Fresheyeball$elm_return$Return$command,
							A2($author$project$Timesheet$Requests$startTimer, model.gr, fee),
							$Fresheyeball$elm_return$Return$singleton(model))));
			case 42:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$InputControl$selectActiveContent(0),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 43:
				var bool = feeFormMsg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							dA: _Utils_update(
								fee,
								{hA: bool})
						}));
			default:
				var subMsg = feeFormMsg.a;
				var aiUpdateModel = {gr: model.gr, g_: fee.aC, a6: fee.aQ};
				var _v38 = A2($author$project$Components$AiInput$Update$update, subMsg, aiUpdateModel);
				var newAiInput = _v38.a;
				var subCmd = _v38.b;
				var updatedFee = _Utils_update(
					fee,
					{aQ: newAiInput});
				return A2(
					$Fresheyeball$elm_return$Return$mapCmd,
					A2(
						$elm$core$Basics$composeL,
						$author$project$TimesheetPage$Messages$FeeFormEdit(updatedFee.aC),
						$author$project$FeeEntry$Messages$AiInputMessage),
					A2(
						$Fresheyeball$elm_return$Return$command,
						subCmd,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{dA: updatedFee}))));
		}
	});
var $author$project$FeeEntry$Update$update = F4(
	function (zone, recentMatters, msg, model) {
		if (msg.$ === 7) {
			var feeFormMsg = msg.b;
			return A4($author$project$FeeEntry$Update$processFeeFormEdit, zone, feeFormMsg, recentMatters, model);
		} else {
			return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$Model$IntegrationStatuses$updateBrowserExtensionStatus = F2(
	function (integrationStatus, integrationStatuses) {
		return _Utils_update(
			integrationStatuses,
			{cX: integrationStatus});
	});
var $author$project$Model$IntegrationStatuses$updateExchangeStatus = F2(
	function (integrationStatus, integrationStatuses) {
		return _Utils_update(
			integrationStatuses,
			{bC: integrationStatus});
	});
var $author$project$Timesheet$FeeLogic$updateFeeStatus = F3(
	function (zone, feeStatus, fees) {
		var rataDie = A2($author$project$Timesheet$FeeLogic$getRataDie, zone, feeStatus);
		var feeStatusUpdate = F2(
			function (status, item) {
				return _Utils_update(
					item,
					{dy: status.dy, dz: status.dz, eD: status.eD, cK: status.cK});
			});
		var entries = A3(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$update,
			rataDie,
			$elm$core$Maybe$andThen(
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$toList,
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$Timesheet$FeeLogic$updateFeeIdWith,
							feeStatusUpdate(feeStatus),
							feeStatus),
						$mgold$elm_nonempty_list$List$Nonempty$fromList))),
			fees.$7);
		return _Utils_update(
			fees,
			{$7: entries});
	});
var $author$project$Timesheet$FeeLogic$updateFeesEntries = F2(
	function (fees, entries) {
		return _Utils_update(
			fees,
			{$7: entries});
	});
var $author$project$TimesheetPage$Messages$ConversationMatterMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Timesheet$FeeLogic$conversationMatterDomId = function (convKey) {
	return 'conv-fee-row-' + (convKey + '-matter');
};
var $author$project$Components$MatterInput$Views$EditMode$Model$Model = $elm$core$Basics$identity;
var $author$project$Components$MatterInput$Views$EditMode$Model$makeDomId = function (fee) {
	return $author$project$Timesheet$FeeLogic$matterDomId(fee.aC);
};
var $author$project$Components$MatterInput$Views$EditMode$Model$createInternalModel = F3(
	function (pms, fee, feeSearchTerms) {
		return {
			gG: $author$project$Components$MatterInput$Views$EditMode$Model$makeDomId(fee),
			bF: feeSearchTerms,
			aB: fee.aB,
			a_: fee.a_,
			h$: fee.eg,
			ce: pms,
			cq: fee.hY
		};
	});
var $mgold$elm_nonempty_list$List$Nonempty$length = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $elm$core$List$length(xs) + 1;
};
var $mgold$elm_nonempty_list$List$Nonempty$get = F2(
	function (i, ne) {
		var x = ne.a;
		var xs = ne.b;
		var j = A2(
			$elm$core$Basics$modBy,
			$mgold$elm_nonempty_list$List$Nonempty$length(ne),
			i);
		var find = F2(
			function (k, ys) {
				find:
				while (true) {
					if (!ys.b) {
						return x;
					} else {
						var z = ys.a;
						var zs = ys.b;
						if (!k) {
							return z;
						} else {
							var $temp$k = k - 1,
								$temp$ys = zs;
							k = $temp$k;
							ys = $temp$ys;
							continue find;
						}
					}
				}
			});
		return (!j) ? x : A2(find, j - 1, xs);
	});
var $author$project$Timesheet$Conversation$Logic$earliestFee = function (fees) {
	return A2($mgold$elm_nonempty_list$List$Nonempty$get, -1, fees);
};
var $mgold$elm_nonempty_list$List$Nonempty$any = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return f(x) || A2($elm$core$List$any, f, xs);
	});
var $author$project$Timesheet$Conversation$Logic$hasIncompleteFee = function (fees) {
	return A2(
		$mgold$elm_nonempty_list$List$Nonempty$any,
		function (fee) {
			return fee.aB;
		},
		fees);
};
var $author$project$Components$MatterInput$Views$EditMode$Model$updateMatterInputToEditMode = F2(
	function (mode, model) {
		var input = model.h$;
		var updatedInput = _Utils_update(
			input,
			{bY: mode});
		return _Utils_update(
			model,
			{h$: updatedInput});
	});
var $author$project$Components$MatterInput$Views$EditMode$Model$fromConversationMatterInput = F5(
	function (zone, pms, groupByKey, convMatterInput, fees) {
		var hasIncompleteFee = $author$project$Timesheet$Conversation$Logic$hasIncompleteFee(fees);
		var earliestFee = $author$project$Timesheet$Conversation$Logic$earliestFee(fees);
		return function (m) {
			if (!convMatterInput.$) {
				var openGroupKey = convMatterInput.a;
				var matterModel = convMatterInput.b;
				return _Utils_eq(openGroupKey, groupByKey) ? _Utils_update(
					m,
					{h$: matterModel}) : A2($author$project$Components$MatterInput$Views$EditMode$Model$updateMatterInputToEditMode, 1, m);
			} else {
				return A2($author$project$Components$MatterInput$Views$EditMode$Model$updateMatterInputToEditMode, 1, m);
			}
		}(
			function (m) {
				return _Utils_update(
					m,
					{
						gG: $author$project$Timesheet$FeeLogic$conversationMatterDomId(groupByKey),
						aB: hasIncompleteFee
					});
			}(
				A3($author$project$Components$MatterInput$Views$EditMode$Model$createInternalModel, pms, earliestFee, $elm$core$Maybe$Nothing)));
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Timesheet$FeeLogic$replaceFees = F3(
	function (zone, feeList, fees) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Timesheet$FeeLogic$replaceFee(zone),
			fees,
			feeList);
	});
var $author$project$Model$Fees$OneIsOpen = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Timesheet$FeeLogic$setConversationMatterInput = F3(
	function (convMatterInput, groupByKey_, fees) {
		return _Utils_update(
			fees,
			{
				c4: function () {
					var _v0 = convMatterInput.bY;
					if (_v0 === 1) {
						return $author$project$Model$Fees$AllClosed;
					} else {
						return A2($author$project$Model$Fees$OneIsOpen, groupByKey_, convMatterInput);
					}
				}()
			});
	});
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $author$project$TimesheetPage$Update$updateForConversationMatterMsg = F5(
	function (zone, model, matterMsg, groupByKey, fees) {
		var derivedMatterModel = function () {
			var _v2 = A5($author$project$Components$MatterInput$Views$EditMode$Model$fromConversationMatterInput, zone, model.jS.ce, groupByKey, model.aY.c4, fees);
			var editModeInternalModel = _v2;
			return editModeInternalModel.h$;
		}();
		var applyMsgToConversationMatterModel = A4(
			$author$project$Components$MatterInput$Update$update,
			matterMsg,
			derivedMatterModel,
			model.iP,
			$author$project$Timesheet$FeeLogic$conversationMatterDomId(groupByKey));
		var _v0 = applyMsgToConversationMatterModel;
		var convNewMatterInput = _v0.a;
		var matterSelection = _v0.b;
		var subCmd = _v0.c;
		var applyMatterChangeToChildFees = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$batch,
			$elm$core$List$unzip(
				A2(
					$elm$core$List$map,
					function (fee) {
						return A6($author$project$MatterLogic$applyMatterSelectionToFee, model.gr, model.jS.ce, model.iP, matterSelection, fee, fee);
					},
					$mgold$elm_nonempty_list$List$Nonempty$toList(fees))));
		var _v1 = applyMatterChangeToChildFees;
		var updatedConversationFees = _v1.a;
		var saveChildFeesCmd = _v1.b;
		return A2(
			$Fresheyeball$elm_return$Return$command,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$TimesheetPage$Messages$ConversationMatterMsg(groupByKey),
				subCmd),
			A2(
				$Fresheyeball$elm_return$Return$command,
				saveChildFeesCmd,
				$Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							aY: A3(
								$author$project$Timesheet$FeeLogic$setConversationMatterInput,
								convNewMatterInput,
								groupByKey,
								A3($author$project$Timesheet$FeeLogic$replaceFees, zone, updatedConversationFees, model.aY))
						}))));
	});
var $author$project$Components$SearchInput$SearchInputSelectors$FeeTypeSelector = 0;
var $author$project$FeeEntry$Messages$OpenSearchInput = function (a) {
	return {$: 7, a: a};
};
var $author$project$TimesheetPage$Update$newEntryFocus = F2(
	function (feeId, model) {
		return ($elm$core$List$length(model.bG) > 1) ? $author$project$Utils$send(
			A2(
				$author$project$TimesheetPage$Messages$FeeFormEdit,
				feeId,
				$author$project$FeeEntry$Messages$OpenSearchInput(0))) : $author$project$TimesheetPage$Update$focusOnFeeEntryDescription;
	});
var $author$project$TimesheetPage$Update$updateForNewManualEntryResponse = F3(
	function (zone, model, response) {
		var _v0 = $author$project$Model$Fee$feeDecoder(response);
		if (!_v0.$) {
			var fee = _v0.a;
			return A2(
				$Fresheyeball$elm_return$Return$andThen,
				$author$project$TimesheetPage$Update$scrollSelectedFeeIdIntoView,
				A2(
					$Fresheyeball$elm_return$Return$effect_,
					$author$project$TimesheetPage$Update$newEntryFocus(fee.aC),
					A2(
						$Fresheyeball$elm_return$Return$map,
						$author$project$TimesheetPage$Update$clearNewEntryLoading,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									aY: A3($author$project$Timesheet$FeeLogic$addFee, zone, fee, model.aY)
								})))));
		} else {
			var error = _v0.a;
			return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $author$project$MatterLogic$updateMatterList = F2(
	function (matters, matter) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$List$take,
				10,
				A2($elm$core$List$cons, matter, matters)),
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return A2(
						$elm$core$List$cons,
						m,
						A2($elm_community$list_extra$List$Extra$remove, m, matters));
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.aC;
						},
						$elm$core$Basics$eq(matter.aC)),
					matters)));
	});
var $author$project$Model$IntegrationStatuses$updatePMSStatus = F2(
	function (integrationStatus, integrationStatuses) {
		return _Utils_update(
			integrationStatuses,
			{ce: integrationStatus});
	});
var $author$project$Model$IntegrationStatuses$updatePhoneStatus = F2(
	function (integrationStatus, integrationStatuses) {
		return _Utils_update(
			integrationStatuses,
			{bC: integrationStatus});
	});
var $author$project$Timesheet$FeeSearchConfigurationLogic$updateReceivedFeeStatus = F2(
	function (feeSearchConfig, feeStatus) {
		return _Utils_update(
			feeSearchConfig,
			{
				dI: A3(
					$author$project$Timesheet$FeeCountsLogic$addToFilterCount,
					$author$project$Timesheet$FeeCountsLogic$PostFailed($author$project$Timesheet$FeeCountsLogic$NoFilter),
					feeStatus.g_,
					feeSearchConfig.dI)
			});
	});
var $author$project$TimesheetPage$Update$innerUpdate = F3(
	function (zone, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A4($author$project$Activities$Update$update, zone, model.gr, subMsg, model.fI);
				var updatedActivityFeed = _v1.a;
				var subCmd = _v1.b;
				var maybeCmd = _v1.c;
				return A2(
					$author$project$TimesheetPage$Update$applyMaybeCommand,
					maybeCmd,
					A2(
						$Fresheyeball$elm_return$Return$mapCmd,
						$author$project$TimesheetPage$Messages$ActivityFeedComponent,
						A2(
							$Fresheyeball$elm_return$Return$command,
							subCmd,
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{fI: updatedActivityFeed})))));
			case 85:
				var time = msg.a;
				var toMinuteMillis = $elm$core$Maybe$map(
					A2(
						$elm$core$Basics$composeR,
						A2($justinmimbs$time_extra$Time$Extra$floor, 13, zone),
						$elm$time$Time$posixToMillis));
				var dashboard = model.gx;
				var updatedModel = (!_Utils_eq(
					toMinuteMillis(
						$elm$core$Maybe$Just(time)),
					toMinuteMillis(dashboard.io))) ? _Utils_update(
					model,
					{
						gx: _Utils_update(
							dashboard,
							{
								io: $elm$core$Maybe$Just(time)
							})
					}) : model;
				return A2(
					$Fresheyeball$elm_return$Return$map,
					A2($author$project$TimesheetPage$Update$injectCurrentTimeToRunningTimer, zone, time),
					$Fresheyeball$elm_return$Return$singleton(updatedModel));
			case 86:
				var time = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							aU: A2($author$project$CoreX$RataDie$fromPosix, zone, time)
						}));
			case 99:
				var timezone = msg.a;
				var groupedFees = A2($author$project$Timesheet$FeeLogic$initGroupFees, timezone, model.aY);
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{aY: groupedFees}));
			case 50:
				var time = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$map,
					A2($author$project$TimesheetPage$Update$checkFeesHaveOccurred, zone, time),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 101:
				return $Fresheyeball$elm_return$Return$singleton(model);
			case 102:
				var version = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(model);
			case 104:
				var tour = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$CompletedTourEvent(tour)),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$User$Requests$completeTour, model.gr, tour),
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									jS: A2($author$project$User$UserLogic$completeUserTour, tour, model.jS)
								}))));
			case 105:
				if (!msg.a.$) {
					var response = msg.a.a;
					return $Fresheyeball$elm_return$Return$singleton(model);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 94:
				var subMsg = msg.a;
				var completeTourIfAcknowledged = F2(
					function (isAcknowledged, context) {
						var tour = $elm$core$Maybe$Just(
							function () {
								if (!context) {
									return 2;
								} else {
									return 3;
								}
							}());
						return isAcknowledged ? A2(
							$Fresheyeball$elm_return$Return$command,
							A2($author$project$User$Requests$completeTour, model.gr, tour),
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{
										jS: A2($author$project$User$UserLogic$completeUserTour, tour, model.jS)
									}))) : $Fresheyeball$elm_return$Return$singleton(model);
					});
				var closeModal = function (m) {
					return _Utils_update(
						m,
						{h7: $author$project$Components$Modal$Model$Closed});
				};
				var _v2 = model.h7;
				if (_v2.$ === 2) {
					var modalModel = _v2.a;
					switch (subMsg.$) {
						case 0:
							var acknowledgedModal = $author$project$Components$Modal$Model$UiInfoAlertModal(
								A2($author$project$Components$UiInfoAlerts$Update$update, subMsg, modalModel));
							return $Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{h7: acknowledgedModal}));
						case 1:
							var context = subMsg.a;
							return A2(
								$Fresheyeball$elm_return$Return$map,
								closeModal,
								A2(completeTourIfAcknowledged, modalModel.bm, context));
						default:
							if (subMsg.a === 1) {
								var _v4 = subMsg.a;
								return A2(
									$Fresheyeball$elm_return$Return$map,
									closeModal,
									A2(
										$Fresheyeball$elm_return$Return$andThen,
										$author$project$TimesheetPage$Update$consolidateFees(1),
										A2(completeTourIfAcknowledged, modalModel.bm, 1)));
							} else {
								return $Fresheyeball$elm_return$Return$singleton(model);
							}
					}
				} else {
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 7:
				if (((msg.b.$ === 35) && (msg.b.a.$ === 5)) && (!msg.b.a.a)) {
					var feeId = msg.a;
					var _v6 = msg.b.a;
					var _v7 = _v6.a;
					var context = _v6.b;
					return A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$TimesheetPage$Update$scrollSelectedFeeIdIntoView,
						A2(
							$elm$core$Maybe$withDefault,
							$Fresheyeball$elm_return$Return$singleton(model),
							A2(
								$elm$core$Maybe$map,
								A4($author$project$TimesheetPage$Update$openMatterAndSelectFee, zone, model, 0, context),
								A2($author$project$Timesheet$FeeLogic$findFeeById, feeId, model.aY))));
				} else {
					var feeFormEditMsg = msg;
					var feeId = feeFormEditMsg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$Fresheyeball$elm_return$Return$singleton(model),
						A2(
							$elm$core$Maybe$map,
							function (existingFee) {
								var setFeeEntryChangesOnTopModel = function (_v8) {
									var fee = _v8.dA;
									var matterInput = _v8.eg;
									var currentSearchInput = _v8.gt;
									var selectInput = _v8.e_;
									return _Utils_update(
										model,
										{
											gX: currentSearchInput,
											gY: selectInput,
											aY: A3(
												$author$project$Timesheet$FeeLogic$replaceFee,
												zone,
												_Utils_update(
													fee,
													{eg: matterInput}),
												model.aY)
										});
								};
								return A2(
									$Fresheyeball$elm_return$Return$map,
									setFeeEntryChangesOnTopModel,
									A4(
										$author$project$FeeEntry$Update$update,
										zone,
										model.iP,
										feeFormEditMsg,
										{
											bn: model.bn,
											gr: model.gr,
											gt: model.gX,
											gI: A2($author$project$Components$DurationInput$DurationInputLogic$getHoursAndMinutes, existingFee.jP, model.jS.ej),
											dA: existingFee,
											bG: model.bG,
											hU: model.jS.E.hU,
											eg: existingFee.eg,
											ej: model.jS.ej,
											ce: model.jS.ce,
											e_: model.gY,
											jS: model.jS,
											cL: model.cL
										}));
							},
							A2($author$project$Timesheet$FeeLogic$findFeeById, feeId, model.aY)));
				}
			case 30:
				var fee = msg.a;
				var triggeredFrom = msg.b;
				var fromToString = function (from) {
					switch (from) {
						case 0:
							return 'Timesheet';
						case 1:
							return 'FeeForm';
						default:
							return 'RunningTimerBanner';
					}
				};
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent(
						'Stop Timer - ' + fromToString(triggeredFrom)),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$FeeTimerLogic$stopFeeTimerCmd, model.gr, fee),
						$Fresheyeball$elm_return$Return$singleton(model)));
			case 31:
				var fee = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent('Resumed Timer'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$FeeEntry$Update$removeConsolidatedFeeIdCmd(fee.aC),
						A2(
							$Fresheyeball$elm_return$Return$command,
							A2($author$project$Timesheet$Requests$startTimer, model.gr, fee),
							$Fresheyeball$elm_return$Return$singleton(
								A2($author$project$TimesheetPage$Update$selectFee, fee, model)))));
			case 8:
				var groupByKey = msg.a;
				var matterMsg = msg.b;
				return A2(
					$elm$core$Maybe$withDefault,
					$Fresheyeball$elm_return$Return$singleton(model),
					A2(
						$elm$core$Maybe$map,
						A4($author$project$TimesheetPage$Update$updateForConversationMatterMsg, zone, model, matterMsg, groupByKey),
						$mgold$elm_nonempty_list$List$Nonempty$fromList(
							A2(
								$author$project$Timesheet$FeeLogic$getFeesBy,
								function (f) {
									return _Utils_eq(
										A2($author$project$Timesheet$FeeLogic$groupByKey, zone, f),
										groupByKey);
								},
								model.aY))));
			case 51:
				var defaultFeeType = A2(
					$elm$core$Maybe$andThen,
					function (dft) {
						return A2($author$project$FeeTypeLogic$getById, dft, model.bG);
					},
					model.jS.da);
				var _v10 = _Utils_Tuple2(model.g$.ep, defaultFeeType);
				if (_v10.a) {
					return $author$project$FlashMessageLogic$addLoadingMessage(model);
				} else {
					if (_v10.b.$ === 1) {
						var _v11 = _v10.b;
						return A2($author$project$FlashMessageLogic$addFromString, model, 'No default fee type');
					} else {
						var feeType = _v10.b.a;
						return A2(
							$Fresheyeball$elm_return$Return$command,
							$author$project$Ports$EventTracking$trackEvent('Create Manual Fee'),
							A2(
								$Fresheyeball$elm_return$Return$command,
								A2($author$project$FeeEntry$Requests$createFee, model.gr, feeType),
								$Fresheyeball$elm_return$Return$singleton(
									A2($author$project$TimesheetPage$Update$setFeeSearchNewEntryLoading, true, model))));
					}
				}
			case 52:
				var defaultFeeType = A2(
					$elm$core$Maybe$andThen,
					function (dft) {
						return A2($author$project$FeeTypeLogic$getById, dft, model.bG);
					},
					model.jS.da);
				var _v12 = _Utils_Tuple2(model.g$.ep, defaultFeeType);
				if (_v12.a) {
					return $author$project$FlashMessageLogic$addLoadingMessage(model);
				} else {
					if (_v12.b.$ === 1) {
						var _v13 = _v12.b;
						return A2($author$project$FlashMessageLogic$addFromString, model, 'No default fee type');
					} else {
						var feeType = _v12.b.a;
						return A2(
							$Fresheyeball$elm_return$Return$command,
							$author$project$Ports$EventTracking$trackEvent('Create Quicktimer Fee'),
							A2(
								$Fresheyeball$elm_return$Return$command,
								A2($author$project$FeeEntry$Requests$createFeeWithTimer, model.gr, feeType),
								$Fresheyeball$elm_return$Return$singleton(
									A2($author$project$TimesheetPage$Update$setFeeSearchNewEntryLoading, true, model))));
					}
				}
			case 77:
				var fees = msg.a;
				var updatedFees = A3(
					$elm$core$List$foldl,
					F2(
						function (f, feeList) {
							return A3($author$project$Timesheet$FeeLogic$insertIfMissing, zone, f, feeList);
						}),
					model.aY,
					fees);
				var updatedFeeSearchConfiguration = A3(
					$elm$core$List$foldl,
					F2(
						function (f, config) {
							return A5($author$project$Timesheet$FeeSearchConfigurationLogic$updateReceivedFee, zone, model.aU, model.jS.aX, config, f);
						}),
					model.g$,
					fees);
				return A2(
					$Fresheyeball$elm_return$Return$effect_,
					$author$project$Ports$PageTitle$updatePageTitle,
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{g$: updatedFeeSearchConfiguration, aY: updatedFees})));
			case 76:
				var fee = msg.a;
				var cmd = function () {
					if (A3($author$project$Timesheet$FeeLogic$isDayLoaded, zone, model.aY, fee)) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var date = A2($justinmimbs$date$Date$fromPosix, zone, fee.b7);
						return A2($author$project$Timesheet$Requests$fetchFeesFor, date, model.g$);
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$command,
					cmd,
					A2(
						$Fresheyeball$elm_return$Return$effect_,
						$author$project$Ports$PageTitle$updatePageTitle,
						$Fresheyeball$elm_return$Return$singleton(
							A3($author$project$TimesheetPage$Update$receiveFee, zone, model, fee))));
			case 79:
				var fee = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$effect_,
					$author$project$Ports$PageTitle$updatePageTitle,
					$Fresheyeball$elm_return$Return$singleton(
						A3($author$project$TimesheetPage$Update$receiveFee, zone, model, fee)));
			case 78:
				var fee = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$TimesheetPage$Update$scrollSelectedFeeIdIntoView,
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$TimesheetPage$Update$focusOnFeeEntryDescription,
						A2(
							$Fresheyeball$elm_return$Return$effect_,
							$author$project$Ports$PageTitle$updatePageTitle,
							$Fresheyeball$elm_return$Return$singleton(
								A2(
									$author$project$TimesheetPage$Update$selectFee,
									fee,
									A3($author$project$TimesheetPage$Update$receiveFee, zone, model, fee))))));
			case 65:
				if (!msg.a.$) {
					var _v14 = msg.a.a;
					var response = _v14.b;
					return A3($author$project$TimesheetPage$Update$updateForNewManualEntryResponse, zone, model, response);
				} else {
					var response = msg.a.a;
					var newModel = $author$project$TimesheetPage$Update$clearNewEntryLoading(model);
					return A2($author$project$FlashMessageLogic$addFromError, newModel, response);
				}
			case 66:
				if (!msg.a.$) {
					var _v15 = msg.a.a;
					var response = _v15.b;
					return A4($author$project$TimesheetPage$Update$addFeeFromCreateFeeResponse, zone, response, model, false);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 67:
				if (!msg.a.$) {
					var _v16 = msg.a.a;
					var response = _v16.b;
					return A4($author$project$TimesheetPage$Update$addFeeFromCreateFeeResponse, zone, response, model, false);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 68:
				if (!msg.a.$) {
					var _v17 = msg.a.a;
					var response = _v17.b;
					return A3($author$project$TimesheetPage$Update$consolidateFeesResponse, zone, response, model);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 69:
				if (!msg.a.$) {
					var _v18 = msg.a.a;
					var response = _v18.b;
					return A2($author$project$TimesheetPage$Update$handleFlashWhenPresent, response, model);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 75:
				if (!msg.a.$) {
					return $Fresheyeball$elm_return$Return$singleton(model);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 19:
				var fee = msg.a;
				var isInGroup = msg.b;
				var consolidatedFees = $author$project$Timesheet$FeeLogic$getConsolidatedFees(fee);
				var trackOrDropGroupEvent = function () {
					var _v19 = fee.fG;
					if (!_v19.$) {
						var a = _v19.a;
						var _v20 = _Utils_Tuple2(isInGroup, a.i);
						if (_v20.a && (_v20.b.$ === 3)) {
							return $author$project$Ports$EventTracking$trackEventFor(
								$author$project$Ports$EventTracking$EmailGroupEvent('Manually Post Email in Group'));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					} else {
						return ((!$elm$core$List$isEmpty(consolidatedFees)) && A2(
							$elm$core$List$all,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fG;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$map($author$project$Activities$ActivityLogic$isEmail),
									$elm$core$Maybe$withDefault(false))),
							consolidatedFees)) ? $author$project$Ports$EventTracking$trackEventFor(
							$author$project$Ports$EventTracking$EmailGroupEvent('Manually Post Merged Email')) : $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$command,
					trackOrDropGroupEvent,
					A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Ports$EventTracking$trackEvent('Posted Fee'),
						A2(
							$Fresheyeball$elm_return$Return$command,
							A2($author$project$Timesheet$Requests$queueFee, model.gr, fee),
							$Fresheyeball$elm_return$Return$singleton(model))));
			case 21:
				if (!msg.a.$) {
					var _v21 = msg.a;
					var filingStatus = _v21.a;
					var fileNoteResource = _v21.b;
					var selectedLib = function () {
						var _v23 = filingStatus.hV;
						if (_v23.$ === 1) {
							return model.jS.E.iI;
						} else {
							var lib = _v23.a;
							return $elm$core$Maybe$Just(lib);
						}
					}();
					var selectedLibItem = A2($elm$core$Maybe$map, $author$project$Components$SelectInput$Libraries$toItem, selectedLib);
					var selectedFolder = A2(
						$elm$core$Maybe$map,
						function (f) {
							return {gz: f, aC: f, b2: ''};
						},
						filingStatus.hb);
					var matterInput = A2($author$project$Components$MatterInput$Model$resetContactMatterInput, $elm$core$Maybe$Nothing, model.iP);
					var initModel = A7(
						$author$project$Components$FileNotes$Model$init,
						$author$project$TimesheetPage$Messages$FileNote,
						$author$project$TimesheetPage$Messages$ModalAction($author$project$Components$Modal$Model$Closed),
						model.gr,
						model.jS,
						model.iP,
						fileNoteResource,
						filingStatus);
					var _v22 = A2(
						$author$project$Components$FileNotes$Update$update,
						A2($author$project$Components$FileNotes$Messages$Open, filingStatus, fileNoteResource),
						initModel);
					var updatedFileNoteModel = _v22.a;
					var cmd = _v22.b;
					return A2(
						$Fresheyeball$elm_return$Return$command,
						cmd,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									h7: $author$project$Components$Modal$Model$FileNotes(updatedFileNoteModel)
								})));
				} else {
					var subMsg = msg.a;
					var _v24 = model.h7;
					if (_v24.$ === 3) {
						var fileNoteModel = _v24.a;
						var _v25 = A2($author$project$Components$FileNotes$Update$update, subMsg, fileNoteModel);
						var updatedFileNoteModel = _v25.a;
						var cmd = _v25.b;
						return A2(
							$Fresheyeball$elm_return$Return$command,
							cmd,
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{
										h7: $author$project$Components$Modal$Model$FileNotes(updatedFileNoteModel)
									})));
					} else {
						return $Fresheyeball$elm_return$Return$singleton(model);
					}
				}
			case 20:
				var fee = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A3($author$project$Timesheet$Requests$fileEmail, model.gr, fee, $elm$core$Maybe$Nothing),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 22:
				var toHoldStatus = msg.a;
				var fee = msg.b;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A3($author$project$Timesheet$Requests$holdFee, model.gr, toHoldStatus, fee),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 23:
				var fee = msg.a;
				var tagId = msg.b;
				var availableTags = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function ($) {
						return $.fi;
					},
					fee.hY);
				var feeWithNewTags = function () {
					var _v26 = A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$eq(tagId),
							function ($) {
								return $.aC;
							}),
						availableTags);
					if (!_v26.$) {
						var tag = _v26.a;
						return _Utils_update(
							fee,
							{
								fi: _List_fromArray(
									[tag])
							});
					} else {
						return fee;
					}
				}();
				var updatedFees = A3($author$project$Timesheet$FeeLogic$replaceOrInsert, zone, feeWithNewTags, model.aY);
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A3($author$project$Timesheet$Requests$setTag, model.gr, feeWithNewTags, tagId),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{aY: updatedFees})));
			case 24:
				var fee = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2($author$project$Timesheet$Requests$cloneFee, model.gr, fee),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 25:
				if (!msg.a.$) {
					var fee = msg.a.a;
					var durationInSeconds = A2(
						$elm_community$maybe_extra$Maybe$Extra$orElse,
						fee.jc,
						A2($elm$core$Maybe$andThen, $author$project$Activities$ActivityLogic$getDuration, fee.fG));
					var initModel = A5($author$project$Components$SplitFee$Model$init, model.gr, model.jS, fee, durationInSeconds, model.iP);
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Utils$send(
							$author$project$TimesheetPage$Messages$SplitFee(
								$author$project$Components$SplitFee$Messages$SplitChanged(
									$elm$core$String$fromInt(initModel.b4)))),
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									h7: $author$project$Components$Modal$Model$SplitFeeModal(initModel)
								})));
				} else {
					var subMsg = msg.a;
					var _v27 = model.h7;
					if (_v27.$ === 4) {
						var splitFeeModel = _v27.a;
						var _v28 = A2($author$project$Components$SplitFee$Update$update, subMsg, splitFeeModel);
						var updatedSplitFeeModel = _v28.a;
						var cmd = _v28.b;
						return A2(
							$Fresheyeball$elm_return$Return$command,
							cmd,
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{
										h7: $author$project$Components$Modal$Model$SplitFeeModal(updatedSplitFeeModel)
									})));
					} else {
						return $Fresheyeball$elm_return$Return$singleton(model);
					}
				}
			case 26:
				var fee = msg.a;
				var updatedFee = _Utils_update(
					fee,
					{hx: !fee.hx});
				var entries = A3($author$project$Timesheet$FeeLogic$replaceFeeActionsMenuOpen, zone, updatedFee, model.aY.$7);
				var fees = A2($author$project$Timesheet$FeeLogic$updateFeesEntries, model.aY, entries);
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{aY: fees}));
			case 93:
				var subMsg = msg.a;
				var _v29 = model.h7;
				if (!_v29.$) {
					var activity = _v29.a;
					var contactModalModel = _v29.b;
					return A2(
						$Fresheyeball$elm_return$Return$map,
						A2($author$project$TimesheetPage$Update$setContactModal, model, activity),
						function () {
							if (subMsg.$ === 7) {
								return A2(
									$elm$core$Basics$composeR,
									$Fresheyeball$elm_return$Return$effect_(
										A2($author$project$Components$ContactModal$Requests$createContactAndUpgradeActivityRequest, model.gr, activity)),
									$Fresheyeball$elm_return$Return$command(
										$author$project$Ports$EventTracking$trackEvent('Click Create Outlook Contact')));
							} else {
								return $elm$core$Basics$identity;
							}
						}()(
							$Fresheyeball$elm_return$Return$singleton(
								A2($author$project$Components$ContactModal$Update$update, subMsg, contactModalModel))));
				} else {
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 4:
				if (!msg.a.$) {
					var _v31 = msg.a.a;
					var metadata = _v31.a;
					var body = _v31.b;
					var closeContactModal = function (m) {
						return _Utils_update(
							m,
							{h7: $author$project$Components$Modal$Model$Closed});
					};
					return A2(
						$Fresheyeball$elm_return$Return$map,
						closeContactModal,
						A4($author$project$TimesheetPage$Update$addFeeFromCreateFeeResponse, zone, body, model, true));
				} else {
					if (msg.a.a.$ === 3) {
						var response = msg.a.a;
						var statusCode = response.a.e9;
						var body = response.b;
						if (statusCode === 409) {
							var _v32 = $author$project$Components$ContactModal$Model$decodeConflictingContact(body);
							if (!_v32.$) {
								var conflictingContact = _v32.a;
								var _v33 = model.h7;
								if (!_v33.$) {
									var activity = _v33.a;
									var contactModalModel = _v33.b;
									return A2(
										$Fresheyeball$elm_return$Return$map,
										A2($author$project$TimesheetPage$Update$setContactModal, model, activity),
										$Fresheyeball$elm_return$Return$singleton(
											A2(
												$author$project$Components$ContactModal$Update$update,
												$author$project$Components$ContactModal$Messages$SetConflictingContact(conflictingContact),
												contactModalModel)));
								} else {
									return $Fresheyeball$elm_return$Return$singleton(model);
								}
							} else {
								return A2($author$project$TimesheetPage$Update$setHeaderErrorOnContactModalCreate, response, model);
							}
						} else {
							return A2($author$project$TimesheetPage$Update$setHeaderErrorOnContactModalCreate, response, model);
						}
					} else {
						var response = msg.a.a;
						return A2($author$project$TimesheetPage$Update$setHeaderErrorOnContactModalCreate, response, model);
					}
				}
			case 96:
				if (!msg.a.$) {
					var _v34 = msg.a.a;
					var response = _v34.b;
					return A2($author$project$FlashMessageLogic$addFromString, model, response);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 97:
				var str = msg.a;
				var actionType = msg.b;
				var entityType = msg.c;
				var entityIds = msg.d;
				return A5($author$project$FlashMessageLogic$addFromStringWithAction, model, str, actionType, entityType, entityIds);
			case 88:
				var errorMessage = msg.a;
				return A2($author$project$FlashMessageLogic$addFromString, model, errorMessage);
			case 89:
				var errorMessage = msg.a;
				return A2($author$project$FlashMessageLogic$addFromString, model, errorMessage);
			case 10:
				var feeId = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Timesheet$Requests$blockFeeByEmail, model.gr, feeId),
								$author$project$Ports$EventTracking$trackEvent('Block Contactless Email Fee')
							])));
			case 11:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 64:
				var subMsg = msg.a;
				var fees = model.aY;
				var deletedFees = model.aY.dc;
				var _v35 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, deletedFees.c8);
				var debouncedModel = _v35.a;
				var subCmd = _v35.b;
				var emittedMsg = _v35.c;
				var updatedDebouncer = _Utils_update(
					deletedFees,
					{c8: debouncedModel});
				var updatedFees = _Utils_update(
					fees,
					{dc: updatedDebouncer});
				var updatedModel = _Utils_update(
					model,
					{aY: updatedFees});
				var mappedCmd = A2($elm$core$Platform$Cmd$map, $author$project$TimesheetPage$Messages$QueueDeleteFees, subCmd);
				if (!emittedMsg.$) {
					var emitted = emittedMsg.a;
					var _v37 = A3($author$project$TimesheetPage$Update$innerUpdate, zone, emitted, updatedModel);
					var m = _v37.a;
					var c = _v37.b;
					return _Utils_Tuple2(
						m,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[c, mappedCmd])));
				} else {
					return _Utils_Tuple2(updatedModel, mappedCmd);
				}
			case 12:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2($author$project$Timesheet$Requests$deleteFees, model.gr, model.aY.dc.dD),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 14:
				var feeIds = msg.a;
				var ids = A2(
					$elm$core$List$map,
					function ($) {
						return $.g_;
					},
					feeIds);
				var updatedCounts = A3(
					$elm$core$List$foldl,
					F2(
						function (f, count) {
							return A2($author$project$Timesheet$FeeCountsLogic$removeFromFilterCounts, f, count);
						}),
					model.g$.dI,
					ids);
				var allEmails = A2(
					$elm$core$List$all,
					A2($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Activities$ActivityLogic$isEmail),
					A2(
						$elm$core$List$map,
						function (id) {
							return A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.fG;
								},
								A2($author$project$Timesheet$FeeLogic$findFeeById, id, model.aY));
						},
						ids));
				var trackCmd = allEmails ? $author$project$Ports$EventTracking$trackEventFor(
					$author$project$Ports$EventTracking$EmailGroupEvent('Delete Email Group')) : $elm$core$Platform$Cmd$none;
				var _v38 = A2($author$project$TimesheetPage$Update$debouncedDeleteFees, model, feeIds);
				var updatedModel = _v38.a;
				var cmd = _v38.b;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					cmd,
					A2(
						$Fresheyeball$elm_return$Return$command,
						trackCmd,
						A2(
							$Fresheyeball$elm_return$Return$command,
							$author$project$Ports$EventTracking$trackEvent('Delete Fee Group'),
							$Fresheyeball$elm_return$Return$singleton(
								A3(
									$author$project$TimesheetPage$Update$setFeeSearchCounts,
									updatedCounts,
									false,
									A2($author$project$Timesheet$ConsolidateUpdateLogic$deselectFeesForMerge, ids, updatedModel))))));
			case 13:
				var feeId = msg.a;
				var maybeNextFeeId = msg.b;
				var isInGroup = msg.c;
				var trackCmd = isInGroup ? $author$project$Ports$EventTracking$trackEventFor(
					$author$project$Ports$EventTracking$EmailGroupEvent('Delete Email from Group')) : $elm$core$Platform$Cmd$none;
				var isInDeletedFeesAlready = A2($elm$core$List$member, feeId.g_, model.aY.dc.dD);
				var feeExists = $elm_community$maybe_extra$Maybe$Extra$isJust(
					A2($author$project$Timesheet$FeeLogic$findFeeById, feeId.g_, model.aY));
				if ((!feeExists) || isInDeletedFeesAlready) {
					return $Fresheyeball$elm_return$Return$singleton(model);
				} else {
					var updatedFeeSearchConfiguration = A2($author$project$Timesheet$FeeSearchConfigurationLogic$removeDeletedFee, model.g$, feeId.g_);
					var _v39 = A2(
						$author$project$TimesheetPage$Update$debouncedDeleteFees,
						model,
						_List_fromArray(
							[feeId]));
					var updatedModel = _v39.a;
					var cmd = _v39.b;
					return A2(
						$Fresheyeball$elm_return$Return$command,
						cmd,
						A2(
							$Fresheyeball$elm_return$Return$command,
							trackCmd,
							A2(
								$Fresheyeball$elm_return$Return$command,
								$author$project$Ports$EventTracking$trackEvent('Delete Fee'),
								$Fresheyeball$elm_return$Return$singleton(
									A2(
										$author$project$TimesheetPage$Update$setFeeSearchConfig,
										updatedFeeSearchConfiguration,
										A2(
											$author$project$Timesheet$ConsolidateUpdateLogic$deselectSingleFeeForMerge,
											feeId.g_,
											A2(
												$elm$core$Maybe$withDefault,
												_Utils_update(
													updatedModel,
													{
														aY: A2($author$project$Timesheet$FeeLogic$unselectFee, zone, updatedModel.aY)
													}),
												A2(
													$elm$core$Maybe$map,
													function (fee) {
														return A2($author$project$TimesheetPage$Update$selectFee, fee, updatedModel);
													},
													A2(
														$elm$core$Maybe$andThen,
														function (nextFeeId) {
															return A2($author$project$Timesheet$FeeLogic$findFeeById, nextFeeId, updatedModel.aY);
														},
														maybeNextFeeId)))))))));
				}
			case 15:
				var feeIds = msg.a;
				var ids = $elm$core$Set$toList(feeIds);
				var updatedFeeSearchConfiguration = A2($author$project$Timesheet$FeeSearchConfigurationLogic$removeDeletedFees, model.g$, ids);
				var _v40 = A2($author$project$TimesheetPage$Update$debouncedDeleteFees_, model, ids);
				var updatedModel = _v40.a;
				var cmd = _v40.b;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					cmd,
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$TimesheetPage$Update$setFeeSearchConfig,
							updatedFeeSearchConfiguration,
							$author$project$TimesheetPage$Update$resetSelectedForMerge(updatedModel))));
			case 16:
				var feeIds = msg.a;
				var activityIds = msg.b;
				var toCmd = F2(
					function (cmd, ids) {
						return $elm$core$Set$isEmpty(ids) ? $elm$core$Platform$Cmd$none : cmd(ids);
					});
				var deleteFeesCmd = A2($elm$core$Basics$composeL, $author$project$Utils$send, $author$project$TimesheetPage$Messages$DeleteFees);
				var deleteActivitiesCmd = A2($elm$core$Basics$composeL, $author$project$TimesheetPage$Update$activityFeedCommand, $author$project$Activities$Messages$DeleteActivities);
				var batchCmd = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(toCmd, deleteFeesCmd, feeIds),
							A2(toCmd, deleteActivitiesCmd, activityIds)
						]));
				return _Utils_Tuple2(model, batchCmd);
			case 74:
				if (!msg.a.$) {
					var _v41 = msg.a.a;
					return $Fresheyeball$elm_return$Return$singleton(model);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 110:
				var actionType = msg.a;
				var entityType = msg.b;
				var entityIds = msg.c;
				if (!actionType) {
					return A3($author$project$TimesheetPage$Update$handleUndo, model, entityType, entityIds);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 17:
				var contactId = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent('DowngradeToActivities Fee'),
					A2(
						$Fresheyeball$elm_return$Return$return,
						model,
						A2($author$project$Timesheet$Requests$downgradeToActivities, model.gr, contactId)));
			case 18:
				if (!msg.a.$) {
					var _v43 = msg.a.a;
					var response = _v43.b;
					return A2($author$project$FlashMessageLogic$addFromResponse, model, response);
				} else {
					var response = msg.a.a;
					return A2(
						$Fresheyeball$elm_return$Return$effect_,
						$author$project$TimesheetPage$Update$fetchFeesCmd,
						A2($author$project$FlashMessageLogic$addFromError, model, response));
				}
			case 70:
				if (!msg.b.$) {
					var fee = msg.a;
					var activity = fee.fG;
					var _v44 = msg.b.a;
					var contact = _v44.b;
					var updatedDescription = $elm$core$Maybe$Just(
						A2($author$project$FeeEntry$FeeEntryLogic$descriptionForContact, fee.g0.dd, contact.b2));
					var updatedActivity = A2(
						$elm$core$Maybe$map,
						function (a) {
							return _Utils_update(
								a,
								{
									c2: $elm$core$Maybe$Just(contact)
								});
						},
						activity);
					var updatedFee = _Utils_update(
						fee,
						{fG: updatedActivity, dd: updatedDescription});
					var entries = A4($author$project$Timesheet$FeeLogic$replaceFeeData, zone, fee, updatedFee, model.aY.$7);
					var fees = A2($author$project$Timesheet$FeeLogic$updateFeesEntries, model.aY, entries);
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Ports$EventTracking$trackEvent('ChangeContact Fee'),
						A2(
							$Fresheyeball$elm_return$Return$return,
							_Utils_update(
								model,
								{aY: fees}),
							A3($author$project$Timesheet$FeeLogic$saveFeeCmd, model.gr, fee, updatedFee)));
				} else {
					var fee = msg.a;
					var activity = fee.fG;
					var err = msg.b.a;
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 71:
				if (!msg.b.$) {
					var _v45 = msg.b.a;
					var response = _v45.b;
					return A4($author$project$TimesheetPage$Update$handleUpdateFeeResponse, zone, model, response, $elm$core$Platform$Cmd$none);
				} else {
					var previousFee = msg.a;
					var response = msg.b.a;
					return A4($author$project$TimesheetPage$Update$handleUpdateFeeResponseErr, zone, model, previousFee, response);
				}
			case 72:
				if (!msg.c.$) {
					var selector = msg.a;
					var previousFee = msg.b;
					var _v46 = msg.c.a;
					var response = _v46.b;
					var fetcherCmd = function () {
						if (selector === 3) {
							return $author$project$FeeEntry$Requests$getScaleItems(previousFee);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return A4($author$project$TimesheetPage$Update$handleUpdateFeeResponse, zone, model, response, fetcherCmd);
				} else {
					var previousFee = msg.b;
					var response = msg.c.a;
					return A4($author$project$TimesheetPage$Update$handleUpdateFeeResponseErr, zone, model, previousFee, response);
				}
			case 73:
				var feeId = msg.a;
				var _v48 = A2($author$project$Timesheet$FeeLogic$findFeeById, feeId, model.aY);
				if (!_v48.$) {
					var fee = _v48.a;
					return A3(
						$author$project$TimesheetPage$Update$innerUpdate,
						zone,
						A2($author$project$TimesheetPage$Messages$FeeFormEdit, feeId, $author$project$FeeEntry$Messages$StartPostedEdit),
						A2($author$project$TimesheetPage$Update$selectFee, fee, model));
				} else {
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 53:
				if (!msg.a.$) {
					var _v49 = msg.a.a;
					var feeCounts = _v49.b;
					return $Fresheyeball$elm_return$Return$singleton(
						A3($author$project$TimesheetPage$Update$setFeeSearchCounts, feeCounts, false, model));
				} else {
					var error = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, error);
				}
			case 47:
				if (!msg.a.$) {
					var _v50 = msg.a.a;
					var rates = _v50.b;
					return $Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								bn: $krisajenkins$remotedata$RemoteData$Success(rates)
							}));
				} else {
					var response = msg.a.a;
					var error = $author$project$ErrorLogic$getHttpError(response);
					return A2(
						$Fresheyeball$elm_return$Return$map,
						function (m) {
							return _Utils_update(
								m,
								{
									bn: $krisajenkins$remotedata$RemoteData$Failure(error)
								});
						},
						A2($author$project$FlashMessageLogic$addFromError, model, response));
				}
			case 48:
				if (!msg.a.$) {
					var _v51 = msg.a.a;
					var fees = _v51.b;
					var modelFees = model.aY;
					var emptyFees = _Utils_update(
						modelFees,
						{
							$7: $rtfeldman$elm_sorter_experiment$Sort$Dict$empty($author$project$CoreX$Sorter$reverseInt)
						});
					return $Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								aY: A3($author$project$Timesheet$FeeLogic$appendUniqFeeEntries, zone, emptyFees, fees)
							}));
				} else {
					var error = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, error);
				}
			case 49:
				if (!msg.a.$) {
					var _v52 = msg.a.a;
					var fees = _v52.b;
					var getDayDomId = function (fee) {
						return $author$project$TimesheetPage$Update$focusOn(
							A2(
								$elm$core$String$append,
								'timesheet-day-',
								$elm$core$String$fromInt(
									A2($author$project$CoreX$RataDie$fromPosix, zone, fee.b7))));
					};
					var focusDayCmd = A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							getDayDomId,
							$elm$core$List$head(fees)));
					return A2(
						$Fresheyeball$elm_return$Return$command,
						focusDayCmd,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									aY: A3($author$project$Timesheet$FeeLogic$appendUniqFeeEntries, zone, model.aY, fees)
								})));
				} else {
					var error = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, error);
				}
			case 87:
				var aiError = msg.a;
				var updateModel = function (feeId) {
					return _Utils_update(
						model,
						{
							aY: A3($author$project$Timesheet$FeeLogic$resetAiCompleted, zone, feeId, model.aY)
						});
				};
				var fee = A2($author$project$Timesheet$FeeLogic$findFeeById, aiError.g_, model.aY);
				var updatedModel = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					model,
					A2($elm$core$Basics$composeL, updateModel, $author$project$Timesheet$FeeLogic$toFeeId),
					fee);
				return A2($author$project$FlashMessageLogic$addFromString, updatedModel, aiError.eh);
			case 84:
				var feeId = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							aY: A3($author$project$Timesheet$FeeLogic$resetAiCompleted, zone, feeId, model.aY)
						}));
			case 83:
				var feeDesc = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							aY: A3($author$project$Timesheet$FeeLogic$appendToFeeSummary, zone, feeDesc, model.aY)
						}));
			case 81:
				var feeStatus = msg.a;
				var updatedFeeSearchConfiguration = $elm_community$maybe_extra$Maybe$Extra$isJust(feeStatus.dz) ? A2($author$project$Timesheet$FeeSearchConfigurationLogic$updateReceivedFeeStatus, model.g$, feeStatus) : model.g$;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							g$: updatedFeeSearchConfiguration,
							aY: A3($author$project$Timesheet$FeeLogic$updateFeeStatus, zone, feeStatus, model.aY)
						}));
			case 82:
				var filingStatusUpdate = msg.a;
				var updateFeeCmd = function (maybeUpdatedFee) {
					return $Fresheyeball$elm_return$Return$singleton(
						A2(
							$elm$core$Maybe$withDefault,
							model,
							A2(
								$elm$core$Maybe$map,
								function (updatedFee) {
									return _Utils_update(
										model,
										{
											aY: A3($author$project$Timesheet$FeeLogic$replaceFee, zone, updatedFee, model.aY)
										});
								},
								maybeUpdatedFee)));
				};
				var _v53 = filingStatusUpdate.gl;
				if (_v53.$ === 1) {
					return updateFeeCmd(
						A2(
							$elm$core$Maybe$map,
							function (fee) {
								return A2($author$project$Timesheet$FeeLogic$setFilingStatus, fee, filingStatusUpdate.dH);
							},
							A2($author$project$Timesheet$FeeLogic$findFeeById, filingStatusUpdate.g_, model.aY)));
				} else {
					var id = _v53.a;
					var updateConsolidatedFees = F2(
						function (feeId, fee) {
							var updatedConsolidatedFees = A3(
								$elm_community$list_extra$List$Extra$updateIf,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.aC;
									},
									$elm$core$Basics$eq(feeId)),
								function (f) {
									return A2($author$project$Timesheet$FeeLogic$setFilingStatus, f, filingStatusUpdate.dH);
								},
								$author$project$Timesheet$FeeLogic$getConsolidatedFees(fee));
							return _Utils_update(
								fee,
								{gm: updatedConsolidatedFees});
						});
					return updateFeeCmd(
						A2(
							$elm$core$Maybe$map,
							updateConsolidatedFees(filingStatusUpdate.g_),
							A2($author$project$Timesheet$FeeLogic$findFeeById, id, model.aY)));
				}
			case 80:
				var feeIds = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$TimesheetPage$Update$scrollSelectedFeeIdIntoView,
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$Timesheet$ConsolidateUpdateLogic$deselectFeesForMerge,
							feeIds,
							A3($author$project$TimesheetPage$Update$receivedDeletedFees, zone, model, feeIds))));
			case 98:
				var flashMessage = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					A2($author$project$FlashMessageLogic$clear, model, flashMessage));
			case 32:
				var feeToSelect = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$TimesheetPage$Update$focusOnFeeEntryDescription,
					A2(
						$Fresheyeball$elm_return$Return$map,
						$author$project$TimesheetPage$Update$resetMobileDeviceTab,
						$Fresheyeball$elm_return$Return$singleton(
							A2(
								$author$project$TimesheetPage$Update$selectFee,
								feeToSelect,
								_Utils_update(
									model,
									{gX: $author$project$Components$SearchInput$Model$Closed})))));
			case 33:
				var currentFee = msg.a;
				var direction = msg.b;
				var feeToBeSelected = A4($author$project$Timesheet$FeeLogic$getNextFee, zone, currentFee, model.aY, direction);
				var focusCmd = function () {
					var _v54 = _Utils_Tuple2(feeToBeSelected, direction);
					if (_v54.a.$ === 1) {
						if (_v54.b === 1) {
							var _v55 = _v54.a;
							var _v56 = _v54.b;
							return $elm$core$Platform$Cmd$none;
						} else {
							var _v57 = _v54.a;
							var _v58 = _v54.b;
							return $author$project$TimesheetPage$Update$focusOn('load-more-fees-link');
						}
					} else {
						var selectedFee = _v54.a.a;
						return $author$project$Timesheet$FeeLogic$isEditable(selectedFee) ? $author$project$TimesheetPage$Update$focusOnFeeEntryDescription : $author$project$TimesheetPage$Update$focusOn('hidden-fee-type-selector');
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$TimesheetPage$Update$scrollSelectedFeeIdIntoView,
					A2(
						$Fresheyeball$elm_return$Return$command,
						focusCmd,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									aY: A2($author$project$Timesheet$FeeLogic$maybeSelectFee, feeToBeSelected, model.aY)
								}))));
			case 27:
				return $Fresheyeball$elm_return$Return$singleton(
					A2($author$project$TimesheetPage$Update$closeFee, zone, model));
			case 6:
				var tab = msg.a;
				var updatedModel = _Utils_update(
					model,
					{h6: tab});
				switch (tab) {
					case 0:
						return $Fresheyeball$elm_return$Return$singleton(updatedModel);
					case 1:
						return A2(
							$Fresheyeball$elm_return$Return$command,
							$author$project$TimesheetPage$Update$activityFeedCommand(
								$author$project$Activities$Messages$SetActivityFeedMode(0)),
							$Fresheyeball$elm_return$Return$singleton(updatedModel));
					default:
						return $Fresheyeball$elm_return$Return$singleton(updatedModel);
				}
			case 35:
				var groupByKey = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					A2($author$project$TimesheetPage$Update$expandConversation, groupByKey, model));
			case 34:
				var groupByKey = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					A2(
						$author$project$TimesheetPage$Update$closeFee,
						zone,
						A2($author$project$TimesheetPage$Update$collapseConversation, groupByKey, model)));
			case 46:
				var fees = model.aY;
				var feesLoading = _Utils_update(
					fees,
					{dE: 0});
				return A2(
					$Fresheyeball$elm_return$Return$effect_,
					$author$project$TimesheetPage$Update$fetchMoreFeesCmd,
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{aY: feesLoading})));
			case 54:
				var feeFilterState = msg.a;
				var newFilterState = _Utils_eq(feeFilterState, model.g$.g9) ? $author$project$FeeFilter$Off : feeFilterState;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$FilterEvent(newFilterState)),
					A2(
						$Fresheyeball$elm_return$Return$effect_,
						$author$project$TimesheetPage$Update$fetchFeesCmd,
						$Fresheyeball$elm_return$Return$singleton(
							A2($author$project$TimesheetPage$Update$setFeeFilterState, newFilterState, model))));
			case 55:
				var showPosted = msg.a;
				var user = model.jS;
				var updatedUser = _Utils_update(
					user,
					{i7: showPosted});
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$FilterPostedEvent(showPosted)),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$Timesheet$Requests$setShowPostedEntries, model.gr, showPosted),
						$Fresheyeball$elm_return$Return$singleton(
							A2(
								$author$project$TimesheetPage$Update$setFeeFilterState,
								$author$project$FeeFilter$Off,
								_Utils_update(
									model,
									{jS: updatedUser})))));
			case 56:
				if (!msg.a.$) {
					var _v60 = msg.a.a;
					var cmd = function () {
						if (model.jS.i7) {
							return $author$project$TimesheetPage$Update$fetchFeesCmd;
						} else {
							var feeCount = $elm$core$List$length(
								$rtfeldman$elm_sorter_experiment$Sort$Dict$values(
									A2($author$project$Timesheet$FeeLogic$filterFees, $author$project$Timesheet$FeeLogic$isNotPosted, model.aY.$7)));
							return (feeCount < 10) ? $author$project$TimesheetPage$Update$fetchFeesCmd : $elm$core$Basics$always($elm$core$Platform$Cmd$none);
						}
					}();
					return A2(
						$Fresheyeball$elm_return$Return$effect_,
						cmd,
						$Fresheyeball$elm_return$Return$singleton(model));
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 57:
				var feeSearchMode = msg.a;
				return A2($author$project$TimesheetPage$Update$resetFeeSearch, model, feeSearchMode);
			case 58:
				var groupByMode = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEventFor(
						$author$project$Ports$EventTracking$GroupByEvent(groupByMode)),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								g$: A2($author$project$Timesheet$FeeSearchConfigurationLogic$setFeeSearchGroupByFilterMode, groupByMode, model.g$)
							})));
			case 95:
				return $Fresheyeball$elm_return$Return$singleton(model);
			case 59:
				return A2(
					$Fresheyeball$elm_return$Return$effect_,
					$author$project$TimesheetPage$Update$fetchFeeCountsCmd,
					A2(
						$Fresheyeball$elm_return$Return$effect_,
						$author$project$TimesheetPage$Update$fetchFeesCmd,
						$Fresheyeball$elm_return$Return$singleton(model)));
			case 60:
				if (msg.a === '') {
					var fees = model.aY;
					var feesLoading = _Utils_update(
						fees,
						{
							$7: $rtfeldman$elm_sorter_experiment$Sort$Dict$empty($author$project$CoreX$Sorter$reverseInt),
							dE: 0
						});
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$TimesheetPage$Update$queueSearchFeesCmd,
						$Fresheyeball$elm_return$Return$singleton(
							A2(
								$author$project$TimesheetPage$Update$setFeeSearchForDate,
								$elm$core$Maybe$Nothing,
								_Utils_update(
									model,
									{aY: feesLoading}))));
				} else {
					var filterDateString = msg.a;
					var feesForDate = $author$project$TimesheetPage$Update$convertDateIsoToDate(filterDateString);
					var fees = model.aY;
					var feesLoading = _Utils_update(
						fees,
						{
							$7: $rtfeldman$elm_sorter_experiment$Sort$Dict$empty($author$project$CoreX$Sorter$reverseInt),
							dE: 0
						});
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$TimesheetPage$Update$queueSearchFeesCmd,
						$Fresheyeball$elm_return$Return$singleton(
							A2(
								$author$project$TimesheetPage$Update$setFeeSearchForDate,
								feesForDate,
								_Utils_update(
									model,
									{aY: feesLoading}))));
				}
			case 61:
				var text = msg.a;
				var cmd = ($elm$core$String$length(text) === 1) ? $elm$core$Platform$Cmd$none : $author$project$TimesheetPage$Update$queueSearchFeesCmd;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					cmd,
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$TimesheetPage$Update$setFeeSearchTerm,
							$elm$core$Maybe$Just(text),
							model)));
			case 62:
				var text = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$TimesheetPage$Update$queueSearchFeesCmd,
					A2(
						$Fresheyeball$elm_return$Return$map,
						$author$project$TimesheetPage$Update$setFeeSearchTerm(
							$elm$core$Maybe$Just(text)),
						A2($author$project$TimesheetPage$Update$resetFeeSearch, model, 0)));
			case 63:
				var subMsg = msg.a;
				var _v61 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, model.g$.c8);
				var debouncedModel = _v61.a;
				var subCmd = _v61.b;
				var maybeEmittedMsg = _v61.c;
				var applyEmittedMsg = function () {
					if (!maybeEmittedMsg.$) {
						var emittedMsg = maybeEmittedMsg.a;
						return A2($author$project$TimesheetPage$Update$innerUpdate, zone, emittedMsg);
					} else {
						return $Fresheyeball$elm_return$Return$singleton;
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					applyEmittedMsg,
					A3(
						$Fresheyeball$elm_return$Return$mapBoth,
						$author$project$TimesheetPage$Messages$QueueSearchFees,
						$author$project$TimesheetPage$Update$setFeeSearchDebouncer(model),
						A2($Fresheyeball$elm_return$Return$return, debouncedModel, subCmd)));
			case 100:
				var errStr = msg.a;
				return A2(
					$author$project$FlashMessageLogic$addFromResponse,
					model,
					$elm$json$Json$Decode$errorToString(errStr));
			case 28:
				var matterId = msg.a;
				var sendRequestCmd = A2($author$project$Timesheet$Requests$queueAllPostableFeesForMatter, model.gr, matterId);
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent('Posted All For Matter'),
					A2($Fresheyeball$elm_return$Return$return, model, sendRequestCmd));
			case 29:
				if (!msg.a.$) {
					var _v63 = msg.a.a;
					var response = _v63.b;
					return A2($author$project$FlashMessageLogic$addFromResponse, model, response);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 103:
				var id = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$Scroll$scrollIntoView(id),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 41:
				var subMsg = msg.a;
				var _v64 = model.a4;
				if (!_v64.$) {
					var mergeFees = _v64.a;
					var _v65 = A2($author$project$Components$MergeFees$Update$update, subMsg, mergeFees);
					var updatedMergeFees = _v65.a;
					var cmd = _v65.b;
					return A2(
						$Fresheyeball$elm_return$Return$command,
						cmd,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									a4: $author$project$Components$MergeFees$Model$Open(updatedMergeFees)
								})));
				} else {
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 42:
				var activityIds = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					A2($author$project$Timesheet$ConsolidateUpdateLogic$deselectActivitiesForMerge, activityIds, model));
			case 37:
				var consolidateState = msg.a;
				var feeId = msg.b;
				return $Fresheyeball$elm_return$Return$singleton(
					A3(
						$author$project$Timesheet$ConsolidateUpdateLogic$updateFeesForMerge,
						$elm$core$List$singleton(feeId),
						consolidateState,
						model));
			case 38:
				var confirmationRequired = msg.a;
				var consolidateState = msg.b;
				var feeIds = msg.c;
				var origFeeIds = function () {
					if (!confirmationRequired) {
						return model.aY.gj;
					} else {
						return $elm$core$Set$empty;
					}
				}();
				var updatedFees = A2(
					$author$project$Timesheet$ConsolidateUpdateLogic$updateConsolidatedFeeIds,
					model.aY,
					A3(
						$mgold$elm_nonempty_list$List$Nonempty$foldl,
						$author$project$Timesheet$ConsolidateUpdateLogic$setConsolidatedFeeId(consolidateState),
						origFeeIds,
						feeIds));
				var cmd = function () {
					if (!confirmationRequired) {
						return $elm$core$Platform$Cmd$none;
					} else {
						return $author$project$Utils$send(
							$author$project$TimesheetPage$Messages$Consolidate(confirmationRequired));
					}
				}();
				return A2(
					$Fresheyeball$elm_return$Return$command,
					cmd,
					$Fresheyeball$elm_return$Return$singleton(
						$author$project$Timesheet$ConsolidateUpdateLogic$setMergeFees(
							_Utils_update(
								model,
								{aY: updatedFees}))));
			case 39:
				var consolidateState = msg.a;
				var activityId = msg.b;
				return $Fresheyeball$elm_return$Return$singleton(
					A3(
						$author$project$Timesheet$ConsolidateUpdateLogic$updateActivitiesForMerge,
						$elm$core$Set$singleton(activityId),
						consolidateState,
						model));
			case 40:
				var consolidateState = msg.a;
				var activityIds = msg.b;
				return $Fresheyeball$elm_return$Return$singleton(
					A3($author$project$Timesheet$ConsolidateUpdateLogic$updateActivitiesForMerge, activityIds, consolidateState, model));
			case 43:
				var confirmationRequired = msg.a;
				var feeIds = $elm$core$Set$toList(model.aY.gj);
				var _v68 = _Utils_Tuple2(
					A2($author$project$Timesheet$FeeLogic$haveSameMatter, feeIds, model.aY),
					model.jS.cI.hh);
				if ((!_v68.a) && (!_v68.b)) {
					return $Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								h7: $author$project$Components$Modal$Model$UiInfoAlertModal($author$project$Components$UiInfoAlerts$Data$feeMergingAlert)
							}));
				} else {
					return A2($author$project$TimesheetPage$Update$consolidateFees, confirmationRequired, model);
				}
			case 44:
				var deconsolidatedFeeId = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2($author$project$Timesheet$Requests$deconsolidate, deconsolidatedFeeId, model.gr),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 45:
				var feeId = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2($author$project$Timesheet$Requests$deconsolidateAll, feeId, model.gr),
					$Fresheyeball$elm_return$Return$singleton(model));
			case 92:
				var state = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{h7: state}));
			case 91:
				var state = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{ht: state}));
			case 1:
				var user = model.jS;
				var isCollapsed = !model.jS.gg;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2($author$project$Activities$Requests$collapseActivityFeed, model.gr, isCollapsed),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								jS: _Utils_update(
									user,
									{gg: isCollapsed})
							})));
			case 107:
				return $Fresheyeball$elm_return$Return$singleton(model);
			case 2:
				var activityTourCompleted = model.jS.cI.hi;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Ports$EventTracking$trackEvent('Activated Activity Feed'),
					A2(
						$Fresheyeball$elm_return$Return$command,
						A2($author$project$Activities$Requests$activateTrackActivities, model.gr, activityTourCompleted),
						$Fresheyeball$elm_return$Return$singleton(model)));
			case 3:
				if (!msg.b.$) {
					var hasCompletedActivityReviewTour = msg.a;
					var _v69 = msg.b.a;
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Ports$TourTriggers$startActivityReviewTour(hasCompletedActivityReviewTour),
						$Fresheyeball$elm_return$Return$singleton(
							$author$project$TimesheetPage$Data$activateTrackActivities(model)));
				} else {
					var response = msg.b.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 106:
				return $author$project$Timesheet$FeeLogic$hasSelected(model.aY) ? $Fresheyeball$elm_return$Return$singleton(
					A2($author$project$TimesheetPage$Update$closeFee, zone, model)) : $Fresheyeball$elm_return$Return$singleton(model);
			case 5:
				if (!msg.a.$) {
					var _v70 = msg.a.a;
					var response = _v70.b;
					return A2($author$project$FlashMessageLogic$addFromResponse, model, response);
				} else {
					var response = msg.a.a;
					return A2($author$project$FlashMessageLogic$addFromError, model, response);
				}
			case 90:
				var integrationType = msg.a;
				var status = msg.b;
				var integrationStatuses = function () {
					switch (integrationType) {
						case 0:
							return A2($author$project$Model$IntegrationStatuses$updatePMSStatus, status, model.hu);
						case 2:
							return A2($author$project$Model$IntegrationStatuses$updatePhoneStatus, status, model.hu);
						case 1:
							return A2($author$project$Model$IntegrationStatuses$updateExchangeStatus, status, model.hu);
						default:
							return A2($author$project$Model$IntegrationStatuses$updateBrowserExtensionStatus, status, model.hu);
					}
				}();
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{hu: integrationStatuses}));
			case 108:
				var status = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							gx: A3($author$project$BudgetBar$Data$Model, status, model.gx.gy, model.gx.io)
						}));
			case 109:
				var switchUi = function (ui) {
					if (!ui) {
						return 1;
					} else {
						return 0;
					}
				};
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							gx: A3(
								$author$project$BudgetBar$Data$Model,
								model.gx.ha,
								switchUi(model.gx.gy),
								model.gx.io)
						}));
			case 36:
				return $Fresheyeball$elm_return$Return$singleton(
					$author$project$TimesheetPage$Update$resetSelectedForMerge(model));
			case 9:
				var matter = msg.a;
				var _v73 = matter.iU ? _Utils_Tuple2(
					model.iP,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (ms) {
							return A2($author$project$MatterLogic$updateMatterList, ms, matter);
						},
						model.eI)) : _Utils_Tuple2(
					A2($author$project$MatterLogic$updateMatterList, model.iP, matter),
					model.eI);
				var recentMatters = _v73.a;
				var recentRestrictedMatters = _v73.b;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{iP: recentMatters, eI: recentRestrictedMatters}));
			default:
				return $Fresheyeball$elm_return$Return$singleton(model);
		}
	});
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$TimesheetPage$Update$reloadPageWhen = function (reloadRequired) {
	return reloadRequired ? $elm$browser$Browser$Navigation$reload : $elm$core$Platform$Cmd$none;
};
var $author$project$TimesheetPage$Update$update = F2(
	function (msg, contextualModel) {
		var model = contextualModel.a6;
		var currentTime = contextualModel.gw;
		var timeZone = contextualModel.jy;
		var announcementMsgReceivedAt = contextualModel.fM;
		var frontendVersion = contextualModel.hd;
		var _v0 = function () {
			switch (msg.$) {
				case 85:
					var time = msg.a;
					return $Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							contextualModel,
							{gw: time}));
				case 86:
					return $Fresheyeball$elm_return$Return$singleton(contextualModel);
				case 99:
					var newTimeZone = msg.a;
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$TimesheetPage$Update$getCurrentRataDieCommand,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								contextualModel,
								{jy: newTimeZone})));
				case 101:
					var expiryTime = function () {
						var connectionTimeoutInMs = 70 * 1000;
						var announcedInMs = $elm$time$Time$posixToMillis(announcementMsgReceivedAt);
						return $elm$time$Time$millisToPosix(announcedInMs + connectionTimeoutInMs);
					}();
					var isExpired = A2($author$project$CoreX$DateCompare$isLaterThan, expiryTime, currentTime);
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$TimesheetPage$Update$reloadPageWhen(isExpired),
						$Fresheyeball$elm_return$Return$singleton(contextualModel));
				case 102:
					var version = msg.a;
					var versionMismatch = !_Utils_eq(version, frontendVersion);
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$TimesheetPage$Update$reloadPageWhen(versionMismatch),
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								contextualModel,
								{fM: currentTime})));
				default:
					return $Fresheyeball$elm_return$Return$singleton(contextualModel);
			}
		}();
		var newContextualModel = _v0.a;
		var newContextualCmds = _v0.b;
		var _v2 = function () {
			var _v3 = A3($author$project$TimesheetPage$Update$innerUpdate, timeZone, msg, model);
			var updatedModel = _v3.a;
			var cmds = _v3.b;
			return _Utils_Tuple2(updatedModel, cmds);
		}();
		var newModel = _v2.a;
		var newCmds = _v2.b;
		return A2(
			$Fresheyeball$elm_return$Return$command,
			newContextualCmds,
			A2(
				$Fresheyeball$elm_return$Return$command,
				newCmds,
				$Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						newContextualModel,
						{a6: newModel}))));
	});
var $author$project$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				return A2($author$project$Initialisation$Update$update, subMsg, model);
			case 1:
				var headerMsg = msg.a;
				var _v1 = A2($author$project$Components$Header$Update$update, headerMsg, model.hl);
				var newHeader = _v1.a;
				var cmd = _v1.b;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					A2($elm$core$Platform$Cmd$map, $author$project$Messages$HeaderMsg, cmd),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{hl: newHeader})));
			case 4:
				var matters = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					A2(
						$author$project$Update$setRecentMatters,
						A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, matters),
						model));
			case 3:
				if (!msg.a.$) {
					var _v2 = msg.a;
					var filingStatus = _v2.a;
					var fileNoteResource = _v2.b;
					var _v3 = model.jS;
					if (_v3.$ === 3) {
						var user = _v3.a;
						var initModel = A7(
							$author$project$Components$FileNotes$Model$init,
							$author$project$Messages$FileNoteMsg,
							$author$project$Messages$ModalMsg(0),
							model.gr,
							user,
							_List_Nil,
							fileNoteResource,
							filingStatus);
						var _v4 = A2(
							$author$project$Components$FileNotes$Update$update,
							A2($author$project$Components$FileNotes$Messages$Open, filingStatus, fileNoteResource),
							initModel);
						var updatedFileNoteModel = _v4.a;
						var cmd = _v4.b;
						return A2(
							$Fresheyeball$elm_return$Return$command,
							$author$project$Components$MatterInput$Requests$fetchRecentMatters($author$project$Messages$RecentMattersFetched),
							A2(
								$Fresheyeball$elm_return$Return$command,
								cmd,
								$Fresheyeball$elm_return$Return$singleton(
									_Utils_update(
										model,
										{
											h7: $author$project$Components$Modal$Model$FileNotesModal(updatedFileNoteModel)
										}))));
					} else {
						return $Fresheyeball$elm_return$Return$singleton(model);
					}
				} else {
					var subMsg = msg.a;
					var _v5 = model.jS;
					if (_v5.$ === 3) {
						var _v6 = model.h7;
						if (_v6.$ === 1) {
							var fileNoteModel = _v6.a;
							var _v7 = A2($author$project$Components$FileNotes$Update$update, subMsg, fileNoteModel);
							var updatedFileNoteModel = _v7.a;
							var cmd = _v7.b;
							return A2(
								$Fresheyeball$elm_return$Return$command,
								cmd,
								$Fresheyeball$elm_return$Return$singleton(
									_Utils_update(
										model,
										{
											h7: $author$project$Components$Modal$Model$FileNotesModal(updatedFileNoteModel)
										})));
						} else {
							return $Fresheyeball$elm_return$Return$singleton(model);
						}
					} else {
						return $Fresheyeball$elm_return$Return$singleton(model);
					}
				}
			case 5:
				var _v8 = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{h7: $author$project$Components$Modal$Model$ClosedModal}));
			case 6:
				var subMsg = msg.a;
				var _v9 = model.iC;
				if (!_v9.$) {
					var contextualModel = _v9.a;
					var _v10 = A2($author$project$TimesheetPage$Update$update, subMsg, contextualModel);
					var updatedContextualModel = _v10.a;
					var cmd = _v10.b;
					return A2(
						$Fresheyeball$elm_return$Return$mapCmd,
						$author$project$Messages$PageMsg,
						A2(
							$Fresheyeball$elm_return$Return$command,
							cmd,
							$Fresheyeball$elm_return$Return$singleton(
								A2(
									$author$project$Update$applyPage,
									$author$project$Page$Timesheet(updatedContextualModel),
									model))));
				} else {
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 7:
				return _Utils_Tuple2(
					model,
					$elm$http$Http$get(
						{
							z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$Messages$NewsResponse, $author$project$Update$newsResponseDecoder),
							jR: '/api/token'
						}));
			case 8:
				if (!msg.a.$) {
					var _v11 = msg.a.a;
					var token = _v11.b;
					return _Utils_Tuple2(
						model,
						$author$project$Ports$OpenNewTab$openNewTab(model.b5 + ('?token=' + (token + ('&region=' + model.ci)))));
				} else {
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 9:
				return _Utils_Tuple2(
					model,
					$elm$http$Http$get(
						{
							z: A2($jzxhuang$http_extras$Http$Detailed$expectJson, $author$project$Messages$HelpResponse, $author$project$Update$newsResponseDecoder),
							jR: '/api/token'
						}));
			case 10:
				if (!msg.a.$) {
					var _v12 = msg.a.a;
					var token = _v12.b;
					return _Utils_Tuple2(
						model,
						$author$project$Ports$OpenNewTab$openNewTab(model.bM + ('?token=' + (token + ('&region=' + model.ci)))));
				} else {
					return $Fresheyeball$elm_return$Return$singleton(model);
				}
			case 11:
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$LoggedOutPage$Requests$logOut(model.gr),
					$Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$Update$applyPage,
							$author$project$Page$LogOut('See you again'),
							model)));
			case 12:
				if (!msg.a.$) {
					var _v13 = msg.a.a;
					var resp = _v13.b;
					var _v14 = $author$project$LoggedOutPage$Data$logOutDecoder(resp);
					if (!_v14.$) {
						var path = _v14.a;
						return A2(
							$Fresheyeball$elm_return$Return$command,
							A2(
								$author$project$Update$delay,
								1,
								$author$project$Messages$LoadPage(path)),
							$Fresheyeball$elm_return$Return$singleton(model));
					} else {
						return $Fresheyeball$elm_return$Return$singleton(
							A2(
								$author$project$Update$applyPage,
								A2($author$project$Page$SessionError, 'Please refresh this page', 'Mitimes needs to be reloaded.'),
								model));
					}
				} else {
					var error = msg.a.a;
					return $Fresheyeball$elm_return$Return$singleton(
						A2(
							$author$project$Update$applyPage,
							A2(
								$author$project$Page$SessionError,
								'Please refresh this page',
								$author$project$ErrorLogic$getMessage(error)),
							model));
				}
			case 13:
				var path = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$elm$browser$Browser$Navigation$load(path),
					$Fresheyeball$elm_return$Return$singleton(model));
			default:
				if ((msg.a.$ === 3) && (msg.a.a.$ === 1)) {
					var response = msg.a.a.a;
					return A2(
						$Fresheyeball$elm_return$Return$mapCmd,
						$author$project$Messages$PageMsg,
						A2(
							$Fresheyeball$elm_return$Return$command,
							$author$project$Activities$Update$setFlashResponseCmd(response),
							$Fresheyeball$elm_return$Return$singleton(model)));
				} else {
					var updateMsg = msg.a;
					var resetNotificationModal = function () {
						var _v16 = model.h7;
						if (!_v16.$) {
							return $author$project$Components$Modal$Model$ClosedModal;
						} else {
							return model.h7;
						}
					}();
					var notificationModel = {c5: model.c5, gr: model.gr, im: model.im};
					var isModal = function (n) {
						return (n.jN === 1) || (n.jN === 2);
					};
					var _v15 = A2($author$project$Components$Notifications$Update$update, updateMsg, notificationModel);
					var updatedModel = _v15.a;
					var cmd = _v15.b;
					var modal = A2(
						$elm$core$Maybe$withDefault,
						resetNotificationModal,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Modal$Model$NotificationsModal,
							$elm$core$List$head(
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									_List_Nil,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.$9;
											},
											$elm$core$List$filter(isModal)),
										updatedModel.im)))));
					return A2(
						$Fresheyeball$elm_return$Return$command,
						A2($elm$core$Platform$Cmd$map, $author$project$Messages$NotificationMsg, cmd),
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{h7: modal, im: updatedModel.im})));
				}
		}
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$View$isHeaderOnly = function (appModel) {
	var _v0 = appModel.iC;
	_v0$2:
	while (true) {
		switch (_v0.$) {
			case 2:
				if (!_v0.a) {
					return true;
				} else {
					break _v0$2;
				}
			case 1:
				return true;
			default:
				break _v0$2;
		}
	}
	return false;
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Components$Notifications$Messages$AcknowledgeNotification = function (a) {
	return {$: 2, a: a};
};
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$version = _VirtualDom_attribute('version');
var $author$project$Icons$CloseCross$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('cross-copy-3'),
								$elm$svg$Svg$Attributes$transform('translate(-36.000000, -36.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('close-cross'),
										$elm$svg$Svg$Attributes$transform('translate(38.000000, 38.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M20,0 L0,20'),
												$elm$svg$Svg$Attributes$id('Path-2')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M0,0 L20,20'),
												$elm$svg$Svg$Attributes$id('Path-1')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Components$Notifications$View$renderCloseButton = F2(
	function (id, closeable) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-1 self-center')
				]),
			closeable ? _List_fromArray(
				[
					$author$project$Icons$CloseCross$viewWithAttributes(
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Messages$NotificationMsg(
								$author$project$Components$Notifications$Messages$AcknowledgeNotification(id))),
							$elm$svg$Svg$Attributes$class('cursor-pointer w-3 stroke-current icon icon--close-cross')
						]))
				]) : _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-3')
						]),
					_List_Nil)
				]));
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Components$Notifications$View$renderLink = F4(
	function (cspNonce, color, link, linkText) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'nonce', cspNonce),
					$elm$html$Html$Attributes$class('cursor-pointer w-content underline mr-3 self-start'),
					A2($elm$html$Html$Attributes$style, 'color', color),
					$elm$html$Html$Attributes$href(link),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(linkText)
				]));
	});
var $author$project$Components$Notifications$View$renderLinkWithDefault = F4(
	function (cspNonce, color, link, linkText) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($elm$html$Html$div, _List_Nil, _List_Nil),
			A3(
				$elm$core$Maybe$map2,
				A2($author$project$Components$Notifications$View$renderLink, cspNonce, color),
				link,
				linkText));
	});
var $author$project$Components$Notifications$View$renderBanner = F2(
	function (cspNonce, notification) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'nonce', cspNonce),
					A2($elm$html$Html$Attributes$style, 'background-color', notification.fP),
					A2($elm$html$Html$Attributes$style, 'color', notification.jv),
					$elm$html$Html$Attributes$class('flex truncate-group justify-between px-3 py-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mr-2 whitespace-normal break-words')
						]),
					_List_fromArray(
						[
							A3(
							$elm$core$Basics$composeL,
							$elm$html$Html$text,
							$elm$core$Maybe$withDefault(''),
							notification.go)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex')
						]),
					_List_fromArray(
						[
							A4($author$project$Components$Notifications$View$renderLinkWithDefault, cspNonce, notification.jv, notification.hW, notification.hX),
							A2($author$project$Components$Notifications$View$renderCloseButton, notification.aC, notification.gf)
						]))
				]));
	});
var $author$project$Components$Notifications$View$renderNotification = F2(
	function (cspNonce, notification) {
		var _v0 = notification.jN;
		if (!_v0) {
			return A2($author$project$Components$Notifications$View$renderBanner, cspNonce, notification);
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden')
					]),
				_List_Nil);
		}
	});
var $author$project$Components$Notifications$View$view = function (model) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		A2($elm$html$Html$div, _List_Nil, _List_Nil),
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (_v0) {
				var notifications = _v0.$9;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Notifications$View$renderNotification(model.c5),
						notifications));
			},
			model.im));
};
var $author$project$View$renderNotifications = F3(
	function (notificationData, cspNonce, csrfToken) {
		return $author$project$Components$Notifications$View$view(
			{c5: cspNonce, gr: csrfToken, im: notificationData});
	});
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$TimesheetPage$Messages$NoOp = {$: 111};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$TimesheetPage$Messages$UndoAction = F3(
	function (a, b, c) {
		return {$: 110, a: a, b: b, c: c};
	});
var $author$project$Timesheet$Views$FlashMessage$undoAction = function (message) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('d-btn d-btn-link pl-8 no-underline'),
				$elm$html$Html$Events$onClick(
				A3($author$project$TimesheetPage$Messages$UndoAction, message.bo, message.bB, message.bA))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Undo')
			]));
};
var $author$project$Timesheet$Views$FlashMessage$flashMessageAction = function (message) {
	var _v0 = message.bo;
	if (!_v0) {
		return $author$project$Timesheet$Views$FlashMessage$undoAction(message);
	} else {
		return A2($elm$html$Html$span, _List_Nil, _List_Nil);
	}
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm_community$html_extra$Html$Events$Extra$onClickStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Timesheet$Views$FlashMessage$displayFlashMessage = function (flashMessage) {
	var message = flashMessage.eh;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-row items-center justify-center h-12 py-3'),
				$elm$html$Html$Attributes$class('text-center font-semibold'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'flash-messages'),
				$elm$html$Html$Attributes$title('Click to dismiss message'),
				$elm$html$Html$Events$onClick(
				$author$project$TimesheetPage$Messages$ClearFlashMessage(flashMessage))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-xs md:text-base truncate'),
						$elm$html$Html$Attributes$title(message),
						$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation($author$project$TimesheetPage$Messages$NoOp)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					])),
				$author$project$Timesheet$Views$FlashMessage$flashMessageAction(flashMessage),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cursor-pointer absolute right-0 mr-4'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'flash-message-close')
					]),
				_List_fromArray(
					[
						$author$project$Icons$CloseCross$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('mb-0 w-3 stroke-current text-white icon icon--close-cross')
							]))
					]))
			]));
};
var $author$project$Timesheet$Views$FlashMessage$displayAllFlashMessages = function (flashMessages) {
	var noMessages = $elm$core$List$isEmpty(flashMessages);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed z-50'),
				$elm$html$Html$Attributes$class(' bg-mt-purple-light text-white'),
				$elm$html$Html$Attributes$class('inset-x-0 bottom-0 transition-height duration-500'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('h-12', !noMessages),
						_Utils_Tuple2('h-0', noMessages)
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Timesheet$Views$FlashMessage$displayFlashMessage,
			$elm$core$List$reverse(flashMessages)));
};
var $author$project$TimesheetPage$Messages$CloseFee = {$: 27};
var $author$project$MobileDeviceTab$Dashboard = 2;
var $author$project$BudgetBar$View$ViewModel = F9(
	function (model, fees, mobileDashboardOn, dailyBudget, cspNonce, zone, minutesPerUnit, hasActivityFeedOnLeft, barConfig) {
		return {aw: barConfig, c5: cspNonce, aV: dailyBudget, aY: fees, am: hasActivityFeedOnLeft, ej: minutesPerUnit, ek: mobileDashboardOn, a6: model, fA: zone};
	});
var $author$project$FeeFilter$ExpiringToday = 1;
var $author$project$FeeFilter$Failed = 2;
var $author$project$FeeFilter$HasPendingMatter = 3;
var $author$project$FeeFilter$Incomplete = 0;
var $author$project$FeeFilter$On = function (a) {
	return {$: 0, a: a};
};
var $author$project$FeeFilter$OnHold = 4;
var $author$project$TimesheetPage$Messages$ToggleFeeFilterState = function (a) {
	return {$: 54, a: a};
};
var $author$project$Timesheet$Views$ActionBar$filterLink = F3(
	function (feeFilter, currentlySelected, ids) {
		var isActive = _Utils_eq(
			currentlySelected,
			$author$project$FeeFilter$On(feeFilter));
		var filterTextColour = function () {
			switch (feeFilter) {
				case 1:
					return 'text-mt-red-dark';
				case 2:
					return 'text-mt-red';
				case 0:
					return 'text-mt-grey-light';
				case 3:
					return 'text-mt-grey-darker';
				default:
					return 'text-black';
			}
		}();
		var filterText = $author$project$FeeFilter$feeFilterString(feeFilter);
		var filterBgColour = function () {
			switch (feeFilter) {
				case 1:
					return 'bg-mt-red-dark';
				case 2:
					return 'bg-mt-red';
				case 0:
					return 'bg-mt-grey-light';
				case 3:
					return 'bg-mt-grey-darker';
				default:
					return 'bg-black';
			}
		}();
		var count = $elm$core$Set$size(ids);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('#'),
						$elm$html$Html$Attributes$class('tooltip font-light hover:no-underline filter-hover'),
						$elm$html$Html$Attributes$class(filterTextColour),
						$elm$html$Html$Attributes$class('ml-3 lg:ml-5'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('active-filter text-decoration-white hover:bg-mt-blue-light active hover:no-underline', isActive)
							])),
						A2($elm$html$Html$Attributes$attribute, 'data-role', filterText + '-filter'),
						$elm$html$Html$Events$onClick(
						$author$project$TimesheetPage$Messages$ToggleFeeFilterState(
							$author$project$FeeFilter$On(feeFilter)))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('filter-selected')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(filterText)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-flex items-center justify-center h-4 px-1 rounded-full text-xs font-semibold text-white no-underline'),
										$elm$html$Html$Attributes$class(filterBgColour),
										A2($elm$html$Html$Attributes$attribute, 'data-role', filterText + '-count')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(count))
									]))
							]))
					]))
			]);
	});
var $author$project$TimesheetPage$Messages$SetGroupByMode = function (a) {
	return {$: 58, a: a};
};
var $author$project$Model$Timesheet$GroupByFilter$close = function (filterMode) {
	if (!filterMode.$) {
		var filter = filterMode.a;
		return $author$project$Model$Timesheet$GroupByFilter$Closed(filter);
	} else {
		return filterMode;
	}
};
var $author$project$Model$Timesheet$GroupByFilter$isFilterOn = F2(
	function (filter, filterMode) {
		return A3(
			$elm$core$Basics$composeR,
			$author$project$Model$Timesheet$GroupByFilter$getCurrentGrouping,
			$elm$core$Basics$eq(filter),
			filterMode);
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Model$Timesheet$GroupByFilter$setFilter = F2(
	function (filter, filterMode) {
		if (!filterMode.$) {
			return $author$project$Model$Timesheet$GroupByFilter$Closed(filter);
		} else {
			return $author$project$Model$Timesheet$GroupByFilter$Closed(filter);
		}
	});
var $author$project$Timesheet$Views$ActionBar$renderItem = F2(
	function (filter, groupByFilterMode) {
		var setter = $author$project$TimesheetPage$Messages$SetGroupByMode(
			A2($author$project$Model$Timesheet$GroupByFilter$setFilter, filter, groupByFilterMode));
		var itemText = $author$project$Model$Timesheet$GroupByFilter$filterText(filter);
		var dataRole = A2(
			$elm$core$String$append,
			'group-by-',
			A3(
				$elm$core$String$replace,
				' ',
				'-',
				$elm$core$String$toLower(itemText)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-2 px-4 text-left border-none hover:bg-mt-purple-lightest hover:text-mt-grey-darker hover:border-0'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'bg-mt-purple-lighter',
							A2($author$project$Model$Timesheet$GroupByFilter$isFilterOn, filter, groupByFilterMode))
						])),
					$elm$html$Html$Events$onClick(setter)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hover:no-underline text-black text-sm'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', dataRole),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'font-semibold',
									A2($author$project$Model$Timesheet$GroupByFilter$isFilterOn, filter, groupByFilterMode))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(itemText)
						]))
				]));
	});
var $author$project$Timesheet$Views$ActionBar$groupByDropdownMenu = function (groupByFilterMode) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute right-0 top-8 flex flex-col w-56'),
					$elm$html$Html$Attributes$class('z-30'),
					$elm$html$Html$Attributes$class('pt-4 pb-2'),
					$elm$html$Html$Attributes$class('border bg-white shadow-sm outline-hidden text-left'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'group-by-menu-items')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4 font-bold text-left mb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Group by')
						])),
					A2($author$project$Timesheet$Views$ActionBar$renderItem, 0, groupByFilterMode),
					A2($author$project$Timesheet$Views$ActionBar$renderItem, 1, groupByFilterMode)
				]))
		]);
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Model$Timesheet$GroupByFilter$isOpen = function (filterMode) {
	if (!filterMode.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Model$Timesheet$GroupByFilter$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Timesheet$GroupByFilter$toggleMode = function (filterMode) {
	if (!filterMode.$) {
		var filter = filterMode.a;
		return $author$project$Model$Timesheet$GroupByFilter$Closed(filter);
	} else {
		var filter = filterMode.a;
		return $author$project$Model$Timesheet$GroupByFilter$Open(filter);
	}
};
var $author$project$Timesheet$Views$ActionBar$menuButton = function (groupByFilterMode) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('leading-normal bg-transparent font-semibold p-1 border rounded-sm border-mt-purple text-xs text-mt-purple hover:border-mt-blue-light hover:text-mt-blue-light'),
				$elm$html$Html$Events$onClick(
				$author$project$TimesheetPage$Messages$SetGroupByMode(
					$author$project$Model$Timesheet$GroupByFilter$toggleMode(groupByFilterMode)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Group By: '),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-bold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Model$Timesheet$GroupByFilter$filterModeText(groupByFilterMode))
					]))
			]));
};
var $author$project$OnClickOutsideAfterFocus$invertDecoder = function (decoder) {
	var invertMaybe = function (maybe) {
		if (maybe.$ === 1) {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('');
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		invertMaybe,
		$elm$json$Json$Decode$maybe(decoder));
};
var $author$project$OnClickOutsideAfterFocus$succeedIfBloodlineHasId = function (targetId) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return _Utils_eq(id, targetId) ? $elm$json$Json$Decode$succeed(0) : A2(
				$elm$json$Json$Decode$field,
				'parentNode',
				$author$project$OnClickOutsideAfterFocus$succeedIfBloodlineHasId(targetId));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
};
var $author$project$OnClickOutsideAfterFocus$succeedIfClickIsOustideOfId = function (targetId) {
	return $author$project$OnClickOutsideAfterFocus$invertDecoder(
		A2(
			$elm$json$Json$Decode$field,
			'relatedTarget',
			$author$project$OnClickOutsideAfterFocus$succeedIfBloodlineHasId(targetId)));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$OnClickOutsideAfterFocus$withId = F2(
	function (id, onClickOutsideMsg) {
		var decodeFocusOut = A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$always(onClickOutsideMsg),
			$author$project$OnClickOutsideAfterFocus$succeedIfClickIsOustideOfId(id));
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$id(id),
				$elm$html$Html$Attributes$tabindex(-1),
				A2($elm$html$Html$Events$on, 'focusout', decodeFocusOut)
			]);
	});
var $author$project$Timesheet$Views$ActionBar$groupByFilter = function (groupByFilterMode) {
	var open = $author$project$Model$Timesheet$GroupByFilter$isOpen(groupByFilterMode);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			A2(
				$author$project$CoreX$Appendable$andAppend,
				A2(
					$author$project$OnClickOutsideAfterFocus$withId,
					'group-by-dropdown-menu',
					$author$project$TimesheetPage$Messages$SetGroupByMode(
						$author$project$Model$Timesheet$GroupByFilter$close(groupByFilterMode))),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative ml-3 lg:ml-5 outline-hidden cursor-pointer h-full w-full'),
						$elm$html$Html$Attributes$id('group-by-dropdown-menu'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'loaded-group-by-menu')
					])),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				open,
				$author$project$Timesheet$Views$ActionBar$groupByDropdownMenu(groupByFilterMode),
				_List_fromArray(
					[
						$author$project$Timesheet$Views$ActionBar$menuButton(groupByFilterMode)
					])))
		]);
};
var $author$project$TimesheetPage$Messages$NewEntryWithRunningTimer = {$: 52};
var $elm$svg$Svg$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$ellipse = $elm$svg$Svg$trustedNode('ellipse');
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $author$project$Icons$Timer$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 52 52'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('stroke-current group-hover:stroke-white fill-white group-hover:fill-mt-red-dark'),
						$elm$svg$Svg$Attributes$id('timer'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('timer-button'),
								$elm$svg$Svg$Attributes$transform('translate(-22.000000, -22.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('timer'),
										$elm$svg$Svg$Attributes$transform('translate(24.000000, 24.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$ellipse,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('face'),
												$elm$svg$Svg$Attributes$cx('24'),
												$elm$svg$Svg$Attributes$cy('25.5'),
												$elm$svg$Svg$Attributes$rx('12'),
												$elm$svg$Svg$Attributes$ry('11.5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M19,9 L29,9'),
												$elm$svg$Svg$Attributes$id('top')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M24,19 L24,25.5'),
												$elm$svg$Svg$Attributes$id('hand')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M34,14 L33,15'),
												$elm$svg$Svg$Attributes$id('stop')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$circle,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('oval'),
												$elm$svg$Svg$Attributes$fillOpacity('0'),
												$elm$svg$Svg$Attributes$fill('#fff'),
												$elm$svg$Svg$Attributes$cx('24'),
												$elm$svg$Svg$Attributes$cy('24'),
												$elm$svg$Svg$Attributes$r('24')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Timesheet$Views$ActionBar$newEntryButtons = F2(
	function (newEntryLoading, feeSearchMode) {
		var searchIsOpen = !feeSearchMode;
		var isReady = !newEntryLoading;
		var loadingGuarded = function (txt) {
			return isReady ? txt : 'Loading...';
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sm:ml-4 inline-block'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden sm:inline-block', searchIsOpen)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltip cursor-pointer'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'quick-timer-button'),
							A2($elm$html$Html$Attributes$attribute, 'data-tour', 'quick-timer-button')
						]),
					_List_fromArray(
						[
							$author$project$Icons$Timer$viewWithAttributes(
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								isReady,
								_List_fromArray(
									[
										$elm$svg$Svg$Events$onClick($author$project$TimesheetPage$Messages$NewEntryWithRunningTimer)
									]),
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('w-7 h-7 relative top-9px stroke-current text-mt-purple hover:text-mt-blue-light icon icon--timer')
									]))),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext mt-11 w-20 shadow-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									loadingGuarded('Quick Timer'))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltip ml-1 xs:ml-3 cursor-pointer'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'new-entry-button'),
							A2($elm$html$Html$Attributes$attribute, 'data-tour', 'new-entry-button')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								isReady,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$NewEntry)
									]),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('leading-normal bg-transparent font-semibold p-1 border rounded-sm border-mt-purple text-xs text-mt-purple hover:border-mt-blue-light hover:text-mt-blue-light')
									])),
							_List_fromArray(
								[
									$elm$html$Html$text('New Entry')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext mt-11 w-21 shadow-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									loadingGuarded('Alt + N'))
								]))
						]))
				]));
	});
var $author$project$TimesheetPage$Messages$SetShowPostedEntries = function (a) {
	return {$: 55, a: a};
};
var $author$project$Timesheet$Views$ActionBar$showPostedEntriesLink = function (showPostedEntries) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('#'),
					$elm$html$Html$Attributes$title('Show posted entries in fee list'),
					$elm$html$Html$Attributes$class('font-light ml-3 hover:no-underline filter-hover'),
					$elm$html$Html$Attributes$class('lg:ml-5'),
					$elm$html$Html$Attributes$class('text-mt-green-dark'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active-filter text-decoration-white hover:bg-mt-green-light active hover:no-underline', showPostedEntries)
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'show-posted-entries-filter'),
					$elm$html$Html$Events$onClick(
					$author$project$TimesheetPage$Messages$SetShowPostedEntries(!showPostedEntries))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filter-selected')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('posted')
						]))
				]))
		]);
};
var $author$project$Timesheet$Views$ActionBar$actionBarView = F2(
	function (showPostedEntries, _v0) {
		var searchMode = _v0.i1;
		var newEntryLoading = _v0.ep;
		var filterCounts = _v0.dI;
		var feeCountsLoading = _v0.dB;
		var filterState = _v0.g9;
		var groupByFilterMode = _v0.dT;
		var showPostedEntriesFilter = (!_Utils_eq(filterState, $author$project$FeeFilter$Off)) ? $author$project$Timesheet$Views$ActionBar$showPostedEntriesLink(false) : $author$project$Timesheet$Views$ActionBar$showPostedEntriesLink(showPostedEntries);
		var _v1 = filterCounts;
		var failed = _v1.dx;
		var expiring = _v1.du;
		var incomplete = _v1.d$;
		var pending = _v1.ez;
		var onHold = _v1.ip;
		var expiringFilterVisible = ($elm$core$Set$size(expiring) > 0) || _Utils_eq(
			filterState,
			$author$project$FeeFilter$On(1));
		var expiringTodayFilter = A3($author$project$Timesheet$Views$ActionBar$filterLink, 1, filterState, expiring);
		var failedFilter = A3($author$project$Timesheet$Views$ActionBar$filterLink, 2, filterState, failed);
		var failedFilterVisible = ($elm$core$Set$size(failed) > 0) || _Utils_eq(
			filterState,
			$author$project$FeeFilter$On(2));
		var incompleteFilter = A3($author$project$Timesheet$Views$ActionBar$filterLink, 0, filterState, incomplete);
		var onHoldFilter = A3($author$project$Timesheet$Views$ActionBar$filterLink, 4, filterState, onHold);
		var onHoldFilterVisible = ($elm$core$Set$size(onHold) > 0) || _Utils_eq(
			filterState,
			$author$project$FeeFilter$On(4));
		var pendingFilter = A3($author$project$Timesheet$Views$ActionBar$filterLink, 3, filterState, pending);
		var pendingFilterVisible = ($elm$core$Set$size(pending) > 0) || _Utils_eq(
			filterState,
			$author$project$FeeFilter$On(3));
		var filterLinks = A2(
			$author$project$CoreX$Appendable$andAppend,
			$author$project$Timesheet$Views$ActionBar$groupByFilter(groupByFilterMode),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				showPostedEntriesFilter,
				A2(
					$author$project$CoreX$Appendable$andAppend,
					incompleteFilter,
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						pendingFilterVisible,
						pendingFilter,
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							expiringFilterVisible,
							expiringTodayFilter,
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								failedFilterVisible,
								failedFilter,
								A3($author$project$CoreX$Appendable$andAppendIf, onHoldFilterVisible, onHoldFilter, _List_Nil)))))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-12 text-mt-grey-darker my-auto pr-4 mr-4'),
					$elm$html$Html$Attributes$class('grow'),
					$elm$html$Html$Attributes$class('text-right'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'timesheet-action-bar')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('desktop inline-block')
						]),
					feeCountsLoading ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Loading timesheet filters...')
								]))
						]) : filterLinks),
					A2($author$project$Timesheet$Views$ActionBar$newEntryButtons, newEntryLoading, searchMode)
				]));
	});
var $author$project$MobileDeviceTab$ActivityFeed = 1;
var $author$project$TimesheetPage$Messages$ActivateTrackActivities = {$: 2};
var $author$project$TimesheetPage$Messages$ToggleActivityFeed = {$: 1};
var $author$project$ActivityFeedLogic$modeToString = function (mode) {
	if (!mode) {
		return 'active';
	} else {
		return 'inactive';
	}
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Activities$View$keyedAs = F2(
	function (key, view) {
		return _Utils_Tuple2(key, view);
	});
var $author$project$Activities$Messages$NextActivityPage = {$: 33};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Activities$View$loadMoreButton = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('block w-64 mx-auto border rounded-full bg-mt-blue-lighter border-mt-blue-lighter hover:bg-mt-blue-light hover:border-mt-blue-light text-white'),
			$elm$html$Html$Attributes$type_('button'),
			A2($elm$html$Html$Attributes$attribute, 'data-role', 'load-more-activities'),
			$elm$html$Html$Events$onClick(
			$author$project$TimesheetPage$Messages$ActivityFeedComponent($author$project$Activities$Messages$NextActivityPage))
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Load more')
		]));
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Icons$LoadingPendulum$view = A2(
	$elm$core$List$repeat,
	6,
	A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pendulum')
			]),
		_List_Nil));
var $author$project$Activities$View$moreLinkRow = function (_v0) {
	var activities = _v0.fF;
	var activitiesLoading = _v0.cP;
	var hasActivityFeedOnLeft = _v0.am;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-between border-mt-blue w-full'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('no-border-l', !hasActivityFeedOnLeft),
						_Utils_Tuple2('no-border-r', hasActivityFeedOnLeft)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mx-auto h-12 mt-6 mb-6 lg:mb-3')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = _Utils_Tuple2(activities, activitiesLoading);
						switch (_v1.b) {
							case 0:
								var _v3 = _v1.b;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-36 mx-auto')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('float-left relative transform scale-50')
												]),
											$author$project$Icons$LoadingPendulum$view),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-right')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Loading activities...')
												]))
										]));
							case 2:
								if (!_v1.a.b) {
									var _v2 = _v1.b;
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'data-role', 'no-load-more-activities-link'),
												$elm$html$Html$Attributes$class('hidden')
											]),
										_List_Nil);
								} else {
									var _v4 = _v1.b;
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('End of activities')
											]));
								}
							default:
								var _v5 = _v1.b;
								return $author$project$Activities$View$loadMoreButton;
						}
					}()
					]))
			]));
};
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Activities$View$messageRow = function (message) {
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('p-3 text-grey')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$em,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]))
					]))
			]));
};
var $author$project$Activities$View$noActivitiesMessage = function (_v0) {
	var activities = _v0.fF;
	var searchTerms = _v0.eX;
	var activitiesLoading = _v0.cP;
	var _v1 = _Utils_Tuple3(activities, searchTerms, activitiesLoading);
	if ((!_v1.a.b) && (_v1.c === 2)) {
		if (_v1.b.$ === 1) {
			var _v2 = _v1.b;
			var _v3 = _v1.c;
			return _List_fromArray(
				[
					A2(
					$author$project$Activities$View$keyedAs,
					'activity-message',
					$author$project$Activities$View$messageRow('No activities'))
				]);
		} else {
			var _v4 = _v1.c;
			return _List_fromArray(
				[
					A2(
					$author$project$Activities$View$keyedAs,
					'activity-message',
					$author$project$Activities$View$messageRow('No activities match description.'))
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$GroupBy$mapByRataDie = F4(
	function (zone, getDate, renderFunc, list) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (l) {
					return $rtfeldman$elm_sorter_experiment$Sort$Dict$values(
						A2(
							$rtfeldman$elm_sorter_experiment$Sort$Dict$map,
							renderFunc,
							A3(
								$author$project$GroupBy$groupBy,
								$author$project$CoreX$Sorter$reverseInt,
								A2(
									$elm$core$Basics$composeR,
									getDate,
									$author$project$CoreX$RataDie$fromPosix(zone)),
								l)));
				},
				$mgold$elm_nonempty_list$List$Nonempty$fromList(list)));
	});
var $author$project$BudgetBar$BudgetBarLogic$fitUnitsTo = F2(
	function (totalUnitsDisplayed, unitsToday) {
		var overPercentage = F2(
			function (takenPercentage, percentage) {
				return A2($elm$core$Basics$max, 0, (takenPercentage + percentage) - 100);
			});
		var asPercentage = function (unit) {
			return (unit / totalUnitsDisplayed) * 100;
		};
		var chargeablePercentage = asPercentage(unitsToday.ax);
		var chargeablePercentageOver = A2(overPercentage, 0, chargeablePercentage);
		var nonChargeablePercentage = asPercentage(unitsToday.aH);
		var nonChargeablePercentageOver = A2(overPercentage, chargeablePercentage - chargeablePercentageOver, nonChargeablePercentage);
		var unverifiedPercentage = asPercentage(unitsToday.aN);
		var unverifiedPercentageOver = A2(overPercentage, ((chargeablePercentage - chargeablePercentageOver) + nonChargeablePercentage) - nonChargeablePercentageOver, unverifiedPercentage);
		return {
			ax: {S: chargeablePercentageOver, aI: chargeablePercentage},
			aH: {S: nonChargeablePercentageOver, aI: nonChargeablePercentage},
			aN: {S: unverifiedPercentageOver, aI: unverifiedPercentage}
		};
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$BudgetBar$BudgetBarLogic$isOverBarWidth = function (_v0) {
	var chargeable = _v0.ax;
	var nonChargeable = _v0.aH;
	var unverified = _v0.aN;
	return ((chargeable.S + nonChargeable.S) + unverified.S) > 0;
};
var $author$project$BudgetBar$BudgetBarLogic$isVisible = function (_v0) {
	var percentage = _v0.aI;
	var over = _v0.S;
	return (percentage - over) > 0;
};
var $author$project$CoreX$List$mapFirst = F2(
	function (f, list) {
		if (list.b) {
			var head = list.a;
			var tail = list.b;
			return A2(
				$elm$core$List$cons,
				f(head),
				tail);
		} else {
			return _List_Nil;
		}
	});
var $author$project$CoreX$List$mapLast = F2(
	function (f, list) {
		return $elm$core$List$reverse(
			A2(
				$author$project$CoreX$List$mapFirst,
				f,
				$elm$core$List$reverse(list)));
	});
var $ryan_haskell$date_format$DateFormat$AmPmLowercase = {$: 23};
var $ryan_haskell$date_format$DateFormat$amPmLowercase = $ryan_haskell$date_format$DateFormat$AmPmLowercase;
var $ryan_haskell$date_format$DateFormat$HourNumber = {$: 26};
var $ryan_haskell$date_format$DateFormat$hourNumber = $ryan_haskell$date_format$DateFormat$HourNumber;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $author$project$CoreX$DateFormat$getTimeOfDayInSeconds = F2(
	function (posix, zone) {
		var seconds = A2($elm$time$Time$toSecond, zone, posix);
		var minuteAsSeconds = 60 * A2($elm$time$Time$toMinute, zone, posix);
		var hourAsSeconds = 3600 * A2($elm$time$Time$toHour, zone, posix);
		return (hourAsSeconds + minuteAsSeconds) + seconds;
	});
var $author$project$BudgetBar$View$percentageFromStart = F2(
	function (time, zone) {
		var twelveHoursAsSeconds = 12 * 3600;
		var sixAmAsSeconds = 6 * 3600;
		var secondsSince6am = A2($author$project$CoreX$DateFormat$getTimeOfDayInSeconds, time, zone) - sixAmAsSeconds;
		return (secondsSince6am / twelveHoursAsSeconds) * 100.0;
	});
var $author$project$BudgetBar$View$renderTimePointer = F3(
	function (cspNonce, nowTime, zone) {
		if (nowTime.$ === 1) {
			return _List_Nil;
		} else {
			var t = nowTime.a;
			var toShortTimeString = $ryan_haskell$date_format$DateFormat$format(
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$hourNumber,
						$ryan_haskell$date_format$DateFormat$text('.'),
						$ryan_haskell$date_format$DateFormat$minuteFixed,
						$ryan_haskell$date_format$DateFormat$amPmLowercase
					]));
			var timeLabel = 'Now ' + A2(toShortTimeString, zone, t);
			var pct = A2($author$project$BudgetBar$View$percentageFromStart, t, zone);
			return ((pct < 0) || (pct > 100)) ? _List_Nil : _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute top-0 h-full pointer-events-none z-20'),
							A2($elm$html$Html$Attributes$attribute, 'nonce', cspNonce),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$elm$core$String$fromFloat(pct) + '%'),
							A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Current time: ' + timeLabel),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'budget-bar-time-pointer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px bg-black')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute top-full left-1/2 -translate-x-1/2 h-0 w-0 border-l-6 border-r-6 border-l-transparent border-r-transparent border-b-6 border-b-black')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute top-full mt-1 left-1/2 -translate-x-1/2 text-mt-grey text-xs whitespace-nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(timeLabel)
								]))
						]))
				]);
		}
	});
var $author$project$BudgetBar$View$displayProgress = F8(
	function (cspNonce, dailyBudget, isMainBudgetBar, showNonChargeable, showTimePointer, nowTime, zone, unitsToday) {
		var plusSign = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center absolute text-white h-4'),
					$elm$html$Html$Attributes$class('right-2px pb-2px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('+')
				]));
		var filteredUnits = showNonChargeable ? unitsToday : _Utils_update(
			unitsToday,
			{aH: 0});
		var drawFullBarContainer = F2(
			function (attrs, children) {
				return A2(
					$elm$html$Html$div,
					A2(
						$author$project$CoreX$Appendable$andAppend,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex w-full h-4 lg:w-full left-1/2 transform -translate-x-1/2')
							]),
						attrs),
					children);
			});
		var drawBar = function (_v2) {
			var percentage = _v2.a.aI;
			var over = _v2.a.S;
			var colour = _v2.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex h-full'),
						$elm$html$Html$Attributes$class(colour),
						A2($elm$html$Html$Attributes$attribute, 'nonce', cspNonce),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromFloat(percentage - over) + '%'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'unit-draw-bar')
					]),
				_List_Nil);
		};
		var clampedUnitPercentages = A2($author$project$BudgetBar$BudgetBarLogic$fitUnitsTo, dailyBudget, filteredUnits);
		var drawVisibleSections = function () {
			var getVisibleSections = function (sections) {
				return A2(
					$elm$core$List$filter,
					function (_v1) {
						var u = _v1.a;
						return $author$project$BudgetBar$BudgetBarLogic$isVisible(u);
					},
					sections);
			};
			var addStyle = F2(
				function (newStyle, _v0) {
					var u = _v0.a;
					var style = _v0.b;
					return _Utils_Tuple2(u, style + (' ' + newStyle));
				});
			return A2(
				$elm$core$List$map,
				drawBar,
				A2(
					$author$project$CoreX$List$mapLast,
					addStyle('rounded-r-lg'),
					A2(
						$author$project$CoreX$List$mapFirst,
						addStyle('rounded-l-lg'),
						getVisibleSections(
							_List_fromArray(
								[
									_Utils_Tuple2(clampedUnitPercentages.ax, 'bg-mt-green-dark'),
									_Utils_Tuple2(clampedUnitPercentages.aH, 'bg-mt-blue-light'),
									_Utils_Tuple2(clampedUnitPercentages.aN, 'bg-mt-red-light')
								])))));
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-center items-center relative'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('items-center w-24', !isMainBudgetBar)
							]))
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					isMainBudgetBar && showTimePointer,
					A3($author$project$BudgetBar$View$renderTimePointer, cspNonce, nowTime, zone),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						$author$project$BudgetBar$BudgetBarLogic$isOverBarWidth(clampedUnitPercentages),
						_List_fromArray(
							[plusSign]),
						A2(
							$author$project$CoreX$Appendable$andAppend,
							_List_fromArray(
								[
									A2(
									drawFullBarContainer,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('relative border border-mt-grey-lighter rounded-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('absolute inset-0 flex rounded-full overflow-hidden')
												]),
											drawVisibleSections)
										]))
								]),
							_List_Nil))))
			]);
	});
var $author$project$BudgetBar$Data$NonChargeable = 2;
var $author$project$BudgetBar$View$percentageFromEnd = F2(
	function (time, zone) {
		var twelveHoursAsSeconds = 12 * 3600;
		var sixPmAsSeconds = 18 * 3600;
		var secondsUntil6pm = sixPmAsSeconds - A2($author$project$CoreX$DateFormat$getTimeOfDayInSeconds, time, zone);
		return (secondsUntil6pm / twelveHoursAsSeconds) * 100.0;
	});
var $ryan_haskell$date_format$DateFormat$HourFixed = {$: 27};
var $ryan_haskell$date_format$DateFormat$hourFixed = $ryan_haskell$date_format$DateFormat$HourFixed;
var $author$project$CoreX$DateFormat$to12HourTimeString = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed,
			$ryan_haskell$date_format$DateFormat$amPmLowercase
		]));
var $author$project$BudgetBar$Data$Incomplete = 1;
var $author$project$BudgetBar$Data$Verified = 0;
var $author$project$Timesheet$FeeLogic$isNonChargeable = function (fee) {
	var matterBillingBehaviour = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.fS;
			},
			fee.hY));
	return A2(
		$elm$core$List$any,
		function (b) {
			return !(!b);
		},
		_List_fromArray(
			[fee.fS, fee.g0.fS, matterBillingBehaviour]));
};
var $author$project$BudgetBar$BudgetBarLogic$toStatus = function (fee) {
	var _v0 = _Utils_Tuple2(
		$author$project$Timesheet$FeeCountsLogic$isIncomplete(fee),
		$author$project$Timesheet$FeeLogic$isNonChargeable(fee));
	if (_v0.a) {
		return 1;
	} else {
		if (_v0.b) {
			return 2;
		} else {
			return 0;
		}
	}
};
var $author$project$BudgetBar$View$produceFeeBlock = F4(
	function (zone, minutesPerUnit, cspNonce, fee) {
		var startPercent = $elm$core$String$fromFloat(
			A2($author$project$BudgetBar$View$percentageFromStart, fee.b7, zone));
		var hoverText = function () {
			var time = A2($author$project$CoreX$DateFormat$to12HourTimeString, zone, fee.b7);
			var status = function () {
				var _v1 = $author$project$BudgetBar$BudgetBarLogic$toStatus(fee);
				switch (_v1) {
					case 0:
						return 'Verified';
					case 1:
						return 'Incomplete';
					default:
						return 'Non-Chargeable';
				}
			}();
			return time + (' (' + ($elm$core$String$fromFloat(fee.jP) + (' ' + (status + ' Units)'))));
		}();
		var feeDurationMillis = $elm$core$Basics$ceiling(((fee.jP * minutesPerUnit) * 60.0) * 1000.0);
		var endTime = $elm$time$Time$millisToPosix(
			feeDurationMillis + $elm$time$Time$posixToMillis(fee.b7));
		var endPercent = $elm$core$String$fromFloat(
			A2($author$project$BudgetBar$View$percentageFromEnd, endTime, zone));
		var colour = function () {
			var _v0 = $author$project$BudgetBar$BudgetBarLogic$toStatus(fee);
			switch (_v0) {
				case 0:
					return 'bg-mt-green-dark';
				case 1:
					return 'bg-mt-red-light';
				default:
					return 'bg-mt-blue-light';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(hoverText),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-block'),
					$elm$html$Html$Attributes$class('hover:bg-opacity-75'),
					$elm$html$Html$Attributes$class('h-4'),
					$elm$html$Html$Attributes$class('z-10 absolute left-0 w-full h-full mix-blend-multiply ' + colour),
					A2($elm$html$Html$Attributes$attribute, 'nonce', cspNonce),
					A2($elm$html$Html$Attributes$style, 'clip-path', 'inset(0% ' + (endPercent + ('% 0% ' + (startPercent + '%)'))))
				]),
			_List_Nil);
	});
var $author$project$BudgetBar$View$displayTimeline = F7(
	function (fees, minutesPerUnit, isMainBudgetBar, showNonChargeable, status, zone, cspNonce) {
		var visibleFees = A2(
			$elm$core$List$filter,
			function (fee) {
				return showNonChargeable || ($author$project$BudgetBar$BudgetBarLogic$toStatus(fee) !== 2);
			},
			fees);
		var renderFeeBlocks = function (fs) {
			return A2(
				$elm$core$List$map,
				A3($author$project$BudgetBar$View$produceFeeBlock, zone, minutesPerUnit, cspNonce),
				fs);
		};
		var hoursTicks = isMainBudgetBar ? _List_fromArray(
			['Today', '8am', '10am', '12pm', '2pm', '4pm', '6pm']) : _List_fromArray(
			['6am', '12pm', '6pm']);
		var hourBlocks = A2(
			$elm$core$List$map,
			function (_v2) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('z-0 flex-1 bg-mt-grey-lightest')
						]),
					_List_Nil);
			},
			A2($elm$core$List$range, 0, 11));
		var renderHourBlocks = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-4 flex gap-x-0.5 w-full justify-between mix-blend-normal')
					]),
				hourBlocks)
			]);
		var filteredFees = function () {
			if (status.$ === 1) {
				return visibleFees;
			} else {
				var subMsg = status.a;
				return A2(
					$elm$core$List$filter,
					function (fee) {
						return _Utils_eq(
							$author$project$BudgetBar$BudgetBarLogic$toStatus(fee),
							subMsg);
					},
					visibleFees);
			}
		}();
		var createHours = function (hrs) {
			var hours = A2(
				$elm$core$List$map,
				function (hour) {
					switch (hour) {
						case '8am':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-time-slow')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(hour)
									]));
						case '2pm':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pl-4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(hour)
									]));
						case '4pm':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pl-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(hour)
									]));
						default:
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(hour)
									]));
					}
				},
				hrs);
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-1 w-full justify-between mix-blend-normal')
						]),
					hours)
				]);
		};
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex h-4 relative'),
						$elm$html$Html$Attributes$class('w-full text-mt-grey'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'budget-bar'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('h-4', isMainBudgetBar),
								_Utils_Tuple2('h-2', !isMainBudgetBar)
							]))
					]),
				_Utils_ap(
					renderHourBlocks,
					renderFeeBlocks(filteredFees))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('h-4', isMainBudgetBar),
								_Utils_Tuple2('h-2 mt-1', !isMainBudgetBar)
							])),
						$elm$html$Html$Attributes$class('text-sm text-mt-grey')
					]),
				createHours(hoursTicks))
			]);
	});
var $author$project$BudgetBar$View$barView = F3(
	function (isMainBudgetBar, unitsToday, _v0) {
		var model = _v0.a6;
		var fees = _v0.aY;
		var dailyBudget = _v0.aV;
		var zone = _v0.fA;
		var minutesPerUnit = _v0.ej;
		var cspNonce = _v0.c5;
		var barConfig = _v0.aw;
		return (!model.gy) ? A8($author$project$BudgetBar$View$displayProgress, cspNonce, dailyBudget, isMainBudgetBar, barConfig.bf, barConfig.e5, model.io, zone, unitsToday) : A7($author$project$BudgetBar$View$displayTimeline, fees, minutesPerUnit, isMainBudgetBar, barConfig.bf, model.ha, zone, cspNonce);
	});
var $author$project$BudgetBar$View$HoverRow = F3(
	function (colour, label, units) {
		return {c0: colour, ec: label, jP: units};
	});
var $author$project$BudgetBar$View$unitsTowardBudget = F2(
	function (countNonChargeablesInBudget, unitsToday) {
		return countNonChargeablesInBudget ? (unitsToday.ax + unitsToday.aH) : unitsToday.ax;
	});
var $author$project$BudgetBar$View$budgetBarHoverRows = F2(
	function (unitsToday, _v0) {
		var dailyBudget = _v0.aV;
		var barConfig = _v0.aw;
		var ncInBudget = barConfig.aT;
		var remaining = A2(
			$elm$core$Basics$max,
			0,
			dailyBudget - A2($author$project$BudgetBar$View$unitsTowardBudget, ncInBudget, unitsToday));
		return A2(
			$author$project$CoreX$Appendable$andAppend,
			_List_fromArray(
				[
					A3($author$project$BudgetBar$View$HoverRow, 'bg-mt-grey-lighter-two', 'Remaining', remaining)
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						A3($author$project$BudgetBar$View$HoverRow, 'bg-mt-blue-light', 'Non-Chargeable', unitsToday.aH)
					]),
				_List_fromArray(
					[
						A3($author$project$BudgetBar$View$HoverRow, 'bg-black', 'Budget', dailyBudget),
						A3($author$project$BudgetBar$View$HoverRow, 'bg-mt-green-dark', 'Verified', unitsToday.ax),
						A3($author$project$BudgetBar$View$HoverRow, 'bg-mt-red-light', 'Incomplete', unitsToday.aN)
					])));
	});
var $author$project$BudgetBar$View$isProgress = function (dashboardUI) {
	return !dashboardUI;
};
var $author$project$Timesheet$FeeLogic$roundUnitsString = function (units) {
	var isCloseToFullUnit = $elm$core$Basics$abs(
		units - $elm$core$Basics$round(units)) < 0.05;
	var chargeableUnits = isCloseToFullUnit ? $elm$core$String$fromInt(
		$elm$core$Basics$round(units)) : $elm$core$String$fromFloat(units);
	var _v0 = A2($elm$core$String$split, '.', chargeableUnits);
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.b.b) {
				if (!_v0.b.b.b) {
					var _int = _v0.a;
					var _v1 = _v0.b;
					var dec = _v1.a;
					return _int + ('.' + A3($elm$core$String$slice, 0, 2, dec));
				} else {
					break _v0$2;
				}
			} else {
				var _int = _v0.a;
				return _int;
			}
		} else {
			break _v0$2;
		}
	}
	return '1';
};
var $author$project$BudgetBar$View$renderHoverRow = function (_v0) {
	var colour = _v0.c0;
	var label = _v0.ec;
	var units = _v0.jP;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center gap-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-3 h-3 rounded-full shrink-0'),
						$elm$html$Html$Attributes$class(colour)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Timesheet$FeeLogic$roundUnitsString(units))
					]))
			]));
};
var $author$project$BudgetBar$View$renderHoverCard = function (rows) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-2 px-3 py-3 text-base'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'budget-hover-card')
			]),
		A2($elm$core$List$map, $author$project$BudgetBar$View$renderHoverRow, rows));
};
var $author$project$BudgetBar$BudgetBarLogic$toUnitsToday = function (fees) {
	var toSum = function (ls) {
		return $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (f) {
					return f.jP;
				},
				ls));
	};
	var _v0 = A2($elm$core$List$partition, $author$project$Timesheet$FeeCountsLogic$isIncomplete, fees);
	var unverified = _v0.a;
	var rest = _v0.b;
	var _v1 = A2(
		$elm$core$List$partition,
		function (f) {
			return $author$project$Timesheet$FeeLogic$isNonChargeable(f);
		},
		rest);
	var nonChargeable = _v1.a;
	var chargeable = _v1.b;
	return {
		ax: toSum(chargeable),
		aH: toSum(nonChargeable),
		aN: toSum(unverified)
	};
};
var $author$project$BudgetBar$View$totalUnitsString = F2(
	function (countNonChargeablesInBudget, unitsToday) {
		return $author$project$Timesheet$FeeLogic$roundUnitsString(
			A2($author$project$BudgetBar$View$unitsTowardBudget, countNonChargeablesInBudget, unitsToday));
	});
var $author$project$CoreX$Maybe$withDefaultLazy = F2(
	function (defaultFunc, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return defaultFunc(0);
		}
	});
var $author$project$BudgetBar$View$dailySummaryView = F2(
	function (unitsForToday, model) {
		var barConfig = model.aw;
		var unitsToday = A2(
			$author$project$CoreX$Maybe$withDefaultLazy,
			function (_v0) {
				return $author$project$BudgetBar$BudgetBarLogic$toUnitsToday(model.aY);
			},
			unitsForToday);
		var ncInBudget = barConfig.aT;
		var isProgressBar = $author$project$BudgetBar$View$isProgress(model.a6.gy);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-2 relative hovercard'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'daily-summary')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !isProgressBar)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-mt-grey-dark font-semibold mr-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$BudgetBar$View$totalUnitsString, ncInBudget, unitsToday))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-mt-grey mr-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Units ')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('w-24', isProgressBar),
									_Utils_Tuple2('w-48 mt-1', !isProgressBar)
								]))
						]),
					A3($author$project$BudgetBar$View$barView, false, unitsToday, model)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hovercardtext w-48'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('-left-18', isProgressBar),
									_Utils_Tuple2('-left-12', !isProgressBar)
								]))
						]),
					_List_fromArray(
						[
							$author$project$BudgetBar$View$renderHoverCard(
							A2($author$project$BudgetBar$View$budgetBarHoverRows, unitsToday, model))
						]))
				]));
	});
var $author$project$CoreX$DateFormat$isSameYear = F3(
	function (zone, date, currDate) {
		var year = A2($elm$time$Time$toYear, zone, date);
		var currYear = A2($elm$time$Time$toYear, zone, currDate);
		return _Utils_eq(year, currYear);
	});
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$MonthNameFull = {$: 4};
var $ryan_haskell$date_format$DateFormat$monthNameFull = $ryan_haskell$date_format$DateFormat$MonthNameFull;
var $author$project$CoreX$DateFormat$toDayAndMonthStringWithOptYear = F3(
	function (zone, showYear, date) {
		var formatter = $ryan_haskell$date_format$DateFormat$format(
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				showYear,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$yearNumber
					]),
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$monthNameFull
					])));
		return A2(formatter, zone, date);
	});
var $author$project$Components$DayHeader$dateSpan = F3(
	function (zone, date, currDate) {
		var showYear = !A3($author$project$CoreX$DateFormat$isSameYear, zone, date, currDate);
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-light')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					' ' + A3($author$project$CoreX$DateFormat$toDayAndMonthStringWithOptYear, zone, showYear, date))
				]));
	});
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $author$project$CoreX$DateCompare$sameRataDie = F3(
	function (zone, a, b) {
		return _Utils_eq(
			A2($author$project$CoreX$RataDie$fromPosix, zone, a),
			A2($author$project$CoreX$RataDie$fromPosix, zone, b));
	});
var $author$project$Components$DayHeader$dayHeader = F6(
	function (zone, dayText, date, today, suffix, budgetBar) {
		var isToday = A3($author$project$CoreX$DateCompare$sameRataDie, zone, date, today);
		var isFutureDate = A2($author$project$CoreX$DateCompare$isLaterThan, today, date);
		var highlight = isToday && (suffix === 'fee');
		var dayHeaderRole = isToday ? ('today-header-' + suffix) : ('day-header-' + suffix);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col lg:flex-row justify-between'),
					$elm$html$Html$Attributes$class('mt-3 mb-0 pl-2 pb-4'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', dayHeaderRole)
				]),
			A2(
				$author$project$CoreX$Appendable$andAppendMaybe,
				A2(
					$elm$core$Maybe$map,
					$author$project$BudgetBar$View$dailySummaryView($elm$core$Maybe$Nothing),
					budgetBar),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h6,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-0'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('text-mt-red', isFutureDate)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('bg-yellow-100 p-1', highlight)
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(dayText)
									])),
								A3($author$project$Components$DayHeader$dateSpan, zone, date, today)
							]))
					])));
	});
var $author$project$CoreX$RataDie$dateToParts = function (date) {
	var y = $justinmimbs$date$Date$year(date);
	var m = $justinmimbs$date$Date$month(date);
	var d = $justinmimbs$date$Date$day(date);
	return A7($justinmimbs$time_extra$Time$Extra$Parts, y, m, d, 0, 0, 0, 0);
};
var $justinmimbs$date$Date$fromRataDie = function (rd) {
	return rd;
};
var $author$project$CoreX$RataDie$toPosix = F2(
	function (zone, rataDie) {
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			$author$project$CoreX$RataDie$dateToParts(
				$justinmimbs$date$Date$fromRataDie(rataDie)));
	});
var $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull = {$: 14};
var $ryan_haskell$date_format$DateFormat$dayOfWeekNameFull = $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull;
var $author$project$CoreX$DateFormat$toWeekDayString = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text('')
		]));
var $author$project$Components$DayHeader$renderDayHeader = F5(
	function (zone, eventDate, todayRataDie, suffix, budgetBar) {
		var today = A2($author$project$CoreX$RataDie$toPosix, zone, todayRataDie);
		var dateDay = A2($author$project$CoreX$RataDie$fromPosix, zone, eventDate);
		var dateDiff = todayRataDie - dateDay;
		switch (dateDiff) {
			case 0:
				return A6($author$project$Components$DayHeader$dayHeader, zone, 'Today', eventDate, today, suffix, $elm$core$Maybe$Nothing);
			case 1:
				return A6($author$project$Components$DayHeader$dayHeader, zone, 'Yesterday', eventDate, today, suffix, budgetBar);
			default:
				return A6(
					$author$project$Components$DayHeader$dayHeader,
					zone,
					A2($author$project$CoreX$DateFormat$toWeekDayString, zone, eventDate),
					eventDate,
					today,
					suffix,
					budgetBar);
		}
	});
var $author$project$Components$DayHeader$renderDayHeaderFromRataDie = F4(
	function (zone, rataDie, suffix, unitsToday) {
		return A4(
			$author$project$Components$DayHeader$renderDayHeader,
			zone,
			A2($author$project$CoreX$RataDie$toPosix, zone, rataDie),
			suffix,
			unitsToday);
	});
var $mgold$elm_nonempty_list$List$Nonempty$isSingleton = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $elm$core$List$isEmpty(xs);
};
var $author$project$ActivityRowType$ChildRow = 1;
var $author$project$Activities$ActivityLogic$getAggregateDuration = function (activities) {
	return A3(
		$elm$core$List$foldl,
		$elm$core$Maybe$map2($elm$core$Basics$add),
		$elm$core$Maybe$Just(0),
		A2(
			$elm$core$List$map,
			function (a) {
				return $author$project$Activities$ActivityLogic$getDuration(a);
			},
			activities));
};
var $author$project$Activities$Messages$CloseKebabActivityMenu = function (a) {
	return {$: 23, a: a};
};
var $author$project$ActivityRowType$HeaderRow = 0;
var $author$project$ActivityRowType$SingletonRow = 2;
var $author$project$Activities$Messages$AcceptActivity = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Activities$Messages$BlockActivity = function (a) {
	return {$: 21, a: a};
};
var $author$project$Activities$Messages$DeleteActivity = function (a) {
	return {$: 17, a: a};
};
var $author$project$Activities$Messages$SendBrowserExtensionMessage = function (a) {
	return {$: 34, a: a};
};
var $author$project$Activities$Views$ActionBar$actionButtonIconStyle = 'w-7 h-7 ' + 'icon fill-current stroke-current text-white ';
var $author$project$Activities$Views$ActionBar$actionButtonStyle = 'flex flex-col items-center justify-center w-18 h-full ' + ('lg:mt-0 lg:w-8 lg:h-18 lg:mr-1 ' + 'lg:bg-transparent ');
var $author$project$Activities$ActivityLogic$NotUpgradeable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Activities$ActivityLogic$UpgradeAndCreateContact = {$: 1};
var $author$project$Activities$ActivityLogic$Upgradeable = {$: 0};
var $author$project$Activities$ActivityLogic$hasContact = function (_v0) {
	var contact = _v0.c2;
	return $elm_community$maybe_extra$Maybe$Extra$isJust(contact);
};
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{cZ: false, en: false},
		string);
};
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$Activities$ActivityLogic$replaceInString = F3(
	function (userRegex, replacer, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return string;
		} else {
			var regex = _v0.a;
			return A3($elm$regex$Regex$replace, regex, replacer, string);
		}
	});
var $author$project$Activities$ActivityLogic$numericOnly = function (string) {
	return A3(
		$author$project$Activities$ActivityLogic$replaceInString,
		'[^0-9]',
		function (_v0) {
			return '';
		},
		string);
};
var $author$project$Activities$ActivityLogic$isNonNumeric = function (str) {
	return $author$project$Activities$ActivityLogic$numericOnly(str) === '';
};
var $author$project$Activities$ActivityLogic$getUpgradeContext = function (activity) {
	if ($author$project$Activities$ActivityLogic$hasContact(activity)) {
		return $author$project$Activities$ActivityLogic$Upgradeable;
	} else {
		var _v0 = activity.i;
		switch (_v0.$) {
			case 4:
				var phone = _v0.a;
				return $author$project$Activities$ActivityLogic$isNonNumeric(phone.a9) ? $author$project$Activities$ActivityLogic$NotUpgradeable('Cannot Upgrade Anonymous Phone Calls') : $author$project$Activities$ActivityLogic$UpgradeAndCreateContact;
			case 1:
				var _v1 = _v0.a;
				return $author$project$Activities$ActivityLogic$NotUpgradeable('Cannot Upgrade MS Teams Calls');
			case 0:
				var appt = _v0.a;
				return (appt.ai === '') ? $author$project$Activities$ActivityLogic$NotUpgradeable('Cannot Upgrade without Attendees') : $author$project$Activities$ActivityLogic$UpgradeAndCreateContact;
			case 3:
				return $author$project$Activities$ActivityLogic$UpgradeAndCreateContact;
			case 2:
				return $author$project$Activities$ActivityLogic$NotUpgradeable('Cannot Upgrade Documents');
			default:
				return $author$project$Activities$ActivityLogic$NotUpgradeable('Cannot Upgrade Browser Research');
		}
	}
};
var $author$project$Components$ContactModal$Model$Unsupported = 2;
var $author$project$Components$ContactModal$Model$blankContact = {gh: '', c1: $author$project$Components$ContactModal$Model$NoConflict, dl: '', gM: '', hf: '', bV: false, hO: '', ik: '', iz: 2, iH: '', jo: ''};
var $elm_community$list_extra$List$Extra$unconsLast = function (list) {
	var _v0 = $elm$core$List$reverse(list);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var last_ = _v0.a;
		var rest = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				last_,
				$elm$core$List$reverse(rest)));
	}
};
var $author$project$Components$ContactModal$Model$initialiseContactModalForUpgrade = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 4:
			var call = _v0.a;
			return _Utils_update(
				$author$project$Components$ContactModal$Model$blankContact,
				{iz: 1, iH: call.a9});
		case 3:
			var email = _v0.a;
			var _v1 = A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2('', _List_Nil),
				$elm_community$list_extra$List$Extra$unconsLast(
					A2($elm$core$String$split, ' ', email.dm)));
			var surname = _v1.a;
			var givenNames = _v1.b;
			return _Utils_update(
				$author$project$Components$ContactModal$Model$blankContact,
				{
					dl: email.dl,
					hf: A2($elm$core$String$join, ' ', givenNames),
					iz: 0,
					jo: surname
				});
		default:
			return $author$project$Components$ContactModal$Model$blankContact;
	}
};
var $author$project$Activities$Views$ActionBar$mobileButtonTitle = 'pt-3 text-xxs font-bold text-center leading-tight ' + 'lg:hidden ';
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $author$project$Icons$Upgrade$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 64 64'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$class('transition-15 stroke-current')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('transition-15'),
								$elm$svg$Svg$Attributes$transform('translate(2.000000, 2.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('lg:group-hover:fill-mt-purple group-hover:stroke-white'),
										$elm$svg$Svg$Attributes$fillRule('nonzero'),
										$elm$svg$Svg$Attributes$cx('30'),
										$elm$svg$Svg$Attributes$cy('30'),
										$elm$svg$Svg$Attributes$r('30')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('group-hover:stroke-white '),
										$elm$svg$Svg$Attributes$transform('translate(16.000000, 16.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$polyline,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$transform('translate(14.000000, 7.333333) rotate(180.000000) translate(-14.000000, -7.333333) '),
												$elm$svg$Svg$Attributes$points('27.3333333 0.666666667 14 14 0.666666667 0.666666667')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M14,27.3333333 L14,0.666666667'),
												$elm$svg$Svg$Attributes$id('Path-17'),
												$elm$svg$Svg$Attributes$fillRule('nonzero')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Icons$UpgradeAndCreateContact$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 70 67'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$class('transition-15')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:fill-transparent lg:stroke-mt-purple lg:group-hover:fill-mt-purple lg:group-hover:stroke-white fill-mt-purple stroke-white'),
								$elm$svg$Svg$Attributes$d('M61.0539 26.1705C61.9573 29.0391 62.4444 32.0923 62.4444 35.2592C62.4444 51.9505 48.9135 65.4814 32.2222 65.4814C15.5309 65.4814 2 51.9505 2 35.2592C2 18.5679 15.5309 5.03699 32.2222 5.03699C36.4919 5.03699 40.5547 5.92237 44.2372 7.51955'),
								$elm$svg$Svg$Attributes$strokeWidth('3'),
								$elm$svg$Svg$Attributes$strokeLinecap('square'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:group-hover:stroke-white lg:group-hover:fill-mt-purple lg:stroke-mt-purple lg:fill-transparent stroke-white fill-mt-purple')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M18.7906 35.2593L32.2227 21.8272L45.6548 35.2593'),
										$elm$svg$Svg$Attributes$strokeWidth('3'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M32.2218 48.6912V21.827'),
										$elm$svg$Svg$Attributes$strokeWidth('3'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('lg:stroke-mt-purple')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:group-hover:fill-mt-purple lg:group-hover:stroke-white lg:fill-transparent fill-mt-purple'),
								$elm$svg$Svg$Attributes$cx('56.1482'),
								$elm$svg$Svg$Attributes$cy('13.8519'),
								$elm$svg$Svg$Attributes$r('12.5532'),
								$elm$svg$Svg$Attributes$strokeWidth('2.59722')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:group-hover:fill-white lg:group-hover:stroke-white lg:fill-mt-purple lg:stroke-mt-purple fill-white'),
								$elm$svg$Svg$Attributes$d('M57.4466 8.65735C57.4466 7.94015 56.8652 7.35874 56.1479 7.35874C55.4307 7.35874 54.8493 7.94015 54.8493 8.65735H57.4466ZM54.8493 19.912C54.8493 20.6292 55.4307 21.2106 56.1479 21.2106C56.8652 21.2106 57.4466 20.6292 57.4466 19.912H54.8493ZM54.8493 8.65735V19.912H57.4466V8.65735H54.8493Z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:group-hover:fill-white lg:group-hover:stroke-white lg:fill-mt-purple lg:stroke-mt-purple fill-white'),
								$elm$svg$Svg$Attributes$d('M50.521 12.9861C49.8038 12.9861 49.2224 13.5675 49.2224 14.2847C49.2224 15.0019 49.8038 15.5833 50.521 15.5833V12.9861ZM61.7756 15.5833C62.4928 15.5833 63.0742 15.0019 63.0742 14.2847C63.0742 13.5675 62.4928 12.9861 61.7756 12.9861V15.5833ZM50.521 15.5833H61.7756V12.9861H50.521V15.5833Z')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Activities$Views$ActionBar$acceptAndUpgradeButton = function (activity) {
	var upgradeIconClass = A2($author$project$CoreX$Appendable$andAppend, 'icon--upgrade-button', $author$project$Activities$Views$ActionBar$actionButtonIconStyle);
	var upgradeContext = $author$project$Activities$ActivityLogic$getUpgradeContext(activity);
	var hoverText = function () {
		switch (upgradeContext.$) {
			case 0:
				return 'Charge & Upgrade';
			case 1:
				return 'Charge & Upgrade New Contact';
			default:
				var reason = upgradeContext.a;
				return reason;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonStyle),
				$elm$html$Html$Attributes$class('bg-mt-purple-dark'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'charge-and-upgrade-button')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('group tooltip cursor-pointer')
					]),
				_List_fromArray(
					[
						function () {
						switch (upgradeContext.$) {
							case 0:
								return $author$project$Icons$Upgrade$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class(upgradeIconClass + ' lg:text-mt-purple'),
											$elm$svg$Svg$Events$onClick(
											$author$project$TimesheetPage$Messages$ActivityFeedComponent(
												A2($author$project$Activities$Messages$AcceptActivity, activity, false)))
										]));
							case 1:
								var model = $author$project$Components$ContactModal$Model$initialiseContactModalForUpgrade(activity);
								return $author$project$Icons$UpgradeAndCreateContact$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class(upgradeIconClass),
											$elm$svg$Svg$Events$onClick(
											$author$project$TimesheetPage$Messages$ModalAction(
												A2($author$project$Components$Modal$Model$ContactModal, activity, model)))
										]));
							default:
								return $author$project$Icons$Upgrade$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class(upgradeIconClass + ' upgrade-disabled lg:text-mt-grey-lightest')
										]));
						}
					}(),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tooltiptext mt-12 w-28 shadow-sm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(hoverText)
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$mobileButtonTitle),
						$elm$html$Html$Attributes$class('text-white')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(hoverText)
					]))
			]));
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Icons$AcceptButton$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 64 64'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('translate(-16.000000, -16.000000)'),
						$elm$svg$Svg$Attributes$strokeWidth('3'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$class('transition-15')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$transform('translate(18.000000, 18.000000)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('lg:group-hover:fill-mt-green lg:fill-transparent'),
										$elm$svg$Svg$Attributes$fill('#2BEEA6'),
										$elm$svg$Svg$Attributes$cx('30'),
										$elm$svg$Svg$Attributes$cy('30'),
										$elm$svg$Svg$Attributes$r('30')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$polyline,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('lg:group-hover:stroke-white'),
										$elm$svg$Svg$Attributes$fill('none'),
										$elm$svg$Svg$Attributes$points('18 32.9014472 27 40 45 20')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Activities$Views$ActionBar$acceptButton = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonStyle),
				$elm$html$Html$Attributes$class('bg-mt-green'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'charge-once-off-button'),
				A2($elm$html$Html$Attributes$attribute, 'data-tour', 'charge-once-off-button')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('group tooltip cursor-pointer')
					]),
				_List_fromArray(
					[
						$author$project$Icons$AcceptButton$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonIconStyle + 'lg:text-mt-green icon icon--tick-button'),
								$elm$svg$Svg$Events$onClick(message)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tooltiptext mt-12 w-26 shadow-sm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Charge Once')
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$mobileButtonTitle + 'text-white')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Charge'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Once')
					]))
			]));
};
var $author$project$Activities$ActivityLogic$isRunningResearchEvent = function (activity) {
	var _v0 = activity.i;
	if (_v0.$ === 5) {
		var event = _v0.a;
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(event.X);
	} else {
		return false;
	}
};
var $author$project$Icons$RubbishBinButton$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 64 64'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('transition duration-150'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:group-hover:fill-mt-red-light lg:group-hover:stroke-white'),
								$elm$svg$Svg$Attributes$strokeWidth('3'),
								$elm$svg$Svg$Attributes$cx('32'),
								$elm$svg$Svg$Attributes$cy('32'),
								$elm$svg$Svg$Attributes$r('30')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:group-hover:stroke-white'),
								$elm$svg$Svg$Attributes$transform('translate(20.000000, 16.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M22,5 L22,27.9061834 C22,30.1671359 20.1671359,32 17.9061834,32 L6.09381663,32 C3.83286414,32 2,30.1671359 2,27.9061834 L2,5'),
										$elm$svg$Svg$Attributes$id('body')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M0,4.5 L24,4.5'),
										$elm$svg$Svg$Attributes$id('lid')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M8,3 L8,1 C8,0.44771525 8.44771525,0 9,0 L15,0 C15.5522847,0 16,0.44771525 16,1 L16,3'),
										$elm$svg$Svg$Attributes$id('handle')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M8.5,11 L8.5,26'),
										$elm$svg$Svg$Attributes$id('mid-line-1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M15.5,11 L15.5,26'),
										$elm$svg$Svg$Attributes$id('mid-line-2')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Activities$Views$ActionBar$deleteButton = F2(
	function (msg, activity) {
		var _v0 = $author$project$Activities$ActivityLogic$isRunningResearchEvent(activity) ? _Utils_Tuple3(' lg:text-mt-grey-lightest', 'Stop tracking to delete', $author$project$TimesheetPage$Messages$NoOp) : _Utils_Tuple3(' lg:text-mt-red-light', 'Delete', msg);
		var colour = _v0.a;
		var hoverText = _v0.b;
		var clickMessage = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonStyle),
					$elm$html$Html$Attributes$class('bg-mt-red-light'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'delete-button'),
					A2($elm$html$Html$Attributes$attribute, 'data-tour', 'delete-button')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('group tooltip cursor-pointer')
						]),
					_List_fromArray(
						[
							$author$project$Icons$RubbishBinButton$viewWithAttributes(
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'delete-button-click'),
									$elm$svg$Svg$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonIconStyle + (colour + ' icon icon--delete-button')),
									$elm$svg$Svg$Events$onClick(clickMessage)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext mt-12 w-14 shadow-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(hoverText)
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$mobileButtonTitle + 'text-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(hoverText),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-mt-red-light')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('-')
								]))
						]))
				]));
	});
var $author$project$Activities$ActivityLogic$Downgradeable = 0;
var $author$project$Icons$Downgrade$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 64 64'),
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$class('group')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$class('transition-15')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$transform('translate(2.000000, 2.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('lg:group-hover:fill-mt-grey-dark lg:group-hover:stroke-white lg:fill-transparent'),
										$elm$svg$Svg$Attributes$fillRule('nonzero'),
										$elm$svg$Svg$Attributes$cx('30'),
										$elm$svg$Svg$Attributes$cy('30'),
										$elm$svg$Svg$Attributes$r('30')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$polyline,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('lg:group-hover:fill-mt-grey-dark lg:group-hover:stroke-white lg:fill-transparent'),
										$elm$svg$Svg$Attributes$transform('translate(30.000000, 37.333333) rotate(360.000000) translate(-30.000000, -37.333333)'),
										$elm$svg$Svg$Attributes$points('43.3333333 30.6666667 30 44 16.6666667 30.6666667')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('lg:group-hover:stroke-white'),
										$elm$svg$Svg$Attributes$d('M30,43.3333333 L30,16.6666667'),
										$elm$svg$Svg$Attributes$fillRule('nonzero'),
										$elm$svg$Svg$Attributes$transform('translate(30.000000, 30.000000) rotate(180.000000) translate(-30.000000, -30.000000)')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Activities$Views$ActionBar$downgradeButton = F2(
	function (downgradeContext, message) {
		var isEnabled = !downgradeContext;
		var hoverText = function () {
			switch (downgradeContext) {
				case 0:
					return 'Delete & Downgrade';
				case 5:
					return 'Cannot Downgrade Anonymous Phone Calls';
				case 1:
					return 'Cannot Downgrade without Attendees';
				case 2:
					return 'Cannot Downgrade Documents';
				case 4:
					return 'Cannot Downgrade MS Teams Calls';
				default:
					return 'Cannot Downgrade Browser Research';
			}
		}();
		var downgradeIconClass = A3(
			$author$project$CoreX$Appendable$andAppendIf,
			!isEnabled,
			' downgrade-disabled lg:text-mt-grey-lightest',
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				isEnabled,
				' lg:text-mt-grey-dark',
				A2($author$project$CoreX$Appendable$andAppend, ' icon icon--downgrade-button', $author$project$Activities$Views$ActionBar$actionButtonIconStyle)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A3($author$project$CoreX$Appendable$andAppendIf, isEnabled, 'bg-mt-grey-dark', $author$project$Activities$Views$ActionBar$actionButtonStyle)),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'downgrade-button')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('group tooltip cursor-pointer')
						]),
					_List_fromArray(
						[
							$author$project$Icons$Downgrade$viewWithAttributes(
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								isEnabled,
								_List_fromArray(
									[
										$elm$svg$Svg$Events$onClick(message)
									]),
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class(downgradeIconClass)
									]))),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext tooltip-left mt-12 right-0 w-28 shadow-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(hoverText)
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$mobileButtonTitle + 'text-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete & Downgrade')
						]))
				]));
	});
var $author$project$Activities$ActivityLogic$AnonymousPhonecall = 5;
var $author$project$Activities$ActivityLogic$AppointmentWithoutAttendees = 1;
var $author$project$Activities$ActivityLogic$BrowserResearchNotDowngradable = 3;
var $author$project$Activities$ActivityLogic$DocumentNotDowngradeable = 2;
var $author$project$Activities$ActivityLogic$MSTeamsCallNotDowngradeable = 4;
var $author$project$Activities$ActivityLogic$getDowngradeContext = function (activity) {
	if ($author$project$Activities$ActivityLogic$hasContact(activity)) {
		return 0;
	} else {
		var _v0 = activity.i;
		switch (_v0.$) {
			case 4:
				var phone = _v0.a;
				return $author$project$Activities$ActivityLogic$isNonNumeric(phone.a9) ? 5 : 0;
			case 1:
				var _v1 = _v0.a;
				return 4;
			case 0:
				var appt = _v0.a;
				return (appt.ai === '') ? 1 : 0;
			case 3:
				return 0;
			case 5:
				return 3;
			default:
				return 2;
		}
	}
};
var $author$project$Icons$Stop$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 64 64')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('transition duration-150'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:group-hover:fill-mt-purple-light'),
								$elm$svg$Svg$Attributes$strokeWidth('3'),
								$elm$svg$Svg$Attributes$cx('32'),
								$elm$svg$Svg$Attributes$cy('32'),
								$elm$svg$Svg$Attributes$r('30')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('lg:group-hover:fill-white'),
								$elm$svg$Svg$Attributes$transform('translate(24, 24)'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M0,0h16c0.553,0,1,0.447,1,1v16c0,0.553-0.447,1-1,1H0c-0.553,0-1-0.447-1-1V1C-1,0.447,0.447,0,1,0z')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Activities$Views$ActionBar$stopButton = function (msg) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonStyle),
				$elm$html$Html$Attributes$class('bg-mt-purple-light'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'stop-button')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('group tooltip cursor-pointer')
					]),
				_List_fromArray(
					[
						$author$project$Icons$Stop$viewWithAttributes(
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'stop-button-click'),
								$elm$svg$Svg$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonIconStyle + ' lg:text-mt-purple-light icon'),
								$elm$svg$Svg$Events$onClick(msg)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tooltiptext mt-12 w-14 shadow-sm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Stop Tracking')
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$mobileButtonTitle + 'text-white')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Stop Tracking'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-mt-purple-light')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('-')
							]))
					]))
			]));
};
var $author$project$Activities$Views$ActionBar$actionBarView = function (activity) {
	var downgradeContext = $author$project$Activities$ActivityLogic$getDowngradeContext(activity);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-start items-center h-full')
				]),
			$author$project$Activities$ActivityLogic$isBinned(activity) ? _List_fromArray(
				[
					$author$project$Activities$Views$ActionBar$acceptButton(
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						A2($author$project$Activities$Messages$AcceptActivity, activity, true))),
					$author$project$Activities$Views$ActionBar$acceptAndUpgradeButton(activity)
				]) : _List_fromArray(
				[
					$author$project$Activities$ActivityLogic$isRunningResearchEvent(activity) ? $author$project$Activities$Views$ActionBar$stopButton(
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						$author$project$Activities$Messages$SendBrowserExtensionMessage(
							_List_fromArray(
								[activity.aC])))) : $author$project$Activities$Views$ActionBar$acceptButton(
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						A2($author$project$Activities$Messages$AcceptActivity, activity, true))),
					A2(
					$author$project$Activities$Views$ActionBar$deleteButton,
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						$author$project$Activities$Messages$DeleteActivity(activity)),
					activity),
					$author$project$Activities$Views$ActionBar$acceptAndUpgradeButton(activity),
					A2(
					$author$project$Activities$Views$ActionBar$downgradeButton,
					downgradeContext,
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						$author$project$Activities$Messages$BlockActivity(activity)))
				]))
		]);
};
var $author$project$Model$Fee$Merge$Checked = 0;
var $author$project$TimesheetPage$Messages$SetActivityConsolidating = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm_community$html_extra$Html$Events$Extra$onEnter = function (onEnterAction) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				return (keyCode === 13) ? $elm$json$Json$Decode$succeed(onEnterAction) : $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(keyCode));
			},
			$elm$html$Html$Events$keyCode));
};
var $author$project$Icons$Tick$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 40 40')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M 17 24.17 L 12.83 20 L 11.41 21.41 L 17 27 L 29 15 L 27.59 13.59 Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$CheckBox$view = function (model) {
	return A2(
		$elm$html$Html$div,
		A3(
			$author$project$CoreX$Appendable$andAppendIf,
			model.gJ && model.hN,
			_List_fromArray(
				[
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(model.gc),
					$elm$html$Html$Attributes$tabindex(0),
					$elm_community$html_extra$Html$Events$Extra$onEnter(model.gc)
				]),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				model.hM,
				_List_Nil,
				A2(
					$author$project$CoreX$Appendable$andAppend,
					model.gU,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-6'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', model.i_),
							A2($elm$html$Html$Attributes$attribute, 'data-tour', model.i_),
							$elm$html$Html$Attributes$title('Select')
						])))),
		model.hN ? _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					model.gJ,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cursor-pointer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center mt-0 pt-0 mx-1 font-light')
						])),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('group tick inline-block'),
								$elm$html$Html$Attributes$class(model.ga),
								$elm$html$Html$Attributes$class('mx-1'),
								$elm$html$Html$Attributes$class('border-[1.5px] rounded-4 text-white'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('border-mt-grey-lighter bg-white hover:border-mt-grey-dark hover:text-mt-grey-lighter', (!model.hM) && model.gJ),
										_Utils_Tuple2('bg-mt-purple border-mt-purple', model.hM && model.gJ)
									]))
							]),
						_List_fromArray(
							[
								$author$project$Icons$Tick$viewWithAttributes(
								A3(
									$author$project$CoreX$Appendable$andAppendIf,
									!model.gJ,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('bg-mt-grey-lighter text-mt-grey-lighter')
										]),
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('fill-current stroke-current')
										])))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(model.jw),
								A2($elm$html$Html$Attributes$attribute, 'data-role', model.hs),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('text-mt-grey-light', !model.hM),
										_Utils_Tuple2('text-mt-blue-light font-normal', model.hM)
									])),
								$elm$html$Html$Attributes$title(model.ho)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.hR)
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(model.jw + ' font-light text-mt-grey-light')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(model.hR)
					]))
			]));
};
var $author$project$Activities$Views$Activity$activityCheckbox = F3(
	function (clickMsg, isEditable, isSet) {
		var checkBoxModel = {
			ga: 'h-6 w-6',
			gc: clickMsg,
			gJ: isEditable,
			gU: (!isEditable) ? _List_fromArray(
				[
					$elm$html$Html$Attributes$title('Activity is pending')
				]) : _List_Nil,
			ho: 'Set for activity action',
			hs: 'set-activity-action',
			hM: isSet,
			hN: true,
			hR: '',
			i_: 'set-for-activity-action',
			jw: 'text-xs'
		};
		return $author$project$Components$CheckBox$view(checkBoxModel);
	});
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $author$project$Icons$CallIncoming$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('call-incoming'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('phone'),
								$elm$svg$Svg$Attributes$transform('translate(36.172678, 48.682956) rotate(-25.000000) translate(-36.172678, -48.682956) translate(23.672678, 10.682956)'),
								$elm$svg$Svg$Attributes$stroke('currentColor'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M13.5091362,18.9635122 C12.6163455,21.8619465 9.37209384,28.2284126 9.37209384,38.6804967 C9.37209384,49.1325808 11.9536384,53.8393833 12.8464291,56.7378175'),
										$elm$svg$Svg$Attributes$id('Path-Copy'),
										$elm$svg$Svg$Attributes$transform('translate(11.440615, 37.850665) scale(-1, 1) rotate(180.000000) translate(-11.440615, -37.850665) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M12.3482285,19.6200908 C18.9257016,22.1468372 24.3722297,21.3444014 24.3674408,18.4578004 C24.3570806,12.2129679 24.346259,5.69000115 24.340969,2.50137101 C24.3330341,-2.28157418 12.7673295,1.05106223 10.2766022,2.24228425 C7.78587484,3.43350626 4.32773345,7.19878337 2.28051726,16.3807952 C1.48046852,19.9691104 6.25607502e-15,29.5899009 0,37.9569801 C-6.42515812e-15,46.3240592 1.10622118,55.0761275 1.77201941,58.921382 C3.42182313,68.4496669 7.78587484,72.4804538 10.2766022,73.6716759 C12.7673295,74.8628979 24.3330341,78.1955343 24.340969,73.4125891 C24.346259,70.223959 24.3570806,63.7009922 24.3674408,57.4561597 C24.3723466,54.4990889 18.6565237,53.7291858 11.8645474,56.484894'),
										$elm$svg$Svg$Attributes$id('Path-Copy-2'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$transform('translate(12.183722, 37.956980) scale(-1, 1) rotate(180.000000) translate(-12.183722, -37.956980) ')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('ovals'),
								$elm$svg$Svg$Attributes$transform('translate(59.918584, 37.160254) rotate(155.000000) translate(-59.918584, -37.160254) translate(36.918584, 27.160254)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$ellipse,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3'),
										$elm$svg$Svg$Attributes$fillOpacity('0.4'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('5.11111111'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$rx('5.11111111'),
										$elm$svg$Svg$Attributes$ry('5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$ellipse,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3-Copy'),
										$elm$svg$Svg$Attributes$fillOpacity('0.7'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('17.8888889'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$rx('6.38888889'),
										$elm$svg$Svg$Attributes$ry('6.25')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$ellipse,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3-Copy-2'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('35.7777778'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$rx('10.2222222'),
										$elm$svg$Svg$Attributes$ry('10')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$polyline,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Path-2'),
										$elm$svg$Svg$Attributes$stroke('#FFFFFF'),
										$elm$svg$Svg$Attributes$strokeWidth('2'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round'),
										$elm$svg$Svg$Attributes$points('34.5 5 39.6111111 10 34.5 15')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$CallOutgoing$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('call-outgoing'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('phone'),
								$elm$svg$Svg$Attributes$transform('translate(36.172678, 48.682956) rotate(-25.000000) translate(-36.172678, -48.682956) translate(23.672678, 10.682956)'),
								$elm$svg$Svg$Attributes$stroke('currentColor'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M13.5091362,18.9635122 C12.6163455,21.8619465 9.37209384,28.2284126 9.37209384,38.6804967 C9.37209384,49.1325808 11.9536384,53.8393833 12.8464291,56.7378175'),
										$elm$svg$Svg$Attributes$id('Path-Copy'),
										$elm$svg$Svg$Attributes$transform('translate(11.440615, 37.850665) scale(-1, 1) rotate(180.000000) translate(-11.440615, -37.850665) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M12.3482285,19.6200908 C18.9257016,22.1468372 24.3722297,21.3444014 24.3674408,18.4578004 C24.3570806,12.2129679 24.346259,5.69000115 24.340969,2.50137101 C24.3330341,-2.28157418 12.7673295,1.05106223 10.2766022,2.24228425 C7.78587484,3.43350626 4.32773345,7.19878337 2.28051726,16.3807952 C1.48046852,19.9691104 6.25607502e-15,29.5899009 0,37.9569801 C-6.42515812e-15,46.3240592 1.10622118,55.0761275 1.77201941,58.921382 C3.42182313,68.4496669 7.78587484,72.4804538 10.2766022,73.6716759 C12.7673295,74.8628979 24.3330341,78.1955343 24.340969,73.4125891 C24.346259,70.223959 24.3570806,63.7009922 24.3674408,57.4561597 C24.3723466,54.4990889 18.6565237,53.7291858 11.8645474,56.484894'),
										$elm$svg$Svg$Attributes$id('Path-Copy-2'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$transform('translate(12.183722, 37.956980) scale(-1, 1) rotate(180.000000) translate(-12.183722, -37.956980) ')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('ovals'),
								$elm$svg$Svg$Attributes$transform('translate(59.918584, 35.160254) rotate(-30.000000) translate(-59.918584, -35.160254) translate(36.918584, 25.160254)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$ellipse,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3'),
										$elm$svg$Svg$Attributes$fillOpacity('0.4'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('5.11111111'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$rx('5.11111111'),
										$elm$svg$Svg$Attributes$ry('5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$ellipse,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3-Copy'),
										$elm$svg$Svg$Attributes$fillOpacity('0.7'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('17.8888889'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$rx('6.38888889'),
										$elm$svg$Svg$Attributes$ry('6.25')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$ellipse,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3-Copy-2'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('35.7777778'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$rx('10.2222222'),
										$elm$svg$Svg$Attributes$ry('10')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$polyline,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Path-2'),
										$elm$svg$Svg$Attributes$stroke('#FFFFFF'),
										$elm$svg$Svg$Attributes$strokeWidth('2'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round'),
										$elm$svg$Svg$Attributes$points('34.5 5 39.6111111 10 34.5 15')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$Icons$ConsolidatedEmails$viewWithAttributes = F2(
	function (attributes, otherAttributes) {
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
						$elm$svg$Svg$Attributes$version('1.1')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('consolidated-email'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$strokeWidth('1'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$fillRule('evenodd')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('envelope'),
										$elm$svg$Svg$Attributes$strokeWidth('3')
									]),
								otherAttributes),
							A2(
								$elm$core$List$concatMap,
								function (_v0) {
									var x_coord = _v0.a;
									var y_coord = _v0.b;
									return _List_fromArray(
										[
											A2(
											$elm$svg$Svg$rect,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$x(x_coord),
													$elm$svg$Svg$Attributes$y(y_coord),
													$elm$svg$Svg$Attributes$rx('5'),
													$elm$svg$Svg$Attributes$ry('5'),
													$elm$svg$Svg$Attributes$width('64'),
													$elm$svg$Svg$Attributes$height('46')
												]),
											_List_Nil),
											A2(
											$elm$svg$Svg$path,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$d('M1,1 L29.2317412,27.4337749 C30.7696128,28.8770561 33.1638771,28.8783197 34.7032712,27.4366626 L63,1'),
													$elm$svg$Svg$Attributes$transform('translate(' + (x_coord + (', ' + (y_coord + ')')))),
													$elm$svg$Svg$Attributes$strokeLinejoin('round')
												]),
											_List_Nil)
										]);
								},
								_List_fromArray(
									[
										_Utils_Tuple2('12', '21'),
										_Utils_Tuple2('16', '25'),
										_Utils_Tuple2('20', '29'),
										_Utils_Tuple2('24', '33')
									])))
						]))
				]));
	});
var $author$project$Icons$DefaultFeeType$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('other'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('book'),
								$elm$svg$Svg$Attributes$transform('translate(27.000000, 18.000000)'),
								$elm$svg$Svg$Attributes$stroke('currentColor')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M4.375,10.5 L37.625,10.5 C40.0412458,10.5 42,12.4587542 42,14.875 L42,51.625 C42,54.0412458 40.0412458,56 37.625,56 L4.375,56 C1.95875422,56 0,54.0412458 0,51.625 L0,5.25'),
										$elm$svg$Svg$Attributes$id('Rectangle-3'),
										$elm$svg$Svg$Attributes$strokeWidth('3')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M4.375,10.5 C1.95875422,10.5 0,7.66624578 0,5.25 C0,2.83375422 1.95875422,0 4.375,0 L37.625,0'),
										$elm$svg$Svg$Attributes$id('Rectangle-4'),
										$elm$svg$Svg$Attributes$strokeWidth('3'),
										$elm$svg$Svg$Attributes$strokeLinecap('round')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M4.375,5.25 L39.375,5.25'),
										$elm$svg$Svg$Attributes$id('Path-24'),
										$elm$svg$Svg$Attributes$strokeWidth('2'),
										$elm$svg$Svg$Attributes$strokeLinecap('round')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $author$project$Icons$Document$sanitiseExtension = function (extension) {
	return A2($elm$core$String$left, 4, extension);
};
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $author$project$Icons$Document$viewWithAttributes = F2(
	function (documentExtension, attributes) {
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('bg-transparent'),
						$elm$svg$Svg$Attributes$width('100%'),
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('1'),
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$d('m 9,12 h 6 m 2,9 H 7 C 5.8954305,21 5,20.104569 5,19 V 5 C 5,3.8954305 5.8954305,3 7,3 h 5.586 c 0.265195,5.66e-5 0.519507,0.1054506 0.707,0.293 l 5.414,5.414 C 18.894549,8.8944927 18.999943,9.1488052 19,9.414 V 19 c 0,1.104569 -0.895431,2 -2,2 z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('currentColor'),
							$elm$svg$Svg$Attributes$textAnchor('middle'),
							$elm$svg$Svg$Attributes$fontSize('0.35rem'),
							$elm$svg$Svg$Attributes$x('50%'),
							$elm$svg$Svg$Attributes$y('75%')
						]),
					_List_fromArray(
						[
							$elm$svg$Svg$text(
							$author$project$Icons$Document$sanitiseExtension(documentExtension))
						]))
				]));
	});
var $author$project$Icons$EmailIncoming$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('mail-incoming'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('envelope'),
								$elm$svg$Svg$Attributes$transform('translate(16.000000, 25.000000)'),
								$elm$svg$Svg$Attributes$stroke('currentColor'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M0,31 C0,24.5555556 0,15.8888889 0,3 C0,1.34314575 1.34314575,0 3,0 L61,0 C62.6568542,0 64,1.34314575 64,3 C64,8.33333333 64,13.6666667 64,19 C64,27 64,36 64,39 C64,41 64,41.6666667 64,41 C64,43.209139 62.209139,45 60,45 C51.1111111,45 45.4444444,45 41,45'),
										$elm$svg$Svg$Attributes$id('Rectangle-3'),
										$elm$svg$Svg$Attributes$strokeLinecap('round')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M1,1 L29.2317412,27.4337749 C30.7696128,28.8770561 33.1638771,28.8783197 34.7032712,27.4366626 L63,1'),
										$elm$svg$Svg$Attributes$id('Path-10'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('ovals'),
								$elm$svg$Svg$Attributes$transform('translate(30.500000, 69.000000) rotate(180.000000) translate(-30.500000, -69.000000) translate(8.000000, 59.000000)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3'),
										$elm$svg$Svg$Attributes$fillOpacity('0.4'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('5'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$r('5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3-Copy'),
										$elm$svg$Svg$Attributes$fillOpacity('0.7'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('17.5'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$r('6.25')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3-Copy-2'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$cx('35'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$r('10')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$polyline,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Path-2'),
										$elm$svg$Svg$Attributes$stroke('#FFFFFF'),
										$elm$svg$Svg$Attributes$strokeWidth('2'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round'),
										$elm$svg$Svg$Attributes$points('33.75 5 38.75 10 33.75 15')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$EmailOutgoing$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('mail-outgoing'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('ovals'),
								$elm$svg$Svg$Attributes$transform('translate(43.000000, 60.000000)'),
								$elm$svg$Svg$Attributes$fill('currentColor')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3'),
										$elm$svg$Svg$Attributes$fillOpacity('0.4'),
										$elm$svg$Svg$Attributes$cx('5'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$r('5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3-Copy'),
										$elm$svg$Svg$Attributes$fillOpacity('0.7'),
										$elm$svg$Svg$Attributes$cx('17.5'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$r('6.25')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Oval-3-Copy-2'),
										$elm$svg$Svg$Attributes$cx('35'),
										$elm$svg$Svg$Attributes$cy('10'),
										$elm$svg$Svg$Attributes$r('10')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('envelope'),
								$elm$svg$Svg$Attributes$transform('translate(16.000000, 25.000000)'),
								$elm$svg$Svg$Attributes$stroke('currentColor'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M23,45 L4,45 C1.790861,45 0,43.209139 0,41 L0,3 C0,1.34314575 1.34314575,0 3,0 L61,0 C62.6568542,0 64,1.34314575 64,3 C64,8.33333333 64,25.6666667 64,31'),
										$elm$svg$Svg$Attributes$id('Rectangle-3'),
										$elm$svg$Svg$Attributes$strokeLinecap('round')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M1,1 L29.2317412,27.4337749 C30.7696128,28.8770561 33.1638771,28.8783197 34.7032712,27.4366626 L63,1'),
										$elm$svg$Svg$Attributes$id('Path-10'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$polyline,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('arrow'),
								$elm$svg$Svg$Attributes$stroke('#FFFFFF'),
								$elm$svg$Svg$Attributes$strokeWidth('2'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round'),
								$elm$svg$Svg$Attributes$points('76.75 65 81.75 70 76.75 75')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Icons$Globe$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 -960 960 960'),
					$elm$svg$Svg$Attributes$fill('currentColor')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M480-120q-74.31 0-140-28.42-65.69-28.43-114.42-77.16-48.73-48.73-77.16-114.42Q120-405.69 120-480q0-74.54 28.42-140.12 28.43-65.57 77.16-114.3 48.73-48.73 114.42-77.16Q405.69-840 480-840q74.54 0 140.12 28.42 65.57 28.43 114.3 77.16 48.73 48.73 77.16 114.3Q840-554.54 840-480q0 74.31-28.42 140-28.43 65.69-77.16 114.42-48.73 48.73-114.3 77.16Q554.54-120 480-120Zm0-39.69q35.23-45.23 58.08-88.85 22.84-43.61 37.15-97.61H384.77q15.85 57.07 37.92 100.69 22.08 43.61 57.31 85.77Zm-50.92-6q-28-33-51.12-81.58-23.11-48.58-34.42-98.88H190.15q34.39 74.61 97.5 122.38 63.12 47.77 141.43 58.08Zm101.84 0q78.31-10.31 141.43-58.08 63.11-47.77 97.5-122.38H616.46q-15.15 51.07-38.27 99.65-23.11 48.58-47.27 80.81ZM173.85-386.15h161.38q-4.54-24.62-6.42-47.97-1.89-23.34-1.89-45.88 0-22.54 1.89-45.88 1.88-23.35 6.42-47.97H173.85q-6.54 20.77-10.2 45.27Q160-504.08 160-480t3.65 48.58q3.66 24.5 10.2 45.27Zm201.38 0h209.54q4.54-24.62 6.42-47.2 1.89-22.57 1.89-46.65t-1.89-46.65q-1.88-22.58-6.42-47.2H375.23q-4.54 24.62-6.42 47.2-1.89 22.57-1.89 46.65t1.89 46.65q1.88 22.58 6.42 47.2Zm249.54 0h161.38q6.54-20.77 10.2-45.27Q800-455.92 800-480t-3.65-48.58q-3.66-24.5-10.2-45.27H624.77q4.54 24.62 6.42 47.97 1.89 23.34 1.89 45.88 0 22.54-1.89 45.88-1.88 23.35-6.42 47.97Zm-8.31-227.7h153.39Q734.69-690 673.5-736.23q-61.19-46.23-142.58-58.85 28 36.85 50.35 84.27 22.35 47.43 35.19 96.96Zm-231.69 0h190.46q-15.85-56.3-39.08-101.84-23.23-45.54-56.15-84.62-32.92 39.08-56.15 84.62-23.23 45.54-39.08 101.84Zm-194.62 0h153.39q12.84-49.53 35.19-96.96 22.35-47.42 50.35-84.27-82.16 12.62-142.96 59.23-60.81 46.62-95.97 122Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$MSTeamsMeeting$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 48 48'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M32.1699 19.5879H45.6415V29.0615C45.6415 32.7816 42.6257 35.7973 38.9057 35.7973C35.1856 35.7973 32.1699 32.7816 32.1699 29.0615V19.5879Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.6367 19.5879H31.7573V31.2127C31.7573 36.7689 27.2532 41.273 21.697 41.273C16.1409 41.273 11.6367 36.7688 11.6367 31.2127V19.5879Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('22.2841'),
						$elm$svg$Svg$Attributes$cy('11.8514'),
						$elm$svg$Svg$Attributes$r('4.78015'),
						$elm$svg$Svg$Attributes$stroke('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('38.7115'),
						$elm$svg$Svg$Attributes$cy('13.6109'),
						$elm$svg$Svg$Attributes$r('3.0201'),
						$elm$svg$Svg$Attributes$stroke('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('2.14258'),
						$elm$svg$Svg$Attributes$y('12.8301'),
						$elm$svg$Svg$Attributes$width('17.9916'),
						$elm$svg$Svg$Attributes$height('17.2094'),
						$elm$svg$Svg$Attributes$rx('1.88889'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M13.6201 18.3174V19.1719H11.2031V25.4902H10.2168V19.1719H7.7998V18.3174H13.6201Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$Meeting$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('meeting'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('hand'),
								$elm$svg$Svg$Attributes$transform('translate(14.000000, 14.000000)'),
								$elm$svg$Svg$Attributes$stroke('currentColor'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M26.6823499,38.3587129 L18.0736542,38.3587129 C14.90402,38.3587129 12.3345238,35.7892167 12.3345238,32.6195824 L12.3345238,5.83697374 C12.3345238,2.66733953 14.90402,0.097843309 18.0736542,0.097843309 L19.9866977,0.097843309'),
										$elm$svg$Svg$Attributes$id('Rectangle-23'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round'),
										$elm$svg$Svg$Attributes$transform('translate(19.508437, 19.228278) rotate(45.000000) translate(-19.508437, -19.228278) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M59.8382159,27.8228951 L59.8382159,18.2576777 C59.8382159,15.0880435 57.2687197,12.5185472 54.0990855,12.5185472 L27.3164768,12.5185472 C24.1468426,12.5185472 21.5773464,15.0880435 21.5773464,18.2576777 L21.5773464,38.3446342 C21.5773464,40.4577237 23.2903439,42.1707211 25.4034333,42.1707211 C27.5165228,42.1707211 29.2295203,40.4577237 29.2295203,38.3446342 L29.2295203,27.8228951 L64.6208246,27.8228951 C66.2056418,27.8228951 67.4903899,29.1076432 67.4903899,30.6924603 L67.4903899,32.6055038 C67.4903899,34.1903209 66.2056418,35.475069 64.6208246,35.475069'),
										$elm$svg$Svg$Attributes$id('Rectangle-23'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round'),
										$elm$svg$Svg$Attributes$transform('translate(44.533868, 27.344634) rotate(45.000000) translate(-44.533868, -27.344634) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M15.1120773,32.8815389 L15.1120773,32.8815389 C17.2251667,32.8815389 18.9381642,34.5945364 18.9381642,36.7076259 L18.9381642,45.1858868 C18.9381642,46.842741 17.5950185,48.1858868 15.9381642,48.1858868 L14.2859903,48.1858868 C12.6291361,48.1858868 11.2859903,46.842741 11.2859903,45.1858868 L11.2859903,36.7076259 C11.2859903,34.5945364 12.9989878,32.8815389 15.1120773,32.8815389 Z'),
										$elm$svg$Svg$Attributes$id('Rectangle-13'),
										$elm$svg$Svg$Attributes$transform('translate(15.112077, 40.533713) rotate(45.000000) translate(-15.112077, -40.533713) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M20.5229813,38.292443 L20.5229813,38.292443 C22.6360708,38.292443 24.3490683,40.0054405 24.3490683,42.11853 L24.3490683,50.5967908 C24.3490683,52.2536451 23.0059225,53.5967908 21.3490683,53.5967908 L19.6968944,53.5967908 C18.0400401,53.5967908 16.6968944,52.2536451 16.6968944,50.5967908 L16.6968944,42.11853 C16.6968944,40.0054405 18.4098919,38.292443 20.5229813,38.292443 Z'),
										$elm$svg$Svg$Attributes$id('Rectangle-13-Copy'),
										$elm$svg$Svg$Attributes$transform('translate(20.522981, 45.944617) rotate(45.000000) translate(-20.522981, -45.944617) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M25.9338854,43.7033471 L25.9338854,43.7033471 C28.0469749,43.7033471 29.7599724,45.4163445 29.7599724,47.529434 L29.7599724,56.0076949 C29.7599724,57.6645491 28.4168266,59.0076949 26.7599724,59.0076949 L25.1077984,59.0076949 C23.4509442,59.0076949 22.1077984,57.6645491 22.1077984,56.0076949 L22.1077984,47.529434 C22.1077984,45.4163445 23.8207959,43.7033471 25.9338854,43.7033471 Z'),
										$elm$svg$Svg$Attributes$id('Rectangle-13-Copy-2'),
										$elm$svg$Svg$Attributes$transform('translate(25.933885, 51.355521) rotate(45.000000) translate(-25.933885, -51.355521) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M31.3447895,49.1142511 L31.3447895,49.1142511 C33.4578789,49.1142511 35.1708764,50.8272486 35.1708764,52.9403381 L35.1708764,61.418599 C35.1708764,63.0754532 33.8277307,64.418599 32.1708764,64.418599 L30.5187025,64.418599 C28.8618483,64.418599 27.5187025,63.0754532 27.5187025,61.418599 L27.5187025,52.9403381 C27.5187025,50.8272486 29.2317,49.1142511 31.3447895,49.1142511 Z'),
										$elm$svg$Svg$Attributes$id('Rectangle-13-Copy-3'),
										$elm$svg$Svg$Attributes$transform('translate(31.344789, 56.766425) rotate(45.000000) translate(-31.344789, -56.766425) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M50.7272256,38.968806 L50.7272256,51.4035886 C50.7272256,52.9884057 49.4424775,54.2731538 47.8576604,54.2731538 L45.9446169,54.2731538 C44.3597998,54.2731538 43.0750517,52.9884057 43.0750517,51.4035886'),
										$elm$svg$Svg$Attributes$id('Rectangle-13-Copy-5'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$transform('translate(46.901139, 46.620980) rotate(-45.000000) translate(-46.901139, -46.620980) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M45.3163215,44.3797101 L45.3163215,56.8144927 C45.3163215,58.3993098 44.0315734,59.6840579 42.4467563,59.6840579 L40.5337128,59.6840579 C38.9488957,59.6840579 37.6641476,58.3993098 37.6641476,56.8144927 L37.6641476,51.0753622'),
										$elm$svg$Svg$Attributes$id('Rectangle-13-Copy-6'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$transform('translate(41.490235, 52.031884) rotate(-45.000000) translate(-41.490235, -52.031884) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M42.272688,55.5057108 L42.272688,61.2448412 C42.272688,62.8296583 40.9879399,64.1144064 39.4031228,64.1144064 L37.4900793,64.1144064 C35.9052622,64.1144064 34.6205141,62.8296583 34.6205141,61.2448412 L34.6205141,56.4622325'),
										$elm$svg$Svg$Attributes$id('Rectangle-13-Copy-7'),
										$elm$svg$Svg$Attributes$transform('translate(38.446601, 59.810059) rotate(-45.000000) translate(-38.446601, -59.810059) ')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$MergeArrow$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 -960 960 960'),
					$elm$svg$Svg$Attributes$fill('currentColor')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M664-160 440-384v-301L336-581l-57-57 201-201 200 200-57 57-103-103v269l200 200-56 56Zm-368 1-56-56 127-128 57 57-128 127Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$ReadingDocument$sanitiseExtension = function (extension) {
	return A2($elm$core$String$left, 4, extension);
};
var $author$project$Icons$ReadingDocument$viewWithAttributes = F2(
	function (documentExtension, attributes) {
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('bg-transparent p-4px'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$width('100%'),
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 52 64')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$strokeWidth('3'),
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$d('M8.61166 1.5H34.8116L49.8151 18.27V55.3876C49.8151 59.3087 46.6231 62.5 42.7035 62.5H8.61242C4.69206 62.5 1.5 59.3079 1.5 55.3876V8.61242C1.5 4.69189 4.69148 1.5 8.61166 1.5Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('currentColor'),
							$elm$svg$Svg$Attributes$d('M24.6667 37.6667C26.2444 37.6667 27.5833 37.1167 28.6833 36.0167C29.7833 34.9167 30.3333 33.5778 30.3333 32C30.3333 30.4222 29.7833 29.0833 28.6833 27.9833C27.5833 26.8833 26.2444 26.3333 24.6667 26.3333C23.0889 26.3333 21.75 26.8833 20.65 27.9833C19.55 29.0833 19 30.4222 19 32C19 33.5778 19.55 34.9167 20.65 36.0167C21.75 37.1167 23.0889 37.6667 24.6667 37.6667ZM24.6667 35.7333C23.6222 35.7333 22.7389 35.3722 22.0167 34.65C21.2944 33.9278 20.9333 33.0444 20.9333 32C20.9333 30.9556 21.2944 30.0722 22.0167 29.35C22.7389 28.6278 23.6222 28.2667 24.6667 28.2667C25.7111 28.2667 26.5944 28.6278 27.3167 29.35C28.0389 30.0722 28.4 30.9556 28.4 32C28.4 33.0444 28.0389 33.9278 27.3167 34.65C26.5944 35.3722 25.7111 35.7333 24.6667 35.7333ZM24.6667 42C21.4222 42 18.4889 41.0778 15.8667 39.2333C13.2444 37.3889 11.2889 34.9778 10 32C11.2889 29.0222 13.2444 26.6111 15.8667 24.7667C18.4889 22.9222 21.4222 22 24.6667 22C27.9111 22 30.8444 22.9222 33.4667 24.7667C36.0889 26.6111 38.0444 29.0222 39.3333 32C38.0444 34.9778 36.0889 37.3889 33.4667 39.2333C30.8444 41.0778 27.9111 42 24.6667 42ZM24.6667 40C27.3556 40 29.8278 39.2722 32.0833 37.8167C34.3389 36.3611 36.0556 34.4222 37.2333 32C36.0556 29.5778 34.3389 27.6389 32.0833 26.1833C29.8278 24.7278 27.3556 24 24.6667 24C21.9778 24 19.5056 24.7278 17.25 26.1833C14.9944 27.6389 13.2667 29.5778 12.0667 32C13.2667 34.4222 14.9944 36.3611 17.25 37.8167C19.5056 39.2722 21.9778 40 24.6667 40Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('currentColor'),
							$elm$svg$Svg$Attributes$textAnchor('middle'),
							$elm$svg$Svg$Attributes$fontSize('1rem'),
							$elm$svg$Svg$Attributes$x('50%'),
							$elm$svg$Svg$Attributes$y('85%')
						]),
					_List_fromArray(
						[
							$elm$svg$Svg$text(
							$author$project$Icons$ReadingDocument$sanitiseExtension(documentExtension))
						]))
				]));
	});
var $author$project$Components$ActivityIconSelector$feeTypeIcon = F4(
	function (eventType, direction, maybeExtension, otherAttrs) {
		if (!eventType.$) {
			switch (eventType.a) {
				case 9:
					var _v1 = eventType.a;
					return $author$project$Icons$MergeArrow$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('mx-auto')
							]));
				case 7:
					var _v2 = eventType.a;
					var attrs = $elm$core$List$isEmpty(otherAttrs) ? _List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('fill-white stroke-mt-purple')
						]) : otherAttrs;
					return A2(
						$author$project$Icons$ConsolidatedEmails$viewWithAttributes,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--email-consolidated')
							]),
						attrs);
				case 6:
					var _v3 = eventType.a;
					return (!direction) ? $author$project$Icons$EmailIncoming$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--email-incoming')
							])) : $author$project$Icons$EmailOutgoing$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--email-outgoing')
							]));
				case 2:
					var _v4 = eventType.a;
					return (!direction) ? $author$project$Icons$CallIncoming$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--call-incoming')
							])) : $author$project$Icons$CallOutgoing$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--call-outgoing')
							]));
				case 1:
					var _v5 = eventType.a;
					return $author$project$Icons$MSTeamsMeeting$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--ms-teams-meeting')
							]));
				case 0:
					var _v6 = eventType.a;
					return $author$project$Icons$Meeting$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--meeting')
							]));
				case 3:
					var _v7 = eventType.a;
					var extension = A2($elm$core$Maybe$withDefault, '', maybeExtension);
					return A2(
						$author$project$Icons$Document$viewWithAttributes,
						extension,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--drafting')
							]));
				case 4:
					var _v8 = eventType.a;
					var extension = A2($elm$core$Maybe$withDefault, '', maybeExtension);
					return A2(
						$author$project$Icons$Document$viewWithAttributes,
						extension,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--drafting')
							]));
				case 5:
					var _v9 = eventType.a;
					var extension = A2($elm$core$Maybe$withDefault, '', maybeExtension);
					return A2(
						$author$project$Icons$ReadingDocument$viewWithAttributes,
						extension,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--reading')
							]));
				default:
					var _v10 = eventType.a;
					return $author$project$Icons$Globe$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('icon icon--research')
							]));
			}
		} else {
			return $author$project$Icons$DefaultFeeType$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('icon icon--default')
					]));
		}
	});
var $author$project$Components$ActivityIconSelector$activityIcon = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 3:
			var act = _v0.a;
			return A4(
				$author$project$Components$ActivityIconSelector$feeTypeIcon,
				$elm$core$Maybe$Just(6),
				act.df,
				$elm$core$Maybe$Nothing,
				_List_Nil);
		case 4:
			var act = _v0.a;
			return A4(
				$author$project$Components$ActivityIconSelector$feeTypeIcon,
				$elm$core$Maybe$Just(2),
				act.df,
				$elm$core$Maybe$Nothing,
				_List_Nil);
		case 1:
			var _v1 = _v0.a;
			return A4(
				$author$project$Components$ActivityIconSelector$feeTypeIcon,
				$elm$core$Maybe$Just(1),
				2,
				$elm$core$Maybe$Nothing,
				_List_Nil);
		case 0:
			return A4(
				$author$project$Components$ActivityIconSelector$feeTypeIcon,
				$elm$core$Maybe$Just(0),
				2,
				$elm$core$Maybe$Nothing,
				_List_Nil);
		case 2:
			switch (_v0.a) {
				case 0:
					var _v2 = _v0.a;
					var act = _v0.b;
					return A4(
						$author$project$Components$ActivityIconSelector$feeTypeIcon,
						$elm$core$Maybe$Just(3),
						2,
						$elm$core$Maybe$Just(act.dv),
						_List_Nil);
				case 1:
					var _v3 = _v0.a;
					var act = _v0.b;
					return A4(
						$author$project$Components$ActivityIconSelector$feeTypeIcon,
						$elm$core$Maybe$Just(3),
						2,
						$elm$core$Maybe$Just(act.dv),
						_List_Nil);
				default:
					var _v4 = _v0.a;
					var act = _v0.b;
					return A4(
						$author$project$Components$ActivityIconSelector$feeTypeIcon,
						$elm$core$Maybe$Just(5),
						2,
						$elm$core$Maybe$Just(act.dv),
						_List_Nil);
			}
		default:
			var act = _v0.a;
			return (act.aR === 'pdf') ? A2(
				$author$project$Icons$ReadingDocument$viewWithAttributes,
				'pdf',
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('icon icon--reading')
					])) : A4(
				$author$project$Components$ActivityIconSelector$feeTypeIcon,
				$elm$core$Maybe$Just(8),
				2,
				$elm$core$Maybe$Nothing,
				_List_Nil);
	}
};
var $author$project$Activities$ActivityLogic$getDocumentMatterDescription = function (activity) {
	var _v0 = activity.i;
	if (_v0.$ === 2) {
		var doc = _v0.b;
		var _v1 = _Utils_Tuple2(doc.hZ, doc.h_);
		if (!_v1.a.$) {
			if (_v1.b.$ === 1) {
				var mc = _v1.a.a;
				var _v4 = _v1.b;
				return mc + ': matter id';
			} else {
				var mc = _v1.a.a;
				var md = _v1.b.a;
				return mc + (': ' + md);
			}
		} else {
			if (_v1.b.$ === 1) {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				return 'missing: matter id';
			} else {
				var _v5 = _v1.a;
				return '';
			}
		}
	} else {
		return '';
	}
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm$html$Html$mark = _VirtualDom_node('mark');
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$MarkMatchingTerms$buildTextWithMark = F3(
	function (matches, string, elemList) {
		var _v0 = $elm$core$List$head(matches);
		if (_v0.$ === 1) {
			return function (a) {
				return _Utils_ap(
					a,
					_List_fromArray(
						[
							$elm$html$Html$text(string)
						]));
			}(elemList);
		} else {
			var match = _v0.a;
			var _v1 = $elm$core$List$head(
				A3(
					$elm$regex$Regex$findAtMost,
					1,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$regex$Regex$never,
						A2(
							$elm$regex$Regex$fromStringWith,
							{cZ: true, en: false},
							match.bX)),
					string));
			if (_v1.$ === 1) {
				return elemList;
			} else {
				var newMatch = _v1.a;
				var remainderString = A2(
					$elm$core$String$dropLeft,
					newMatch.d0 + $elm$core$String$length(newMatch.bX),
					string);
				var remainderMatches = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(matches));
				var nonMatchedString = A3($elm$core$String$slice, 0, newMatch.d0, string);
				var newElemList = function (a) {
					return _Utils_ap(
						a,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$mark,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(newMatch.bX)
									]))
							]));
				}(
					function (a) {
						return _Utils_ap(
							a,
							_List_fromArray(
								[
									$elm$html$Html$text(nonMatchedString)
								]));
					}(elemList));
				return A3($author$project$Components$MarkMatchingTerms$buildTextWithMark, remainderMatches, remainderString, newElemList);
			}
		}
	});
var $author$project$Components$MarkMatchingTerms$markedTexts = F2(
	function (searchTerms, textToDisplay) {
		if (searchTerms.$ === 1) {
			return _List_fromArray(
				[
					$elm$html$Html$text(textToDisplay)
				]);
		} else {
			var string = searchTerms.a;
			var regexString = A2(
				$elm$core$String$join,
				'|',
				$elm$core$String$words(
					$elm$core$String$trim(string)));
			var pattern = A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				A2(
					$elm$regex$Regex$fromStringWith,
					{cZ: true, en: false},
					'(' + (regexString + ')')));
			var matches = A2($elm$regex$Regex$find, pattern, textToDisplay);
			return A3($author$project$Components$MarkMatchingTerms$buildTextWithMark, matches, textToDisplay, _List_Nil);
		}
	});
var $author$project$Activities$Views$ActivityFeedRowData$noDescription = $elm$html$Html$text('(No Description)');
var $author$project$Activities$Views$ActivityFeedRowData$truncate = function (html) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('truncate')
				]),
			html)
		]);
};
var $author$project$Activities$Views$ActivityFeedRowData$renderDescription = F3(
	function (activity, activitySearchTerms, rowType) {
		var _v0 = _Utils_Tuple2(activity.i, rowType);
		switch (_v0.a.$) {
			case 4:
				var phone = _v0.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_fromArray(
						[$author$project$Activities$Views$ActivityFeedRowData$noDescription]),
					A2(
						$elm$core$Maybe$map,
						A3(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $elm$core$Basics$always, $author$project$Activities$Views$ActivityFeedRowData$truncate),
							$author$project$Components$MarkMatchingTerms$markedTexts(activitySearchTerms),
							phone.a9),
						activity.c2));
			case 2:
				var _v1 = _v0.a;
				var doc = _v1.b;
				var _v2 = doc.jb;
				if (!_v2) {
					return _List_Nil;
				} else {
					return $author$project$Activities$Views$ActivityFeedRowData$truncate(
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Activities$ActivityLogic$getDocumentMatterDescription(activity))
							]));
				}
			case 5:
				if (!_v0.b) {
					var event = _v0.a.a;
					var _v3 = _v0.b;
					return (event.aR === 'pdf') ? _List_fromArray(
						[
							$elm$html$Html$text(event.jR)
						]) : _List_fromArray(
						[
							$elm$html$Html$text(event.fX)
						]);
				} else {
					var act = _v0.a.a;
					return $author$project$Activities$Views$ActivityFeedRowData$truncate(
						A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, act.jR));
				}
			case 1:
				var _v4 = _v0.a;
				var _v5 = _v4.a;
				var call = _v4.b;
				return $author$project$Activities$Views$ActivityFeedRowData$truncate(
					A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, call.ai));
			case 3:
				var email = _v0.a.a;
				var _v6 = email.cB;
				if (_v6 === '') {
					return _List_fromArray(
						[$author$project$Activities$Views$ActivityFeedRowData$noDescription]);
				} else {
					var subject = _v6;
					var content = A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, subject);
					return A2(
						$elm$core$Maybe$withDefault,
						content,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always(
								$author$project$Activities$Views$ActivityFeedRowData$truncate(content)),
							email.X));
				}
			default:
				var appt = _v0.a.a;
				return (appt.cB === '') ? _List_fromArray(
					[$author$project$Activities$Views$ActivityFeedRowData$noDescription]) : $author$project$Activities$Views$ActivityFeedRowData$truncate(
					A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, appt.cB));
		}
	});
var $author$project$Activities$Model$Event$isTitan = function (doc) {
	return doc.dr === 'Titan';
};
var $author$project$CoreX$DateFormat$formatDuration = function (timeInSeconds) {
	var hours = (timeInSeconds / 3600) | 0;
	var hourRemainder = A2($elm$core$Basics$modBy, 3600, timeInSeconds);
	var minutes = (hourRemainder / 60) | 0;
	var seconds = A2($elm$core$Basics$modBy, 60, hourRemainder);
	return A2(
		$elm$core$String$join,
		':',
		A2(
			$elm$core$List$map,
			A2($elm$core$String$padLeft, 2, '0'),
			A2(
				$elm$core$List$map,
				$elm$core$String$fromInt,
				A2(
					$author$project$CoreX$Appendable$andAppend,
					_List_fromArray(
						[minutes, seconds]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						hours > 0,
						_List_fromArray(
							[hours]),
						_List_Nil)))));
};
var $author$project$Activities$Views$ActivityFeedRowData$renderFormattedDuration = function (duration) {
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Duration: '),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-mt-grey-dark font-medium')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$CoreX$DateFormat$formatDuration(duration))
					]))
			]));
};
var $author$project$Activities$Views$ActivityFeedRowData$renderCompletedDuration = F2(
	function (leading, duration) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(leading),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('—')
						])),
					$author$project$Activities$Views$ActivityFeedRowData$renderFormattedDuration(duration)
				]));
	});
var $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration = function (leading) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(leading),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('—')
					])),
				$elm$html$Html$text('Duration: '),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-mt-red-light pl-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Pending')
					]))
			]));
};
var $author$project$Activities$Views$ActivityFeedRowData$renderZeroDuration = function (txt) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-mt-red-light')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(txt)
			]));
};
var $author$project$Activities$Views$ActivityFeedRowData$renderDuration = F2(
	function (activity, duration) {
		var _v0 = _Utils_Tuple2(activity.i, duration);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					switch (_v0.a.a) {
						case 1:
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var _v2 = _v1.a;
								var doc = _v1.b;
								var d = _v0.b.a;
								var _v3 = _Utils_Tuple2(doc.jb, d > 0);
								if (!_v3.a) {
									if (_v3.b) {
										var _v4 = _v3.a;
										return A2($author$project$Activities$Views$ActivityFeedRowData$renderCompletedDuration, 'Drafting', d);
									} else {
										var _v5 = _v3.a;
										return $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration('Drafting');
									}
								} else {
									var _v6 = _v3.a;
									return $author$project$Activities$Model$Event$isTitan(doc) ? A2($author$project$Activities$Views$ActivityFeedRowData$renderCompletedDuration, 'Drafting', d) : A2($author$project$Activities$Views$ActivityFeedRowData$renderCompletedDuration, 'Checked In', d);
								}
							} else {
								break _v0$7;
							}
						case 0:
							var _v7 = _v0.a;
							var _v8 = _v7.a;
							var doc = _v7.b;
							var _v9 = doc.jb;
							if (!_v9) {
								return $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration('Drafting');
							} else {
								return $author$project$Activities$Model$Event$isTitan(doc) ? $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration('Drafting') : $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration('Checked Out');
							}
						default:
							if (!_v0.b.$) {
								var _v10 = _v0.a;
								var _v11 = _v10.a;
								var doc = _v10.b;
								var d = _v0.b.a;
								var _v12 = _Utils_Tuple2(doc.jb, d > 0);
								if (!_v12.a) {
									if (_v12.b) {
										var _v13 = _v12.a;
										return A2($author$project$Activities$Views$ActivityFeedRowData$renderCompletedDuration, 'Reading', d);
									} else {
										var _v14 = _v12.a;
										return $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration('Reading');
									}
								} else {
									var _v15 = _v12.a;
									return $author$project$Activities$Model$Event$isTitan(doc) ? A2($author$project$Activities$Views$ActivityFeedRowData$renderCompletedDuration, 'Drafting', d) : A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('hidden')
											]),
										_List_Nil);
								}
							} else {
								var _v16 = _v0.a;
								var _v17 = _v16.a;
								var doc = _v16.b;
								var _v18 = _v0.b;
								return $author$project$Activities$Model$Event$isTitan(doc) ? $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration('Drafting') : A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hidden')
										]),
									_List_Nil);
							}
					}
				case 5:
					if (!_v0.b.$) {
						var act = _v0.a.a;
						var d = _v0.b.a;
						return (act.aR === 'pdf') ? A2($author$project$Activities$Views$ActivityFeedRowData$renderCompletedDuration, 'Reading', d) : A2($author$project$Activities$Views$ActivityFeedRowData$renderCompletedDuration, 'Complete', d);
					} else {
						var act = _v0.a.a;
						return (act.aR === 'pdf') ? $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration('Reading') : $author$project$Activities$Views$ActivityFeedRowData$renderPendingDuration('Tracking');
					}
				case 4:
					if ((!_v0.b.$) && (!_v0.b.a)) {
						return $author$project$Activities$Views$ActivityFeedRowData$renderZeroDuration('Missed Call');
					} else {
						break _v0$7;
					}
				default:
					break _v0$7;
			}
		}
		var maybeDuration = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden')
					]),
				_List_Nil),
			A2($elm$core$Maybe$map, $author$project$Activities$Views$ActivityFeedRowData$renderFormattedDuration, maybeDuration));
	});
var $author$project$Activities$Views$ActivityFeedRowData$renderName = F3(
	function (activity, activitySearchTerms, rowType) {
		var getTitleByType = function (event) {
			var _v1 = _Utils_Tuple2(event, rowType);
			switch (_v1.a.$) {
				case 4:
					var phone = _v1.a.a;
					return A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, phone.a9);
				case 1:
					var _v2 = _v1.a;
					var _v3 = _v2.a;
					var call = _v2.b;
					return A2(
						$elm$core$List$cons,
						$elm$html$Html$text('Teams Meeting with '),
						A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, call.ai));
				case 3:
					var email = _v1.a.a;
					return A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, email.dl);
				case 2:
					var _v4 = _v1.a;
					var doc = _v4.b;
					return A2(
						$author$project$Components$MarkMatchingTerms$markedTexts,
						activitySearchTerms,
						$author$project$Activities$ActivityLogic$getDocumentFileName(doc));
				case 5:
					if (!_v1.b) {
						var details = _v1.a.a;
						var _v5 = _v1.b;
						return (details.aR === 'pdf') ? A2(
							$author$project$Components$MarkMatchingTerms$markedTexts,
							activitySearchTerms,
							A2($elm$core$Maybe$withDefault, details.jR, details.iD)) : A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, details.aR);
					} else {
						var details = _v1.a.a;
						return A2(
							$author$project$Components$MarkMatchingTerms$markedTexts,
							activitySearchTerms,
							A2($elm$core$Maybe$withDefault, details.aR, details.iD));
					}
				default:
					return A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, '');
			}
		};
		var _v0 = activity.c2;
		if (!_v0.$) {
			var contact = _v0.a;
			return A2($author$project$Components$MarkMatchingTerms$markedTexts, activitySearchTerms, contact.b2);
		} else {
			return getTitleByType(activity.i);
		}
	});
var $author$project$Activities$Views$ActivityFeedRowData$from = F4(
	function (activity, activitySearchTerms, rowType, headerDuration) {
		var duration = (!rowType) ? headerDuration : $author$project$Activities$ActivityLogic$getDuration(activity);
		return {
			dd: A3($author$project$Activities$Views$ActivityFeedRowData$renderDescription, activity, activitySearchTerms, rowType),
			X: A2($author$project$Activities$Views$ActivityFeedRowData$renderDuration, activity, duration),
			b2: A3($author$project$Activities$Views$ActivityFeedRowData$renderName, activity, activitySearchTerms, rowType)
		};
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Contacts$Data$stringFromContactSource = function (contactSource) {
	switch (contactSource) {
		case 0:
			return 'ActionStep';
		case 1:
			return 'Affinity';
		case 4:
			return 'FilePro';
		case 2:
			return 'Nebulaw';
		case 5:
			return 'Clio';
		case 3:
			return 'Outlook';
		default:
			return 'Nebulaw';
	}
};
var $author$project$Activities$ActivityLogic$contactDetailedName = function (activity) {
	var _v0 = _Utils_Tuple2(activity.c2, activity.i);
	if (!_v0.a.$) {
		var contact = _v0.a.a;
		var displayedContactName = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(''),
				_List_fromArray(
					[contact.b2, contact.gh])));
		return displayedContactName + (' (from ' + ($author$project$Contacts$Data$stringFromContactSource(contact.jb) + ')'));
	} else {
		switch (_v0.b.$) {
			case 4:
				var _v1 = _v0.a;
				var phone = _v0.b.a;
				return 'No Contact: <' + (phone.a9 + '>');
			case 1:
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				var _v4 = _v3.a;
				var call = _v3.b;
				return 'No Contact: ' + call.ai;
			case 3:
				var _v5 = _v0.a;
				var email = _v0.b.a;
				return 'No Contact: ' + (email.dm + (' <' + (email.dl + '>')));
			case 0:
				var _v6 = _v0.a;
				var appt = _v0.b.a;
				return (appt.ai === '') ? 'No Contact' : ('No Contact: ' + (appt.dm + (' <' + (appt.dl + '>'))));
			default:
				var _v7 = _v0.a;
				return 'No Contact';
		}
	}
};
var $author$project$Activities$ActivityLogic$getResearchBookmark = function (activity) {
	var _v0 = activity.i;
	if (_v0.$ === 5) {
		var event = _v0.a;
		return event.aR;
	} else {
		return '';
	}
};
var $author$project$Activities$ActivityLogic$isDocument = function (activity) {
	var _v0 = activity.i;
	if (_v0.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Activities$ActivityLogic$isResearchEvent = function (activity) {
	var _v0 = activity.i;
	if (_v0.$ === 5) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Activities$Views$Hovercard$renderEventType = F2(
	function (event, doc) {
		if ($author$project$Activities$Model$Event$isTitan(doc)) {
			return 'Drafting';
		} else {
			switch (event) {
				case 0:
					return 'Checked Out';
				case 1:
					return 'Checked In';
				default:
					return 'Reading';
			}
		}
	});
var $author$project$Activities$Views$Hovercard$renderBody = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 2:
			var event = _v0.a;
			var doc_act = _v0.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'hovercard-document-details'),
							$elm$html$Html$Attributes$class('hovercard-ellipsis')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Event: ' + A2($author$project$Activities$Views$Hovercard$renderEventType, event, doc_act)),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(
							$author$project$Activities$ActivityLogic$getDocumentMatterDescription(activity))
						]))
				]);
		case 3:
			var email = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'hovercard-email-body'),
							$elm$html$Html$Attributes$class('hovercard-ellipsis')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(email.fW)
						]))
				]);
		case 5:
			var details = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'hovercard-research-details'),
							$elm$html$Html$Attributes$class('hovercard-ellipsis')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(details.jR)
						]))
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$Activities$Views$Hovercard$renderDuration = function (activity) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (duration) {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						' (Duration: ' + ($author$project$CoreX$DateFormat$formatDuration(duration) + ')'))
					]);
			},
			$author$project$Activities$ActivityLogic$getDuration(activity)));
};
var $author$project$Activities$Views$Hovercard$view = function (activity) {
	return A2(
		$author$project$CoreX$Appendable$andAppend,
		$author$project$Activities$Views$Hovercard$renderBody(activity),
		A2(
			$author$project$CoreX$Appendable$andAppend,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Activities$ActivityLogic$getTitle(activity))
							]),
						$author$project$Activities$Views$Hovercard$renderDuration(activity)))
				]),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				$author$project$Activities$ActivityLogic$isResearchEvent(activity),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Bookmark: ' + $author$project$Activities$ActivityLogic$getResearchBookmark(activity))
							]))
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					!($author$project$Activities$ActivityLogic$isDocument(activity) || $author$project$Activities$ActivityLogic$isResearchEvent(activity)),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Activities$ActivityLogic$contactDetailedName(activity))
								]))
						]),
					_List_Nil))));
};
var $author$project$Activities$Views$Activity$activityRowDetails = F4(
	function (activitySearchTerms, rowType, activity, headerDuration) {
		var activityRowData = A4($author$project$Activities$Views$ActivityFeedRowData$from, activity, activitySearchTerms, rowType, headerDuration);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col justify-center'),
					$elm$html$Html$Attributes$class('w-full overflow-x-hidden'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pl-7 w-70 lg:w-70', rowType === 1),
							_Utils_Tuple2('pl-4 w-82 lg:w-70', !rowType),
							_Utils_Tuple2('pl-4 lg:w-70', rowType === 2)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hovercard')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full font-medium break-words truncate'),
									$elm$html$Html$Attributes$class('md:w-auto')
								]),
							activityRowData.b2),
							$elm$core$List$isEmpty(activityRowData.dd) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex w-full h-5 text-sm overflow-hidden text-mt-grey leading-tight max-h-xxs ellipsis description'),
									$elm$html$Html$Attributes$class('md:w-auto md:h-full md:text-11')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0 truncate'),
											$elm$html$Html$Attributes$class('md:mt-1 md:whitespace-normal')
										]),
									activityRowData.dd)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm text-mt-grey'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'duration')
								]),
							_List_fromArray(
								[activityRowData.X])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hovercardtext'),
									$elm$html$Html$Attributes$class('w-full left-0')
								]),
							$author$project$Activities$Views$Hovercard$view(activity))
						]))
				]));
	});
var $author$project$Activities$Views$Activity$activityDetailsView = F5(
	function (zone, activitySearchTerms, rowType, activity, isActivitySelected) {
		var nextConsolidateState = isActivitySelected ? 1 : 0;
		var isEditable = function () {
			var _v0 = activity.i;
			if (_v0.$ === 5) {
				return $elm_community$maybe_extra$Maybe$Extra$isJust(
					$author$project$Activities$ActivityLogic$getDuration(activity));
			} else {
				return true;
			}
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative pl-2'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('w-10', rowType === 1),
								_Utils_Tuple2('w-18', rowType !== 1)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute flex flex-col items-center inset-0 mt-4 ml-1'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('invisible group-hover:visible', !isActivitySelected)
									])),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-select')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Activities$Views$Activity$activityCheckbox,
								A2($author$project$TimesheetPage$Messages$SetActivityConsolidating, nextConsolidateState, activity.aC),
								isEditable,
								isActivitySelected)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col items-center'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('invisible', isActivitySelected),
										_Utils_Tuple2('group-hover:invisible', !isActivitySelected)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-10 h-10 text-mt-purple'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'mt-2',
												$author$project$Activities$ActivityLogic$isBinned(activity))
											]))
									]),
								_List_fromArray(
									[
										$author$project$Components$ActivityIconSelector$activityIcon(activity)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm lg:text-xxs font-light text-mt-grey-light leading-tight'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('pl-2', rowType === 1)
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$CoreX$DateFormat$to12HourTimeString, zone, activity.jg))
									]))
							]))
					])),
				A4($author$project$Activities$Views$Activity$activityRowDetails, activitySearchTerms, 2, activity, $elm$core$Maybe$Nothing)
			]);
	});
var $author$project$Activities$ActivityLogic$feedDecisionReason = function (activity) {
	return activity.g3;
};
var $author$project$Activities$Views$Activity$binnedReasonText = function (activity) {
	var _v0 = _Utils_Tuple2(
		$author$project$Activities$ActivityLogic$isBinned(activity),
		$author$project$Activities$ActivityLogic$feedDecisionReason(activity));
	if (_v0.a && (!_v0.b.$)) {
		var reason = _v0.b.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute left-0 top-0 -mt-1 font-light text-xxs text-mt-red'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'binned-reason'),
					$elm$html$Html$Attributes$title(reason)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(reason)
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hidden')
				]),
			_List_Nil);
	}
};
var $author$project$Activities$Messages$OpenKebabActivityMenu = function (a) {
	return {$: 24, a: a};
};
var $author$project$Icons$Kebab$view = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('8'),
			$elm$svg$Svg$Attributes$height('42'),
			$elm$svg$Svg$Attributes$viewBox('0 0 8 42'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('4'),
					$elm$svg$Svg$Attributes$cy('4'),
					$elm$svg$Svg$Attributes$r('4'),
					$elm$svg$Svg$Attributes$fill('#D8D8D8')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('4'),
					$elm$svg$Svg$Attributes$cy('21'),
					$elm$svg$Svg$Attributes$r('4'),
					$elm$svg$Svg$Attributes$fill('#D8D8D8')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('4'),
					$elm$svg$Svg$Attributes$cy('38'),
					$elm$svg$Svg$Attributes$r('4'),
					$elm$svg$Svg$Attributes$fill('#D8D8D8')
				]),
			_List_Nil)
		]));
var $author$project$Activities$Views$Activity$kebabMenu = F2(
	function (rowType, activity) {
		var rightAdjustment = (rowType === 1) ? '' : 'mr-2px';
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mobile lg:hidden px-3 absolute right-0 ' + rightAdjustment),
						$elm$html$Html$Events$onClick(
						$author$project$TimesheetPage$Messages$ActivityFeedComponent(
							$author$project$Activities$Messages$OpenKebabActivityMenu(activity)))
					]),
				_List_fromArray(
					[$author$project$Icons$Kebab$view]))
			]);
	});
var $author$project$Activities$Views$Activity$activityRow = F6(
	function (zone, activitySearchTerms, rowType, activity, conversationExpanded, isActivitySelected) {
		var bgClass = (rowType === 1) ? 'bg-mt-purple-lightest' : ($author$project$Activities$ActivityLogic$isBinned(activity) ? 'bg-mt-red-lightest' : 'bg-white');
		var activityTypeRole = $author$project$Activities$ActivityLogic$kindToString(activity) + '-row';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative flex flex-row items-center'),
					$elm$html$Html$Attributes$class('w-auto h-24 lg:h-18'),
					$elm$html$Html$Attributes$class(bgClass),
					$elm$html$Html$Attributes$class('border-mt-purple hover:bg-mt-purple-lightest'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('border-t border-r border-l ml-4', rowType === 1),
							_Utils_Tuple2('border-t', !rowType),
							_Utils_Tuple2('border-t border-r', rowType === 2),
							_Utils_Tuple2('bg-mt-purple-lightest', isActivitySelected)
						])),
					$elm$html$Html$Attributes$id(
					'activity-row-' + $elm$core$String$fromInt(activity.aC)),
					A2($elm$html$Html$Attributes$attribute, 'data-role', activityTypeRole)
				]),
			_List_fromArray(
				[
					$author$project$Activities$Views$Activity$binnedReasonText(activity),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative right-0 flex items-center w-full h-full z-20 group'),
							$elm$html$Html$Attributes$class('lg:static lg:z-auto'),
							$elm$html$Html$Attributes$class('lg:bg-transparent'),
							$elm$html$Html$Attributes$class(bgClass),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('open', activity.hw),
									_Utils_Tuple2('close', !activity.hw),
									_Utils_Tuple2(
									'right-72',
									activity.hw && (!$author$project$Activities$ActivityLogic$isBinned(activity))),
									_Utils_Tuple2(
									'right-36',
									activity.hw && $author$project$Activities$ActivityLogic$isBinned(activity))
								]))
						]),
					_Utils_ap(
						A5($author$project$Activities$Views$Activity$activityDetailsView, zone, activitySearchTerms, rowType, activity, isActivitySelected),
						A2($author$project$Activities$Views$Activity$kebabMenu, rowType, activity))),
					A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(
								'activity-kebab' + $elm$core$String$fromInt(activity.aC)),
								$elm$html$Html$Attributes$class('absolute right-0 h-full outline-hidden'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('-right-1', conversationExpanded)
									]))
							]),
						A2(
							$author$project$OnClickOutsideAfterFocus$withId,
							'activity-kebab' + $elm$core$String$fromInt(activity.aC),
							$author$project$TimesheetPage$Messages$ActivityFeedComponent(
								$author$project$Activities$Messages$CloseKebabActivityMenu(activity)))),
					$author$project$Activities$Views$ActionBar$actionBarView(activity))
				]));
	});
var $author$project$Activities$Views$Group$keyedAs = F2(
	function (key, view_) {
		return _Utils_Tuple2(key, view_);
	});
var $elm$virtual_dom$VirtualDom$lazy6 = _VirtualDom_lazy6;
var $elm$html$Html$Lazy$lazy6 = $elm$virtual_dom$VirtualDom$lazy6;
var $author$project$Activities$Views$Group$renderActivities = F6(
	function (zone, searchTerms, rowType, activities, groupExpanded, selectedActivityIds) {
		var isActivitySelected = function (act) {
			return A2($elm$core$Set$member, act.aC, selectedActivityIds);
		};
		return A2(
			$elm$core$List$map,
			function (activity) {
				return A2(
					$author$project$Activities$Views$Group$keyedAs,
					'activity-id' + $elm$core$String$fromInt(activity.aC),
					A7(
						$elm$html$Html$Lazy$lazy6,
						$author$project$Activities$Views$Activity$activityRow,
						zone,
						searchTerms,
						rowType,
						activity,
						groupExpanded,
						isActivitySelected(activity)));
			},
			$mgold$elm_nonempty_list$List$Nonempty$toList(activities));
	});
var $author$project$Activities$Messages$CollapseActivityGroups = function (a) {
	return {$: 29, a: a};
};
var $author$project$Activities$Messages$ExpandActivityGroups = function (a) {
	return {$: 28, a: a};
};
var $author$project$Activities$Data$InactiveActivities = 1;
var $author$project$Activities$Messages$ToggleKebabGroupMenu = function (a) {
	return {$: 25, a: a};
};
var $author$project$Activities$Messages$AcceptGroupActivities = function (a) {
	return {$: 30, a: a};
};
var $author$project$Activities$Views$Group$acceptAllActivities = F3(
	function (groupByKey, isExpanded, isKebabOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonStyle + 'bg-mt-green lg:flex'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', (!isKebabOpen) || ((!isKebabOpen) && (!isExpanded)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('group tooltip cursor-pointer'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'activities-group-bulk-accept')
						]),
					_List_fromArray(
						[
							$author$project$Icons$AcceptButton$viewWithAttributes(
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonIconStyle + 'lg:text-mt-green icon icon--tick-button'),
									$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
									$author$project$TimesheetPage$Messages$ActivityFeedComponent(
										$author$project$Activities$Messages$AcceptGroupActivities(groupByKey)))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext tooltip-left mt-12 pin-r w-28 shadow-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Charge Once All')
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$mobileButtonTitle + 'text-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Charge Once All')
						]))
				]));
	});
var $author$project$TimesheetPage$Messages$SetActivityGroupConsolidating = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Activities$Views$Group$activityGroupCheckbox = F3(
	function (clickMsg, isEditable, isSet) {
		var checkBoxModel = {
			ga: 'h-6 w-6',
			gc: clickMsg,
			gJ: isEditable,
			gU: (!isEditable) ? _List_fromArray(
				[
					$elm$html$Html$Attributes$title('Activity group is pending')
				]) : _List_Nil,
			ho: 'Set for activity group action',
			hs: 'set-activity-group-action',
			hM: isSet,
			hN: true,
			hR: '',
			i_: 'set-for-activity-group-action',
			jw: 'text-xs'
		};
		return $author$project$Components$CheckBox$view(checkBoxModel);
	});
var $mgold$elm_nonempty_list$List$Nonempty$all = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return f(x) && A2($elm$core$List$all, f, xs);
	});
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $author$project$Icons$Contracted$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 50 50')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('matrix(0,-0.79534139,0.65561996,0,8.6311105,44.883535)'),
						$elm$svg$Svg$Attributes$class('expanded-g')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$polyline,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$points('45 15 25 35 5 15'),
								$elm$svg$Svg$Attributes$stroke('#6633ff'),
								$elm$svg$Svg$Attributes$strokeWidth('6.5'),
								$elm$svg$Svg$Attributes$strokeOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('matrix(0,-0.79534139,0.65561996,0,8.6203058,44.883535)'),
						$elm$svg$Svg$Attributes$class('expanded-g')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$polyline,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$points('45 15 25 35 5 15'),
								$elm$svg$Svg$Attributes$stroke('currentColor'),
								$elm$svg$Svg$Attributes$strokeWidth('6.5'),
								$elm$svg$Svg$Attributes$strokeOpacity('1')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Icons$Contracted$view = $author$project$Icons$Contracted$viewWithAttributes(_List_Nil);
var $author$project$Icons$Expanded$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 50 50')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('matrix(-0.79534139,0,0,0.65561996,44.883535,8.6203055)'),
						$elm$svg$Svg$Attributes$class('expanded-g')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$polyline,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$points('45 15 25 35 5 15'),
								$elm$svg$Svg$Attributes$class('expanded-line')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Icons$Expanded$view = $author$project$Icons$Expanded$viewWithAttributes(_List_Nil);
var $author$project$Activities$Views$Group$expandToggler = function (groupExpanded) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute left-0 top-0 mt-7 ml-1'),
				$elm$html$Html$Attributes$class('inline-flex items-center justify-center'),
				$elm$html$Html$Attributes$class('h-3 px-1'),
				$elm$html$Html$Attributes$class('font-bold text-mt-purple'),
				$elm$html$Html$Attributes$class('cursor-pointer')
			]),
		_List_fromArray(
			[
				groupExpanded ? $author$project$Icons$Expanded$view : $author$project$Icons$Contracted$view
			]));
};
var $mgold$elm_nonempty_list$List$Nonempty$map = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			f(x),
			A2($elm$core$List$map, f, xs));
	});
var $author$project$Activities$Views$Group$activityDetailsView = F4(
	function (isExpanded, selectedActivityIds, childActivities, groupIcon) {
		var totalCount = $mgold$elm_nonempty_list$List$Nonempty$length(childActivities);
		var isEditable = A2(
			$mgold$elm_nonempty_list$List$Nonempty$all,
			function (act) {
				var _v0 = act.i;
				if (_v0.$ === 5) {
					return $elm_community$maybe_extra$Maybe$Extra$isJust(
						$author$project$Activities$ActivityLogic$getDuration(act));
				} else {
					return true;
				}
			},
			childActivities);
		var groupChecked = A2(
			$mgold$elm_nonempty_list$List$Nonempty$all,
			function (actId) {
				return A2($elm$core$Set$member, actId, selectedActivityIds);
			},
			A2(
				$mgold$elm_nonempty_list$List$Nonempty$map,
				function ($) {
					return $.aC;
				},
				childActivities));
		var nextConsolidateState = groupChecked ? 1 : 0;
		var countText = (totalCount > 99) ? '99+' : $elm$core$String$fromInt(totalCount);
		var activityIds = $elm$core$Set$fromList(
			$mgold$elm_nonempty_list$List$Nonempty$toList(
				A2(
					$mgold$elm_nonempty_list$List$Nonempty$map,
					function ($) {
						return $.aC;
					},
					childActivities)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative group flex flex-col items-center pl-2 w-18')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute mt-5'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('invisible group-hover:visible', !groupChecked)
								])),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-group-select')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Activities$Views$Group$activityGroupCheckbox,
							A2($author$project$TimesheetPage$Messages$SetActivityGroupConsolidating, nextConsolidateState, activityIds),
							isEditable,
							groupChecked)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('leading-none text-xs font-semibold text-mt-purple')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Group')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative w-10 h-10 text-mt-purple'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('invisible', groupChecked),
									_Utils_Tuple2('group-hover:invisible', !groupChecked)
								]))
						]),
					_List_fromArray(
						[
							groupIcon,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute right-0 bottom-0 inline-flex items-center justify-center h-4 px-1 rounded-full text-xs font-semibold text-white bg-mt-purple')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(countText)
								]))
						])),
					$author$project$Activities$Views$Group$expandToggler(isExpanded),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-sm lg:text-xxs font-light text-mt-grey-light leading-tight')
						]),
					_List_Nil)
				]));
	});
var $author$project$Activities$Messages$DeleteGroupActivities = function (a) {
	return {$: 31, a: a};
};
var $author$project$Activities$Views$Group$deleteAllActivities = F4(
	function (groupByKey, isExpanded, isKebabOpen, displayResearchStopButton) {
		var _v0 = displayResearchStopButton ? _Utils_Tuple3(' lg:text-mt-grey-lightest', 'Stop tracking to delete', $author$project$TimesheetPage$Messages$NoOp) : _Utils_Tuple3(
			' lg:text-mt-red-light',
			'Delete All',
			$author$project$TimesheetPage$Messages$ActivityFeedComponent(
				$author$project$Activities$Messages$DeleteGroupActivities(groupByKey)));
		var colour = _v0.a;
		var hoverText = _v0.b;
		var clickMessage = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonStyle + 'bg-mt-red-light lg:flex'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', (!isKebabOpen) || ((!isKebabOpen) && (!isExpanded)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('group tooltip cursor-pointer'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'activities-group-bulk-delete')
						]),
					_List_fromArray(
						[
							$author$project$Icons$RubbishBinButton$viewWithAttributes(
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonIconStyle + (colour + ' icon--delete-button')),
									$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(clickMessage)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext tooltip-left mt-12 pin-r w-28 shadow-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(hoverText)
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$mobileButtonTitle + 'text-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(hoverText)
						]))
				]));
	});
var $author$project$Activities$Views$Group$emptyButtonSlot = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonStyle),
			$elm$html$Html$Attributes$class('hidden lg:block')
		]),
	_List_Nil);
var $author$project$Activities$ActivityLogic$groupIcon = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 3:
			return $author$project$Icons$EmailOutgoing$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('icon icon--email-outgoing')
					]));
		case 2:
			if (_v0.a === 2) {
				var _v1 = _v0.a;
				return A2(
					$author$project$Icons$ReadingDocument$viewWithAttributes,
					'',
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('icon icon--group-reading-document')
						]));
			} else {
				return A2(
					$author$project$Icons$Document$viewWithAttributes,
					'',
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('icon icon--group-document')
						]));
			}
		case 5:
			var act = _v0.a;
			return (act.aR === 'pdf') ? A2(
				$author$project$Icons$ReadingDocument$viewWithAttributes,
				'pdf',
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('icon icon--group-reading-document')
					])) : $author$project$Icons$Globe$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('icon icon--group-document')
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden')
					]),
				_List_Nil);
	}
};
var $author$project$Activities$Views$Group$kebabMenu = function (groupByKey) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mobile lg:hidden px-3 absolute right-0 mr-2px'),
				$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
				$author$project$TimesheetPage$Messages$ActivityFeedComponent(
					$author$project$Activities$Messages$ToggleKebabGroupMenu(
						$elm$core$Maybe$Just(groupByKey))))
			]),
		_List_fromArray(
			[$author$project$Icons$Kebab$view]));
};
var $author$project$Activities$Messages$StopOutstandingResearchEvents = function (a) {
	return {$: 32, a: a};
};
var $author$project$Activities$Views$Group$stopOutstandingResearchActivities = F3(
	function (groupByKey, isExpanded, isKebabOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonStyle + 'bg-mt-green lg:flex'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', (!isKebabOpen) || ((!isKebabOpen) && (!isExpanded)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('group tooltip cursor-pointer'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'activities-group-bulk-accept')
						]),
					_List_fromArray(
						[
							$author$project$Icons$Stop$viewWithAttributes(
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class($author$project$Activities$Views$ActionBar$actionButtonIconStyle + ' lg:text-mt-purple-light icon'),
									$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
									$author$project$TimesheetPage$Messages$ActivityFeedComponent(
										$author$project$Activities$Messages$StopOutstandingResearchEvents(groupByKey)))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext tooltip-left mt-12 pin-r w-28 shadow-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Stop all outstanding tracking')
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$Activities$Views$ActionBar$mobileButtonTitle + 'text-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Stop all')
						]))
				]));
	});
var $author$project$Activities$Views$Group$renderGroupHeader = F6(
	function (_v0, activity, groupByKey, groupExpanded, headerDuration, childActivities) {
		var openGroupKebab = _v0.it;
		var searchTerms = _v0.eX;
		var feedMode = _v0.g5;
		var selectedActivityIds = _v0.cp;
		var kebabIsOpen = _Utils_eq(
			openGroupKebab,
			$elm$core$Maybe$Just(groupByKey));
		var expandOrCollapseMessage = groupExpanded ? $author$project$TimesheetPage$Messages$ActivityFeedComponent(
			$author$project$Activities$Messages$CollapseActivityGroups(groupByKey)) : $author$project$TimesheetPage$Messages$ActivityFeedComponent(
			$author$project$Activities$Messages$ExpandActivityGroups(groupByKey));
		var displayResearchStopButton = ($author$project$Activities$ActivityLogic$getActivityType(activity) === 8) && (!$author$project$Timesheet$FeeLogic$isJust(headerDuration));
		var buttonToRender = displayResearchStopButton ? $author$project$Activities$Views$Group$stopOutstandingResearchActivities : $author$project$Activities$Views$Group$acceptAllActivities;
		var bgClass = $author$project$Activities$ActivityLogic$isBinned(activity) ? 'bg-mt-red-lightest' : 'bg-white';
		return _Utils_Tuple2(
			'activity-group-header-' + $elm$core$String$fromInt(activity.aC),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative flex flex-row items-center'),
						$elm$html$Html$Attributes$class('w-auto h-24 lg:h-18'),
						$elm$html$Html$Attributes$class(bgClass),
						$elm$html$Html$Attributes$class('border-mt-purple border-r border-l'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('border-y', groupExpanded),
								_Utils_Tuple2('border-t', !groupExpanded)
							])),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'activities-group-header'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bg-mt-red-lightest',
								$author$project$Activities$ActivityLogic$isBinned(activity))
							])),
						$elm$html$Html$Events$onClick(expandOrCollapseMessage)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('relative right-0 flex items-center w-full h-full z-20'),
								$elm$html$Html$Attributes$class('lg:static lg:z-auto'),
								$elm$html$Html$Attributes$class('lg:bg-transparent'),
								$elm$html$Html$Attributes$class(bgClass),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('open', kebabIsOpen),
										_Utils_Tuple2('close', !kebabIsOpen),
										_Utils_Tuple2(
										'right-36',
										kebabIsOpen && (!$author$project$Activities$ActivityLogic$isBinned(activity))),
										_Utils_Tuple2(
										'right-18',
										kebabIsOpen && $author$project$Activities$ActivityLogic$isBinned(activity))
									]))
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Activities$Views$Group$activityDetailsView,
								groupExpanded,
								selectedActivityIds,
								childActivities,
								$author$project$Activities$ActivityLogic$groupIcon(activity)),
								A4($author$project$Activities$Views$Activity$activityRowDetails, searchTerms, 0, activity, headerDuration),
								$author$project$Activities$Views$Group$kebabMenu(groupByKey)
							])),
						A2(
						$elm$html$Html$div,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('activity-kebab' + groupByKey),
									$elm$html$Html$Attributes$class('absolute right-0 h-full outline-hidden'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('-right-1', groupExpanded)
										]))
								]),
							A2(
								$author$project$OnClickOutsideAfterFocus$withId,
								'activity-kebab' + groupByKey,
								$author$project$TimesheetPage$Messages$ActivityFeedComponent(
									$author$project$Activities$Messages$ToggleKebabGroupMenu($elm$core$Maybe$Nothing)))),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex justify-start items-center h-full')
									]),
								A3(
									$author$project$CoreX$Appendable$andAppendIf,
									feedMode === 1,
									_List_fromArray(
										[$author$project$Activities$Views$Group$emptyButtonSlot]),
									A3(
										$author$project$CoreX$Appendable$andAppendIf,
										!feedMode,
										_List_fromArray(
											[
												A4($author$project$Activities$Views$Group$deleteAllActivities, groupByKey, groupExpanded, kebabIsOpen, displayResearchStopButton),
												$author$project$Activities$Views$Group$emptyButtonSlot,
												$author$project$Activities$Views$Group$emptyButtonSlot
											]),
										_List_fromArray(
											[
												A3(buttonToRender, groupByKey, groupExpanded, kebabIsOpen)
											]))))
							]))
					])));
	});
var $author$project$Activities$Views$Group$renderGroup = F4(
	function (zone, earliestActivity, activities, activityFeed) {
		var expandedActivityGroups = activityFeed.ds;
		var searchTerms = activityFeed.eX;
		var selectedActivityIds = activityFeed.cp;
		var headerDuration = $author$project$Activities$ActivityLogic$getAggregateDuration(
			$mgold$elm_nonempty_list$List$Nonempty$toList(activities));
		var groupByKey = A2($author$project$Activities$ActivityLogic$groupByKey, zone, earliestActivity);
		var groupExpanded = A2($elm$core$List$member, groupByKey, expandedActivityGroups);
		return _Utils_Tuple2(
			groupByKey,
			A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-auto'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('border-mt-purple border-r-4', groupExpanded)
							])),
						$elm$html$Html$Attributes$class('relative'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-row'),
						$elm$html$Html$Attributes$id('activities-group_' + groupByKey)
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					groupExpanded,
					A6($author$project$Activities$Views$Group$renderActivities, zone, searchTerms, 1, activities, groupExpanded, selectedActivityIds),
					_List_fromArray(
						[
							A6($author$project$Activities$Views$Group$renderGroupHeader, activityFeed, earliestActivity, groupByKey, groupExpanded, headerDuration, activities)
						]))));
	});
var $mgold$elm_nonempty_list$List$Nonempty$fromElement = $mgold$elm_nonempty_list$List$Nonempty$singleton;
var $author$project$Activities$Views$Group$renderSingleton = F3(
	function (zone, earliestActivity, _v0) {
		var searchTerms = _v0.eX;
		var selectedActivityIds = _v0.cp;
		return _Utils_Tuple2(
			'group-singleton-activity-id-' + $elm$core$String$fromInt(earliestActivity.aC),
			A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-auto'),
						A2($elm$html$Html$Attributes$attribute, 'data-tour', 'activities-group-singleton'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-row')
					]),
				A6(
					$author$project$Activities$Views$Group$renderActivities,
					zone,
					searchTerms,
					2,
					$mgold$elm_nonempty_list$List$Nonempty$fromElement(earliestActivity),
					false,
					selectedActivityIds)));
	});
var $author$project$Activities$Views$Group$view = F3(
	function (zone, activityFeed, _v0) {
		var groupByKey = _v0.a;
		var activities = _v0.b;
		var earliestActivity = A2($mgold$elm_nonempty_list$List$Nonempty$get, -1, activities);
		return $mgold$elm_nonempty_list$List$Nonempty$isSingleton(activities) ? A3($author$project$Activities$Views$Group$renderSingleton, zone, earliestActivity, activityFeed) : A4($author$project$Activities$Views$Group$renderGroup, zone, earliestActivity, activities, activityFeed);
	});
var $author$project$Activities$View$renderDay = F5(
	function (zone, activityFeed, currentRataDie, rataDie, activities) {
		var conversations = A2(
			$elm$core$List$map,
			A2($author$project$Activities$Views$Group$view, zone, activityFeed),
			A3(
				$author$project$GroupBy$conversation,
				function ($) {
					return $.jg;
				},
				$author$project$Activities$ActivityLogic$groupByKey(zone),
				activities));
		var activityDayKey = 'activity-day-' + $elm$core$String$fromInt(rataDie);
		return _Utils_Tuple2(
			activityDayKey,
			A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-auto border-mt-purple border-b'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-day')
					]),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'activity-day-header',
						A5($author$project$Components$DayHeader$renderDayHeaderFromRataDie, zone, rataDie, currentRataDie, 'activity', $elm$core$Maybe$Nothing)),
					conversations)));
	});
var $author$project$Activities$View$renderActivitiesByDay = F3(
	function (zone, activityFeed, currentRataDie) {
		return A4(
			$author$project$GroupBy$mapByRataDie,
			zone,
			function ($) {
				return $.jg;
			},
			A3($author$project$Activities$View$renderDay, zone, activityFeed, currentRataDie),
			activityFeed.fF);
	});
var $author$project$Activities$View$renderInbox = F3(
	function (zone, activityFeed, currentRataDie) {
		var loadMoreLinkRow = $author$project$Activities$View$moreLinkRow(activityFeed);
		return A2(
			$elm$core$List$append,
			A3($author$project$Activities$View$renderActivitiesByDay, zone, activityFeed, currentRataDie),
			A2(
				$elm$core$List$append,
				$author$project$Activities$View$noActivitiesMessage(activityFeed),
				_List_fromArray(
					[
						A2($author$project$Activities$View$keyedAs, 'activities-more-link', loadMoreLinkRow)
					])));
	});
var $author$project$Activities$Messages$SearchActivitiesInputChanged = function (a) {
	return {$: 13, a: a};
};
var $author$project$Activities$Messages$SetActivitySearchMode = function (a) {
	return {$: 7, a: a};
};
var $author$project$Activities$Views$FeedHeader$currentFeedTitle = F2(
	function (feedDisplay, searchMode) {
		return (!searchMode) ? '' : 'Activities';
	});
var $author$project$Activities$Messages$SetActivityFilterOpen = function (a) {
	return {$: 8, a: a};
};
var $author$project$Activities$Messages$ClearActivityFeedFilter = {$: 11};
var $elm$svg$Svg$Events$stopPropagationOn = $elm$html$Html$Events$stopPropagationOn;
var $author$project$Activities$Views$FeedHeader$filterStatus = function (enabledFilterCount) {
	var filterText = (!enabledFilterCount) ? '' : (': ' + $elm$core$String$fromInt(enabledFilterCount));
	var alwaysStopPropagationMsg = _Utils_Tuple2(
		$author$project$TimesheetPage$Messages$ActivityFeedComponent($author$project$Activities$Messages$ClearActivityFeedFilter),
		true);
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('font-bold lg:text-sm mr-2'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('text-mt-purple', !(!enabledFilterCount))
					]))
			]),
		A2(
			$author$project$CoreX$Appendable$andAppend,
			_List_fromArray(
				[
					$elm$html$Html$text('Filter' + filterText)
				]),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				!(!enabledFilterCount),
				_List_fromArray(
					[
						$author$project$Icons$CloseCross$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('inline w-3 stroke-current cursor-pointer icon icon--close-cross mr-3'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-feed-filter-clear'),
								$elm$svg$Svg$Attributes$id('clear-activity-feed-filter-button'),
								A2(
								$elm$svg$Svg$Events$stopPropagationOn,
								'click',
								$elm$json$Json$Decode$succeed(alwaysStopPropagationMsg))
							]))
					]),
				_List_Nil)));
};
var $author$project$Activities$Messages$FetchActivitiesBeforeDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$DateInput$commonClasses = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('w-full max-w-32 pill border-solid border border-mt-grey-lighter py-2'),
		$elm$html$Html$Attributes$class('flex items-center'),
		$elm$html$Html$Attributes$class('hover:bg-mt-purple-lightest'),
		$elm$html$Html$Attributes$class('focus:border-mt-purple-lighter'),
		A2($elm$html$Html$Attributes$attribute, 'data-tour', 'date-input'),
		A2($elm$html$Html$Attributes$attribute, 'data-role', 'date-input')
	]);
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Components$DateInput$inputAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$type_('date'),
		$elm$html$Html$Attributes$class('pr-px'),
		$elm$html$Html$Attributes$class('w-full text-grey-darkest bg-transparent'),
		$elm$html$Html$Attributes$class('md:font-normal leading-normal'),
		$elm$html$Html$Attributes$class('focus:border-mt-purple')
	]);
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$CoreX$Events$onInputDate = function (tagger) {
	var dateMsgDecoder = function (dateStr) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$json$Json$Decode$fail('invalid date'),
			function (val) {
				return (val >= 1000) ? $elm$json$Json$Decode$succeed(
					tagger(dateStr)) : $elm$json$Json$Decode$fail('incomplete year');
			},
			$elm$core$String$toInt(
				A2($elm$core$String$left, 4, dateStr)));
	};
	return A2(
		$elm$html$Html$Events$on,
		'input',
		A2($elm$json$Json$Decode$andThen, dateMsgDecoder, $elm$html$Html$Events$targetValue));
};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Components$DateInput$genericDateInput = F3(
	function (zone, dateSetter, maybeDate) {
		var editableAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('cursor-pointer time-focus'),
				$elm$html$Html$Attributes$required(true),
				$author$project$CoreX$Events$onInputDate(dateSetter)
			]);
		var dateAttrs = A2(
			$elm$core$Maybe$map,
			function (dt) {
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						A2($author$project$CoreX$DateFormat$toDateString, zone, dt))
					]);
			},
			maybeDate);
		var commonAttrs = A2($author$project$CoreX$Appendable$andMaybeAppend, dateAttrs, $author$project$Components$DateInput$inputAttrs);
		return A2(
			$elm$html$Html$div,
			$author$project$Components$DateInput$commonClasses,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_Utils_ap(commonAttrs, editableAttrs),
					_List_Nil)
				]));
	});
var $author$project$Activities$Views$FeedHeader$feedActivityDatePicker = F2(
	function (zone, feedBeforeTime) {
		var isDateSet = $elm_community$maybe_extra$Maybe$Extra$isJust(feedBeforeTime);
		var forDateValue = A2(
			$elm$core$Maybe$map,
			A2($author$project$CoreX$DateConstruct$withDayOffset, zone, -1),
			feedBeforeTime);
		return A2(
			$author$project$CoreX$Appendable$andAppend,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 mb-4 border-b')
						]),
					_List_Nil)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold mb-2 px-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Show from Date')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center text-sm px-4 py-1'),
							$elm$html$Html$Attributes$title('Show from date'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-feed-date-input')
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						isDateSet,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-2'),
										$elm$html$Html$Attributes$title('Clear date')
									]),
								_List_fromArray(
									[
										$author$project$Icons$CloseCross$viewWithAttributes(
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('w-3 stroke-current cursor-pointer icon icon--close-cross'),
												A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-feed-date-close'),
												$elm$svg$Svg$Attributes$id('close-activity-feed-date-button'),
												$elm$svg$Svg$Events$onClick(
												A3($elm$core$Basics$composeL, $author$project$TimesheetPage$Messages$ActivityFeedComponent, $author$project$Activities$Messages$FetchActivitiesBeforeDate, ''))
											]))
									]))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$DateInput$genericDateInput,
								zone,
								A2($elm$core$Basics$composeL, $author$project$TimesheetPage$Messages$ActivityFeedComponent, $author$project$Activities$Messages$FetchActivitiesBeforeDate),
								forDateValue)
							])))
				]));
	});
var $author$project$Activities$Data$availableFilters = _List_fromArray(
	[0, 1, 3, 4, 2, 5]);
var $author$project$Activities$Messages$ToggleActivityFeedFilter = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Activities$Data$activityFeedFilterText = function (feedFilter) {
	switch (feedFilter) {
		case 3:
			return 'Meetings';
		case 1:
			return 'Phone Calls';
		case 2:
			return 'Teams Meetings';
		case 4:
			return 'Documents';
		case 0:
			return 'Emails';
		case 5:
			return 'Online Research';
		default:
			return '';
	}
};
var $author$project$Activities$Views$FeedHeader$renderFilterItem = F3(
	function (feedMode, feedFilters, feedFilter) {
		var param = $author$project$Activities$Data$activityFeedFilterParam(feedFilter);
		var isSet = A2($turboMaCk$any_set$Set$Any$member, feedFilter, feedFilters);
		var filterText = $author$project$Activities$Data$activityFeedFilterText(feedFilter);
		var checkBoxModel = {
			ga: 'h-4 w-4',
			gc: $author$project$TimesheetPage$Messages$ActivityFeedComponent(
				A3($author$project$Activities$Messages$ToggleActivityFeedFilter, feedFilter, feedFilters, feedMode)),
			gJ: true,
			gU: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-1')
				]),
			ho: 'Set for selecting ' + param,
			hs: 'set-' + param,
			hM: isSet,
			hN: true,
			hR: '',
			i_: 'set-for-' + param,
			jw: 'text-xs'
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center'),
					$elm$html$Html$Attributes$class('py-1 px-4'),
					$elm$html$Html$Attributes$class('hover:bg-mt-blue-lightest'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-' + (param + '-filter')),
					$elm$html$Html$Events$onClick(
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						A3($author$project$Activities$Messages$ToggleActivityFeedFilter, feedFilter, feedFilters, feedMode)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('-ml-2')
						]),
					_List_fromArray(
						[
							$author$project$Components$CheckBox$view(checkBoxModel)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('-ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(filterText)
						]))
				]));
	});
var $author$project$Activities$Views$FeedHeader$feedActivityFilterItems = F2(
	function (feedFilters, feedMode) {
		return A2(
			$author$project$CoreX$Appendable$andAppend,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 mb-4 border-b')
						]),
					_List_Nil)
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				A2(
					$elm$core$List$map,
					A2($author$project$Activities$Views$FeedHeader$renderFilterItem, feedMode, feedFilters),
					$author$project$Activities$Data$availableFilters),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-bold mb-2 px-4 pt-4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Activity Type')
							]))
					])));
	});
var $author$project$Icons$Radio$viewWithAttributes = F2(
	function (checked, attributes) {
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$version('1.1'),
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$width('100%'),
						$elm$svg$Svg$Attributes$id('Layer_1'),
						$elm$svg$Svg$Attributes$x('0px'),
						$elm$svg$Svg$Attributes$y('0px'),
						$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				attributes),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				checked,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('oval-tick'),
								$elm$svg$Svg$Attributes$cx('12'),
								$elm$svg$Svg$Attributes$cy('12'),
								$elm$svg$Svg$Attributes$r('5.25')
							]),
						_List_Nil)
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'),
								$elm$svg$Svg$Attributes$fillRule('evenodd'),
								$elm$svg$Svg$Attributes$strokeWidth('0.2')
							]),
						_List_Nil)
					])));
	});
var $author$project$Activities$Views$FeedHeader$feedActivityStateItems = function (feedMode) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-bold mb-2 px-4')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Activity State')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center py-1 px-4'),
					$elm$html$Html$Attributes$class('hover:bg-mt-blue-lightest'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('font-bold text-mt-purple', !feedMode)
						])),
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						$author$project$Activities$Messages$SetActivityFeedMode(0))),
					$elm$html$Html$Attributes$id('show-active-activities-trigger')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Icons$Radio$viewWithAttributes,
					!feedMode,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-4 h-4 mr-1 icon icon--post-now stroke-current fill-current')
						])),
					$elm$html$Html$text('Show Active')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center py-1 px-4'),
					$elm$html$Html$Attributes$class('hover:bg-mt-blue-lightest'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('font-bold text-mt-purple', feedMode === 1)
						])),
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						$author$project$Activities$Messages$SetActivityFeedMode(1))),
					$elm$html$Html$Attributes$id('show-deleted-activities-trigger')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Icons$Radio$viewWithAttributes,
					feedMode === 1,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-4 h-4 mr-1 icon icon--post-now stroke-current fill-current ')
						])),
					$elm$html$Html$text('Show Deleted')
				]))
		]);
};
var $author$project$Activities$Views$FeedHeader$renderDropdownItems = F4(
	function (zone, feedFilters, feedMode, feedBeforeTime) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute right-10 flex flex-col w-48 mt-1'),
						$elm$html$Html$Attributes$class('z-40'),
						$elm$html$Html$Attributes$class('border bg-white shadow-sm cursor-pointer outline-hidden')
					]),
				A2(
					$author$project$CoreX$Appendable$andAppend,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-4')
								]),
							_List_Nil)
						]),
					A2(
						$author$project$CoreX$Appendable$andAppend,
						$author$project$Activities$Views$FeedHeader$feedActivityStateItems(feedMode),
						A2(
							$author$project$CoreX$Appendable$andAppend,
							A2($author$project$Activities$Views$FeedHeader$feedActivityDatePicker, zone, feedBeforeTime),
							A2(
								$author$project$CoreX$Appendable$andAppend,
								A2($author$project$Activities$Views$FeedHeader$feedActivityFilterItems, feedFilters, feedMode),
								_List_Nil)))))
			]);
	});
var $turboMaCk$any_dict$Dict$Any$size = function (_v0) {
	var dict = _v0.d;
	return $elm$core$Dict$size(dict);
};
var $turboMaCk$any_set$Set$Any$size = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$size(dict);
};
var $author$project$Icons$FilterMenu$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 23 15'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2 1.81538H21.5692'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2.44615'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$class('group-hover:stroke-mt-purple')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M5.26172 7.52309H18.3079'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2.44615'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$class('group-hover:stroke-mt-purple')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.52295 13.4346H15.046'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2.44615'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$class('group-hover:stroke-mt-purple')
					]),
				_List_Nil)
			]));
};
var $author$project$Activities$Views$FeedHeader$filterMenu = F5(
	function (zone, feedFilters, feedMode, feedBeforeTime, filterMenuOpen) {
		var enabledFilterCount = $turboMaCk$any_set$Set$Any$size(feedFilters);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('activity-filter-menu'),
						$elm$html$Html$Attributes$class('outline-hidden cursor-pointer'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('bg-mt-purple-lightest pl-1 py-1 rounded-sm', !(!enabledFilterCount))
							])),
						$elm$html$Html$Events$onClick(
						$author$project$TimesheetPage$Messages$ActivityFeedComponent(
							$author$project$Activities$Messages$SetActivityFilterOpen(true)))
					]),
				A2(
					$author$project$OnClickOutsideAfterFocus$withId,
					'activity-filter-menu',
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						$author$project$Activities$Messages$SetActivityFilterOpen(false)))),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				filterMenuOpen,
				A4($author$project$Activities$Views$FeedHeader$renderDropdownItems, zone, feedFilters, feedMode, feedBeforeTime),
				A2(
					$author$project$CoreX$Appendable$andAppend,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('group px-1')
								]),
							_List_fromArray(
								[
									$author$project$Icons$FilterMenu$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('relative inline stroke-current text-mt-purple-light hover:text-mt-purple h-5 w-5 icon pt-0 cursor-pointer')
										]))
								]))
						]),
					A2(
						$author$project$CoreX$Appendable$andAppend,
						_List_fromArray(
							[
								$author$project$Activities$Views$FeedHeader$filterStatus(enabledFilterCount)
							]),
						_List_Nil))));
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Activities$Views$FeedHeader$searchPlaceholder = function (feedMode) {
	if (!feedMode) {
		return 'Search across Activities...';
	} else {
		return 'Search across Bin...';
	}
};
var $author$project$Icons$Collapse$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 50 50')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('matrix(0,-0.79534139,0.65561996,0,16.631111,44.883535)'),
						$elm$svg$Svg$Attributes$class('expanded-g')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$polyline,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$points('45 15 25 35 5 15'),
								$elm$svg$Svg$Attributes$strokeWidth('6.5'),
								$elm$svg$Svg$Attributes$strokeOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('matrix(0,-0.79534139,0.65561996,0,4.6203058,44.883535)'),
						$elm$svg$Svg$Attributes$class('expanded-g')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$polyline,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$points('45 15 25 35 5 15'),
								$elm$svg$Svg$Attributes$strokeWidth('6.5'),
								$elm$svg$Svg$Attributes$strokeOpacity('1')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Icons$Search$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 16 18'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$class('group-hover:stroke-mt-purple')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$transform('translate(-19.000000, -57.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Search'),
										$elm$svg$Svg$Attributes$transform('translate(0.000000, 47.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('Group-Copy'),
												$elm$svg$Svg$Attributes$transform('translate(28.093999, 19.282840) scale(-1, 1) rotate(80.000000) translate(-28.093999, -19.282840) translate(21.093999, 11.282840)')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$circle,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('Oval-3'),
														$elm$svg$Svg$Attributes$fill(''),
														$elm$svg$Svg$Attributes$cx('5.5'),
														$elm$svg$Svg$Attributes$cy('5.5'),
														$elm$svg$Svg$Attributes$r('5.5')
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$path,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$d('M9.05664062,9.82421875 L13.4472656,15.0605469'),
														$elm$svg$Svg$Attributes$id('Path-3')
													]),
												_List_Nil)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Activities$Views$FeedHeader$view = F2(
	function (zone, _v0) {
		var searchMode = _v0.i1;
		var feedMode = _v0.g5;
		var feedFilters = _v0.g4;
		var filterMenuOpen = _v0.g8;
		var feedBeforeTime = _v0.g2;
		var searchTerms = _v0.eX;
		var hasActivityFeedOnLeft = _v0.am;
		if (searchMode === 1) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex h-12 sm:h-16 px-4 justify-between items-center border-mt-purple border-r')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-block')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('m-0 inline-block text-xl sm:text-3xl font-light')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Activities$Views$FeedHeader$currentFeedTitle, feedMode, searchMode))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('group inline-block w-4 px-2 text-mt-purple-light hover:text-mt-purple cursor-pointer'),
										$elm$html$Html$Attributes$id('search-feed-button'),
										$elm$html$Html$Events$onClick(
										$author$project$TimesheetPage$Messages$ActivityFeedComponent(
											$author$project$Activities$Messages$SetActivitySearchMode(0)))
									]),
								_List_fromArray(
									[
										$author$project$Icons$Search$viewWithAttributes(
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('w-5 -mb-px stroke-current icon icon--search pt-0')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex h-full items-center relative')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center gap-1 pr-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xs font-bold text-mt-purple h-full mt-0.5')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												(!feedMode) ? '' : 'Deleted')
											])),
										A5($author$project$Activities$Views$FeedHeader$filterMenu, zone, feedFilters, feedMode, feedBeforeTime, filterMenuOpen)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('hidden xl:inline-block border-mt-grey-lighter cursor-pointer'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('transform rotate-180 mt-2 pr-2 border-r', hasActivityFeedOnLeft),
												_Utils_Tuple2('pl-2 border-l', !hasActivityFeedOnLeft)
											])),
										$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$ToggleActivityFeed),
										$elm$html$Html$Attributes$title('Collapse Activities'),
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'collapse-activities')
									]),
								_List_fromArray(
									[
										$author$project$Icons$Collapse$viewWithAttributes(
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('stroke-current text-mt-purple-light hover:text-mt-purple inline h-5 w-5')
											]))
									]))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex h-16 px-6 justify-between items-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid-row flex-auto flex sm:pr-4')
							]),
						_List_fromArray(
							[
								$author$project$Icons$Search$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('w-5 stroke-current icon icon--search pt-0 text-mt-purple-lighter')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex-auto flex pr-2 border-b border-mt-grey-lighter focus-within:border-mt-purple')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full pl-2 text-grey-darkest'),
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$id('activity-search-field'),
												$elm$html$Html$Attributes$placeholder(
												$author$project$Activities$Views$FeedHeader$searchPlaceholder(feedMode)),
												$elm$html$Html$Attributes$value(
												A2($elm$core$Maybe$withDefault, '', searchTerms)),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$TimesheetPage$Messages$ActivityFeedComponent, $author$project$Activities$Messages$SearchActivitiesInputChanged))
											]),
										_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('cursor-pointer font-light')
											]),
										_List_fromArray(
											[
												$author$project$Icons$CloseCross$viewWithAttributes(
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('inline mb-0 w-2 stroke-current text-mt-grey icon icon--close-cross'),
														$elm$svg$Svg$Attributes$id('close-cross-button'),
														$elm$svg$Svg$Events$onClick(
														$author$project$TimesheetPage$Messages$ActivityFeedComponent(
															$author$project$Activities$Messages$SetActivitySearchMode(1)))
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex h-full items-center relative')
							]),
						_List_fromArray(
							[
								A5($author$project$Activities$Views$FeedHeader$filterMenu, zone, feedFilters, feedMode, feedBeforeTime, filterMenuOpen)
							]))
					]));
		}
	});
var $author$project$Activities$View$activityFeedView = F3(
	function (zone, _v0, currentRataDie) {
		var user = _v0.jS;
		var activityFeed = _v0.fI;
		var activateTrackActivitiesButton = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-1 bg-transparent text-sm font-semibold p-1 border rounded-sm border-mt-purple text-mt-purple hover:border-mt-blue-light hover:text-white hover:bg-mt-purple'),
							$elm$html$Html$Attributes$class('hidden md:inline-block'),
							$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$ActivateTrackActivities),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'activate-track-activities')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Turn On Activities')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-1 bg-transparent text-sm font-semibold p-1 border rounded-sm border-mt-purple text-mt-purple hover:border-mt-blue-light hover:text-white hover:bg-mt-purple'),
							$elm$html$Html$Attributes$class('md:hidden'),
							$elm$html$Html$Attributes$class('cursor-not-allowed'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'disabled-activate-track-activities')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Please use a larger screen for initial training (landscape iPad or larger).')
						]))
				]));
		return user.gg ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cursor-pointer text-xs'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('rounded-l', !activityFeed.am),
							_Utils_Tuple2('rounded-r', activityFeed.am)
						])),
					$elm$html$Html$Attributes$class('bg-linear-to-r from-mt-purple to-mt-blue'),
					$elm$html$Html$Attributes$class('hover:from-mt-blue'),
					$elm$html$Html$Attributes$class('absolute top-0 mt-3 px-1 py-2'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('right-0 mr-15px ', !activityFeed.am),
							_Utils_Tuple2('left-0', activityFeed.am)
						])),
					$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$ToggleActivityFeed),
					$elm$html$Html$Attributes$title('Expand Activities'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'expand-activities')
				]),
			_List_fromArray(
				[
					$author$project$Icons$Collapse$viewWithAttributes(
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						!activityFeed.am,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('transform rotate-180')
							]),
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('stroke-current text-white hover:text-mt-purple-lighter inline ml-0.5 h-5 w-5')
							]))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-white mt-1 write-vertical-rl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Activities')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col h-full overflow-hidden w-screen md:w-128'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-feed'),
					A2($elm$html$Html$Attributes$attribute, 'data-tour', 'activity-feed'),
					$elm$html$Html$Attributes$id(
					$author$project$ActivityFeedLogic$modeToString(activityFeed.g5))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-0 bg-white border-b'),
							A2($elm$html$Html$Attributes$attribute, 'data-tour', 'activity-feed-header')
						]),
					_List_fromArray(
						[
							A2($author$project$Activities$Views$FeedHeader$view, zone, activityFeed)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block h-full w-full pt-px overflow-y-auto')
						]),
					user.jL ? _List_fromArray(
						[
							A3(
							$elm$html$Html$Keyed$node,
							'div',
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full')
								]),
							A3($author$project$Activities$View$renderInbox, zone, activityFeed, currentRataDie))
						]) : _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-2 border rounded-lg border-mt-yellow bg-mt-yellow-light p-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Your emails, meetings and phone calls will appear here. You can assess if chargeable.'),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-1 text-center')
										]),
									_List_fromArray(
										[activateTrackActivitiesButton]))
								]))
						]))
				]));
	});
var $author$project$Timesheet$View$activityFeed = F3(
	function (zone, model, currentRataDie) {
		var mobileSideBarActive = model.h6 === 1;
		var activityFeedCollapsed = model.jS.gg;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('sidebar'),
					$elm$html$Html$Attributes$class('h-full xl:border-t border-mt-blue xl:flex xl:flex-initial xl:flex-col'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', !mobileSideBarActive),
							_Utils_Tuple2('absolute xl:relative top-0 right-0 left-0 xl:top-12 sm:left-auto z-20 bg-white', mobileSideBarActive),
							_Utils_Tuple2('w-screen md:w-128', !activityFeedCollapsed),
							_Utils_Tuple2('h-16 relative', activityFeedCollapsed),
							_Utils_Tuple2('xs:border-l', !model.fI.am),
							_Utils_Tuple2('xs:border-r', model.fI.am)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$Activities$View$activityFeedView, zone, model, currentRataDie)
				]));
	});
var $author$project$BudgetBar$BudgetBarLogic$budgetToday = F2(
	function (rataDie, _v0) {
		var mondayBudget = _v0.h8;
		var tuesdayBudget = _v0.jM;
		var wednesdayBudget = _v0.jW;
		var thursdayBudget = _v0.jx;
		var fridayBudget = _v0.hc;
		var saturdayBudget = _v0.i$;
		var sundayBudget = _v0.jn;
		var weekday = $justinmimbs$date$Date$weekday(
			$justinmimbs$date$Date$fromRataDie(rataDie));
		switch (weekday) {
			case 0:
				return mondayBudget;
			case 1:
				return tuesdayBudget;
			case 2:
				return wednesdayBudget;
			case 3:
				return thursdayBudget;
			case 4:
				return fridayBudget;
			case 5:
				return saturdayBudget;
			default:
				return sundayBudget;
		}
	});
var $author$project$TimesheetPage$Messages$SetMobileDeviceTab = function (a) {
	return {$: 6, a: a};
};
var $author$project$Timesheet$View$anyFiltersActive = function (_v0) {
	var searchMode = _v0.i1;
	var filterState = _v0.g9;
	return (!searchMode) || (!_Utils_eq(filterState, $author$project$FeeFilter$Off));
};
var $author$project$TimesheetPage$Messages$FetchMoreFees = {$: 46};
var $author$project$Timesheet$View$loadFeesMessage = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-36 mx-auto')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('float-left relative transform scale-50')
					]),
				$author$project$Icons$LoadingPendulum$view),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-right')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]));
};
var $author$project$Timesheet$View$loadMoreLink = function (model) {
	return _Utils_Tuple2(
		'load-more-fees',
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center justify-between border-mt-blue w-full')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mx-auto h-12 mt-6 mb-6 lg:mb-3')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(model.aY.dE, model.g$.dN);
							switch (_v0.a) {
								case 0:
									var _v1 = _v0.a;
									return $author$project$Timesheet$View$loadFeesMessage('Loading fees....');
								case 2:
									var _v2 = _v0.a;
									return $elm$html$Html$text('End of fees');
								default:
									if (!_v0.b.$) {
										var _v3 = _v0.a;
										return $elm$html$Html$text('End of fees');
									} else {
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$attribute, 'data-role', 'load-more-fees'),
													$elm$html$Html$Attributes$class('block w-64 mx-auto border rounded-full bg-mt-blue-lighter'),
													$elm$html$Html$Attributes$class('border-mt-blue-lighter hover:bg-mt-blue-light'),
													$elm$html$Html$Attributes$class('hover:border-mt-blue-light text-white'),
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$FetchMoreFees),
													$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$TimesheetPage$Messages$FetchMoreFees),
													$elm$html$Html$Attributes$id('load-more-fees-link'),
													$elm$html$Html$Attributes$tabindex(0)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Load more')
												]));
									}
							}
						}()
						]))
				])));
};
var $author$project$Timesheet$View$noFeesMessage = function (message) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'no-fees',
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-6 md:px-4 text-grey italic')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$em,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]))
					])))
		]);
};
var $author$project$BudgetBar$BudgetBarLogic$barStyle = F2(
	function (currentUi, feeSearch) {
		return ((!currentUi) && (_Utils_eq(feeSearch.i2, $elm$core$Maybe$Nothing) && _Utils_eq(feeSearch.g9, $author$project$FeeFilter$Off))) ? 0 : 1;
	});
var $author$project$Timesheet$FeeLogic$removePosted = function (entries) {
	return A2($elm$core$List$filter, $author$project$Timesheet$FeeLogic$isNotPosted, entries);
};
var $author$project$Timesheet$Conversation$Model$Multiple = function (a) {
	return {$: 1, a: a};
};
var $author$project$Timesheet$Conversation$Model$Singleton = function (a) {
	return {$: 0, a: a};
};
var $author$project$Timesheet$FeeLogic$isSelected = F2(
	function (selectedId, fee) {
		return _Utils_eq(
			$elm$core$Maybe$Just(fee.aC),
			selectedId);
	});
var $author$project$Timesheet$Conversation$Logic$anySelected = F2(
	function (selectedId, fees) {
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$any,
			$elm$core$Basics$eq(true),
			A2(
				$mgold$elm_nonempty_list$List$Nonempty$map,
				$author$project$Timesheet$FeeLogic$isSelected(selectedId),
				fees));
	});
var $author$project$Timesheet$Conversation$Model$makeConversation = F5(
	function (expandedFeeConversations, feeTypes, conversationModel, groupByKey, fees) {
		var hasSelectedFee = A2($author$project$Timesheet$Conversation$Logic$anySelected, conversationModel.e1, fees);
		var feesFeeTypes = A2(
			$elm$core$List$map,
			function ($) {
				return $.g0;
			},
			$mgold$elm_nonempty_list$List$Nonempty$toList(fees));
		var conversationExpanded = A2($elm$core$List$member, conversationModel.bL, expandedFeeConversations);
		return {
			gk: A2($author$project$FeeTypeLogic$getDefaultMergeFeeType, feeTypes, feesFeeTypes),
			dk: $author$project$Timesheet$Conversation$Logic$earliestFee(fees),
			bE: conversationModel.bE,
			aY: fees,
			bL: groupByKey,
			hk: hasSelectedFee,
			hC: conversationExpanded || hasSelectedFee,
			eg: conversationModel.eg,
			i2: conversationModel.i2,
			e1: conversationModel.e1
		};
	});
var $author$project$Timesheet$Conversation$Model$make = F7(
	function (selectedId, conversationMatterInput, feeSearchConfiguration, feeRowContext, expandedFeeConversations, feeTypes, _v0) {
		var groupByKey = _v0.a;
		var fees = _v0.b;
		var conversation = {
			dk: $author$project$Timesheet$Conversation$Logic$earliestFee(fees),
			bE: feeRowContext,
			bL: groupByKey,
			eg: conversationMatterInput,
			i2: feeSearchConfiguration.i2,
			e1: selectedId
		};
		return $mgold$elm_nonempty_list$List$Nonempty$isSingleton(fees) ? $author$project$Timesheet$Conversation$Model$Singleton(conversation) : $author$project$Timesheet$Conversation$Model$Multiple(
			A5($author$project$Timesheet$Conversation$Model$makeConversation, expandedFeeConversations, feeTypes, conversation, groupByKey, fees));
	});
var $author$project$TimesheetPage$Messages$CollapseGroupedConversations = function (a) {
	return {$: 34, a: a};
};
var $author$project$TimesheetPage$Messages$ExpandGroupedConversations = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$MatterInput$Messages$GroupHeader = 0;
var $author$project$Model$Fee$Merge$Required = 0;
var $author$project$TimesheetPage$Messages$SetGroupConsolidating = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Timesheet$Views$FeeTypeAndActivityColumns$feeDescription = F2(
	function (fee, searchTerms) {
		var description = A2($elm$core$Maybe$withDefault, '', fee.dd);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('truncate leading-tight'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-description-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					A2($author$project$Components$MarkMatchingTerms$markedTexts, searchTerms, description))
				]));
	});
var $author$project$Timesheet$FeeLogic$isMissingDescription = F2(
	function (hasScaleItem, fee) {
		var feeDescriptionContent = A2($elm$core$Maybe$withDefault, '', fee.dd);
		var feeDescriptionEqualsTypeDescription = function () {
			var feeTypeDescriptionContent = $elm$core$String$trim(fee.g0.dd);
			return _Utils_eq(feeDescriptionContent, feeTypeDescriptionContent);
		}();
		var descriptionBlank = $elm$core$String$trim(feeDescriptionContent) === '';
		return (!hasScaleItem) && (descriptionBlank || feeDescriptionEqualsTypeDescription);
	});
var $author$project$Timesheet$Views$FeeTypeAndActivityColumns$subjectRow = F2(
	function (searchTerms, description) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-xs md:text-base leading-tight font-light text-mt-grey truncate'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-subject-row')
				]),
			A2($author$project$Components$MarkMatchingTerms$markedTexts, searchTerms, description));
	});
var $author$project$Timesheet$Views$FeeTypeAndActivityColumns$activityColumn = F3(
	function (fee, isScaleItem, searchTerms) {
		var associatedWithActivity = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (kind) {
					return _Utils_eq(
						$elm$core$Maybe$Just(kind),
						fee.g0.hQ);
				},
				A2($elm$core$Maybe$map, $author$project$Activities$ActivityLogic$getActivityType, fee.fG)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col w-full overflow-hidden'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-column')
				]),
			A2($author$project$Timesheet$FeeLogic$isMissingDescription, isScaleItem, fee) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-mt-red')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Missing Description')
						]))
				]) : _List_fromArray(
				[
					A2($author$project$Timesheet$Views$FeeTypeAndActivityColumns$feeDescription, fee, searchTerms),
					associatedWithActivity ? A2(
					$author$project$Timesheet$Views$FeeTypeAndActivityColumns$subjectRow,
					searchTerms,
					$author$project$Timesheet$FeeLogic$activitySubject(fee)) : (A2(
					$elm$core$List$member,
					fee.g0.fT,
					_List_fromArray(
						[0, 1])) ? $elm$html$Html$text('') : A2($author$project$Timesheet$Views$FeeTypeAndActivityColumns$subjectRow, $elm$core$Maybe$Nothing, fee.g0.dd))
				]));
	});
var $author$project$Components$Modal$Model$ConsolidateFeeTypeMissingModal = {$: 1};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm_community$html_extra$Html$Extra$nothing = $elm$html$Html$text('');
var $author$project$Timesheet$Views$FeeActionButtons$toolTipSpan = function (tipText) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tooltiptext mt-8 w-20 shadow-sm')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(tipText)
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$consolidateButton = F3(
	function (hasConsolidatedFeeType, feeIds, disableButton) {
		var msg = hasConsolidatedFeeType ? A3($author$project$TimesheetPage$Messages$SetGroupConsolidating, 1, 0, feeIds) : $author$project$TimesheetPage$Messages$ModalAction($author$project$Components$Modal$Model$ConsolidateFeeTypeMissingModal);
		var arrowColour = disableButton ? 'fill-mt-purple-light' : 'fill-mt-purple';
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('leading-normal tooltip bg-transparent font-semibold py-1 px-4 border rounded-sm border-mt-purple text-xs text-mt-purple'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'consolidate-button'),
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(msg),
					$elm$html$Html$Attributes$disabled(disableButton),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('border-mt-purple-light', disableButton)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row gap-2 items-center'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('text-mt-purple-light', disableButton)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-4 h-4')
								]),
							_List_fromArray(
								[
									$author$project$Icons$MergeArrow$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('fill-current ' + arrowColour)
										]))
								])),
							$elm$html$Html$text('Merge')
						])),
					disableButton ? $author$project$Timesheet$Views$FeeActionButtons$toolTipSpan('Disabled. Timer is running') : $elm_community$html_extra$Html$Extra$nothing
				]));
	});
var $author$project$Components$MergeFeesToolbar$consolidateCheckbox = F5(
	function (clickMsg, editable, mergeable, isSet, isTimerRunning) {
		var isEditable = (!isTimerRunning) && editable;
		var checkBoxModel = {
			ga: 'h-6 w-6',
			gc: clickMsg,
			gJ: isEditable,
			gU: A3(
				$author$project$CoreX$Appendable$andAppendIf,
				isTimerRunning,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$title('Timer is running')
					]),
				_List_Nil),
			ho: 'Set for merging',
			hs: 'set-merging',
			hM: isSet,
			hN: mergeable,
			hR: '',
			i_: 'set-for-merging',
			jw: 'text-xs'
		};
		return $author$project$Components$CheckBox$view(checkBoxModel);
	});
var $author$project$Timesheet$Conversation$Logic$conversationPostStatus = function (fees) {
	var postStatuses = A2(
		$elm$core$List$map,
		function ($) {
			return $.eD;
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(fees));
	var isFailed = function (p) {
		return A2(
			$elm$core$List$member,
			p,
			_List_fromArray(
				[6, 7]));
	};
	var arePosted = function (p) {
		return p === 4;
	};
	return A2($elm$core$List$any, isFailed, postStatuses) ? 6 : (A2($elm$core$List$all, arePosted, postStatuses) ? 4 : 0);
};
var $author$project$TimesheetPage$Messages$DeleteFeeGroup = function (a) {
	return {$: 14, a: a};
};
var $author$project$Timesheet$Views$FeeActionButtons$FeeButton = F4(
	function (icon, dataRole, toolTipText, msg) {
		return {c6: dataRole, bN: icon, em: msg, fn: toolTipText};
	});
var $author$project$Timesheet$Views$FeeActionButtons$render = function (feeButton) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-5 group tooltip cursor-pointer'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', feeButton.c6),
				$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
				A2($elm$core$Maybe$withDefault, $author$project$TimesheetPage$Messages$NoOp, feeButton.em))
			]),
		_List_fromArray(
			[
				feeButton.bN,
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tooltiptext mt-8 min-w-24 w-content shadow-sm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(feeButton.fn)
					]))
			]));
};
var $author$project$Icons$RubbishBin$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 28 36'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('delete'),
								$elm$svg$Svg$Attributes$class('transition duration-150'),
								$elm$svg$Svg$Attributes$class('stroke-current'),
								$elm$svg$Svg$Attributes$transform('translate(-34.000000, -30.000000)'),
								$elm$svg$Svg$Attributes$fill('#ffffff'),
								$elm$svg$Svg$Attributes$fillOpacity('0'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('trash'),
										$elm$svg$Svg$Attributes$transform('translate(36.000000, 32.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M22,5 L22,27.9061834 C22,30.1671359 20.1671359,32 17.9061834,32 L6.09381663,32 C3.83286414,32 2,30.1671359 2,27.9061834 L2,5'),
												$elm$svg$Svg$Attributes$id('body')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M0,4.5 L24,4.5'),
												$elm$svg$Svg$Attributes$id('lid')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M8,3 L8,1 C8,0.44771525 8.44771525,0 9,0 L15,0 C15.5522847,0 16,0.44771525 16,1 L16,3'),
												$elm$svg$Svg$Attributes$id('handle')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M8.5,11 L8.5,26'),
												$elm$svg$Svg$Attributes$id('mid-line-2')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M15.5,11 L15.5,26'),
												$elm$svg$Svg$Attributes$id('mid-line-1')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$deleteGroupButton = function (fees) {
	var postableFeeIds = A2(
		$elm$core$List$map,
		$author$project$Timesheet$FeeLogic$toFeeId,
		A2(
			$elm$core$List$filter,
			$author$project$Timesheet$FeeLogic$isEditable,
			$mgold$elm_nonempty_list$List$Nonempty$toList(fees)));
	var buttonIcon = $author$project$Icons$RubbishBin$viewWithAttributes(
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('icon icon--trash text-mt-grey-light hover:text-mt-grey-dark stroke-current fill-white show-on-fee-hover'),
				$elm$svg$Svg$Attributes$fill('')
			]));
	var anyPostable = A2($mgold$elm_nonempty_list$List$Nonempty$any, $author$project$Timesheet$FeeLogic$isEditable, fees);
	var allPostable = A2($mgold$elm_nonempty_list$List$Nonempty$all, $author$project$Timesheet$FeeLogic$isEditable, fees);
	var deleteButtonLabel = allPostable ? 'Delete Group' : 'Delete Group (Unposted only)';
	return anyPostable ? $author$project$Timesheet$Views$FeeActionButtons$render(
		A4(
			$author$project$Timesheet$Views$FeeActionButtons$FeeButton,
			buttonIcon,
			'delete-button',
			deleteButtonLabel,
			$elm$core$Maybe$Just(
				$author$project$TimesheetPage$Messages$DeleteFeeGroup(postableFeeIds)))) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{eh: msg, iK: true, jj: true}));
};
var $author$project$Timesheet$Views$FeeTypeAndActivityColumns$expandToggler = F2(
	function (conversationExpanded, onClickMsg) {
		var _v0 = conversationExpanded ? _Utils_Tuple2($author$project$Icons$Expanded$view, 'Collapse Group') : _Utils_Tuple2($author$project$Icons$Contracted$view, 'Expand Group');
		var icon = _v0.a;
		var toolTipText = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-3 w-3 font-bold text-mt-purple'),
					$elm$html$Html$Attributes$class('cursor-pointer'),
					$elm$html$Html$Attributes$class('tooltip'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'expand-fee-conversation'),
					$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(onClickMsg)
				]),
			_List_fromArray(
				[
					icon,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltiptext w-16 top-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(toolTipText)
						]))
				]));
	});
var $author$project$Timesheet$Views$GroupedFeeTypeAndActivityColumns$feeTypeView = F4(
	function (fee, feesCount, searchTerm, conversationExpanded) {
		var groupIcon = A2(
			$elm$core$Maybe$withDefault,
			A2($elm$html$Html$div, _List_Nil, _List_Nil),
			A2($elm$core$Maybe$map, $author$project$Activities$ActivityLogic$groupIcon, fee.fG));
		var countText = (feesCount > 99) ? '99+' : $elm$core$String$fromInt(feesCount);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center pr-4'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type-column')
				]),
			_List_fromArray(
				[
					A2($author$project$Timesheet$Views$FeeTypeAndActivityColumns$expandToggler, conversationExpanded, $author$project$TimesheetPage$Messages$NoOp),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col items-center w-10')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('leading-none text-xs font-semibold text-mt-purple')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Group')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('relative w-8 h-8 text-mt-purple')
										]),
									_List_fromArray(
										[
											groupIcon,
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('absolute right-0 bottom-0 inline-flex items-center justify-center h-4 px-1 rounded-full text-xs font-semibold text-white bg-mt-purple')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(countText)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Model$Fee$Merge$getNextConsolidateState = function (isSet) {
	return isSet ? 1 : 0;
};
var $author$project$Timesheet$FeeLogic$matterOnHold = function (fee) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (matter) {
				var _v0 = matter.h0;
				if (_v0.$ === 2) {
					return true;
				} else {
					return false;
				}
			},
			fee.hY));
};
var $author$project$Timesheet$FeeLogic$isHeld = function (fee) {
	return fee.ip || $author$project$Timesheet$FeeLogic$matterOnHold(fee);
};
var $author$project$Icons$Hold$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 18 18'),
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$stroke('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M9.375 18C7.6625 18 6.20312 17.3969 4.99687 16.1906C3.79062 14.9844 3.1875 13.525 3.1875 11.8125V5.0625C3.1875 4.5875 3.35312 4.1875 3.68437 3.8625C4.01562 3.5375 4.4125 3.375 4.875 3.375C4.9625 3.375 5.05625 3.38437 5.15625 3.40312C5.25625 3.42187 5.35 3.44375 5.4375 3.46875V2.8125C5.4375 2.3375 5.60312 1.9375 5.93437 1.6125C6.26562 1.2875 6.6625 1.125 7.125 1.125C7.225 1.125 7.32813 1.13438 7.43438 1.15313C7.54063 1.17188 7.64375 1.2 7.74375 1.2375C7.88125 0.875 8.09687 0.578125 8.39062 0.346875C8.68438 0.115625 9.0125 0 9.375 0C9.8125 0 10.2031 0.159375 10.5469 0.478125C10.8906 0.796875 11.0625 1.175 11.0625 1.6125C11.125 1.5875 11.2062 1.5625 11.3062 1.5375C11.4062 1.5125 11.5125 1.5 11.625 1.5C12.1 1.5 12.5 1.6625 12.825 1.9875C13.15 2.3125 13.3125 2.7125 13.3125 3.1875V6.2625C13.4125 6.2375 13.5156 6.21875 13.6219 6.20625C13.7281 6.19375 13.8125 6.1875 13.875 6.1875C14.35 6.1875 14.75 6.35 15.075 6.675C15.4 7 15.5625 7.4 15.5625 7.875V11.8125C15.5625 13.525 14.9594 14.9844 13.7531 16.1906C12.5469 17.3969 11.0875 18 9.375 18ZM9.375 16.875C10.075 16.875 10.7344 16.7438 11.3531 16.4813C11.9719 16.2188 12.5094 15.8594 12.9656 15.4031C13.4219 14.9469 13.7813 14.4094 14.0438 13.7906C14.3063 13.1719 14.4375 12.5125 14.4375 11.8125V7.875C14.4375 7.7125 14.3844 7.57812 14.2781 7.47187C14.1719 7.36562 14.0375 7.3125 13.875 7.3125C13.725 7.3125 13.5938 7.36562 13.4813 7.47187C13.3688 7.57812 13.3125 7.7125 13.3125 7.875V10.4062C13.3125 10.6063 13.2562 10.7719 13.1437 10.9031C13.0312 11.0344 12.8812 11.1313 12.6937 11.1938C12.3062 11.3188 11.975 11.525 11.7 11.8125C11.425 12.1 11.2375 12.4437 11.1375 12.8438C11.1 12.9813 11.0312 13.0938 10.9312 13.1813C10.8312 13.2688 10.7125 13.3125 10.575 13.3125C10.4 13.3125 10.2562 13.25 10.1437 13.125C10.0312 13 9.99375 12.85 10.0312 12.675C10.1688 12.1125 10.425 11.6156 10.8 11.1844C11.175 10.7531 11.6375 10.425 12.1875 10.2V3.1875C12.1875 3.025 12.1344 2.89063 12.0281 2.78438C11.9219 2.67813 11.7875 2.625 11.625 2.625C11.475 2.625 11.3438 2.67813 11.2313 2.78438C11.1188 2.89063 11.0625 3.025 11.0625 3.1875V7.5C11.0625 7.6625 11.0094 7.79688 10.9031 7.90313C10.7969 8.00938 10.6625 8.0625 10.5 8.0625C10.3375 8.0625 10.2031 8.00938 10.0969 7.90313C9.99062 7.79688 9.9375 7.6625 9.9375 7.5V1.6875C9.9375 1.525 9.88438 1.39062 9.77813 1.28437C9.67188 1.17812 9.5375 1.125 9.375 1.125C9.225 1.125 9.09375 1.17812 8.98125 1.28437C8.86875 1.39062 8.8125 1.525 8.8125 1.6875V7.5C8.8125 7.6625 8.75938 7.79688 8.65313 7.90313C8.54688 8.00938 8.4125 8.0625 8.25 8.0625C8.0875 8.0625 7.95312 8.00938 7.84687 7.90313C7.74062 7.79688 7.6875 7.6625 7.6875 7.5V2.8125C7.6875 2.65 7.63438 2.51563 7.52813 2.40938C7.42188 2.30313 7.2875 2.25 7.125 2.25C6.975 2.25 6.84375 2.30313 6.73125 2.40938C6.61875 2.51563 6.5625 2.65 6.5625 2.8125V8.25C6.5625 8.4125 6.50938 8.54688 6.40313 8.65313C6.29688 8.75938 6.1625 8.8125 6 8.8125C5.8375 8.8125 5.70313 8.75938 5.59688 8.65313C5.49063 8.54688 5.4375 8.4125 5.4375 8.25V5.0625C5.4375 4.9 5.38437 4.76563 5.27812 4.65938C5.17187 4.55313 5.0375 4.5 4.875 4.5C4.725 4.5 4.59375 4.55313 4.48125 4.65938C4.36875 4.76563 4.3125 4.9 4.3125 5.0625V11.8125C4.3125 12.5125 4.44375 13.1719 4.70625 13.7906C4.96875 14.4094 5.32813 14.9469 5.78438 15.4031C6.24063 15.8594 6.77813 16.2188 7.39688 16.4813C8.01563 16.7438 8.675 16.875 9.375 16.875Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$onHoldButton = function (isOnHold) {
	return isOnHold ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center w-21 px-1 py-0.5 gap-1'),
				$elm$html$Html$Attributes$class('rounded-lg bg-mt-purple-light'),
				$elm$html$Html$Attributes$class('text-white group cursor-pointer'),
				$elm$html$Html$Attributes$class('text-xs'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'on-hold-button')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Hold$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('w-5 h-5')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('On-hold')
					]))
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-5')
			]),
		_List_Nil);
};
var $elm$html$Html$sup = _VirtualDom_node('sup');
var $author$project$Timesheet$Conversation$View$renderUnits = F2(
	function (chargeableUnits, nonChargeableUnits) {
		return _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Timesheet$FeeLogic$roundUnitsString(chargeableUnits)),
				A2(
				$elm$html$Html$sup,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-mt-blue-light'),
						$elm$html$Html$Attributes$title('Non-Chargeable'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('hidden', !nonChargeableUnits)
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'+' + $author$project$Timesheet$FeeLogic$roundUnitsString(nonChargeableUnits))
					]))
			]);
	});
var $author$project$Timesheet$Conversation$View$tupleMapBoth = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple2(
			f(a),
			f(b));
	});
var $author$project$Timesheet$Conversation$View$sumUnits = function (fees) {
	return A2(
		$author$project$Timesheet$Conversation$View$tupleMapBoth,
		A2($elm$core$List$foldl, $elm$core$Basics$add, 0),
		A2(
			$author$project$Timesheet$Conversation$View$tupleMapBoth,
			$elm$core$List$map(
				function ($) {
					return $.jP;
				}),
			A2(
				$elm$core$List$partition,
				A2($elm$core$Basics$composeR, $author$project$Timesheet$FeeLogic$isNonChargeable, $elm$core$Basics$not),
				$mgold$elm_nonempty_list$List$Nonempty$toList(fees))));
};
var $author$project$Components$MatterInput$Messages$NoOperation = {$: 7};
var $author$project$Components$MatterInput$Views$EditMode$getDisplayedMatters = function (model) {
	var _v0 = $author$project$Components$MatterInput$Model$deriveDisplayMode(model);
	switch (_v0) {
		case 2:
			return A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.eW);
		case 1:
			return A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.fe);
		case 0:
			return model.iP;
		default:
			return A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.eI);
	}
};
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $elm$html$Html$Lazy$lazy4 = $elm$virtual_dom$VirtualDom$lazy4;
var $author$project$CoreX$Predicate$hasSameId = F2(
	function (a, b) {
		return _Utils_eq(a.aC, b.aC);
	});
var $author$project$MatterLogic$isSelected = F2(
	function (selectedMatter, matter) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$CoreX$Predicate$hasSameId(matter),
				selectedMatter));
	});
var $author$project$Components$MatterInput$Messages$SetMatter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$AutocompleteLogic$isHighlighted = F2(
	function (index, currentAutocompleteIndex) {
		return _Utils_eq(
			$elm$core$Maybe$Just(index),
			currentAutocompleteIndex);
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Components$MatterInput$Views$Common$getFields = F2(
	function (pms, matter) {
		return A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.af;
			},
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						{ay: 'font-semibold', ec: 'Description', af: matter.dd}
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendMaybeRun,
					matter.br,
					function (code) {
						return {ay: 'font-light', ec: 'Code', af: code};
					},
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						pms === 1,
						_List_fromArray(
							[
								{ay: 'font-light', ec: 'External Id', af: matter.gS}
							]),
						_List_Nil))));
	});
var $author$project$Components$MatterInput$Views$Common$renderSection = F2(
	function (prefix, descView) {
		var labelRole = A2(
			$elm$core$String$join,
			'-',
			A2(
				$elm$core$String$split,
				' ',
				$elm$core$String$toLower(descView.ec)));
		var role = 'matter-' + labelRole;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pr-1'),
					$elm$html$Html$Attributes$class(descView.ay),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-role',
					_Utils_ap(prefix, role)),
					$elm$html$Html$Attributes$title(descView.af)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(descView.af)
				]));
	});
var $author$project$Components$MatterInput$Views$Common$description = F3(
	function (prefix, pms, matter) {
		return A2(
			$elm$core$List$map,
			$author$project$Components$MatterInput$Views$Common$renderSection(prefix),
			A2($author$project$Components$MatterInput$Views$Common$getFields, pms, matter));
	});
var $author$project$Icons$Error$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 18 18'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('timesheet-error-states'),
								$elm$svg$Svg$Attributes$transform('translate(-817.000000, -221.000000)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('error'),
										$elm$svg$Svg$Attributes$transform('translate(818.000000, 222.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$circle,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('oval'),
												$elm$svg$Svg$Attributes$stroke('currentColor'),
												$elm$svg$Svg$Attributes$strokeWidth('2'),
												$elm$svg$Svg$Attributes$strokeLinecap('round'),
												$elm$svg$Svg$Attributes$strokeLinejoin('round'),
												$elm$svg$Svg$Attributes$cx('8'),
												$elm$svg$Svg$Attributes$cy('8'),
												$elm$svg$Svg$Attributes$r('8')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$circle,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('dot'),
												$elm$svg$Svg$Attributes$fill('currentColor'),
												$elm$svg$Svg$Attributes$cx('8'),
												$elm$svg$Svg$Attributes$cy('12'),
												$elm$svg$Svg$Attributes$r('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M8,9 L8,3'),
												$elm$svg$Svg$Attributes$id('line'),
												$elm$svg$Svg$Attributes$stroke('currentColor'),
												$elm$svg$Svg$Attributes$strokeWidth('2'),
												$elm$svg$Svg$Attributes$strokeLinecap('round'),
												$elm$svg$Svg$Attributes$strokeLinejoin('round')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Icons$Error$view = $author$project$Icons$Error$viewWithAttributes(_List_Nil);
var $author$project$Icons$Warning$view = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$version('1.1'),
			$elm$svg$Svg$Attributes$height('100%'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18.5 19h-18c-0.178 0-0.342-0.094-0.432-0.248s-0.091-0.343-0.004-0.498l9-16c0.089-0.157 0.255-0.255 0.436-0.255s0.347 0.097 0.436 0.255l9 16c0.087 0.155 0.085 0.344-0.004 0.498s-0.254 0.248-0.432 0.248zM1.355 18h16.29l-8.145-14.48-8.145 14.48z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M9.5 14c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276-0.224 0.5-0.5 0.5z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M9.5 17c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z')
				]),
			_List_Nil)
		]));
var $author$project$Components$MatterInput$Views$Common$renderDescription = F3(
	function (prefix, pms, matter) {
		return A2(
			$author$project$CoreX$Appendable$andAppend,
			A3($author$project$Components$MatterInput$Views$Common$description, prefix, pms, matter),
			_List_fromArray(
				[
					function () {
					var _v0 = matter.h0;
					switch (_v0.$) {
						case 2:
							var onHoldReason = _v0.a;
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pr-2 w-3 h-3 inline-block icon icon--warning'),
										$elm$html$Html$Attributes$title(onHoldReason)
									]),
								_List_fromArray(
									[$author$project$Icons$Warning$view]));
						case 1:
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pr-2 w-3 h-3 inline-block icon icon--warning'),
										$elm$html$Html$Attributes$title('Archived')
									]),
								_List_fromArray(
									[$author$project$Icons$Error$view]));
						default:
							return A2($elm$html$Html$span, _List_Nil, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Components$MatterInput$Views$EditMode$SelectableMatter$view = F6(
	function (matter, pms, matterClasses, isSelected, index, autocompleteIndex) {
		var matterIdString = $elm$core$String$fromInt(matter.aC);
		var isHighlighted = A2($author$project$Components$AutocompleteLogic$isHighlighted, index, autocompleteIndex);
		var billableMatter = !matter.fS;
		var titleText = A3(
			$author$project$CoreX$Appendable$andAppendIf,
			!billableMatter,
			' (non-chargeable)',
			$author$project$MatterLogic$matterTitle(matter));
		return A2(
			$elm$html$Html$li,
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				isSelected,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-role-two', 'selected')
					]),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-6 md:px-4 py-2 md:py-0'),
						$elm$html$Html$Attributes$class('text-lg md:text-base font-normal'),
						$elm$html$Html$Attributes$class('border border-transparent hover:bg-mt-blue-lightest cursor-pointer'),
						$elm$html$Html$Attributes$class('truncate'),
						$elm$html$Html$Attributes$id(
						'matter-search-index-' + $elm$core$String$fromInt(index)),
						$elm$html$Html$Attributes$class('matter-' + matterIdString),
						$elm$html$Html$Attributes$class(matterClasses),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('text-mt-purple', isSelected),
								_Utils_Tuple2('text-mt-grey-dark', billableMatter && (!isSelected)),
								_Utils_Tuple2('bg-mt-purple-lighter', isHighlighted),
								_Utils_Tuple2('text-mt-blue', !billableMatter)
							])),
						$elm$html$Html$Attributes$value(matterIdString),
						$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
						$author$project$Components$MatterInput$Messages$SetMatter(matter)),
						$elm_community$html_extra$Html$Events$Extra$onEnter(
						$author$project$Components$MatterInput$Messages$SetMatter(matter)),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter-row'),
						$elm$html$Html$Attributes$title(titleText)
					])),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-light md:font-regular text-lg md:text-sm'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter-clientName')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' (' + (matter.gd + ')'))
							]))
					]),
				A3($author$project$Components$MatterInput$Views$Common$renderDescription, '', pms, matter)));
	});
var $author$project$Components$MatterInput$Views$EditMode$ListMatters$displayMatter = F5(
	function (selectedMatter, pms, autocompleteIndex, index, matter) {
		return A6(
			$author$project$Components$MatterInput$Views$EditMode$SelectableMatter$view,
			matter,
			pms,
			'px-4',
			A2($author$project$MatterLogic$isSelected, selectedMatter, matter),
			index,
			autocompleteIndex);
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Components$MatterInput$Views$EditMode$ListMatters$displayMatters = F4(
	function (selectedMatter, pms, matters, autocompleteIndex) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('max-w-lg'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'matters-list')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('matterId'),
							$elm$html$Html$Attributes$class('p-0 m-0 text-mt-grey-dark')
						]),
					A2(
						$elm$core$List$indexedMap,
						A3($author$project$Components$MatterInput$Views$EditMode$ListMatters$displayMatter, selectedMatter, pms, autocompleteIndex),
						matters))
				]));
	});
var $author$project$Components$ErrorView$matterResultsErrorMessage = F2(
	function (message, element) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					element,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 ')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]));
	});
var $author$project$Components$MatterInput$Views$EditMode$ListMatters$view = F4(
	function (selectedMatter, pms, webdataMatters, autocompleteIndex) {
		switch (webdataMatters.$) {
			case 0:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 text-grey')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Waiting for at least 2 letters...')
						]));
			case 1:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 text-grey')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Loading...')
						]));
			case 2:
				var err = webdataMatters.a;
				return A2(
					$author$project$Components$ErrorView$matterResultsErrorMessage,
					'Fetching matters failed',
					A4($author$project$Components$MatterInput$Views$EditMode$ListMatters$displayMatters, selectedMatter, pms, _List_Nil, $elm$core$Maybe$Nothing));
			default:
				if (!webdataMatters.a.b) {
					return A2(
						$author$project$Components$ErrorView$matterResultsErrorMessage,
						'No results found...',
						A4($author$project$Components$MatterInput$Views$EditMode$ListMatters$displayMatters, selectedMatter, pms, _List_Nil, $elm$core$Maybe$Nothing));
				} else {
					var matters = webdataMatters.a;
					return A4($author$project$Components$MatterInput$Views$EditMode$ListMatters$displayMatters, selectedMatter, pms, matters, autocompleteIndex);
				}
		}
	});
var $author$project$Components$MatterInput$Views$EditMode$mattersForSelection = F3(
	function (selectedMatter, pms, model) {
		var _v0 = $author$project$Components$MatterInput$Model$deriveDisplayMode(model);
		switch (_v0) {
			case 2:
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'search-results',
						A5($elm$html$Html$Lazy$lazy4, $author$project$Components$MatterInput$Views$EditMode$ListMatters$view, selectedMatter, pms, model.eW, model.av))
					]);
			case 1:
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'suggested-matters',
						A4($author$project$Components$MatterInput$Views$EditMode$ListMatters$view, selectedMatter, pms, model.fe, model.av))
					]);
			case 0:
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'recent-matters',
						A4(
							$author$project$Components$MatterInput$Views$EditMode$ListMatters$view,
							selectedMatter,
							pms,
							$krisajenkins$remotedata$RemoteData$succeed(model.iP),
							model.av))
					]);
			default:
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'recent-restricted-matters',
						A4($author$project$Components$MatterInput$Views$EditMode$ListMatters$view, selectedMatter, pms, model.eI, model.av))
					]);
		}
	});
var $author$project$Components$MatterInput$Messages$Autocomplete = {$: 2};
var $author$project$Direction$Next = 0;
var $author$project$Components$MatterInput$Messages$SetAutocompleteIndex = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$MatterInput$HotKeys$autocompleteIndexDetails = F3(
	function (currentIndex, addOneForPendingMatter, records) {
		var onFirst = _Utils_eq(
			currentIndex,
			$elm$core$Maybe$Just(0));
		var noAutocomplete = $elm_community$maybe_extra$Maybe$Extra$isNothing(currentIndex);
		var autocompleteListLength = function (n) {
			return addOneForPendingMatter ? (n + 1) : n;
		}(
			$elm$core$List$length(records));
		var onLast = _Utils_eq(
			currentIndex,
			$elm$core$Maybe$Just(autocompleteListLength - 1));
		return {b6: noAutocomplete, b9: onFirst, ca: onLast};
	});
var $author$project$Components$MatterInput$HotKeys$msgForKeyboardEvent = F2(
	function (currentIndex, records) {
		var _v0 = A3($author$project$Components$MatterInput$HotKeys$autocompleteIndexDetails, currentIndex, true, records);
		var onFirst = _v0.b9;
		var onLast = _v0.ca;
		var noAutocompleteIndex = _v0.b6;
		return _List_fromArray(
			[
				_Utils_Tuple2('Escape', $author$project$Components$MatterInput$Messages$CloseMatterEdit),
				_Utils_Tuple2('Enter', $author$project$Components$MatterInput$Messages$Autocomplete),
				_Utils_Tuple2('Tab', $author$project$Components$MatterInput$Messages$Autocomplete),
				_Utils_Tuple2(
				'ArrowDown',
				((!onLast) || noAutocompleteIndex) ? $author$project$Components$MatterInput$Messages$SetAutocompleteIndex(0) : $author$project$Components$MatterInput$Messages$NoOperation),
				_Utils_Tuple2(
				'ArrowUp',
				(!onFirst) ? $author$project$Components$MatterInput$Messages$SetAutocompleteIndex(1) : $author$project$Components$MatterInput$Messages$NoOperation)
			]);
	});
var $author$project$KeyShortcutEvents$getInDict = F2(
	function (dict, key) {
		return A2($elm$core$Dict$get, key, dict);
	});
var $author$project$KeyShortcutEvents$keyMapper = F2(
	function (specAsList, keyboardEvent) {
		var spec = $elm$core$Dict$fromList(specAsList);
		return A2(
			$elm$core$Maybe$map,
			function (msg) {
				return _Utils_Tuple2(
					msg,
					function () {
						var _v0 = keyboardEvent.d9;
						if ((!_v0.$) && (_v0.a === 'Escape')) {
							return true;
						} else {
							return false;
						}
					}());
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$KeyShortcutEvents$getInDict(spec),
				keyboardEvent.d9));
	});
var $author$project$KeyShortcutEvents$on = function (specAsList) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'keydown',
		$Gizra$elm_keyboard_event$Keyboard$Event$considerKeyboardEvent(
			$author$project$KeyShortcutEvents$keyMapper(specAsList)));
};
var $author$project$Components$MatterInput$Messages$SetPendingMatter = {$: 3};
var $author$project$Components$MatterInput$Views$EditMode$PendingMatter$view = F2(
	function (index, currentAutocompleteIndex) {
		var isHighlighted = A2($author$project$Components$AutocompleteLogic$isHighlighted, index, currentAutocompleteIndex);
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('p-0 m-0 mt-1 text-mt-grey-dark')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 py-2 text-lg font-normal truncate cursor-pointer'),
							$elm$html$Html$Attributes$class('md:px-4 md:py-0 md:text-sm'),
							$elm$html$Html$Attributes$class('hover:bg-mt-blue-lightest'),
							$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Components$MatterInput$Messages$SetPendingMatter),
							$elm$html$Html$Events$onClick($author$project$Components$MatterInput$Messages$SetPendingMatter),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'pending-matter-row'),
							$elm$html$Html$Attributes$title('Pending New Matter'),
							$elm$html$Html$Attributes$id(
							'matter-search-index-' + $elm$core$String$fromInt(index)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('bg-mt-purple-lighter', isHighlighted),
									_Utils_Tuple2('bg-mt-grey-lightest', !isHighlighted)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-block font-regular'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Pending New Matter')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-light md:font-regular text-lg md:inline-block md:text-sm pl-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('-- To Be Created')
								]))
						]))
				]));
	});
var $author$project$Components$MatterInput$Messages$SearchInputChanged = function (a) {
	return {$: 12, a: a};
};
var $author$project$Icons$Unlocked$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 15 20'),
					$elm$svg$Svg$Attributes$fill('currentColor')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M1.80775 6.5H10.5V4.5C10.5 3.66667 10.2083 2.95833 9.625 2.375C9.04167 1.79167 8.33333 1.5 7.5 1.5C6.66667 1.5 5.95833 1.79167 5.375 2.375C4.79167 2.95833 4.5 3.66667 4.5 4.5H3C3 3.25133 3.43783 2.18917 4.3135 1.3135C5.18917 0.437833 6.25133 0 7.5 0C8.74867 0 9.81083 0.437833 10.6865 1.3135C11.5622 2.18917 12 3.25133 12 4.5V6.5H13.1923C13.6909 6.5 14.1169 6.67658 14.4703 7.02975C14.8234 7.38308 15 7.80908 15 8.30775V17.6923C15 18.1909 14.8234 18.6169 14.4703 18.9703C14.1169 19.3234 13.6909 19.5 13.1923 19.5H1.80775C1.30908 19.5 0.883083 19.3234 0.52975 18.9703C0.176583 18.6169 0 18.1909 0 17.6923V8.30775C0 7.80908 0.176583 7.38308 0.52975 7.02975C0.883083 6.67658 1.30908 6.5 1.80775 6.5ZM1.80775 18H13.1923C13.2821 18 13.3558 17.9712 13.4135 17.9135C13.4712 17.8558 13.5 17.7821 13.5 17.6923V8.30775C13.5 8.21792 13.4712 8.14417 13.4135 8.0865C13.3558 8.02883 13.2821 8 13.1923 8H1.80775C1.71792 8 1.64417 8.02883 1.5865 8.0865C1.52883 8.14417 1.5 8.21792 1.5 8.30775V17.6923C1.5 17.7821 1.52883 17.8558 1.5865 17.9135C1.64417 17.9712 1.71792 18 1.80775 18ZM7.5 14.75C7.98583 14.75 8.399 14.5798 8.7395 14.2395C9.07983 13.899 9.25 13.4858 9.25 13C9.25 12.5142 9.07983 12.101 8.7395 11.7605C8.399 11.4202 7.98583 11.25 7.5 11.25C7.01417 11.25 6.601 11.4202 6.2605 11.7605C5.92017 12.101 5.75 12.5142 5.75 13C5.75 13.4858 5.92017 13.899 6.2605 14.2395C6.601 14.5798 7.01417 14.75 7.5 14.75Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$MatterInput$Views$EditMode$SearchInput$view = F4(
	function (model, pms, context, domId) {
		var isRestrictedMode = model.bY === 2;
		var inputDomId = domId + '-search';
		return A3(
			$elm$html$Html$Keyed$node,
			'span',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-between items-center h-12 md:h-6 px-4 mb-2 border-y border-mt-grey-lighter md:border-none')
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						_Utils_Tuple2(
						inputDomId + 'close-key',
						$author$project$Icons$CloseCross$viewWithAttributes(
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$MatterInput$Messages$CloseMatterEdit),
									$elm$svg$Svg$Attributes$class('md:hidden h-3.4 stroke-current text-mt-grey icon icon--search cursor-pointer')
								])))
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					(pms === 1) && (!isRestrictedMode),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'inputDomId' + '-restricted',
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cursor-pointer'),
										$elm$html$Html$Attributes$title('Restricted Matter Search'),
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'restricted-filter-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mr-4 w-6 h-6')
											]),
										_List_fromArray(
											[
												$author$project$Icons$Unlocked$viewWithAttributes(
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('icon fill-mt-purple-lighter hover:fill-mt-purple icon--unlocked'),
														$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
														A2($author$project$Components$MatterInput$Messages$OpenMatterEdit, 2, context))
													]))
											]))
									])))
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							inputDomId + '-icon',
							$author$project$Icons$Search$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('w-6 mr-3 icon stroke-current icon--search pt-0 text-mt-purple-lighter')
									]))),
							_Utils_Tuple2(
							inputDomId + '-input-key',
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('relative z-30 h-6 font-light w-full focus:border-b focus:border-mt-grey-lighter')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id(inputDomId),
												$elm$html$Html$Attributes$class('w-full bg-transparent relative z-10 text-grey-darkest'),
												A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter-search-input'),
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$value(model.eX),
												$elm$html$Html$Events$onInput($author$project$Components$MatterInput$Messages$SearchInputChanged)
											]),
										_List_Nil)
									])))
						]))));
	});
var $author$project$Components$MatterInput$Views$EditMode$view = F2(
	function (context, _v0) {
		var pms = _v0.ce;
		var selectedMatter = _v0.cq;
		var matterModel = _v0.h$;
		var domId = _v0.gG;
		var matters = $author$project$Components$MatterInput$Views$EditMode$getDisplayedMatters(matterModel);
		var mattersListLength = $elm$core$List$length(matters);
		var msgForKeyboardEvent = A2($author$project$Components$MatterInput$HotKeys$msgForKeyboardEvent, matterModel.av, matters);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute'),
					$elm$html$Html$Attributes$class('left-0 top-0 w-full h-screen--12'),
					$elm$html$Html$Attributes$class('md:inset-auto md:h-auto md:w-auto'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'md:-mt-4',
							_Utils_eq(selectedMatter, $elm$core$Maybe$Nothing)),
							_Utils_Tuple2(
							'md:-mt-6',
							!_Utils_eq(selectedMatter, $elm$core$Maybe$Nothing))
						])),
					$author$project$KeyShortcutEvents$on(msgForKeyboardEvent),
					$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation($author$project$Components$MatterInput$Messages$NoOperation)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-8 hidden md:block arrow arrow-up')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('z-50 bg-white'),
							$elm$html$Html$Attributes$class('md:flex md:border md:rounded-lg md:border-grey-light md:shadow-sm'),
							$elm$html$Html$Attributes$class('h-screen--12 md:h-auto'),
							$elm$html$Html$Attributes$class('focus-within:border-mt-purple'),
							$elm$html$Html$Attributes$class('absolute w-screen md:w-128')
						]),
					_List_fromArray(
						[
							A3(
							$elm$html$Html$Keyed$node,
							'div',
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('overflow-y-scroll z-10 md:pt-3 mb-8 md:mb-0 min-w-full'),
										$elm$html$Html$Attributes$class('sm:max-w-sm md:min-h-80 md:max-h-92 lg:max-w-lg'),
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter-input-view')
									]),
								A2($author$project$OnClickOutsideAfterFocus$withId, domId, $author$project$Components$MatterInput$Messages$CloseMatterEdit)),
							_Utils_ap(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'search-input' + domId,
										A4($author$project$Components$MatterInput$Views$EditMode$SearchInput$view, matterModel, pms, context, domId))
									]),
								_Utils_ap(
									A3($author$project$Components$MatterInput$Views$EditMode$mattersForSelection, selectedMatter, pms, matterModel),
									_List_fromArray(
										[
											_Utils_Tuple2(
											'pending-matter',
											A2($author$project$Components$MatterInput$Views$EditMode$PendingMatter$view, mattersListLength, matterModel.av))
										]))))
						]))
				]));
	});
var $author$project$Components$MatterInput$Messages$RunningTimer = 3;
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Components$MatterInput$Views$ShowMode$displaySelectMatterPrompt = F2(
	function (_v0, context) {
		var hasPendingMatter = _v0.a_;
		var matterModel = _v0.h$;
		var promptLabelText = hasPendingMatter ? 'Pending New Matter' : 'Please select a matter.';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden md:block', context === 3)
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-tour', 'matter-selector')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center w-full h-14')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								matterModel.bY === 1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$tabindex(0)
									]),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block -mb-px'),
										$elm$html$Html$Attributes$class('font-bold cursor-pointer text-mt-red-light'),
										$elm$html$Html$Attributes$class('md:hover:text-mt-red'),
										$elm$html$Html$Attributes$class('outline-hidden'),
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'open-matter-search'),
										$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
										A2($author$project$Components$MatterInput$Messages$OpenMatterEdit, 0, context)),
										$elm$html$Html$Events$onFocus(
										A2($author$project$Components$MatterInput$Messages$OpenMatterEdit, 0, context))
									])),
							_List_fromArray(
								[
									$elm$html$Html$text(promptLabelText)
								]))
						]))
				]));
	});
var $author$project$Components$MatterInput$Messages$ConfirmMatter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Icons$BillButton$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 40 40')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M 17 24.17 L 12.83 20 L 11.41 21.41 L 17 27 L 29 15 L 27.59 13.59 Z')
					]),
				_List_Nil)
			]));
};
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $elm$svg$Svg$Attributes$strokeMiterlimit = _VirtualDom_attribute('stroke-miterlimit');
var $author$project$Icons$BillGroupButton$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 40 40')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M 11,24.17 6.83,20 5.41,21.41 11,27 23,15 21.59,13.59 Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m 19.540308,17.335033 h 6.263465'),
						$elm$svg$Svg$Attributes$class('stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1.998'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeOpacity('1'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('4'),
						$elm$svg$Svg$Attributes$strokeDasharray('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m 16.241411,20.7239 h 9.562362'),
						$elm$svg$Svg$Attributes$class('stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1.998'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeOpacity('1'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('4'),
						$elm$svg$Svg$Attributes$strokeDasharray('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M 12.923814,24.1239 H 25.803773'),
						$elm$svg$Svg$Attributes$class('stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1.998'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeOpacity('1'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('4'),
						$elm$svg$Svg$Attributes$strokeDasharray('none')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$MatterInput$Views$ShowMode$matterConfirm = F4(
	function (matter, hasGuessedMatter, editable, context) {
		return (editable && hasGuessedMatter) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$tabindex(-1),
					$elm_community$html_extra$Html$Events$Extra$onEnter(
					A2($author$project$Components$MatterInput$Messages$ConfirmMatter, matter, context)),
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
					A2($author$project$Components$MatterInput$Messages$ConfirmMatter, matter, context)),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'confirm-matter')
				]),
			_List_fromArray(
				[
					function () {
					if (!context) {
						return $author$project$Icons$BillGroupButton$viewWithAttributes;
					} else {
						return $author$project$Icons$BillButton$viewWithAttributes;
					}
				}()(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('align-top mb-8px w-9 icon icon--bill-button fill-current text-mt-grey-light hover:text-mt-green cursor-pointer')
						]))
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hidden')
				]),
			_List_Nil);
	});
var $author$project$Components$MatterInput$Views$ShowMode$displaySelectedMatter = F4(
	function (_v0, editable, context, matter) {
		var pms = _v0.ce;
		var matterModel = _v0.h$;
		var hasGuessedMatter = _v0.aB;
		var feeSearchTerms = _v0.bF;
		var matterDescIsSameAsCode = _Utils_eq(
			matter.br,
			$elm$core$Maybe$Just(matter.dd));
		var matterDescription = matterDescIsSameAsCode ? _List_fromArray(
			[
				$elm$html$Html$text('')
			]) : A2($author$project$Components$MarkMatchingTerms$markedTexts, feeSearchTerms, matter.dd);
		var editableAttrs = editable ? A3(
			$author$project$CoreX$Appendable$andAppendIf,
			matterModel.bY === 1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-bold cursor-pointer truncate'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('text-mt-red-light md:hover:text-mt-red', hasGuessedMatter),
							_Utils_Tuple2('md:hover:text-mt-blue', !hasGuessedMatter)
						])),
					$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
					A2($author$project$Components$MatterInput$Messages$OpenMatterEdit, 0, context)),
					$elm$html$Html$Events$onFocus(
					A2($author$project$Components$MatterInput$Messages$OpenMatterEdit, 0, context))
				])) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('inline-block font-bold truncate')
			]);
		var commonAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-1 sm:mt-0 select-none'),
				$elm$html$Html$Attributes$class('outline-hidden'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'open-matter-search'),
				$elm$html$Html$Attributes$title(matter.dd)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center'),
					$elm$html$Html$Attributes$class('leading-tight'),
					$elm$html$Html$Attributes$class('w-full'),
					$elm$html$Html$Attributes$class('mt-0')
				]),
			_List_fromArray(
				[
					A4($author$project$Components$MatterInput$Views$ShowMode$matterConfirm, matter, hasGuessedMatter, editable, context),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							hasGuessedMatter ? 'w-full-8' : 'w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							A2(
								$author$project$CoreX$Appendable$andAppend,
								editableAttrs,
								A2(
									$author$project$CoreX$Appendable$andAppend,
									commonAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full inline-flex flex-row items-end')
										]))),
							A3($author$project$Components$MatterInput$Views$Common$renderDescription, 'selected-', pms, matter)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select-none max-w-sm font-light text-sm leading-none md:pt-0 pb-2px sm:pb-0 sm:leading-normal sm:text-base truncate'),
									$elm$html$Html$Attributes$title(matter.gd)
								]),
							A2($author$project$Components$MarkMatchingTerms$markedTexts, feeSearchTerms, matter.gd))
						]))
				]));
	});
var $author$project$Components$MatterInput$Views$ShowMode$view = F3(
	function (model, editable, context) {
		var selectedMatter = model.cq;
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$MatterInput$Views$ShowMode$displaySelectMatterPrompt, model, context),
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Components$MatterInput$Views$ShowMode$displaySelectedMatter, model, editable, context),
				selectedMatter));
	});
var $author$project$Components$MatterInput$View$view = F3(
	function (model, editable, context) {
		var matterModel = model.h$;
		var showEdit = !matterModel.bY;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-tour', 'matter-component')
				]),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				showEdit,
				_List_fromArray(
					[
						A2($author$project$Components$MatterInput$Views$EditMode$view, context, model)
					]),
				_List_fromArray(
					[
						A3($author$project$Components$MatterInput$Views$ShowMode$view, model, editable, context)
					])));
	});
var $author$project$Timesheet$Conversation$View$groupHeader = F2(
	function (zone, _v0) {
		var matterInput = _v0.eg;
		var searchTerm = _v0.i2;
		var isExpanded = _v0.hC;
		var hasSelectedFee = _v0.hk;
		var groupByKey = _v0.bL;
		var consolidateFeeType = _v0.gk;
		var feeRowContext = _v0.bE;
		var fees = _v0.aY;
		var earliestFee = _v0.dk;
		var postStatus = $author$project$Model$Fee$PostStatus$toString(
			$author$project$Timesheet$Conversation$Logic$conversationPostStatus(fees));
		var isConversationEditable = A2($mgold$elm_nonempty_list$List$Nonempty$any, $author$project$Timesheet$FeeLogic$isEditable, fees);
		var groupIsMergable = A2($mgold$elm_nonempty_list$List$Nonempty$all, $author$project$Timesheet$FeeLogic$isEditable, fees);
		var groupHasRunningTimer = $elm_community$maybe_extra$Maybe$Extra$isJust(
			A2(
				$elm_community$list_extra$List$Extra$find,
				$author$project$FeeTimerLogic$isTimerRunning,
				$mgold$elm_nonempty_list$List$Nonempty$toList(fees)));
		var groupFee = A2(
			$elm$core$Maybe$withDefault,
			earliestFee,
			A2(
				$elm$core$Maybe$map,
				function (ft) {
					return _Utils_update(
						earliestFee,
						{
							dd: A2($author$project$FeeEntry$FeeEntryLogic$applyFeeTypeChange, earliestFee, ft),
							g0: ft
						});
				},
				consolidateFeeType));
		var feesCount = $mgold$elm_nonempty_list$List$Nonempty$length(fees);
		var feeIds = A2(
			$mgold$elm_nonempty_list$List$Nonempty$map,
			function ($) {
				return $.aC;
			},
			fees);
		var isSetForMerging = A2(
			$mgold$elm_nonempty_list$List$Nonempty$all,
			function (fId) {
				return A2($elm$core$Set$member, fId, feeRowContext.gj);
			},
			feeIds);
		var nextConsolidateState = $author$project$Model$Fee$Merge$getNextConsolidateState(isSetForMerging);
		var expandOrCollapseMessage = isExpanded ? $author$project$TimesheetPage$Messages$CollapseGroupedConversations(groupByKey) : $author$project$TimesheetPage$Messages$ExpandGroupedConversations(groupByKey);
		var disableConsolidateButton = (!groupIsMergable) || groupHasRunningTimer;
		var anyOnHold = A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(true),
			$mgold$elm_nonempty_list$List$Nonempty$toList(
				A2($mgold$elm_nonempty_list$List$Nonempty$map, $author$project$Timesheet$FeeLogic$isHeld, fees)));
		var _v1 = $author$project$Timesheet$Conversation$View$sumUnits(fees);
		var chargeableUnits = _v1.a;
		var nonChargeableUnits = _v1.b;
		return _Utils_Tuple2(
			'fees-conversation-header-' + $author$project$Timesheet$FeeLogic$activitySubject(groupFee),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'fees-conversation-header'),
						$elm$html$Html$Attributes$class('border flex items-center'),
						$elm$html$Html$Attributes$class('fees-conversation-header'),
						$elm$html$Html$Attributes$class('hover:bg-mt-blue-lightest '),
						$elm$html$Html$Attributes$class('hover:border-mt-purple-lighter'),
						$elm$html$Html$Events$onClick(expandOrCollapseMessage),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('bg-mt-purple-lightest', hasSelectedFee || isExpanded),
								_Utils_Tuple2('mb-px', !isExpanded)
							]))
					]),
				A2(
					$author$project$CoreX$Appendable$andAppend,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fee md:h-20 relative'),
									$elm$html$Html$Attributes$class('group'),
									$elm$html$Html$Attributes$class('w-full'),
									$elm$html$Html$Attributes$class('grid gap-x-4 gap-y-0'),
									$elm$html$Html$Attributes$class('grid-cols-fee-form-mobile md:grid-cols-fee'),
									$elm$html$Html$Attributes$class('place-items-center'),
									$elm$html$Html$Attributes$class('pl-2 md:pl-4'),
									$elm$html$Html$Attributes$class('pr-4 md:pr-8'),
									$elm$html$Html$Attributes$class(postStatus),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('conversation-selected', hasSelectedFee)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-span-1 w-full relative min-w-0'),
											A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type')
										]),
									_List_fromArray(
										[
											A4($author$project$Timesheet$Views$GroupedFeeTypeAndActivityColumns$feeTypeView, groupFee, feesCount, searchTerm, isExpanded)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hovercard col-span-2 md:col-span-3 w-full'),
											A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-column')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Timesheet$Views$FeeTypeAndActivityColumns$activityColumn,
											groupFee,
											$elm_community$maybe_extra$Maybe$Extra$isJust(groupFee.bd),
											searchTerm)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-light overflow-hidden min-w-0'),
											$elm$html$Html$Attributes$class('col-start-2 md:col-start-auto col-span-2 md:col-span-4 flex w-full'),
											A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$TimesheetPage$Messages$ConversationMatterMsg(groupByKey),
											A3(
												$author$project$Components$MatterInput$View$view,
												A5($author$project$Components$MatterInput$Views$EditMode$Model$fromConversationMatterInput, zone, feeRowContext.jS.ce, groupByKey, matterInput, fees),
												isConversationEditable,
												0))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'data-role', 'total-units-and-consolidate-button'),
											$elm$html$Html$Attributes$class('col-start-2 md:col-start-auto col-span-2 place-self-end md:col-span-1 md:self-center md:place-self-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('tile flex md:justify-center pt-3 text-right text-lg font-bold'),
													$elm$html$Html$Attributes$class('overflow-hidden sm:pt-0'),
													$elm$html$Html$Attributes$class('md:text-base'),
													A2($elm$html$Html$Attributes$attribute, 'data-role', 'total-units'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('text-mt-blue-light', !chargeableUnits),
															_Utils_Tuple2('hidden', isExpanded && groupIsMergable),
															_Utils_Tuple2('group-hover:hidden', groupIsMergable)
														]))
												]),
											A2($author$project$Timesheet$Conversation$View$renderUnits, chargeableUnits, nonChargeableUnits)),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$attribute, 'data-role', 'consolidate-button-div'),
													$elm$html$Html$Attributes$class('items-center'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('hidden group-hover:block', (!isExpanded) && groupIsMergable),
															_Utils_Tuple2('hidden', (!groupIsMergable) || ((!isExpanded) && groupHasRunningTimer))
														]))
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Timesheet$Views$FeeActionButtons$consolidateButton,
													$elm_community$maybe_extra$Maybe$Extra$isJust(consolidateFeeType),
													feeIds,
													disableConsolidateButton)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hidden md:col-span-2'),
											$elm$html$Html$Attributes$class('md:w-full md:grid md:grid-cols-fee-buttons md:gap-x-1 md:justify-end md:justify-items-end')
										]),
									A2(
										$author$project$CoreX$Appendable$andAppend,
										_List_fromArray(
											[
												$author$project$Timesheet$Views$FeeActionButtons$deleteGroupButton(fees)
											]),
										A2(
											$author$project$CoreX$Appendable$andAppend,
											_List_fromArray(
												[
													A2($elm$html$Html$div, _List_Nil, _List_Nil)
												]),
											A2(
												$author$project$CoreX$Appendable$andAppend,
												_List_fromArray(
													[
														$author$project$Timesheet$Views$FeeActionButtons$onHoldButton(anyOnHold)
													]),
												_List_Nil))))
								]))
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						feeRowContext.cY && groupIsMergable,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A5(
										$author$project$Components$MergeFeesToolbar$consolidateCheckbox,
										A3($author$project$TimesheetPage$Messages$SetGroupConsolidating, 0, nextConsolidateState, feeIds),
										groupIsMergable,
										true,
										isSetForMerging,
										groupHasRunningTimer)
									]))
							]),
						_List_Nil))));
	});
var $author$project$Timesheet$Conversation$View$renderCollapsedFees = function (_v0) {
	var groupByKey = _v0.bL;
	var fees = _v0.aY;
	var collapsedFee = _Utils_Tuple2(
		'collapsed-fee',
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$TimesheetPage$Messages$ExpandGroupedConversations(groupByKey))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-1 flex items-center relative px-4 border-y border-l'),
							$elm$html$Html$Attributes$class('-mt-px hover:bg-mt-blue-lightest hover:border-l-2 hover:pl-15px hover:border-mt-purple-lighter')
						]),
					_List_Nil)
				])));
	return A2(
		$elm$core$List$take,
		8,
		$mgold$elm_nonempty_list$List$Nonempty$toList(
			A2(
				$mgold$elm_nonempty_list$List$Nonempty$map,
				$elm$core$Basics$always(collapsedFee),
				fees)));
};
var $author$project$Components$MatterInput$Messages$InGroup = 1;
var $author$project$FeeEntry$Messages$NoOperation = {$: 44};
var $author$project$FeeEntry$View$availableTagsFor = F2(
	function (_v0, fee) {
		return A2(
			$elm$core$List$filter,
			function (t) {
				return $elm$core$String$toLower(t.b2) !== 'split';
			},
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				function ($) {
					return $.fi;
				},
				fee.hY));
	});
var $author$project$FeeEntry$FeeEntryLogic$Chargeable = 0;
var $author$project$FeeEntry$FeeEntryLogic$FeeTypeNotChargeable = 1;
var $author$project$FeeEntry$FeeEntryLogic$MatterNotChargeable = 2;
var $author$project$FeeEntry$FeeEntryLogic$getChargeableStatus = F2(
	function (matter, feeType) {
		var matterBillingBehaviour = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fS;
				},
				matter));
		return (!(!matterBillingBehaviour)) ? 2 : ((!(!feeType.fS)) ? 1 : 0);
	});
var $author$project$FeeEntry$Messages$SetBillingBehaviour = function (a) {
	return {$: 27, a: a};
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $author$project$Model$Fee$BillingBehaviour$toDisplayString = function (billingBehaviour) {
	switch (billingBehaviour) {
		case 0:
			return 'Chargeable';
		case 1:
			return 'Non-chargeable';
		case 2:
			return 'Hidden';
		default:
			return 'Not Billable';
	}
};
var $author$project$Model$Fee$BillingBehaviour$behavioursToOptions = function (options) {
	return A2(
		$elm$core$List$map,
		function (b) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						$author$project$Model$Fee$BillingBehaviour$toString(b))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Model$Fee$BillingBehaviour$toDisplayString(b))
					]));
		},
		options);
};
var $elm_community$html_extra$Html$Events$Extra$onChange = function (onChangeAction) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, onChangeAction, $elm$html$Html$Events$targetValue));
};
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$FeeEntry$View$selectBehaviourView = F3(
	function (options, fee, editable) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-span-2 col-start-2'),
					$elm$html$Html$Attributes$class('md:col-start-10 md:col-span-2 self-start'),
					$elm$html$Html$Attributes$class('justify-self-start'),
					$elm$html$Html$Attributes$class('h-6 text-xs'),
					$elm$html$Html$Attributes$class('border rounded border-mt-purple-light')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'billing-behaviour-select'),
							A2($elm$html$Html$Attributes$attribute, 'data-tour', 'billing-behaviour-select'),
							$elm$html$Html$Attributes$disabled(!editable),
							$elm_community$html_extra$Html$Events$Extra$onChange(
							function (behaviour) {
								return A2(
									$author$project$TimesheetPage$Messages$FeeFormEdit,
									fee.aC,
									$author$project$FeeEntry$Messages$SetBillingBehaviour(
										$author$project$Model$Fee$BillingBehaviour$fromString(behaviour)));
							}),
							$elm$html$Html$Attributes$value(
							$author$project$Model$Fee$BillingBehaviour$toString(fee.fS))
						]),
					$author$project$Model$Fee$BillingBehaviour$behavioursToOptions(options))
				]));
	});
var $author$project$FeeEntry$View$behaviourSelector = F5(
	function (matter, feeType, editable, options, fee) {
		var matterBillingBehaviourString = $author$project$Model$Fee$BillingBehaviour$toDisplayString(
			A2(
				$elm$core$Maybe$withDefault,
				1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.fS;
					},
					matter)));
		var feeTypeBillingBehaviourString = $author$project$Model$Fee$BillingBehaviour$toDisplayString(feeType.fS);
		var component = F2(
			function (dataRole, txt) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full min-w-42 col-span-2 col-start-2'),
							$elm$html$Html$Attributes$class('md:col-start-9.5 md:col-span-3 justify-self-start'),
							$elm$html$Html$Attributes$class('text-xs font-light text-mt-grey-light text-left'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', dataRole)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(txt)
						]));
			});
		var _v0 = function () {
			var _v1 = A2($author$project$FeeEntry$FeeEntryLogic$getChargeableStatus, matter, feeType);
			switch (_v1) {
				case 2:
					return _Utils_Tuple3(false, 'Matter is ' + matterBillingBehaviourString, 'non-chargeable');
				case 1:
					return _Utils_Tuple3(false, 'Fee Type is ' + feeTypeBillingBehaviourString, 'non-chargeable');
				default:
					return _Utils_Tuple3(true, '', 'chargeable');
			}
		}();
		var displaySelector = _v0.a;
		var labelText = _v0.b;
		var role = _v0.c;
		var _v2 = _Utils_Tuple2(editable, displaySelector);
		_v2$2:
		while (true) {
			if (_v2.a) {
				if (_v2.b) {
					return A3($author$project$FeeEntry$View$selectBehaviourView, options, fee, editable);
				} else {
					break _v2$2;
				}
			} else {
				if (_v2.b) {
					return A2(
						component,
						role,
						$author$project$Model$Fee$BillingBehaviour$toDisplayString(fee.fS));
				} else {
					break _v2$2;
				}
			}
		}
		return A2(component, role, labelText);
	});
var $author$project$FeeEntry$Messages$SetRecordInMinutes = function (a) {
	return {$: 29, a: a};
};
var $author$project$FeeEntry$View$canRecordInMinutesInput = F3(
	function (editable, feeId, feeRecordingInMinutes) {
		var inputRole = feeRecordingInMinutes ? 'recording-in-minutes' : 'recording-in-units';
		var checkBoxModel = {
			ga: 'h-6 w-6 md:h-14px md:w-14px',
			gc: A2(
				$author$project$TimesheetPage$Messages$FeeFormEdit,
				feeId,
				$author$project$FeeEntry$Messages$SetRecordInMinutes(!feeRecordingInMinutes)),
			gJ: editable,
			gU: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-span-2 col-start-2'),
					$elm$html$Html$Attributes$class('md:col-start-10 md:col-span-2 self-start'),
					$elm$html$Html$Attributes$class('justify-self-start whitespace-nowrap'),
					$elm$html$Html$Attributes$class('h-6')
				]),
			ho: 'Set to record in minutes',
			hs: inputRole,
			hM: feeRecordingInMinutes,
			hN: true,
			hR: 'Record in Minutes',
			i_: 'record-in-minutes',
			jw: 'text-xs'
		};
		return $author$project$Components$CheckBox$view(checkBoxModel);
	});
var $author$project$FeeEntry$View$closeButton = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute right-0 top-0'),
				$elm$html$Html$Attributes$class('cursor-pointer'),
				$elm$html$Html$Attributes$class('px-2 pt-0 pb-1'),
				$elm$html$Html$Attributes$class('hover:text-black hover:bg-mt-blue-lightest'),
				$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$CloseFee),
				$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$TimesheetPage$Messages$CloseFee),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'close-fee-cross'),
				A2($elm$html$Html$Attributes$attribute, 'data-tour', 'close-fee-cross'),
				$elm$html$Html$Attributes$id('close-cross-button')
			]),
		_List_fromArray(
			[
				$author$project$Icons$CloseCross$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('inline w-3 stroke-current icon icon--close-cross')
					]))
			]))
	]);
var $author$project$FeeEntry$Messages$CloseContactSelector = {$: 33};
var $author$project$FeeEntry$Messages$ContactSelected = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$FeeTypeSelector$htmlList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filter($elm$core$Tuple$second),
	$elm$core$List$map($elm$core$Tuple$first));
var $author$project$Components$FeeTypeSelector$selectContact = F2(
	function (contacts, isLoading) {
		var isMultiple = $elm$core$List$length(contacts) > 1;
		var headerDiv = F2(
			function (title, subTitle) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-12 pt-2 px-4'),
							$elm$html$Html$Attributes$class('text-xs bg-mt-purple-lighter'),
							$elm$html$Html$Attributes$class('border-b border-mt-purple'),
							$elm$html$Html$Attributes$class('md:rounded-t-lg leading-tight')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('float-right cursor-pointer'),
									$elm$html$Html$Events$onClick($author$project$FeeEntry$Messages$CloseContactSelector)
								]),
							_List_fromArray(
								[
									$author$project$Icons$CloseCross$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('w-2 stroke-current')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(subTitle)
								]))
						]));
			});
		var loadingDiv = A2(headerDiv, 'Loading...', '');
		var multipleContactHeaderDiv = A2(headerDiv, 'Multiple contacts contain the same contact detail.', 'Select relevant contact: (will set as default)');
		var singleContactHeaderDiv = A2(headerDiv, 'A single contact matched the contact detail.', 'Relevant contact:');
		var contactCard = function (contact) {
			var domId = $author$project$Contacts$ContactLogic$domId(contact);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-0 pt-1 pb-2 px-4'),
						$elm$html$Html$Attributes$class('leading-ex-tight text-mt-darker'),
						$elm$html$Html$Attributes$class('hover:bg-mt-blue-lightest cursor-pointer'),
						$elm$html$Html$Attributes$class('outline-hidden'),
						$elm$html$Html$Events$onClick(
						$author$project$FeeEntry$Messages$ContactSelected(contact.aC)),
						$elm_community$html_extra$Html$Events$Extra$onEnter(
						$author$project$FeeEntry$Messages$ContactSelected(contact.aC)),
						$elm$html$Html$Attributes$tabindex(-1),
						A2($elm$html$Html$Attributes$attribute, 'data-role', domId),
						$elm$html$Html$Attributes$id(domId)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-base leading-normal text-mt-grey-darker')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(contact.b2)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xs font-light text-mt-grey-darker')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(contact.gh)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xs font-light text-mt-grey-darker')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-xs font-light text-mt-black')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Contacts$Data$stringFromContactSource(contact.jb) + ':')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(contact.gn)
									]))
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute w-full left-0 top-0 bg-white'),
					$elm$html$Html$Attributes$class('md:mt-12'),
					$elm$html$Html$Attributes$class('h-full md:h-auto z-10'),
					$elm$html$Html$Attributes$class('outline-hidden'),
					$author$project$KeyShortcutEvents$on(
					_List_fromArray(
						[
							_Utils_Tuple2('Escape', $author$project$FeeEntry$Messages$CloseContactSelector)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-32 hidden md:block arrow-up')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_Utils_ap(
						A2($author$project$OnClickOutsideAfterFocus$withId, 'contact-selector', $author$project$FeeEntry$Messages$CloseContactSelector),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-lg border border-mt-purple md:rounded-lg outline-hidden')
							])),
					_Utils_ap(
						_List_Nil,
						_Utils_ap(
							$author$project$Components$FeeTypeSelector$htmlList(
								_List_fromArray(
									[
										_Utils_Tuple2(loadingDiv, isLoading),
										_Utils_Tuple2(singleContactHeaderDiv, (!isLoading) && (!isMultiple)),
										_Utils_Tuple2(multipleContactHeaderDiv, isMultiple)
									])),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pb-2 min-h-28 max-h-48 overflow-y-scroll'),
											A2($elm$html$Html$Attributes$attribute, 'data-role', 'selectable-contact')
										]),
									A2($elm$core$List$map, contactCard, contacts))
								]))))
				]));
	});
var $author$project$Components$FeeTypeSelector$contactSelectorControl = function (fee) {
	var _v0 = fee.g1;
	if (_v0.$ === 2) {
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return A2($author$project$Components$FeeTypeSelector$selectContact, _List_Nil, true);
		} else {
			var contacts = _v0.a.a;
			return A2($author$project$Components$FeeTypeSelector$selectContact, contacts, false);
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$MatterInput$Views$EditMode$Model$createEditModeViewModel = F3(
	function (pms, fee, feeSearchTerms) {
		return A3($author$project$Components$MatterInput$Views$EditMode$Model$createInternalModel, pms, fee, feeSearchTerms);
	});
var $author$project$FeeEntry$Messages$GetCurrentTimeForFee = {$: 25};
var $author$project$FeeEntry$View$currentTimeButton = function (fee_id) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-xs cursor-pointer'),
				$elm$html$Html$Attributes$class('text-mt-purple-dark'),
				$elm$html$Html$Attributes$class('hover:text-mt-purple-light'),
				$elm$html$Html$Events$onClick(
				A2($author$project$TimesheetPage$Messages$FeeFormEdit, fee_id, $author$project$FeeEntry$Messages$GetCurrentTimeForFee))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Current Time')
			]));
};
var $author$project$TimesheetPage$Messages$DeleteFee = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$Timesheet$Views$FeeActionButtons$deleteButton = F3(
	function (maybeNextFeeId, isInGroup, fee) {
		var _v0 = $author$project$Timesheet$FeeLogic$isEditable(fee) ? _Utils_Tuple3(
			'text-mt-grey-light hover:text-mt-grey-dark',
			$elm$core$Maybe$Just(
				A3(
					$author$project$TimesheetPage$Messages$DeleteFee,
					$author$project$Timesheet$FeeLogic$toFeeId(fee),
					maybeNextFeeId,
					isInGroup)),
			'Delete') : _Utils_Tuple3('downgrade-disabled', $elm$core$Maybe$Nothing, 'Delete (Unavailable)');
		var colour = _v0.a;
		var maybeMsg = _v0.b;
		var hoverText = _v0.c;
		var buttonIcon = $author$project$Icons$RubbishBin$viewWithAttributes(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('icon icon--trash stroke-current fill-white show-on-fee-hover'),
					$elm$svg$Svg$Attributes$class(colour),
					A2($elm$html$Html$Attributes$attribute, 'data-tour', 'delete-button'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'delete-button-icon')
				]));
		return $author$project$Timesheet$Views$FeeActionButtons$render(
			A4($author$project$Timesheet$Views$FeeActionButtons$FeeButton, buttonIcon, 'delete-button', hoverText, maybeMsg));
	});
var $author$project$TimesheetPage$Messages$BlockFeeByEmail = function (a) {
	return {$: 10, a: a};
};
var $author$project$TimesheetPage$Messages$DowngradeToActivities = function (a) {
	return {$: 17, a: a};
};
var $author$project$Timesheet$FeeLogic$DowngradableEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Timesheet$FeeLogic$DowngradeableContactId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Timesheet$FeeLogic$NotDowngradeable = {$: 2};
var $author$project$Timesheet$FeeLogic$activityIsEmail = function (fee) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Activities$ActivityLogic$isEmail, fee.fG));
};
var $author$project$Model$Fee$isPostable = function (fee) {
	return _Utils_eq(fee.cK, _List_Nil);
};
var $author$project$Timesheet$FeeLogic$contactDowngradable = function (fee) {
	if ($author$project$Timesheet$FeeLogic$isEditable(fee) && (!$author$project$Model$Fee$isPostable(fee))) {
		var _v0 = $author$project$Timesheet$FeeLogic$contactFromFee(fee);
		if (!_v0.$) {
			var contact = _v0.a;
			return $author$project$Timesheet$FeeLogic$DowngradeableContactId(contact.aC);
		} else {
			return $author$project$Timesheet$FeeLogic$activityIsEmail(fee) ? $author$project$Timesheet$FeeLogic$DowngradableEmail(fee.aC) : $author$project$Timesheet$FeeLogic$NotDowngradeable;
		}
	} else {
		return $author$project$Timesheet$FeeLogic$NotDowngradeable;
	}
};
var $elm$svg$Svg$Attributes$title = _VirtualDom_attribute('title');
var $author$project$Timesheet$Views$FeeActionButtons$downgradeButton = function (fee) {
	var buttonIcon = $author$project$Icons$Downgrade$viewWithAttributes(
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('w-5 h-full stroke-current text-mt-grey-dark btn-icon-upgrade')
			]));
	var _v0 = $author$project$Timesheet$FeeLogic$contactDowngradable(fee);
	switch (_v0.$) {
		case 0:
			var contactId = _v0.a;
			return $author$project$Timesheet$Views$FeeActionButtons$render(
				A4(
					$author$project$Timesheet$Views$FeeActionButtons$FeeButton,
					buttonIcon,
					'downgrade-button',
					'Delete & Downgrade',
					$elm$core$Maybe$Just(
						$author$project$TimesheetPage$Messages$DowngradeToActivities(contactId))));
		case 1:
			var feeId = _v0.a;
			return $author$project$Timesheet$Views$FeeActionButtons$render(
				A4(
					$author$project$Timesheet$Views$FeeActionButtons$FeeButton,
					buttonIcon,
					'downgrade-button',
					'Delete & Downgrade',
					$elm$core$Maybe$Just(
						$author$project$TimesheetPage$Messages$BlockFeeByEmail(feeId))));
		default:
			var disabledIcon = $author$project$Icons$Downgrade$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('w-5 h-full stroke-current downgrade-disabled text-mt-grey-lightest btn-icon-upgrade'),
						$elm$svg$Svg$Attributes$title('Cannot downgrade')
					]));
			return $author$project$Timesheet$Views$FeeActionButtons$render(
				A4($author$project$Timesheet$Views$FeeActionButtons$FeeButton, disabledIcon, 'downgrade-button', 'Delete & Downgrade (Unavailable)', $elm$core$Maybe$Nothing));
	}
};
var $author$project$TimesheetPage$Messages$CloneFee = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Dropdown$dropdownButton = function (buttonModel) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pb-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('group flex justify-between items-center w-full py-6 md:py-2 px-4 text-lg md:text-sm text-left border-b border-mt-purple-light md:border-none hover:bg-mt-purple-lightest hover:text-mt-grey-darker hover:border-0'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', buttonModel.c6),
						$elm$html$Html$Events$onClick(buttonModel.gc)
					]),
				A2(
					$author$project$CoreX$Appendable$andAppendMaybe,
					buttonModel.bN,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('align-middle')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonModel.fk)
								]))
						])))
			]));
};
var $author$project$Icons$Clone$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 18 18'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('clone-fee'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M13.6666667,4 L6.33333333,4 C5.6,4 5,4.6 5,5.33333333 L5,14.6666667 C5,15.4 5.6,16 6.33333333,16 L13.6666667,16 C14.4,16 15,15.4 15,14.6666667 L15,5.33333333 C15,4.6 14.4,4 13.6666667,4 L13.6666667,4 Z M6,5 L14,5 L14,15 L6,15 L6,5 L6,5 Z M4.03408486,13.9659151 C3.4435752,13.8291651 3,13.297202 3,12.6666667 L3,3.33333333 C3,2.6 3.6,2 4.33333333,2 L11.6666667,2 C12.297202,2 12.8291651,2.4435752 12.9659151,3.03408486 C12.8696426,3.01179011 12.7694647,3 12.6666667,3 L8.66666667,3 L4,3 L4,8.66666667 L4,13.6666667 C4,13.7694647 4.01179011,13.8696426 4.03408486,13.9659151 L4.03408486,13.9659151 Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$cloneFeeButton = function (fee) {
	var cloneFeeModel = {
		gc: $author$project$TimesheetPage$Messages$CloneFee(fee),
		c6: 'clone-fee',
		bN: $elm$core$Maybe$Just(
			$author$project$Icons$Clone$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('w-8 md:w-17px icon icon--post-now fill-current text-mt-grey-dark')
					]))),
		fk: 'Clone Fee'
	};
	return $author$project$Components$Dropdown$dropdownButton(cloneFeeModel);
};
var $author$project$TimesheetPage$Messages$DeconsolidateAll = function (a) {
	return {$: 45, a: a};
};
var $author$project$Icons$DemergeArrow$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 -960 960 960')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M440-160v-304L240-664v104h-80v-240h240v80H296l224 224v336h-80Zm154-376-58-58 128-126H560v-80h240v240h-80v-104L594-536Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$demergeAllButton = function (fee) {
	return $author$project$Components$Dropdown$dropdownButton(
		{
			gc: $author$project$TimesheetPage$Messages$DeconsolidateAll(fee.aC),
			c6: 'demerge-all',
			bN: $elm$core$Maybe$Just(
				$author$project$Icons$DemergeArrow$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-8 md:w-17px icon icon--post-now fill-current text-mt-grey-dark')
						]))),
			fk: 'Demerge all'
		});
};
var $author$project$Components$Dropdown$Right = 1;
var $author$project$TimesheetPage$Messages$ToggleActionsMenu = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Dropdown$view = function (model) {
	var opening = function () {
		var _v0 = model.iv;
		if (!_v0) {
			return 'right-0 md:left-0';
		} else {
			return 'right-0';
		}
	}();
	return A2(
		$elm$html$Html$div,
		A3(
			$author$project$CoreX$Appendable$andAppendIf,
			model.hJ,
			_List_fromArray(
				[
					$author$project$KeyShortcutEvents$on(
					_List_fromArray(
						[
							_Utils_Tuple2('Escape', model.ge)
						]))
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				A2($author$project$OnClickOutsideAfterFocus$withId, model.aC, model.ge),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('md:relative group inline'),
						$elm$html$Html$Attributes$id(model.aC)
					]))),
		A3(
			$author$project$CoreX$Appendable$andAppendIf,
			model.hJ,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute mb-0 -top-2 md:top-5 z-40 md:pt-4 mb:pb-2 px-0'),
							$elm$html$Html$Attributes$class(opening),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'drop-down-options')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-screen--12 md:h-auto w-screen md:w-66 bg-white border shadow-sm')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0 flex flex-col justify-between')
										]),
									_Utils_ap(
										model.iw,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('md:hidden')
													]),
												_List_fromArray(
													[
														$author$project$Components$Dropdown$dropdownButton(
														{
															gc: model.ge,
															c6: 'dropdown-menu-close-button',
															bN: $elm$core$Maybe$Just(
																$author$project$Icons$CloseCross$viewWithAttributes(
																	_List_fromArray(
																		[
																			$elm$svg$Svg$Attributes$class('w-5 h-5 stroke-mt-grey-light')
																		]))),
															fk: 'Close Menu'
														})
													]))
											])))
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(model.iu)
						]),
					_List_fromArray(
						[model.bN]))
				])));
};
var $author$project$Icons$DropdownArrow$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 50 50'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$class('transition-15')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$polyline,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('hover:text-mt-grey-dark text-mt-grey-light stroke-current'),
								$elm$svg$Svg$Attributes$strokeWidth('6.5'),
								$elm$svg$Svg$Attributes$points('45 15 25 35 5 15')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$dropDownButton = F2(
	function (fee, options) {
		var openFee = _Utils_update(
			fee,
			{hx: true});
		var dropdownIcon = $author$project$Icons$DropdownArrow$viewWithAttributes(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('mt-1 h-4 icon icon--inline-menu btn-icon-inline-menu cursor-pointer'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'drop-down')
				]));
		var dropdownModel = {
			ge: $author$project$TimesheetPage$Messages$ToggleActionsMenu(openFee),
			bN: dropdownIcon,
			aC: 'fee-actions-menu-dropdown-' + $elm$core$String$fromInt(fee.aC),
			hJ: fee.hx,
			iu: $author$project$TimesheetPage$Messages$ToggleActionsMenu(fee),
			iv: 1,
			iw: options
		};
		return $author$project$Components$Dropdown$view(dropdownModel);
	});
var $author$project$TimesheetPage$Messages$StartPostedEditFor = function (a) {
	return {$: 73, a: a};
};
var $author$project$Icons$Pencil$path = 'M4 20h4L18.5 9.5a2.83 2.83 0 0 0-4-4L4 16v4z M13.5 6.5l4 4';
var $author$project$Icons$Pencil$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d($author$project$Icons$Pencil$path),
						$elm$svg$Svg$Attributes$class('stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1.8'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$editPostedFeeButton = function (fee) {
	return $author$project$Components$Dropdown$dropdownButton(
		{
			gc: $author$project$TimesheetPage$Messages$StartPostedEditFor(fee.aC),
			c6: 'edit-posted-fee',
			bN: $elm$core$Maybe$Just(
				$author$project$Icons$Pencil$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-8 md:w-17px fill-current text-mt-grey-dark')
						]))),
			fk: 'Edit Fee'
		});
};
var $author$project$TimesheetPage$Messages$FileEmail = function (a) {
	return {$: 20, a: a};
};
var $author$project$Icons$FileEmail$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$id('Layer_1'),
					$elm$svg$Svg$Attributes$x('0px'),
					$elm$svg$Svg$Attributes$y('0px'),
					$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2.22222 20L0 6.66667H20L17.7778 20H2.22222ZM3.61111 18.3333H16.3889L17.9722 8.33333H2.02778L3.61111 18.3333ZM7.77778 12.7778H12.2222C12.463 12.7778 12.662 12.6944 12.8194 12.5278C12.9769 12.3611 13.0556 12.1667 13.0556 11.9444C13.0556 11.7037 12.9769 11.5046 12.8194 11.3472C12.662 11.1898 12.463 11.1111 12.2222 11.1111H7.77778C7.55556 11.1111 7.36111 11.1898 7.19445 11.3472C7.02778 11.5046 6.94444 11.7037 6.94444 11.9444C6.94444 12.1667 7.02778 12.3611 7.19445 12.5278C7.36111 12.6944 7.55556 12.7778 7.77778 12.7778ZM3.33333 5C3.11111 5 2.91667 4.91667 2.75 4.75C2.58333 4.58333 2.5 4.38889 2.5 4.16667C2.5 3.92593 2.58333 3.72685 2.75 3.56944C2.91667 3.41204 3.11111 3.33333 3.33333 3.33333H16.6667C16.9074 3.33333 17.1065 3.41204 17.2639 3.56944C17.4213 3.72685 17.5 3.92593 17.5 4.16667C17.5 4.38889 17.4213 4.58333 17.2639 4.75C17.1065 4.91667 16.9074 5 16.6667 5H3.33333ZM5.55556 1.66667C5.33333 1.66667 5.13889 1.58333 4.97222 1.41667C4.80556 1.25 4.72222 1.05556 4.72222 0.833333C4.72222 0.592593 4.80556 0.393519 4.97222 0.236111C5.13889 0.0787038 5.33333 0 5.55556 0H14.4444C14.6852 0 14.8843 0.0787038 15.0417 0.236111C15.1991 0.393519 15.2778 0.592593 15.2778 0.833333C15.2778 1.05556 15.1991 1.25 15.0417 1.41667C14.8843 1.58333 14.6852 1.66667 14.4444 1.66667H5.55556ZM3.61111 18.3333H16.3889H3.61111Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('0.15')
					]),
				_List_Nil)
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$fileEmailListButton = F2(
	function (fee, isConsolidation) {
		var fileText = isConsolidation ? 'File all emails' : 'File email';
		var fileEmailModel = {
			gc: $author$project$TimesheetPage$Messages$FileEmail(fee),
			c6: 'file-email',
			bN: $elm$core$Maybe$Just(
				$author$project$Icons$FileEmail$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-8 md:w-17px icon icon--post-now stroke-current fill-current text-mt-grey-dark')
						]))),
			fk: fileText
		};
		return $author$project$Components$Dropdown$dropdownButton(fileEmailModel);
	});
var $author$project$Components$FileNotes$Types$FileNote$ForFee = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Icons$FileNote$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 -960 960 960'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('28'),
						$elm$svg$Svg$Attributes$d('M575.38-340h30.77v-84.62h84.62v-30.76h-84.62V-540h-30.77v84.62h-84.61v30.76h84.61V-340Zm-400 140q-23.05 0-39.22-16.19Q120-232.38 120-255.38v-449.24q0-23 16.16-39.19Q152.33-760 175.38-760h217.93l70.77 70.77h320.54q23 0 39.19 16.19Q840-656.85 840-633.85v378.47q0 23-16.19 39.19Q807.62-200 784.62-200H175.38Zm0-30.77h609.24q10.76 0 17.69-6.92 6.92-6.93 6.92-17.69v-378.47q0-10.77-6.92-17.69-6.93-6.92-17.69-6.92H452.15l-70.77-70.77h-206q-10.76 0-17.69 6.92-6.92 6.93-6.92 17.69v449.24q0 10.76 6.92 17.69 6.93 6.92 17.69 6.92Zm-24.61 0V-729.23-230.77Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$fileNoteButton = F2(
	function (fileNoteLabel, fee) {
		var description = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$String$slice, 0, 255),
				fee.dd));
		var buttonLabel = 'New ' + fileNoteLabel;
		var disabledButton = A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pb-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full py-6 md:py-2 px-4 text-lg text-mt-grey-light md:text-sm text-left md:border-none hover:bg-mt-purple-lightest hover:border-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$title('Please select a matter')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonLabel)
								]))
						]))
				]));
		var enabledButton = $author$project$Components$Dropdown$dropdownButton(
			{
				gc: $author$project$TimesheetPage$Messages$FileNote(
					A2(
						$author$project$Components$FileNotes$Messages$Open,
						$author$project$Components$FileNotes$Types$FilingStatus$newFileNote(
							$elm$core$Maybe$Just(fee.aC)),
						A3($author$project$Components$FileNotes$Types$FileNote$ForFee, fee.aC, description, fee.hY))),
				c6: 'create-file-note-for-fee',
				bN: $elm$core$Maybe$Just(
					$author$project$Icons$FileNote$viewWithAttributes(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('w-8 md:w-17px icon icon--post-now stroke-current fill-current text-mt-grey-dark')
							]))),
				fk: buttonLabel
			});
		return A2(
			$elm$core$Maybe$withDefault,
			disabledButton,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(enabledButton),
				fee.hY));
	});
var $author$project$Timesheet$FeeLogic$getEmailFees = function (fees) {
	return A2(
		$elm$core$List$filter,
		function (f) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$Activities$ActivityLogic$isEmail, f.fG));
		},
		fees);
};
var $author$project$TimesheetPage$Messages$HoldFee = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Timesheet$Views$FeeActionButtons$holdFeeListButton = function (fee) {
	var heldText = fee.ip ? 'Remove on-hold status' : 'Place time entry on-hold';
	var fileEmailModel = {
		gc: A2($author$project$TimesheetPage$Messages$HoldFee, !fee.ip, fee),
		c6: 'hold-fee',
		bN: $elm$core$Maybe$Just(
			$author$project$Icons$Hold$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('w-8 md:w-17px icon icon--post-now fill-current text-mt-grey-dark')
					]))),
		fk: heldText
	};
	return $author$project$Components$Dropdown$dropdownButton(fileEmailModel);
};
var $author$project$Timesheet$Views$FeeActionButtons$isConnectorPMS = function (pms) {
	return A2(
		$elm$core$List$member,
		pms,
		_List_fromArray(
			[0, 2, 3]));
};
var $author$project$Timesheet$Views$FeeActionButtons$isFiled = function (status) {
	var _v0 = status.dG;
	switch (_v0.$) {
		case 0:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		default:
			return true;
	}
};
var $author$project$FeeEntry$Messages$SetPostStatus = function (a) {
	return {$: 28, a: a};
};
var $author$project$Icons$Posted$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('posted'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stroke('currentColor'),
								$elm$svg$Svg$Attributes$strokeWidth('2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 C14.418278,18 18,14.418278 18,10'),
										$elm$svg$Svg$Attributes$id('oval'),
										$elm$svg$Svg$Attributes$transform('translate(10.000000, 10.000000) rotate(8.000000) translate(-10.000000, -10.000000) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$polyline,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('tick'),
										$elm$svg$Svg$Attributes$points('6 8.45072362 10.3333333 12 19 2')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$markAsPostedButton = function (fee) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title('Mark as Posted - the quarantined fee HAS been posted\nto your practice management system already.\n\nThis avoids duplicate fee charges.')
			]),
		_List_fromArray(
			[
				$author$project$Components$Dropdown$dropdownButton(
				{
					gc: A2(
						$author$project$TimesheetPage$Messages$FeeFormEdit,
						fee.aC,
						$author$project$FeeEntry$Messages$SetPostStatus(4)),
					c6: 'mark-posted',
					bN: $elm$core$Maybe$Just(
						$author$project$Icons$Posted$viewWithAttributes(
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('w-8 md:w-17px icon icon--post-now stroke-current fill-current text-mt-grey-dark')
								]))),
					fk: 'Mark as Posted'
				})
			]));
};
var $elm$svg$Svg$polygon = $elm$svg$Svg$trustedNode('polygon');
var $author$project$Icons$PostNow$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 19 20'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('transition-15 stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('Artboard-5'),
								$elm$svg$Svg$Attributes$transform('translate(-36.000000, -50.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('1.54285714')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('post'),
										$elm$svg$Svg$Attributes$transform('translate(37.000000, 51.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$polygon,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('Path-40'),
												$elm$svg$Svg$Attributes$points('16.8389668 0.401785714 11.1071691 17.6168307 6.12958311 9.54867752 0.102117586 6.29734905'),
												$elm$svg$Svg$Attributes$fillOpacity('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$polygon,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('Path-41'),
												$elm$svg$Svg$Attributes$points('4.5 8.74285714 6.6875 14.4 8 12.6593407 6.25 9.61318681')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M16,1.02857143 L6,9.25714286'),
												$elm$svg$Svg$Attributes$id('Path-42'),
												$elm$svg$Svg$Attributes$fillOpacity('0')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$markAsRepostableButton = function (fee) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title('Mark as Repostable - PMS-side issues fixed / fee HAS NOT been posted.')
			]),
		_List_fromArray(
			[
				$author$project$Components$Dropdown$dropdownButton(
				{
					gc: A2(
						$author$project$TimesheetPage$Messages$FeeFormEdit,
						fee.aC,
						$author$project$FeeEntry$Messages$SetPostStatus(0)),
					c6: 'mark-repostable',
					bN: $elm$core$Maybe$Just(
						$author$project$Icons$PostNow$viewWithAttributes(
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('w-8 md:w-17px icon icon--post-now stroke-current fill-current text-mt-grey-dark')
								]))),
					fk: 'Mark as Repostable'
				})
			]));
};
var $author$project$TimesheetPage$Messages$OpenFeeSearchWith = function (a) {
	return {$: 62, a: a};
};
var $author$project$TimesheetPage$Messages$QueueAllPostableFeesForMatter = function (a) {
	return {$: 28, a: a};
};
var $author$project$Icons$Filter$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 32 36'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('filter'),
								$elm$svg$Svg$Attributes$transform('translate(2.000000, 2.000000)'),
								$elm$svg$Svg$Attributes$stroke('#555555'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M2.00016489,-3.55271368e-15 L26.2804821,2.22044605e-15 C27.3850516,2.01753992e-15 28.2804821,0.8954305 28.2804821,2 C28.2804821,2.41303142 28.1526061,2.815933 27.9144178,3.1533664 L18.4542694,16.5552433 C18.2487117,16.8464501 18.124715,17.1873018 18.0951136,17.5425188 L17.1403235,29 L11.1403235,32 L10.1777232,17.5609956 C10.1532641,17.1941094 10.0281354,16.8410669 9.8160886,16.5406673 L0.366229167,3.1533664 C-0.270757504,2.25096861 -0.055599286,1.00305094 0.846798498,0.366064273 C1.1842319,0.127875992 1.58713347,-3.03275183e-15 2.00016489,-3.10862447e-15 Z'),
										$elm$svg$Svg$Attributes$id('Rectangle-30')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$PostAll$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 52 38'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('post-all'),
								$elm$svg$Svg$Attributes$transform('translate(2.000000, 1.000000)'),
								$elm$svg$Svg$Attributes$stroke('#555555')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('plane')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$polygon,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('Path-40'),
												$elm$svg$Svg$Attributes$strokeWidth('3'),
												$elm$svg$Svg$Attributes$points('32.7006521 0.77330162 21.5697125 33.9064412 11.9034242 18.377975 0.198308582 12.1202672')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$polygon,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('Path-41'),
												$elm$svg$Svg$Attributes$strokeWidth('3'),
												$elm$svg$Svg$Attributes$fill('#555555'),
												$elm$svg$Svg$Attributes$points('8.73883391 16.8270433 12.9868782 27.7151301 15.5357047 24.3649495 12.1372693 18.5021335')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M32.3919444,1.97965215 L11.6517785,17.8168693'),
												$elm$svg$Svg$Attributes$id('Path-42'),
												$elm$svg$Svg$Attributes$strokeWidth('2')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M39,2 L48,2'),
										$elm$svg$Svg$Attributes$id('Path-12-Copy-3'),
										$elm$svg$Svg$Attributes$strokeWidth('3')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M36,13 L48,13'),
										$elm$svg$Svg$Attributes$id('Path-12-Copy-6'),
										$elm$svg$Svg$Attributes$strokeWidth('3')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M33,24 L48,24'),
										$elm$svg$Svg$Attributes$id('Path-12-Copy-6'),
										$elm$svg$Svg$Attributes$strokeWidth('3')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M30,35 L48,35'),
										$elm$svg$Svg$Attributes$id('Path-12-Copy-6'),
										$elm$svg$Svg$Attributes$strokeWidth('3')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$matterButtons = function (matter) {
	var postAllForMatterModel = {
		gc: $author$project$TimesheetPage$Messages$QueueAllPostableFeesForMatter(matter.aC),
		c6: 'queue-all-for-matter',
		bN: $elm$core$Maybe$Just(
			$author$project$Icons$PostAll$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('h-8 md:h-4 -m-2px icon icon--post-now fill-current mt-grey-dark')
					]))),
		fk: 'Post all completed for this matter'
	};
	var matterButtonModel = function (code) {
		return {
			gc: $author$project$TimesheetPage$Messages$OpenFeeSearchWith(code),
			c6: 'fees-by-matter',
			bN: $elm$core$Maybe$Just(
				$author$project$Icons$Filter$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('h-8 md:h-4 mr-2px icon fill-current mt-grey-dark')
						]))),
			fk: 'Show all for matter: ' + code
		};
	};
	var matterButton = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$singleton,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Dropdown$dropdownButton,
				A2($elm$core$Maybe$map, matterButtonModel, matter.br))));
	return A2(
		$author$project$CoreX$Appendable$andAppend,
		matterButton,
		$elm$core$List$singleton(
			$author$project$Components$Dropdown$dropdownButton(postAllForMatterModel)));
};
var $author$project$Components$SplitFee$Messages$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Timesheet$Views$FeeActionButtons$splitFeeButton = function (fee) {
	var splitFeeModel = {
		gc: $author$project$TimesheetPage$Messages$SplitFee(
			$author$project$Components$SplitFee$Messages$Open(fee)),
		c6: 'split-fee',
		bN: $elm$core$Maybe$Just(
			$author$project$Icons$Clone$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('w-8 md:w-17px icon icon--post-now fill-current text-mt-grey-dark')
					]))),
		fk: 'Split Fee'
	};
	return $author$project$Components$Dropdown$dropdownButton(splitFeeModel);
};
var $author$project$Timesheet$Views$FeeActionButtons$dropDownOrEmpty = F3(
	function (user, fee, isInGroup) {
		var toFilingStatus = function (baseFee) {
			return A2(
				$elm$core$List$map,
				$author$project$Timesheet$FeeLogic$getFilingStatus,
				$author$project$Timesheet$FeeLogic$getEmailFees(baseFee));
		};
		var isEmail = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Activities$ActivityLogic$isEmail, fee.fG));
		var fileNoteLabel = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'File Note',
			function ($) {
				return $.ec;
			},
			user.bH);
		var consolidatedFees = $author$project$Timesheet$FeeLogic$getConsolidatedFees(fee);
		var isConsolidation = !$elm$core$List$isEmpty(consolidatedFees);
		var canSplitFee = !(isInGroup || isConsolidation);
		var allFilingStatuses = _Utils_ap(
			toFilingStatus(
				_List_fromArray(
					[fee])),
			toFilingStatus(consolidatedFees));
		var notFiledOk = !$elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				function (fs) {
					if (!fs.$) {
						var f = fs.a;
						return $author$project$Timesheet$Views$FeeActionButtons$isFiled(f);
					} else {
						return true;
					}
				},
				allFilingStatuses));
		var canFile = $elm_community$maybe_extra$Maybe$Extra$isJust(fee.hY) && ((isEmail || isConsolidation) && notFiledOk);
		var options = (fee.eD === 7) ? A3(
			$author$project$CoreX$Appendable$andAppendIf,
			$author$project$Timesheet$Views$FeeActionButtons$isConnectorPMS(user.ce),
			_List_fromArray(
				[
					$author$project$Timesheet$Views$FeeActionButtons$markAsPostedButton(fee)
				]),
			_List_fromArray(
				[
					$author$project$Timesheet$Views$FeeActionButtons$markAsRepostableButton(fee)
				])) : A3(
			$author$project$CoreX$Appendable$andAppendIf,
			canSplitFee,
			_List_fromArray(
				[
					$author$project$Timesheet$Views$FeeActionButtons$splitFeeButton(fee)
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						$author$project$Timesheet$Views$FeeActionButtons$cloneFeeButton(fee)
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					user.f0 && A2($author$project$Timesheet$FeeLogic$canEditPosted, user.ce, fee),
					_List_fromArray(
						[
							$author$project$Timesheet$Views$FeeActionButtons$editPostedFeeButton(fee)
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						isConsolidation,
						_List_fromArray(
							[
								$author$project$Timesheet$Views$FeeActionButtons$demergeAllButton(fee)
							]),
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							$author$project$Timesheet$FeeLogic$isEditable(fee) && user.f2,
							_List_fromArray(
								[
									$author$project$Timesheet$Views$FeeActionButtons$holdFeeListButton(fee)
								]),
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								user.f1 && canFile,
								_List_fromArray(
									[
										A2($author$project$Timesheet$Views$FeeActionButtons$fileEmailListButton, fee, isConsolidation)
									]),
								A3(
									$author$project$CoreX$Appendable$andAppendIf,
									user.E.by !== 2,
									_List_fromArray(
										[
											A2($author$project$Timesheet$Views$FeeActionButtons$fileNoteButton, fileNoteLabel, fee)
										]),
									A2(
										$author$project$CoreX$Appendable$andMaybeAppend,
										A2($elm$core$Maybe$map, $author$project$Timesheet$Views$FeeActionButtons$matterButtons, fee.hY),
										_List_Nil))))))));
		return $elm$core$List$isEmpty(options) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hidden xl:inline')
				]),
			_List_Nil) : A2($author$project$Timesheet$Views$FeeActionButtons$dropDownButton, fee, options);
	});
var $author$project$TimesheetPage$Messages$QueueFee = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Timesheet$FeeLogic$isPostedModified = function (fee) {
	return fee.eD === 5;
};
var $author$project$Timesheet$FeeLogic$postActionName = function (fee) {
	var _v0 = fee.eD;
	switch (_v0) {
		case 6:
			return 'Repost now';
		case 0:
			return 'Post now';
		case 5:
			return 'Post now';
		default:
			return '';
	}
};
var $author$project$Icons$InTransit$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('in-transit'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$transform('translate(10.035529, 10.035529) rotate(8.000000) translate(-10.035529, -10.035529) translate(2.035529, 2.035529)'),
								$elm$svg$Svg$Attributes$id('oval'),
								$elm$svg$Svg$Attributes$strokeWidth('2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M8,0 C3.581722,0 -9.09494702e-13,3.581722 -9.09494702e-13,8 C-9.09494702e-13,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8'),
										$elm$svg$Svg$Attributes$stroke('#E8E8E8')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M-9.09494702e-13,8 C-9.09494702e-13,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8'),
										$elm$svg$Svg$Attributes$stroke('#2BEEA6')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$Queued$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('queued'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$transform('translate(10.035529, 10.035529) rotate(8.000000) translate(-10.035529, -10.035529) translate(2.035529, 2.035529)'),
								$elm$svg$Svg$Attributes$id('oval'),
								$elm$svg$Svg$Attributes$strokeWidth('2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M8,5.68434189e-13 C3.581722,5.68434189e-13 -5.45696821e-12,3.581722 -5.45696821e-12,8 C-5.45696821e-12,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8'),
										$elm$svg$Svg$Attributes$stroke('#E8E8E8')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M8,16 C12.418278,16 16,12.418278 16,8'),
										$elm$svg$Svg$Attributes$stroke('#2BEEA6')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$Warning$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$width('20'),
					$elm$svg$Svg$Attributes$height('20'),
					$elm$svg$Svg$Attributes$viewBox('0 0 20 20')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M18.5 19h-18c-0.178 0-0.342-0.094-0.432-0.248s-0.091-0.343-0.004-0.498l9-16c0.089-0.157 0.255-0.255 0.436-0.255s0.347 0.097 0.436 0.255l9 16c0.087 0.155 0.085 0.344-0.004 0.498s-0.254 0.248-0.432 0.248zM1.355 18h16.29l-8.145-14.48-8.145 14.48z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M9.5 14c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276-0.224 0.5-0.5 0.5z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M9.5 17c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z')
					]),
				_List_Nil)
			]));
};
var $author$project$Timesheet$Views$FeeActionButtons$postStatusIcon = function (postStatus) {
	switch (postStatus) {
		case 0:
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		case 6:
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		case 5:
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		case 7:
			var buttonIcon = $author$project$Icons$Warning$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('h-full icon icon-b-warning stroke-current text-mt-red-lighter hover:text-mt-red')
					]));
			return $author$project$Timesheet$Views$FeeActionButtons$render(
				A4($author$project$Timesheet$Views$FeeActionButtons$FeeButton, buttonIcon, 'warning-icon', 'Quarantined', $elm$core$Maybe$Nothing));
		case 2:
			var buttonIcon = $author$project$Icons$Queued$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('animate-spin h-full icon icon-b-queued')
					]));
			return $author$project$Timesheet$Views$FeeActionButtons$render(
				A4($author$project$Timesheet$Views$FeeActionButtons$FeeButton, buttonIcon, 'queued-icon', 'Processing', $elm$core$Maybe$Nothing));
		case 1:
			var buttonIcon = $author$project$Icons$Queued$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('animate-spin h-full icon icon-b-queued')
					]));
			return $author$project$Timesheet$Views$FeeActionButtons$render(
				A4($author$project$Timesheet$Views$FeeActionButtons$FeeButton, buttonIcon, 'queued-icon', 'Queued', $elm$core$Maybe$Nothing));
		case 3:
			var buttonIcon = $author$project$Icons$InTransit$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('animate-spin h-full icon icon--in-transit')
					]));
			return $author$project$Timesheet$Views$FeeActionButtons$render(
				A4($author$project$Timesheet$Views$FeeActionButtons$FeeButton, buttonIcon, 'in-transit', 'In Transit', $elm$core$Maybe$Nothing));
		default:
			var buttonIcon = $author$project$Icons$Posted$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('h-full icon icon--posted text-mt-green')
					]));
			return $author$project$Timesheet$Views$FeeActionButtons$render(
				A4($author$project$Timesheet$Views$FeeActionButtons$FeeButton, buttonIcon, 'posted', 'Posted', $elm$core$Maybe$Nothing));
	}
};
var $author$project$Timesheet$FeeLogic$unpostableReasonToString = function (reason) {
	switch (reason.$) {
		case 3:
			var err = reason.a;
			return 'Unknown error: ' + err;
		case 12:
			return 'Timer is running';
		case 13:
			return 'Date is invalid';
		case 0:
			return 'Description is missing';
		case 9:
			return 'Matter is pending';
		case 1:
			return 'Matter is unverified';
		case 2:
			return 'Matter is archived';
		case 10:
			return 'Matter is on-hold';
		case 11:
			return 'Fee is on-hold';
		case 4:
			return 'Missing Scale Item';
		case 6:
			return 'ActionStep Rate Unavailable';
		case 5:
			return 'Missing ActionStep Rate';
		case 7:
			return 'Missing Rate Value';
		case 8:
			return 'Missing one or more Utbms Codes';
		case 14:
			return 'Posted';
		default:
			return 'Tag required';
	}
};
var $author$project$Timesheet$Views$FeeActionButtons$postNowButton = F2(
	function (fee, isInGroup) {
		var postNowIcon = function (colourClass) {
			return $author$project$Icons$PostNow$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('h-5.6 stroke-current fill-current'),
						$elm$svg$Svg$Attributes$class('icon icon--post-now'),
						$elm$svg$Svg$Attributes$class('cursor-pointer'),
						$elm$svg$Svg$Attributes$class(colourClass)
					]));
		};
		if (!($author$project$Timesheet$FeeLogic$isEditable(fee) || $author$project$Timesheet$FeeLogic$isPostedModified(fee))) {
			return $author$project$Timesheet$Views$FeeActionButtons$postStatusIcon(fee.eD);
		} else {
			var _v0 = fee.cK;
			if (!_v0.b) {
				return $author$project$Timesheet$Views$FeeActionButtons$render(
					A4(
						$author$project$Timesheet$Views$FeeActionButtons$FeeButton,
						postNowIcon('text-mt-grey-light hover:text-mt-grey show-on-fee-hover'),
						'post-now-button',
						$author$project$Timesheet$FeeLogic$postActionName(fee),
						$elm$core$Maybe$Just(
							A2($author$project$TimesheetPage$Messages$QueueFee, fee, isInGroup))));
			} else {
				var reason = _v0.a;
				var icon = ($author$project$Timesheet$FeeLogic$isHeld(fee) && A2(
					$elm$core$List$member,
					reason,
					_List_fromArray(
						[$author$project$Model$Fee$HeldFee, $author$project$Model$Fee$HeldMatter]))) ? $author$project$Icons$Hold$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-5 h-5 text-mt-purple-light stroke-current')
						])) : postNowIcon('text-mt-red-lighter hover:text-mt-red');
				return $author$project$Timesheet$Views$FeeActionButtons$render(
					A4(
						$author$project$Timesheet$Views$FeeActionButtons$FeeButton,
						icon,
						'post-now-button',
						$author$project$Timesheet$FeeLogic$unpostableReasonToString(reason),
						$elm$core$Maybe$Nothing));
			}
		}
	});
var $author$project$Timesheet$Views$FeeActionButtons$deleteButtonWithDropdown = F4(
	function (user, fee, maybeNextFeeId, isInGroup) {
		return _List_fromArray(
			[
				$author$project$Timesheet$Views$FeeActionButtons$downgradeButton(fee),
				A3($author$project$Timesheet$Views$FeeActionButtons$deleteButton, maybeNextFeeId, isInGroup, fee),
				A2($author$project$Timesheet$Views$FeeActionButtons$postNowButton, fee, isInGroup),
				A2($elm$html$Html$div, _List_Nil, _List_Nil),
				A3($author$project$Timesheet$Views$FeeActionButtons$dropDownOrEmpty, user, fee, isInGroup)
			]);
	});
var $author$project$FeeEntry$Messages$OnFocusDescription = {$: 11};
var $author$project$FeeEntry$Messages$PersistFee = {$: 36};
var $author$project$FeeEntry$Messages$SetDescription = function (a) {
	return {$: 9, a: a};
};
var $author$project$FeeEntry$Messages$SetDescriptionScrollTop = function (a) {
	return {$: 12, a: a};
};
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$OnChange$onChange = function (handler) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
};
var $author$project$MiEvents$onScroll = function (msg) {
	var succ = function (height) {
		return $elm$json$Json$Decode$succeed(
			msg(height));
	};
	var getScrollTopDecoder = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollTop']),
		$elm$json$Json$Decode$int);
	return A2(
		$elm$html$Html$Events$on,
		'scroll',
		A2($elm$json$Json$Decode$andThen, succ, getScrollTopDecoder));
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Components$DescriptionInput$descriptionInput = F4(
	function (key, description, editable, events) {
		var descriptionContent = A2($elm$core$Maybe$withDefault, '', description);
		return editable ? A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('z-0'),
					A2($elm$html$Html$Attributes$attribute, 'data-tour', 'billing-description-component')
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					key,
					A2(
						$elm$html$Html$textarea,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full py-4px px-6px rounded-lg text-sm text-mt-grey-dark inputfocus'),
								$elm$html$Html$Attributes$class('border-solid border'),
								$elm$html$Html$Attributes$class('hover:bg-mt-purple-lightest'),
								$elm$html$Html$Attributes$class('focus:border-mt-purple'),
								$elm$html$Html$Attributes$placeholder('Please enter a billing narrative'),
								$elm$html$Html$Attributes$maxlength(1000),
								$author$project$OnChange$onChange(
								$elm$core$Basics$always(events.eA)),
								$elm$html$Html$Events$onInput(events.e3),
								$elm$html$Html$Events$onFocus(events.dK),
								$author$project$MiEvents$onScroll(events.eU),
								A2($elm$html$Html$Attributes$attribute, 'data-gramm', 'false'),
								$elm$html$Html$Attributes$id('fee-entry-description'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-entry-description'),
								$elm$html$Html$Attributes$value(descriptionContent),
								$elm$html$Html$Attributes$rows(3)
							]),
						_List_Nil))
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block py-4px px-6px text-sm'),
					$elm$html$Html$Attributes$class('rounded-lg'),
					$elm$html$Html$Attributes$class('border-solid border'),
					$elm$html$Html$Attributes$class('hover:bg-mt-grey-lightest'),
					$elm$html$Html$Attributes$class('border-mt-grey')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(descriptionContent)
				]));
	});
var $author$project$Components$AiRunner$DescriptionSummary = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$AiRunner$EmailSummary = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Dropdown$Left = 0;
var $author$project$Components$AiInput$Model$Opened = 0;
var $author$project$Components$AiInput$Messages$RunAi = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$AiRunner$Short = 1;
var $author$project$Components$AiInput$Messages$ToggleSummaryDropdown = function (a) {
	return {$: 1, a: a};
};
var $author$project$Icons$Chip$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$d('M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$Chip$view = $author$project$Icons$Chip$viewWithAttributes(_List_Nil);
var $author$project$Components$AiInput$View$chipIcon = function (isCurrentlyRunning) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-6 w-6 cursor-pointer stroke-mt-purple-light hover:stroke-mt-purple'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('animate-spin', isCurrentlyRunning)
					]))
			]),
		_List_fromArray(
			[$author$project$Icons$Chip$view]));
};
var $author$project$Icons$Spinner$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.1364 6.27273V9.13636L15.9545 5.31818L12.1364 1.5V4.36364C7.91727 4.36364 4.5 7.78091 4.5 12C4.5 13.4986 4.93909 14.8923 5.68364 16.0664L7.07727 14.6727C6.64773 13.8805 6.40909 12.9641 6.40909 12C6.40909 8.84045 8.97682 6.27273 12.1364 6.27273ZM18.5891 7.93364L17.1955 9.32727C17.6155 10.1291 17.8636 11.0359 17.8636 12C17.8636 15.1595 15.2959 17.7273 12.1364 17.7273V14.8636L8.31818 18.6818L12.1364 22.5V19.6364C16.3555 19.6364 19.7727 16.2191 19.7727 12C19.7727 10.5014 19.3336 9.10773 18.5891 7.93364Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$Spinner$view = $author$project$Icons$Spinner$viewWithAttributes(_List_Nil);
var $author$project$Components$AiInput$View$summaryDropdown = F2(
	function (isEmail, model) {
		var spinner = function (aiRunner) {
			return _Utils_eq(
				$author$project$Components$AiInput$Model$Running(aiRunner),
				model.eQ) ? $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('animate-spin h-6 w-6 fill-white stroke-mt-purple-light group-hover:stroke-mt-purple')
						]),
					_List_fromArray(
						[$author$project$Icons$Spinner$view]))) : $elm$core$Maybe$Nothing;
		};
		var emailBtns = _List_fromArray(
			[
				{
				gc: $author$project$Components$AiInput$Messages$RunAi(
					$author$project$Components$AiRunner$EmailSummary(1)),
				c6: 'short-email-summary',
				bN: spinner(
					$author$project$Components$AiRunner$EmailSummary(1)),
				fk: 'Email Summary'
			}
			]);
		var btns = A2(
			$elm$core$List$map,
			$author$project$Components$Dropdown$dropdownButton,
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						{
						gc: $author$project$Components$AiInput$Messages$RunAi(
							$author$project$Components$AiRunner$DescriptionSummary(1)),
						c6: 'short-description-summary',
						bN: spinner(
							$author$project$Components$AiRunner$DescriptionSummary(1)),
						fk: 'Description Summary'
					}
					]),
				A3($author$project$CoreX$Appendable$andAppendIf, isEmail, emailBtns, _List_Nil)));
		return $author$project$Components$Dropdown$view(
			{
				ge: $author$project$Components$AiInput$Messages$ToggleSummaryDropdown(1),
				bN: $author$project$Components$AiInput$View$chipIcon(
					!_Utils_eq(model.eQ, $author$project$Components$AiInput$Model$Idle)),
				aC: 'ml-summary-dropdown',
				hJ: !model.ff,
				iu: $author$project$Components$AiInput$Messages$ToggleSummaryDropdown(0),
				iv: 0,
				iw: btns
			});
	});
var $author$project$FeeEntry$View$summaryDropdownInput = F2(
	function (canUseAi, fee) {
		if (canUseAi) {
			var isGroupedEmails = function () {
				var _v0 = $author$project$Timesheet$FeeLogic$getConsolidatedFees(fee);
				if (!_v0.b) {
					return false;
				} else {
					var fees = _v0;
					return A2($elm$core$List$all, $author$project$Timesheet$FeeLogic$activityIsEmail, fees);
				}
			}();
			var showEmailSummary = $author$project$Timesheet$FeeLogic$activityIsEmail(fee) || isGroupedEmails;
			return A2(
				$elm$html$Html$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
					$author$project$FeeEntry$Messages$AiInputMessage),
				A2($author$project$Components$AiInput$View$summaryDropdown, showEmailSummary, fee.aQ));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Components$AiInput$Messages$Reset = {$: 2};
var $author$project$FeeEntry$Messages$SetDescriptionAndPersist = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$AiInput$View$summary = F2(
	function (optionsFn, model) {
		var _v0 = model.fg;
		if (!_v0.$) {
			var result = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-ai-suggestion'),
						$elm$html$Html$Attributes$class('w-full border border-mt-purple-light rounded-lg p-1 text-sm font-semibold')
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					_Utils_eq(model.eQ, $author$project$Components$AiInput$Model$Idle),
					optionsFn(result),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Summary:')
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(result)
								]))
						])));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$FeeEntry$View$summaryResults = function (fee) {
	var options = function (result) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn cursor-pointer'),
								$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
								$author$project$FeeEntry$Messages$AiInputMessage($author$project$Components$AiInput$Messages$Reset))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex gap-x-2')
							]),
						A2(
							$author$project$CoreX$Appendable$andAppend,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn items-center cursor-pointer'),
											$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
											$author$project$FeeEntry$Messages$SetDescriptionAndPersist(
												A2($elm$core$Maybe$withDefault, '', fee.dd) + ('. ' + result)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Append')
										]))
								]),
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								!$author$project$FeeTypeLogic$isRequiredPrefix(fee.g0),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn items-center cursor-pointer'),
												$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
												$author$project$FeeEntry$Messages$SetDescriptionAndPersist(result))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Replace')
											]))
									]),
								_List_Nil)))
					]))
			]);
	};
	return A2(
		$elm$html$Html$map,
		$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
		A2($author$project$Components$AiInput$View$summary, options, fee.aQ));
};
var $author$project$FeeEntry$View$descriptionInputColumn = F3(
	function (canUseAi, editable, fee) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-7px text-xs font-light')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Billing Narrative')
										])),
									A2($author$project$FeeEntry$View$summaryDropdownInput, canUseAi, fee)
								])),
							A4(
							$author$project$Components$DescriptionInput$descriptionInput,
							fee.gC,
							fee.dd,
							editable && _Utils_eq(fee.aQ.eQ, $author$project$Components$AiInput$Model$Idle),
							{
								dK: A2($author$project$TimesheetPage$Messages$FeeFormEdit, fee.aC, $author$project$FeeEntry$Messages$OnFocusDescription),
								eA: A2($author$project$TimesheetPage$Messages$FeeFormEdit, fee.aC, $author$project$FeeEntry$Messages$PersistFee),
								eU: A2(
									$elm$core$Basics$composeL,
									$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
									$author$project$FeeEntry$Messages$SetDescriptionScrollTop),
								e3: A2(
									$elm$core$Basics$composeL,
									$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
									$author$project$FeeEntry$Messages$SetDescription)
							}),
							$author$project$FeeEntry$View$summaryResults(fee)
						]))
				]));
	});
var $author$project$TimesheetPage$Messages$SelectNextFee = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$FeeEntry$View$elementToNextFeeInput = F2(
	function (fee, direction) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$tabindex(0),
					$elm$html$Html$Events$onFocus(
					A2($author$project$TimesheetPage$Messages$SelectNextFee, fee, direction)),
					$elm$html$Html$Attributes$class('absolute')
				]),
			_List_Nil);
	});
var $author$project$FeeEntry$Messages$EditDate = function (a) {
	return {$: 22, a: a};
};
var $author$project$FeeEntry$Messages$SetDate = function (a) {
	return {$: 21, a: a};
};
var $author$project$CoreX$Events$onBlurWithTargetValue = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $author$project$Components$DateInput$feeDateInput = F5(
	function (zone, commitSetter, tempSetter, occuredAt, maybeTempDate) {
		var editableAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('cursor-pointer time-focus'),
				$elm$html$Html$Attributes$required(true),
				$author$project$CoreX$Events$onBlurWithTargetValue(commitSetter),
				$elm$html$Html$Events$onInput(tempSetter)
			]);
		var dateAttrs = A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			$elm$core$Maybe$Just(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						A2($author$project$CoreX$DateFormat$toDateString, zone, occuredAt))
					])),
			A2(
				$elm$core$Maybe$map,
				function (s) {
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$value(s)
						]);
				},
				maybeTempDate));
		var commonAttrs = A2($author$project$CoreX$Appendable$andMaybeAppend, dateAttrs, $author$project$Components$DateInput$inputAttrs);
		return A2(
			$elm$html$Html$div,
			$author$project$Components$DateInput$commonClasses,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_Utils_ap(commonAttrs, editableAttrs),
					_List_Nil)
				]));
	});
var $author$project$FeeEntry$View$feeDateView = F3(
	function (editable, zone, fee) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pb-1 text-sm')
				]),
			editable ? _List_fromArray(
				[
					A5(
					$author$project$Components$DateInput$feeDateInput,
					zone,
					A2(
						$elm$core$Basics$composeL,
						$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
						$author$project$FeeEntry$Messages$SetDate),
					A2(
						$elm$core$Basics$composeL,
						$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
						$author$project$FeeEntry$Messages$EditDate),
					fee.b7,
					fee.js)
				]) : _List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$CoreX$DateFormat$toDayAndMonthStringWithOptYear, zone, true, fee.b7))
				]));
	});
var $author$project$Timesheet$FeeLogic$feeRowDomId = function (fee) {
	return 'fee-' + $elm$core$String$fromInt(fee.aC);
};
var $author$project$FeeEntry$Messages$EditTime = function (a) {
	return {$: 23, a: a};
};
var $author$project$FeeEntry$Messages$SetTime = function (a) {
	return {$: 24, a: a};
};
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $author$project$CoreX$DateFormat$to24HourTimeString = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $author$project$Components$TimeInput$timeInput = F5(
	function (zone, commitSetter, tempSetter, time, maybeTempTime) {
		var timeString = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$CoreX$DateFormat$to24HourTimeString, zone, time),
			maybeTempTime);
		var editableAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('cursor-pointer time-focus'),
				$author$project$CoreX$Events$onBlurWithTargetValue(commitSetter),
				$elm$html$Html$Events$onInput(tempSetter)
			]);
		var commonAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('time'),
				$elm$html$Html$Attributes$class('w-full text-grey-darkest bg-transparent'),
				$elm$html$Html$Attributes$class('md:font-normal leading-normal'),
				$elm$html$Html$Attributes$class('focus:border-mt-purple'),
				$elm$html$Html$Attributes$value(timeString)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full max-w-32 pill border-solid border border-mt-grey-lighter py-2'),
					$elm$html$Html$Attributes$class('hover:bg-mt-purple-lightest'),
					$elm$html$Html$Attributes$class('flex items-center'),
					$elm$html$Html$Attributes$class('focus:border-mt-purple-lighter'),
					A2($elm$html$Html$Attributes$attribute, 'data-tour', 'time-input'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'time-input')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_Utils_ap(commonAttrs, editableAttrs),
					_List_Nil)
				]));
	});
var $author$project$FeeEntry$View$feeTimeView = F3(
	function (editable, zone, fee) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-sm')
				]),
			editable ? _List_fromArray(
				[
					A5(
					$author$project$Components$TimeInput$timeInput,
					zone,
					A2(
						$elm$core$Basics$composeL,
						$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
						$author$project$FeeEntry$Messages$SetTime),
					A2(
						$elm$core$Basics$composeL,
						$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
						$author$project$FeeEntry$Messages$EditTime),
					fee.b7,
					fee.jt)
				]) : _List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$CoreX$DateFormat$to12HourTimeString, zone, fee.b7))
				]));
	});
var $author$project$FeeEntry$Messages$SetConsolidatedFeesOpen = function (a) {
	return {$: 43, a: a};
};
var $author$project$Timesheet$FeeLogic$getMergeCount = function (mergedType) {
	if (mergedType.$ === 1) {
		var count = mergedType.a;
		return count;
	} else {
		return 0;
	}
};
var $author$project$Timesheet$FeeLogic$isGroupOrConsolidated = function (mergedType) {
	if (mergedType.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm_community$html_extra$Html$Extra$viewIf = F2(
	function (condition, html) {
		return condition ? html : $elm_community$html_extra$Html$Extra$nothing;
	});
var $author$project$Timesheet$Views$FeeTypeAndActivityColumns$feeTypeColumn = function (_v0) {
	var zone = _v0.fA;
	var isSelected = _v0.hL;
	var isFutureDated = _v0.hF;
	var isEditable = _v0.hB;
	var feeType = _v0.g0;
	var occurredAt = _v0.b7;
	var mergedFeeType = _v0.h1;
	var isConsolidatedFeesOpen = _v0.hA;
	var textMsg = isSelected ? feeType.dd : A2($author$project$CoreX$DateFormat$to12HourTimeString, zone, occurredAt);
	var textColourClass = (isSelected || (!isFutureDated)) ? 'text-mt-grey-light' : 'text-mt-red';
	var feeTooltip = isSelected ? 'Change Fee Type' : feeType.dd;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type-column'),
				$elm$html$Html$Attributes$class('relative flex flex-col items-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm_community$html_extra$Html$Extra$viewIf,
				$author$project$Timesheet$FeeLogic$isGroupOrConsolidated(mergedFeeType),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-3 leading-loose text-xs font-semibold text-mt-purple')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Merged')
						]))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative flex items-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						$author$project$Timesheet$FeeLogic$isGroupOrConsolidated(mergedFeeType),
						A2(
							$author$project$Timesheet$Views$FeeTypeAndActivityColumns$expandToggler,
							isConsolidatedFeesOpen,
							$author$project$FeeEntry$Messages$SetConsolidatedFeesOpen(!isConsolidatedFeesOpen))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('h-10 w-10 tooltip text-mt-purple')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								A3(
									$author$project$CoreX$Appendable$andAppendIf,
									isSelected,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('open-fee-type')
										]),
									A3(
										$author$project$CoreX$Appendable$andAppendIf,
										isEditable,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick(
												$author$project$FeeEntry$Messages$OpenSearchInput(0)),
												$elm$html$Html$Attributes$class('cursor-pointer hover:bg-mt-purple-lightest')
											]),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('h-8 w-8 flex justify-center items-center border border-mt-purple rounded-full')
											]))),
								_List_fromArray(
									[
										A4($author$project$Components$ActivityIconSelector$feeTypeIcon, feeType.hQ, feeType.df, $elm$core$Maybe$Nothing, _List_Nil),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tooltiptext -left-3 -right-3 top-12 w-18')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(feeTooltip)
											])),
										A2(
										$elm_community$html_extra$Html$Extra$viewIf,
										$author$project$Timesheet$FeeLogic$isGroupOrConsolidated(mergedFeeType),
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$attribute, 'data-role', 'merged-fees-count'),
													$elm$html$Html$Attributes$class('absolute right-0 bottom-2 inline-flex items-center justify-center h-4 px-1 rounded-full text-xs font-semibold text-white bg-mt-purple')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$author$project$Timesheet$FeeLogic$getMergeCount(mergedFeeType)))
												])))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute top-8 w-14 -left-2 -right-2 max-h-10 overflow-hidden text-xxs lg:text-xxs font-light text-center leading-tight'),
										$elm$html$Html$Attributes$class(textColourClass),
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type-icon-description')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(textMsg)
									]))
							]))
					]))
			]));
};
var $author$project$FeeEntry$Messages$CloseSearchInput = {$: 8};
var $author$project$FeeEntry$Messages$SearchInputSet = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$FeeTypeSelector$displayFeeType = F4(
	function (isCurrent, isAutocompletion, feeTypeIndex, feeType) {
		var displayableCode = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (code) {
					return code + ' : ';
				},
				$author$project$FeeTypeLogic$getSearchableField(feeType)));
		var description = _Utils_ap(displayableCode, feeType.dd);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(description),
					$elm$html$Html$Attributes$class('px-6 md:px-2 flex items-center hover:bg-mt-blue-lightest cursor-pointer py-1 md:py-0'),
					$elm$html$Html$Attributes$class('shrink-0'),
					$elm$html$Html$Attributes$class(
					'fee-type-' + $elm$core$String$fromInt(feeType.aC)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'bg-mt-purple-lighter',
							isAutocompletion(feeTypeIndex))
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-test-role', 'selectable-fee-type'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-role',
					'fee-type-' + $elm$core$String$fromInt(feeType.aC)),
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(feeType.aC)),
					$elm$html$Html$Attributes$id(
					'fee-type-search-index-' + $elm$core$String$fromInt(feeTypeIndex)),
					$elm$html$Html$Events$onClick(
					$author$project$FeeEntry$Messages$SearchInputSet(
						$elm$core$String$fromInt(feeType.aC)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-10 h-10 text-mt-purple')
						]),
					_List_fromArray(
						[
							A4($author$project$Components$ActivityIconSelector$feeTypeIcon, feeType.hQ, feeType.df, $elm$core$Maybe$Nothing, _List_Nil)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pl-4 ph-1 truncate md:text-base'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'text-mt-purple',
									isCurrent(feeType)),
									_Utils_Tuple2('text-mt-blue', !(!feeType.fS))
								])),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type-description-and-code')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(description)
						]))
				]));
	});
var $author$project$Components$FeeTypeSelector$displayFeeTypes = F4(
	function (fee, filteredFeeTypes, searchTerms, autocompleteIndex) {
		var isCurrent = function (feeType) {
			return A2($author$project$CoreX$Predicate$hasSameId, fee.g0, feeType);
		};
		var isAutocompletion = function (feeTypeIndex) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (autoIndex) {
						return _Utils_eq(autoIndex, feeTypeIndex);
					},
					autocompleteIndex));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('form-fee-type-label'),
					$elm$html$Html$Attributes$class('p-0 m-0 overflow-y-auto flex flex-col'),
					$elm$html$Html$Attributes$class('min-h-0'),
					$elm$html$Html$Attributes$tabindex(-1)
				]),
			A2(
				$elm$core$List$indexedMap,
				A2($author$project$Components$FeeTypeSelector$displayFeeType, isCurrent, isAutocompletion),
				filteredFeeTypes));
	});
var $author$project$Components$AutocompleteLogic$setAutocompleteIndex = F2(
	function (autocompleteIndex, autocompleteDetails) {
		return _Utils_update(
			autocompleteDetails,
			{av: autocompleteIndex});
	});
var $author$project$Components$AutocompleteLogic$setSearchTerms = F2(
	function (searchTerms, autocompleteDetails) {
		return _Utils_update(
			autocompleteDetails,
			{eX: searchTerms});
	});
var $author$project$FeeEntry$Messages$FilterSearchInputRecords = function (a) {
	return {$: 6, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$FeeEntry$Messages$AutocompleteSearchInput = {$: 5};
var $author$project$FeeEntry$Messages$SetAutocompleteIndex = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$SearchInput$HotKeys$autocompleteIndexDetails = F3(
	function (currentIndex, addOneForPendingMatter, records) {
		var onFirst = _Utils_eq(
			currentIndex,
			$elm$core$Maybe$Just(0));
		var noAutocomplete = $elm_community$maybe_extra$Maybe$Extra$isNothing(currentIndex);
		var autocompleteListLength = function (n) {
			return addOneForPendingMatter ? (n + 1) : n;
		}(
			$elm$core$List$length(records));
		var onLast = _Utils_eq(
			currentIndex,
			$elm$core$Maybe$Just(autocompleteListLength - 1));
		return {b6: noAutocomplete, b9: onFirst, ca: onLast};
	});
var $author$project$Components$SearchInput$HotKeys$msgForKeyboardEvent = F2(
	function (records, autocompleteIndex) {
		var _v0 = A3($author$project$Components$SearchInput$HotKeys$autocompleteIndexDetails, autocompleteIndex, false, records);
		var onFirst = _v0.b9;
		var onLast = _v0.ca;
		var noAutocompleteIndex = _v0.b6;
		var upOp = (!onFirst) ? $author$project$FeeEntry$Messages$SetAutocompleteIndex(1) : $author$project$FeeEntry$Messages$NoOperation;
		var downOp = ((!onLast) || noAutocompleteIndex) ? $author$project$FeeEntry$Messages$SetAutocompleteIndex(0) : $author$project$FeeEntry$Messages$NoOperation;
		return _List_fromArray(
			[
				_Utils_Tuple2('Escape', $author$project$FeeEntry$Messages$CloseSearchInput),
				_Utils_Tuple2('Enter', $author$project$FeeEntry$Messages$AutocompleteSearchInput),
				_Utils_Tuple2('Tab', $author$project$FeeEntry$Messages$AutocompleteSearchInput),
				_Utils_Tuple2('ArrowDown', downOp),
				_Utils_Tuple2('ArrowUp', upOp)
			]);
	});
var $author$project$Components$SearchInput$SearchInputLogic$resourceName = function (selector) {
	switch (selector) {
		case 0:
			return 'fee type';
		case 4:
			return 'file email';
		case 1:
			return 'rate-label';
		case 2:
			return 'rate-value';
		case 3:
			return 'scale item';
		case 5:
			return 'ubtms activity code';
		case 6:
			return 'ubtms task code';
		default:
			return 'ubtms timekeeper code';
	}
};
var $author$project$Components$SearchInput$View$view = F2(
	function (currentlyOpen, _v0) {
		var filteredRecords = _v0.aZ;
		var autocompleteIndex = _v0.av;
		var records = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, filteredRecords);
		var msgForKeyboardEvent = A2($author$project$Components$SearchInput$HotKeys$msgForKeyboardEvent, records, autocompleteIndex);
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-between items-center'),
					$elm$html$Html$Attributes$class('h-12 md:h-6'),
					$elm$html$Html$Attributes$class('px-4 mb-2'),
					$elm$html$Html$Attributes$class('border-y border-mt-grey-lighter md:border-none')
				]),
			_List_fromArray(
				[
					$author$project$Icons$Search$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-mt-purple-lighter w-6 h-6 mr-3 stroke-current icon icon--search')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('z-30 h-6 text-base w-full'),
							$elm$html$Html$Attributes$class('border-mt-grey-lighter border-b focus:border-mt-purple-lightest'),
							$elm$html$Html$Attributes$class('text-grey-darkest'),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$id(
							$author$project$Components$SearchInput$SearchInputLogic$domResourcePrefix(currentlyOpen) + '-search-input'),
							$elm$html$Html$Events$onInput($author$project$FeeEntry$Messages$FilterSearchInputRecords),
							$elm$html$Html$Attributes$placeholder(
							'Select ' + ($author$project$Components$SearchInput$SearchInputLogic$resourceName(currentlyOpen) + ' or search')),
							$elm$html$Html$Attributes$autocomplete(false),
							$author$project$KeyShortcutEvents$on(msgForKeyboardEvent)
						]),
					_List_Nil),
					$author$project$Icons$CloseCross$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('md:hidden h-3.4 stroke-current text-mt-grey icon icon--search cursor-pointer'),
							$elm$html$Html$Events$onClick($author$project$FeeEntry$Messages$CloseSearchInput)
						]))
				]));
	});
var $author$project$Components$SearchInput$View$feeTypeSearchInput = F3(
	function (feeTypes, searchTerms, autocompleteIndex) {
		var records = $krisajenkins$remotedata$RemoteData$Success(
			A2($elm$core$List$map, $author$project$FeeTypeLogic$makeSearchInputRecord, feeTypes));
		var autocompleteDetails = A2(
			$author$project$Components$AutocompleteLogic$setAutocompleteIndex,
			autocompleteIndex,
			A2(
				$author$project$Components$AutocompleteLogic$setSearchTerms,
				searchTerms,
				$author$project$Components$AutocompleteLogic$makeAutocompleteDetails(records)));
		return A2($author$project$Components$SearchInput$View$view, 0, autocompleteDetails);
	});
var $author$project$Components$FeeTypeSelector$searchFeeTypesView = F4(
	function (fee, feeTypes, searchTerms, autocompleteIndex) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative z-10'),
						$elm$html$Html$Attributes$class('flex flex-col'),
						$elm$html$Html$Attributes$class('bg-white focus-within:border-mt-purple'),
						$elm$html$Html$Attributes$class('h-full md:h-56'),
						$elm$html$Html$Attributes$class('pb-2 pt-0 md:pt-4'),
						$elm$html$Html$Attributes$class('md:border md:rounded-lg md:border-solid md:border-mt-grey-lighter'),
						$elm$html$Html$Attributes$tabindex(-1)
					]),
				A2($author$project$OnClickOutsideAfterFocus$withId, 'fee-type-selector-container', $author$project$FeeEntry$Messages$CloseSearchInput)),
			_List_fromArray(
				[
					A3($author$project$Components$SearchInput$View$feeTypeSearchInput, feeTypes, searchTerms, autocompleteIndex),
					A4($author$project$Components$FeeTypeSelector$displayFeeTypes, fee, feeTypes, searchTerms, autocompleteIndex)
				]));
	});
var $author$project$Components$FeeTypeSelector$feeTypeControl = F4(
	function (editable, fee, feeTypes, searchInput) {
		if ((searchInput.$ === 1) && (!searchInput.a)) {
			var _v1 = searchInput.a;
			var searchTerms = searchInput.b.eX;
			var autocompleteIndex = searchInput.b.av;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute w-screen md:w-128 h-full left-0 top-0 md:top-12')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-8 hidden md:block arrow arrow-up')
							]),
						_List_Nil),
						A4($author$project$Components$FeeTypeSelector$searchFeeTypesView, fee, feeTypes, searchTerms, autocompleteIndex)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					editable,
					_List_fromArray(
						[
							$elm$html$Html$Events$onFocus(
							$author$project$FeeEntry$Messages$OpenSearchInput(0))
						]),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$tabindex(0),
							$elm$html$Html$Attributes$class('absolute'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type-search-closed-control')
						])),
				_List_Nil);
		}
	});
var $author$project$User$Data$docSystemName = function (docSystem) {
	switch (docSystem) {
		case 0:
			return $elm$core$Maybe$Just('NetDocs');
		case 1:
			return $elm$core$Maybe$Just('iManage');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FeeEntry$View$filingUser = function (user) {
	return {
		f5: user.f$,
		gF: $author$project$User$Data$docSystemName(user.E.by),
		di: user.E.di,
		dM: user.E.dM,
		fw: user.E.fw
	};
};
var $author$project$FeeTypeLogic$filterFeeTypes = F2(
	function (feeTypeSearchText, feeTypes) {
		var anyMatch = F2(
			function (description, term) {
				return A2(
					$elm$core$List$any,
					$elm$core$String$startsWith(
						$elm$core$String$toLower(term)),
					A2(
						$elm$core$String$split,
						' ',
						$elm$core$String$toLower(description)));
			});
		var matchesSearch = F2(
			function (filterString, feeType) {
				var stringForFiltering = A2(
					$author$project$CoreX$Appendable$andAppendMaybe,
					$author$project$FeeTypeLogic$getSearchableField(feeType),
					_List_fromArray(
						[feeType.dd]));
				return A2(
					$elm$core$List$all,
					anyMatch(
						A2($elm$core$String$join, ' ', stringForFiltering)),
					A2($elm$core$String$split, ' ', filterString));
			});
		if (feeTypeSearchText.$ === 1) {
			return feeTypes;
		} else {
			var filterString = feeTypeSearchText.a;
			return A2(
				$elm$core$List$filter,
				matchesSearch(filterString),
				feeTypes);
		}
	});
var $author$project$Model$Fee$Multi = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Fee$Singleton = {$: 0};
var $author$project$Timesheet$FeeLogic$getFeeConsolidationType = function (fee) {
	return $author$project$Timesheet$FeeLogic$isConsolidation(fee) ? $author$project$Model$Fee$Multi(
		$elm$core$List$length(
			$author$project$Timesheet$FeeLogic$getConsolidatedFees(fee))) : $author$project$Model$Fee$Singleton;
};
var $author$project$Timesheet$Views$FeeTypeAndActivityColumns$fromFee = F3(
	function (zone, isSelected, fee) {
		return {
			g0: fee.g0,
			hA: fee.hA,
			hB: $author$project$Timesheet$FeeLogic$isEditable(fee),
			hF: $author$project$Timesheet$FeeLogic$isFutureDated(fee),
			hL: isSelected,
			h1: $author$project$Timesheet$FeeLogic$getFeeConsolidationType(fee),
			b7: fee.b7,
			fA: zone
		};
	});
var $author$project$CoreX$DateCompare$diffInMs = F2(
	function (posix1, posix2) {
		return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
	});
var $author$project$FeeTimerLogic$millisecondsPerUnit = function (minutesPerUnit) {
	return (minutesPerUnit * 60) * 1000;
};
var $author$project$FeeTimerLogic$millisecondsToSeconds = function (ms) {
	return $elm$core$Basics$floor(ms / 1000.0);
};
var $author$project$FeeTimerLogic$computeUnits = F2(
	function (minutesPerUnit, timer) {
		var millisecondsPast = $elm$core$Basics$abs(
			timer.jJ + A2($author$project$CoreX$DateCompare$diffInMs, timer.jf, timer.gw));
		var partialUnitElapsed = $author$project$FeeTimerLogic$millisecondsToSeconds(
			millisecondsPast % $author$project$FeeTimerLogic$millisecondsPerUnit(minutesPerUnit));
		var unitsSoFar = $elm$core$Basics$ceiling(
			millisecondsPast / $author$project$FeeTimerLogic$millisecondsPerUnit(minutesPerUnit));
		return {iF: partialUnitElapsed, jK: millisecondsPast, jP: unitsSoFar};
	});
var $author$project$FeeTimerLogic$getUnitsAndPartialUnitSeconds = F2(
	function (minutesPerUnit, fee) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$FeeTimerLogic$computeUnits(minutesPerUnit),
			A2(
				$elm$core$Maybe$andThen,
				function (t) {
					return $author$project$FeeTimerLogic$running(t) ? $elm$core$Maybe$Just(t) : $elm$core$Maybe$Nothing;
				},
				fee.jA));
	});
var $author$project$Timesheet$FeeLogic$isFieldEditable = function (fee) {
	return $author$project$Timesheet$FeeLogic$isEditable(fee) || $author$project$Timesheet$FeeLogic$isPostedModified(fee);
};
var $o_train$elm_search_input$Select$isOpen = function (model) {
	return !model.a5;
};
var $author$project$User$UserLogic$isWholeUnitOnlyOrg = function (pms) {
	switch (pms) {
		case 2:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$FeeEntry$View$pmsWholeUnitsLabel = function (pms) {
	var isWholeUnitOnlyOrg = $author$project$User$UserLogic$isWholeUnitOnlyOrg(pms);
	return isWholeUnitOnlyOrg ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-lg font-bold mx-2 pb-4'),
				$elm$html$Html$Attributes$title('Your practice management system accepts whole units only')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('*')
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hidden')
			]),
		_List_Nil);
};
var $author$project$FeeEntry$Messages$StartTimer = {$: 13};
var $author$project$Icons$QuickUnitTimer$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 14 17')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$stroke('#FFF'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$transform('translate(1)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('6'),
								$elm$svg$Svg$Attributes$cy('10.2'),
								$elm$svg$Svg$Attributes$r('6')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M3.6 1.2h4.8M6 7v3.7M11.3 4.2l-.5.5')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$FeeEntry$View$quickTimer = F3(
	function (feeId, style, svgStyle) {
		var svgAttrs = svgStyle + ' stroke-current icon icon--quick-unit-timer';
		var cssStyle = style + ' flex flex-row justify-center';
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(cssStyle),
					$elm$html$Html$Attributes$class('font-base border rounded-4 bg-mt-blue-light border-mt-blue-light'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'unit-selector-timer'),
					$elm$html$Html$Attributes$class('cursor-pointer'),
					$elm$html$Html$Events$onClick(
					A2($author$project$TimesheetPage$Messages$FeeFormEdit, feeId, $author$project$FeeEntry$Messages$StartTimer))
				]),
			_List_fromArray(
				[
					$author$project$Icons$QuickUnitTimer$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class(svgAttrs)
						]))
				]));
	});
var $author$project$FeeEntry$Messages$PersistUnit = function (a) {
	return {$: 14, a: a};
};
var $author$project$FeeEntry$View$unitSelector = F3(
	function (editable, feeId, unit) {
		var editableAttrs = editable ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2(
					$author$project$TimesheetPage$Messages$FeeFormEdit,
					feeId,
					$author$project$FeeEntry$Messages$PersistUnit(unit))),
				$elm$html$Html$Attributes$class('btn-unit cursor-pointer')
			]) : _List_Nil;
		var commonAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-center h-6 w-6'),
				$elm$html$Html$Attributes$class('font-base border rounded-4 text-mt-blue-light border-mt-blue-light'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'unit-selector-' + unit)
			]);
		return A2(
			$elm$html$Html$span,
			_Utils_ap(commonAttrs, editableAttrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(unit)
						]))
				]));
	});
var $author$project$FeeEntry$View$quickUnitsCell = F2(
	function (editable, fee) {
		var defaultUnitSelectors = _List_fromArray(
			['2', '3', '4', '5', '6', '7', '8', '9', '10']);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid gap-1 grid-cols-5 animate-fade-in')
						]),
					A2(
						$elm$core$List$cons,
						A3($author$project$FeeEntry$View$quickTimer, fee.aC, 'h-6 w-6', 'w-3.5'),
						A2(
							$elm$core$List$map,
							A2($author$project$FeeEntry$View$unitSelector, editable, fee.aC),
							defaultUnitSelectors)))
				]));
	});
var $author$project$FeeEntry$View$RateLabelAndRateValue = 1;
var $author$project$FeeEntry$View$RateLabelOnly = 0;
var $author$project$Components$SearchInput$SearchInputSelectors$ActivityCodeSelector = 5;
var $author$project$Components$SearchInput$Views$SearchResult$displaySearchInputResult = F5(
	function (domId, isSelected, isHighlighted, index, record) {
		return A2(
			$elm$html$Html$li,
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				isSelected(record),
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-role-two', 'selected')
					]),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-6 md:px-4 py-2 md:py-0'),
						$elm$html$Html$Attributes$class('text-lg md:text-base font-normal'),
						$elm$html$Html$Attributes$class('border border-transparent hover:bg-mt-blue-lightest cursor-pointer'),
						$elm$html$Html$Attributes$class('truncate'),
						$elm$html$Html$Attributes$id(
						domId + ('-search-index-' + $elm$core$String$fromInt(index))),
						$elm$html$Html$Attributes$class(domId + ('-' + record.aC)),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'text-mt-purple',
								isSelected(record)),
								_Utils_Tuple2(
								'text-mt-grey-dark',
								!isSelected(record)),
								_Utils_Tuple2(
								'bg-mt-purple-lighter',
								isHighlighted(index))
							])),
						$elm$html$Html$Attributes$value(record.aC),
						$elm_community$html_extra$Html$Events$Extra$onEnter(
						$author$project$FeeEntry$Messages$SearchInputSet(record.aC)),
						$elm$html$Html$Events$onClick(
						$author$project$FeeEntry$Messages$SearchInputSet(record.aC)),
						A2($elm$html$Html$Attributes$attribute, 'data-role', domId + '-row'),
						$elm$html$Html$Attributes$title(record.br + (' ' + record.dd))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-light inline-block w-12 truncate float-left'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', domId + '-code')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(record.br)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pl-2 font-regular'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', domId + '-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(record.dd)
						]))
				]));
	});
var $author$project$ErrorLogic$getHttpMessage = function (error) {
	switch (error.$) {
		case 0:
			var string = error.a;
			return 'Looks like ' + (string + ' cannot be found.');
		case 1:
			return 'Looks like the server timed out, please try again soon.';
		case 2:
			return 'Problem with request due to Network connection.';
		case 3:
			var status = error.a;
			return 'That didn\'t work ' + ('(' + ($elm$core$String$fromInt(status) + ')'));
		default:
			var string = error.a;
			return 'We\'re sorry but the data sent was bad: ' + string;
	}
};
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$SearchInput$Views$SearchResult$displaySearchInputResults = F3(
	function (maybeActivity, domId, _v0) {
		var searchTerms = _v0.eX;
		var autocompleteIndex = _v0.av;
		var filteredRecords = _v0.aZ;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('form-' + (domId + '-label')),
					$elm$html$Html$Attributes$class('max-w-lg overflow-y-auto'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', domId + '-list'),
					$elm$html$Html$Attributes$tabindex(-1)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(domId),
							$elm$html$Html$Attributes$class('text-mt-grey-dark'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pl-6',
									!$krisajenkins$remotedata$RemoteData$isSuccess(filteredRecords)),
									_Utils_Tuple2(
									'p-0 m-0',
									$krisajenkins$remotedata$RemoteData$isSuccess(filteredRecords))
								]))
						]),
					function () {
						switch (filteredRecords.$) {
							case 1:
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-6 md:px-4 py-2 md:py-0 pl-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Loading...')
											]))
									]);
							case 3:
								if (!filteredRecords.a.b) {
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-6 md:px-4 py-2 md:py-0 pl-2')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('No results.')
												]))
										]);
								} else {
									var recs = filteredRecords.a;
									var isSelected = function (record) {
										return A2(
											$elm$core$Maybe$withDefault,
											false,
											A2(
												$elm$core$Maybe$map,
												function (r) {
													return _Utils_eq(r.aC, record.aC);
												},
												maybeActivity));
									};
									var isAutocompletion = function (index) {
										return A2(
											$elm$core$Maybe$withDefault,
											false,
											A2(
												$elm$core$Maybe$map,
												function (autoIndex) {
													return _Utils_eq(autoIndex, index);
												},
												autocompleteIndex));
									};
									return A2(
										$elm$core$List$indexedMap,
										A3($author$project$Components$SearchInput$Views$SearchResult$displaySearchInputResult, domId, isSelected, isAutocompletion),
										recs);
								}
							case 0:
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-6 md:px-4 py-2 md:py-0 pl-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Not loaded.')
											]))
									]);
							default:
								var err = filteredRecords.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-6 md:px-4 py-2 md:py-0 pl-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$ErrorLogic$getHttpMessage(err))
											]))
									]);
						}
					}())
				]));
	});
var $author$project$Components$SearchInput$Views$SearchResult$editMode = F3(
	function (currentlySelected, currentlyOpen, autocompleteDetails) {
		var domId = $author$project$Components$SearchInput$SearchInputLogic$domResourcePrefix(currentlyOpen);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative z-10'),
						$elm$html$Html$Attributes$class('flex flex-col'),
						$elm$html$Html$Attributes$class('bg-white focus-within:border-mt-purple'),
						$elm$html$Html$Attributes$class('h-screen md:h-56'),
						$elm$html$Html$Attributes$class('md:mt-0 md:mx-0'),
						$elm$html$Html$Attributes$class('pb-2 pt-0 md:pt-4'),
						$elm$html$Html$Attributes$class('md:border md:rounded-lg md:border-solid md:border-mt-grey-lighter'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'search-input-selector-edit-mode'),
						$elm$html$Html$Attributes$class('absolute w-screen md:w-128'),
						$elm$html$Html$Attributes$class('left-0 top-0')
					]),
				A2($author$project$OnClickOutsideAfterFocus$withId, domId + '-edit-mode', $author$project$FeeEntry$Messages$CloseSearchInput)),
			_List_fromArray(
				[
					A2($author$project$Components$SearchInput$View$view, currentlyOpen, autocompleteDetails),
					A3($author$project$Components$SearchInput$Views$SearchResult$displaySearchInputResults, currentlySelected, domId, autocompleteDetails)
				]));
	});
var $author$project$Components$SearchInput$Views$SearchResult$editModeCaret = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('hidden ml-6 md:block arrow arrow-up')
		]),
	_List_Nil);
var $author$project$Components$SearchInput$Views$SearchResult$view = F3(
	function (currentlySelected, searchInputSelector, autocompleteDetails) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute'),
					$elm$html$Html$Attributes$class('left-0 top-0 w-full h-screen--12'),
					$elm$html$Html$Attributes$class('md:inset-auto md:h-auto md:w-auto')
				]),
			_List_fromArray(
				[
					$author$project$Components$SearchInput$Views$SearchResult$editModeCaret,
					A3($author$project$Components$SearchInput$Views$SearchResult$editMode, currentlySelected, searchInputSelector, autocompleteDetails)
				]));
	});
var $author$project$Components$SearchInput$Views$ShowMode$editMode = F3(
	function (selector, currentlySelected, searchInputModel) {
		if (!searchInputModel.$) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden')
					]),
				_List_Nil);
		} else {
			var searchInputSelector = searchInputModel.a;
			var autocompleteDetails = searchInputModel.b;
			return _Utils_eq(searchInputSelector, selector) ? A3($author$project$Components$SearchInput$Views$SearchResult$view, currentlySelected, selector, autocompleteDetails) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden')
					]),
				_List_Nil);
		}
	});
var $author$project$Components$SearchInput$SearchInputLogic$getPrompt = function (selector) {
	switch (selector) {
		case 2:
			return 'Rate Value';
		case 1:
			return 'Rate';
		case 3:
			return 'Scale Item';
		case 0:
			return 'Fee Type';
		case 4:
			return 'File Email';
		case 5:
			return 'Utbms Activity Code';
		case 6:
			return 'Utbms Task Code';
		default:
			return 'Utbms Timekeeper Code';
	}
};
var $author$project$Components$SearchInput$SearchInputLogic$selectorIsOpen = F2(
	function (selector, searchInput) {
		if (!searchInput.$) {
			return false;
		} else {
			var currentlyOpen = searchInput.a;
			return _Utils_eq(currentlyOpen, selector);
		}
	});
var $author$project$Components$SearchInput$Views$ShowMode$promptForNoSelection = function (selector) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			'Please select ' + $author$project$Components$SearchInput$SearchInputLogic$resourceName(selector))
		]);
};
var $author$project$Components$SearchInput$Views$ShowMode$showSelectedSearchInputRecord = function (_v0) {
	var code = _v0.br;
	var description = _v0.dd;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(code)
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-bold pl-2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(description)
				]))
		]);
};
var $author$project$Components$SearchInput$Views$ShowMode$showMode = F4(
	function (selector, currentlySelected, editable, isOpen) {
		var searchInputResourceName = $author$project$Components$SearchInput$SearchInputLogic$resourceName(selector);
		var isDeletedRecord = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.d6;
				},
				currentlySelected));
		var hasSelection = !_Utils_eq(currentlySelected, $elm$core$Maybe$Nothing);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center w-full')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						editable,
						_List_fromArray(
							[
								$elm$html$Html$Events$onFocus(
								$author$project$FeeEntry$Messages$OpenSearchInput(selector))
							]),
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							!isOpen,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$tabindex(0)
								]),
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								isDeletedRecord,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$title('This ' + (searchInputResourceName + ' is no longer available.'))
									]),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block -mb-px'),
										$elm$html$Html$Attributes$class('text-sm cursor-pointer'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('text-mt-red-light md:hover:text-mt-red', (!hasSelection) || isDeletedRecord),
												_Utils_Tuple2('md:hover:text-mt-blue', hasSelection)
											])),
										$elm$html$Html$Attributes$class('outline-hidden'),
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'open-search-input-selector')
									])))),
					function () {
						if (!currentlySelected.$) {
							var selectedSearchInputRecord = currentlySelected.a;
							return $author$project$Components$SearchInput$Views$ShowMode$showSelectedSearchInputRecord(selectedSearchInputRecord);
						} else {
							return $author$project$Components$SearchInput$Views$ShowMode$promptForNoSelection(selector);
						}
					}())
				]));
	});
var $author$project$Components$SearchInput$Views$ShowMode$view = F4(
	function (selector, selected, searchInputModel, editable) {
		var currentlySelected = A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var id = _v0.aC;
				var code = _v0.br;
				var description = _v0.dd;
				var isDeleted = _v0.d6;
				return {br: code, dd: description, aC: id, d6: isDeleted};
			},
			selected);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xs')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$SearchInput$SearchInputLogic$getPrompt(selector))
						])),
					A4(
					$author$project$Components$SearchInput$Views$ShowMode$showMode,
					selector,
					currentlySelected,
					editable,
					A2($author$project$Components$SearchInput$SearchInputLogic$selectorIsOpen, selector, searchInputModel)),
					A3($author$project$Components$SearchInput$Views$ShowMode$editMode, selector, currentlySelected, searchInputModel)
				]));
	});
var $author$project$FeeEntry$View$activityCodeSelector = F3(
	function (fee, feeCardCurrentSearchInput, editable) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-light'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'utbms-activity-codes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
					A4(
						$author$project$Components$SearchInput$Views$ShowMode$view,
						5,
						A2($elm$core$Maybe$map, $author$project$Model$UtbmsCode$utbmsCodeToSearchInputRecord, fee.bp),
						feeCardCurrentSearchInput,
						editable))
				]));
	});
var $author$project$Timesheet$Views$FeeWarning$matterHasWarning = function (maybeMatter) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (matter) {
				return !_Utils_eq(matter.h0, $author$project$MatterTypes$MatterOk);
			},
			maybeMatter));
};
var $author$project$Timesheet$Views$FeeWarning$hasWarning = function (fee) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(fee.dz) || ($author$project$Timesheet$Views$FeeWarning$matterHasWarning(fee.hY) || fee.ip);
};
var $author$project$Components$SearchInput$SearchInputSelectors$RateLabelSelector = 1;
var $author$project$Components$SearchInput$SearchInputSelectors$RateValueSelector = 2;
var $author$project$FeeEntry$View$rateAndRateValueSelectors = F6(
	function (displayRateValue, rateSelectorDisplay, fee, actionStepRates, feeCardCurrentSearchInput, editable) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				rateSelectorDisplay === 1,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-light h-12'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'action-step-matter-rate')
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = fee.fD;
								if (_v0.$ === 1) {
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('')
											]));
								} else {
									var r = _v0.a;
									var rateValue = A2(
										$elm$core$Maybe$withDefault,
										'Error',
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.iB;
											},
											fee.aO));
									var isFixedAmount = A2(
										$elm$core$Maybe$withDefault,
										false,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.hE;
											},
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (rv) {
													return _Utils_eq(rv.fE, r.aC);
												},
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.iN;
														},
														A2(
															$elm_community$list_extra$List$Extra$find,
															function (all) {
																return _Utils_eq(all.aC, r.aC);
															},
															A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, actionStepRates)))))));
									return isFixedAmount ? A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pl-8 text-xs')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('($ ' + (rateValue + ')'))
											])) : A2(
										$elm$html$Html$map,
										$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
										A4(
											$author$project$Components$SearchInput$Views$ShowMode$view,
											2,
											A2(
												$elm$core$Maybe$map,
												A2($author$project$Model$ActionStep$RateValue$toSearchInputRecord, displayRateValue, fee.f_),
												fee.aO),
											feeCardCurrentSearchInput,
											editable));
								}
							}()
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-light'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'action-step-rate')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
								A4(
									$author$project$Components$SearchInput$Views$ShowMode$view,
									1,
									A2($elm$core$Maybe$map, $author$project$Model$ActionStep$Rate$toSearchInputRecord, fee.fD),
									feeCardCurrentSearchInput,
									editable))
							]))
					])));
	});
var $author$project$Components$SearchInput$SearchInputSelectors$TaskCodeSelector = 6;
var $author$project$FeeEntry$View$taskCodeSelector = F3(
	function (fee, feeCardCurrentSearchInput, editable) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-light'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'utbms-task-codes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
					A4(
						$author$project$Components$SearchInput$Views$ShowMode$view,
						6,
						A2($elm$core$Maybe$map, $author$project$Model$UtbmsCode$taskCodeToSearchInputRecord, fee.cE),
						feeCardCurrentSearchInput,
						editable))
				]));
	});
var $author$project$Components$SearchInput$SearchInputSelectors$TimekeeperCodeSelector = 7;
var $author$project$FeeEntry$View$timekeeperCodeSelector = F3(
	function (fee, feeCardCurrentSearchInput, editable) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-light'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'utbms-timekeeper-codes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
					A4(
						$author$project$Components$SearchInput$Views$ShowMode$view,
						7,
						A2($elm$core$Maybe$map, $author$project$Model$UtbmsCode$utbmsCodeToSearchInputRecord, fee.cG),
						feeCardCurrentSearchInput,
						editable))
				]));
	});
var $author$project$FeeEntry$View$rateSelectors = function (_v0) {
	var canSetFileProRates = _v0.aS;
	var pms = _v0.ce;
	var fee = _v0.dA;
	var editable = _v0.gJ;
	var rates = _v0.cf;
	var displayUTBMS = _v0.bx;
	var searchInput = _v0.ck;
	var canViewRateValues = _v0.f7;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'row-start-5 md:row-start-4',
						$author$project$Timesheet$Views$FeeWarning$hasWarning(fee)),
						_Utils_Tuple2(
						'row-start-4 md:row-start-3',
						!$author$project$Timesheet$Views$FeeWarning$hasWarning(fee))
					])),
				$elm$html$Html$Attributes$class('md:row-start-auto col-start-2 md:col-start-5 col-span-2 md:col-span-4 place-self-start')
			]),
		function () {
			switch (pms) {
				case 1:
					return ((!_Utils_eq(fee.hY, $elm$core$Maybe$Nothing)) && (!fee.aB)) ? A3(
						$author$project$CoreX$Appendable$andAppendIf,
						displayUTBMS,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pt-4 pb-4')
									]),
								_List_fromArray(
									[
										A3($author$project$FeeEntry$View$taskCodeSelector, fee, searchInput, editable),
										A3($author$project$FeeEntry$View$activityCodeSelector, fee, searchInput, editable),
										A3($author$project$FeeEntry$View$timekeeperCodeSelector, fee, searchInput, editable)
									]))
							]),
						_List_fromArray(
							[
								A6($author$project$FeeEntry$View$rateAndRateValueSelectors, canViewRateValues, 1, fee, rates, searchInput, editable)
							])) : _List_Nil;
				case 3:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-light'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'scale-item')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
									A4(
										$author$project$Components$SearchInput$Views$ShowMode$view,
										3,
										A2($elm$core$Maybe$map, $author$project$Model$ScaleItem$toSearchInputRecord, fee.bd),
										searchInput,
										editable))
								]))
						]);
				case 2:
					return canSetFileProRates ? _List_fromArray(
						[
							A6($author$project$FeeEntry$View$rateAndRateValueSelectors, canViewRateValues, 0, fee, rates, searchInput, editable)
						]) : _List_Nil;
				case 4:
					return _List_fromArray(
						[
							A6($author$project$FeeEntry$View$rateAndRateValueSelectors, canViewRateValues, 1, fee, rates, searchInput, editable)
						]);
				case 5:
					return _List_Nil;
				case 0:
					return _List_Nil;
				case 6:
					return _List_Nil;
				default:
					return _List_Nil;
			}
		}());
};
var $author$project$FeeTypeLogic$scaleGroupFilter = F2(
	function (matter, feeTypes) {
		return A2(
			$elm$core$Maybe$withDefault,
			feeTypes,
			A2(
				$elm$core$Maybe$map,
				function (id) {
					return A2(
						$elm$core$List$filter,
						function (ft) {
							return _Utils_eq(
								ft.eS,
								$elm$core$Maybe$Just(id));
						},
						feeTypes);
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.eS;
					},
					matter)));
	});
var $o_train$elm_search_input$Select$domId = function (label) {
	return 'elm-search-' + label;
};
var $o_train$elm_search_input$Select$Select = function (a) {
	return {$: 1, a: a};
};
var $o_train$elm_search_input$Select$itemDomId = function (index) {
	return 'elm-search-index-' + $elm$core$String$fromInt(index);
};
var $o_train$elm_search_input$Select$itemView = F3(
	function (autocompleteIndex, index, item) {
		var titleText = item.ec;
		var isHighlighted = _Utils_eq(
			$elm$core$Maybe$Just(index),
			autocompleteIndex);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-search-item'),
					$elm$html$Html$Attributes$id(
					$o_train$elm_search_input$Select$itemDomId(index)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-mt-purple-lighter', isHighlighted),
							_Utils_Tuple2('text-mt-grey-dark', item.hK),
							_Utils_Tuple2('elm-disabled', !item.hK)
						])),
					$elm$html$Html$Attributes$value(item.aC),
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
					$o_train$elm_search_input$Select$Set(
						$o_train$elm_search_input$Select$Select(item))),
					$elm_community$html_extra$Html$Events$Extra$onEnter(
					$o_train$elm_search_input$Select$Set(
						$o_train$elm_search_input$Select$Select(item))),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'item-row'),
					$elm$html$Html$Attributes$title(titleText)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-light')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(titleText)
						]))
				]));
	});
var $o_train$elm_search_input$Select$itemsView = F4(
	function (min, selected, webdataItems, autocompleteIndex) {
		switch (webdataItems.$) {
			case 0:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 text-grey')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Waiting for at least ' + ($elm$core$String$fromInt(min) + ' letters...'))
						]));
			case 1:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 text-grey')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Loading...')
						]));
			case 2:
				var err = webdataItems.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 text-grey')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Search failed...')
						]));
			default:
				if (!webdataItems.a.b) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('px-4 text-grey')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No results matching terms...')
							]));
				} else {
					var items = webdataItems.a;
					var selectableItems = A2(
						$elm$core$List$indexedMap,
						$o_train$elm_search_input$Select$itemView(autocompleteIndex),
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								$o_train$elm_search_input$Select$isSelected(selected)),
							items));
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('max-w-lg'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'items-list')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('select-item-for-'),
										$elm$html$Html$Attributes$class('p-0 m-0 text-mt-grey-dark')
									]),
								selectableItems)
							]));
				}
		}
	});
var $o_train$elm_search_input$Select$SearchTerms = function (a) {
	return {$: 4, a: a};
};
var $o_train$elm_search_input$Select$Clear = {$: 1};
var $o_train$elm_search_input$Select$filterView = function (filter) {
	var v = filter;
	return v;
};
var $o_train$elm_search_input$Select$Icons$CloseCross$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$stroke('currentColor')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('cross-copy-3'),
								$elm$svg$Svg$Attributes$transform('translate(-36.000000, -36.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('close-cross'),
										$elm$svg$Svg$Attributes$transform('translate(38.000000, 38.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M20,0 L0,20'),
												$elm$svg$Svg$Attributes$id('Path-2')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M0,0 L20,20'),
												$elm$svg$Svg$Attributes$id('Path-1')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $o_train$elm_search_input$Select$filtersView = function (search) {
	var _v0 = (_Utils_eq(search.N, $elm$core$Maybe$Nothing) || _Utils_eq(
		search.N,
		$elm$core$Maybe$Just(''))) ? _Utils_Tuple2(
		'Close Search',
		$o_train$elm_search_input$Select$Set(
			$o_train$elm_search_input$Select$Mode(1))) : _Utils_Tuple2('Clear', $o_train$elm_search_input$Select$Clear);
	var closeTitle = _v0.a;
	var closeMsg = _v0.b;
	return A3(
		$o_train$elm_search_input$Select$flip,
		$elm$core$List$append,
		_List_fromArray(
			[
				$o_train$elm_search_input$Select$Icons$CloseCross$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-icon'),
						$elm$html$Html$Attributes$title(closeTitle),
						$elm$html$Html$Events$onClick(closeMsg)
					]))
			]),
		A2($elm$core$List$map, $o_train$elm_search_input$Select$filterView, search.aA));
};
var $o_train$elm_search_input$Select$Autocomplete = {$: 0};
var $o_train$elm_search_input$Select$AutocompleteIndex = function (a) {
	return {$: 3, a: a};
};
var $o_train$elm_search_input$Select$Autocomplete$Next = 0;
var $o_train$elm_search_input$Select$Autocomplete$Previous = 1;
var $o_train$elm_search_input$Select$isNothing = function (mebe) {
	return _Utils_eq(mebe, $elm$core$Maybe$Nothing);
};
var $o_train$elm_search_input$Select$autocompleteIndexDetails = F2(
	function (currentIndex, records) {
		var onFirst = _Utils_eq(
			currentIndex,
			$elm$core$Maybe$Just(0));
		var noAutocomplete = $o_train$elm_search_input$Select$isNothing(currentIndex);
		var autocompleteListLength = $elm$core$List$length(records);
		var onLast = _Utils_eq(
			currentIndex,
			$elm$core$Maybe$Just(autocompleteListLength - 1));
		return {b6: noAutocomplete, b9: onFirst, ca: onLast};
	});
var $o_train$elm_search_input$Select$msgForKeyboardEvent = F2(
	function (records, autocompleteIndex) {
		var _v0 = A2($o_train$elm_search_input$Select$autocompleteIndexDetails, autocompleteIndex, records);
		var onFirst = _v0.b9;
		var onLast = _v0.ca;
		var noAutocompleteIndex = _v0.b6;
		var upOp = (!onFirst) ? $o_train$elm_search_input$Select$Set(
			$o_train$elm_search_input$Select$AutocompleteIndex(1)) : $o_train$elm_search_input$Select$NoOp;
		var downOp = ((!onLast) || noAutocompleteIndex) ? $o_train$elm_search_input$Select$Set(
			$o_train$elm_search_input$Select$AutocompleteIndex(0)) : $o_train$elm_search_input$Select$NoOp;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'Escape',
				$o_train$elm_search_input$Select$Set(
					$o_train$elm_search_input$Select$Mode(1))),
				_Utils_Tuple2('Enter', $o_train$elm_search_input$Select$Autocomplete),
				_Utils_Tuple2('Tab', $o_train$elm_search_input$Select$Autocomplete),
				_Utils_Tuple2('ArrowDown', downOp),
				_Utils_Tuple2('ArrowUp', upOp)
			]);
	});
var $o_train$elm_search_input$Select$KeyShortcutEvents$getInDict = F2(
	function (dict, key) {
		return A2($elm$core$Dict$get, key, dict);
	});
var $o_train$elm_search_input$Select$KeyShortcutEvents$keyMapper = F2(
	function (specAsList, keyboardEvent) {
		var spec = $elm$core$Dict$fromList(specAsList);
		return A2(
			$elm$core$Maybe$map,
			function (msg) {
				return _Utils_Tuple2(
					msg,
					function () {
						var _v0 = keyboardEvent.d9;
						if ((!_v0.$) && (_v0.a === 'Escape')) {
							return true;
						} else {
							return false;
						}
					}());
			},
			A2(
				$elm$core$Maybe$andThen,
				$o_train$elm_search_input$Select$KeyShortcutEvents$getInDict(spec),
				keyboardEvent.d9));
	});
var $o_train$elm_search_input$Select$KeyShortcutEvents$on = function (specAsList) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'keydown',
		$Gizra$elm_keyboard_event$Keyboard$Event$considerKeyboardEvent(
			$o_train$elm_search_input$Select$KeyShortcutEvents$keyMapper(specAsList)));
};
var $o_train$elm_search_input$Select$Icons$Search$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 16 18'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$transform('translate(-19.000000, -57.000000)'),
								$elm$svg$Svg$Attributes$strokeWidth('2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('Search'),
										$elm$svg$Svg$Attributes$transform('translate(0.000000, 47.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('Group-Copy'),
												$elm$svg$Svg$Attributes$transform('translate(28.093999, 19.282840) scale(-1, 1) rotate(80.000000) translate(-28.093999, -19.282840) translate(21.093999, 11.282840)')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$circle,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('Oval-3'),
														$elm$svg$Svg$Attributes$fill(''),
														$elm$svg$Svg$Attributes$cx('5.5'),
														$elm$svg$Svg$Attributes$cy('5.5'),
														$elm$svg$Svg$Attributes$r('5.5')
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$path,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$d('M9.05664062,9.82421875 L13.4472656,15.0605469'),
														$elm$svg$Svg$Attributes$id('Path-3')
													]),
												_List_Nil)
											]))
									]))
							]))
					]))
			]));
};
var $o_train$elm_search_input$Select$searchInputView = function (model) {
	var records = model.eV.Q;
	var msgEvents = A2($o_train$elm_search_input$Select$msgForKeyboardEvent, records, model.av);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('elm-search-input')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					$o_train$elm_search_input$Select$Icons$Search$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-icon')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-search-text-input'),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$id(
							$o_train$elm_search_input$Select$domInputId(model.ec)),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $o_train$elm_search_input$Select$Set, $o_train$elm_search_input$Select$SearchTerms)),
							$elm$html$Html$Attributes$value(
							A2($elm$core$Maybe$withDefault, '', model.eV.N)),
							$elm$html$Html$Attributes$placeholder('Select or search'),
							$elm$html$Html$Attributes$autocomplete(false),
							$o_train$elm_search_input$Select$KeyShortcutEvents$on(msgEvents)
						]),
					_List_Nil)
				]),
			$o_train$elm_search_input$Select$filtersView(model.eV)));
};
var $o_train$elm_search_input$Select$Deselect = function (a) {
	return {$: 2, a: a};
};
var $o_train$elm_search_input$Select$selectedView = function (selected) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm_community$html_extra$Html$Extra$nothing,
		A2(
			$elm$core$Maybe$map,
			function (item) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-search-item'),
							$elm$html$Html$Attributes$class('elm-selected'),
							$elm$html$Html$Attributes$id('elm-search-selected'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'item-row'),
							$elm$html$Html$Attributes$title(item.ec + ' - click to deselect'),
							$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
							$o_train$elm_search_input$Select$Set(
								$o_train$elm_search_input$Select$Deselect(item)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-semibold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(item.ec)
								])),
							$o_train$elm_search_input$Select$Icons$CloseCross$viewWithAttributes(
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-icon-deselect'),
									$elm$html$Html$Attributes$title('Click to deselect')
								]))
						]));
			},
			selected));
};
var $o_train$elm_search_input$Select$OnClickOutsideAfterFocus$invertDecoder = function (decoder) {
	var invertMaybe = function (maybe) {
		if (maybe.$ === 1) {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('');
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		invertMaybe,
		$elm$json$Json$Decode$maybe(decoder));
};
var $o_train$elm_search_input$Select$OnClickOutsideAfterFocus$succeedIfBloodlineHasId = function (targetId) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return _Utils_eq(id, targetId) ? $elm$json$Json$Decode$succeed(0) : A2(
				$elm$json$Json$Decode$field,
				'parentNode',
				$o_train$elm_search_input$Select$OnClickOutsideAfterFocus$succeedIfBloodlineHasId(targetId));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
};
var $o_train$elm_search_input$Select$OnClickOutsideAfterFocus$succeedIfClickIsOustideOfId = function (targetId) {
	return $o_train$elm_search_input$Select$OnClickOutsideAfterFocus$invertDecoder(
		A2(
			$elm$json$Json$Decode$field,
			'relatedTarget',
			$o_train$elm_search_input$Select$OnClickOutsideAfterFocus$succeedIfBloodlineHasId(targetId)));
};
var $o_train$elm_search_input$Select$OnClickOutsideAfterFocus$withId = F2(
	function (id, onClickOutsideMsg) {
		var decodeFocusOut = A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$always(onClickOutsideMsg),
			$o_train$elm_search_input$Select$OnClickOutsideAfterFocus$succeedIfClickIsOustideOfId(id));
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$id(id),
				$elm$html$Html$Attributes$tabindex(-1),
				A2($elm$html$Html$Events$on, 'focusout', decodeFocusOut)
			]);
	});
var $o_train$elm_search_input$Select$view = function (model) {
	var items = A2(
		$elm$core$Maybe$withDefault,
		$krisajenkins$remotedata$RemoteData$succeed(model.eV.Q),
		A2(
			$elm$core$Maybe$map,
			function (t) {
				return ($elm$core$String$trim(t) !== '') ? model.eV.iV : $krisajenkins$remotedata$RemoteData$succeed(model.eV.Q);
			},
			model.eV.N));
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('elm-search-input-container'),
			A2(
				$o_train$elm_search_input$Select$OnClickOutsideAfterFocus$withId,
				$o_train$elm_search_input$Select$domId(model.ec),
				$o_train$elm_search_input$Select$Set(
					$o_train$elm_search_input$Select$Mode(1)))),
		_List_fromArray(
			[
				$o_train$elm_search_input$Select$searchInputView(model),
				$o_train$elm_search_input$Select$selectedView(model.e0),
				A4($o_train$elm_search_input$Select$itemsView, model.aE, model.e0, items, model.av)
			]));
};
var $author$project$FeeEntry$View$selectInputView = F2(
	function (fee, selectInput) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-search-input-container1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('arrow arrow-up')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-search-input-container2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
							A2(
								$elm$html$Html$map,
								$author$project$FeeEntry$Messages$SelectInput,
								$o_train$elm_search_input$Select$view(selectInput)))
						]))
				]));
	});
var $author$project$TimesheetPage$Messages$SetFeeTag = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $elm_community$html_extra$Html$Attributes$Extra$empty = $elm$html$Html$Attributes$classList(_List_Nil);
var $elm_community$html_extra$Html$Attributes$Extra$attributeIf = F2(
	function (condition, attr) {
		return condition ? attr : $elm_community$html_extra$Html$Attributes$Extra$empty;
	});
var $author$project$FeeEntry$View$tagChip = F3(
	function (fee, selectedIds, tag) {
		var isSelected = A2($elm$core$Set$member, tag.aC, selectedIds);
		var editable = $author$project$Timesheet$FeeLogic$isEditable(fee);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('d-badge d-badge-sm w-fit cursor-pointer font-semibold'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('text-white bg-mt-purple border-mt-purple', isSelected),
							_Utils_Tuple2('bg-white text-mt-grey-dark bg-mt-grey-lightest!', !isSelected)
						])),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
					editable,
					$elm$html$Html$Events$onClick(
						A2($author$project$TimesheetPage$Messages$SetFeeTag, fee, tag.aC)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(tag.b2)
				]));
	});
var $author$project$FeeEntry$View$tagChipRow = F2(
	function (user, fee) {
		var selectedIds = $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.aC;
				},
				fee.fi));
		var availableTags = A2($author$project$FeeEntry$View$availableTagsFor, user, fee);
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			A3($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty, availableTags),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-span-full md:col-start-2 md:col-span-7 w-full justify-self-start flex flex-wrap justify-start gap-2 pt-3 pb-1'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-tags-row')
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$FeeEntry$View$tagChip, fee, selectedIds),
					availableTags)));
	});
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$html$Html$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $author$project$FeeEntry$Messages$SetHours = function (a) {
	return {$: 40, a: a};
};
var $author$project$FeeEntry$Messages$SetMinutes = function (a) {
	return {$: 39, a: a};
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Components$DurationInput$DurationInputLogic$toHoursMins = function (durationInput) {
	var padZero = function (x) {
		return ($elm$core$String$length(x) === 1) ? ('0' + x) : x;
	};
	var val = function (x) {
		return padZero(
			$elm$core$String$fromInt(x));
	};
	var _v0 = _Utils_Tuple2(
		val(durationInput._),
		val(durationInput.aF));
	var hours = _v0.a;
	var minutes = _v0.b;
	return _Utils_Tuple2(hours, minutes);
};
var $author$project$Components$DurationInput$View$view = F2(
	function (editable, durationInput) {
		var _v0 = $author$project$Components$DurationInput$DurationInputLogic$toHoursMins(durationInput);
		var hours = _v0.a;
		var minutes = _v0.b;
		return editable ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-center items-center w-18 h-10 py-2 bg-white'),
							$elm$html$Html$Attributes$class('rounded-lg text-mt-grey-dark border-solid border border-mt-grey-lighter'),
							$elm$html$Html$Attributes$class('hover:bg-mt-purple-lightest'),
							$elm$html$Html$Attributes$class('focus-within:border-mt-purple'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'duration-input')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$class('text-xl w-6'),
									$elm$html$Html$Attributes$class('text-center cursor-pointer'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'hours-input'),
									$elm$html$Html$Attributes$value(hours),
									A2(
									$elm$html$Html$Attributes$property,
									'max',
									$elm$json$Json$Encode$string('23')),
									$elm$html$Html$Events$onInput($author$project$FeeEntry$Messages$SetHours),
									$elm$html$Html$Events$onBlur($author$project$FeeEntry$Messages$PersistMinutes)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(':')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$class('text-xl w-6'),
									$elm$html$Html$Attributes$class('text-center cursor-pointer'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'minutes-input'),
									$elm$html$Html$Attributes$value(minutes),
									$elm$html$Html$Events$onInput($author$project$FeeEntry$Messages$SetMinutes),
									$elm$html$Html$Events$onBlur($author$project$FeeEntry$Messages$PersistMinutes)
								]),
							_List_Nil)
						]))
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-12 text-center text-xl align-middle')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(durationInput._) + (':' + $elm$core$String$fromInt(durationInput.aF)))
				]));
	});
var $author$project$FeeEntry$View$minutesInputSelector = F3(
	function (editable, fee, minutesPerUnit) {
		var minutesInput = A2($author$project$Components$DurationInput$DurationInputLogic$getHoursAndMinutes, fee.jP, minutesPerUnit);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
							A2($author$project$Components$DurationInput$View$view, editable, minutesInput))
						]))
				]));
	});
var $author$project$FeeEntry$Messages$PersistFeeViaUnitField = function (a) {
	return {$: 38, a: a};
};
var $author$project$FeeEntry$Messages$UnitInputFocused = function (a) {
	return {$: 42, a: a};
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Components$UnitsInput$unitsInput = F3(
	function (editable, fee, unitSaver) {
		var unitsStr = $elm$core$String$fromFloat(fee.jP);
		return editable ? A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('number'),
					$elm$html$Html$Attributes$class('w-18 h-10 py-2'),
					$elm$html$Html$Attributes$class('text-center text-xl cursor-pointer'),
					$elm$html$Html$Attributes$class('rounded-lg text-mt-grey-dark border-solid border border-mt-grey-lighter'),
					$elm$html$Html$Attributes$class('hover:bg-mt-purple-lightest'),
					$elm$html$Html$Attributes$class('focus:border-mt-purple'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'unit-input'),
					$elm$html$Html$Attributes$min('0'),
					$elm$html$Html$Attributes$max('99'),
					$elm$html$Html$Attributes$step('any'),
					$elm$html$Html$Attributes$value(unitsStr),
					$author$project$OnChange$onChange(unitSaver),
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$TimesheetPage$Messages$FeeFormEdit,
						fee.aC,
						$author$project$FeeEntry$Messages$UnitInputFocused(fee.aC)))
				]),
			_List_Nil) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-12 text-center text-xl align-middle')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromFloat(fee.jP))
				]));
	});
var $author$project$FeeEntry$View$unitsInputSelector = F2(
	function (editable, fee) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-row items-center text')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Components$UnitsInput$unitsInput,
							editable,
							fee,
							A2(
								$elm$core$Basics$composeR,
								$author$project$FeeEntry$Messages$PersistFeeViaUnitField,
								$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC)))
						]))
				]));
	});
var $author$project$Model$Fee$FeeForm = 1;
var $author$project$TimesheetPage$Messages$StopFeeTimer = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $elm$core$Basics$cos = _Basics_cos;
var $author$project$Components$TimerRenderer$fractionalRatio = F2(
	function (seconds, secondsPerUnit) {
		return A2($elm$core$Basics$modBy, secondsPerUnit, seconds) / secondsPerUnit;
	});
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$sin = _Basics_sin;
var $author$project$Components$TimerRenderer$coordinatesFor = F2(
	function (sec, secondsPerUnit) {
		var ratio = A2($author$project$Components$TimerRenderer$fractionalRatio, sec, secondsPerUnit);
		var x = ($elm$core$Basics$sin((2.0 * $elm$core$Basics$pi) * ratio) * 60) + 60;
		var y = ($elm$core$Basics$cos((2.0 * $elm$core$Basics$pi) * ratio) * (-60)) + 60;
		return _Utils_Tuple2(x, y);
	});
var $author$project$Components$TimerRenderer$formatFloat = function (x) {
	var wholePart = $elm$core$String$fromInt(
		$elm$core$Basics$floor(x));
	var fractionalPart = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			function (a) {
				return A2(
					F2(
						function (dividend, modulus) {
							return A2($elm$core$Basics$modBy, modulus, dividend);
						}),
					a,
					100);
			}(
				$elm$core$Basics$round(100.0 * x))));
	return wholePart + ('.' + fractionalPart);
};
var $author$project$Components$TimerRenderer$coordsForSecond = F2(
	function (sec, secondsPerUnit) {
		var _v0 = A2($author$project$Components$TimerRenderer$coordinatesFor, sec, secondsPerUnit);
		var x = _v0.a;
		var y = _v0.b;
		return $author$project$Components$TimerRenderer$formatFloat(x) + (' ' + $author$project$Components$TimerRenderer$formatFloat(y));
	});
var $author$project$Components$TimerRenderer$minutesToSeconds = function (minutesPerUnit) {
	return minutesPerUnit * 60;
};
var $author$project$Components$TimerRenderer$sweepFlags = F2(
	function (sec, secondsPerUnit) {
		return (A2($author$project$Components$TimerRenderer$fractionalRatio, sec, secondsPerUnit) <= 0.5) ? '0, 1' : '1, 1';
	});
var $author$project$Components$TimerRenderer$computeElapsedPath = F2(
	function (seconds, minutesPerUnit) {
		var secondsPerUnit = $author$project$Components$TimerRenderer$minutesToSeconds(minutesPerUnit);
		var secondsCoords = A2($author$project$Components$TimerRenderer$coordsForSecond, seconds, secondsPerUnit);
		var arcFlags = A2($author$project$Components$TimerRenderer$sweepFlags, seconds, secondsPerUnit);
		return 'M 60 60 L 60 0 A 60 60, 0, ' + (arcFlags + (', ' + (secondsCoords + ' L 60 60')));
	});
var $author$project$Components$TimerRenderer$computeRotation = F2(
	function (seconds, secondsPerUnit) {
		var currentLapSoFar = A2($elm$core$Basics$modBy, secondsPerUnit, seconds);
		var circleDegrees = 360.0;
		var degreesPerSecond = circleDegrees / secondsPerUnit;
		return currentLapSoFar * degreesPerSecond;
	});
var $author$project$Components$TimerRenderer$rotateGradation = F2(
	function (seconds, secondsPerUnit) {
		var rotation = $author$project$Components$TimerRenderer$formatFloat(
			A2($author$project$Components$TimerRenderer$computeRotation, seconds, secondsPerUnit));
		return 'rotate(' + (rotation + ', 60, 60)');
	});
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$stopOpacity = _VirtualDom_attribute('stop-opacity');
var $author$project$Components$TimerRenderer$timerStrokeColour = function (sec) {
	return (!A2($elm$core$Basics$modBy, 2, sec)) ? '#2BEEA6' : '#94F7D4';
};
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Components$TimerRenderer$timerGradient = function (sec) {
	return A2(
		$elm$svg$Svg$linearGradient,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('timer-gradient'),
				$elm$svg$Svg$Attributes$x1('0%'),
				$elm$svg$Svg$Attributes$y1('0%'),
				$elm$svg$Svg$Attributes$x2('100%'),
				$elm$svg$Svg$Attributes$y2('50%')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$stop,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$offset('0%'),
						$elm$svg$Svg$Attributes$stopColor(
						$author$project$Components$TimerRenderer$timerStrokeColour(sec)),
						$elm$svg$Svg$Attributes$stopOpacity('1')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$stop,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$offset('20%'),
						$elm$svg$Svg$Attributes$stopColor(
						$author$project$Components$TimerRenderer$timerStrokeColour(sec)),
						$elm$svg$Svg$Attributes$stopOpacity('1')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$stop,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$offset('60%'),
						$elm$svg$Svg$Attributes$stopColor(
						$author$project$Components$TimerRenderer$timerStrokeColour(sec)),
						$elm$svg$Svg$Attributes$stopOpacity('0')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$TimerRenderer$renderTimer = F2(
	function (seconds, minutesPerUnit) {
		var secondsPerUnit = $author$project$Components$TimerRenderer$minutesToSeconds(minutesPerUnit);
		var secondsCoords = A2($author$project$Components$TimerRenderer$coordsForSecond, seconds, secondsPerUnit);
		var gradientSlice = 'M 60 60 L 60 0 A 60 60, 0, 0, 1, ' + (secondsCoords + ' L 60 60 ');
		var elapsedPath = A2($author$project$Components$TimerRenderer$computeElapsedPath, seconds, minutesPerUnit);
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 120 120'),
					$elm$svg$Svg$Attributes$class('timer-wheel')
				]),
			_List_fromArray(
				[
					$author$project$Components$TimerRenderer$timerGradient(seconds),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d(elapsedPath),
							$elm$svg$Svg$Attributes$stroke(
							$author$project$Components$TimerRenderer$timerStrokeColour(seconds)),
							$elm$svg$Svg$Attributes$fill(
							$author$project$Components$TimerRenderer$timerStrokeColour(seconds))
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d(gradientSlice),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('url(#timer-gradient)'),
							$elm$svg$Svg$Attributes$transform(
							A2($author$project$Components$TimerRenderer$rotateGradation, seconds, secondsPerUnit))
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Timer$timerView = F5(
	function (fee, stopTimerMsg, units, secondsElapsed, minutesPerUnit) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timer'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'timer')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$TimerRenderer$renderTimer, secondsElapsed, minutesPerUnit),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('face')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('timer-ui stop timer-button'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'timer-stop-button'),
									$elm$html$Html$Events$onClick(stopTimerMsg)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('units w-18 text-center text-xl align-middle')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromFloat(units))
								]))
						]))
				]));
	});
var $author$project$FeeEntry$View$unitsWithRunningTimer = F3(
	function (fee, timerUnits, minutesPerUnit) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-row items-center text mt-4 mb-2 -ml-2')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Components$Timer$timerView,
					fee,
					A2($author$project$TimesheetPage$Messages$StopFeeTimer, fee, 1),
					timerUnits.jP,
					timerUnits.iF,
					minutesPerUnit)
				]));
	});
var $author$project$FeeEntry$View$unitsAndTimerSelector = F3(
	function (editable, fee, minutesPerUnit) {
		var _v0 = A2($author$project$FeeTimerLogic$getUnitsAndPartialUnitSeconds, minutesPerUnit, fee);
		if (!_v0.$) {
			var timerUnits = _v0.a;
			return A3($author$project$FeeEntry$View$unitsWithRunningTimer, fee, timerUnits, minutesPerUnit);
		} else {
			return fee.iQ ? A3($author$project$FeeEntry$View$minutesInputSelector, editable, fee, minutesPerUnit) : A3($elm$html$Html$Lazy$lazy2, $author$project$FeeEntry$View$unitsInputSelector, editable, fee);
		}
	});
var $author$project$FeeEntry$Messages$Decrement = 1;
var $author$project$FeeEntry$Messages$Increment = 0;
var $author$project$FeeEntry$Messages$UpdateMinute = function (a) {
	return {$: 45, a: a};
};
var $author$project$Components$DurationInput$IncrementDecrement$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('inline-flex mr-2 items-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center justify-center hover:bg-mt-blue-light'),
					$elm$html$Html$Attributes$class('hover:text-white font-semibold px-3.5 pb-2.5 h-10 text-3xl'),
					$elm$html$Html$Attributes$class('font-base border rounded-4 text-mt-blue-light border-mt-blue-light mr-2'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'increment-button'),
					$elm$html$Html$Events$onClick(
					$author$project$FeeEntry$Messages$UpdateMinute(0))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('+')
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center justify-center hover:bg-mt-blue-light leading-10'),
					$elm$html$Html$Attributes$class('hover:text-white font-semibold px-2 pb-3 h-10 text-3xl'),
					$elm$html$Html$Attributes$class('font-base border rounded-4 text-mt-blue-light border-mt-blue-light'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'decrement-button'),
					$elm$html$Html$Events$onClick(
					$author$project$FeeEntry$Messages$UpdateMinute(1))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('—')
				]))
		]));
var $author$project$FeeEntry$View$FilingStatus$isInFlight = function (filingStatus) {
	return _Utils_eq(filingStatus.dG, $author$project$Activities$Model$FilingStatus$Filing);
};
var $author$project$FeeEntry$Messages$ToggleFilingMenu = function (a) {
	return {$: 20, a: a};
};
var $author$project$FeeEntry$Messages$RetryRename = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$FeeEntry$View$FilingStatus$filedDocumentUrl = F2(
	function (context, filingStatus) {
		return A3($elm$core$Maybe$map2, $elm$core$Basics$append, context.di, filingStatus.gR);
	});
var $author$project$FeeEntry$View$FilingStatus$documentUrl = F2(
	function (context, filingStatus) {
		var _v0 = filingStatus.dG;
		switch (_v0.$) {
			case 0:
				return A2($author$project$FeeEntry$View$FilingStatus$filedDocumentUrl, context, filingStatus);
			case 4:
				return A2($author$project$FeeEntry$View$FilingStatus$filedDocumentUrl, context, filingStatus);
			case 5:
				return A2($author$project$FeeEntry$View$FilingStatus$filedDocumentUrl, context, filingStatus);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$FeeEntry$View$FilingStatus$menuLink = function (link) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pb-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					link.a8,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$rel('noopener noreferrer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('group flex justify-between items-center w-full py-6 md:py-2 px-4 text-lg md:text-sm text-left text-black border-b border-mt-purple-light md:border-none hover:bg-mt-purple-lightest hover:text-mt-grey-darker hover:border-0'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', link.c6),
							$elm$html$Html$Attributes$href(link.jR)
						])),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('align-middle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(link.fk)
							])),
						link.bN
					]))
			]));
};
var $author$project$Icons$ExternalLink$path = 'M14 4h6v6 M20 4l-8 8 M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5';
var $author$project$Icons$ExternalLink$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d($author$project$Icons$ExternalLink$path),
						$elm$svg$Svg$Attributes$class('stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1.8'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$FeeEntry$View$FilingStatus$documentLink = F2(
	function (context, filingStatus) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (dmsName, url) {
					return $author$project$FeeEntry$View$FilingStatus$menuLink(
						{
							c6: 'view-in-dms',
							bN: $author$project$Icons$ExternalLink$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('w-4 h-4')
									])),
							a8: true,
							fk: 'View email in ' + dmsName,
							jR: url
						});
				}),
			context.gF,
			A2($author$project$FeeEntry$View$FilingStatus$documentUrl, context, filingStatus));
	});
var $author$project$FeeEntry$View$FilingStatus$matterUrl = F2(
	function (context, filingStatus) {
		var _v0 = A3($elm$core$Maybe$map2, $elm$core$Basics$append, context.fw, filingStatus.jZ);
		if (!_v0.$) {
			var url = _v0.a;
			return $elm$core$Maybe$Just(url);
		} else {
			return A3($elm$core$Maybe$map2, $elm$core$Basics$append, context.dM, filingStatus.hb);
		}
	});
var $author$project$FeeEntry$View$FilingStatus$matterLink = F2(
	function (context, filingStatus) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (dmsName, url) {
					return $author$project$FeeEntry$View$FilingStatus$menuLink(
						{
							c6: 'view-matter-in-dms',
							bN: $author$project$Icons$ExternalLink$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('w-4 h-4')
									])),
							a8: true,
							fk: 'View matter in ' + dmsName,
							jR: url
						});
				}),
			context.gF,
			A2($author$project$FeeEntry$View$FilingStatus$matterUrl, context, filingStatus));
	});
var $author$project$FeeEntry$Messages$OpenSubjectEditor = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$FeeEntry$View$FilingStatus$openEditorMsg = function (context) {
	return A2(
		$author$project$TimesheetPage$Messages$FeeFormEdit,
		context.g_,
		A2($author$project$FeeEntry$Messages$OpenSubjectEditor, context.fc, context.cB));
};
var $author$project$Icons$FiledDocument$path = 'M6 3h8l4 4v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z M14 3v5h4 M9 13h6 M9 17h6';
var $author$project$Icons$FiledDocument$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d($author$project$Icons$FiledDocument$path),
						$elm$svg$Svg$Attributes$class('stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1.8'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$Refresh$arcs = 'M20 11a8 8 0 0 0-13.7-5.7L3 8.5 M4 13a8 8 0 0 0 13.7 5.7L21 15.5';
var $author$project$Icons$Refresh$tips = 'M3 4v4.5h4.5 M21 20v-4.5h-4.5';
var $author$project$Icons$Refresh$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d($author$project$Icons$Refresh$arcs),
						$elm$svg$Svg$Attributes$class('stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1.8'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d($author$project$Icons$Refresh$tips),
						$elm$svg$Svg$Attributes$class('stroke-current'),
						$elm$svg$Svg$Attributes$strokeWidth('1.8'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$FeeEntry$View$FilingStatus$menuOptions = F2(
	function (context, filingStatus) {
		return A2(
			$author$project$CoreX$Appendable$andAppendMaybe,
			A2($author$project$FeeEntry$View$FilingStatus$matterLink, context, filingStatus),
			A2(
				$author$project$CoreX$Appendable$andAppendMaybe,
				A2($author$project$FeeEntry$View$FilingStatus$documentLink, context, filingStatus),
				A2(
					$author$project$CoreX$Appendable$andAppend,
					_List_fromArray(
						[
							$author$project$FeeEntry$View$FilingStatus$menuLink(
							{
								c6: 'filed-documents',
								bN: $author$project$Icons$FiledDocument$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('w-4 h-4')
										])),
								a8: false,
								fk: 'Filed Documents',
								jR: '/filing_statuses'
							})
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						context.f4,
						_List_fromArray(
							[
								$author$project$Components$Dropdown$dropdownButton(
								{
									gc: $author$project$FeeEntry$View$FilingStatus$openEditorMsg(context),
									c6: 'rename-subject',
									bN: $elm$core$Maybe$Just(
										$author$project$Icons$Pencil$viewWithAttributes(
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('w-4 h-4')
												]))),
									fk: 'Rename'
								})
							]),
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							_Utils_eq(filingStatus.dG, $author$project$Activities$Model$FilingStatus$RenameFailed),
							_List_fromArray(
								[
									$author$project$Components$Dropdown$dropdownButton(
									{
										gc: A2(
											$author$project$TimesheetPage$Messages$FeeFormEdit,
											context.g_,
											A2($author$project$FeeEntry$Messages$RetryRename, context.fc, context.cB)),
										c6: 'retry-rename',
										bN: $elm$core$Maybe$Just(
											$author$project$Icons$Refresh$viewWithAttributes(
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('w-4 h-4')
													]))),
										fk: 'Retry rename'
									})
								]),
							_List_Nil)))));
	});
var $author$project$FeeEntry$View$FilingStatus$menu = F2(
	function (context, filingStatus) {
		var trigger = $author$project$Icons$DropdownArrow$viewWithAttributes(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('h-3 w-3 cursor-pointer'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'filing-status-menu')
				]));
		return $author$project$Components$Dropdown$view(
			{
				ge: A2(
					$author$project$TimesheetPage$Messages$FeeFormEdit,
					context.g_,
					$author$project$FeeEntry$Messages$ToggleFilingMenu($elm$core$Maybe$Nothing)),
				bN: trigger,
				aC: 'filing-status-menu-' + $elm$core$String$fromInt(context.fc),
				hJ: context.hI,
				iu: A2(
					$author$project$TimesheetPage$Messages$FeeFormEdit,
					context.g_,
					$author$project$FeeEntry$Messages$ToggleFilingMenu(
						$elm$core$Maybe$Just(context.fc))),
				iv: 1,
				iw: A2($author$project$FeeEntry$View$FilingStatus$menuOptions, context, filingStatus)
			});
	});
var $author$project$Components$SearchInput$SearchInputSelectors$FileEmailSelector = 4;
var $author$project$FeeEntry$View$FilingStatus$statusClasses = function (filedStatus) {
	switch (filedStatus.$) {
		case 2:
			return 'bg-mt-blue-lightest text-mt-blue';
		case 3:
			return 'bg-mt-yellow-lighter text-mt-amber-darker';
		case 0:
			return 'bg-mt-green-lighter text-mt-green-darker';
		case 4:
			return 'bg-mt-yellow-lighter text-mt-amber-darker';
		case 5:
			return 'bg-mt-red-lightest text-mt-red';
		case 1:
			return 'bg-mt-red-lightest text-mt-red';
		case 7:
			return 'bg-mt-grey-lightest text-mt-grey-dark';
		default:
			return 'bg-mt-blue-lightest text-mt-blue';
	}
};
var $author$project$FeeEntry$View$FilingStatus$statusLabel = F2(
	function (context, filedStatus) {
		switch (filedStatus.$) {
			case 2:
				return context.iJ + ' Filing Scheduled';
			case 3:
				return 'Filing ' + context.iJ;
			case 0:
				return context.iJ + ' Filed';
			case 4:
				return context.iJ + ' Filed';
			case 5:
				return 'Failed to rename subject';
			case 1:
				return context.iJ + ' can\'t be filed';
			case 7:
				return context.iJ + ' filing cancelled';
			default:
				return 'Failed to find matter in library';
		}
	});
var $author$project$FeeEntry$View$FilingStatus$dmsLabel = function (context) {
	return A2($elm$core$Maybe$withDefault, 'the document system', context.gF);
};
var $ryan_haskell$date_format$DateFormat$MinuteNumber = {$: 30};
var $ryan_haskell$date_format$DateFormat$minuteNumber = $ryan_haskell$date_format$DateFormat$MinuteNumber;
var $author$project$CoreX$DateFormat$toFriendlyFormatDateTime = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
			$ryan_haskell$date_format$DateFormat$text(', '),
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text(' at '),
			$ryan_haskell$date_format$DateFormat$hourNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteNumber,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$amPmLowercase
		]));
var $author$project$FeeEntry$View$FilingStatus$statusTooltip = F2(
	function (context, filedStatus) {
		switch (filedStatus.$) {
			case 2:
				var scheduledAt = filedStatus.a;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'Scheduled to file at',
							A2($author$project$CoreX$DateFormat$to12HourTimeString, context.fA, scheduledAt)
						]));
			case 3:
				return 'Filing in progress';
			case 0:
				var updatedAt = filedStatus.a;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'Filed',
							A2($author$project$CoreX$DateFormat$toFriendlyFormatDateTime, context.fA, updatedAt)
						]));
			case 4:
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'Filed. Updating the subject in',
							$author$project$FeeEntry$View$FilingStatus$dmsLabel(context)
						]));
			case 5:
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							context.iJ + ' is filed, but the subject could not be updated in',
							$author$project$FeeEntry$View$FilingStatus$dmsLabel(context) + '. Try again.'
						]));
			case 1:
				var failReason = filedStatus.a;
				return A2(
					$elm$core$String$join,
					'. ',
					_List_fromArray(
						['Issue filing email', failReason]));
			case 7:
				return 'Filing email was cancelled';
			default:
				return 'Please select a library';
		}
	});
var $author$project$FeeEntry$View$FilingStatus$statusStyle = F2(
	function (context, filedStatus) {
		return {
			ay: $author$project$FeeEntry$View$FilingStatus$statusClasses(filedStatus),
			ec: A2($author$project$FeeEntry$View$FilingStatus$statusLabel, context, filedStatus),
			aK: A2($author$project$FeeEntry$View$FilingStatus$statusTooltip, context, filedStatus)
		};
	});
var $author$project$FeeEntry$View$FilingStatus$selectionRequiredView = function (context) {
	var style = A2($author$project$FeeEntry$View$FilingStatus$statusStyle, context, $author$project$Activities$Model$FilingStatus$SelectionRequired);
	var isFileEmailSelector = function () {
		var _v0 = context.ck;
		if ((_v0.$ === 1) && (_v0.a === 4)) {
			var _v1 = _v0.a;
			return true;
		} else {
			return false;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative w-full'),
				$elm$html$Html$Events$onClick(
				A2(
					$author$project$TimesheetPage$Messages$FeeFormEdit,
					context.g_,
					$author$project$FeeEntry$Messages$OpenSearchInput(4)))
			]),
		A3(
			$author$project$CoreX$Appendable$andAppendIf,
			isFileEmailSelector,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-light'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'file-email-selector')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$TimesheetPage$Messages$FeeFormEdit(context.g_),
							A3($author$project$Components$SearchInput$Views$ShowMode$editMode, 4, $elm$core$Maybe$Nothing, context.ck))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center gap-2 w-full max-w-72 mt-1 px-2 py-1 rounded cursor-pointer'),
							$elm$html$Html$Attributes$class(style.ay),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'filing-status-bar'),
							$elm$html$Html$Attributes$title(style.aK)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xs font-semibold truncate')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(style.ec)
								]))
						]))
				])));
};
var $author$project$Icons$FileWarning$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM13.2 18H10.8V15.6H13.2V18ZM13.2 13.2H10.8V6H13.2V13.2Z'),
						$elm$svg$Svg$Attributes$fill('#FF3D5E')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$FileWarning$view = $author$project$Icons$FileWarning$viewWithAttributes(_List_Nil);
var $author$project$Icons$Filing$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('12'),
						$elm$svg$Svg$Attributes$cy('12'),
						$elm$svg$Svg$Attributes$r('12'),
						$elm$svg$Svg$Attributes$fill('#FF9900')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.1364 6.27273V9.13636L15.9545 5.31818L12.1364 1.5V4.36364C7.91727 4.36364 4.5 7.78091 4.5 12C4.5 13.4986 4.93909 14.8923 5.68364 16.0664L7.07727 14.6727C6.64773 13.8805 6.40909 12.9641 6.40909 12C6.40909 8.84045 8.97682 6.27273 12.1364 6.27273ZM18.5891 7.93364L17.1955 9.32727C17.6155 10.1291 17.8636 11.0359 17.8636 12C17.8636 15.1595 15.2959 17.7273 12.1364 17.7273V14.8636L8.31818 18.6818L12.1364 22.5V19.6364C16.3555 19.6364 19.7727 16.2191 19.7727 12C19.7727 10.5014 19.3336 9.10773 18.5891 7.93364Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$Filing$view = $author$project$Icons$Filing$viewWithAttributes(_List_Nil);
var $author$project$Icons$Clock$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('12'),
						$elm$svg$Svg$Attributes$cy('12'),
						$elm$svg$Svg$Attributes$r('12'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 6.5V12L15.75 14.25'),
						$elm$svg$Svg$Attributes$stroke('white'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$FeeEntry$View$FilingStatus$statusIcon = function (filedStatus) {
	switch (filedStatus.$) {
		case 2:
			return $author$project$Icons$Clock$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('text-mt-blue')
					]));
		case 3:
			return $author$project$Icons$Filing$view;
		case 4:
			return $author$project$Icons$Filing$view;
		case 5:
			return $author$project$Icons$FileWarning$view;
		case 1:
			return $author$project$Icons$FileWarning$view;
		case 0:
			return $author$project$Icons$Tick$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('bg-mt-green-dark fill-white stroke-4 stroke-white rounded-full')
					]));
		case 7:
			return $author$project$Icons$CloseCross$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('bg-mt-grey-light fill-white stroke-4 stroke-white rounded-full p-2px')
					]));
		default:
			return $author$project$Icons$CloseCross$viewWithAttributes(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('bg-mt-grey-light fill-white stroke-4 stroke-white rounded-full p-2px')
					]));
	}
};
var $author$project$FeeEntry$View$FilingStatus$bar = F2(
	function (context, filingStatus) {
		var _v0 = filingStatus.dG;
		if (_v0.$ === 6) {
			return $author$project$FeeEntry$View$FilingStatus$selectionRequiredView(context);
		} else {
			var filedStatus = _v0;
			var style = A2($author$project$FeeEntry$View$FilingStatus$statusStyle, context, filedStatus);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center gap-2 w-full max-w-72 mt-1 px-2 py-1 rounded'),
						$elm$html$Html$Attributes$class(style.ay),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'filing-status-bar'),
						$elm$html$Html$Attributes$title(style.aK)
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					!$author$project$FeeEntry$View$FilingStatus$isInFlight(filingStatus),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-auto')
								]),
							_List_fromArray(
								[
									A2($author$project$FeeEntry$View$FilingStatus$menu, context, filingStatus)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-4 h-4 shrink-0')
								]),
							_List_fromArray(
								[
									$author$project$FeeEntry$View$FilingStatus$statusIcon(filingStatus.dG)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xs font-semibold truncate')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(style.ec)
								]))
						])));
		}
	});
var $author$project$FeeEntry$Messages$OpenContactSelector = {$: 30};
var $author$project$FeeEntry$View$FeeActivityView$contactView = F2(
	function (fee, hasFiledEmail) {
		var _v0 = $author$project$Timesheet$FeeLogic$contactFromFee(fee);
		if (!_v0.$) {
			var contact = _v0.a;
			var editable = $author$project$Timesheet$FeeLogic$isEditable(fee);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('mt-0', !hasFiledEmail),
								_Utils_Tuple2('-mt-1', hasFiledEmail)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-block text-xxxs w-8')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Contact:')
							])),
						A2(
						$elm$html$Html$div,
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							editable,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cursor-pointer hover:text-mt-purple'),
									$elm$html$Html$Attributes$tabindex(0),
									$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$FeeEntry$Messages$OpenContactSelector),
									$elm$html$Html$Events$onClick($author$project$FeeEntry$Messages$OpenContactSelector)
								]),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-block pl-1 text-xs'),
									$elm$html$Html$Attributes$class('focus:bg-mt-purple-lightest focus:border-mt-purple rounded-4'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'open-contact-selector'),
									$elm$html$Html$Attributes$title(contact.b2)
								])),
						editable ? _List_fromArray(
							[
								$elm$html$Html$text(contact.b2),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-xs text-mt-purple')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(' (change)')
									]))
							]) : _List_fromArray(
							[
								$elm$html$Html$text(contact.b2)
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('mt-0', !hasFiledEmail),
								_Utils_Tuple2('-mt-1', hasFiledEmail)
							])),
						$elm$html$Html$Attributes$class('mx-0 text-xxxs font-normal')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No Contact')
					]));
		}
	});
var $author$project$FeeEntry$View$FeeActivityView$commonDurationView = function (duration) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('-mt-1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block text-xxxs w-8')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Duration:')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block pl-1 text-xs')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$CoreX$DateFormat$formatDuration(duration))
					]))
			]));
};
var $author$project$FeeEntry$View$FeeActivityView$documentDuration = F2(
	function (event, doc) {
		if ($author$project$Activities$Model$Event$isTitan(doc)) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pl-1 text-xs')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$CoreX$DateFormat$formatDuration(doc.X))
					]));
		} else {
			switch (event) {
				case 0:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1 text-xs')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('N/A')
							]));
				case 1:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1 text-xs')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$CoreX$DateFormat$formatDuration(doc.X))
							]));
				default:
					return $elm$html$Html$text('');
			}
		}
	});
var $author$project$FeeEntry$View$FeeActivityView$documentStatus = F2(
	function (event, doc) {
		if ($author$project$Activities$Model$Event$isTitan(doc)) {
			return 'Drafting';
		} else {
			var _v0 = _Utils_Tuple2(doc.jb, event);
			if (!_v0.a) {
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return 'Drafting';
					case 1:
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return 'Drafting';
					default:
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return 'Reading';
				}
			} else {
				switch (_v0.b) {
					case 0:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return 'Checked Out';
					case 1:
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return 'Checked Out -> Checked In';
					default:
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return 'Reading';
				}
			}
		}
	});
var $author$project$FeeEntry$View$FeeActivityView$eventView = function (event) {
	switch (event.$) {
		case 3:
			var email = event.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('-mt-1')
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendMaybeRun,
					email.X,
					$author$project$FeeEntry$View$FeeActivityView$commonDurationView,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-block text-xxxs w-8')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Body:')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-block pl-1 text-xs'),
									$elm$html$Html$Attributes$title(email.fW)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(email.fW)
								]))
						])));
		case 4:
			var phone = event.a;
			return $author$project$FeeEntry$View$FeeActivityView$commonDurationView(phone.X);
		case 1:
			var _v1 = event.a;
			var phone = event.b;
			return $author$project$FeeEntry$View$FeeActivityView$commonDurationView(phone.X);
		case 0:
			var appt = event.a;
			return $author$project$FeeEntry$View$FeeActivityView$commonDurationView(appt.X);
		case 2:
			var evt = event.a;
			var doc = event.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('-mt-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-block text-xxxs w-8')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Event:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-block pl-1 text-xs')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$FeeEntry$View$FeeActivityView$documentStatus, evt, doc))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('-mt-1')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-xxxs w-8')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Duration:')
									])),
								A2($author$project$FeeEntry$View$FeeActivityView$documentDuration, evt, doc)
							]))
					]));
		default:
			var act = event.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('-mt-1 flex flex-row gap-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xxxs')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Duration:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1 text-xs')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$CoreX$DateFormat$formatDuration(
									A2($elm$core$Maybe$withDefault, 0, act.X)))
							]))
					]));
	}
};
var $author$project$FeeEntry$View$FeeActivityView$canRename = F3(
	function (filingUser, fee, filingStatus) {
		var isFiled = function () {
			var _v1 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dG;
				},
				filingStatus);
			_v1$3:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 0:
							return true;
						case 4:
							var _v2 = _v1.a;
							return true;
						case 5:
							var _v3 = _v1.a;
							return true;
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return false;
		}();
		var isEmail = function () {
			var _v0 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.i;
				},
				fee.fG);
			if ((!_v0.$) && (_v0.a.$ === 3)) {
				return true;
			} else {
				return false;
			}
		}();
		var inFlight = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$FeeEntry$View$FilingStatus$isInFlight, filingStatus));
		return isEmail && ((!inFlight) && ((!isFiled) || filingUser.f5));
	});
var $author$project$FeeEntry$View$FeeActivityView$filingContext = F7(
	function (zone, searchInput, filingUser, fee, subjectFee, subject, filingStatus) {
		return {
			f4: A3($author$project$FeeEntry$View$FeeActivityView$canRename, filingUser, subjectFee, filingStatus),
			gF: filingUser.gF,
			di: filingUser.di,
			g_: fee.aC,
			dM: filingUser.dM,
			hI: _Utils_eq(
				fee.cb,
				$elm$core$Maybe$Just(subjectFee.aC)),
			iJ: 'Email',
			ck: searchInput,
			cB: subject,
			fc: subjectFee.aC,
			fw: filingUser.fw,
			fA: zone
		};
	});
var $author$project$Activities$ActivityLogic$getTitleLabel = function (activity) {
	var _v0 = activity.i;
	switch (_v0.$) {
		case 1:
			var _v1 = _v0.a;
			return 'Meeting:';
		case 3:
			return 'Subject:';
		case 4:
			return 'Phoned:';
		case 0:
			return 'Subject:';
		case 2:
			return 'File name:';
		default:
			return 'Title:';
	}
};
var $author$project$Activities$ActivityLogic$hasFilingStatus = function (activity) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		$author$project$Activities$ActivityLogic$getFilingStatus(activity.i));
};
var $author$project$FeeEntry$View$FeeActivityView$contentView = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full place-self-start col-start-2 md:col-start-auto col-span-2 md:col-span-4 flex items-center text-xs text-mt-grey mb-2')
			]),
		children);
};
var $author$project$FeeEntry$View$FeeActivityView$iconlessView = function (otherView) {
	return $author$project$FeeEntry$View$FeeActivityView$contentView(
		_List_fromArray(
			[
				A2($elm$html$Html$div, _List_Nil, otherView)
			]));
};
var $author$project$FeeEntry$Messages$CancelSubjectEdit = {$: 19};
var $author$project$FeeEntry$Messages$EditSubject = function (a) {
	return {$: 16, a: a};
};
var $author$project$FeeEntry$Messages$SaveSubject = {$: 17};
var $author$project$FeeEntry$View$FilingStatus$editorView = F2(
	function (feeId, currentValue) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-2 mt-1'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'subject-editor')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-52 text-xs bg-white border border-mt-grey-light rounded px-2 py-1'),
							$elm$html$Html$Attributes$class('focus:border-mt-purple inputfocus'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'edit-subject-input'),
							$elm$html$Html$Attributes$value(currentValue),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$TimesheetPage$Messages$FeeFormEdit(feeId),
								$author$project$FeeEntry$Messages$EditSubject)),
							$elm_community$html_extra$Html$Events$Extra$onEnter(
							A2($author$project$TimesheetPage$Messages$FeeFormEdit, feeId, $author$project$FeeEntry$Messages$SaveSubject))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-3 py-1 text-xs rounded bg-mt-grey-darker text-white'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'save-subject'),
							$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
							A2($author$project$TimesheetPage$Messages$FeeFormEdit, feeId, $author$project$FeeEntry$Messages$SaveSubject))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Rename')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-3 py-1 text-xs rounded border border-mt-grey-light'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'cancel-subject'),
							$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
							A2($author$project$TimesheetPage$Messages$FeeFormEdit, feeId, $author$project$FeeEntry$Messages$CancelSubjectEdit))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel')
						]))
				]));
	});
var $author$project$FeeEntry$View$FeeActivityView$subjectEditorView = F2(
	function (context, fee) {
		var _v0 = fee.ad;
		if (!_v0.$) {
			var editor = _v0.a;
			return _Utils_eq(editor.g_, context.fc) ? A2($author$project$FeeEntry$View$FilingStatus$editorView, context.g_, editor.af) : $elm_community$html_extra$Html$Extra$nothing;
		} else {
			return $elm_community$html_extra$Html$Extra$nothing;
		}
	});
var $elm_community$html_extra$Html$Extra$viewMaybe = F2(
	function (fn, maybeThing) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm_community$html_extra$Html$Extra$nothing,
			A2($elm$core$Maybe$map, fn, maybeThing));
	});
var $author$project$FeeEntry$View$FeeActivityView$activityView = F6(
	function (zone, searchInput, libraries, filingUser, fee, activity) {
		var hasFiledEmail = $author$project$Activities$ActivityLogic$hasFilingStatus(activity);
		var filingStatus = $author$project$Activities$ActivityLogic$getFilingStatus(activity.i);
		var activityTitle = $author$project$Activities$ActivityLogic$getTitle(activity);
		var context = A7($author$project$FeeEntry$View$FeeActivityView$filingContext, zone, searchInput, filingUser, fee, fee, activityTitle, filingStatus);
		return $author$project$FeeEntry$View$FeeActivityView$iconlessView(
			_List_fromArray(
				[
					function () {
					var _v0 = activity.i;
					switch (_v0.$) {
						case 2:
							return $elm$html$Html$text('');
						case 5:
							var act = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('max-w-72 flex flex-row gap-6')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xxxs')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('URL:')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xs truncate'),
												$elm$html$Html$Attributes$title(act.jR)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(act.jR)
											]))
									]));
						default:
							return A2(
								$elm$html$Html$map,
								$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
								A2($author$project$FeeEntry$View$FeeActivityView$contactView, fee, hasFiledEmail));
					}
				}(),
					function () {
					var _v1 = activity.i;
					if (_v1.$ === 5) {
						var act = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('max-w-72 flex flex-col')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('-mt-1 flex flex-row gap-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-xxxs ')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Activities$ActivityLogic$getTitleLabel(activity))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-xs truncate'),
													$elm$html$Html$Attributes$title(activityTitle)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(activityTitle)
												]))
										])),
									$author$project$FeeEntry$View$FeeActivityView$eventView(activity.i)
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('max-w-72 truncate')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('-mt-1')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inline-block text-xxxs w-8')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Activities$ActivityLogic$getTitleLabel(activity))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inline-block pl-1 text-xs'),
													$elm$html$Html$Attributes$title(activityTitle)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(activityTitle)
												]))
										])),
									$author$project$FeeEntry$View$FeeActivityView$eventView(activity.i)
								]));
					}
				}(),
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					$author$project$FeeEntry$View$FilingStatus$bar(context),
					filingStatus),
					A2($author$project$FeeEntry$View$FeeActivityView$subjectEditorView, context, fee)
				]));
	});
var $author$project$FeeEntry$View$FilingStatus$icon = function (filingStatus) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-3 h-3')
			]),
		_List_fromArray(
			[
				$author$project$FeeEntry$View$FilingStatus$statusIcon(filingStatus.dG)
			]));
};
var $author$project$FeeEntry$View$FeeActivityView$filingStatusIcon = function (filingStatus) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute top-0 right-0')
			]),
		_List_fromArray(
			[
				$author$project$FeeEntry$View$FilingStatus$icon(filingStatus)
			]));
};
var $author$project$FeeEntry$View$FeeActivityView$commonView = F3(
	function (iconView, filingStatus, otherView) {
		return $author$project$FeeEntry$View$FeeActivityView$contentView(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-8 w-8 relative text-mt-purple')
						]),
					_List_fromArray(
						[
							iconView,
							A2($elm_community$html_extra$Html$Extra$viewMaybe, $author$project$FeeEntry$View$FeeActivityView$filingStatusIcon, filingStatus)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					otherView)
				]));
	});
var $author$project$FeeEntry$View$FeeActivityView$summaryLabel = F2(
	function (filedStatus, count) {
		var emails = (count === 1) ? '1 Email' : ($elm$core$String$fromInt(count) + ' Emails');
		switch (filedStatus.$) {
			case 2:
				return emails + ' Filing Scheduled';
			case 3:
				return 'Filing ' + emails;
			case 0:
				return emails + ' Filed';
			case 4:
				return emails + ' Filed, renaming';
			case 5:
				return emails + ' failed to rename';
			case 1:
				return emails + ' can\'t be filed';
			case 7:
				return emails + ' filing cancelled';
			default:
				return emails + ' need a library';
		}
	});
var $author$project$FeeEntry$View$FeeActivityView$summaryTooltip = function (filedStatus) {
	switch (filedStatus.$) {
		case 2:
			return 'Scheduled to file. Expand to see each email.';
		case 3:
			return 'Filing in progress';
		case 0:
			return 'Filed. Expand to see each email.';
		case 4:
			return 'Filed. Updating the subject in the document system.';
		case 5:
			return 'Filed, but the subject could not be updated. Expand to retry.';
		case 1:
			return 'Issue filing. Expand to see each email.';
		case 7:
			return 'Filing was cancelled';
		default:
			return 'Please select a library. Expand to see each email.';
	}
};
var $author$project$FeeEntry$View$FeeActivityView$consolidatedSummaryBar = function (summary) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center gap-2 w-full max-w-72 ml-4 mt-1 px-2 py-1 rounded cursor-pointer'),
				$elm$html$Html$Attributes$class(
				$author$project$FeeEntry$View$FilingStatus$statusClasses(summary.M)),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'consolidated-fees-open'),
				$elm$html$Html$Attributes$title(
				$author$project$FeeEntry$View$FeeActivityView$summaryTooltip(summary.M)),
				$elm$html$Html$Events$onClick(
				A2(
					$author$project$TimesheetPage$Messages$FeeFormEdit,
					summary.g_,
					$author$project$FeeEntry$Messages$SetConsolidatedFeesOpen(!summary.hJ)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-4 h-4 shrink-0')
					]),
				_List_fromArray(
					[
						$author$project$FeeEntry$View$FilingStatus$statusIcon(summary.M)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-xs font-semibold truncate')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$FeeEntry$View$FeeActivityView$summaryLabel, summary.M, summary.aj))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-auto w-3 h-3 shrink-0'),
						$elm$html$Html$Attributes$title(summary.bw)
					]),
				_List_fromArray(
					[summary.bv]))
			]));
};
var $author$project$Activities$Model$FilingStatus$sorter = function (filingStatus) {
	var _v0 = filingStatus.dG;
	switch (_v0.$) {
		case 0:
			return 4;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		case 4:
			return 2;
		case 5:
			return 1;
		case 7:
			return 5;
		default:
			return 3;
	}
};
var $author$project$FeeEntry$View$FeeActivityView$summaryTieBreak = function (filedStatus) {
	switch (filedStatus.$) {
		case 5:
			return 0;
		case 4:
			return 0;
		case 1:
			return 1;
		case 3:
			return 1;
		case 2:
			return 2;
		case 0:
			return 0;
		case 7:
			return 0;
		default:
			return 0;
	}
};
var $author$project$FeeEntry$View$FeeActivityView$summaryPriority = function (filingStatus) {
	return _Utils_Tuple2(
		$author$project$Activities$Model$FilingStatus$sorter(filingStatus),
		$author$project$FeeEntry$View$FeeActivityView$summaryTieBreak(filingStatus.dG));
};
var $author$project$FeeEntry$View$FeeActivityView$summariseFilingStatuses = function (filingStatuses) {
	return A2(
		$elm$core$Maybe$map,
		function (dominant) {
			return {
				aj: $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						function (fs) {
							return _Utils_eq(
								$author$project$Activities$Model$FilingStatus$sorter(fs),
								$author$project$Activities$Model$FilingStatus$sorter(dominant));
						},
						filingStatuses)),
				M: dominant.dG
			};
		},
		$elm$core$List$head(
			A2($elm$core$List$sortBy, $author$project$FeeEntry$View$FeeActivityView$summaryPriority, filingStatuses)));
};
var $author$project$FeeEntry$View$FeeActivityView$eventDuration = function (event) {
	switch (event.$) {
		case 3:
			var email = event.a;
			return email.X;
		case 4:
			var phone = event.a;
			return $elm$core$Maybe$Just(phone.X);
		case 1:
			var phone = event.b;
			return $elm$core$Maybe$Just(phone.X);
		case 0:
			var appt = event.a;
			return $elm$core$Maybe$Just(appt.X);
		case 2:
			if (!event.a) {
				var _v1 = event.a;
				return $elm$core$Maybe$Nothing;
			} else {
				var doc = event.b;
				return $elm$core$Maybe$Just(doc.X);
			}
		default:
			var act = event.a;
			return act.X;
	}
};
var $author$project$FeeEntry$View$FeeActivityView$totalConsolidatedDuration = function (fees) {
	var durations = A2(
		$elm$core$List$filterMap,
		function (fee) {
			return A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return $author$project$FeeEntry$View$FeeActivityView$eventDuration(a.i);
				},
				fee.fG);
		},
		fees);
	if (!durations.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(
			$elm$core$List$sum(durations));
	}
};
var $author$project$FeeEntry$View$FeeActivityView$consolidatedFeesView = F3(
	function (feeId, isConsolidatedFeesOpen, consolidatedFees) {
		var isClonedEntry = A2(
			$elm$core$List$all,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.cg;
				},
				$elm$core$Basics$eq(6)),
			consolidatedFees);
		var icon = A2($elm$core$List$all, $author$project$Timesheet$FeeLogic$activityIsEmail, consolidatedFees) ? A2(
			$author$project$Icons$ConsolidatedEmails$viewWithAttributes,
			_List_Nil,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('fill-white stroke-mt-purple')
				])) : (isClonedEntry ? $author$project$Icons$Clone$viewWithAttributes(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('stroke-mt-purple stroke-current')
				])) : A2($elm$html$Html$div, _List_Nil, _List_Nil));
		var filingStatuses = A2(
			$elm$core$List$sortBy,
			$author$project$Activities$Model$FilingStatus$sorter,
			A3(
				$elm$core$List$foldl,
				F2(
					function (fes, acc) {
						var _v1 = $author$project$Timesheet$FeeLogic$getFilingStatus(fes);
						if (_v1.$ === 1) {
							return acc;
						} else {
							var fs = _v1.a;
							return A2($elm$core$List$cons, fs, acc);
						}
					}),
				_List_Nil,
				consolidatedFees));
		var filingSummary = $author$project$FeeEntry$View$FeeActivityView$summariseFilingStatuses(filingStatuses);
		var filingStatus = $elm$core$List$head(filingStatuses);
		var feesCountText = function (num) {
			return num + ' Merged Fees';
		}(
			$elm$core$String$fromInt(
				$elm$core$List$length(consolidatedFees)));
		var duration = $author$project$FeeEntry$View$FeeActivityView$totalConsolidatedDuration(consolidatedFees);
		var _v0 = isConsolidatedFeesOpen ? _Utils_Tuple2('Hide', $author$project$Icons$Expanded$view) : _Utils_Tuple2('Show', $author$project$Icons$Contracted$view);
		var displayMoreText = _v0.a;
		var displayMoreButton = _v0.b;
		return A3(
			$author$project$FeeEntry$View$FeeActivityView$commonView,
			icon,
			filingStatus,
			_List_fromArray(
				[
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					isClonedEntry,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cloned Entry')
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-4 ml-4 mx-0 text-xs font-normal flex items-center'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'consolidated-fees-activity')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(feesCountText)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4')
						]),
					_List_fromArray(
						[
							A2($elm_community$html_extra$Html$Extra$viewMaybe, $author$project$FeeEntry$View$FeeActivityView$commonDurationView, duration)
						])),
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (summary) {
						return $author$project$FeeEntry$View$FeeActivityView$consolidatedSummaryBar(
							{aj: summary.aj, bv: displayMoreButton, bw: displayMoreText, g_: feeId, hJ: isConsolidatedFeesOpen, M: summary.M});
					},
					filingSummary)
				]));
	});
var $author$project$Icons$Clone$view = $author$project$Icons$Clone$viewWithAttributes(_List_Nil);
var $author$project$Icons$DefaultFeeType$view = $author$project$Icons$DefaultFeeType$viewWithAttributes(_List_Nil);
var $author$project$FeeEntry$View$FeeActivityView$noActivtyEntryView = function (fee) {
	var splitEntryDuration = A2(
		$elm$core$Maybe$withDefault,
		$elm_community$html_extra$Html$Extra$nothing,
		A2($elm$core$Maybe$map, $author$project$FeeEntry$View$FeeActivityView$commonDurationView, fee.jc));
	var _v0 = function () {
		var _v1 = fee.cg;
		switch (_v1) {
			case 6:
				return _Utils_Tuple2('Cloned Entry', $author$project$Icons$Clone$view);
			case 7:
				return _Utils_Tuple2('Split Entry', $author$project$Icons$Clone$view);
			case 1:
				return _Utils_Tuple2('Manual Entry', $author$project$Icons$DefaultFeeType$view);
			default:
				return _Utils_Tuple2('Unknown', $author$project$Icons$DefaultFeeType$view);
		}
	}();
	var entryText = _v0.a;
	var feeTypeView = _v0.b;
	return A3(
		$author$project$FeeEntry$View$FeeActivityView$commonView,
		feeTypeView,
		$elm$core$Maybe$Nothing,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-4 mx-0 text-xs font-normal')
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					fee.cg === 7,
					_List_fromArray(
						[splitEntryDuration]),
					_List_fromArray(
						[
							$elm$html$Html$text(entryText)
						])))
			]));
};
var $author$project$FeeEntry$View$FeeActivityView$view = F5(
	function (zone, searchInput, libraries, filingUser, fee) {
		var consolidatedFees = $author$project$Timesheet$FeeLogic$getConsolidatedFees(fee);
		var _v0 = _Utils_Tuple2(consolidatedFees, fee.fG);
		if (!_v0.a.b) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.b;
				return $author$project$FeeEntry$View$FeeActivityView$noActivtyEntryView(fee);
			} else {
				var activity = _v0.b.a;
				return A6($author$project$FeeEntry$View$FeeActivityView$activityView, zone, searchInput, libraries, filingUser, fee, activity);
			}
		} else {
			var fees = _v0.a;
			return A3($author$project$FeeEntry$View$FeeActivityView$consolidatedFeesView, fee.aC, fee.hA, fees);
		}
	});
var $author$project$Timesheet$Views$FeeTypeAndActivityColumns$hovercard = function (fee) {
	var chargeReason = function () {
		var _v0 = fee.cg;
		switch (_v0) {
			case 0:
				return '';
			case 1:
				return 'Manually charged.';
			case 6:
				return 'Cloned fee';
			case 7:
				return 'Split fee';
			case 2:
				return 'Auto-charged due to linked matter.';
			case 3:
				return 'Auto-charged from previous charge.';
			case 4:
				return 'Matter code found in subject';
			default:
				return 'Merged fees';
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hovercardtext')
			]),
		A2(
			$author$project$CoreX$Appendable$andAppend,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(chargeReason)
						]))
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Activities$Views$Hovercard$view, fee.fG))));
};
var $author$project$Timesheet$Views$ConsolidatedFee$renderSubjectEditor = function (parentFee) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full col-start-2 md:col-start-8 md:col-span-4'),
				$elm$html$Html$Attributes$class('flex items-center justify-end')
			]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm_community$html_extra$Html$Extra$nothing,
				A2(
					$elm$core$Maybe$map,
					function (editor) {
						return A2($author$project$FeeEntry$View$FilingStatus$editorView, parentFee.aC, editor.af);
					},
					parentFee.ad))
			]));
};
var $author$project$TimesheetPage$Messages$Deconsolidate = function (a) {
	return {$: 44, a: a};
};
var $author$project$Timesheet$Views$ConsolidatedFee$renderDemergeButton = function (feeId) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('leading-normal font-semibold py-1 px-3 rounded bg-mt-purple-lightest text-xs text-mt-purple'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-role',
				'deconsolidate-button-fee-' + $elm$core$String$fromInt(feeId)),
				$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
				$author$project$TimesheetPage$Messages$Deconsolidate(feeId))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-row gap-2 items-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Demerge'),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-4 h-4')
							]),
						_List_fromArray(
							[
								$author$project$Icons$DemergeArrow$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('fill-current fill-mt-purple')
									]))
							]))
					]))
			]));
};
var $author$project$FeeEntry$View$FilingStatus$pill = F2(
	function (context, filingStatus) {
		var _v0 = filingStatus.dG;
		if (_v0.$ === 6) {
			return $author$project$FeeEntry$View$FilingStatus$selectionRequiredView(context);
		} else {
			var filedStatus = _v0;
			var style = A2($author$project$FeeEntry$View$FilingStatus$statusStyle, context, filedStatus);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center gap-1 min-w-0 px-2 py-1 rounded'),
						$elm$html$Html$Attributes$class(style.ay),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'filing-status-pill'),
						$elm$html$Html$Attributes$title(style.aK)
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					!$author$project$FeeEntry$View$FilingStatus$isInFlight(filingStatus),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-auto')
								]),
							_List_fromArray(
								[
									A2($author$project$FeeEntry$View$FilingStatus$menu, context, filingStatus)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-3 h-3 shrink-0')
								]),
							_List_fromArray(
								[
									$author$project$FeeEntry$View$FilingStatus$statusIcon(filingStatus.dG)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xs font-semibold truncate')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(style.ec)
								]))
						])));
		}
	});
var $author$project$Timesheet$Views$ConsolidatedFee$renderFilingStatus = F6(
	function (zone, searchInput, filingUser, parentFee, fee, activity) {
		var filingStatus = $author$project$Activities$ActivityLogic$getFilingStatus(activity.i);
		var context = A7(
			$author$project$FeeEntry$View$FeeActivityView$filingContext,
			zone,
			searchInput,
			filingUser,
			parentFee,
			fee,
			$author$project$Activities$ActivityLogic$getTitle(activity),
			filingStatus);
		return A2(
			$elm_community$html_extra$Html$Extra$viewMaybe,
			$author$project$FeeEntry$View$FilingStatus$pill(context),
			filingStatus);
	});
var $author$project$Timesheet$Views$ConsolidatedFee$rowActions = F6(
	function (postStatus, zone, searchInput, filingUser, parentFee, fee) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full col-start-2 md:col-start-8 md:col-span-4'),
					$elm$html$Html$Attributes$class('flex gap-2 items-center justify-end font-light min-w-0')
				]),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				$author$project$Model$Fee$PostStatus$isEditable(postStatus),
				_List_fromArray(
					[
						$author$project$Timesheet$Views$ConsolidatedFee$renderDemergeButton(fee.aC)
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$html_extra$Html$Extra$viewMaybe,
						A5($author$project$Timesheet$Views$ConsolidatedFee$renderFilingStatus, zone, searchInput, filingUser, parentFee, fee),
						fee.fG)
					])));
	});
var $author$project$Timesheet$Views$ConsolidatedFee$view = F7(
	function (postStatus, zone, searchInput, libraries, filingUser, parentFee, fee) {
		var postStatusString = $author$project$Model$Fee$PostStatus$toString(postStatus);
		var isBeingRenamed = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.g_;
					},
					$elm$core$Basics$eq(fee.aC)),
				parentFee.ad));
		var feeRowDomId = 'fee-' + $elm$core$String$fromInt(fee.aC);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'consolidated-fee-item'),
					$elm$html$Html$Attributes$class('-mt-1px first:border-t-0'),
					$elm$html$Html$Attributes$class('border-t border-mt-grey-lightest'),
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation($author$project$TimesheetPage$Messages$NoOp)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fee'),
							$elm$html$Html$Attributes$class('grid gap-x-4 gap-y-1'),
							$elm$html$Html$Attributes$class('grid-cols-fee-form-mobile md:grid-cols-fee'),
							$elm$html$Html$Attributes$class('place-items-center'),
							$elm$html$Html$Attributes$class('py-2'),
							$elm$html$Html$Attributes$class('consolidated-fee-entry-row'),
							$elm$html$Html$Attributes$class('relative'),
							$elm$html$Html$Attributes$class('pl-2 md:pl-4'),
							$elm$html$Html$Attributes$class('pr-4 md:pr-8'),
							$elm$html$Html$Attributes$class('m-0'),
							$elm$html$Html$Attributes$class(postStatusString),
							$elm$html$Html$Attributes$id(feeRowDomId),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'consolidated-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-span-1 w-full relative min-w-0'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
									$author$project$Timesheet$Views$FeeTypeAndActivityColumns$feeTypeColumn(
										{g0: fee.g0, hA: false, hB: false, hF: false, hL: false, h1: $author$project$Model$Fee$Singleton, b7: fee.b7, fA: zone}))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hovercard col-span-2 md:col-span-3 w-full'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-column')
								]),
							_List_fromArray(
								[
									A3($author$project$Timesheet$Views$FeeTypeAndActivityColumns$activityColumn, fee, false, $elm$core$Maybe$Nothing),
									$author$project$Timesheet$Views$FeeTypeAndActivityColumns$hovercard(fee)
								])),
							isBeingRenamed ? $author$project$Timesheet$Views$ConsolidatedFee$renderSubjectEditor(parentFee) : A6($author$project$Timesheet$Views$ConsolidatedFee$rowActions, postStatus, zone, searchInput, filingUser, parentFee, fee)
						]))
				]));
	});
var $author$project$Timesheet$Views$FeeWarning$feeWarning = F5(
	function (role, colour, reason, icon, titleMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-1 col-span-3 md:col-start-5 md:col-end-12'),
					$elm$html$Html$Attributes$class('place-self-start'),
					$elm$html$Html$Attributes$class('flex items-center max-w-72 sm:max-w-96 md:max-w-144'),
					$elm$html$Html$Attributes$class('px-8 py-1 gap-1 rounded-lg text-white group cursor-pointer'),
					$elm$html$Html$Attributes$class('text-sm'),
					$elm$html$Html$Attributes$class('bg-mt-' + (colour + '-light')),
					A2($elm$html$Html$Attributes$attribute, 'data-role', role),
					$elm$html$Html$Attributes$title(titleMsg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block h-5 w-5 stroke-current icon icon--error')
						]),
					_List_fromArray(
						[icon])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('truncate')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(reason)
						]))
				]));
	});
var $author$project$CoreX$Maybe$justWhen = F2(
	function (predicate, value) {
		return predicate ? $elm$core$Maybe$Just(value) : $elm$core$Maybe$Nothing;
	});
var $author$project$Timesheet$Views$FeeWarning$matterWarning = F2(
	function (showOnHold, matter) {
		var _v0 = matter.h0;
		switch (_v0.$) {
			case 1:
				return $elm$core$Maybe$Just(
					A5($author$project$Timesheet$Views$FeeWarning$feeWarning, 'matter-warning', 'red', 'Matter is Archived', $author$project$Icons$Error$view, 'Matter archived'));
			case 2:
				var onHoldReason = _v0.a;
				var message = 'Matter is on-hold';
				var icon = $author$project$Icons$Warning$view;
				return A2(
					$author$project$CoreX$Maybe$justWhen,
					showOnHold,
					A5($author$project$Timesheet$Views$FeeWarning$feeWarning, 'matter-warning', 'purple', message, icon, onHoldReason));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$oneOf = F2(
	function (fmbs, a) {
		oneOf:
		while (true) {
			if (!fmbs.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var fmb = fmbs.a;
				var rest = fmbs.b;
				var _v1 = fmb(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$fmbs = rest,
						$temp$a = a;
					fmbs = $temp$fmbs;
					a = $temp$a;
					continue oneOf;
				}
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$orListLazy = function (maybes) {
	return A2($elm_community$maybe_extra$Maybe$Extra$oneOf, maybes, 0);
};
var $author$project$Icons$Hold$view = $author$project$Icons$Hold$viewWithAttributes(_List_Nil);
var $author$project$Timesheet$Views$FeeWarning$view = F3(
	function (fee, zone, showOnHold) {
		var feeOnHold = function (_v2) {
			return A2(
				$author$project$CoreX$Maybe$justWhen,
				fee.ip && showOnHold,
				A5($author$project$Timesheet$Views$FeeWarning$feeWarning, 'fee-on-hold', 'purple', 'Time entry is On-hold', $author$project$Icons$Hold$view, 'Fee held'));
		};
		var feeMatterWarning = function (_v1) {
			return A2(
				$elm$core$Maybe$andThen,
				$author$project$Timesheet$Views$FeeWarning$matterWarning(showOnHold),
				fee.hY);
		};
		var failureHTML = function (_v0) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (reason, failedAt) {
						var titleMsg = 'Failed to post on ' + A2($author$project$CoreX$DateFormat$toFriendlyFormatDateTime, zone, failedAt);
						return A5($author$project$Timesheet$Views$FeeWarning$feeWarning, 'failure-message', 'red', reason, $author$project$Icons$Error$view, titleMsg);
					}),
				fee.dz,
				fee.dy);
		};
		var defaultRow = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-span-full')
				]),
			_List_Nil);
		return ($author$project$Timesheet$FeeLogic$isEditable(fee) || (fee.eD === 7)) ? A2(
			$elm$core$Maybe$withDefault,
			defaultRow,
			$elm_community$maybe_extra$Maybe$Extra$orListLazy(
				_List_fromArray(
					[failureHTML, feeMatterWarning, feeOnHold]))) : defaultRow;
	});
var $author$project$FeeEntry$View$feeFormEls = F3(
	function (zone, _v0, _v1) {
		var actionStepRates = _v0.bn;
		var minutesPerUnit = _v0.ej;
		var feeCardCurrentSearchInput = _v0.gX;
		var feeCardCurrentSelectInput = _v0.gY;
		var libraries = _v0.hU;
		var feeTypes = _v0.bG;
		var user = _v0.jS;
		var utbmsCodes = _v0.cL;
		var isInGroup = _v0.hH;
		var billingOptions = _v0.fU;
		var fee = _v1.dA;
		var nextFeeId = _v1.ib;
		var prefilteredFeeTypes = (user.ce === 1) ? A2($author$project$FeeTypeLogic$scaleGroupFilter, fee.hY, feeTypes) : feeTypes;
		var postStatusString = $author$project$Model$Fee$PostStatus$toString(fee.eD);
		var matterUIContext = isInGroup ? 1 : 2;
		var hasTags = A3(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
			$author$project$FeeEntry$View$availableTagsFor(user),
			fee);
		var filteredFeeTypes = function () {
			var searchTermsWhenOpen = function () {
				if ((feeCardCurrentSearchInput.$ === 1) && (!feeCardCurrentSearchInput.a)) {
					var _v4 = feeCardCurrentSearchInput.a;
					var searchTerms = feeCardCurrentSearchInput.b.eX;
					return searchTerms;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			return A2($author$project$FeeTypeLogic$filterFeeTypes, searchTermsWhenOpen, prefilteredFeeTypes);
		}();
		var feeTypeModel = A3($author$project$Timesheet$Views$FeeTypeAndActivityColumns$fromFee, zone, true, fee);
		var editable = $author$project$Timesheet$FeeLogic$isFieldEditable(fee);
		var displayUtbmsSelectors = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return m.jT;
				},
				fee.hY)) && $elm_community$maybe_extra$Maybe$Extra$isJust(utbmsCodes);
		return A3(
			$author$project$CoreX$Appendable$andAppendIf,
			fee.hA,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-0 block md:w-full'),
									$elm$html$Html$Attributes$class('md:border-b md:border-l md:border-r md:border-mt-blue mb-1px')
								]),
							A2(
								$elm$core$List$map,
								A6(
									$author$project$Timesheet$Views$ConsolidatedFee$view,
									fee.eD,
									zone,
									feeCardCurrentSearchInput,
									libraries,
									$author$project$FeeEntry$View$filingUser(user),
									fee),
								$author$project$Timesheet$FeeLogic$getConsolidatedFees(fee)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fee min-h-screen--12 md:min-h-64 max-h-screen--12'),
							$elm$html$Html$Attributes$class('overflow-x-hidden overflow-y-auto md:overflow-x-visible md:overflow-y-visible'),
							$elm$html$Html$Attributes$class('grid md:gap-x-4 gap-y-4 md:gap-y-1'),
							$elm$html$Html$Attributes$class('grid-cols-fee-form-mobile'),
							$elm$html$Html$Attributes$class('md:grid-cols-fee'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('md:grid-rows-fee-with-tags', hasTags),
									_Utils_Tuple2('md:grid-rows-fee', !hasTags)
								])),
							$elm$html$Html$Attributes$class('place-items-center'),
							$elm$html$Html$Attributes$class('text-mt-grey-dark border-solid border-b'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'bg-white',
									!$author$project$Timesheet$FeeLogic$isPostedModified(fee))
								])),
							$elm$html$Html$Attributes$class('absolute'),
							$elm$html$Html$Attributes$class('w-screen left-0 top-0 z-20'),
							$elm$html$Html$Attributes$class('md:relative md:w-full md:z-auto'),
							$elm$html$Html$Attributes$class('pl-2 md:pl-4'),
							$elm$html$Html$Attributes$class('pr-4 md:pr-8'),
							$elm$html$Html$Attributes$class('m-0'),
							$elm$html$Html$Attributes$class('fee-selected'),
							$elm$html$Html$Attributes$class('shadow-sm'),
							$elm$html$Html$Attributes$class('-mt-2px'),
							$elm$html$Html$Attributes$class(postStatusString),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'timesheet-row'),
							$elm$html$Html$Attributes$id(
							$author$project$Timesheet$FeeLogic$feeRowDomId(fee)),
							$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
							A2($author$project$TimesheetPage$Messages$FeeFormEdit, fee.aC, $author$project$FeeEntry$Messages$NoOperation))
						]),
					A2(
						$author$project$CoreX$Appendable$andAppend,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('md:hidden')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2($elm$html$Html$br, _List_Nil, _List_Nil)
									])),
								A2($author$project$FeeEntry$View$elementToNextFeeInput, fee, 0)
							]),
						A2(
							$author$project$CoreX$Appendable$andAppend,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('h-12 w-full flex flex-col col-span-1 col-start-2 md:col-start-2 md:col-span-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-row gap-4 items-end')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A3($author$project$FeeEntry$View$feeDateView, editable, zone, fee),
															A3($author$project$FeeEntry$View$feeTimeView, editable, zone, fee)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('lg:block md:hidden')
														]),
													_List_fromArray(
														[
															$author$project$FeeEntry$View$currentTimeButton(fee.aC)
														]))
												]))
										])),
									A5(
									$author$project$FeeEntry$View$FeeActivityView$view,
									zone,
									feeCardCurrentSearchInput,
									libraries,
									$author$project$FeeEntry$View$filingUser(user),
									fee),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-span-1 col-start-2 md:col-span-2 md:col-start-10'),
											$elm$html$Html$Attributes$class('grid'),
											$elm$html$Html$Attributes$class('w-full grid-cols-fee-buttons-sm gap-x-1 place-self-start md:place-self-center md:justify-self-end md:justify-items-end')
										]),
									A4($author$project$Timesheet$Views$FeeActionButtons$deleteButtonWithDropdown, user, fee, nextFeeId, isInGroup))
								]),
							A2(
								$author$project$CoreX$Appendable$andAppend,
								function () {
									var rateSelection = {aS: user.aS, f7: user.f7, bx: displayUtbmsSelectors, gJ: editable, dA: fee, ce: user.ce, cf: actionStepRates, ck: feeCardCurrentSearchInput};
									return _List_fromArray(
										[
											$author$project$FeeEntry$View$rateSelectors(rateSelection),
											A5($author$project$FeeEntry$View$behaviourSelector, fee.hY, fee.g0, editable, billingOptions, fee)
										]);
								}(),
								A3(
									$author$project$CoreX$Appendable$andAppendIf,
									user.f3,
									_List_fromArray(
										[
											A3($author$project$FeeEntry$View$canRecordInMinutesInput, editable, fee.aC, fee.iQ)
										]),
									A2(
										$author$project$CoreX$Appendable$andAppend,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-full min-w-0 col-span-1'),
														A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type-column')
													]),
												_List_fromArray(
													[
														A2($author$project$FeeEntry$View$elementToNextFeeInput, fee, 1),
														A2(
														$elm$html$Html$map,
														$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
														$author$project$Timesheet$Views$FeeTypeAndActivityColumns$feeTypeColumn(
															_Utils_update(
																feeTypeModel,
																{hB: editable}))),
														A2(
														$elm$html$Html$map,
														$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
														A4($author$project$Components$FeeTypeSelector$feeTypeControl, editable, fee, filteredFeeTypes, feeCardCurrentSearchInput)),
														A2(
														$elm$html$Html$map,
														$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
														$author$project$Components$FeeTypeSelector$contactSelectorControl(fee))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-full flex justify-start'),
														$elm$html$Html$Attributes$class('col-span-2'),
														$elm$html$Html$Attributes$class('md:col-span-3'),
														$elm$html$Html$Attributes$class('md:row-span-2 md:self-start'),
														A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-column')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('flex flex-col w-full')
															]),
														_List_fromArray(
															[
																A3($author$project$FeeEntry$View$descriptionInputColumn, user.f6, editable, fee),
																A2(
																$elm_community$html_extra$Html$Extra$viewMaybe,
																function (promptText) {
																	return A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('flex items-center gap-x-2 mt-1 px-3 py-1 rounded-md bg-yellow-100 text-black text-xs')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$span,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('shrink-0 flex items-center justify-center w-4 h-4 rounded-full border border-black text-[10px] leading-none')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('ℹ')
																					])),
																				$elm$html$Html$text(promptText)
																			]));
																},
																A2(
																	$elm$core$Maybe$andThen,
																	function ($) {
																		return $.iL;
																	},
																	user.bH))
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-full min-w-0'),
														$elm$html$Html$Attributes$class('col-start-2 col-span-2'),
														$elm$html$Html$Attributes$class('md:col-start-auto md:col-span-4'),
														A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-lg md:text-base leading-tight md:leading-normal')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
																A2(
																	$elm$html$Html$map,
																	$author$project$FeeEntry$Messages$MatterInputMessage,
																	A3(
																		$author$project$Components$MatterInput$View$view,
																		A3($author$project$Components$MatterInput$Views$EditMode$Model$createEditModeViewModel, user.ce, fee, $elm$core$Maybe$Nothing),
																		editable,
																		matterUIContext))),
																A2(
																$elm_community$html_extra$Html$Extra$viewIf,
																$o_train$elm_search_input$Select$isOpen(feeCardCurrentSelectInput),
																A2($author$project$FeeEntry$View$selectInputView, fee, feeCardCurrentSelectInput))
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('col-span-1 col-start-2 md:col-start-auto justify-self-start start md:justify-self-center'),
														A2($elm$html$Html$Attributes$attribute, 'data-tour', 'unit-block')
													]),
												_List_fromArray(
													[
														A3($author$project$FeeEntry$View$unitsAndTimerSelector, editable, fee, minutesPerUnit)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('col-span-1 md:col-span-2 justify-self-start md:justify-self-start'),
														A2($elm$html$Html$Attributes$attribute, 'data-tour', 'quick-unit-block')
													]),
												_List_fromArray(
													[
														function () {
														if (fee.iQ) {
															return A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex animate-fade-in')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$map,
																		$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
																		$author$project$Components$DurationInput$IncrementDecrement$view),
																		A3($author$project$FeeEntry$View$quickTimer, fee.aC, 'h-10 w-11', 'w-6 h-9'),
																		$author$project$FeeEntry$View$pmsWholeUnitsLabel(user.ce)
																	]));
														} else {
															var _v2 = A2($author$project$FeeTimerLogic$getUnitsAndPartialUnitSeconds, minutesPerUnit, fee);
															if (!_v2.$) {
																return A2($elm$html$Html$div, _List_Nil, _List_Nil);
															} else {
																return A2($author$project$FeeEntry$View$quickUnitsCell, editable, fee);
															}
														}
													}()
													]))
											]),
										A2(
											$author$project$CoreX$Appendable$andAppend,
											_List_fromArray(
												[
													A3($author$project$Timesheet$Views$FeeWarning$view, fee, zone, true)
												]),
											A3(
												$author$project$CoreX$Appendable$andAppendIf,
												hasTags,
												_List_fromArray(
													[
														A2($author$project$FeeEntry$View$tagChipRow, user, fee)
													]),
												$author$project$FeeEntry$View$closeButton))))))))
				]));
	});
var $author$project$TimesheetPage$Messages$SelectFee = function (a) {
	return {$: 32, a: a};
};
var $author$project$TimesheetPage$Messages$ResumeFeeTimer = function (a) {
	return {$: 31, a: a};
};
var $author$project$Model$Fee$Timesheet = 0;
var $author$project$Components$TimerRenderer$renderStoppedTimer = F2(
	function (seconds, minutesPerUnit) {
		var elapsedPath = A2($author$project$Components$TimerRenderer$computeElapsedPath, seconds, minutesPerUnit);
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 120 120'),
					$elm$svg$Svg$Attributes$class('timer-wheel')
				]),
			_List_fromArray(
				[
					$author$project$Components$TimerRenderer$timerGradient(seconds),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d(elapsedPath),
							$elm$svg$Svg$Attributes$stroke('#666666'),
							$elm$svg$Svg$Attributes$fill('#bbbbbb')
						]),
					_List_Nil)
				]));
	});
var $author$project$Icons$PlayButton$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('16px'),
					$elm$svg$Svg$Attributes$width('16px'),
					$elm$svg$Svg$Attributes$viewBox('-15 0 90 80'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('playbutton'),
						$elm$svg$Svg$Attributes$strokeWidth('0'),
						$elm$svg$Svg$Attributes$fill('#999bff')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('outline-solid'),
								$elm$svg$Svg$Attributes$d('M67.5 35.6699C70.8333 37.5944 70.8333 42.4056 67.5 44.3301L7.5 78.9711C4.16667 80.8956 0 78.49 0 74.641V5.35899C0 1.50998 4.16667 -0.895644 7.5 1.02886L67.5 35.6699Z')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Components$Timer$stoppedTimerView = F5(
	function (fee, resumeTimerMsg, units, secondsElapsed, minutesPerUnit) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timer stopped')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$TimerRenderer$renderStoppedTimer, secondsElapsed, minutesPerUnit),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('face stopped')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('timer-ui resume timer-button'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'timer-resume-button'),
									$elm$html$Html$Events$onClick(resumeTimerMsg)
								]),
							_List_fromArray(
								[
									$author$project$Icons$PlayButton$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('relative stroke-current text-mt-purple hover:text-mt-blue-light icon icon--timer')
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('units w-18 text-center text-xl align-middle'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'units-in-timer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Timesheet$FeeLogic$roundUnitsString(units))
								]))
						]))
				]));
	});
var $author$project$Timesheet$Views$Fee$renderUnitTextWithTimer = F2(
	function (fee, minutesPerUnit) {
		var timerState = A2($author$project$FeeTimerLogic$getUnitsAndPartialUnitSeconds, minutesPerUnit, fee);
		var _v0 = _Utils_Tuple3(timerState, fee.eD, fee.jA);
		if (!_v0.a.$) {
			var timerUnits = _v0.a.a;
			return A5(
				$author$project$Components$Timer$timerView,
				fee,
				A2($author$project$TimesheetPage$Messages$StopFeeTimer, fee, 0),
				timerUnits.jP,
				timerUnits.iF,
				minutesPerUnit);
		} else {
			if ((!_v0.b) && (!_v0.c.$)) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				var t = _v0.c.a;
				var secondsIntoCurrentUnit = $author$project$FeeTimerLogic$millisecondsToSeconds(
					A2(
						$elm$core$Basics$modBy,
						$author$project$FeeTimerLogic$millisecondsPerUnit(minutesPerUnit),
						t.jJ));
				return A5(
					$author$project$Components$Timer$stoppedTimerView,
					fee,
					$author$project$TimesheetPage$Messages$ResumeFeeTimer(fee),
					fee.jP,
					secondsIntoCurrentUnit,
					minutesPerUnit);
			} else {
				var _v3 = _v0.a;
				return $elm$html$Html$text(
					$author$project$Timesheet$FeeLogic$roundUnitsString(fee.jP));
			}
		}
	});
var $author$project$Timesheet$Views$Fee$renderFee = F4(
	function (zone, isFeeEditable, _v0, _v1) {
		var searchTerm = _v0.i2;
		var minutesPerUnit = _v0.ej;
		var user = _v0.jS;
		var consolidateFeeIds = _v0.gj;
		var isInGroup = _v0.hH;
		var fee = _v1.dA;
		var nextFeeId = _v1.ib;
		var selected = _v1.e0;
		var matterUIContext = isInGroup ? 1 : 2;
		return _List_fromArray(
			[
				A3($author$project$Timesheet$Views$FeeWarning$view, fee, zone, false),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-span-1 w-full relative min-w-0'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-type')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
						$author$project$Timesheet$Views$FeeTypeAndActivityColumns$feeTypeColumn(
							A3($author$project$Timesheet$Views$FeeTypeAndActivityColumns$fromFee, zone, false, fee)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hovercard col-span-2 md:col-span-3 w-full'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'activity-column')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Timesheet$Views$FeeTypeAndActivityColumns$activityColumn,
						fee,
						$elm_community$maybe_extra$Maybe$Extra$isJust(fee.bd),
						searchTerm),
						$author$project$Timesheet$Views$FeeTypeAndActivityColumns$hovercard(fee)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-start-2 md:col-start-auto col-span-2 md:col-span-4 flex w-full font-light overflow-hidden'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
							$author$project$FeeEntry$Messages$MatterInputMessage),
						A3(
							$author$project$Components$MatterInput$View$view,
							A3($author$project$Components$MatterInput$Views$EditMode$Model$createEditModeViewModel, user.ce, fee, searchTerm),
							isFeeEditable,
							matterUIContext))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-start-2 md:col-start-auto col-span-2 place-self-end md:col-span-1 md:self-center md:place-self-center'),
						$elm$html$Html$Attributes$class('tile justify-end md:justify-center text-right sm:text-lg sm:font-bold'),
						$elm$html$Html$Attributes$class('flex'),
						$elm$html$Html$Attributes$class('sm:px-0'),
						$elm$html$Html$Attributes$class('md:text-base'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'text-mt-blue-light',
								$author$project$Timesheet$FeeLogic$isNonChargeable(fee))
							])),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'units')
					]),
				_List_fromArray(
					[
						A2($author$project$Timesheet$Views$Fee$renderUnitTextWithTimer, fee, minutesPerUnit)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden md:col-span-2'),
						$elm$html$Html$Attributes$class('md:w-full md:grid md:grid-cols-fee-buttons md:gap-x-1 md:items-center md:justify-items-end')
					]),
				A4($author$project$Timesheet$Views$FeeActionButtons$deleteButtonWithDropdown, user, fee, nextFeeId, isInGroup))
			]);
	});
var $author$project$Timesheet$Views$Fee$renderTemporaryFee = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row-span-full col-span-1 w-full relative min-w-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rounded-full bg-mt-purple-lighter h-10 w-10')
					]),
				_List_Nil)
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row-span-full col-span-2 md:col-span-3 col-end-auto w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-4 bg-mt-purple-lighter rounded-sm')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-4 bg-mt-purple-lighter rounded-sm mt-1')
					]),
				_List_Nil)
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row-span-full col-span-1 md:col-span-2 w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-4 bg-mt-purple-lighter rounded-sm')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-4 bg-mt-purple-lighter rounded-sm mt-1')
					]),
				_List_Nil)
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row-span-full col-span-2 md:col-span-3 w-full')
			]),
		_List_Nil)
	]);
var $author$project$Timesheet$Views$Fee$feeView = F3(
	function (zone, feeRowContext, feeRowData) {
		var consolidateFeeIds = feeRowContext.gj;
		var fee = feeRowData.dA;
		var selected = feeRowData.e0;
		var postStatus = $author$project$Model$Fee$PostStatus$toString(fee.eD);
		var isTemporaryFee = $elm_community$maybe_extra$Maybe$Extra$isJust(fee.ju);
		var isSetForMerging = A2($elm$core$Set$member, fee.aC, consolidateFeeIds);
		var isFeeEditable = $author$project$Timesheet$FeeLogic$isEditable(fee);
		var feeRowDomId = 'fee-' + $elm$core$String$fromInt(fee.aC);
		var consolidateState = $author$project$Model$Fee$Merge$getNextConsolidateState(isSetForMerging);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'fee-item'),
					A2($elm$html$Html$Attributes$attribute, 'data-tour', 'fee-item'),
					$elm$html$Html$Attributes$class('border h-full -mt-1px'),
					$elm$html$Html$Attributes$class('hover:border-mt-purple-lighter'),
					$elm$html$Html$Attributes$class('hover:bg-mt-blue-lightest '),
					$elm$html$Html$Attributes$class('flex items-center'),
					$elm$html$Html$Attributes$class(postStatus),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'timer-running-fill',
							$author$project$FeeTimerLogic$isTimerRunning(fee))
						]))
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fee grow'),
								$elm$html$Html$Attributes$class('grid gap-x-4 gap-y-1'),
								$elm$html$Html$Attributes$class('grid-cols-fee-form-mobile'),
								$elm$html$Html$Attributes$class('md:grid-cols-fee'),
								$elm$html$Html$Attributes$class('md:grid-rows-fee'),
								$elm$html$Html$Attributes$class('place-items-center'),
								$elm$html$Html$Attributes$class('fee-entry-row'),
								$elm$html$Html$Attributes$class('relative'),
								$elm$html$Html$Attributes$class('pl-2 md:pl-4'),
								$elm$html$Html$Attributes$class('pr-4 md:pr-8'),
								$elm$html$Html$Attributes$class('m-0'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('selected', selected),
										_Utils_Tuple2('animate-pulse md:h-20 justify-items-center', isTemporaryFee)
									])),
								$elm$html$Html$Attributes$id(feeRowDomId),
								$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
								$author$project$TimesheetPage$Messages$SelectFee(fee)),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'timesheet-row'),
								A2($elm$html$Html$Attributes$attribute, 'data-post-status', postStatus)
							]),
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							!isTemporaryFee,
							A4($author$project$Timesheet$Views$Fee$renderFee, zone, isFeeEditable, feeRowContext, feeRowData),
							A3($author$project$CoreX$Appendable$andAppendIf, isTemporaryFee, $author$project$Timesheet$Views$Fee$renderTemporaryFee, _List_Nil)))
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					feeRowContext.cY && $author$project$Timesheet$FeeLogic$isEditable(fee),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A5(
									$author$project$Components$MergeFeesToolbar$consolidateCheckbox,
									A2($author$project$TimesheetPage$Messages$SetConsolidating, consolidateState, fee.aC),
									isFeeEditable,
									true,
									isSetForMerging,
									$author$project$FeeTimerLogic$isTimerRunning(fee))
								]))
						]),
					_List_Nil)));
	});
var $author$project$Timesheet$Conversation$View$renderFee = F3(
	function (zone, feeRowContext, feeRowData) {
		return _Utils_Tuple2(
			'fee-row-' + $elm$core$String$fromInt(feeRowData.dA.aC),
			feeRowData.e0 ? A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('z-20 bg-white')
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'edited-fee',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(''),
									$elm$html$Html$Attributes$id('fee-form')
								]),
							A3($author$project$FeeEntry$View$feeFormEls, zone, feeRowContext, feeRowData)))
					])) : A4($elm$html$Html$Lazy$lazy3, $author$project$Timesheet$Views$Fee$feeView, zone, feeRowContext, feeRowData));
	});
var $mgold$elm_nonempty_list$List$Nonempty$tail = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return xs;
};
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$Timesheet$Conversation$View$renderFees = F3(
	function (zone, _v0, feeRowContext) {
		var selectedId = _v0.e1;
		var fees = _v0.aY;
		var shiftedLeftFeeIds = _Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.aC;
					},
					$mgold$elm_nonempty_list$List$Nonempty$tail(fees))),
			_List_fromArray(
				[$elm$core$Maybe$Nothing]));
		var feesWithNextId = A2(
			$elm_community$list_extra$List$Extra$zip,
			$mgold$elm_nonempty_list$List$Nonempty$toList(fees),
			shiftedLeftFeeIds);
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var fee = _v1.a;
				var maybeNextFeeId = _v1.b;
				var feeRowData = {
					dA: fee,
					ib: maybeNextFeeId,
					e0: A2($author$project$Timesheet$FeeLogic$isSelected, selectedId, fee)
				};
				return A3($author$project$Timesheet$Conversation$View$renderFee, zone, feeRowContext, feeRowData);
			},
			feesWithNextId);
	});
var $author$project$Timesheet$Conversation$View$renderGroup = F4(
	function (zone, conversation, minutesPerUnit, currentRataDie) {
		var fees = conversation.aY;
		var isExpanded = conversation.hC;
		var hasSelectedFee = conversation.hk;
		var groupByKey = conversation.bL;
		var feeRowContext = conversation.bE;
		var updatedFeeRowContext = _Utils_update(
			feeRowContext,
			{hH: true});
		var anySetForMerging = A2(
			$mgold$elm_nonempty_list$List$Nonempty$any,
			function (f) {
				return A2($elm$core$Set$member, f.aC, feeRowContext.gj);
			},
			fees);
		var showNested = isExpanded || anySetForMerging;
		return _Utils_Tuple2(
			groupByKey,
			A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-auto ml-4-not-first-child'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'fees-conversation'),
						$elm$html$Html$Attributes$id(groupByKey),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('border-mt-purple border-r-4', hasSelectedFee)
							]))
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					!showNested,
					$author$project$Timesheet$Conversation$View$renderCollapsedFees(conversation),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						showNested,
						A3($author$project$Timesheet$Conversation$View$renderFees, zone, conversation, updatedFeeRowContext),
						_List_fromArray(
							[
								A2($author$project$Timesheet$Conversation$View$groupHeader, zone, conversation)
							])))));
	});
var $author$project$Timesheet$Conversation$View$renderSingletonFee = F3(
	function (zone, _v0, minutesPerUnit) {
		var selectedId = _v0.e1;
		var groupByKey = _v0.bL;
		var earliestFee = _v0.dk;
		var feeRowContext = _v0.bE;
		var updatedFeeRowContext = _Utils_update(
			feeRowContext,
			{hH: false});
		var feeRowData = {
			dA: earliestFee,
			ib: $elm$core$Maybe$Nothing,
			e0: A2($author$project$Timesheet$FeeLogic$isSelected, selectedId, earliestFee)
		};
		return _Utils_Tuple2(
			'conversation-singleton-fee-id-' + $elm$core$String$fromInt(earliestFee.aC),
			A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-auto fee-transparent-right-border'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'fees-conversation-singleton'),
						A2($elm$html$Html$Attributes$attribute, 'data-tour', 'fees-conversation-singleton'),
						$elm$html$Html$Attributes$id(groupByKey)
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					feeRowData.dA.hA && (!feeRowData.e0),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'consolidated-fees' + $elm$core$String$fromInt(feeRowData.dA.aC),
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-4')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('m-0 block md:w-full'),
												$elm$html$Html$Attributes$class('md:border-b md:border-l md:border-r md:border mb-1px')
											]),
										A2(
											$elm$core$List$map,
											A6(
												$author$project$Timesheet$Views$ConsolidatedFee$view,
												feeRowData.dA.eD,
												zone,
												$author$project$Components$SearchInput$Model$Closed,
												feeRowContext.hU,
												$author$project$FeeEntry$View$filingUser(feeRowContext.jS),
												feeRowData.dA),
											$author$project$Timesheet$FeeLogic$getConsolidatedFees(feeRowData.dA)))
									])))
						]),
					A2(
						$author$project$CoreX$Appendable$andAppend,
						_List_fromArray(
							[
								A3($author$project$Timesheet$Conversation$View$renderFee, zone, updatedFeeRowContext, feeRowData)
							]),
						_List_Nil))));
	});
var $author$project$Timesheet$Conversation$View$view = F4(
	function (zone, minutesPerUnit, currentRataDie, model) {
		if (!model.$) {
			var baseConversation = model.a;
			return A3($author$project$Timesheet$Conversation$View$renderSingletonFee, zone, baseConversation, minutesPerUnit);
		} else {
			var conversation = model.a;
			return A4($author$project$Timesheet$Conversation$View$renderGroup, zone, conversation, minutesPerUnit, currentRataDie);
		}
	});
var $author$project$Timesheet$Views$Fees$Day$renderConversations = F5(
	function (zone, feeRowContext, model, currentRataDie, entries) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Timesheet$Conversation$View$view, zone, model.jS.ej, currentRataDie),
			A2(
				$elm$core$List$map,
				A6($author$project$Timesheet$Conversation$Model$make, model.aY.e1, model.aY.c4, model.g$, feeRowContext, model.gO, model.bG),
				A3(
					$author$project$GroupBy$conversation,
					function ($) {
						return $.b7;
					},
					$author$project$Timesheet$FeeLogic$groupByKey(zone),
					entries)));
	});
var $author$project$Timesheet$FeeLogic$getMatterKeyForGrouping = function (fee) {
	var defaultKey = function (f) {
		return f.a_ ? 'pending-matter' : 'no-matter-selected';
	};
	return A2(
		$elm$core$Maybe$withDefault,
		defaultKey(fee),
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aC;
				},
				$elm$core$String$fromInt),
			fee.hY));
};
var $author$project$Timesheet$Views$Fees$Day$matterGroupSortKey = function (_v0) {
	var matterKey = _v0.a;
	var fees = _v0.b;
	var _v1 = $mgold$elm_nonempty_list$List$Nonempty$head(fees).hY;
	if (!_v1.$) {
		var matter = _v1.a;
		return _Utils_Tuple3(
			0,
			$elm$core$String$toLower(matter.dd),
			matterKey);
	} else {
		return _Utils_Tuple3(1, '', matterKey);
	}
};
var $author$project$Timesheet$Views$Fees$Day$matterDesc = F2(
	function (maybeMatter, fee) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							fee.a_ ? 'Pending Matter' : 'Please select a Matter')
						]))
				]),
			A2(
				$elm$core$Maybe$map,
				function (matter) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-light')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$Basics$identity, matter.br)))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pl-1 font-bold')
								]),
							_Utils_eq(
								matter.br,
								$elm$core$Maybe$Just(matter.dd)) ? _List_fromArray(
								[
									$elm$html$Html$text('')
								]) : _List_fromArray(
								[
									$elm$html$Html$text(matter.dd)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pl-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('(' + (matter.gd + ')'))
								]))
						]);
				},
				maybeMatter));
	});
var $author$project$Timesheet$Views$Fees$Day$renderSelectAllCheckbox = F3(
	function (hasRunningTimer, isSet, feeIds) {
		var nextConsolidateState = $author$project$Model$Fee$Merge$getNextConsolidateState(isSet);
		var checkBoxModel = {
			ga: 'h-6 w-6',
			gc: A3($author$project$TimesheetPage$Messages$SetGroupConsolidating, 0, nextConsolidateState, feeIds),
			gJ: !hasRunningTimer,
			gU: A3(
				$author$project$CoreX$Appendable$andAppendIf,
				hasRunningTimer,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$title('Timer is running')
					]),
				_List_Nil),
			ho: 'Set for selecting all',
			hs: 'set-selecting',
			hM: isSet,
			hN: true,
			hR: '',
			i_: 'set-for-selecting',
			jw: 'text-xs'
		};
		return $author$project$Components$CheckBox$view(checkBoxModel);
	});
var $author$project$Timesheet$Views$Fees$Day$renderMatter = F5(
	function (hasRunningTimer, consolidateFeeIds, feeIds, feeTypes, fee) {
		var isSet = A2(
			$mgold$elm_nonempty_list$List$Nonempty$all,
			function (feeId) {
				return A2($elm$core$Set$member, feeId, consolidateFeeIds);
			},
			feeIds);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex')
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				A2($author$project$Timesheet$Views$Fees$Day$matterDesc, fee.hY, fee),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					$author$project$FeeTypeLogic$canMergeFees(feeTypes),
					_List_fromArray(
						[
							A3($author$project$Timesheet$Views$Fees$Day$renderSelectAllCheckbox, hasRunningTimer, isSet, feeIds)
						]),
					_List_Nil)));
	});
var $author$project$Timesheet$Views$Fees$Day$matterHeader = F3(
	function (fees, matterKey, feeRowContext) {
		var hasRunningTimer = $elm_community$maybe_extra$Maybe$Extra$isJust(
			A2(
				$elm_community$list_extra$List$Extra$find,
				$author$project$FeeTimerLogic$isTimerRunning,
				$mgold$elm_nonempty_list$List$Nonempty$toList(fees)));
		var firstFee = $mgold$elm_nonempty_list$List$Nonempty$head(fees);
		var feeIds = A2(
			$mgold$elm_nonempty_list$List$Nonempty$map,
			function ($) {
				return $.aC;
			},
			fees);
		var consolidateFeeIds = feeRowContext.gj;
		var _v0 = $author$project$Timesheet$Conversation$View$sumUnits(fees);
		var chargeableUnits = _v0.a;
		var nonChargeableUnits = _v0.b;
		var unitText = ((chargeableUnits + nonChargeableUnits) > 1) ? 'units' : 'unit';
		return _Utils_Tuple2(
			'matter-header-' + matterKey,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between mt-8 mb-2')
					]),
				_List_fromArray(
					[
						A5($author$project$Timesheet$Views$Fees$Day$renderMatter, hasRunningTimer, consolidateFeeIds, feeIds, feeRowContext.bG, firstFee),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-1/5 font-bold mr-1')
							]),
						A2(
							$author$project$CoreX$Appendable$andAppend,
							_List_fromArray(
								[
									$elm$html$Html$text(' ' + unitText)
								]),
							A2($author$project$Timesheet$Conversation$View$renderUnits, chargeableUnits, nonChargeableUnits)))
					])));
	});
var $author$project$Timesheet$Views$Fees$Day$renderFeesWithSameMatter = F5(
	function (zone, feeRowContext, model, currentRataDie, _v0) {
		var matterKey = _v0.a;
		var fees = _v0.b;
		return _Utils_Tuple2(
			'matter-id-' + matterKey,
			A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-auto'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'matter-group-fees'),
						$elm$html$Html$Attributes$id('matter-id-' + matterKey)
					]),
				A2(
					$elm$core$List$cons,
					A3($author$project$Timesheet$Views$Fees$Day$matterHeader, fees, matterKey, feeRowContext),
					A5($author$project$Timesheet$Views$Fees$Day$renderConversations, zone, feeRowContext, model, currentRataDie, fees))));
	});
var $author$project$Timesheet$Views$Fees$Day$renderFeesByMatter = F5(
	function (zone, feeRowContext, model, currentRataDie, entries) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Timesheet$Views$Fees$Day$renderFeesWithSameMatter, zone, feeRowContext, model, currentRataDie),
			A2(
				$elm$core$List$sortBy,
				$author$project$Timesheet$Views$Fees$Day$matterGroupSortKey,
				$rtfeldman$elm_sorter_experiment$Sort$Dict$toList(
					A3($author$project$GroupBy$groupBy, $rtfeldman$elm_sorter_experiment$Sort$alphabetical, $author$project$Timesheet$FeeLogic$getMatterKeyForGrouping, entries))));
	});
var $author$project$Timesheet$Views$Fees$Day$view = F7(
	function (zone, currentRataDie, budgetBar, feeRowContext, model, rataDie, entries) {
		var isGroupByDayAndMatter = feeRowContext.hG;
		var user = feeRowContext.jS;
		var render = isGroupByDayAndMatter ? $author$project$Timesheet$Views$Fees$Day$renderFeesByMatter : $author$project$Timesheet$Views$Fees$Day$renderConversations;
		var filteredFees = model.jS.i7 ? $elm$core$Maybe$Just(entries) : $mgold$elm_nonempty_list$List$Nonempty$fromList(
			$author$project$Timesheet$FeeLogic$removePosted(
				$mgold$elm_nonempty_list$List$Nonempty$toList(entries)));
		var budgetBarWithFees = function () {
			if (model.jS.i5) {
				var budgetBarModel = budgetBar.a6;
				var budgieSmuggler = _Utils_update(
					budgetBarModel,
					{
						gy: A2($author$project$BudgetBar$BudgetBarLogic$barStyle, budgetBarModel.gy, model.g$)
					});
				var budget = A2($author$project$BudgetBar$BudgetBarLogic$budgetToday, rataDie, user.jY);
				return $elm$core$Maybe$Just(
					_Utils_update(
						budgetBar,
						{
							aV: budget,
							aY: $mgold$elm_nonempty_list$List$Nonempty$toList(entries),
							a6: budgieSmuggler
						}));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		if (filteredFees.$ === 1) {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		} else {
			var fees = filteredFees.a;
			return A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-auto timesheet-day'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'day'),
						$elm$html$Html$Attributes$id(
						'timesheet-day-' + $elm$core$String$fromInt(rataDie)),
						$elm$html$Html$Attributes$tabindex(-1)
					]),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'day-header',
						A5($author$project$Components$DayHeader$renderDayHeaderFromRataDie, zone, rataDie, currentRataDie, 'fee', budgetBarWithFees)),
					A5(render, zone, feeRowContext, model, currentRataDie, fees)));
		}
	});
var $author$project$Timesheet$View$renderFeesByDay = F4(
	function (zone, currentRataDie, budgetBar, model) {
		var fees = model.aY;
		var feeRowContext = {
			bn: model.bn,
			fU: model.fU,
			cY: $author$project$FeeTypeLogic$canMergeFees(model.bG),
			gj: model.aY.gj,
			gX: model.gX,
			gY: model.gY,
			bG: model.bG,
			hG: A2($author$project$Model$Timesheet$GroupByFilter$isFilterOn, 0, model.g$.dT),
			hH: false,
			hU: model.jS.E.hU,
			ej: model.jS.ej,
			i2: model.g$.i2,
			jS: model.jS,
			cL: model.cL
		};
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var rataDie = _v0.a;
				var entries = _v0.b;
				return _Utils_Tuple2(
					'fee-day-' + $elm$core$String$fromInt(rataDie),
					entries);
			},
			$rtfeldman$elm_sorter_experiment$Sort$Dict$toList(
				A2(
					$rtfeldman$elm_sorter_experiment$Sort$Dict$map,
					F2(
						function (rataDie, entries) {
							return A7($author$project$Timesheet$Views$Fees$Day$view, zone, currentRataDie, budgetBar, feeRowContext, model, rataDie, entries);
						}),
					fees.$7)));
	});
var $author$project$Timesheet$View$renderTimesheet = F4(
	function (zone, model, currentRataDie, budgetBar) {
		var fees = model.aY;
		var feeSearchConfiguration = model.g$;
		var expandedFeeConversations = model.gO;
		var _v0 = _Utils_Tuple2(
			$rtfeldman$elm_sorter_experiment$Sort$Dict$toList(fees.$7),
			fees.dE);
		if ((!_v0.a.b) && (_v0.b === 2)) {
			var _v1 = _v0.b;
			return $author$project$Timesheet$View$anyFiltersActive(feeSearchConfiguration) ? $author$project$Timesheet$View$noFeesMessage('Sorry, no fees found that match.') : $author$project$Timesheet$View$noFeesMessage('Add a fee to get started.');
		} else {
			return _Utils_ap(
				A4($author$project$Timesheet$View$renderFeesByDay, zone, currentRataDie, budgetBar, model),
				_List_fromArray(
					[
						$author$project$Timesheet$View$loadMoreLink(model)
					]));
		}
	});
var $author$project$Timesheet$View$timesheetFees = F4(
	function (zone, model, currentRataDie, budgetBar) {
		var mobileSidebarIsActive = !(!model.h6);
		return A2(
			$elm$html$Html$div,
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				mobileSidebarIsActive,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$TimesheetPage$Messages$SetMobileDeviceTab(0))
					]),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fees w-screen md:w-auto grow h-full border-t border-mt-grey-lighter'),
						$elm$html$Html$Attributes$class('overflow-y-auto overflow-x-hidden md:overflow-x-visible'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'timesheet-fees'),
						$elm$html$Html$Attributes$id('timesheet-fees'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('md:px-12', model.jS.gg),
								_Utils_Tuple2('md:px-4', !model.jS.gg)
							]))
					])),
			_List_fromArray(
				[
					A3(
					$elm$html$Html$Keyed$node,
					'div',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-auto min-h-60'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'fees-list')
						]),
					A4($author$project$Timesheet$View$renderTimesheet, zone, model, currentRataDie, budgetBar))
				]));
	});
var $author$project$TimesheetPage$Messages$SearchFeesForDate = function (a) {
	return {$: 60, a: a};
};
var $author$project$TimesheetPage$Messages$SearchFeesInputChanged = function (a) {
	return {$: 61, a: a};
};
var $author$project$TimesheetPage$Messages$SetFeeSearchMode = function (a) {
	return {$: 57, a: a};
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Timesheet$View$searchTermClass = function (maybeSearchTerm) {
	var textLength = function (length) {
		return ($elm$core$String$length(length) > 0) ? 'text-lg' : '';
	};
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, textLength, maybeSearchTerm));
};
var $author$project$Timesheet$View$titleAndSearchView = F2(
	function (zone, _v0) {
		var searchMode = _v0.i1;
		var keyVersion = _v0.ea;
		var forDate = _v0.dN;
		var searchTerm = _v0.i2;
		var inputKey = 'fee-search-' + $elm$core$String$fromInt(keyVersion);
		var forDateValue = A2(
			$elm$core$Maybe$map,
			function (date) {
				return A2($author$project$CoreX$DateConstruct$fromDate, zone, date);
			},
			forDate);
		var forDateIsSet = $elm_community$maybe_extra$Maybe$Extra$isJust(forDate);
		if (!searchMode) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-auto flex-wrap flex items-center mx-4 px-2 my-auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-block mt-px')
							]),
						_List_fromArray(
							[
								$author$project$Icons$Search$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('relative text-mt-purple-light hover:text-mt-purple top-1 w-4.5 md:w-5 mr-3 stroke-current icon icon--search pt-0')
									]))
							])),
						A3(
						$elm$html$Html$Keyed$node,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-3 border-b border-mt-purple-light focus-within:border-mt-purple')
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								inputKey,
								A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											'flex-auto pl-2 pb-1' + $author$project$Timesheet$View$searchTermClass(searchTerm)),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$id('timesheet-search-field'),
											A2($elm$html$Html$Attributes$attribute, 'data-role', 'timesheet-search-field'),
											$elm$html$Html$Attributes$placeholder('Search timesheet...'),
											$elm$html$Html$Attributes$value(
											A2($elm$core$Maybe$withDefault, '', searchTerm)),
											$elm$html$Html$Events$onInput($author$project$TimesheetPage$Messages$SearchFeesInputChanged)
										]),
									_List_Nil))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Icons$CloseCross$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('inline mb-0 w-3 stroke-current text-mt-purple-light hover:text-mt-purple cursor-pointer icon icon--close-cross'),
										$elm$svg$Svg$Attributes$id('close-cross-button'),
										$elm$svg$Svg$Events$onClick(
										$author$project$TimesheetPage$Messages$SetFeeSearchMode(1))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-2 mt-1.5')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm flex h-8 pt-1.5 mt-0.25'),
										$elm$html$Html$Attributes$title('Show day (by date)'),
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'fees-search-date-input'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('text-white bg-mt-purple-light border-mt-purple rounded-sm px-2', forDateIsSet)
											]))
									]),
								A3(
									$author$project$CoreX$Appendable$andAppendIf,
									forDateIsSet,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-white ml-8')
												]),
											_List_fromArray(
												[
													$author$project$Icons$CloseCross$viewWithAttributes(
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('text-white inline -mt-1 w-3 stroke-current cursor-pointer icon icon--close-cross'),
															A2($elm$html$Html$Attributes$attribute, 'data-role', 'timesheet-close-search'),
															$elm$svg$Svg$Attributes$id('close-fee-filter-date-button'),
															$elm$svg$Svg$Events$onClick(
															$author$project$TimesheetPage$Messages$SearchFeesForDate(''))
														]))
												]))
										]),
									_List_fromArray(
										[
											A3($author$project$Components$DateInput$genericDateInput, zone, $author$project$TimesheetPage$Messages$SearchFeesForDate, forDateValue)
										])))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center justify-between w-auto mx-4 my-auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline text-xl sm:text-3xl leading-none sm:leading-base m-0')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Timesheet')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('group inline-block w-8 px-2 text-mt-purple-lighter')
									]),
								_List_fromArray(
									[
										$author$project$Icons$Search$viewWithAttributes(
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('w-4.5 md:w-5 stroke-current icon icon--search pt-0 -mb-1px md:mb-0 cursor-pointer'),
												A2($elm$html$Html$Attributes$attribute, 'data-role', 'timesheet-header-search'),
												$elm$svg$Svg$Events$onClick(
												$author$project$TimesheetPage$Messages$SetFeeSearchMode(0))
											]))
									]))
							]))
					]));
		}
	});
var $author$project$BudgetBar$View$budgetBarWithHoverCard = F3(
	function (isProgressBar, unitsToday, viewModel) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative hovercard flex flex-col gap-0.5')
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hovercardtext w-48 -mt-2')
							]),
						_List_fromArray(
							[
								$author$project$BudgetBar$View$renderHoverCard(
								A2($author$project$BudgetBar$View$budgetBarHoverRows, unitsToday, viewModel))
							]))
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					isProgressBar,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-4')
								]),
							_List_Nil)
						]),
					A3($author$project$BudgetBar$View$barView, true, unitsToday, viewModel))));
	});
var $author$project$TimesheetPage$Messages$ToggleDashboardUI = {$: 109};
var $author$project$Icons$ExpandAll$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('16'),
					$elm$svg$Svg$Attributes$height('16'),
					$elm$svg$Svg$Attributes$viewBox('0 -960 960 960')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M480-93.85 253.85-320l42.77-42.77L480-180.15l183.38-182.62L706.15-320 480-93.85Zm-182.77-504L253.85-640 480-866.15 706.15-640l-43.38 42.15-182.77-182-182.77 182Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$ExpandAll$view = $author$project$Icons$ExpandAll$viewWithAttributes(_List_Nil);
var $author$project$BudgetBar$View$displayBudgetBarToggle = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('cursor-pointer'),
			$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$ToggleDashboardUI)
		]),
	_List_fromArray(
		[$author$project$Icons$ExpandAll$view]));
var $author$project$BudgetBar$View$totalUnits = F3(
	function (countNonChargeablesInBudget, unitsToday, dailyBudget) {
		var progress = A2($author$project$BudgetBar$View$unitsTowardBudget, countNonChargeablesInBudget, unitsToday);
		var remaining = A2($elm$core$Basics$max, 0, dailyBudget - progress);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-x-1'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'budget-total-units')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-medium')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Today')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Timesheet$FeeLogic$roundUnitsString(progress) + (' of ' + ($author$project$Timesheet$FeeLogic$roundUnitsString(dailyBudget) + ' units')))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('•')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-mt-grey'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'units-to-go')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Timesheet$FeeLogic$roundUnitsString(remaining) + ' units to go')
						]))
				]));
	});
var $author$project$BudgetBar$Data$On = function (a) {
	return {$: 0, a: a};
};
var $author$project$TimesheetPage$Messages$SetDashboardFilter = function (a) {
	return {$: 108, a: a};
};
var $author$project$BudgetBar$View$getFilterAttributes = F2(
	function (model, outgoing) {
		var outgoingFilter = _Utils_eq(model.ha, outgoing);
		var filterUnavailableStyle = 'font-light';
		var filterInactiveStyle = 'cursor-pointer font-light hover:underline truncate font-light';
		var filterActiveStyle = 'cursor-pointer font-light hover:underline rounded-full py-0 px-2 bg-blue-200 text-black';
		var dashboardUI = model.gy;
		var _v0 = _Utils_Tuple2(dashboardUI, outgoingFilter);
		if (_v0.a === 1) {
			if (_v0.b) {
				var _v1 = _v0.a;
				return _Utils_Tuple2(
					filterActiveStyle,
					$author$project$TimesheetPage$Messages$SetDashboardFilter($author$project$BudgetBar$Data$Off));
			} else {
				var _v2 = _v0.a;
				return _Utils_Tuple2(
					filterInactiveStyle,
					$author$project$TimesheetPage$Messages$SetDashboardFilter(outgoing));
			}
		} else {
			var _v3 = _v0.a;
			return _Utils_Tuple2(filterUnavailableStyle, $author$project$TimesheetPage$Messages$NoOp);
		}
	});
var $author$project$BudgetBar$View$displayChargeableUnits = F2(
	function (unitsToday, model) {
		var chargable = unitsToday.ax;
		var _v0 = A2(
			$author$project$BudgetBar$View$getFilterAttributes,
			model,
			$author$project$BudgetBar$Data$On(0));
		var filterStyle = _v0.a;
		var filterAction = _v0.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					$elm$core$String$fromFloat(chargable) + ' Verified Units Today'),
					$elm$html$Html$Attributes$class(filterStyle),
					$elm$html$Html$Events$onClick(filterAction)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-mt-green-dark pb-6'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'chargeable-units-today')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(chargable))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' Verified')
						]))
				]));
	});
var $author$project$BudgetBar$View$displayNonChargeableUnits = F2(
	function (unitsToday, model) {
		var nonChargeable = unitsToday.aH;
		var _v0 = A2(
			$author$project$BudgetBar$View$getFilterAttributes,
			model,
			$author$project$BudgetBar$Data$On(2));
		var filterStyle = _v0.a;
		var filterAction = _v0.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					$elm$core$String$fromFloat(nonChargeable) + ' Non-chargeable Units Today'),
					$elm$html$Html$Attributes$class(filterStyle),
					$elm$html$Html$Events$onClick(filterAction)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-mt-blue-light'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'non-chargeable-units-today')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(nonChargeable))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' Non-chargeable')
						]))
				]));
	});
var $author$project$BudgetBar$View$displayUnverifiedUnits = F2(
	function (unitsToday, model) {
		var unverified = unitsToday.aN;
		var _v0 = A2(
			$author$project$BudgetBar$View$getFilterAttributes,
			model,
			$author$project$BudgetBar$Data$On(1));
		var filterStyle = _v0.a;
		var filterAction = _v0.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					$elm$core$String$fromFloat(unverified) + ' Incomplete Units Today'),
					$elm$html$Html$Attributes$class(filterStyle),
					$elm$html$Html$Events$onClick(filterAction)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-mt-red-light'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'unverified-units-today')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(unverified))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' Incomplete')
						]))
				]));
	});
var $author$project$BudgetBar$View$unitsDetails = F3(
	function (showNonChargeable, unitsToday, model) {
		return A3(
			$author$project$CoreX$Appendable$andAppendIf,
			!(!unitsToday.ax),
			_List_fromArray(
				[
					A2($author$project$BudgetBar$View$displayChargeableUnits, unitsToday, model)
				]),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				showNonChargeable && (!(!unitsToday.aH)),
				_List_fromArray(
					[
						A2($author$project$BudgetBar$View$displayNonChargeableUnits, unitsToday, model)
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					!(!unitsToday.aN),
					_List_fromArray(
						[
							A2($author$project$BudgetBar$View$displayUnverifiedUnits, unitsToday, model)
						]),
					_List_Nil)));
	});
var $author$project$BudgetBar$View$view = function (viewModel) {
	var model = viewModel.a6;
	var fees = viewModel.aY;
	var mobileDashboardOn = viewModel.ek;
	var hasActivityFeedOnLeft = viewModel.am;
	var barConfig = viewModel.aw;
	var dailyBudget = viewModel.aV;
	var unitsToday = $author$project$BudgetBar$BudgetBarLogic$toUnitsToday(fees);
	var ncInBudget = barConfig.aT;
	var isProgressBar = $author$project$BudgetBar$View$isProgress(model.gy);
	var unitsToDisplay = A3(
		$author$project$CoreX$Appendable$andAppendIf,
		!isProgressBar,
		A3($author$project$BudgetBar$View$unitsDetails, barConfig.bf, unitsToday, model),
		A3(
			$author$project$CoreX$Appendable$andAppendIf,
			isProgressBar,
			_List_fromArray(
				[
					A3($author$project$BudgetBar$View$totalUnits, ncInBudget, unitsToday, dailyBudget)
				]),
			_List_fromArray(
				[$author$project$BudgetBar$View$displayBudgetBarToggle])));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('items-center flex flex-row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('z-50 xl:z-auto w-screen md:w-128 h-screen--12 xl:h-16'),
						$elm$html$Html$Attributes$class('px-4'),
						$elm$html$Html$Attributes$class('md:border-solid md:border-mt-blue xl:border-mt-grey-lighter'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('absolute xl:relative top-0 right-0 xl:block z-10 bg-white left-0 sm:left-auto', mobileDashboardOn),
								_Utils_Tuple2('hidden xl:flex xl:flex-col gap-0.5 xl:h-auto', !mobileDashboardOn),
								_Utils_Tuple2('md:border-l', !hasActivityFeedOnLeft),
								_Utils_Tuple2('md:border-r', hasActivityFeedOnLeft)
							])),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'budget-bar')
					]),
				A2(
					$author$project$CoreX$Appendable$andAppend,
					_List_fromArray(
						[
							A3($author$project$BudgetBar$View$budgetBarWithHoverCard, isProgressBar, unitsToday, viewModel)
						]),
					A2(
						$author$project$CoreX$Appendable$andAppend,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col-reverse items-center pb-4 pt-1 text-xl gap-4'),
										$elm$html$Html$Attributes$class('xl:flex-row-reverse xl:justify-between xl:pb-0 xl:text-base')
									]),
								unitsToDisplay)
							]),
						_List_Nil)))
			]));
};
var $author$project$Timesheet$View$timesheetView = F3(
	function (zone, model, animationsOn) {
		var feeSearchConfiguration = model.g$;
		var feeTypes = model.bG;
		var todaysFees = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$mgold$elm_nonempty_list$List$Nonempty$toList,
				A2($rtfeldman$elm_sorter_experiment$Sort$Dict$get, model.aU, model.aY.$7)));
		var mobileDashboardOn = model.h6 === 2;
		var budget = A2($author$project$BudgetBar$BudgetBarLogic$budgetToday, model.aU, model.jS.jY);
		var baseBudgetBar = A9(
			$author$project$BudgetBar$View$ViewModel,
			model.gx,
			_List_Nil,
			mobileDashboardOn,
			budget,
			model.c5,
			zone,
			model.jS.ej,
			model.fI.am,
			{aT: model.jS.aT, bf: model.jS.i6, e5: model.jS.e5});
		var budgetBar = $author$project$BudgetBar$View$view(
			_Utils_update(
				baseBudgetBar,
				{aY: todaysFees}));
		var activityFeedView = A3($author$project$Timesheet$View$activityFeed, zone, model, model.aU);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('timesheet-page'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'timesheet-header'),
					$elm$html$Html$Attributes$class('relative flex flex-col h-full overflow-hidden'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('fade-in-animation', animationsOn)
						])),
					$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$CloseFee)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full flex h-16 sm:h-20')
								]),
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								!model.fI.am,
								_List_fromArray(
									[budgetBar]),
								A2(
									$author$project$CoreX$Appendable$andAppend,
									_List_fromArray(
										[
											A2($author$project$Timesheet$View$titleAndSearchView, zone, feeSearchConfiguration),
											A2($author$project$Timesheet$Views$ActionBar$actionBarView, model.jS.i7, feeSearchConfiguration)
										]),
									A3(
										$author$project$CoreX$Appendable$andAppendIf,
										model.fI.am,
										_List_fromArray(
											[budgetBar]),
										_List_Nil))))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex h-full overflow-hidden')
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						!model.fI.am,
						_List_fromArray(
							[activityFeedView]),
						A2(
							$author$project$CoreX$Appendable$andAppend,
							_List_fromArray(
								[
									A4($author$project$Timesheet$View$timesheetFees, zone, model, model.aU, baseBudgetBar)
								]),
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								model.fI.am,
								_List_fromArray(
									[activityFeedView]),
								_List_Nil))))
				]));
	});
var $author$project$Activities$Messages$AcceptActivities = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$MergeFeesToolbar$renderTooltipText = F3(
	function (action, numOfFees, numOfActivities) {
		return $elm$html$Html$text(
			function () {
				var _v0 = _Utils_Tuple2(numOfFees, numOfActivities);
				if (!_v0.a) {
					return action + ' Activities';
				} else {
					if (!_v0.b) {
						return action + ' Fees';
					} else {
						return action + ' Items';
					}
				}
			}());
	});
var $author$project$Components$MergeFeesToolbar$chargeButton = F2(
	function (numOfActivities, activityIds) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ml-2 w-8 h-8 tooltip cursor-pointer'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'charge-button'),
					$elm$html$Html$Events$onClick(
					$author$project$TimesheetPage$Messages$ActivityFeedComponent(
						$author$project$Activities$Messages$AcceptActivities(activityIds)))
				]),
			_List_fromArray(
				[
					$author$project$Icons$Tick$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-white stroke-current fill-white hover:text-mt-purple-lighter')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltiptext mt-12 w-26 shadow-sm')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$MergeFeesToolbar$renderTooltipText, 'Charge', 0, numOfActivities)
						]))
				]));
	});
var $author$project$TimesheetPage$Messages$ResetSelectedForMerge = {$: 36};
var $author$project$Components$MergeFeesToolbar$closeButton = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('ml-8 tooltip')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-4 h-4'),
					$elm$html$Html$Attributes$class('cursor-pointer'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'merge-bar-close'),
					$elm$html$Html$Events$onClick($author$project$TimesheetPage$Messages$ResetSelectedForMerge)
				]),
			_List_fromArray(
				[
					$author$project$Icons$CloseCross$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('stroke-current text-white hover:text-mt-purple-lighter')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltiptext mt-8')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Close')
						]))
				]))
		]));
var $author$project$TimesheetPage$Messages$DeleteFeesAndActivities = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$MergeFeesToolbar$deleteButton = F2(
	function (_v0, _v1) {
		var numOfFees = _v0.a;
		var feeIds = _v0.b;
		var numOfActivities = _v1.a;
		var activityIds = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ml-2 h-5 h-5 tooltip cursor-pointer'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'delete-button'),
					$elm$html$Html$Events$onClick(
					A2($author$project$TimesheetPage$Messages$DeleteFeesAndActivities, feeIds, activityIds))
				]),
			_List_fromArray(
				[
					$author$project$Icons$RubbishBin$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-white stroke-current fill-white hover:text-mt-purple-lighter')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltiptext mt-12 w-26 shadow-sm')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$MergeFeesToolbar$renderTooltipText, 'Delete', numOfFees, numOfActivities)
						]))
				]));
	});
var $author$project$Components$MergeFeesToolbar$activityCount = function (numOfFees) {
	if (numOfFees === 1) {
		return '1 Activity';
	} else {
		var c = numOfFees;
		return $elm$core$String$fromInt(c) + ' Activities';
	}
};
var $author$project$Components$MergeFeesToolbar$feeCount = function (numOfFees) {
	if (numOfFees === 1) {
		return '1 Fee';
	} else {
		var c = numOfFees;
		return $elm$core$String$fromInt(c) + ' Fees';
	}
};
var $author$project$Components$MergeFeesToolbar$feeAndActivityCount = F2(
	function (numOfFees, numOfActivities) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-white')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						var _v0 = _Utils_Tuple2(numOfFees, numOfActivities);
						if (!_v0.a) {
							var na = _v0.b;
							return $author$project$Components$MergeFeesToolbar$activityCount(na);
						} else {
							if (!_v0.b) {
								var nf = _v0.a;
								return $author$project$Components$MergeFeesToolbar$feeCount(nf);
							} else {
								var nf = _v0.a;
								var na = _v0.b;
								return $author$project$Components$MergeFeesToolbar$feeCount(nf) + (' and ' + $author$project$Components$MergeFeesToolbar$activityCount(na));
							}
						}
					}() + ' Selected')
				]));
	});
var $author$project$Components$MergeFeesToolbar$toolTipSpan = function (tipText) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tooltiptext mt-24 shadow-sm')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(tipText)
			]));
};
var $author$project$Components$MergeFeesToolbar$feeTypeButton = function (feeType) {
	var desc = A2(
		$elm$core$Maybe$withDefault,
		'Select Fee Type',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dd;
			},
			feeType));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tooltip')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-start items-center gap-1'),
						$elm$html$Html$Attributes$class('text-white hover:text-mt-purple-lightest group'),
						$elm$html$Html$Attributes$class('max-w-48 truncate'),
						$elm$html$Html$Attributes$class('cursor-pointer'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'select-fee-type-button'),
						$elm$html$Html$Events$onClick(
						$author$project$TimesheetPage$Messages$MergeFeesAction(
							$o_train$elm_search_input$Select$Set(
								$o_train$elm_search_input$Select$Mode(0)))),
						$elm$html$Html$Attributes$title(desc)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(desc)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-2 h-0 w-0 border-r-6 border-l-6 border-r-transparent border-l-transparent  border-t-6 border-t-white group-hover:border-t-mt-purple-lightest')
							]),
						_List_Nil),
						$author$project$Components$MergeFeesToolbar$toolTipSpan('Change Fee Type')
					]))
			]));
};
var $author$project$Components$MergeFeesToolbar$mergeButton = F2(
	function (numOfFees, numOfActivities) {
		var action = (numOfActivities > 0) ? 'Charge and Merge' : 'Merge';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ml-1 w-6 h-6 tooltip cursor-pointer'),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'merge-button'),
					$elm$html$Html$Events$onClick(
					$author$project$TimesheetPage$Messages$Consolidate(0))
				]),
			_List_fromArray(
				[
					$author$project$Icons$MergeArrow$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('text-white stroke-current hover:text-mt-purple-lighter')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltiptext mt-12 w-26 shadow-sm')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$MergeFeesToolbar$renderTooltipText, action, numOfFees, numOfActivities)
						]))
				]));
	});
var $author$project$Components$MergeFeesToolbar$selectInputView = F2(
	function (msg, selectInput) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-search-input-containerbot')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-search-input-container2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$TimesheetPage$Messages$MergeFeesAction,
							A2(
								$elm$html$Html$map,
								msg,
								$o_train$elm_search_input$Select$view(selectInput)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('arrow arrow-down')
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$MergeFeesToolbar$mergeFeesToolbar = function (mergeFees) {
	var numOfFees = $elm$core$Set$size(mergeFees.dD);
	var numOfActivities = $elm$core$Set$size(mergeFees.cQ);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex justify-center absolute bottom-6 md:bottom-20 w-full animate-fade-in pointer-events-none'),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'merge-bar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4 justify-between items-center pointer-events-auto'),
						$elm$html$Html$Attributes$class('w-screen md:w-168'),
						$elm$html$Html$Attributes$class('h-14 px-8 rounded-full'),
						$elm$html$Html$Attributes$class('bg-mt-purple drop-shadow')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-center items-center gap-4')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$MergeFeesToolbar$feeAndActivityCount, numOfFees, numOfActivities)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-center items-center gap-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm_community$html_extra$Html$Extra$viewIf,
								mergeFees.cY,
								$author$project$Components$MergeFeesToolbar$feeTypeButton(
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.aa;
										},
										mergeFees.eZ.e0))),
								A2(
								$elm_community$html_extra$Html$Extra$viewIf,
								$o_train$elm_search_input$Select$isOpen(mergeFees.eZ),
								A2($author$project$Components$MergeFeesToolbar$selectInputView, $elm$core$Basics$identity, mergeFees.eZ)),
								A2(
								$elm_community$html_extra$Html$Extra$viewIf,
								numOfActivities > 1,
								A2($author$project$Components$MergeFeesToolbar$chargeButton, numOfActivities, mergeFees.cQ)),
								A2(
								$elm_community$html_extra$Html$Extra$viewIf,
								mergeFees.cY,
								A2($author$project$Components$MergeFeesToolbar$mergeButton, numOfFees, numOfActivities)),
								A2(
								$author$project$Components$MergeFeesToolbar$deleteButton,
								_Utils_Tuple2(numOfFees, mergeFees.dD),
								_Utils_Tuple2(numOfActivities, mergeFees.cQ)),
								$author$project$Components$MergeFeesToolbar$closeButton
							]))
					]))
			]));
};
var $author$project$Components$MergeFeesToolbar$view = function (model) {
	if (!model.$) {
		var mergeFees = model.a;
		return $author$project$Components$MergeFeesToolbar$mergeFeesToolbar(mergeFees);
	} else {
		return $elm_community$html_extra$Html$Extra$nothing;
	}
};
var $author$project$Components$Modal$View$ModalView = F4(
	function (role, dimensions, visible, contents) {
		return {c3: contents, de: dimensions, i_: role, bl: visible};
	});
var $author$project$TimesheetPage$Messages$ContactModalEdit = function (a) {
	return {$: 93, a: a};
};
var $author$project$Components$ContactModal$Messages$CreateExchangeContact = {$: 7};
var $author$project$Components$ContactModal$Messages$SetCompanyName = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ContactModal$Messages$SetGivenNames = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ContactModal$Messages$SetJobTitle = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$ContactModal$Messages$SetNotes = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ContactModal$Messages$SetSurname = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ContactModal$View$contactExistsMessage = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mx-auto w-64')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-mt-red text-xs')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('We found an existing contact. Create anyway, or cancel and adjust your address book in Outlook.')
					]))
			]))
	]);
var $author$project$Components$ContactModal$Messages$SetEmailAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ContactModal$View$contactExistsErrorMessage = F2(
	function (originallyFrom, conflictingContact) {
		if (conflictingContact.$ === 1) {
			return _List_Nil;
		} else {
			var contactName = conflictingContact.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xs text-mt-red')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								switch (originallyFrom) {
									case 0:
										return contactName + ' already exists for this phone number';
									case 1:
										return contactName + ' already exists for this address';
									default:
										return '';
								}
							}())
						]))
				]);
		}
	});
var $author$project$Components$ContactModal$View$inputLabel = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-xs text-mt-grey mt-1')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Components$ContactModal$View$textInputField = F4(
	function (role, label, val, msg) {
		var autoFocus = function () {
			var _v0 = msg('');
			if (!_v0.$) {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-1')
				]),
			_List_fromArray(
				[
					$author$project$Components$ContactModal$View$inputLabel(label),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-6 text-base text-grey-darkest w-full border-b border-mt-grey-lighter focus:border-b-2 focus:border-mt-purple transition-2 mb-3'),
							$elm$html$Html$Attributes$type_('text'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-' + role),
							$elm$html$Html$Attributes$value(val),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$TimesheetPage$Messages$ContactModalEdit, msg)),
							$elm$html$Html$Attributes$autofocus(autoFocus)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$ContactModal$View$emailInput = function (modal) {
	return (!modal.iz) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-1')
			]),
		_List_fromArray(
			[
				$author$project$Components$ContactModal$View$inputLabel('Email Address'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-6 mb-3 font-light'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-email')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(modal.dl)
					]))
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-email-parent')
			]),
		A3(
			$author$project$CoreX$Appendable$andAppendIf,
			modal.iz === 1,
			A2($author$project$Components$ContactModal$View$contactExistsErrorMessage, modal.iz, modal.c1),
			_List_fromArray(
				[
					A4(
					$author$project$Components$ContactModal$View$textInputField,
					'email',
					'Email Address',
					modal.dl,
					function (e) {
						return $author$project$Components$ContactModal$Messages$SetEmailAddress(e);
					})
				])));
};
var $author$project$Components$ContactModal$Messages$SetPhoneNumber = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ContactModal$View$phoneInput = function (modal) {
	return (modal.iz === 1) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-1')
			]),
		_List_fromArray(
			[
				$author$project$Components$ContactModal$View$inputLabel('Phone Number'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-6 mb-3 font-light'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-phone')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(modal.iH)
					]))
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-phone-parent')
			]),
		A3(
			$author$project$CoreX$Appendable$andAppendIf,
			!modal.iz,
			A2($author$project$Components$ContactModal$View$contactExistsErrorMessage, modal.iz, modal.c1),
			_List_fromArray(
				[
					A4(
					$author$project$Components$ContactModal$View$textInputField,
					'phone',
					'Phone Number',
					modal.iH,
					function (e) {
						return $author$project$Components$ContactModal$Messages$SetPhoneNumber(e);
					})
				])));
};
var $author$project$Components$ContactModal$Views$PendulumLoading$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('pt-8 pendulum-holder'),
			A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-loading')
		]),
	$author$project$Icons$LoadingPendulum$view);
var $author$project$Components$ContactModal$View$view = function (modal) {
	var modalFlashMessage = (modal.gM === '') ? 'Contact required to upgrade.' : modal.gM;
	var createButtonText = function () {
		var _v0 = modal.c1;
		if (_v0.$ === 1) {
			return 'Create Outlook Contact';
		} else {
			return 'Create Contact Anyway';
		}
	}();
	return _List_fromArray(
		[
			modal.bV ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute z-30 left-0 w-full h-full overflow-auto bg-black-60')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center m-auto mt-32 h-64 w-1/2 bg-white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pt-8')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Creating an Outlook contact please wait...')
								])),
							$author$project$Components$ContactModal$Views$PendulumLoading$view
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hidden')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full text-center text-sm'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-mt-grey-lighter lighter', modal.gM === ''),
							_Utils_Tuple2('bg-mt-red-light text-white', modal.gM !== '')
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-flash-message')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-16 overflow-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Icons$Warning$viewWithAttributes(
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('inline h-5 w-5 pr-1 fill-current icon icon--warning')
												]))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(modalFlashMessage)
										]))
								]))
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pt-3 px-5 max-w-sm')
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex mt-2 md:block max-w-sm')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-create-button'),
										$elm$html$Html$Attributes$class('block mx-auto border rounded-full bg-mt-purple-light text-white border-none transition-2'),
										$elm$html$Html$Attributes$class('hover:bg-mt-purple-dark'),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Events$onClick(
										$author$project$TimesheetPage$Messages$ContactModalEdit($author$project$Components$ContactModal$Messages$CreateExchangeContact))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(createButtonText)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-cancel-button'),
										$elm$html$Html$Attributes$class('block mx-auto text-sm text-mt-grey-light underline border-0 hover:text-mt-purple-light'),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Events$onClick(
										$author$project$TimesheetPage$Messages$ModalAction($author$project$Components$Modal$Model$Closed))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('cancel')
									]))
							]))
					]),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					$author$project$Components$ContactModal$ContactModalLogic$hasConflictingContact(modal),
					$author$project$Components$ContactModal$View$contactExistsMessage,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-lg text-center text-mt-purple font-bold my-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create New Outlook Contact')
								])),
							A4(
							$author$project$Components$ContactModal$View$textInputField,
							'given-names',
							'Given names',
							modal.hf,
							function (e) {
								return $author$project$Components$ContactModal$Messages$SetGivenNames(e);
							}),
							A4(
							$author$project$Components$ContactModal$View$textInputField,
							'surname',
							'Surname',
							modal.jo,
							function (e) {
								return $author$project$Components$ContactModal$Messages$SetSurname(e);
							}),
							$author$project$Components$ContactModal$View$emailInput(modal),
							$author$project$Components$ContactModal$View$phoneInput(modal),
							A4(
							$author$project$Components$ContactModal$View$textInputField,
							'company-name',
							'Company Name',
							modal.gh,
							function (e) {
								return $author$project$Components$ContactModal$Messages$SetCompanyName(e);
							}),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xxs font-semibold bg-mt-grey-lightest border-t border-b')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Below fields only supported by Office365 (with MSGraph) users')
								])),
							A4(
							$author$project$Components$ContactModal$View$textInputField,
							'notes',
							'Personal Notes',
							modal.ik,
							function (e) {
								return $author$project$Components$ContactModal$Messages$SetNotes(e);
							}),
							A4(
							$author$project$Components$ContactModal$View$textInputField,
							'job-title',
							'Job Title',
							modal.hO,
							function (e) {
								return $author$project$Components$ContactModal$Messages$SetJobTitle(e);
							})
						]))))
		]);
};
var $author$project$Components$FileNotes$Messages$Close = {$: 1};
var $author$project$Components$FileNotes$Messages$Save = {$: 8};
var $author$project$Components$FileNotes$Messages$SetUnits = function (a) {
	return {$: 15, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Components$FileNotes$Model$checkFolder = function (model) {
	var _v0 = model.E.by;
	switch (_v0) {
		case 1:
			return $elm_community$maybe_extra$Maybe$Extra$isJust(model.cn.e0) ? $elm$core$Result$Ok(model) : $elm$core$Result$Err('Must select a folder');
		case 0:
			return $elm$core$Result$Ok(model);
		default:
			return $elm$core$Result$Ok(model);
	}
};
var $author$project$Components$FileNotes$Model$checkLibrary = function (model) {
	var _v0 = model.E.by;
	switch (_v0) {
		case 1:
			return $elm_community$maybe_extra$Maybe$Extra$isJust(model.co.e0) ? $elm$core$Result$Ok(model) : $elm$core$Result$Err('Must select a library');
		case 0:
			return $elm$core$Result$Ok(model);
		default:
			return $elm$core$Result$Ok(model);
	}
};
var $author$project$Components$FileNotes$Model$mapValid = F3(
	function (label, model, isValid) {
		return isValid ? $elm$core$Result$Ok(model) : $elm$core$Result$Err(label + ' is invalid');
	});
var $author$project$Components$FileNotes$Model$checkResource = function (model) {
	var _v0 = model.bI;
	if (_v0.$ === 1) {
		return A3(
			$author$project$Components$FileNotes$Model$mapValid,
			'Matter',
			model,
			!_Utils_eq(model.cq, $elm$core$Maybe$Nothing));
	} else {
		if (_v0.c.$ === 1) {
			var _v1 = _v0.c;
			return A3($author$project$Components$FileNotes$Model$mapValid, 'Fee', model, false);
		} else {
			return A3($author$project$Components$FileNotes$Model$mapValid, 'Fee', model, true);
		}
	}
};
var $author$project$Components$FileNotes$Model$hasContent = F3(
	function (getter, label, model) {
		return A3(
			$author$project$Components$FileNotes$Model$mapValid,
			label,
			model,
			!$elm$core$String$isEmpty(
				getter(model)));
	});
var $author$project$Components$FileNotes$Model$checkValid = function (model) {
	return A2(
		$elm$core$Result$andThen,
		A2(
			$author$project$Components$FileNotes$Model$hasContent,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dH;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ij;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function ($) {
								return $.go;
							}),
						$elm$core$Maybe$withDefault('')))),
			'Content'),
		A2(
			$elm$core$Result$andThen,
			A2(
				$author$project$Components$FileNotes$Model$hasContent,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dH;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ij;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								function ($) {
									return $.jB;
								}),
							$elm$core$Maybe$withDefault('')))),
				'Title'),
			A2(
				$elm$core$Result$andThen,
				$author$project$Components$FileNotes$Model$checkFolder,
				A2(
					$elm$core$Result$andThen,
					$author$project$Components$FileNotes$Model$checkLibrary,
					A2(
						$elm$core$Result$andThen,
						$author$project$Components$FileNotes$Model$checkResource,
						$elm$core$Result$Ok(model))))));
};
var $author$project$Components$MatterInput$Views$EditMode$Model$createEditModel = F5(
	function (domId, pms, matter, model, searchTerms) {
		return {gG: domId, bF: searchTerms, aB: false, a_: false, h$: model, ce: pms, cq: matter};
	});
var $author$project$Components$FileNotes$View$fieldSelectorLabel = F3(
	function (str, selected, results) {
		var desc = function () {
			if (results.$ === 1) {
				return 'Loading...';
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					'Select ' + str,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ec;
						},
						selected));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-start items-center gap-1'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'file-note-field-' + str),
							$elm$html$Html$Attributes$class('text-mt-purple hover:text-mt-purple-darker group'),
							$elm$html$Html$Attributes$class('max-w-64'),
							$elm$html$Html$Attributes$class('cursor-pointer'),
							$elm$html$Html$Attributes$tabindex(0),
							$elm$html$Html$Events$onClick(
							$o_train$elm_search_input$Select$Set(
								$o_train$elm_search_input$Select$Mode(0))),
							$elm$html$Html$Events$onFocus(
							$o_train$elm_search_input$Select$Set(
								$o_train$elm_search_input$Select$Mode(0)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('truncate')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(desc)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-2 h-0 w-0 border-r-6 border-l-6 border-r-transparent border-l-transparent  border-t-6 border-t-white group-hover:border-t-mt-purple-lightest')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext mt-8')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change ' + str)
								]))
						]))
				]));
	});
var $author$project$Components$FileNotes$View$fieldSelector = F2(
	function (msg, selectModel) {
		return A2(
			$elm$html$Html$map,
			msg,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-semibold mb-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(selectModel.ec)
							])),
						A3($author$project$Components$FileNotes$View$fieldSelectorLabel, selectModel.ec, selectModel.e0, selectModel.eV.iV),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						$o_train$elm_search_input$Select$isOpen(selectModel),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('elm-search-input-container1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('arrow arrow-up')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('elm-search-input-container2')
										]),
									_List_fromArray(
										[
											$o_train$elm_search_input$Select$view(selectModel)
										]))
								])))
					])));
	});
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Components$FileNotes$FilingStatusLogic$isFileable = function (filingStatus) {
	var _v0 = filingStatus.dG;
	switch (_v0.$) {
		case 0:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		default:
			return true;
	}
};
var $author$project$Components$FileNotes$View$statusMessage = function (filingStatus) {
	var statusMessageContainer = F3(
		function (bgColour, textColour, message) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(bgColour),
						$elm$html$Html$Attributes$class('text-white font-semibold'),
						$elm$html$Html$Attributes$class('animate-slide-down-height'),
						$elm$html$Html$Attributes$class('h-full max-h-16 rounded-sm'),
						$elm$html$Html$Attributes$class('flex items-center justify-between py-2 px-8'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'file-note-flash')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(textColour),
								$elm$html$Html$Attributes$class('max-w-128 truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							])),
						A2(
						$elm_community$html_extra$Html$Extra$viewMaybe,
						function (id) {
							return A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'file-note-check-status'),
										$elm$html$Html$Attributes$class('px-5 py-1 border border-current rounded-full hover:no-underline'),
										$elm$html$Html$Attributes$class(textColour),
										$elm$html$Html$Attributes$href(
										'/filing_statuses/' + $elm$core$String$fromInt(id)),
										$elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Check Status')
									]));
						},
						filingStatus.aC)
					]));
		});
	var _v0 = filingStatus.dG;
	switch (_v0.$) {
		case 0:
			return A3(statusMessageContainer, 'bg-mt-green-dark', 'text-white', 'Sent File Note');
		case 2:
			return A3(statusMessageContainer, 'bg-mt-yellow-darkest', 'text-black', 'Sending File Note...');
		case 3:
			return A3(statusMessageContainer, 'bg-mt-yellow-darkest', 'text-black', 'Sending File Note...');
		case 4:
			return A3(statusMessageContainer, 'bg-mt-yellow-darkest', 'text-black', 'Renaming File Note...');
		case 5:
			return A3(statusMessageContainer, 'bg-mt-red-dark', 'text-white', 'Failed to rename File Note');
		case 1:
			var reason = _v0.a;
			return A3(statusMessageContainer, 'bg-mt-red-dark', 'text-white', 'Failed for reason: ' + reason);
		case 6:
			return A3(statusMessageContainer, 'bg-mt-purple-dark', 'text-white', 'Selection of folder required');
		case 7:
			return A3(statusMessageContainer, 'bg-mt-red-dark', 'text-white', 'Cancelled filing');
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-0 hidden')
					]),
				_List_Nil);
	}
};
var $author$project$Components$FileNotes$View$view = function (model) {
	var isFileable = $author$project$Components$FileNotes$FilingStatusLogic$isFileable(model.dH);
	var _v0 = function () {
		var _v1 = $author$project$Components$FileNotes$Model$checkValid(model);
		if (!_v1.$) {
			return _Utils_Tuple2(true, 'Save file note');
		} else {
			var str = _v1.a;
			return _Utils_Tuple2(false, str);
		}
	}();
	var isValidNote = _v0.a;
	var clickMsg = _v0.b;
	var isSaveable = isValidNote && isFileable;
	var _v2 = model.dH.ij;
	if (_v2.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Must be a File Note')
				]));
	} else {
		var fileNote = _v2.a;
		var fileNoteLabel = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'File Note',
			function ($) {
				return $.ec;
			},
			model.bH);
		var fileNoteTitle = A3(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aC;
			},
			$elm_community$maybe_extra$Maybe$Extra$isJust,
			fileNote) ? fileNoteLabel : ('New ' + fileNoteLabel);
		var appendUnits = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			false,
			function ($) {
				return $.fN;
			},
			model.bH);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'file-note-modal'),
					$elm$html$Html$Attributes$class('flex flex-col w-screen md:w-auto md:max-w-168 gap-2 md:gap-4 px-2 py-2 md:py-8 h-full md:max-h-screen--32')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex h-fit md:mb-4 items-center justify-between')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-0 font-light text-2xl md:text-3xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(fileNoteTitle)
								])),
							$author$project$Icons$CloseCross$viewWithAttributes(
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								isFileable,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-confirm', 'Your data will be lost')
									]),
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('bg-white stroke-4 stroke-mt-grey-light hover:stroke-mt-grey cursor-pointer rounded-full h-6 w-6'),
										$elm$html$Html$Events$onClick($author$project$Components$FileNotes$Messages$Close)
									])))
						])),
					$author$project$Components$FileNotes$View$statusMessage(model.dH),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-semibold mb-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Title')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('file-note-title'),
									$elm$html$Html$Attributes$class('border p-2 rounded-sm w-full focus:border-mt-purple-light'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'file-note-input'),
									$elm$html$Html$Attributes$placeholder('Enter File Note Title'),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$value(fileNote.jB),
									$author$project$OnChange$onChange($author$project$Components$FileNotes$Messages$SetTitle)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-semibold mb-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Matter')
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$FileNotes$Messages$MatterInputMessage,
							A3(
								$author$project$Components$MatterInput$View$view,
								A5($author$project$Components$MatterInput$Views$EditMode$Model$createEditModel, 'file-note-matter-selection', model.ce, model.cq, model.eg, $elm$core$Maybe$Nothing),
								true,
								2))
						])),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					model.E.by === 1,
					A2($author$project$Components$FileNotes$View$fieldSelector, $author$project$Components$FileNotes$Messages$SelectLibraryMessage, model.co)),
					A2($author$project$Components$FileNotes$View$fieldSelector, $author$project$Components$FileNotes$Messages$SelectFolderMessage, model.cn),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					$elm_community$maybe_extra$Maybe$Extra$isNothing(
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.aC;
							},
							model.dH.ij)),
					A2($author$project$Components$FileNotes$View$fieldSelector, $author$project$Components$FileNotes$Messages$SelectTemplateMessage, model.e$)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-semibold mb-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Content')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row justify-between px-6'),
									$elm$html$Html$Attributes$id('file-note-editor'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'file-note-content-editor')
								]),
							_List_Nil)
						])),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					appendUnits && (!_Utils_eq(model.bI, $author$project$Components$FileNotes$Types$FileNote$ForMatter)),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-semibold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Number of Units')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm text-mt-grey-light')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Duration of time taken creating file note.')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center gap-x-3 mt-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										A3(
											$author$project$CoreX$Appendable$andAppendIf,
											model.jP <= 0,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$disabled(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-7 h-7 min-w-7 p-0 rounded-full bg-black text-white text-base leading-none flex items-center justify-center cursor-pointer'),
													$elm$html$Html$Events$onClick(
													$author$project$Components$FileNotes$Messages$SetUnits(model.jP - 1))
												])),
										_List_fromArray(
											[
												$elm$html$Html$text('−')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-10 h-8 border border-mt-grey-light rounded text-center leading-8 text-base')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(model.jP))
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-7 h-7 min-w-7 p-0 rounded-full bg-black text-white text-base leading-none flex items-center justify-center cursor-pointer'),
												$elm$html$Html$Events$onClick(
												$author$project$Components$FileNotes$Messages$SetUnits(model.jP + 1))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('+')
											]))
									]))
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center mt-4')
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						isFileable,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								A3(
									$author$project$CoreX$Appendable$andAppendIf,
									isSaveable,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Components$FileNotes$Messages$Save)
										]),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('py-1 px-5 text-center rounded-full text-white bg-mt-purple-dark cursor-pointer', isSaveable),
													_Utils_Tuple2('btn-disabled border rounded-full px-5 py-1', !isSaveable)
												])),
											$elm$html$Html$Attributes$disabled(!isSaveable),
											A2($elm$html$Html$Attributes$attribute, 'data-role', 'save-file-note'),
											$elm$html$Html$Attributes$title(clickMsg)
										])),
								_List_fromArray(
									[
										$elm$html$Html$text('Save and File')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								A3(
									$author$project$CoreX$Appendable$andAppendIf,
									isFileable,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'data-confirm', 'Your data will be lost')
										]),
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Components$FileNotes$Messages$Close),
											$elm$html$Html$Attributes$class('cursor-pointer text-mt-grey-light')
										])),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							]))),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				]));
	}
};
var $author$project$Components$SplitFee$Messages$Close = {$: 1};
var $author$project$Components$SplitFee$Messages$ConfirmSplit = {$: 3};
var $author$project$Components$SplitFee$View$matterInputView = F2(
	function (source, model) {
		var feeInput = A3($author$project$Components$SplitFee$Model$applyEither, source, $elm$core$Basics$identity, model);
		var domId_ = A2($author$project$Components$SplitFee$Update$domId, source, model);
		return A2(
			$elm$html$Html$map,
			$author$project$Components$SplitFee$Messages$MatterInputMessage(source),
			A3(
				$author$project$Components$MatterInput$View$view,
				A5($author$project$Components$MatterInput$Views$EditMode$Model$createEditModel, domId_, model.ce, feeInput.cq, feeInput.eg, $elm$core$Maybe$Nothing),
				true,
				2));
	});
var $author$project$Components$SplitFee$View$renderTxt = F2(
	function (cls, txt) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-medium ' + cls)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(txt)
				]));
	});
var $author$project$Components$SplitFee$View$renderDuration = F2(
	function (source, model) {
		var durationText = function (_v0) {
			var durationInSeconds = _v0.bz;
			return A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$CoreX$DateFormat$formatDuration,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$append('Duration: '),
						$author$project$Components$SplitFee$View$renderTxt('text-mt-grey-light'))),
				durationInSeconds);
		};
		return A3($author$project$Components$SplitFee$Model$applyEither, source, durationText, model);
	});
var $author$project$Components$SplitFee$View$renderMeasure = F2(
	function (source, model) {
		var renderUnits = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Components$SplitFee$View$renderTxt('text-mt-grey-light'),
				$elm$core$Basics$append('Units: ')),
			$elm$core$String$fromFloat);
		var renderDurationInput = function (durationInput) {
			var _v1 = $author$project$Components$DurationInput$DurationInputLogic$toHoursMins(durationInput);
			var hours = _v1.a;
			var mins = _v1.b;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Components$SplitFee$View$renderTxt, 'text-mt-grey-light', 'Minutes: ' + (hours + (':' + mins)))
					]));
		};
		var measureText = function (_v0) {
			var measure = _v0.b_;
			return A3($author$project$Components$SplitFee$Model$applyFeeMeaure, measure, renderUnits, renderDurationInput);
		};
		return A3($author$project$Components$SplitFee$Model$applyEither, source, measureText, model);
	});
var $author$project$Components$SplitFee$View$renderPercentage = F2(
	function (source, model) {
		var totalHundredths = model.bh;
		var newPercent = $elm$core$Basics$round(
			($author$project$Components$SplitFee$Model$newHundredths(model) * 100) / totalHundredths);
		var badge = F2(
			function (cls, percent) {
				return A2(
					$author$project$Components$SplitFee$View$renderTxt,
					cls,
					$elm$core$String$fromInt(percent) + '%');
			});
		return A4(
			$author$project$Components$SplitFee$Model$applyFeeInput,
			source,
			$elm$core$Basics$always(
				A2(badge, 'd-badge d-badge-neutral', 100 - newPercent)),
			$elm$core$Basics$always(
				A2(badge, 'd-badge d-badge-primary bg-mt-purple border-mt-purple', newPercent)),
			model);
	});
var $author$project$Components$SplitFee$View$renderSource = function (source) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Components$SplitFee$View$renderTxt('text-black'),
		A3(
			$author$project$Components$SplitFee$Model$applyFeeInput,
			source,
			$elm$core$Basics$always('Original'),
			$elm$core$Basics$always('New')));
};
var $author$project$Components$SplitFee$View$feeInputView = F2(
	function (source, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-y-8 w-full')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center gap-x-2')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$SplitFee$View$renderPercentage, source, model),
									A2($author$project$Components$SplitFee$View$renderSource, source, model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center gap-x-8')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$SplitFee$View$renderMeasure, source, model),
									A2(
									$elm$core$Maybe$withDefault,
									$elm_community$html_extra$Html$Extra$nothing,
									A2($author$project$Components$SplitFee$View$renderDuration, source, model))
								]))
						])),
					A2($author$project$Components$SplitFee$View$matterInputView, source, model)
				]));
	});
var $author$project$Components$SplitFee$View$rangeInputView = function (model) {
	var newSteps = model.b4;
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('range'),
				$elm$html$Html$Attributes$min('1'),
				$elm$html$Html$Attributes$max(
				$elm$core$String$fromInt(
					$author$project$Components$SplitFee$Model$maxSteps(model))),
				$elm$html$Html$Attributes$step('1'),
				$elm$html$Html$Attributes$class('d-range d-range-xs my-8 w-full [--d-range-bg:#5B2EFF]'),
				$elm$html$Html$Attributes$value(
				$elm$core$String$fromInt(newSteps)),
				$elm$html$Html$Events$onInput($author$project$Components$SplitFee$Messages$SplitChanged)
			]),
		_List_Nil);
};
var $author$project$Components$SplitFee$View$splitControlView = function (model) {
	return ($author$project$Components$SplitFee$Model$maxSteps(model) < 1) ? A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('my-8 text-center text-mt-grey-light')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('This fee can\'t be split at this increment.')
			])) : $author$project$Components$SplitFee$View$rangeInputView(model);
};
var $author$project$Components$SplitFee$View$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full px-8')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-medium text-2xl mb-8')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Split Fee')
					])),
				A2($author$project$Components$SplitFee$View$feeInputView, 0, model),
				$author$project$Components$SplitFee$View$splitControlView(model),
				A2($author$project$Components$SplitFee$View$feeInputView, 1, model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between mt-8')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'split-fee-modal-cancel-button'),
								$elm$html$Html$Attributes$class('text-sm w-fit text-mt-grey-light underline border-0'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick($author$project$Components$SplitFee$Messages$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'split-fee-button'),
								$elm$html$Html$Attributes$class('d-btn d-btn-active d-btn-primary bg-mt-purple border-mt-purple rounded-full text-white font-medium hover:no-underline'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick($author$project$Components$SplitFee$Messages$ConfirmSplit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Split Fee')
							]))
					]))
			]));
};
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Components$UiInfoAlerts$Messages$Close = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$UiInfoAlerts$Messages$ContinueMerge = function (a) {
	return {$: 2, a: a};
};
var $author$project$TimesheetPage$Messages$UiInfoModalEdit = function (a) {
	return {$: 94, a: a};
};
var $author$project$Components$UiInfoAlerts$View$renderButtonGroup = function (context) {
	if (!context) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn btn-primary my-6 mr-2'),
					$elm$html$Html$Events$onClick(
					$author$project$TimesheetPage$Messages$UiInfoModalEdit(
						$author$project$Components$UiInfoAlerts$Messages$Close(context)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Save and Close')
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex my-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-semibold px-4 py-1 text-mt-purple border border-mt-purple rounded-full mr-2'),
							$elm$html$Html$Attributes$class('hover:text-white hover:bg-mt-purple'),
							$elm$html$Html$Events$onClick(
							$author$project$TimesheetPage$Messages$UiInfoModalEdit(
								$author$project$Components$UiInfoAlerts$Messages$ContinueMerge(1)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Continue')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-semibold px-4 py-1 text-mt-red border border-mt-red rounded-full'),
							$elm$html$Html$Attributes$class('hover:text-white hover:bg-mt-red-light hover:border-mt-red-dark'),
							$elm$html$Html$Events$onClick(
							$author$project$TimesheetPage$Messages$UiInfoModalEdit(
								$author$project$Components$UiInfoAlerts$Messages$Close(context)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel Merge')
						]))
				]));
	}
};
var $author$project$Components$UiInfoAlerts$Messages$Acknowledge = {$: 0};
var $author$project$Components$UiInfoAlerts$View$toggleAcknowledgement = function (acknowledged) {
	var checkBoxModel = {
		ga: 'h-6 w-6',
		gc: $author$project$TimesheetPage$Messages$UiInfoModalEdit($author$project$Components$UiInfoAlerts$Messages$Acknowledge),
		gJ: true,
		gU: _List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-2 pt-6 mx-0')
			]),
		ho: 'Don\'t show this message again',
		hs: 'toggle-acknowledged',
		hM: acknowledged,
		hN: true,
		hR: 'Don\'t show this message again',
		i_: 'toggle-acknowledged',
		jw: 'text-base'
	};
	return $author$project$Components$CheckBox$view(checkBoxModel);
};
var $author$project$Components$UiInfoAlerts$View$view = function (alert) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h5,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-8 text-center relative')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(alert.jB)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mx-8 overflow-y-auto whitespace-pre-line break-normal')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(alert.go)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row justify-between w-full px-6')
						]),
					_List_fromArray(
						[
							$author$project$Components$UiInfoAlerts$View$toggleAcknowledgement(alert.bm),
							$author$project$Components$UiInfoAlerts$View$renderButtonGroup(alert.bs)
						]))
				]))
		]);
};
var $author$project$Timesheet$Conversation$Modal$view = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-5')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-lg text-center text-mt-purple font-bold my-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Fee type missing')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-bold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('A consolidate/merge fee type has not been setup for your firm.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('If you\'d like to use this feature please ask your Practice Manager to set up a System Activity for \'Email conversation\' and/or \'Merged Fees\'')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-small font-light py-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('You may also bypass the system activity requirement if you ensure only one fee type is selected within the group')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block w-64 mx-auto mt-6 mb-2 border rounded-full'),
								$elm$html$Html$Attributes$class('bg-mt-purple-light text-white border-none transition-2'),
								$elm$html$Html$Attributes$class('hover:text-white hover:bg-mt-purple-dark'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'consolidate-setup-close-button'),
								$elm$html$Html$Events$onClick(
								$author$project$TimesheetPage$Messages$ModalAction($author$project$Components$Modal$Model$Closed))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							]))
					]))
			]))
	]);
var $author$project$Components$Modal$View$createModalView = function (model) {
	switch (model.$) {
		case 0:
			var contactModalModel = model.b;
			var sizeClasses = $author$project$Components$ContactModal$ContactModalLogic$hasConflictingContact(contactModalModel) ? 'md:w-90 md:h-192' : 'md:w-90 md:h-180';
			return A4(
				$author$project$Components$Modal$View$ModalView,
				'contact-modal',
				sizeClasses,
				true,
				$author$project$Components$ContactModal$View$view(contactModalModel));
		case 1:
			return A4($author$project$Components$Modal$View$ModalView, 'consolidated-email-type-missing-modal', 'md:w-128 md:h-76', true, $author$project$Timesheet$Conversation$Modal$view);
		case 2:
			var alert = model.a;
			return A4(
				$author$project$Components$Modal$View$ModalView,
				'ui-info-alert-modal',
				'md:w-150 md:h-58',
				true,
				$author$project$Components$UiInfoAlerts$View$view(alert));
		case 3:
			var fileNote = model.a;
			return A4(
				$author$project$Components$Modal$View$ModalView,
				'file-notes-modal',
				'md:h-fit md:w-192 md:min-h-128 md:max-h-screen--32 overflow-y-auto rounded-lg',
				true,
				$elm$core$List$singleton(
					A2(
						$elm$html$Html$map,
						$author$project$TimesheetPage$Messages$FileNote,
						$author$project$Components$FileNotes$View$view(fileNote))));
		case 4:
			var mod = model.a;
			return A4(
				$author$project$Components$Modal$View$ModalView,
				'split-fee-modal',
				'md:w-128 md:h-128 rounded',
				true,
				$elm$core$List$singleton(
					A2(
						$elm$html$Html$map,
						$author$project$TimesheetPage$Messages$SplitFee,
						$author$project$Components$SplitFee$View$view(mod))));
		default:
			return A4($author$project$Components$Modal$View$ModalView, 'hidden-modal', '', false, _List_Nil);
	}
};
var $author$project$Components$Modal$View$viewWithClasses = F2(
	function (msg, model) {
		return model.bl ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed m-auto w-full h-full border bg-white flex flex-col items-center justify-center'),
						$elm$html$Html$Attributes$id('modal-content'),
						$elm$html$Html$Attributes$class('md:inset-0 md:shadow-lg'),
						$elm$html$Html$Attributes$class(model.de),
						$author$project$KeyShortcutEvents$on(
						_List_fromArray(
							[
								_Utils_Tuple2('Escape', msg)
							]))
					]),
				model.c3)
			]) : _List_Nil;
	});
var $author$project$Components$Modal$View$renderModal = F2(
	function (msg, modalView) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('modal'),
					$elm$html$Html$Attributes$class('absolute md:fixed inset-0'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('z-1 opacity-0 h-0 w-0', !modalView.bl),
							_Utils_Tuple2('z-50 opacity-100', modalView.bl)
						])),
					$elm$html$Html$Attributes$class('bg-black-40 transition-opacity duration-300')
				]),
			A2($author$project$Components$Modal$View$viewWithClasses, msg, modalView));
	});
var $author$project$Components$Modal$View$view = function (model) {
	return A2(
		$author$project$Components$Modal$View$renderModal,
		$author$project$TimesheetPage$Messages$ModalAction($author$project$Components$Modal$Model$Closed),
		$author$project$Components$Modal$View$createModalView(model));
};
var $author$project$Model$Fee$RunningTimerBanner = 2;
var $author$project$Components$RunningTimerBanner$feeUnitsAndTotalElapsedTime = F2(
	function (fee, minutesPerUnit) {
		var _v0 = A2($author$project$FeeTimerLogic$getUnitsAndPartialUnitSeconds, minutesPerUnit, fee);
		if (!_v0.$) {
			var timerUnits = _v0.a;
			return _Utils_Tuple2(timerUnits.jP | 0, timerUnits.jK);
		} else {
			return _Utils_Tuple2(0, 0);
		}
	});
var $author$project$FeeTimerLogic$runningTimerPeriods = function (totalMillisecondsPast) {
	var totalSeconds = (totalMillisecondsPast / 1000) | 0;
	var hours = (totalSeconds / 3600) | 0;
	var hourRemainders = A2($elm$core$Basics$modBy, 3600, totalSeconds);
	var minuteRemainders = A2($elm$core$Basics$modBy, 60, hourRemainders);
	var seconds = A2($elm$core$Basics$modBy, 60, minuteRemainders);
	var minutes = (hourRemainders / 60) | 0;
	return {_: hours, aF: minutes, cm: seconds};
};
var $author$project$FeeTimerLogic$formatTimeElapsed = function (totalMillisecondsPast) {
	var timePeriods = $author$project$FeeTimerLogic$runningTimerPeriods(totalMillisecondsPast);
	var padZeroes = function (num) {
		return A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(num));
	};
	var hideHours = !timePeriods._;
	var displayHours = hideHours ? '' : $elm$core$String$fromInt(timePeriods._);
	return A2(
		$elm$core$String$join,
		':',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					displayHours,
					padZeroes(timePeriods.aF),
					padZeroes(timePeriods.cm)
				])));
};
var $author$project$Components$RunningTimerBanner$view = F4(
	function (zone, pms, entries, minutesPerUnit) {
		var _v0 = $author$project$FeeTimerLogic$getRunningTimer(entries);
		if (_v0.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden')
					]),
				_List_Nil);
		} else {
			var fee = _v0.a;
			var startedAtText = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.jf;
						},
						$author$project$CoreX$DateFormat$to12HourTimeString(zone)),
					fee.jA));
			var matterModel = A3($author$project$Components$MatterInput$Views$EditMode$Model$createEditModeViewModel, pms, fee, $elm$core$Maybe$Nothing);
			var description = A2($elm$core$Maybe$withDefault, fee.g0.dd, fee.dd);
			var _v1 = A2($author$project$Components$RunningTimerBanner$feeUnitsAndTotalElapsedTime, fee, minutesPerUnit);
			var units = _v1.a;
			var timeRunning = _v1.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('z-30 mitimes-bg-gradient'),
						$elm$html$Html$Attributes$class('absolute md:relative h-screen--12 md:h-24'),
						$elm$html$Html$Attributes$class('text-white bg-mt-purple'),
						$elm$html$Html$Attributes$class('max-w-7xl w-full'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'running-timer-banner')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col md:flex-row w-full px-2 md:px-8'),
								$elm$html$Html$Attributes$class('pt-8 md:pt-0 text-center md:text-left')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full md:w-1/4 text-3xl h-full mt-2.5')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('h-fit truncate')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(description)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pb-2px text-base')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('started at ' + startedAtText)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mx-auto md:ml-4 w-4/5 xl:w-1/4  lg:ml-8 w-1/2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										A2(
											$elm$core$Basics$composeL,
											$author$project$TimesheetPage$Messages$FeeFormEdit(fee.aC),
											$author$project$FeeEntry$Messages$MatterInputMessage),
										A3($author$project$Components$MatterInput$Views$ShowMode$view, matterModel, false, 3))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full md:w-max xl:w-max')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full md:mt-4 h-full align-baseline w-full lg:w-1/2 xl:w-1/3 2xl:w-1/4 mt-12 ')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline md:mt-2 font-light'),
												$elm$html$Html$Attributes$class('text-6xl md:text-7xl'),
												A2($elm$html$Html$Attributes$attribute, 'data-role', 'running-timer-banner-units')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(units))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline md:mt-2 text-sm font-light')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('units')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('block md:inline mt-12 md:mt-2 md:ml-4 font-light'),
												$elm$html$Html$Attributes$class('text-7xl md:text-2xl'),
												A2($elm$html$Html$Attributes$attribute, 'data-role', 'running-timer-banner-running-time'),
												$elm$html$Html$Attributes$class('timer-line-height')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$FeeTimerLogic$formatTimeElapsed(timeRunning))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('block md:inline mt-12 md:mt-0 md:ml-4'),
												A2($elm$html$Html$Attributes$attribute, 'data-role', 'running-timer-banner-stop')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('ml-4 leading-normal bg-transparent font-semibold'),
														$elm$html$Html$Attributes$class('py-4 px-12 md:py-0.5 md:px-6'),
														$elm$html$Html$Attributes$class('text-white text-xl md:text-xs'),
														$elm$html$Html$Attributes$class('border rounded-sm rounded-full border-white'),
														$elm$html$Html$Attributes$class('hover:border-mt-purple hover:bg-white hover:text-mt-purple'),
														$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
														A2($author$project$TimesheetPage$Messages$StopFeeTimer, fee, 2))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('stop')
													]))
											]))
									]))
							]))
					]));
		}
	});
var $author$project$Model$IntegrationStatuses$BannerClosed = 2;
var $author$project$Model$IntegrationStatuses$BannerMaximized = 1;
var $author$project$TimesheetPage$Messages$SetIntegrationStatusBanner = function (a) {
	return {$: 91, a: a};
};
var $author$project$Timesheet$Views$IntegrationStatuses$getStates = F2(
	function (isTrackingActivities, integrationStatuses) {
		return A3(
			$author$project$CoreX$Appendable$andAppendIf,
			isTrackingActivities,
			_List_fromArray(
				[integrationStatuses.bC.jh, integrationStatuses.iG.jh]),
			_List_fromArray(
				[integrationStatuses.ce.jh]));
	});
var $author$project$Timesheet$Views$IntegrationStatuses$isOk = function (state) {
	return state === 3;
};
var $author$project$Timesheet$Views$IntegrationStatuses$allOk = F2(
	function (isTrackingActivities, integrationStatuses) {
		return A2(
			$elm$core$List$all,
			$author$project$Timesheet$Views$IntegrationStatuses$isOk,
			A2($author$project$Timesheet$Views$IntegrationStatuses$getStates, isTrackingActivities, integrationStatuses));
	});
var $author$project$Timesheet$Views$IntegrationStatuses$sortState = function (state) {
	switch (state) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Timesheet$Views$IntegrationStatuses$getDisplayableStatuses = F2(
	function (isTrackingActivities, integrationStatuses) {
		return A2(
			$elm$core$List$sortBy,
			function (_v1) {
				var status = _v1.b;
				return $author$project$Timesheet$Views$IntegrationStatuses$sortState(status.jh);
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var status = _v0.b;
					return status.jh !== 3;
				},
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					isTrackingActivities,
					_List_fromArray(
						[
							_Utils_Tuple2(3, integrationStatuses.cX)
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						isTrackingActivities,
						_List_fromArray(
							[
								_Utils_Tuple2(2, integrationStatuses.iG)
							]),
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							isTrackingActivities,
							_List_fromArray(
								[
									_Utils_Tuple2(1, integrationStatuses.bC)
								]),
							_List_fromArray(
								[
									_Utils_Tuple2(0, integrationStatuses.ce)
								]))))));
	});
var $author$project$Timesheet$Views$IntegrationStatuses$bannerIconAttributes = function (dataRole) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'data-role', dataRole),
			$elm$svg$Svg$Attributes$class('w-6 h-6 stroke-current')
		]);
};
var $author$project$Timesheet$Views$IntegrationStatuses$bannerExpandButtonState = function (state) {
	return (state === 1) ? _Utils_Tuple3(
		'Show Less Errors',
		0,
		$author$project$Icons$Expanded$viewWithAttributes(
			$author$project$Timesheet$Views$IntegrationStatuses$bannerIconAttributes('banner-contract-me'))) : _Utils_Tuple3(
		'Show More Errors',
		1,
		$author$project$Icons$Contracted$viewWithAttributes(
			$author$project$Timesheet$Views$IntegrationStatuses$bannerIconAttributes('banner-expand-me')));
};
var $author$project$Timesheet$Views$IntegrationStatuses$renderBannerButton = function (_v0) {
	var titleText = _v0.a;
	var event = _v0.b;
	var icon = _v0.c;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('border-white border-2 rounded-full'),
				$elm$html$Html$Attributes$class('transform scale-75'),
				$elm$html$Html$Attributes$class('hover:bg-white hover:border-mt-purple text-white hover:text-mt-purple'),
				$elm$html$Html$Attributes$class('cursor-pointer'),
				$elm$html$Html$Attributes$class('px-2 py-2'),
				$elm$html$Html$Events$onClick(
				$author$project$TimesheetPage$Messages$SetIntegrationStatusBanner(event)),
				$elm$html$Html$Attributes$title(titleText),
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'banner-ui-button')
			]),
		_List_fromArray(
			[icon]));
};
var $author$project$Timesheet$Views$IntegrationStatuses$bannerExpandButton = function (state) {
	return $author$project$Timesheet$Views$IntegrationStatuses$renderBannerButton(
		$author$project$Timesheet$Views$IntegrationStatuses$bannerExpandButtonState(state));
};
var $author$project$Timesheet$Views$IntegrationStatuses$bgColourClass = function (state) {
	switch (state) {
		case 0:
			return 'bg-mt-red-light';
		case 1:
			return 'bg-mt-yellow-darker';
		case 2:
			return 'bg-mt-blue-lighter';
		default:
			return 'bg-mt-green-light';
	}
};
var $author$project$Icons$Call$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('7'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('phone'),
								$elm$svg$Svg$Attributes$class('stroke-current'),
								$elm$svg$Svg$Attributes$transform('translate(19, 19) rotate(-25)'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round'),
								$elm$svg$Svg$Attributes$strokeWidth('7')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M13.5091362,18.9635122 C12.6163455,21.8619465 9.37209384,28.2284126 9.37209384,38.6804967 C9.37209384,49.1325808 11.9536384,53.8393833 12.8464291,56.7378175'),
										$elm$svg$Svg$Attributes$id('Path-Copy'),
										$elm$svg$Svg$Attributes$transform('translate(11.440615, 37.850665) scale(-1, 1) rotate(180.000000) translate(-11.440615, -37.850665) ')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M12.3482285,19.6200908 C18.9257016,22.1468372 24.3722297,21.3444014 24.3674408,18.4578004 C24.3570806,12.2129679 24.346259,5.69000115 24.340969,2.50137101 C24.3330341,-2.28157418 12.7673295,1.05106223 10.2766022,2.24228425 C7.78587484,3.43350626 4.32773345,7.19878337 2.28051726,16.3807952 C1.48046852,19.9691104 6.25607502e-15,29.5899009 0,37.9569801 C-6.42515812e-15,46.3240592 1.10622118,55.0761275 1.77201941,58.921382 C3.42182313,68.4496669 7.78587484,72.4804538 10.2766022,73.6716759 C12.7673295,74.8628979 24.3330341,78.1955343 24.340969,73.4125891 C24.346259,70.223959 24.3570806,63.7009922 24.3674408,57.4561597 C24.3723466,54.4990889 18.6565237,53.7291858 11.8645474,56.484894'),
										$elm$svg$Svg$Attributes$id('Path-Copy-2'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$transform('translate(12.183722, 37.956980) scale(-1, 1) rotate(180.000000) translate(-12.183722, -37.956980) ')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$Email$viewWithAttributes = function (attributes) {
	var y_coord = '21';
	var x_coord = '12';
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('stroke-current group-hover:fill-current'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$id('email'),
						$elm$svg$Svg$Attributes$strokeWidth('7')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('envelope'),
								$elm$svg$Svg$Attributes$strokeWidth('7'),
								$elm$svg$Svg$Attributes$class('group-hover:stroke-current group-hover:fill-current'),
								$elm$svg$Svg$Attributes$fill('none')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(x_coord),
										$elm$svg$Svg$Attributes$y(y_coord),
										$elm$svg$Svg$Attributes$rx('5'),
										$elm$svg$Svg$Attributes$ry('5'),
										$elm$svg$Svg$Attributes$width('64'),
										$elm$svg$Svg$Attributes$height('46')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M1,1 L29.2317412,27.4337749 C30.7696128,28.8770561 33.1638771,28.8783197 34.7032712,27.4366626 L63,1'),
										$elm$svg$Svg$Attributes$transform('translate(' + (x_coord + (', ' + (y_coord + ')')))),
										$elm$svg$Svg$Attributes$id('Path-10'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$PMS$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$d('M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01')
					]),
				_List_Nil)
			]));
};
var $author$project$Timesheet$Views$IntegrationStatuses$renderIcon = function (integrationType) {
	var generalClasses = 'w-10 h-10 inline';
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					switch (integrationType) {
						case 0:
							return $author$project$Icons$PMS$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('text-white stroke-current fill-none'),
										$elm$svg$Svg$Attributes$class('w-8 h-8 inline')
									]));
						case 1:
							return $author$project$Icons$Email$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('text-white stroke-current'),
										$elm$svg$Svg$Attributes$class(generalClasses)
									]));
						case 2:
							return $author$project$Icons$Call$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('text-white fill-current'),
										$elm$svg$Svg$Attributes$class(generalClasses)
									]));
						default:
							return $author$project$Icons$Globe$viewWithAttributes(
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('text-white stroke-current fill-none'),
										$elm$svg$Svg$Attributes$class('w-8 h-8 inline')
									]));
					}
				}()
				]))
		]);
};
var $author$project$Timesheet$Views$IntegrationStatuses$renderLink = function (link) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ml-2 btn btn-primary-inverted'),
				$elm$html$Html$Attributes$href(link.jC)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(link.fk)
			]));
};
var $author$project$Timesheet$Views$IntegrationStatuses$renderStatusText = F2(
	function (statusText, extraInformation) {
		var titleText = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (info) {
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$title(info),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'status-extra-information')
						]);
				},
				extraInformation));
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('ml-1'),
				titleText),
			_List_fromArray(
				[
					$elm$html$Html$text(statusText)
				]));
	});
var $author$project$Timesheet$Views$IntegrationStatuses$renderStatus = F2(
	function (integrationType, status) {
		if ($author$project$Timesheet$Views$IntegrationStatuses$isOk(status.jh)) {
			return A2($elm$html$Html$span, _List_Nil, _List_Nil);
		} else {
			var link = A2($elm$core$Maybe$map, $author$project$Timesheet$Views$IntegrationStatuses$renderLink, status.hW);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						$author$project$Timesheet$Views$IntegrationStatuses$bgColourClass(status.jh)),
						$elm$html$Html$Attributes$class('w-screen text-center h-12 flex justify-center items-center')
					]),
				A2(
					$author$project$CoreX$Appendable$andAppendMaybe,
					link,
					A2(
						$author$project$CoreX$Appendable$andAppend,
						_List_fromArray(
							[
								A2($author$project$Timesheet$Views$IntegrationStatuses$renderStatusText, status.fk, status.gV)
							]),
						$author$project$Timesheet$Views$IntegrationStatuses$renderIcon(integrationType))));
		}
	});
var $author$project$Timesheet$Views$IntegrationStatuses$renderHead = F3(
	function (state, hasMore, _v0) {
		var type_ = _v0.a;
		var integrationStatus = _v0.b;
		var bgClass = $author$project$Timesheet$Views$IntegrationStatuses$bgColourClass(integrationStatus.jh);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-between'),
					$elm$html$Html$Attributes$class(bgClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-32')
						]),
					_List_Nil),
					A2($author$project$Timesheet$Views$IntegrationStatuses$renderStatus, type_, integrationStatus),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-32')
						]),
					A2(
						$author$project$CoreX$Appendable$andAppend,
						_List_fromArray(
							[
								$author$project$Timesheet$Views$IntegrationStatuses$renderBannerButton(
								_Utils_Tuple3(
									'Hide',
									2,
									$author$project$Icons$CloseCross$viewWithAttributes(
										$author$project$Timesheet$Views$IntegrationStatuses$bannerIconAttributes('banner-close-me'))))
							]),
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							hasMore,
							_List_fromArray(
								[
									$author$project$Timesheet$Views$IntegrationStatuses$bannerExpandButton(state)
								]),
							_List_Nil)))
				]));
	});
var $author$project$Timesheet$Views$IntegrationStatuses$renderRest = function (listOfStatusContent) {
	if (!listOfStatusContent.b) {
		return _List_Nil;
	} else {
		var rest = listOfStatusContent;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var type_ = _v1.a;
				var status = _v1.b;
				return A2($author$project$Timesheet$Views$IntegrationStatuses$renderStatus, type_, status);
			},
			rest);
	}
};
var $author$project$Timesheet$Views$IntegrationStatuses$renderContent = F3(
	function (uIState, isTrackingActivities, integrationStatuses) {
		var sortedStatuses = A2($author$project$Timesheet$Views$IntegrationStatuses$getDisplayableStatuses, isTrackingActivities, integrationStatuses);
		if (!sortedStatuses.b) {
			return _List_Nil;
		} else {
			var h = sortedStatuses.a;
			var t = sortedStatuses.b;
			var hasMore = !$elm$core$List$isEmpty(t);
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative')
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						uIState === 1,
						$author$project$Timesheet$Views$IntegrationStatuses$renderRest(t),
						_List_fromArray(
							[
								A3($author$project$Timesheet$Views$IntegrationStatuses$renderHead, uIState, hasMore, h)
							])))
				]);
		}
	});
var $author$project$Timesheet$Views$IntegrationStatuses$view = F3(
	function (isTrackingActivities, state, integrationStatuses) {
		if (state === 2) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'banner-closed')
					]),
				_List_Nil);
		} else {
			var hasStatuses = !A2($author$project$Timesheet$Views$IntegrationStatuses$allOk, isTrackingActivities, integrationStatuses);
			return A2(
				$elm$html$Html$div,
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					state === 1,
					A2(
						$author$project$OnClickOutsideAfterFocus$withId,
						'integration-statuses-banner',
						$author$project$TimesheetPage$Messages$SetIntegrationStatusBanner(0)),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-semibold text-white'),
							$elm$html$Html$Attributes$class('m-auto'),
							$elm$html$Html$Attributes$class('animate-slide-down-height'),
							$elm$html$Html$Attributes$id('integration-statuses-banner'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('overflow-y-visible z-10 bg-white w-full max-w-7xl', state === 1),
									_Utils_Tuple2('overflow-y-hidden w-full max-w-7xl', !state),
									_Utils_Tuple2('h-0 overflow-y-hidden', !hasStatuses),
									_Utils_Tuple2('h-12', hasStatuses)
								]))
						])),
				hasStatuses ? A3($author$project$Timesheet$Views$IntegrationStatuses$renderContent, state, isTrackingActivities, integrationStatuses) : _List_Nil);
		}
	});
var $author$project$TimesheetPage$View$view = F3(
	function (animationsOn, zone, model) {
		var isTrackingActivities = model.jS.jL && model.jS.hD;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-screen--12 relative flex flex-col bg-white overflow-hidden')
				]),
			_List_fromArray(
				[
					A4($author$project$Components$RunningTimerBanner$view, zone, model.jS.ce, model.aY.$7, model.jS.ej),
					A3($author$project$Timesheet$Views$IntegrationStatuses$view, isTrackingActivities, model.ht, model.hu),
					A3($author$project$Timesheet$View$timesheetView, zone, model, animationsOn),
					$author$project$Components$Modal$View$view(model.h7),
					$author$project$Timesheet$Views$FlashMessage$displayAllFlashMessages(model.P),
					$author$project$Components$MergeFeesToolbar$view(model.a4)
				]));
	});
var $author$project$View$renderPageContent = function (appModel) {
	var _v0 = appModel.iC;
	switch (_v0.$) {
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'hidden-page')
					]),
				_List_Nil);
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'hidden-page')
					]),
				_List_Nil);
		case 0:
			var model = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Messages$PageMsg,
				A4($elm$html$Html$Lazy$lazy3, $author$project$TimesheetPage$View$view, appModel.bq, model.jy, model.a6));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute top-12 h-screen bg-white')
					]),
				_List_Nil);
	}
};
var $author$project$Components$Notifications$Messages$NextSlide = 0;
var $author$project$Components$Notifications$Messages$PrevSlide = 1;
var $author$project$Components$Notifications$Messages$UIMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Components$Notifications$NotificationModalView$renderCloseButton = function (id) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute top-0 right-0 mt-2 mr-2 md:-top-5 md:-right-5 md:mt-0 md:mr-0 p-3 bg-white rounded-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stroke-4 stroke-mt-grey hover:stroke-mt-grey-darker cursor-pointer h-5 w-5')
					]),
				_List_fromArray(
					[
						$author$project$Icons$CloseCross$viewWithAttributes(
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Components$Notifications$Messages$AcknowledgeNotification(id))
							]))
					]))
			]));
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Components$Notifications$NotificationModalView$renderBase = F4(
	function (notificationId, imageLink, title, content) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						A2(
							$author$project$CoreX$Appendable$andAppendMaybe,
							A2($elm$core$Maybe$map, $elm$html$Html$Attributes$src, imageLink),
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'img-link'),
									$elm$html$Html$Attributes$class('w-full md:w-160 md:h-100 border-0')
								])),
						_List_Nil),
						$author$project$Components$Notifications$NotificationModalView$renderCloseButton(notificationId)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-60')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h5,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pt-6 text-center mb-5')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mx-8 h-32 mb-0 overflow-y-auto whitespace-pre-line break-normal')
							]),
						_List_fromArray(
							[
								A3(
								$elm$core$Basics$composeL,
								$elm$html$Html$text,
								$elm$core$Maybe$withDefault(''),
								content)
							]))
					]))
			]);
	});
var $author$project$Components$Notifications$NotificationModalView$renderLinkButton = F3(
	function (id, link, linkText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-primary'),
							$elm$html$Html$Attributes$href(link),
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Events$onClick(
							$author$project$Components$Notifications$Messages$AcknowledgeNotification(id))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(linkText)
						]))
				]));
	});
var $author$project$Components$Notifications$NotificationModalView$renderButtonWithDefault = F3(
	function (id, link, linkText) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($elm$html$Html$div, _List_Nil, _List_Nil),
			A3(
				$elm$core$Maybe$map2,
				$author$project$Components$Notifications$NotificationModalView$renderLinkButton(id),
				link,
				linkText));
	});
var $author$project$Components$Notifications$NotificationModalView$renderSlide = F6(
	function (notification, index, last, _v0, link, linkText) {
		var imageLink = _v0.d_;
		var title = _v0.jB;
		var content = _v0.go;
		return A2(
			$author$project$CoreX$Appendable$andAppend,
			A4(
				$author$project$Components$Notifications$NotificationModalView$renderBase,
				notification.aC,
				$elm$core$Maybe$Just(imageLink),
				title,
				$elm$core$Maybe$Just(content)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex absolute inset-x-0 bottom-0 mb-4 justify-center gap-x-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							index > 0,
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'prev-slide-click'),
										$elm$html$Html$Attributes$class('btn btn-primary'),
										$elm$html$Html$Events$onClick(
										A2($author$project$Components$Notifications$Messages$UIMsg, 1, notification))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Previous')
									]))),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							_Utils_cmp(index, last) < 0,
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-role', 'next-slide-click'),
										$elm$html$Html$Attributes$class('btn btn-primary'),
										$elm$html$Html$Events$onClick(
										A2($author$project$Components$Notifications$Messages$UIMsg, 0, notification))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Next')
									]))),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							_Utils_eq(index, last),
							A3($author$project$Components$Notifications$NotificationModalView$renderButtonWithDefault, notification.aC, link, linkText))
						]))
				]));
	});
var $author$project$Components$Notifications$NotificationModalView$renderCurrentSlide = function (notification) {
	var slides = notification.ja;
	var link = notification.hW;
	var linkText = notification.hX;
	var currentSlideIdx = notification.gv;
	var last = $elm$core$List$length(slides) - 1;
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (slide) {
				return A6($author$project$Components$Notifications$NotificationModalView$renderSlide, notification, currentSlideIdx, last, slide, link, linkText);
			},
			A2($elm_community$list_extra$List$Extra$getAt, currentSlideIdx, slides)));
};
var $author$project$Components$Notifications$NotificationModalView$renderModal = function (_v0) {
	var id = _v0.aC;
	var imageLink = _v0.d_;
	var title = _v0.jB;
	var content = _v0.go;
	var link = _v0.hW;
	var linkText = _v0.hX;
	return A2(
		$author$project$CoreX$Appendable$andAppend,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						A3($author$project$Components$Notifications$NotificationModalView$renderButtonWithDefault, id, link, linkText)
					]))
			]),
		A4($author$project$Components$Notifications$NotificationModalView$renderBase, id, imageLink, title, content));
};
var $author$project$Components$Notifications$NotificationModalView$view = function (notification) {
	var _v0 = notification.jN;
	switch (_v0) {
		case 1:
			return $author$project$Components$Notifications$NotificationModalView$renderModal(notification);
		case 2:
			return $author$project$Components$Notifications$NotificationModalView$renderCurrentSlide(notification);
		default:
			return _List_Nil;
	}
};
var $author$project$Components$Modal$View$createTopLevelModalView = function (model) {
	switch (model.$) {
		case 0:
			var notification = model.a;
			return A4(
				$author$project$Components$Modal$View$ModalView,
				'notification-modal',
				'h-full md:w-160 md:h-160',
				true,
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Messages$NotificationMsg),
					$author$project$Components$Notifications$NotificationModalView$view(notification)));
		case 1:
			var fileNote = model.a;
			return A4(
				$author$project$Components$Modal$View$ModalView,
				'file-notes-modal',
				'md:h-fit md:w-192 md:min-h-128 md:max-h-screen--32 overflow-y-auto rounded-lg',
				true,
				$elm$core$List$singleton(
					A2(
						$elm$html$Html$map,
						$author$project$Messages$FileNoteMsg,
						$author$project$Components$FileNotes$View$view(fileNote))));
		default:
			return A4($author$project$Components$Modal$View$ModalView, 'hidden-modal', '', false, _List_Nil);
	}
};
var $author$project$Components$Modal$View$topLevelView = function (model) {
	if (model.$ === 2) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hidden')
				]),
			_List_Nil);
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-screen--12 absolute flex flex-col bg-white overflow-hidden')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Modal$View$renderModal,
					$author$project$Messages$ModalMsg(0),
					$author$project$Components$Modal$View$createTopLevelModalView(model))
				]));
	}
};
var $author$project$Components$Header$View$checkUser = F2(
	function (func, user) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2($krisajenkins$remotedata$RemoteData$map, func, user));
	});
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Icons$Shadow$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 21C10.75 21 9.57917 20.7625 8.4875 20.2875C7.39583 19.8125 6.44583 19.1708 5.6375 18.3625C4.82917 17.5542 4.1875 16.6042 3.7125 15.5125C3.2375 14.4208 3 13.25 3 12C3 10.75 3.2375 9.57917 3.7125 8.4875C4.1875 7.39583 4.82917 6.44583 5.6375 5.6375C6.44583 4.82917 7.39583 4.1875 8.4875 3.7125C9.57917 3.2375 10.75 3 12 3C13.25 3 14.4208 3.2375 15.5125 3.7125C16.6042 4.1875 17.5542 4.82917 18.3625 5.6375C19.1708 6.44583 19.8125 7.39583 20.2875 8.4875C20.7625 9.57917 21 10.75 21 12C21 13.25 20.7625 14.4208 20.2875 15.5125C19.8125 16.6042 19.1708 17.5542 18.3625 18.3625C17.5542 19.1708 16.6042 19.8125 15.5125 20.2875C14.4208 20.7625 13.25 21 12 21ZM4.5 12C4.5 13.5333 4.925 14.9292 5.775 16.1875C6.625 17.4458 7.76667 18.3667 9.2 18.95C8.48333 18.0667 7.9375 17.0292 7.5625 15.8375C7.1875 14.6458 7 13.3667 7 12C7 10.6333 7.19167 9.35417 7.575 8.1625C7.95833 6.97083 8.5 5.93333 9.2 5.05C7.76667 5.63333 6.625 6.55417 5.775 7.8125C4.925 9.07083 4.5 10.4667 4.5 12ZM12.675 19.475C14.4917 19.3083 16.0375 18.5875 17.3125 17.3125C18.5875 16.0375 19.3083 14.4917 19.475 12.675L12.675 19.475ZM11.575 19.15L19.475 11.25C19.4417 10.9167 19.3875 10.5917 19.3125 10.275C19.2375 9.95833 19.1333 9.64167 19 9.325L10.35 17.975C10.5333 18.2083 10.725 18.4208 10.925 18.6125C11.125 18.8042 11.3417 18.9833 11.575 19.15ZM9.775 17.125L18.55 8.35C18.4167 8.11667 18.2667 7.8875 18.1 7.6625C17.9333 7.4375 17.7583 7.21667 17.575 7L9.05 15.525C9.13333 15.7917 9.23333 16.0542 9.35 16.3125C9.46667 16.5708 9.60833 16.8417 9.775 17.125ZM8.75 14.45L16.875 6.3C16.6417 6.11667 16.4083 5.94583 16.175 5.7875C15.9417 5.62917 15.7 5.48333 15.45 5.35L8.5 12.3C8.51667 12.6833 8.54167 13.05 8.575 13.4C8.60833 13.75 8.66667 14.1 8.75 14.45ZM8.55 10.825L14.475 4.925C14.1083 4.79167 13.7375 4.69167 13.3625 4.625C12.9875 4.55833 12.6083 4.51667 12.225 4.5C11.1917 5.05 10.3583 5.875 9.725 6.975C9.09167 8.075 8.7 9.35833 8.55 10.825Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$Shadow$view = $author$project$Icons$Shadow$viewWithAttributes(_List_Nil);
var $author$project$Components$Header$View$impersonationMessage = function (user) {
	return A2(
		$elm$core$Maybe$withDefault,
		A2($elm$html$Html$div, _List_Nil, _List_Nil),
		A2(
			$elm$core$Maybe$map,
			function (impersonation) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row rounded-full gap-2 pl-2 pr-3 bg-mt-amber overflow-y-hidden text-black mr-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[$author$project$Icons$Shadow$view])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(''),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'impersonating')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Viewing as ' + impersonation.b2)
								]))
						]));
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.a$;
				},
				$krisajenkins$remotedata$RemoteData$toMaybe(user))));
};
var $author$project$Components$Header$Messages$OpenNavBarDropdown = {$: 3};
var $author$project$Components$Header$View$loadedAttribute = F2(
	function (user, str) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-role', 'loading-page')
				]),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (_v0) {
					return _List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-role', str)
						]);
				},
				user));
	});
var $author$project$Components$Header$Messages$CloseNavBarDropdown = {$: 0};
var $author$project$Messages$LogOut = {$: 11};
var $author$project$Messages$News = {$: 7};
var $author$project$Components$Header$Messages$QueueAllPostableFeesForMatter = {$: 6};
var $author$project$Components$Header$View$isDelegate = function (impersonation) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (i) {
				return i.hp === 1;
			},
			impersonation));
};
var $author$project$Icons$Bullhorn$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 -960 960 960')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80Zm240-182v-196l-98 58H160v80h182l98 58Zm120 36v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346ZM300-480Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$DocumentFilled$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('100%'),
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('80 -880 800 800'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$d('M327.69-453.85h304.62v-60H327.69v60Zm0 115.39h304.62v-60H327.69v60Zm0 115.38h184.62v-60H327.69v60ZM252.31-100Q222-100 201-121q-21-21-21-51.31v-615.38Q180-818 201-839q21-21 51.31-21H570l210 210v477.69Q780-142 759-121q-21 21-51.31 21H252.31ZM540-620v-180H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v615.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-620H540ZM240-800v180-180V-160v-640Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$LogOut$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 -3 22 22'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('Artboard-5'),
								$elm$svg$Svg$Attributes$transform('translate(-94.000000, -52.000000)'),
								$elm$svg$Svg$Attributes$stroke('#555555'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('log-out'),
										$elm$svg$Svg$Attributes$transform('translate(105.000000, 60.000000) rotate(90.000000) translate(-105.000000, -60.000000) translate(98.000000, 50.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M1.77967285,7.78160544 C1.38743139,8.22036827 1.04968762,8.70888231 0.777077904,9.2365112 C0.280460448,10.1977011 0,11.2886996 0,12.445203 C0,16.3111963 3.13400675,19.445203 7,19.445203 C10.8659932,19.445203 14,16.3111963 14,12.445203 C14,10.6544563 13.3275715,9.02076358 12.2214385,7.7828489'),
												$elm$svg$Svg$Attributes$id('Oval-2'),
												$elm$svg$Svg$Attributes$fillRule('nonzero')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M6.98412698,13.7566138 L6.98412698,0.952380952'),
												$elm$svg$Svg$Attributes$id('Path-17'),
												$elm$svg$Svg$Attributes$fillRule('nonzero')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$polyline,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('arrow'),
												$elm$svg$Svg$Attributes$transform('translate(6.984127, 2.328042) rotate(180.000000) translate(-6.984127, -2.328042) '),
												$elm$svg$Svg$Attributes$points('11.6402116 0.328042328 6.98412698 4.32804233 2.32804233 0.328042328')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Icons$MitimesLogo$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 96 96'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('mitimes-logo'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('Group'),
								$elm$svg$Svg$Attributes$transform('translate(2.000000, 2.000000)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('top'),
										$elm$svg$Svg$Attributes$fill('#6039FF'),
										$elm$svg$Svg$Attributes$class('mix-blend-multiply'),
										$elm$svg$Svg$Attributes$cx('66.7252747'),
										$elm$svg$Svg$Attributes$cy('25.2747253'),
										$elm$svg$Svg$Attributes$r('25.2747253')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('mid'),
										$elm$svg$Svg$Attributes$fill('#8562FB'),
										$elm$svg$Svg$Attributes$class('mix-blend-multiply'),
										$elm$svg$Svg$Attributes$cx('46.5054945'),
										$elm$svg$Svg$Attributes$cy('46.5054945'),
										$elm$svg$Svg$Attributes$r('25.2747253')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('bottom'),
										$elm$svg$Svg$Attributes$fill('#C2AFFC'),
										$elm$svg$Svg$Attributes$class('mix-blend-multiply'),
										$elm$svg$Svg$Attributes$cx('25.2747253'),
										$elm$svg$Svg$Attributes$cy('66.7252747'),
										$elm$svg$Svg$Attributes$r('25.2747253')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$Profile$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('Artboard-5'),
								$elm$svg$Svg$Attributes$transform('translate(-3.000000, -32.000000)'),
								$elm$svg$Svg$Attributes$stroke('#555555')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('profile'),
										$elm$svg$Svg$Attributes$transform('translate(4.000000, 33.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M15,15.9501305 C15,12.8828962 12.3137085,10.3964115 9,10.3964115 C5.6862915,10.3964115 3,12.8828962 3,15.9501305'),
												$elm$svg$Svg$Attributes$id('Oval-11'),
												$elm$svg$Svg$Attributes$strokeWidth('1.41176471')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 C4.02943725,0 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 Z'),
												$elm$svg$Svg$Attributes$id('Oval-3'),
												$elm$svg$Svg$Attributes$strokeWidth('1.5'),
												$elm$svg$Svg$Attributes$strokeLinecap('round'),
												$elm$svg$Svg$Attributes$fillRule('nonzero')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$circle,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('Oval'),
												$elm$svg$Svg$Attributes$strokeWidth('1.5'),
												$elm$svg$Svg$Attributes$strokeLinecap('round'),
												$elm$svg$Svg$Attributes$cx('9'),
												$elm$svg$Svg$Attributes$cy('7'),
												$elm$svg$Svg$Attributes$r('3')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Icons$Settings$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 16 18'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('Artboard-5'),
								$elm$svg$Svg$Attributes$transform('translate(-40.000000, -12.000000)'),
								$elm$svg$Svg$Attributes$stroke('#555555'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('settings'),
										$elm$svg$Svg$Attributes$transform('translate(41.000000, 13.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M7,0 L7,16'),
												$elm$svg$Svg$Attributes$id('Path-66')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M1.61538462,0 L1.61538462,16'),
												$elm$svg$Svg$Attributes$id('Path-66')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M12.3846154,0 L12.3846154,16'),
												$elm$svg$Svg$Attributes$id('Path-66')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M0,8 L3.23076923,8'),
												$elm$svg$Svg$Attributes$id('Path-68')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M5.38461538,12.2666667 L8.61538462,12.2666667'),
												$elm$svg$Svg$Attributes$id('Path-68')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M10.7692308,3.73333333 L14,3.73333333'),
												$elm$svg$Svg$Attributes$id('Path-68')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Icons$Timesheet$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 18 22'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('Page-1'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$class('transition-15')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('Artboard-5'),
								$elm$svg$Svg$Attributes$transform('translate(-94.000000, -14.000000)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('timesheet'),
										$elm$svg$Svg$Attributes$transform('translate(94.000000, 14.000000)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$rect,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('Rectangle'),
												$elm$svg$Svg$Attributes$strokeWidth('1.375'),
												$elm$svg$Svg$Attributes$fillRule('nonzero'),
												$elm$svg$Svg$Attributes$fillOpacity('0'),
												$elm$svg$Svg$Attributes$x('0.6875'),
												$elm$svg$Svg$Attributes$y('0.6875'),
												$elm$svg$Svg$Attributes$width('16.625'),
												$elm$svg$Svg$Attributes$height('20.625'),
												$elm$svg$Svg$Attributes$rx('1.83333333')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M9.7178,14.311 C9.6288,14.832 9.4048,15.292 9.0768,15.699 C8.4278,16.508 7.5838,16.945 6.5438,16.996 C4.7118,17.085 3.1618,15.685 3.0118,13.903 C2.8718,12.229 3.9348,10.72 5.5538,10.305 C5.5898,10.296 5.6278,10.294 5.6648,10.289 L5.6618,10.285 C5.6438,10.433 5.6188,10.581 5.6078,10.73 C5.5038,12.164 6.2598,13.473 7.5598,14.083 C8.2498,14.407 8.9748,14.494 9.7228,14.317 L9.7178,14.311 Z'),
												$elm$svg$Svg$Attributes$id('Fill-1'),
												$elm$svg$Svg$Attributes$strokeWidth('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M8.2589,7.6968 C8.4979,6.6078 9.1219,5.8078 10.1239,5.3348 C12.1369,4.3858 14.4359,5.5398 14.9129,7.7178 C15.3019,9.4918 14.1389,11.3168 12.3659,11.7168 C12.3489,11.7208 12.3289,11.7188 12.3109,11.7198 L12.3159,11.7248 C12.4179,11.2458 12.4139,10.7678 12.3169,10.2878 C11.9499,8.4718 10.0489,7.2568 8.2539,7.6928 L8.2589,7.6968 Z'),
												$elm$svg$Svg$Attributes$id('Fill-4'),
												$elm$svg$Svg$Attributes$strokeWidth('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$d('M5.6646,10.2886 C5.8166,9.6276 6.1256,9.0526 6.6106,8.5776 C7.0446,8.1506 7.5586,7.8626 8.1476,7.7096 C8.1836,7.7016 8.2216,7.7016 8.2586,7.6966 L8.2536,7.6926 C8.2516,7.7156 8.2526,7.7396 8.2476,7.7626 C7.9876,9.1206 8.5616,10.4906 9.7166,11.2446 C10.5146,11.7646 11.3846,11.9136 12.3156,11.7256 L12.3106,11.7206 C12.2276,12.2226 12.0086,12.6646 11.7046,13.0646 C11.2336,13.6816 10.6206,14.0936 9.8686,14.2926 C9.8196,14.3056 9.7686,14.3056 9.7176,14.3106 L9.7236,14.3166 C9.8216,13.8236 9.8236,13.3306 9.7106,12.8396 C9.2966,11.0436 7.5106,9.8766 5.6616,10.2846 L5.6646,10.2886 Z'),
												$elm$svg$Svg$Attributes$id('Fill-6'),
												$elm$svg$Svg$Attributes$strokeWidth('0')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Icons$UserGroup$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height('100%'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$d('M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Header$View$dropdownIconView = function (linkText) {
	var _v0 = function () {
		switch (linkText) {
			case 'My Profile':
				return _Utils_Tuple3('w-5', $author$project$Icons$Profile$viewWithAttributes, 'profile');
			case 'Timesheet':
				return _Utils_Tuple3('w-18px mr-px stroke-current fill-current text-mt-grey-dark', $author$project$Icons$Timesheet$viewWithAttributes, 'timesheet');
			case 'Post all completed fees':
				return _Utils_Tuple3('w-5', $author$project$Icons$PostAll$viewWithAttributes, 'post-all-completed-fees');
			case 'Settings':
				return _Utils_Tuple3('w-4 mr-3px', $author$project$Icons$Settings$viewWithAttributes, 'settings');
			case 'Matters':
				return _Utils_Tuple3('w-4 mr-3px', $author$project$Icons$Filter$viewWithAttributes, 'matters');
			case 'Contacts':
				return _Utils_Tuple3('w-4 mr-3px', $author$project$Icons$Filter$viewWithAttributes, 'contacts');
			case 'Teams':
				return _Utils_Tuple3('w-5 stroke-current text-mt-grey-dark', $author$project$Icons$UserGroup$viewWithAttributes, 'user-group');
			case 'Filed Documents':
				return _Utils_Tuple3('w-5 stroke-current text-mt-grey-dark', $author$project$Icons$DocumentFilled$viewWithAttributes, 'filing_statuses');
			case 'Mitimes Admin':
				return _Utils_Tuple3('w-5', $author$project$Icons$MitimesLogo$viewWithAttributes, 'mitimes-admin');
			case 'What\'s New':
				return _Utils_Tuple3('w-5', $author$project$Icons$Bullhorn$viewWithAttributes, 'mitimes-news');
			case 'Logout':
				return _Utils_Tuple3('w-5', $author$project$Icons$LogOut$viewWithAttributes, 'log-out');
			default:
				return _Utils_Tuple3('w-5', $author$project$Icons$LogOut$viewWithAttributes, '');
		}
	}();
	var spanClass = _v0.a;
	var iconSvg = _v0.b;
	var iconClass = _v0.c;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-5 ' + spanClass)
			]),
		_List_fromArray(
			[
				iconSvg(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('icon icon--' + iconClass)
					]))
			]));
};
var $author$project$Components$Header$View$listClass = 'h-7 mb-2 pt-2px px-4 text-sm text-left border-none hover:bg-mt-purple-lightest hover:text-mt-grey-darker hover:border-0';
var $author$project$Components$Header$View$navLinkDataRole = function (linkText) {
	return A3(
		$elm$regex$Regex$replace,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('\\s')),
		function (_v0) {
			return '-';
		},
		$elm$core$String$toLower(linkText));
};
var $author$project$Components$Header$View$navLinkView = F2(
	function (linkText, linkTo) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$Components$Header$View$listClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center py-0 w-full text-black hover:no-underline'),
							$elm$html$Html$Attributes$href(linkTo),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-role',
							$author$project$Components$Header$View$navLinkDataRole(linkText))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(linkText),
							$author$project$Components$Header$View$dropdownIconView(linkText)
						]))
				]));
	});
var $author$project$Components$Header$View$navMessageExternalLinkView = F2(
	function (linkText, msg) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$Components$Header$View$listClass),
					$elm$html$Html$Attributes$class('cursor-pointer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center py-0 w-full text-black hover:no-underline'),
							$elm$html$Html$Events$onClick(msg),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-role',
							$author$project$Components$Header$View$navLinkDataRole(linkText)),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(linkText),
							$author$project$Components$Header$View$dropdownIconView(linkText)
						]))
				]));
	});
var $author$project$Components$Header$View$navMessageLinkView = F2(
	function (linkText, msg) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$Components$Header$View$listClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center py-0 w-full text-black hover:no-underline'),
							$elm$html$Html$Events$onClick(msg),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-role',
							$author$project$Components$Header$View$navLinkDataRole(linkText))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(linkText),
							$author$project$Components$Header$View$dropdownIconView(linkText)
						]))
				]));
	});
var $author$project$Components$Header$View$navDropdownMenu = F2(
	function (user, inTimesheet) {
		return A2(
			$elm$html$Html$ul,
			A2(
				$author$project$CoreX$Appendable$andAppend,
				A2(
					$author$project$OnClickOutsideAfterFocus$withId,
					'top-hamburger-menu',
					$author$project$Messages$HeaderMsg($author$project$Components$Header$Messages$CloseNavBarDropdown)),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute right-0 top-8 flex flex-col w-56'),
						$elm$html$Html$Attributes$class('z-30'),
						$elm$html$Html$Attributes$class('px-0 pt-4 pb-2'),
						$elm$html$Html$Attributes$class('border bg-white shadow-sm cursor-pointer outline-hidden'),
						$elm$html$Html$Attributes$id('top-hamburger-menu'),
						A2($elm$html$Html$Attributes$attribute, 'data-role', 'hamburger-menu-items')
					])),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				_List_fromArray(
					[
						A2($author$project$Components$Header$View$navMessageLinkView, 'Logout', $author$project$Messages$LogOut)
					]),
				A2(
					$author$project$CoreX$Appendable$andAppend,
					_List_fromArray(
						[
							A2($author$project$Components$Header$View$navMessageExternalLinkView, 'What\'s New', $author$project$Messages$News)
						]),
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						A2(
							$author$project$Components$Header$View$checkUser,
							function (u) {
								return u.d7 && _Utils_eq(u.a$, $elm$core$Maybe$Nothing);
							},
							user),
						_List_fromArray(
							[
								A2($author$project$Components$Header$View$navLinkView, 'Mitimes Admin', '/super_admin/organisations')
							]),
						A3(
							$author$project$CoreX$Appendable$andAppendIf,
							A2(
								$author$project$Components$Header$View$checkUser,
								function (u) {
									return u.hy && (!$author$project$Components$Header$View$isDelegate(u.a$));
								},
								user),
							_List_fromArray(
								[
									A2($author$project$Components$Header$View$navLinkView, 'Settings', '/admin/setup')
								]),
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								A2(
									$author$project$Components$Header$View$checkUser,
									function (u) {
										return (u.E.by !== 2) && u.f1;
									},
									user),
								_List_fromArray(
									[
										A2($author$project$Components$Header$View$navLinkView, 'Filed Documents', '/filing_statuses')
									]),
								A2(
									$author$project$CoreX$Appendable$andAppend,
									_List_fromArray(
										[
											A2($author$project$Components$Header$View$navLinkView, 'Contacts', '/contacts')
										]),
									A3(
										$author$project$CoreX$Appendable$andAppendIf,
										inTimesheet,
										_List_fromArray(
											[
												A2(
												$author$project$Components$Header$View$navMessageLinkView,
												'Post all completed fees',
												$author$project$Messages$HeaderMsg($author$project$Components$Header$Messages$QueueAllPostableFeesForMatter))
											]),
										A3(
											$author$project$CoreX$Appendable$andAppendIf,
											!inTimesheet,
											_List_fromArray(
												[
													A2($author$project$Components$Header$View$navLinkView, 'Timesheet', '/')
												]),
											A3(
												$author$project$CoreX$Appendable$andAppendIf,
												A2(
													$author$project$Components$Header$View$checkUser,
													function (u) {
														return !$author$project$Components$Header$View$isDelegate(u.a$);
													},
													user),
												_List_fromArray(
													[
														A2($author$project$Components$Header$View$navLinkView, 'My Profile', '/my_profile/timesheet_profile_configuration/edit')
													]),
												_List_Nil))))))))));
	});
var $author$project$Icons$Menu$viewWithAttributes = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('24'),
					$elm$svg$Svg$Attributes$height('24')
				]),
			attributes),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M 3 12 L 21 12'),
						$elm$svg$Svg$Attributes$fill('transparent'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeDasharray('')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M 3 6 L 21 6'),
						$elm$svg$Svg$Attributes$fill('transparent'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeDasharray('')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M 3 18 L 21 18'),
						$elm$svg$Svg$Attributes$fill('transparent'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeDasharray('')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Header$View$navHamburgerMenu = F3(
	function (headerModel, user, inTimesheet) {
		return A3(
			$author$project$CoreX$Appendable$andAppendIf,
			headerModel.eo,
			_List_fromArray(
				[
					A2($author$project$Components$Header$View$navDropdownMenu, user, inTimesheet)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$author$project$CoreX$Appendable$andAppend,
						A2($author$project$Components$Header$View$loadedAttribute, user, 'loaded-hamburger-menu'),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('relative outline-hidden cursor-pointer h-full'),
								$elm$html$Html$Events$onClick(
								$author$project$Messages$HeaderMsg($author$project$Components$Header$Messages$OpenNavBarDropdown)),
								$elm$html$Html$Attributes$id('hamburger-menu-trigger'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'loaded-hamburger-menu')
							])),
					_List_fromArray(
						[
							$author$project$Icons$Menu$viewWithAttributes(
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('icon icon--menu text-white stroke-current'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'hamburger-menu-svg')
								]))
						]))
				]));
	});
var $author$project$Components$Header$Messages$OpenHelpDropdown = {$: 4};
var $author$project$Components$Header$Messages$CloseHelpDropdown = {$: 5};
var $author$project$Messages$Help = {$: 9};
var $author$project$Components$Header$Messages$HelpDeskEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HelpDesk$Messages$OpenHelpDesk = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Header$View$helpDropdownMenu = function (user) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		A2($elm$html$Html$div, _List_Nil, _List_Nil),
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (u) {
				var helpDeskMessage = $author$project$Messages$HeaderMsg(
					$author$project$Components$Header$Messages$HelpDeskEdit(
						$author$project$Components$HelpDesk$Messages$OpenHelpDesk(u)));
				return A2(
					$elm$html$Html$div,
					A2(
						$author$project$CoreX$Appendable$andAppend,
						A2(
							$author$project$OnClickOutsideAfterFocus$withId,
							'top-help-menu',
							$author$project$Messages$HeaderMsg($author$project$Components$Header$Messages$CloseHelpDropdown)),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute right-0 top-8 flex flex-col w-56'),
								$elm$html$Html$Attributes$class('z-30'),
								$elm$html$Html$Attributes$class('px-0 pt-4 pb-2'),
								$elm$html$Html$Attributes$class('border bg-white shadow-sm outline-hidden'),
								$elm$html$Html$Attributes$id('top-help-menu'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'help-menu-items')
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-0')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Header$View$navMessageExternalLinkView, 'Help Centre', $author$project$Messages$Help),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class($author$project$Components$Header$View$listClass),
											$elm$html$Html$Attributes$class('cursor-pointer'),
											$elm$html$Html$Events$onClick(helpDeskMessage),
											$elm$html$Html$Attributes$id('support-ticket-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Submit a ticket?')
										]))
								]))
						]));
			},
			user));
};
var $author$project$Components$Header$View$helpDeskButton = F2(
	function (headerModel, webDataUser) {
		return A3(
			$author$project$CoreX$Appendable$andAppendIf,
			headerModel.dX,
			_List_fromArray(
				[
					$author$project$Components$Header$View$helpDropdownMenu(webDataUser)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$author$project$CoreX$Appendable$andAppend,
						A2($author$project$Components$Header$View$loadedAttribute, webDataUser, 'loaded-help-menu'),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('relative cursor-pointer'),
								$elm$html$Html$Events$onClick(
								$author$project$Messages$HeaderMsg($author$project$Components$Header$Messages$OpenHelpDropdown)),
								$elm$html$Html$Attributes$id('help-menu-trigger'),
								A2($elm$html$Html$Attributes$attribute, 'data-role', 'loaded-help-menu')
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cursor-pointer border border-mt-white rounded-full px-3 text-white mr-2'),
									$elm$html$Html$Attributes$class('hover:text-mt-purple-dark hover:border-mt-purple-dark hover:bg-white'),
									$elm$html$Html$Attributes$id('help-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Help?')
								]))
						]))
				]));
	});
var $author$project$Components$Header$View$renderHelpdeskTrigger = F2(
	function (headerModel, user) {
		return A2($author$project$Components$Header$View$helpDeskButton, headerModel, user);
	});
var $author$project$Components$Header$View$helpAndNavMenu = F3(
	function (header, user, inTimesheet) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-row justify-between items-center')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Components$Header$View$impersonationMessage(user)
						]),
					_Utils_ap(
						A2($author$project$Components$Header$View$renderHelpdeskTrigger, header, user),
						A3($author$project$Components$Header$View$navHamburgerMenu, header, user, inTimesheet))))
			]);
	});
var $author$project$Icons$DashboardButton$viewWithAttributes = F2(
	function (attributes, isActive) {
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('transition duration-150'),
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 26 19'),
						$elm$svg$Svg$Attributes$version('1.1')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('dashboard-btn'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$strokeWidth('1'),
							$elm$svg$Svg$Attributes$fill('#FFFFFF'),
							$elm$svg$Svg$Attributes$fillOpacity('0'),
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('MVP-dashboard-Copy-2'),
									$elm$svg$Svg$Attributes$transform('translate(-48.000000, -27.000000)'),
									$elm$svg$Svg$Attributes$class(
									A3($author$project$CoreX$Appendable$andAppendIf, isActive, ' stroke-mt-green-light', 'hover:stroke-mt-green-light')),
									$elm$svg$Svg$Attributes$stroke('#FFFFFF'),
									$elm$svg$Svg$Attributes$strokeWidth('1.80564263')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$g,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('Group-14-Copy'),
											$elm$svg$Svg$Attributes$transform('translate(-1.000000, -199.000000)')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$g,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$id('dash-icon'),
													$elm$svg$Svg$Attributes$transform('translate(50.000000, 227.000000)')
												]),
											_List_fromArray(
												[
													A2(
													$elm$svg$Svg$path,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$d('M24,11.7241379 C24,5.24907535 18.627417,0 12,0 C5.372583,0 0,5.24907535 0,11.7241379'),
															$elm$svg$Svg$Attributes$id('arch')
														]),
													_List_Nil),
													A2(
													$elm$svg$Svg$path,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$d('M12,4.68965517 L12,11.748521'),
															$elm$svg$Svg$Attributes$id('path')
														]),
													_List_Nil),
													A2(
													$elm$svg$Svg$ellipse,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$id('oval'),
															$elm$svg$Svg$Attributes$cx('12'),
															$elm$svg$Svg$Attributes$cy('14.6551724'),
															$elm$svg$Svg$Attributes$rx('2.4'),
															$elm$svg$Svg$Attributes$ry('2.34482759')
														]),
													_List_Nil)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Icons$FeedInbox$viewWithAttributes = F2(
	function (attributes, isActive) {
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 34 34'),
						$elm$svg$Svg$Attributes$version('1.1')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class(
							A3($author$project$CoreX$Appendable$andAppendIf, isActive, ' stroke-mt-green-light', 'transition-15 stroke-white hover:stroke-mt-green-light active:stroke-mt-green-light')),
							$elm$svg$Svg$Attributes$strokeWidth('1'),
							$elm$svg$Svg$Attributes$fill('#FFFFFF'),
							$elm$svg$Svg$Attributes$fillOpacity('0'),
							$elm$svg$Svg$Attributes$fillRule('evenodd')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$transform('translate(-31.000000, -31.000000)'),
									$elm$svg$Svg$Attributes$strokeWidth('3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$g,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$transform('translate(31.000000, 31.000000)')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$path,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$d('M1.7,22.95 L10.88,22.95 C11.7389474,25.2166667 13.7789474,26.35 17,26.35 C20.2210526,26.35 22.2610526,25.2166667 23.12,22.95 L32.3,22.95'),
													$elm$svg$Svg$Attributes$id('path'),
													$elm$svg$Svg$Attributes$strokeLinecap('round'),
													$elm$svg$Svg$Attributes$strokeLinejoin('round')
												]),
											_List_Nil),
											A2(
											$elm$svg$Svg$rect,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$id('rectangle'),
													$elm$svg$Svg$Attributes$x('1.5'),
													$elm$svg$Svg$Attributes$y('1.5'),
													$elm$svg$Svg$Attributes$width('31'),
													$elm$svg$Svg$Attributes$height('31'),
													$elm$svg$Svg$Attributes$rx('5.1')
												]),
											_List_Nil)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Header$View$mobileTabs = function (activeTab) {
	var isActive = function (thisTab) {
		return _Utils_eq(thisTab, activeTab);
	};
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('transition-opacity delay-500 duration-500 opacity-100 xl:opacity-0 w-4.5 xl:w-0')
				]),
			_List_fromArray(
				[
					$author$project$Icons$Timesheet$viewWithAttributes(
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-full pt-0'),
							$elm$svg$Svg$Attributes$class(
							A3(
								$author$project$CoreX$Appendable$andAppendIf,
								isActive(0),
								' stroke-mt-green-light fill-mt-green-light',
								'hover:stroke-mt-green-light hover:fill-mt-green-light stroke-white fill-white ')),
							$elm$svg$Svg$Events$onClick(
							$author$project$Messages$PageMsg(
								$author$project$TimesheetPage$Messages$SetMobileDeviceTab(0)))
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('transition-all delay-500 duration-500 opacity-100 xl:opacity-0 w-5 xl:w-0')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Icons$FeedInbox$viewWithAttributes,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-full pt-0'),
							$elm$svg$Svg$Events$onClick(
							$author$project$Messages$PageMsg(
								$author$project$TimesheetPage$Messages$SetMobileDeviceTab(1))),
							$elm$svg$Svg$Attributes$id('activity-feed-tab-trigger')
						]),
					isActive(1))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('transition-all delay-500 duration-500 opacity-100 xl:opacity-0 w-6 xl:w-0')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Icons$DashboardButton$viewWithAttributes,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('w-full pt-0'),
							$elm$svg$Svg$Events$onClick(
							$author$project$Messages$PageMsg(
								$author$project$TimesheetPage$Messages$SetMobileDeviceTab(2))),
							$elm$svg$Svg$Attributes$id('dashboard-tab-trigger')
						]),
					isActive(2))
				]))
		]);
};
var $author$project$Components$Header$View$renderMenuLinks = F4(
	function (header, user, inTimesheet, mobileDeviceTab) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex w-full items-center'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('justify-between', inTimesheet),
							_Utils_Tuple2('justify-end', !inTimesheet)
						]))
				]),
			A2(
				$author$project$CoreX$Appendable$andAppend,
				A3($author$project$Components$Header$View$helpAndNavMenu, header, user, inTimesheet),
				A3(
					$author$project$CoreX$Appendable$andAppendIf,
					inTimesheet,
					$author$project$Components$Header$View$mobileTabs(mobileDeviceTab),
					_List_Nil)));
	});
var $author$project$Components$HelpDesk$Messages$SetDescription = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$HelpDesk$Messages$SetName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HelpDesk$Messages$SetSubject = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HelpDesk$Messages$SetEmailAddress = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HelpDesk$View$inputLabel = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-md text-mt-grey mb-1')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Components$HelpDesk$View$textInputField = F4(
	function (role, label, val, msg) {
		var autoFocus = function () {
			var _v0 = msg('');
			if (_v0.$ === 4) {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-1 rounded-sm')
				]),
			_List_fromArray(
				[
					$author$project$Components$HelpDesk$View$inputLabel(label),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-base p-2 rounded-sm text-grey-darkest w-full border border-mt-grey-lighter focus:border focus:border-mt-purple mb-3'),
							$elm$html$Html$Attributes$type_('text'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'helpdesk-popup-' + role),
							$elm$html$Html$Attributes$value(val),
							$elm$html$Html$Attributes$autofocus(autoFocus),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Messages$HeaderMsg, $author$project$Components$Header$Messages$HelpDeskEdit),
								msg))
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$HelpDesk$View$emailInput = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'contact-modal-email-parent')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Components$HelpDesk$View$textInputField,
				'email',
				'Email Address *',
				model.dl,
				function (e) {
					return $author$project$Components$HelpDesk$Messages$SetEmailAddress(e);
				})
			]));
};
var $author$project$Components$HelpDesk$View$invalidWarning = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('w-full rounded-sm border border-gray-400 bg-mt-purple-light text-white text-center p-2')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Please complete required fields *')
		]));
var $author$project$Components$HelpDesk$Messages$SubmitTicket = {$: 7};
var $author$project$Components$HelpDesk$View$submitButton = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('w-full rounded-sm border border-gray-400 bg-mt-purple text-white text-center p-2'),
			$elm$html$Html$Events$onClick(
			$author$project$Messages$HeaderMsg(
				$author$project$Components$Header$Messages$HelpDeskEdit($author$project$Components$HelpDesk$Messages$SubmitTicket)))
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Submit')
		]));
var $author$project$Components$HelpDesk$View$textAreaField = F4(
	function (role, label, val, msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-1')
				]),
			_List_fromArray(
				[
					$author$project$Components$HelpDesk$View$inputLabel(label),
					A2(
					$elm$html$Html$textarea,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$rows(5),
							$elm$html$Html$Attributes$class('text-base p-2 rounded-xs text-grey-darkest w-full border border-mt-grey-lighter focus:border focus:border-mt-purple mb-3'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'helpdesk-popup-' + role),
							$elm$html$Html$Attributes$value(val),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Messages$HeaderMsg, $author$project$Components$Header$Messages$HelpDeskEdit),
								msg))
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$HelpDesk$View$formComponent = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-1')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Components$HelpDesk$View$textInputField,
						'name',
						'Your Name *',
						model.b2,
						function (e) {
							return $author$project$Components$HelpDesk$Messages$SetName(e);
						}),
						$author$project$Components$HelpDesk$View$emailInput(model),
						A4(
						$author$project$Components$HelpDesk$View$textInputField,
						'subject',
						'Subject *',
						model.cB,
						function (e) {
							return $author$project$Components$HelpDesk$Messages$SetSubject(e);
						}),
						A4(
						$author$project$Components$HelpDesk$View$textAreaField,
						'description',
						'Description',
						model.dd,
						function (e) {
							return $author$project$Components$HelpDesk$Messages$SetDescription(e);
						})
					])),
				model.cF ? $author$project$Components$HelpDesk$View$submitButton : $author$project$Components$HelpDesk$View$invalidWarning
			]));
};
var $author$project$Components$HelpDesk$View$innerComponent = F3(
	function (styles, heading, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xl font-semibold ' + styles)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(heading)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]));
	});
var $author$project$Components$HelpDesk$View$loadingComponent = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-2 animate-pulse')
		]),
	_List_fromArray(
		[
			A3($author$project$Components$HelpDesk$View$innerComponent, 'text-mt-purple-light', 'Submitting ticket', 'please wait....')
		]));
var $author$project$Components$HelpDesk$Messages$CloseHelpDesk = {$: 1};
var $author$project$Components$HelpDesk$View$closeButton = $author$project$Icons$CloseCross$viewWithAttributes(
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('inline mb-0 w-4 stroke-current text-mt-grey icon icon--close-cross'),
			$elm$svg$Svg$Attributes$id('close-cross-button'),
			$elm$svg$Svg$Events$onClick(
			$author$project$Messages$HeaderMsg(
				$author$project$Components$Header$Messages$HelpDeskEdit($author$project$Components$HelpDesk$Messages$CloseHelpDesk)))
		]));
var $author$project$Components$HelpDesk$View$popup = function (componentToDisplay) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('animate-fade-in'),
				$elm$html$Html$Attributes$class('absolute right-0 top-12 md:right-10 md:top-auto md:-bottom-[94vh] z-30'),
				$elm$html$Html$Attributes$class('border rounded-md bg-white px-7 pt-2 pb-8 drop-shadow-3xl'),
				$elm$html$Html$Attributes$class('h-screen--12 md:h-auto overflow-y-auto'),
				$elm$html$Html$Attributes$class('lg:w-112 md:w-1/2 w-screen')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-row justify-between py-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-2xl font-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Support Request')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cursor-pointer font-light')
							]),
						_List_fromArray(
							[$author$project$Components$HelpDesk$View$closeButton]))
					])),
				componentToDisplay
			]));
};
var $author$project$Components$HelpDesk$View$submissionFailureComponent = A3($author$project$Components$HelpDesk$View$innerComponent, 'text-mt-red-dark', 'Something went wrong', 'Our dev team has been informed and will create a ticket on your behalf.');
var $author$project$Components$HelpDesk$View$submissionSuccessComponent = A3($author$project$Components$HelpDesk$View$innerComponent, 'text-mt-green-dark', 'Submitted', 'Check your inbox for an email confirmation. Our support team will be in touch soon.');
var $author$project$Components$HelpDesk$View$view = function (model) {
	var _v0 = _Utils_Tuple2(model.cJ, model.cC);
	if (_v0.a === 1) {
		var _v1 = _v0.a;
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		switch (_v0.b) {
			case 0:
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return $author$project$Components$HelpDesk$View$popup(
					$author$project$Components$HelpDesk$View$formComponent(model));
			case 1:
				var _v4 = _v0.a;
				var _v5 = _v0.b;
				return $author$project$Components$HelpDesk$View$popup($author$project$Components$HelpDesk$View$loadingComponent);
			case 2:
				var _v6 = _v0.a;
				var _v7 = _v0.b;
				return $author$project$Components$HelpDesk$View$popup($author$project$Components$HelpDesk$View$submissionSuccessComponent);
			default:
				var _v8 = _v0.a;
				var _v9 = _v0.b;
				return $author$project$Components$HelpDesk$View$popup($author$project$Components$HelpDesk$View$submissionFailureComponent);
		}
	}
};
var $author$project$Components$Header$View$viewHeader = F4(
	function (user, headerModel, inTimesheet, mobileDeviceTab) {
		var superAdminHeaderAttrs = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-role', 'super-admin-header'),
				$elm$html$Html$Attributes$class('mitimes-super-admin-bg-gradient')
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$HelpDesk$View$view(headerModel.dW),
					A2(
					$elm$html$Html$header,
					A3(
						$author$project$CoreX$Appendable$andAppendIf,
						A2(
							$author$project$Components$Header$View$checkUser,
							function ($) {
								return $.d7;
							},
							user),
						superAdminHeaderAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sticky top-0 m-auto w-full h-12 max-w-7xl px-3 z-40')
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$nav,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative flex px-3 justify-between items-center h-full'),
									$elm$html$Html$Attributes$id('toc')
								]),
							_List_fromArray(
								[
									A4($author$project$Components$Header$View$renderMenuLinks, headerModel, user, inTimesheet, mobileDeviceTab)
								]))
						]))
				]));
	});
var $author$project$Components$Header$View$view = function (appModel) {
	var _v0 = function () {
		var _v1 = appModel.iC;
		if (!_v1.$) {
			var timesheetModel = _v1.a;
			return _Utils_Tuple2(true, timesheetModel.a6.h6);
		} else {
			return _Utils_Tuple2(false, 0);
		}
	}();
	var inTimesheet = _v0.a;
	var mobileDeviceTab = _v0.b;
	return A5($elm$html$Html$Lazy$lazy4, $author$project$Components$Header$View$viewHeader, appModel.jS, appModel.hl, inTimesheet, mobileDeviceTab);
};
var $author$project$PageLogo$PageLogoAttributes = F5(
	function (classes, renderPendulums, logoText, logoSubText, animationsOn) {
		return {bq: animationsOn, ay: classes, a2: logoSubText, bW: logoText, eK: renderPendulums};
	});
var $author$project$PageLogo$makeAttributes = function (appModel) {
	var organisationName = A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		'mitimes',
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			function ($) {
				return $.iy;
			},
			appModel.jS));
	var _v0 = appModel.iC;
	switch (_v0.$) {
		case 0:
			var model = _v0.a;
			var _v1 = $author$project$FeeTimerLogic$getRunningTimer(model.a6.aY.$7);
			if (!_v1.$) {
				return A5($author$project$PageLogo$PageLogoAttributes, 'logo-timesheet loaded running-timer', true, 'timer running', $elm$core$Maybe$Nothing, appModel.bq);
			} else {
				return A5($author$project$PageLogo$PageLogoAttributes, 'logo-timesheet loaded', true, organisationName, $elm$core$Maybe$Nothing, appModel.bq);
			}
		case 2:
			if (_v0.a) {
				return A5($author$project$PageLogo$PageLogoAttributes, 'logo-timesheet loading', true, 'loading', $elm$core$Maybe$Nothing, appModel.bq);
			} else {
				return A5($author$project$PageLogo$PageLogoAttributes, 'logo-header-only loading', false, '', $elm$core$Maybe$Nothing, appModel.bq);
			}
		case 1:
			return A5($author$project$PageLogo$PageLogoAttributes, 'logo-header-only loaded', false, organisationName, $elm$core$Maybe$Nothing, appModel.bq);
		case 4:
			var desc = _v0.a;
			var errMsg = _v0.b;
			return A5(
				$author$project$PageLogo$PageLogoAttributes,
				'logo-other-page',
				false,
				desc,
				$elm$core$Maybe$Just(errMsg + ' If you have any further issues please contact support.'),
				false);
		default:
			var desc = _v0.a;
			return A5($author$project$PageLogo$PageLogoAttributes, 'logo-other-page', true, desc, $elm$core$Maybe$Nothing, false);
	}
};
var $author$project$PageLogo$renderSubText = function (subText) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('leading-normal text-xxs text-mt-grey-dark')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(subText)
			]));
};
var $author$project$PageLogo$view = function (appModel) {
	var logoAttributes = $author$project$PageLogo$makeAttributes(appModel);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(logoAttributes.ay)
			]),
		A2(
			$author$project$CoreX$Appendable$andAppend,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/'),
							$elm$html$Html$Attributes$class('logo-link absolute')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-8-5 w-8-5 p-1 bg-white border border-mt-purple rounded-full logo-and-text')
								]),
							_List_fromArray(
								[
									$author$project$Icons$MitimesLogo$viewWithAttributes(
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('icon icon--logo text-grey stroke-current fill-white logo')
										]))
								])),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-0 text-xl'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('font-normal', logoAttributes.bW === 'mitimes'),
											_Utils_Tuple2(
											'logo-text',
											$elm_community$maybe_extra$Maybe$Extra$isNothing(logoAttributes.a2)),
											_Utils_Tuple2(
											'absolute w-full text-mt-purple text-center p-6 rounded-sm bg-mt-yellow-lighter',
											$elm_community$maybe_extra$Maybe$Extra$isJust(logoAttributes.a2))
										]))
								]),
							A2(
								$author$project$CoreX$Appendable$andAppendMaybe,
								A2($elm$core$Maybe$map, $author$project$PageLogo$renderSubText, logoAttributes.a2),
								_List_fromArray(
									[
										$elm$html$Html$text(logoAttributes.bW)
									])))
						]))
				]),
			A3(
				$author$project$CoreX$Appendable$andAppendIf,
				logoAttributes.eK,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute pendulums')
							]),
						$author$project$Icons$LoadingPendulum$view)
					]),
				_List_Nil)));
};
var $author$project$View$view = function (appModel) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative max-w-7xl mx-auto'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'h-screen bg-white overflow-hidden',
						!$author$project$View$isHeaderOnly(appModel))
					]))
			]),
		_List_fromArray(
			[
				A3($author$project$View$renderNotifications, appModel.im, appModel.c5, appModel.gr),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative')
					]),
				_List_fromArray(
					[
						$author$project$Components$Header$View$view(appModel),
						$author$project$PageLogo$view(appModel),
						$author$project$Components$Modal$View$topLevelView(appModel.h7)
					])),
				$author$project$View$renderPageContent(appModel)
			]));
};
var $author$project$Main$main = $elm$browser$Browser$element(
	{hr: $author$project$Main$init, jm: $author$project$Main$subscriptions, jQ: $author$project$Update$update, jV: $author$project$View$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (region) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (newsUrl) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (inTimesheet) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (helpCentreUrl) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (csrfToken) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (cspNonce) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (animationsOn) {
															return $elm$json$Json$Decode$succeed(
																{bq: animationsOn, c5: cspNonce, gr: csrfToken, bM: helpCentreUrl, bU: inTimesheet, b5: newsUrl, ci: region});
														},
														A2($elm$json$Json$Decode$field, 'animationsOn', $elm$json$Json$Decode$bool));
												},
												A2($elm$json$Json$Decode$field, 'cspNonce', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'csrfToken', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'helpCentreUrl', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'inTimesheet', $elm$json$Json$Decode$bool));
				},
				A2($elm$json$Json$Decode$field, 'newsUrl', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'region', $elm$json$Json$Decode$string)))(0)}});}(this));